var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  ABSENCE_APPLICATION_TYPES: () => ABSENCE_APPLICATION_TYPES,
  ABSENCE_STATUSES: () => ABSENCE_STATUSES,
  ACCOUNT_COMPANY_CREATION_TYPE: () => ACCOUNT_COMPANY_CREATION_TYPE,
  ACCOUNT_COMPANY_VAT_HANDLING: () => ACCOUNT_COMPANY_VAT_HANDLING,
  AccountUserFilter: () => AccountUserFilter_default,
  ActionBadge: () => ActionBadge_default,
  ActiveFilterDisplay: () => ActiveFilterDisplay_default,
  ActiveFilters: () => ActiveFilters_default,
  Address: () => Address_default,
  AttributeBoolean: () => AttributeBoolean_default,
  AttributeChat: () => AttributeChat_default,
  AttributeChecklist: () => AttributeChecklist_default,
  AttributeChecklistField: () => AttributeChecklistField_default,
  AttributeDate: () => AttributeDate_default,
  AttributeDateField: () => AttributeDateField_default,
  AttributeFile: () => AttributeFile_default,
  AttributeFileItem: () => AttributeFileItem_default,
  AttributeHtml: () => AttributeHtml_default,
  AttributeLabel: () => AttributeLabel_default,
  AttributeList: () => AttributeList_default,
  AttributeListMulti: () => AttributeListMulti_default,
  AttributeNumber: () => AttributeNumber_default,
  AttributeText: () => AttributeText_default,
  Attributes: () => Attributes_default,
  AuraCustomTranslation: () => AuraCustomTranslation,
  AuraDatePicker: () => AuraDatePicker_default,
  AuraDrawer: () => AuraDrawer,
  AuraDrawerBody: () => AuraDrawerBody,
  AuraDrawerCloseButton: () => AuraDrawerCloseButton,
  AuraDrawerContent: () => AuraDrawerContent,
  AuraDrawerFooter: () => AuraDrawerFooter,
  AuraDrawerHeader: () => AuraDrawerHeader,
  AuraDrawerOverlay: () => AuraDrawerOverlay,
  AuraDropdownMenu: () => AuraDropdownMenu_default,
  AuraErrorResolverException: () => AuraErrorResolverException,
  AuraFormLabel: () => AuraFormLabel_default,
  AuraInput: () => AuraInput_default,
  AuraInputCompact: () => AuraInputCompact,
  AuraMenuItem: () => AuraMenuItem_default,
  AuraModal: () => AuraModal,
  AuraModalBody: () => AuraModalBody,
  AuraModalCloseButton: () => AuraModalCloseButton,
  AuraModalContent: () => AuraModalContent,
  AuraModalFooter: () => AuraModalFooter,
  AuraModalHeader: () => AuraModalHeader,
  AuraModalOverlay: () => AuraModalOverlay,
  AuraSelect: () => AuraSelect_default,
  AuraSpinner: () => AuraSpinner_default,
  AuraTabs: () => AuraTabs_default,
  AuraTextarea: () => AuraTextarea_default,
  AuraTranslation: () => AuraTranslation_default,
  AuthContext: () => AuthContext,
  AuthContextProvider: () => AuthContextProvider,
  AvailabilityFilter: () => AvailabilityFilter_default,
  BackwardNavigation: () => BackwardNavigation_default,
  BasketContext: () => BasketContext,
  BasketContextProvider: () => BasketContextProvider,
  BlockedDisabledInfo: () => BlockedDisabledInfo_default,
  BooleanCell: () => BooleanCell_default,
  BooleanFilter: () => BooleanFilter_default,
  BoxCollapse: () => BoxCollapse,
  BoxCollapseButton: () => BoxCollapseButton,
  BoxCollapseContent: () => BoxCollapseContent,
  BoxCollapseItem: () => BoxCollapseItem,
  BoxCollapseItemCompact: () => BoxCollapseItemCompact,
  BoxIcon: () => BoxIcon,
  Breadcrumbs: () => Breadcrumbs_default,
  ButtonAction: () => ButtonAction_default,
  ButtonFavorite: () => ButtonFavorite_default,
  ButtonManage2FA: () => ButtonManage2FA_default,
  CAMPAIGN_OPPORTUNITY_STATUSES: () => CAMPAIGN_OPPORTUNITY_STATUSES,
  CAMPAIGN_STATUSES: () => CAMPAIGN_STATUSES,
  CHANGELOG_FIELD_TYPES: () => CHANGELOG_FIELD_TYPES,
  COMMISSION_SCOPE_TYPES: () => COMMISSION_SCOPE_TYPES,
  COMMISSION_SCOPE_TYPE_LABELS: () => COMMISSION_SCOPE_TYPE_LABELS,
  COPY_PRODUCTS_STORAGE_KEY: () => COPY_PRODUCTS_STORAGE_KEY,
  CSSReset: () => CSSReset,
  CURRENCY_CHANGE_CONFIRM_DIALOG_TYPES: () => CURRENCY_CHANGE_CONFIRM_DIALOG_TYPES,
  CellWrapper: () => CellWrapper_default,
  ChangeHistoryTable: () => ChangeHistoryTable_default,
  ColorPicker: () => ColorPicker_default,
  CommunicatorThreads: () => CommunicatorThreads_default,
  ConnectedCampaignOpportunity: () => ConnectedCampaignOpportunity_default,
  ConnectedDocument: () => ConnectedDocument_default,
  ConnectedProcess: () => ConnectedProcess_default,
  ConnectedProcessPopover: () => ConnectedProcessPopover_default,
  ConnectedProcessesPopover: () => ConnectedProcessesPopover_default,
  ConnectedServicedProduct: () => ConnectedServicedProduct_default,
  ConnectedTaskAndEvent: () => ConnectedTaskAndEvent_default,
  ContentBox: () => ContentBox_default,
  CookieNotice: () => CookieNotice_default,
  CountBadge: () => CountBadge_default,
  CountryFilter: () => CountryFilter_default,
  CreatorUserCell: () => CreatorUserCell_default,
  CredentialsCompact: () => CredentialsCompact_default,
  CustomCSSReset: () => CustomCSSReset_default,
  CustomMultiValueContainer: () => CustomMultiValueContainer,
  CustomMultiValueRemove: () => CustomMultiValueRemove,
  CustomProductOption: () => CustomProductOption_default,
  CustomScripts: () => CustomScripts_default,
  CustomSelectOption: () => CustomSelectOption_default,
  CustomizeColumns: () => CustomizeColumns_default,
  CustomizeColumnsModal: () => CustomizeColumnsModal_default,
  CustomizerContext: () => CustomizerContext,
  CustomizerContextProvider: () => CustomizerContext_default,
  CustomizerInit: () => CustomizerInit_default,
  DATETIME_FORMAT_DOTS: () => DATETIME_FORMAT_DOTS,
  DATE_DAY_MONTH_FORMAT: () => DATE_DAY_MONTH_FORMAT,
  DATE_FORMAT_DOTS: () => DATE_FORMAT_DOTS,
  DEFAULT_LIMIT_AVAILABLE_PRODUCTS: () => DEFAULT_LIMIT_AVAILABLE_PRODUCTS,
  DISCOUNT_APPLY_ON: () => DISCOUNT_APPLY_ON,
  DISCOUNT_CODES_SCOPES: () => DISCOUNT_CODES_SCOPES,
  DISCOUNT_CODES_TYPES: () => DISCOUNT_CODES_TYPES,
  DISCOUNT_SCOPES: () => DISCOUNT_SCOPES,
  DOCUMENT_INVOICE_TYPES: () => DOCUMENT_INVOICE_TYPES,
  DOCUMENT_POSITION_TYPES: () => DOCUMENT_POSITION_TYPES,
  DOCUMENT_TYPES: () => DOCUMENT_TYPES,
  DURATION_ERROR_VISIBLE: () => DURATION_ERROR_VISIBLE,
  DataSelector: () => DataSelector_default,
  DataSelectorFilter: () => DataSelectorFilter_default,
  DateInput: () => DateInput_default,
  DateTag: () => DateTag_default,
  DateraContext: () => DateraContext,
  DateraProvider: () => DateraProvider,
  DatetimeFilter: () => DatetimeFilter_default,
  DefaultEventDates: () => DefaultEventDates,
  DiscountApplyOnTypes: () => DiscountApplyOnTypes,
  DiscountCodeScopeTypes: () => DiscountCodeScopeTypes,
  DiscountScopeTypes: () => DiscountScopeTypes,
  DocumentPositionTile: () => DocumentPositionTile_default,
  DocumentSummary: () => DocumentSummary_default,
  DocumentSummaryVerticalTable: () => DocumentSummaryVerticalTable_default,
  EmptyFilters: () => EmptyFilters_default,
  EmptyList: () => EmptyList_default,
  EmptyState: () => EmptyState_default,
  ExternalMarkerContainer: () => ExternalMarkerContainer_default,
  ExternalMarkerFilter: () => ExternalMarkerFilter_default,
  ExternalMarkerLabel: () => ExternalMarkerLabel_default,
  ExternalMarkersContext: () => ExternalMarkersContext,
  ExternalMarkersProvider: () => ExternalMarkersContext_default,
  FileDetails: () => FileDetails_default,
  FilePreview: () => FilePreview,
  FilterFormLabel: () => FilterFormLabel_default,
  FilterInputSeparator: () => FilterInputSeparator_default,
  FilterName: () => FilterName,
  FilterTextInput: () => FilterTextInput_default,
  FiltersDisplayItem: () => FiltersDisplayItem_default,
  GalleryItem: () => GalleryItem_default,
  HOUR_MINUTE_FORMAT: () => HOUR_MINUTE_FORMAT,
  Header: () => Header_default,
  InBasketInfo: () => InBasketInfo_default,
  InBasketText: () => InBasketText_default,
  Information: () => Information_default,
  KSEF_STATUSES: () => KSEF_STATUSES,
  LANGUAGES: () => LANGUAGES,
  LOCAL_STORAGE_MESSAGES_LAST_FETCH: () => LOCAL_STORAGE_MESSAGES_LAST_FETCH,
  LanguageContext: () => LanguageContext,
  LanguageProvider: () => LanguageProvider,
  LinkContext: () => LinkContext,
  LinkContextProvider: () => LinkContextProvider,
  Linkify: () => Linkify_default,
  List: () => List_default,
  ListFilter: () => ListFilter_default,
  ListFilters: () => ListFilters_default,
  ListFiltersContext: () => ListFiltersContext,
  ListFiltersContextProvider: () => ListFiltersContext_default,
  LoadingModal: () => LoadingModal_default,
  LoadingOverlay: () => LoadingOverlay_default,
  MESSAGE_FETCH_INTERVAL: () => MESSAGE_FETCH_INTERVAL,
  MODULE_MAP: () => MODULE_MAP,
  MainHeader: () => MainHeader,
  MessageBreadcrumbs: () => MessageBreadcrumbs_default,
  MessageItem: () => MessageItem_default,
  MessagesContext: () => MessagesContext,
  MessagesContextProvider: () => MessagesContext_default,
  Modal: () => Modal_default,
  ModalAbsence: () => ModalAbsence_default,
  ModalAbsenceLimit: () => ModalAbsenceLimit_default,
  ModalAccountUser: () => ModalAccountUser_default,
  ModalAdditionalI18n: () => ModalAdditionalI18n_default,
  ModalAddress: () => ModalAddress_default,
  ModalCampaignOpportunity: () => ModalCampaignOpportunity_default,
  ModalCommission: () => ModalCommission_default,
  ModalCompany: () => ModalCompany_default,
  ModalDiscount: () => ModalDiscount_default,
  ModalDiscountCode: () => ModalDiscountCode_default,
  ModalHoliday: () => ModalHoliday_default,
  ModalMassDiscount: () => ModalMassDiscount_default,
  ModalMessageThread: () => ModalMessageThread_default,
  ModalPriceIndividual: () => ModalPriceIndividual_default,
  ModalSelectTemplate: () => ModalSelectTemplate_default,
  ModalServicedProduct: () => ModalServicedProduct_default,
  ModalVisibilityProvider: () => ModalVisibilityProvider,
  ModuleLink: () => ModuleLink,
  MoreIconButton: () => MoreIconButton_default,
  MultiFilter: () => MultiFilter_default,
  NIP_BLOCKING_MODE: () => NIP_BLOCKING_MODE,
  NameDisplay: () => NameDisplay_default,
  NotificationBar: () => NotificationBar,
  NumberBox: () => NumberBox,
  NumericFilter: () => NumericFilter_default,
  ObjectsPerPageSelect: () => ObjectsPerPageSelect,
  Pagination: () => Pagination_default,
  PanelHeading: () => PanelHeading_default,
  PerPage: () => PerPage_default,
  PersonInfo: () => PersonInfo_default,
  PersonItem: () => PersonItem_default,
  PersonList: () => PersonList_default,
  PriceDisplay: () => PriceDisplay_default,
  PriceWithCurrency: () => PriceWithCurrency,
  ProductAvailability: () => ProductAvailability_default,
  ProductEAN: () => ProductEAN_default,
  ProductImage: () => ProductImage_default,
  ProductListItem: () => ProductListItem_default,
  ProductQuantitySelector: () => ProductQuantitySelector_default,
  ProductSlider: () => ProductSlider_default,
  ProfileSaveConfigModal: () => ProfileSaveConfigModal_default,
  QAvatar: () => QAvatar_default,
  QuantitySelector: () => QuantitySelector_default,
  RECEIVER_GROUP_USERS_TYPES: () => RECEIVER_GROUP_USERS_TYPES,
  ReportTable: () => ReportTable_default,
  RepositoryFile: () => RepositoryFile_default,
  RepositoryFileList: () => RepositoryFileList_default,
  ResultsPagination: () => ResultsPagination_default,
  ResultsPerPage: () => ResultsPerPage_default,
  RoundIcon: () => RoundIcon_default,
  STable: () => Table,
  STableContainer: () => TableContainer,
  STbody: () => Tbody,
  STd: () => Td,
  STfoot: () => Tfoot,
  STh: () => Th,
  SThead: () => Thead,
  STr: () => Tr,
  SecondaryHeader: () => SecondaryHeader,
  SettingsContext: () => SettingsContext,
  SettingsProvider: () => SettingsProvider,
  SmallTag: () => SmallTag_default,
  SortingIndicator: () => SortingIndicator_default,
  SubordinatesCheckbox: () => SubordinatesCheckbox_default,
  TAGS_TYPES: () => TAGS_TYPES,
  TAX_NON_UE_COUNTRIES: () => TAX_NON_UE_COUNTRIES,
  TAX_TYPES: () => TAX_TYPES,
  TAX_UE_COUNTRIES: () => TAX_UE_COUNTRIES,
  Table: () => Table_default,
  TagButton: () => TagButton,
  TagDisplay: () => TagDisplay,
  TagFilter: () => TagFilter_default,
  TaskItem: () => TaskItem_default,
  TaskList: () => TaskList_default,
  TaxCheckAlert: () => TaxCheckAlert_default,
  TaxDuplicatesModal: () => TaxDuplicatesModal_default,
  Tbody: () => Tbody_default,
  Td: () => Td_default,
  TextFilter: () => TextFilter_default,
  TextScroll: () => TextScroll_default,
  Th: () => Th_default,
  Thead: () => Thead_default,
  TileItem: () => TileItem_default,
  TileItemList: () => TileItemList_default,
  TileList: () => TileList_default,
  Timeline: () => Timeline_default,
  TimelineCompact: () => TimelineCompact,
  TimelineItem: () => TimelineItem_default,
  TooltipWrapper: () => TooltipWrapper,
  Tr: () => Tr_default,
  UNRESET_SCSS: () => UNRESET_SCSS,
  USED_SETTINGS: () => USED_SETTINGS,
  UsedMaterials: () => UsedMaterials_default,
  UserAvatarManage: () => UserAvatarManage_default,
  UserTypes: () => UserTypes,
  WRAP_LINES_IN_LISTS: () => WRAP_LINES_IN_LISTS,
  Widget: () => Widget_default,
  WidgetBody: () => WidgetBody_default,
  WidgetControls: () => WidgetControls_default,
  WidgetHeader: () => WidgetHeader_default,
  WidgetName: () => WidgetName_default,
  WidgetSettingsModal: () => WidgetSettingsModal_default,
  auraAddNewEvent: () => auraAddNewEvent,
  auraAddNewTask: () => auraAddNewTask,
  auraCompleteTask: () => auraCompleteTask,
  auraCreateCampaignOpportunity: () => auraCreateCampaignOpportunity,
  auraCreateProccesFromShortcut: () => auraCreateProccesFromShortcut,
  auraEditTask: () => auraEditTask,
  auraParseDisplayValue: () => auraParseDisplayValue,
  auraParseFloat: () => auraParseFloat,
  auraSelectFilterConfig: () => auraSelectFilterConfig,
  baseApi: () => api_default,
  baseInputStyle: () => baseInputStyle,
  buildOptions: () => buildOptions,
  checkIsEdgeElement: () => checkIsEdgeElement,
  checkIsVirtualTask: () => checkIsVirtualTask,
  confirm: () => confirm2,
  confirmWrapper: () => confirmWrapper,
  disableSortingColumns: () => disableSortingColumns,
  documentInvoiceStatus: () => documentInvoiceStatus,
  documentStatusPositions: () => documentStatusPositions,
  downloadXlsxDocument: () => downloadXlsxDocument,
  escapeFilterValueForQuery: () => escapeFilterValueForQuery,
  expandRecurringTasks: () => expandRecurringTasks,
  fetchData: () => fetchData,
  filterGlobalExcludedFields: () => filterGlobalExcludedFields,
  formatAttributeCell: () => formatAttributeCell,
  formatAttributeHeader: () => formatAttributeHeader,
  formatDateForApi: () => formatDateForApi,
  formatFieldCell: () => formatFieldCell,
  formatHeader: () => formatHeader,
  formatPhoneNumber: () => formatPhoneNumber,
  formatRelationFieldCell: () => formatRelationFieldCell,
  formatRelationHeader: () => formatRelationHeader,
  formatValue: () => formatValue,
  getActiveMarkers: () => getActiveMarkers,
  getAttributeClass: () => getAttributeClass,
  getAttributeContainerId: () => getAttributeContainerId,
  getAttributeId: () => getAttributeId,
  getAttributeIdFromHTMLId: () => getAttributeIdFromHTMLId,
  getAttributeTagTypeForModule: () => getAttributeTagTypeForModule,
  getAvailabilityProductLabel: () => getAvailabilityProductLabel,
  getBasePriceFilter: () => getBasePriceFilter,
  getCommonI18nConfig: () => getCommonI18nConfig,
  getCountryNameByCode: () => getCountryNameByCode,
  getDocumentRelationName: () => getDocumentRelationName,
  getFormattedPlaceLabel: () => getFormattedPlaceLabel,
  getGoogleMapsQueryUrl: () => getGoogleMapsQueryUrl,
  getImageUrl: () => getImageUrl,
  getListFiltersConfig: () => getListFiltersConfig,
  getModuleHref: () => getModuleHref,
  getParsedCellValue: () => getParsedCellValue,
  getPriceFilterLevelForUserType: () => getPriceFilterLevelForUserType,
  getUserPrice: () => getUserPrice,
  getVisibleColumnsParams: () => getVisibleColumnsParams,
  idExists: () => idExists,
  imageSizeValue: () => imageSizeValue,
  initModal: () => initModal,
  isAppliedVatForCompany: () => isAppliedVatForCompany,
  isCommaSeparatorVisible: () => isCommaSeparatorVisible,
  isFieldDirty: () => isFieldDirty,
  isFile: () => isFile,
  isImage: () => isImage,
  log: () => logger_default,
  mapRelationTasksToTaskFields: () => mapRelationTasksToTaskFields,
  normalizeSettings: () => normalizeSettings,
  openGoogleMaps: () => openGoogleMaps,
  parseAttributeNameFormPrefix: () => parseAttributeNameFormPrefix,
  parseFiltersForApi: () => parseFiltersForApi,
  parseMetaToColumns: () => parseMetaToColumns,
  parseTaxId: () => parseTaxId,
  parseUrlParams: () => parseUrlParams,
  prepareAllTasks: () => prepareAllTasks,
  prepareAttributeFormValues: () => prepareAttributeFormValues,
  prepareAttributesDefaultValues: () => prepareAttributesDefaultValues,
  prepareAttributesForApi: () => prepareAttributesForApi,
  prepareDocumentPositionTile: () => prepareDocumentPositionTile,
  prepareObjectRelationEvents: () => prepareObjectRelationEvents,
  prepareObjectRelationTasks: () => prepareObjectRelationTasks,
  preparePositionAttributesDefaultValues: () => preparePositionAttributesDefaultValues,
  preparePositionAttributesForApi: () => preparePositionAttributesForApi,
  preparePositionAttributesWithValues: () => preparePositionAttributesWithValues,
  prepareSeoUrlForProduct: () => prepareSeoUrlForProduct,
  prepareToastDescription: () => prepareToastDescription,
  priceFormatter: () => priceFormatter,
  redirectToUrl: () => redirectToUrl,
  replaceForSeo: () => replaceForSeo,
  sanitizeDecimalInput: () => sanitizeDecimalInput,
  scrollToField: () => scrollToField,
  setValueWithPriceFormat: () => setValueWithPriceFormat,
  shouldShowDiscountInfo: () => shouldShowDiscountInfo,
  simplePriceFormatter: () => simplePriceFormatter,
  sortTasks: () => sortTasks,
  splitPriceParts: () => splitPriceParts,
  statusCampaignOpportunity: () => statusCampaignOpportunity,
  stripHtmlTags: () => stripHtmlTags,
  theme: () => customTheme,
  transformApiResponse: () => transformApiResponse,
  translateOptions: () => translateOptions,
  useAuraErrorResolver: () => useAuraErrorResolver_default,
  useAuraTranslation: () => useAuraTranslation_default,
  useBasketContent: () => useBasketContent,
  useCheckCompanyTax: () => useCheckCompanyTax_default,
  useClearElasticFilter: () => useClearElasticFilter_default,
  useCloneFiles: () => useCloneFiles_default,
  useCustomScript: () => useCustomScript_default,
  useDatera: () => useDatera_default,
  useExternalMarkers: () => useExternalMarkers,
  useFilesUpdateValidate: () => useFilesUpdateValidate_default,
  useLanguage: () => useLanguage,
  useLink: () => useLink,
  useListColumnsOrdering: () => useListColumnsOrdering_default,
  useListColumnsVisibility: () => useListColumnsVisibility_default,
  useListFilters: () => useListFilters,
  useListFiltersVisibility: () => useListFiltersVisibility_default,
  useListPagination: () => useListPagination_default,
  useListSorting: () => useListSorting_default,
  useMessages: () => useMessages,
  useMinimalAutoselect: () => useMinimalAutoselect_default,
  useModalVisibilityContext: () => useModalVisibilityContext,
  useOnClick: () => useOnClick_default,
  usePersistedState: () => usePersistedState_default,
  useProductPrice: () => useProductPrice_default,
  useQueryParams: () => useQueryParams_default,
  useResponsive: () => useResponsive_default,
  useSetting: () => useSetting_default,
  useSettings: () => useSettings_default,
  useTemplates: () => useTemplates_default,
  useUserProfiles: () => useUserProfiles_default,
  useUserSettingsWithFallback: () => useUserSettingsWithFallback_default,
  validateAttribute: () => validateAttribute
});
module.exports = __toCommonJS(src_exports);

// src/components/ActionBadge/ActionBadge.tsx
var import_react = require("@chakra-ui/react");
var import_react2 = require("@emotion/react");
var import_react3 = require("react");
var import_fa = require("react-icons/fa");
var import_jsx_runtime = require("react/jsx-runtime");
var ActionBadge = (0, import_react3.forwardRef)(
  ({ isError, isSuccess, isLoading, noAnimation, ...props }, ref) => {
    if (!isError && !isSuccess && !isLoading)
      return null;
    const getIcon = () => {
      if (isSuccess)
        return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_fa.FaCheckCircle, {});
      if (isError)
        return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_fa.FaTimesCircle, {});
    };
    return isLoading ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react.Spinner, {
      size: "sm"
    }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react.Box, {
      ref,
      color: !isError ? "green.400" : "red.400",
      animation: noAnimation ? "" : `${fadeInOut} 0.5s ease-in-out`,
      "aria-label": !isError ? "success" : "error",
      ...props,
      children: getIcon()
    });
  }
);
var fadeInOut = import_react2.keyframes`
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
`;
var ActionBadge_default = ActionBadge;

// src/components/ActiveFilterDisplay/ActiveFilterDisplay.tsx
var import_react45 = require("@chakra-ui/react");
var import_isEmpty5 = __toESM(require("lodash/isEmpty"));
var import_isNil3 = __toESM(require("lodash/isNil"));

// src/components/ActiveFilterDisplay/FiltersDisplayItem/FiltersDisplayItem.tsx
var import_react41 = require("@chakra-ui/react");
var import_date_fns5 = require("date-fns");
var import_isNil2 = __toESM(require("lodash/isNil"));
var import_js4 = require("@mdi/js");

// src/utils/logger.ts
var logLevel = require("loglevel");
var loglevelPrefix = require("loglevel-plugin-prefix");
loglevelPrefix.reg(logLevel);
loglevelPrefix.apply(logLevel);
if (process.env.NODE_ENV === "development") {
  logLevel.enableAll();
}
var logger = logLevel.getLogger("logger");
var logger_default = logger;

// src/utils/misc.ts
var import_axios = __toESM(require("axios"));
var import_dompurify = __toESM(require("dompurify"));
var import_isNumber = __toESM(require("lodash/isNumber"));
var import_react_select_country_list = __toESM(require("react-select-country-list"));
var getImageUrl = (dbName, size, fileName) => {
  if (!dbName || typeof dbName !== "string") {
    return null;
  }
  let params = `${dbName}/`;
  if (size === "thmb" || size === "md") {
    params += `type/${size}/`;
  }
  if (fileName) {
    params += encodeURI(fileName);
  }
  return `/file/show/file/${params}`;
};
var buildOptions = (data, labelField, valueField = "id", includedFields) => {
  if (!data) {
    return [];
  }
  if (typeof data === "string") {
    return [];
  }
  return data.map((item, index) => {
    const optionLabel = labelField ? item[labelField] : item;
    const fields = {};
    includedFields == null ? void 0 : includedFields.forEach((field) => {
      if (item[field] || (0, import_isNumber.default)(item == null ? void 0 : item[field])) {
        fields[field] = item[field];
      }
    });
    let optionValue;
    if (valueField === "arrayIndex") {
      optionValue = index;
    } else {
      optionValue = valueField ? item[valueField] : item;
    }
    return {
      value: optionValue,
      label: optionLabel,
      ...item.additionalName ? { additionalName: item.additionalName } : {},
      ...fields
    };
  });
};
var isImage = (mimetype) => {
  return (mimetype == null ? void 0 : mimetype.startsWith("image/")) ?? false;
};
var stripHtmlTags = (text) => {
  return import_dompurify.default.sanitize(text == null ? void 0 : text.replace(/&nbsp;/g, " "), {
    ALLOWED_TAGS: ["#text"]
  }).trim().replace(/^\s*[\r\n]/gm, "");
};
var translateOptions = (data, t) => {
  if (!data) {
    return [];
  }
  if (typeof data === "string") {
    return [];
  }
  if (typeof t !== "function") {
    return data;
  }
  return data.map((option) => ({
    value: option["value"],
    label: t(`${option["label"]}`)
  }));
};
var redirectToUrl = (url) => window.location.assign(url);
var getCountryNameByCode = (currentValue, currentLocale) => {
  var _a2;
  const regionNames = new Intl.DisplayNames([(currentLocale == null ? void 0 : currentLocale.code) ?? "pl"], {
    type: "region"
  });
  const countries = (_a2 = (0, import_react_select_country_list.default)().getData()) == null ? void 0 : _a2.map((country) => ({
    ...country,
    label: regionNames.of(country.value)
  }));
  const parsedValue = currentValue === "POLAND" ? "PL" : currentValue;
  const transformedValue = countries == null ? void 0 : countries.find(
    (country) => country.value === parsedValue || country.label === parsedValue
  );
  return (transformedValue == null ? void 0 : transformedValue.label) ?? currentValue;
};
var idExists = (value) => {
  if (value === null || value === void 0)
    return false;
  if (typeof value === "string") {
    const trimmed = value.trim();
    return /^[0-9]+$/.test(trimmed);
  }
  if (typeof value === "number")
    return !Number.isNaN(value);
  return false;
};
var isFieldDirty = (dirtyEntry) => {
  if (typeof dirtyEntry === "boolean")
    return dirtyEntry;
  if (dirtyEntry && typeof dirtyEntry === "object") {
    return Object.values(dirtyEntry).some((value) => isFieldDirty(value));
  }
  return !!dirtyEntry;
};
var getGoogleMapsQueryUrl = (queryString) => {
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
    queryString
  )}`;
};
var openGoogleMaps = (googleMapUrl, openInMobileApp) => {
  if (!googleMapUrl || googleMapUrl.trim() === "") {
    return;
  }
  if (openInMobileApp) {
    window.open(googleMapUrl, "_system", "location=yes");
  } else {
    window.open(googleMapUrl, "_blank");
  }
};
var scrollToField = (fieldName) => {
  let idScroll = fieldName;
  switch (fieldName) {
    case "servicedProduct":
      idScroll = "servicedProducts";
      break;
    case "product":
      idScroll = "products";
      break;
    default:
      break;
  }
  const elementToScrollTo = document.getElementById(idScroll);
  elementToScrollTo && elementToScrollTo.scrollIntoView({ behavior: "smooth", block: "center" });
};
var formatPhoneNumber = (phoneNumber) => {
  let preparedPhoneNumber = phoneNumber.replace(/[\s-]/g, "");
  if (!preparedPhoneNumber)
    return "";
  if (preparedPhoneNumber.length === 9) {
    return preparedPhoneNumber.replace(/(\d{3})(\d{3})(\d{3})/, "$1 $2 $3");
  } else if (preparedPhoneNumber.length === 10) {
    return preparedPhoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, "$1 $2 $3");
  } else if (preparedPhoneNumber.length > 10) {
    const mainNumber = preparedPhoneNumber.slice(-9);
    const prefix = preparedPhoneNumber.slice(0, preparedPhoneNumber.length - 9);
    const formattedMain = mainNumber.replace(
      /(\d{3})(\d{3})(\d{3})/,
      "$1 $2 $3"
    );
    return `${prefix} ${formattedMain}`;
  } else {
    return preparedPhoneNumber;
  }
};
var transformHeadersForAxios = (reqParams) => {
  let headers = {};
  if (reqParams == null ? void 0 : reqParams.cache) {
    headers["Cache-Control"] = "no-store";
    headers["Pragma"] = "no-cache";
    headers["Expires"] = "0";
  }
  return headers;
};
var fetchData = async (endpoint, config = {}, reqParams = {}) => {
  const url = `/api/${endpoint}`;
  let response;
  const customHeaderFromReqParams = transformHeadersForAxios(reqParams);
  try {
    response = await (0, import_axios.default)({
      method: "GET",
      url,
      ...config,
      headers: {
        ...(config == null ? void 0 : config.headers) ?? {},
        ...customHeaderFromReqParams
      }
    });
  } catch (error) {
    if (!import_axios.default.isCancel(error)) {
      console.error(error);
    }
  }
  return response == null ? void 0 : response.data;
};
var parseTaxId = (fullTaxId) => {
  var _a2;
  const match = fullTaxId == null ? void 0 : fullTaxId.match(/^([A-Za-z]{2,3})?\s*([\d\s]*)$/);
  const taxCountry = match == null ? void 0 : match[1];
  const taxId = ((_a2 = match == null ? void 0 : match[2]) == null ? void 0 : _a2.replace(/\s+/g, "")) || void 0;
  return { taxCountry, taxId };
};
var sanitizeDecimalInput = ({
  value,
  decimalPlaces,
  maxIntegerDigits
}) => {
  value = value.replace(/[^\d.,]/g, "");
  const separatorIndex = value.search(/[.,]/);
  if (separatorIndex !== -1) {
    let beforeSeparator = value.slice(0, separatorIndex);
    const separator = value[separatorIndex];
    let afterSeparator = value.slice(separatorIndex + 1).replace(/[.,]/g, "");
    beforeSeparator = beforeSeparator.replace(/^0+(\d)/, "$1");
    beforeSeparator = beforeSeparator.slice(0, maxIntegerDigits);
    if (decimalPlaces !== void 0) {
      afterSeparator = afterSeparator.slice(0, decimalPlaces);
    }
    value = decimalPlaces === 0 ? beforeSeparator : beforeSeparator + separator + afterSeparator;
  } else {
    value = value.replace(/^0+(\d)/, "$1");
    value = value.slice(0, maxIntegerDigits);
  }
  value = value.replace(/^[.,]/, "0$&");
  return value;
};
var checkIsEdgeElement = (collectionLength, currentIndex, edge) => {
  if (collectionLength < 2)
    return true;
  if (edge === "start")
    return true;
  return edge === "end" && currentIndex === collectionLength - 1;
};

// src/types/index.ts
var PriceNames = /* @__PURE__ */ ((PriceNames2) => {
  PriceNames2["brutto"] = "priceBrutto";
  PriceNames2["netto"] = "priceNetto";
  return PriceNames2;
})(PriceNames || {});
var DefaultEventDates = /* @__PURE__ */ ((DefaultEventDates2) => {
  DefaultEventDates2[DefaultEventDates2["Now"] = 1] = "Now";
  DefaultEventDates2[DefaultEventDates2["FromTask"] = 2] = "FromTask";
  return DefaultEventDates2;
})(DefaultEventDates || {});

// src/utils/productUtils.ts
var getActiveMarkers = (externalMarkers) => {
  return externalMarkers == null ? void 0 : externalMarkers.filter((marker) => marker.isActive);
};
var priceFormatter = (value, currencyCode = "PLN", { formatToParts = false } = {}, numberDigits = -1) => {
  currencyCode ?? (currencyCode = "PLN");
  const options = { useGrouping: true };
  if (currencyCode.trim() !== "" && currencyCode.trim() !== "none") {
    options["style"] = "currency";
    options["currency"] = currencyCode;
    options["currencyDisplay"] = "symbol";
  }
  if (numberDigits > -1) {
    options["maximumFractionDigits"] = numberDigits;
    options["minimumFractionDigits"] = numberDigits;
    value = Math.round(value * Math.pow(10, numberDigits + 2)) / Math.pow(10, numberDigits + 2);
  }
  const formatter = new Intl.NumberFormat("pl-PL", options);
  const priceInParts = formatter.formatToParts(value).map(({ type, value: value2 }) => {
    switch (type) {
      case "integer":
        return addPriceSpace(value2);
      default:
        return value2;
    }
  });
  if (formatToParts) {
    return priceInParts;
  }
  const price = priceInParts.join("");
  return price;
};
var simplePriceFormatter = (value, precision = 2) => {
  return priceFormatter(auraParseFloat(value), "none", {}, precision);
};
var addPriceSpace = (formattedPrice) => {
  if (formattedPrice.length === 4) {
    const stringArray = Array.from(formattedPrice);
    stringArray.splice(1, 0, "\xA0");
    return stringArray.join("");
  }
  return formattedPrice;
};
var getBasePriceFilter = ({
  priceLevel,
  priceType,
  filterType
}) => {
  return `filter[prices][${priceLevel}.${PriceNames[priceType]}][${filterType}]`;
};
var getPriceFilterLevelForUserType = ({
  priceType,
  filterType,
  isUserUser,
  forcePriceLevel
}) => {
  const priceLevel = forcePriceLevel ? forcePriceLevel : isUserUser ? "srp" : "purchase";
  return getBasePriceFilter({
    priceType,
    filterType,
    priceLevel
  });
};
var splitPriceParts = (priceParts) => {
  const priceValue = Array.isArray(priceParts) ? priceParts.slice(0, -1).join("") : "?";
  const priceCurrency = Array.isArray(priceParts) ? priceParts.slice(-1).toString() : "?";
  return {
    priceValue,
    priceCurrency
  };
};
var getUserPrice = (prices) => {
  const priceIndividual = prices == null ? void 0 : prices.find(
    (price) => price.priceLevel === "purchase"
  );
  if (priceIndividual) {
    return priceIndividual;
  }
  return prices == null ? void 0 : prices[0];
};
var prepareSeoUrlForProduct = (t, category, name) => {
  const validCategory = !category || category === "root" ? `/${t("PRODUCTS")}`.toLocaleLowerCase() : `/${replaceForSeo(category, t)}`;
  const validName = name ? `/${replaceForSeo(name, t)}` : "";
  return `${validCategory}${validName}`;
};
var replaceForSeo = (val, t) => {
  return val == null ? void 0 : val.toLocaleLowerCase().replace(/\s+/g, "-").replace(/\/+/g, "-").replace(/%/g, `-${t("PERCENT")}`.toLocaleLowerCase()).replace(/-+/g, "-");
};
var shouldShowDiscountInfo = ({
  meta,
  typePrice,
  module: module2
}) => {
  var _a2, _b, _c, _d, _e, _f, _g;
  let flag = false;
  if (module2 === "basket") {
    if (typePrice === "netto") {
      flag = !!((_a2 = meta == null ? void 0 : meta.fields) == null ? void 0 : _a2.basePriceNetto) && !!((_b = meta == null ? void 0 : meta.fields) == null ? void 0 : _b.valueNettoAfterDiscounts);
    } else if (typePrice === "brutto") {
      flag = !!((_c = meta == null ? void 0 : meta.fields) == null ? void 0 : _c.basePriceBrutto) && !!((_d = meta == null ? void 0 : meta.fields) == null ? void 0 : _d.valueBruttoAfterDiscounts);
    }
  }
  if (module2 === "product") {
    const purchase = (_g = (_f = (_e = meta == null ? void 0 : meta.extra_fields) == null ? void 0 : _e.prices) == null ? void 0 : _f.fields) == null ? void 0 : _g.purchase;
    if (typePrice === "netto") {
      flag = !!(purchase == null ? void 0 : purchase.priceNetto) && !!(purchase == null ? void 0 : purchase.discount);
    } else if (typePrice === "brutto") {
      flag = !!(purchase == null ? void 0 : purchase.priceBrutto) && !!(purchase == null ? void 0 : purchase.discount);
    }
  }
  return flag;
};

// src/utils/attributeUtils.ts
var getAttributeId = (id, type, prefix) => {
  const baseId = `attribute__${type}-${id}`;
  if (prefix) {
    return `${prefix}-${baseId}`;
  } else {
    return baseId;
  }
};
var getAttributeIdFromHTMLId = (htmlId) => {
  var _a2, _b, _c;
  const lastSegment = (_c = (_b = (_a2 = htmlId == null ? void 0 : htmlId.split("__")) == null ? void 0 : _a2.at(-1)) == null ? void 0 : _b.split("-")) == null ? void 0 : _c.at(-1);
  if (lastSegment === void 0 || lastSegment === "") {
    return void 0;
  }
  const parsed = Number(lastSegment);
  return Number.isNaN(parsed) ? void 0 : parsed;
};
var getAttributeContainerId = (id) => `attribute-${id}-container`;
var getAttributeClass = (type) => {
  return `attribute-${type}`;
};
var prepareAttributesForApi = (attributes, hasCredential, dirtyAttributes) => {
  var _a2;
  const data = [];
  for (const key in attributes) {
    if (attributes.hasOwnProperty(key) && attributes[key] !== void 0) {
      const attributeId = (_a2 = key == null ? void 0 : key.split("-")) == null ? void 0 : _a2.pop();
      const attributeValue = attributes[key];
      if ((!dirtyAttributes || (dirtyAttributes == null ? void 0 : dirtyAttributes[key])) && hasCredential(parseInt(attributeId), "attribute", "edit")) {
        data.push({ id: attributeId, value: attributeValue ?? null });
      }
    }
  }
  return data;
};
var prepareAttributesDefaultValues = (attributes) => {
  return attributes == null ? void 0 : attributes.reduce((acc, attr) => {
    var _a2, _b, _c, _d, _e, _f, _g, _h;
    const attributeId = `attribute__${attr.type}-${attr.id}`;
    if (attr.type === "list") {
      const preparedValue = (_c = (_b = (_a2 = attr == null ? void 0 : attr.value) == null ? void 0 : _a2.filter((opt) => opt.selected === true)) == null ? void 0 : _b.map((opt) => opt == null ? void 0 : opt.id)) == null ? void 0 : _c[0];
      acc[attributeId] = preparedValue ?? null;
    } else if (attr.type === "listMulti") {
      const preparedValue = (_e = (_d = attr == null ? void 0 : attr.value) == null ? void 0 : _d.filter((opt) => opt.selected === true)) == null ? void 0 : _e.map((opt) => opt == null ? void 0 : opt.id);
      acc[attributeId] = (preparedValue == null ? void 0 : preparedValue.length) ? preparedValue : null;
    } else if (attr.type === "userUser") {
      const preparedValue = (_f = attr == null ? void 0 : attr.value) == null ? void 0 : _f.map((opt) => opt == null ? void 0 : opt.id);
      acc[attributeId] = (preparedValue == null ? void 0 : preparedValue.length) ? preparedValue : null;
    } else if (attr.type === "company") {
      const preparedValue = (_g = attr == null ? void 0 : attr.value) == null ? void 0 : _g.map((opt) => opt == null ? void 0 : opt.id);
      acc[attributeId] = (preparedValue == null ? void 0 : preparedValue.length) ? preparedValue : null;
    } else if (attr.type === "accountUser") {
      const preparedValue = (_h = attr == null ? void 0 : attr.value) == null ? void 0 : _h.map((opt) => opt == null ? void 0 : opt.id);
      acc[attributeId] = (preparedValue == null ? void 0 : preparedValue.length) ? preparedValue : null;
    } else {
      acc[attributeId] = (attr == null ? void 0 : attr.value) ?? null;
    }
    return acc;
  }, {});
};
var preparePositionAttributesDefaultValues = (attributes) => {
  return attributes == null ? void 0 : attributes.reduce((acc, attr) => {
    var _a2, _b, _c, _d, _e;
    if (attr.type === "list") {
      acc[attr.id] = (_c = (_b = (_a2 = attr == null ? void 0 : attr.value) == null ? void 0 : _a2.filter((opt) => opt.selected === true)) == null ? void 0 : _b.map((opt) => opt == null ? void 0 : opt.id)) == null ? void 0 : _c[0];
    } else if (attr.type === "listMulti") {
      acc[attr.id] = (_e = (_d = attr == null ? void 0 : attr.value) == null ? void 0 : _d.filter((opt) => opt.selected === true)) == null ? void 0 : _e.map((opt) => opt == null ? void 0 : opt.id);
    } else {
      acc[attr.id] = attr.value;
    }
    return acc;
  }, {});
};
var preparePositionAttributesForApi = (attributes, metaAttributes, dirtyAttributes) => {
  var _a2;
  const data = [];
  for (const key in attributes) {
    if (attributes.hasOwnProperty(key) && attributes[key] !== void 0) {
      const attributeId = Number(key);
      const attributeValue = attributes[key];
      if ((!dirtyAttributes || (dirtyAttributes == null ? void 0 : dirtyAttributes[key])) && ((_a2 = metaAttributes == null ? void 0 : metaAttributes.find((attr) => attr.id === attributeId)) == null ? void 0 : _a2.credential) === 2) {
        data.push({ id: attributeId, value: attributeValue ?? null });
      }
    }
  }
  return data;
};

// src/utils/auraUtils.ts
var auraWindow = typeof window !== "undefined" ? window : {};
var new_task_uri = auraWindow == null ? void 0 : auraWindow.new_task_uri;
var jQuery = auraWindow == null ? void 0 : auraWindow.jQuery;
var auraCreateCampaignOpportunity = async ({
  companyId,
  onSubmit,
  redirectAfterSuccess = true
} = {}) => {
  const Dialog = auraWindow == null ? void 0 : auraWindow.Dialog;
  const _ = auraWindow == null ? void 0 : auraWindow._;
  let url = "/campaignOpportunity/createDialog/choose_campaign/true";
  if (companyId) {
    url = url + `/company_id/${companyId}`;
  }
  Dialog == null ? void 0 : Dialog.load({
    url,
    size: "small"
  }).element.on(
    "submit:success:ok.dialog",
    async (event, dialog, post, result) => {
      var _a2, _b;
      const id = (_b = (_a2 = result == null ? void 0 : result.json) == null ? void 0 : _a2.data) == null ? void 0 : _b.id;
      if (id) {
        if (onSubmit && typeof onSubmit === "function")
          await onSubmit(id);
        if (redirectAfterSuccess) {
          window.location.href = `/campaignOpportunity/show/opportunity_id/${id}`;
        }
      }
    }
  );
};
function auraCreateProccesFromShortcut({
  data,
  onSubmit,
  redirectAfterSuccess = true
} = {}) {
  const Dialog = auraWindow == null ? void 0 : auraWindow.Dialog;
  Dialog == null ? void 0 : Dialog.load({ url: "/commission/createWithConnection" }).on(
    "submit:ok.dialog",
    function(e, dialog, submittal, result) {
      if (submittal.data && submittal.data.shortcut_id > 0) {
        Dialog == null ? void 0 : Dialog.load({
          url: "/commission/createDialog/",
          data: Object.assign(submittal.data, data),
          size: "modal-xl"
        }).on("submit:ok.dialog", async (e2, dialog2, submittal2, result2) => {
          var _a2, _b;
          const id = (_b = (_a2 = result2 == null ? void 0 : result2.json) == null ? void 0 : _a2.data) == null ? void 0 : _b.id;
          if (id) {
            if (onSubmit && typeof onSubmit === "function")
              await onSubmit(id);
            if (redirectAfterSuccess) {
              window.location.href = `/commission/show/commission_id/${id}`;
            }
          }
        });
      }
    }
  );
}
var auraAddNewTask = () => {
  return new Promise((resolve, reject) => {
    if (auraWindow == null ? void 0 : auraWindow.reactDialog) {
      auraWindow.reactDialog({ url: new_task_uri + "/is_event/0" }, resolve);
    } else {
      auraWindow == null ? void 0 : auraWindow.newWindow({
        url: new_task_uri + "/is_event/0",
        onEvent: function(dial) {
          jQuery(dial).on("closed.dialog", function() {
            resolve();
          });
        }
      });
    }
  });
};
var auraAddNewEvent = () => {
  return new Promise((resolve, reject) => {
    if (auraWindow == null ? void 0 : auraWindow.reactDialog) {
      auraWindow.reactDialog({ url: new_task_uri + "/is_event/1" }, resolve);
    } else {
      auraWindow == null ? void 0 : auraWindow.newWindow({
        url: new_task_uri + "/is_event/1",
        onEvent: function(dial) {
          jQuery(dial).on("closed.dialog", function() {
            resolve();
          });
        }
      });
    }
  });
};
var auraEditTask = ({
  id,
  recurrence,
  callbackAfterClose
}) => {
  const url = `task/edit/task_id/${id}`;
  return new Promise((resolve, reject) => {
    if (auraWindow == null ? void 0 : auraWindow.reactDialog) {
      auraWindow.reactDialog(
        {
          url,
          callbackAfterClose,
          recurrence: (recurrence == null ? void 0 : recurrence.recurrenceUuid) ? recurrence : void 0
        },
        resolve
      );
    } else {
      auraWindow == null ? void 0 : auraWindow.newWindow({
        url,
        onEvent: function(dial) {
          jQuery(dial).on("closed.dialog", function() {
            callbackAfterClose == null ? void 0 : callbackAfterClose();
            return resolve();
          });
        }
      });
    }
  });
};
var auraCompleteTask = ({
  id,
  recurrence,
  callbackAfterClose
}) => {
  let url = (recurrence == null ? void 0 : recurrence.recurrenceUuid) ? `task/edit/execute/1/task_id/${id}` : `task/edit/execute/1/completed_task_id/${id}`;
  return new Promise((resolve, reject) => {
    if (auraWindow == null ? void 0 : auraWindow.reactDialog) {
      auraWindow.reactDialog(
        {
          url,
          callbackAfterClose,
          recurrence: (recurrence == null ? void 0 : recurrence.recurrenceUuid) ? recurrence : void 0
        },
        resolve
      );
    } else {
      auraWindow == null ? void 0 : auraWindow.newWindow({
        url,
        onEvent: function(dial) {
          jQuery(dial).on("closed.dialog", function() {
            callbackAfterClose == null ? void 0 : callbackAfterClose();
            return resolve();
          });
        }
      });
    }
  });
};

// src/utils/i18n.ts
var getCommonI18nConfig = (language, i18nVersion) => {
  return {
    lng: language || "pl",
    fallbackLng: "pl",
    ns: ["messages", "messagesCustom"],
    defaultNS: "messagesCustom",
    fallbackNS: "messages",
    nsSeparator: false,
    keySeparator: false,
    interpolation: {
      escapeValue: false
    },
    react: {
      useSuspense: false
    },
    backend: {
      loadPath: "/assets/{{ns}}.json?lang={{lng}}",
      allowMultiLoading: true,
      queryStringParams: {
        v: i18nVersion ?? ""
      }
    }
  };
};

// src/utils/listUtils.tsx
var import_react39 = require("@chakra-ui/react");
var import_date_fns2 = require("date-fns");
var import_isNil = __toESM(require("lodash/isNil"));
var import_partition = __toESM(require("lodash/partition"));
var import_uniq = __toESM(require("lodash/uniq"));
var import_xor = __toESM(require("lodash/xor"));
var import_react40 = __toESM(require("react"));
var import_fa2 = require("react-icons/fa");

// src/components/FilterFields/CellWrapper.tsx
var import_react28 = __toESM(require("react"));
var import_react29 = require("@chakra-ui/react");

// src/hooks/useAuraErrorResolver/useAuraErrorResolver.tsx
var import_react4 = require("@chakra-ui/react");
var import_js = require("@mdi/js");
var import_react5 = __toESM(require("@mdi/react"));

// src/hooks/useAuraTranslation.ts
var import_react_i18next = require("react-i18next");
var useAuraTranslation = () => {
  const { t: tCustom } = (0, import_react_i18next.useTranslation)("messagesCustom");
  const translationProps = (0, import_react_i18next.useTranslation)(["messagesCustom", "messages"], {
    nsMode: "fallback"
  });
  return { ...translationProps, tCustom };
};
var useAuraTranslation_default = useAuraTranslation;

// src/hooks/useAuraErrorResolver/useAuraErrorResolver.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var DURATION_ERROR_VISIBLE = 5e3;
var useAuraErrorResolver = () => {
  const toast = (0, import_react4.useToast)();
  const { t } = useAuraTranslation_default();
  const resolveApiError = (payload, options = {}) => {
    var _a2;
    const data = ((_a2 = payload == null ? void 0 : payload.response) == null ? void 0 : _a2.data) ?? payload;
    if (hasGeneralErrors(data == null ? void 0 : data.errors)) {
      handleGeneralError(data, options, t, toast);
    } else if (hasItemErrors(data == null ? void 0 : data.errors)) {
      if (options == null ? void 0 : options.nameFieldAsLinks) {
        handleErrorsWithLinks(data, options, t, toast);
      } else {
        handleItemErrors(data, options, t, toast);
      }
    } else if (payload instanceof AuraErrorResolverException) {
      handleCustomError(payload, options, t, toast);
    } else if (data) {
      handleUnknownErrors(data, t, toast);
    }
  };
  return { resolveApiError };
};
var AuraErrorResolverException = class extends Error {
  constructor(message, { code, module: module2 } = {}) {
    super(message);
    this.name = "AuraErrorResolverException";
    this.code = code;
    this.module = module2;
  }
};
var handleGeneralError = (data, options, t, toast) => {
  var _a2, _b;
  if (Array.isArray((_a2 = data == null ? void 0 : data.errors) == null ? void 0 : _a2.general))
    return;
  const toastData = prepareToastData((_b = data == null ? void 0 : data.errors) == null ? void 0 : _b.general, t, options);
  toast(toastData);
};
var handleItemErrors = (data, options, t, toast) => {
  var _a2;
  const errorItemKeys = (_a2 = Object.keys(data.errors)) == null ? void 0 : _a2.filter(
    (key) => key.startsWith("item_")
  );
  errorItemKeys == null ? void 0 : errorItemKeys.forEach((key) => {
    const errorItem = data.errors[key];
    if (Array.isArray(errorItem)) {
      errorItem == null ? void 0 : errorItem.forEach((item) => {
        const toastData = prepareToastData(item, t, options);
        toast(toastData);
      });
    } else {
      const toastData = prepareToastData(errorItem, t, options);
      toast(toastData);
    }
  });
};
var handleErrorsWithLinks = (data, options, t, toast) => {
  var _a2;
  const errorItemKeys = (_a2 = Object.keys(data.errors)) == null ? void 0 : _a2.filter(
    (key) => key.startsWith("item_")
  );
  const errorFields = [];
  errorItemKeys == null ? void 0 : errorItemKeys.forEach((key) => {
    const errorItem = data.errors[key];
    if (Array.isArray(errorItem)) {
      errorItem == null ? void 0 : errorItem.forEach((item) => {
        errorFields.push(item);
      });
    } else {
      errorFields.push(errorItem);
    }
  });
  const toastData = prepareToastData(errorFields, t, options);
  toast(toastData);
};
var handleCustomError = (data, options, t, toast) => {
  const toastData = prepareToastData(data, t, options, true);
  toast(toastData);
};
var handleUnknownErrors = (data, t, toast) => {
  if (process.env.NODE_ENV === "development") {
    console.error(
      "Error caught by useAuraErrorResolver but not handled. Error type unsupported.",
      data
    );
  }
  toast({
    title: t("ERROR"),
    status: "error",
    duration: DURATION_ERROR_VISIBLE,
    isClosable: true,
    variant: "solid"
  });
};
var hasGeneralErrors = (errors) => {
  return errors == null ? void 0 : errors.hasOwnProperty("general");
};
var hasItemErrors = (errors) => {
  if (!errors)
    return false;
  return Object.keys(errors).some((key) => key.startsWith("item_"));
};
var prepareToastData = (data, t, options, isAuraErrorResolverException) => {
  var _a2, _b;
  let preparedToastData = {
    status: "error",
    duration: DURATION_ERROR_VISIBLE,
    isClosable: true,
    variant: (options == null ? void 0 : options.variant) ?? "solid"
  };
  if (options == null ? void 0 : options.nameFieldAsLinks) {
    const toastId = "toast" + Math.random().toString(36).substring(2, 6);
    preparedToastData.render = () => getRenderMessageWithScrollLinks(data, t, toastId);
    preparedToastData.duration = null;
    preparedToastData.id = toastId;
  }
  if ((options == null ? void 0 : options.displayMode) !== "message") {
    if (options == null ? void 0 : options.customTitle) {
      preparedToastData.title = t(options.customTitle);
    } else {
      preparedToastData.title = (data == null ? void 0 : data.code) ? t(data == null ? void 0 : data.code) : t("ERROR");
    }
  }
  if ((options == null ? void 0 : options.displayMode) !== "title") {
    if (!!((_a2 = options == null ? void 0 : options.customMessage) == null ? void 0 : _a2.length)) {
      preparedToastData.description = t(options == null ? void 0 : options.customMessage);
    } else if (isAuraErrorResolverException) {
      preparedToastData.description = data == null ? void 0 : data.message;
    } else if (!!((_b = prepareToastDescription(data, t)) == null ? void 0 : _b.length)) {
      preparedToastData.description = prepareToastDescription(data, t);
    }
  }
  return preparedToastData;
};
var prepareToastDescription = (data, t) => {
  var _a2, _b;
  let description = "";
  const getExpectedPart = () => {
    if (data == null ? void 0 : data.expected) {
      return ` ${t("EXPECTED")}: ${t(data.expected)}.`;
    }
    return "";
  };
  if (data == null ? void 0 : data.field) {
    const customTranslation = ((_b = (_a2 = ErrorFieldsTranslationsMap == null ? void 0 : ErrorFieldsTranslationsMap.modules) == null ? void 0 : _a2[data == null ? void 0 : data.module]) == null ? void 0 : _b[data == null ? void 0 : data.field]) ?? ErrorFieldsTranslationsMap[data == null ? void 0 : data.field];
    const fieldName = customTranslation ?? (data == null ? void 0 : data.field);
    description = `${t("APPLIES_TO_FIELD")}: ${t(
      fieldName
    )}.${getExpectedPart()}`;
  }
  return description;
};
var getRenderMessageWithScrollLinks = (fieldErrors, t, id) => {
  const toast = (0, import_react4.useToast)();
  const getStandardFieldName = (fieldName) => {
    let name = fieldName;
    switch (fieldName) {
      case "accountUser":
        name = "ACCOUNT_USER";
        break;
      case "place":
        name = "ADDRESS";
        break;
      case "startDate":
        name = "DATE_START";
        break;
      case "endDate":
        name = "DATE_END";
        break;
      case "company":
        name = "COMPANY";
        break;
      case "product":
        name = "PRODUCT";
        break;
      case "servicedProduct":
        name = "SERVICED_PRODUCTS";
        break;
      default:
        break;
    }
    return name;
  };
  const links = fieldErrors == null ? void 0 : fieldErrors.map((errorField, index) => {
    var _a2, _b;
    const fieldIdToScroll = idExists((_a2 = errorField == null ? void 0 : errorField.details) == null ? void 0 : _a2.attributeId) ? getAttributeContainerId((_b = errorField == null ? void 0 : errorField.details) == null ? void 0 : _b.attributeId) : errorField.field;
    return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react4.Link, {
      as: "button",
      onClick: () => scrollToField(fieldIdToScroll),
      me: 1,
      _active: {
        textDecoration: "none"
      },
      textTransform: "lowercase",
      children: [
        t(getStandardFieldName(errorField == null ? void 0 : errorField.field)),
        index < (fieldErrors == null ? void 0 : fieldErrors.length) - 1 && ", "
      ]
    }, index);
  });
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react4.Box, {
    borderRadius: "6px",
    backgroundColor: "red.100",
    fontSize: "15px",
    lineHeight: "24px",
    w: "fit-content",
    p: "12px",
    position: "relative",
    className: "error-message-links",
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react4.Flex, {
      flexDir: "row",
      alignItems: "center",
      gap: "12px",
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react4.HStack, {
        alignItems: "flex-start",
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react4.Flex, {
            color: "red.500",
            alignItems: "center",
            h: "100%",
            children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react5.default, {
              size: "20px",
              path: import_js.mdiCloseCircle
            })
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react4.Box, {
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react4.Text, {
                border: "none",
                p: "0",
                letterSpacing: "0.25px",
                fontWeight: "700",
                children: t("ERROR_UPDATING_DATA")
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react4.Text, {
                fontStyle: "bodyInput",
                letterSpacing: "0.5px",
                children: [
                  t("FIELD_NOT_MEET_PHASE_CONDITIONS"),
                  ": ",
                  links
                ]
              })
            ]
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react4.CloseButton, {
            size: "sm",
            onClick: () => toast.close(id),
            position: "absolute",
            insetEnd: 1,
            top: 1
          })
        ]
      })
    })
  });
};
var ErrorFieldsTranslationsMap = {
  company: "CONTRACTOR",
  accountUser: "ACCOUNT_USER",
  place: "LOCATION",
  products: "PRODUCT",
  startDate: "DATE_START",
  endDate: "DATE_END",
  modules: {
    commission: {
      servicedProducts: "SERVICED_PRODUCT_CONNECTED_SERVICED_PRODUCTS",
      commissionPhase: "LIST_COLUMN_commissionPhase",
      user: "LIST_COLUMN_user",
      commissionsUserUsers: "LIST_COLUMN_commissionsUserUsers",
      documentSeriesDefinition: "LIST_COLUMN_documentSeriesDefinition"
    },
    servicedProduct: {
      isActive: "SERVICED_PRODUCT_IS_ACTIVE",
      date: "SERVICED_PRODUCT_DATE"
    },
    accountCompany: {
      defaultPriceType: "ACCOUNT_COMPANY_PRICE_GROUP",
      defaultPaymentType: "ACCOUNT_COMPANY_PAYMENT_TYPE",
      defaultLanguage: "ACCOUNT_COMPANY_LANGUAGE_TYPE",
      vatHandling: "ACCOUNT_COMPANY_VAT_HANDLING",
      defaultDeliveryType: "ACCOUNT_COMPANY_DELIVERY_TYPE",
      defaultOrderSeries: "ACCOUNT_COMPANY_ORDER_SERIES_TYPE",
      accountUsers: "ACCOUNT_COMPANY_INVOICE_ACCOUNT_USERS",
      defaultUser: "ACCOUNT_COMPANY_DEFAULT_USER",
      defaultPlace: "ACCOUNT_COMPANY_DEFAULT_ADDRESS",
      originalCreditLimit: "ACCOUNT_COMPANY_CREDIT_LIMIT",
      additionalPhs: "LIST_COLUMN_additionalPhs",
      PH: "LIST_COLUMN_ph",
      blockOrder: "LIST_COLUMN_blockOrder"
    },
    accountUser: {
      isInvoiceUser: "ACCOUNT_COMPANY_INVOICE_ACCOUNT_USERS"
    }
  }
};
var useAuraErrorResolver_default = useAuraErrorResolver;

// src/hooks/useCloneFiles.tsx
var useCloneFiles = () => {
  const { resolveApiError } = useAuraErrorResolver_default();
  const getCloneFiles = async (files) => {
    const clones = await Promise.all(
      files == null ? void 0 : files.map((file) => {
        var _a2;
        return createClone((_a2 = file.uris) == null ? void 0 : _a2.get, resolveApiError);
      })
    );
    return clones;
  };
  const getCloneFilesIds = async (files) => {
    const clones = await getCloneFiles(files);
    return clones == null ? void 0 : clones.map((file) => file == null ? void 0 : file.id);
  };
  return {
    getCloneFiles,
    getCloneFilesIds
  };
};
var createClone = async (fileUrl, resolveApiError) => {
  var _a2;
  try {
    const formData = new FormData();
    const response = await fetch(fileUrl);
    const blob = await response.blob();
    const fileName = fileUrl.split("/").pop() || "file";
    formData.append(`data_files`, blob, fileName);
    const responseUpload = await api_default.uploadFile(formData);
    return (_a2 = responseUpload == null ? void 0 : responseUpload.data) == null ? void 0 : _a2[0];
  } catch (error) {
    resolveApiError(error);
    console.error("Error while making file copy", error);
  }
};
var useCloneFiles_default = useCloneFiles;

// src/hooks/useListColumnsOrdering.ts
var import_react6 = require("react");
var useListColumnsOrdering = ({ columnOrder }) => {
  const [columnOrdering, setColumnOrdering] = (0, import_react6.useState)(columnOrder);
  (0, import_react6.useEffect)(() => {
    setColumnOrdering(columnOrder);
  }, [columnOrder]);
  return { columnOrdering, setColumnOrdering };
};
var useListColumnsOrdering_default = useListColumnsOrdering;

// src/hooks/useListColumnsVisibility.ts
var import_react7 = require("react");
var useListColumnsVisibility = ({
  allColumns,
  visibleColumns
}) => {
  const [checkedColumns, setCheckedColumns] = (0, import_react7.useState)(
    visibleColumns.map((col) => col.id)
  );
  (0, import_react7.useEffect)(() => {
    setCheckedColumns(visibleColumns.map((col) => col.id));
  }, [visibleColumns]);
  const handleCheckColumn = (columnId) => {
    setCheckedColumns(
      (oldColumns) => oldColumns.includes(columnId) ? oldColumns.filter((column) => column !== columnId) : [...oldColumns, columnId]
    );
  };
  const handleCheckAllColumns = () => {
    const allIds = allColumns.map((col) => col.id);
    if (checkedColumns.length < allIds.length) {
      setCheckedColumns(allColumns.map((col) => col.id));
    } else {
      setCheckedColumns([]);
    }
  };
  return {
    checkedColumns,
    handleCheckColumn,
    handleCheckAllColumns
  };
};
var useListColumnsVisibility_default = useListColumnsVisibility;

// src/hooks/useListFiltersVisibility.ts
var import_react8 = require("react");
var import_difference = __toESM(require("lodash/difference"));
var import_use_deep_compare_effect = __toESM(require("use-deep-compare-effect"));
var useListFiltersVisibility = ({
  allFilters,
  hiddenFilters
}) => {
  const [checkedFilters, setCheckedFilters] = (0, import_react8.useState)([]);
  const handleCheckFilter = (columnId) => {
    setCheckedFilters(
      (oldColumns) => oldColumns.includes(columnId) ? oldColumns.filter((column) => column !== columnId) : [...oldColumns, columnId]
    );
  };
  const handleCheckAllFilters = () => {
    const allIds = allFilters.map((col) => col.id);
    if (checkedFilters.length < allIds.length) {
      setCheckedFilters(allFilters.map((col) => col.id));
    } else {
      setCheckedFilters([]);
    }
  };
  (0, import_use_deep_compare_effect.default)(() => {
    setCheckedFilters(
      (0, import_difference.default)(
        allFilters.map((col) => col.id),
        hiddenFilters
      )
    );
  }, [allFilters, hiddenFilters]);
  return {
    checkedFilters,
    handleCheckFilter,
    handleCheckAllFilters
  };
};
var useListFiltersVisibility_default = useListFiltersVisibility;

// src/hooks/useListFilters.ts
var import_immer = __toESM(require("immer"));
var import_isEmpty = __toESM(require("lodash/isEmpty"));
var import_react10 = require("react");

// src/api.ts
var import_merge = __toESM(require("lodash/merge"));
var import_nookies = require("nookies");
var handleModuleAccessErrors = (response, responseBody, context) => {
  var _a2;
  if (response.status === 403) {
    if (/User has no permission on aura module: product/.test(
      (_a2 = responseBody.errors) == null ? void 0 : _a2.generalMessage
    )) {
      return context.res.redirect(307, "/");
    }
  }
};
var getBaseUrl = (context) => {
  return context ? context.req.apiUrl : document.location.origin + "/api";
};
var getAuthHeader = (apiToken) => {
  if (!apiToken) {
    return {};
  }
  return { Authorization: `Bearer ${apiToken}` };
};
var API = {
  get: async (apiUrl, options, signal, context) => {
    const baseURL = getBaseUrl(context);
    const cookies = (0, import_nookies.parseCookies)(context);
    const apiToken = cookies["api_token"];
    const { params } = options;
    const customReqParams = {
      ...(options == null ? void 0 : options.cache) ? { cache: options == null ? void 0 : options.cache } : {}
    };
    const urlSearchParams = new URLSearchParams(params);
    const fullUrl = `${baseURL}${apiUrl}?${urlSearchParams}`;
    logger_default.debug(`GET ${fullUrl}`);
    let res;
    try {
      res = await fetch(fullUrl, {
        method: "GET",
        headers: {
          ...getAuthHeader(apiToken)
        },
        ...customReqParams,
        signal
      });
    } catch (error) {
      console.error(error.message);
    }
    const jsonResponse = await res.json();
    handleModuleAccessErrors(res, jsonResponse, context);
    return jsonResponse;
  },
  post: async (apiUrl, payload, options, context) => {
    const baseURL = getBaseUrl(context);
    const cookies = (0, import_nookies.parseCookies)(context);
    const apiToken = cookies["api_token"];
    const { params } = options;
    const urlSearchParams = new URLSearchParams(params);
    const isFormData = payload instanceof FormData;
    const res = await fetch(`${baseURL}${apiUrl}?${urlSearchParams}`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        ...!isFormData ? { "Content-Type": "application/json" } : {},
        ...getAuthHeader(apiToken)
      },
      body: isFormData ? payload : JSON.stringify(payload)
    });
    const jsonResponse = await res.json();
    return jsonResponse;
  },
  patch: async (apiUrl, payload, options = { params: {} }, context) => {
    const baseURL = getBaseUrl(context);
    const cookies = (0, import_nookies.parseCookies)(context);
    const apiToken = cookies["api_token"];
    const { params } = options;
    const urlSearchParams = new URLSearchParams(params);
    const data = { data: payload };
    const res = await fetch(`${baseURL}${apiUrl}?${urlSearchParams}`, {
      method: "PATCH",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        ...getAuthHeader(apiToken)
      },
      body: JSON.stringify(data)
    });
    if (res.status === 401) {
      context.res.writeHead(301, {
        Location: "/"
      });
      context.res.end();
      return;
    }
    const jsonResponse = await res.json();
    return jsonResponse;
  },
  delete: async (apiUrl, options = { params: {} }, context) => {
    const baseURL = getBaseUrl(context);
    const { params } = options;
    const urlSearchParams = new URLSearchParams(params);
    const res = await fetch(`${baseURL}${apiUrl}?${urlSearchParams}`, {
      method: "DELETE"
    });
    const jsonResponse = await res.json();
    return jsonResponse;
  }
};
var api_default = {
  getMe: (context) => API.get("/me", {}, null, context),
  getAutoselect: (endpoint, options = {}, signal) => {
    return API.get(`/${endpoint}/autoselect`, options, signal);
  },
  getList: (endpoint, options = {}) => API.get(`/${endpoint}`, { ...options, cache: "no-store" }),
  getSetting: (settingKey, options = {}) => API.get(
    `/settings/${settingKey}`,
    (0, import_merge.default)(
      {
        params: {}
      },
      options
    )
  ),
  getUserSetting: (settingKey, options = {}) => API.get(`/user_settings/${settingKey}`, options),
  getProfileSetting: (settingKey, options = {}) => API.get(`/profile_settings/${settingKey}`, options),
  getSelectedProfileSetting: (options = {}) => API.get(`/profile_settings`, options),
  updateUserSetting: (settingKey, payload) => API.patch(`/user_settings/${settingKey}`, payload),
  updateProfileSetting: (settingKey, profileId, payload, options = {}) => API.post(
    `/profile_settings`,
    (0, import_merge.default)(
      {
        data: {
          name: settingKey,
          userProfile: profileId
        }
      },
      payload
    ),
    options
  ),
  removeUserSetting: (settingKey) => API.delete(`/user_settings/${settingKey}`),
  getBasket: async ({ options }) => API.get("/basket_contents", {
    ...options,
    params: {
      "setting[with_relations]": true,
      "page[limit]": -1
    }
  }),
  updateBasket: async ({ payload, options = {} }) => API.post(
    "/basket_contents",
    { data: payload },
    {
      ...options,
      params: {
        "setting[with_relations]": true,
        "page[limit]": -1
      }
    }
  ),
  getBasketPositions: async (id, options = {}) => API.get(`/baskets/${id}/basket_positions`, {
    params: {
      "setting[with_relations]": true,
      "page[limit]": -1,
      ...options
    }
  }),
  addBasketPosition: async ({ basketId, payload, options = {} }) => API.post(
    `/baskets/${basketId}/basket_positions`,
    { data: payload },
    {
      options
    }
  ),
  createBasketPosition: async ({ payload, options = {} }) => API.post(
    `/baskets/basket_positions`,
    { data: payload },
    {
      options
    }
  ),
  updateBasketPosition: async ({
    basketId,
    positionId,
    payload,
    options = {}
  }) => API.patch(
    `/baskets/${basketId}/basket_positions/${positionId}`,
    payload,
    options
  ),
  deleteBasketPositions: async ({ positionsIds }) => API.delete("/basket_positions", {
    params: {
      "filter[id][in]": positionsIds
    }
  }),
  clearBasketFromPositions: async ({ id }) => API.delete("/basket_positions", {
    params: {
      "filter[basket.id][in]": id
    }
  }),
  removeFavoritePositions: async ({ positionIds }) => API.delete("/favorite_positions", {
    params: {
      "filter[id][in]": positionIds
    }
  }),
  removeFavoriteProducts: async ({ productIds }) => API.delete("/favorite_positions", {
    params: {
      "filter[product.id][in]": productIds
    }
  }),
  updateLanguage: async ({ language, options = {} }) => API.patch(
    "/user_settings/systemLanguage",
    {
      value: [language]
    },
    options
  ),
  getMeta: async (endpoint, options = {}) => API.get(`/${endpoint}/meta`, options),
  getTemplates: async (options = {}) => API.get("/product_templates", options),
  uploadFile: (files, options) => API.post(
    "/files/upload",
    files,
    (0, import_merge.default)(
      {
        params: {}
      },
      options
    )
  ),
  getEndpoint: (endpoint, options) => API.get(`/${endpoint}`, options),
  getEndpointById: (endpoint, id, options) => API.get(
    `/${endpoint}/${id}`,
    (0, import_merge.default)(
      {
        params: {}
      },
      options
    )
  ),
  postEndpoint: (endpoint, data, options) => API.post(
    endpoint,
    data,
    (0, import_merge.default)(
      {
        params: {}
      },
      options
    )
  ),
  patchEndpoint: (endpoint, data, options) => API.patch(
    endpoint,
    data,
    (0, import_merge.default)(
      {
        params: {}
      },
      options
    )
  ),
  deleteElement: (endpoint, id, options) => API.delete(
    `/${endpoint}/${id}`,
    (0, import_merge.default)(
      {
        params: {}
      },
      options
    )
  )
};

// src/context/AuthContext.tsx
var import_react9 = __toESM(require("react"));
var import_react_query = require("react-query");
var import_jsx_runtime = require("react/jsx-runtime");
var UserTypes = /* @__PURE__ */ ((UserTypes2) => {
  UserTypes2[UserTypes2["accountUser"] = 1] = "accountUser";
  UserTypes2[UserTypes2["userUser"] = 2] = "userUser";
  UserTypes2[UserTypes2["guest"] = 3] = "guest";
  UserTypes2[UserTypes2["ghost"] = 4] = "ghost";
  return UserTypes2;
})(UserTypes || {});
var AuthContext = import_react9.default.createContext(null);
AuthContext.displayName = "AuthContext";
var AuthContextProvider = ({ value, me, children }) => {
  var _a2, _b, _c, _d;
  const { data, isLoading, isError } = (0, import_react_query.useQuery)(
    ["auth"],
    async () => {
      const response = await api_default.getMe();
      if (response.status === 401) {
        throw new Error("Unauthorized");
      }
      return response;
    },
    {
      retry: false,
      refetchOnWindowFocus: false,
      initialData: me,
      enabled: !me && !value
    }
  );
  const auth = data;
  if (process.env.NODE_ENV === "development") {
    printDebug(auth);
  }
  const checkIsUserUser = me ? ((_a2 = me == null ? void 0 : me.user) == null ? void 0 : _a2.type) === 2 /* userUser */ : ((_b = auth == null ? void 0 : auth.user) == null ? void 0 : _b.type) === 2 /* userUser */;
  const contextValue = isError ? {
    isUserUser: false,
    user: void 0
  } : me ? {
    isUserUser: checkIsUserUser,
    user: { ...me == null ? void 0 : me.user, profile: (_c = me == null ? void 0 : me.profile) == null ? void 0 : _c.id }
  } : {
    isUserUser: checkIsUserUser,
    user: { ...auth == null ? void 0 : auth.user, profile: (_d = auth == null ? void 0 : auth.profile) == null ? void 0 : _d.id }
  };
  if (isLoading) {
    return null;
  }
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuthContext.Provider, {
    value: value || contextValue,
    children
  });
};
var printDebug = (auth) => {
  if (!auth) {
    return;
  }
  const user = auth == null ? void 0 : auth.user;
  if (user) {
    console.log(
      `[Auth Context] Jeste\u015B zalogowany jako ${user.username} (${UserTypes[user.type]})`
    );
  } else {
    console.log("[Auth Context] Jeste\u015B niezalogowany");
  }
};

// src/hooks/useListFilters.ts
var import_date_fns = require("date-fns");
var initialState = {};
function reducer(state, action) {
  var _a2, _b;
  switch (action.type) {
    case "ADD_FILTER":
      if (typeof action.payload.value !== "boolean" && (action.payload.value === null || (0, import_isEmpty.default)(action.payload.value)) || ((_a2 = action.payload.value) == null ? void 0 : _a2.notZero) === false) {
        const newFilters = { ...state };
        delete newFilters[action.payload.name];
        return newFilters;
      }
      return {
        ...state,
        [action.payload.name]: {
          value: action.payload.value,
          type: action.payload.type,
          module: ((_b = action.payload) == null ? void 0 : _b.relatedModule) ?? null,
          additionalData: action.payload.additionalData
        }
      };
    case "REMOVE_FILTER": {
      const newFilters = { ...state };
      delete newFilters[action.payload];
      return newFilters;
    }
    case "REMOVE_FILTER_VALUE": {
      return (0, import_immer.default)(state, (draft) => {
        const currentFilter = draft[action.payload.filterName];
        if (["from", "to", "notZero"].includes(action.payload.value)) {
          delete currentFilter.value[action.payload.value];
        } else {
          currentFilter.value = currentFilter.value.filter(
            (opt) => opt !== action.payload.value
          );
        }
        if ((0, import_isEmpty.default)(currentFilter.value)) {
          delete draft[action.payload.filterName];
        }
      });
    }
    case "SET_FILTERS": {
      return action.payload;
    }
    case "RESET_FILTERS":
      return {};
    default:
      return state;
  }
}
var getFilterValueForUser = (value, isUserUser, userId) => {
  const cloneValues = [...value];
  const optionMeIndex = cloneValues.indexOf(0);
  if (!isUserUser && optionMeIndex > -1) {
    return value.splice(optionMeIndex, 1);
  }
  cloneValues[optionMeIndex] = userId;
  return cloneValues;
};
var parseFiltersForApi = (filters, isUserUser, user) => {
  if ((0, import_isEmpty.default)(filters)) {
    return {};
  }
  let preparedFilters = {};
  let standardFilters = {};
  let extraFilters = {};
  Object.keys(filters).forEach((f) => {
    var _a2, _b;
    if ((_b = (_a2 = filters[f]) == null ? void 0 : _a2.additionalData) == null ? void 0 : _b.isExtra) {
      extraFilters = { ...extraFilters, [f]: filters[f] };
    } else {
      standardFilters = { ...standardFilters, [f]: filters[f] };
    }
  });
  Object.keys(extraFilters).forEach((filterKey) => {
    var _a2, _b, _c, _d, _e, _f, _g;
    const currentExtraFilter = extraFilters[filterKey];
    if (currentExtraFilter.type === "float" && currentExtraFilter.additionalData.filterField === "prices") {
      const priceMin = currentExtraFilter.value.from;
      const priceMax = currentExtraFilter.value.to;
      const additionalData = currentExtraFilter.additionalData;
      if (priceMin && priceMin > -1) {
        let priceLowFilter = "";
        if (typeof additionalData.filterParam === "object") {
          priceLowFilter = getPriceFilterLevelForUserType({
            isUserUser: additionalData.filterParam.isUserUser,
            filterType: "gte",
            priceType: filterKey === "price_netto" ? "netto" : "brutto"
          });
        } else if (typeof additionalData.filterParam === "function") {
          priceLowFilter = additionalData.filterParam({
            isUserUser: isUserUser ?? false,
            filterType: "gte"
          });
        } else {
          priceLowFilter = additionalData.filterParam;
        }
        preparedFilters[priceLowFilter] = priceMin;
      }
      if (priceMax && priceMax > -1) {
        let priceHighFilter = "";
        if (typeof additionalData.filterParam === "object") {
          priceHighFilter = getPriceFilterLevelForUserType({
            isUserUser: additionalData.filterParam.isUserUser,
            filterType: "lte",
            priceType: filterKey === "price_netto" ? "netto" : "brutto"
          });
        } else if (typeof additionalData.filterParam === "function") {
          priceHighFilter = additionalData.filterParam({
            isUserUser: isUserUser ?? false,
            filterType: "lte"
          });
        } else {
          priceHighFilter = additionalData.filterParam;
        }
        preparedFilters[priceHighFilter] = priceMax;
      }
    }
    if (currentExtraFilter.type === "float" && ["availability", "quantity"].includes(
      currentExtraFilter.additionalData.filterField
    )) {
      if ((_a2 = currentExtraFilter.value) == null ? void 0 : _a2.from) {
        preparedFilters[`${currentExtraFilter.additionalData.filterParam}[gte]`] = Number(currentExtraFilter.value.from);
      }
      if ((_b = currentExtraFilter.value) == null ? void 0 : _b.to) {
        preparedFilters[`${currentExtraFilter.additionalData.filterParam}[lte]`] = Number(currentExtraFilter.value.to);
      }
      if ((_c = currentExtraFilter.value) == null ? void 0 : _c.notZero) {
        preparedFilters[`${currentExtraFilter.additionalData.filterParam}[gt]`] = 0;
      }
    }
    if (filterKey === "storehouse" && ((_d = currentExtraFilter.value) == null ? void 0 : _d[0])) {
      preparedFilters[currentExtraFilter.additionalData.filterParam] = (_e = currentExtraFilter.value) == null ? void 0 : _e[0];
    }
    if (currentExtraFilter.type === "text" && typeof currentExtraFilter.additionalData.filterParam === "string") {
      preparedFilters[currentExtraFilter.additionalData.filterParam] = currentExtraFilter.value;
    }
    if (currentExtraFilter.type === "custom" && typeof currentExtraFilter.additionalData.filterParam === "string") {
      preparedFilters[currentExtraFilter.additionalData.filterParam] = currentExtraFilter.value.join(",");
    }
    if (currentExtraFilter.type === "custom" && typeof currentExtraFilter.additionalData.getFilter === "function") {
      const filters2 = currentExtraFilter.additionalData.getFilter(currentExtraFilter);
      preparedFilters = { ...preparedFilters, ...filters2 };
    }
    if (currentExtraFilter.type === "boolean" && currentExtraFilter.value === true && ((_f = currentExtraFilter.additionalData.filterParam) == null ? void 0 : _f.optionTrue)) {
      preparedFilters = {
        ...preparedFilters,
        ...currentExtraFilter.additionalData.filterParam.optionTrue
      };
    }
    if (currentExtraFilter.type === "boolean" && currentExtraFilter.value === false && ((_g = currentExtraFilter.additionalData.filterParam) == null ? void 0 : _g.optionFalse)) {
      preparedFilters = {
        ...preparedFilters,
        ...currentExtraFilter.additionalData.filterParam.optionFalse
      };
    }
  });
  Object.keys(standardFilters).forEach((filterKey) => {
    var _a2, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u;
    const current = standardFilters[filterKey];
    if (current.module === "attributes") {
      switch (current.type) {
        case "text":
        case "email":
        case "phone":
        case "file":
          preparedFilters[`filter[attributes][${filterKey}][hasText]`] = escapeFilterValueForQuery(current == null ? void 0 : current.value);
          break;
        case "bool":
          preparedFilters[`filter[attributes][${filterKey}][eq]`] = current.value;
          break;
        case "numeric":
          if ((_a2 = current.value) == null ? void 0 : _a2.from) {
            preparedFilters[`filter[attributes][${filterKey}][gte]`] = Number(
              current.value.from
            );
          }
          if ((_b = current.value) == null ? void 0 : _b.to) {
            preparedFilters[`filter[attributes][${filterKey}][lte]`] = Number(
              current.value.to
            );
          }
          break;
        case "list":
        case "listMulti":
        case "tags":
        case "company":
        case "accountUser":
          preparedFilters[`filter[attributes][${filterKey}][in]`] = String(
            current.value
          );
          break;
        case "date":
        case "datetime":
          if ((_c = current.value) == null ? void 0 : _c.from) {
            const dateFrom = ((_d = current.value) == null ? void 0 : _d.from) === "today" ? (0, import_date_fns.startOfToday)() : (_e = current.value) == null ? void 0 : _e.from;
            preparedFilters[`filter[attributes][${filterKey}][gte]`] = formatDateForApi(dateFrom);
          }
          if ((_f = current.value) == null ? void 0 : _f.to) {
            const dateTo = ((_g = current.value) == null ? void 0 : _g.to) === "today" ? (0, import_date_fns.endOfToday)() : (_h = current.value) == null ? void 0 : _h.to;
            preparedFilters[`filter[attributes][${filterKey}][lte]`] = formatDateForApi(dateTo);
          }
          break;
        default:
          console.warn(`Unsupported attribute of type ${current.type}`);
          break;
      }
      return;
    }
    if (current.type === "integer" || current.type === "bigint" || current.type === "smallint" || current.type === "decimal" || current.type === "float") {
      if ((_i = current.value) == null ? void 0 : _i.from) {
        preparedFilters[`filter[${filterKey}][gte]`] = Number(
          current.value.from
        );
      }
      if ((_j = current.value) == null ? void 0 : _j.to) {
        preparedFilters[`filter[${filterKey}][lte]`] = Number(current.value.to);
      }
      return;
    }
    if (filterKey === "verified") {
      preparedFilters[`filter[${filterKey}][${current.value ? "isNull" : "isNotNull"}]`] = null;
      return;
    }
    if (current.type === "boolean") {
      preparedFilters[`filter[${filterKey}][eq]`] = current.value;
      return;
    }
    if (current.type === "datetime" || current.type === "date" || current.type === "datetimetz") {
      if ((_k = current.value) == null ? void 0 : _k.from) {
        const dateFrom = ((_l = current.value) == null ? void 0 : _l.from) === "today" ? (0, import_date_fns.startOfToday)() : (_m = current.value) == null ? void 0 : _m.from;
        preparedFilters[`filter[${filterKey}][gte]`] = formatDateForApi(dateFrom);
      }
      if ((_n = current.value) == null ? void 0 : _n.to) {
        const dateTo = ((_o = current.value) == null ? void 0 : _o.to) === "today" ? (0, import_date_fns.endOfToday)() : (_p = current.value) == null ? void 0 : _p.to;
        preparedFilters[`filter[${filterKey}][lte]`] = formatDateForApi(dateTo);
      }
      return;
    }
    if (current.type === "relation") {
      if ((_q = current == null ? void 0 : current.additionalData) == null ? void 0 : _q.filterParam) {
        preparedFilters[(_r = current == null ? void 0 : current.additionalData) == null ? void 0 : _r.filterParam] = String(
          current.value
        );
        return;
      }
      if (filterKey === "product" && typeof current.value === "string") {
        preparedFilters[`filter[${filterKey}.fullName][hasText]`] = escapeFilterValueForQuery(current == null ? void 0 : current.value);
        return;
      }
      if (["products", "servicedProducts"].includes(filterKey) && typeof current.value === "string") {
        preparedFilters[`filter[relations][${filterKey}.fullName][hasText]`] = escapeFilterValueForQuery(current == null ? void 0 : current.value);
        return;
      }
      if (["products", "servicedProducts"].includes(filterKey)) {
        preparedFilters[`filter[relations][${filterKey}.id][in]`] = String(
          current.value
        );
        return;
      }
      if (filterKey === "applyOn") {
        preparedFilters["filter[product.id][in]"] = String(current.value);
        return;
      }
      if (filterKey === "creatorUser") {
        if ((_s = current.value) == null ? void 0 : _s.includes(0)) {
          preparedFilters[`filterOr[${filterKey}.id][in]`] = String(
            getFilterValueForUser(current.value, isUserUser, user == null ? void 0 : user.id)
          );
          return;
        } else {
          preparedFilters[`filterOr[${filterKey}.id][in]`] = String(
            current.value
          );
        }
        return;
      }
      if (filterKey === "creatorAccountUser") {
        preparedFilters[`filterOr[${filterKey}.id][in]`] = String(
          current.value
        );
        return;
      }
      if (filterKey === "creator") {
        if (current.module === "userUser" && ((_t = current.value) == null ? void 0 : _t.includes(0)) && idExists(user == null ? void 0 : user.id)) {
          preparedFilters[`filter[creatorUser.id][in]`] = String(
            getFilterValueForUser(current.value, isUserUser, user == null ? void 0 : user.id)
          );
          return;
        } else if (current.module === "userUser") {
          preparedFilters[`filter[creatorUser.id][in]`] = String(current.value);
        } else if (current.module === "accountUser") {
          preparedFilters[`filter[creatorAccountUser.id][in]`] = String(
            current.value
          );
        }
        return;
      }
      if (current.module === "userUser" && ((_u = current.value) == null ? void 0 : _u.includes(0)) && idExists(user == null ? void 0 : user.id)) {
        preparedFilters[`filter[${filterKey}.id][in]`] = String(
          getFilterValueForUser(current.value, isUserUser, user == null ? void 0 : user.id)
        );
        return;
      }
      if (filterKey === "places") {
        const parsedValue = String(escapeFilterValueForQuery(current == null ? void 0 : current.value));
        const placeLabelListUsedFields = [
          "streetAddress",
          "streetNumber",
          "localNumber",
          "postalCode",
          "city"
        ];
        placeLabelListUsedFields.forEach(
          (field) => preparedFilters[`filterOr[${filterKey}.${field}][hasText]`] = parsedValue
        );
        return;
      }
      if (filterKey === "company" && typeof current.value === "string") {
        preparedFilters[`filter[${filterKey}.displayName][hasText]`] = escapeFilterValueForQuery(current == null ? void 0 : current.value);
        return;
      }
      preparedFilters[`filter[${filterKey}.id][in]`] = String(current.value);
      return;
    }
    if (filterKey === "elastic") {
      preparedFilters["filter[_q][hasText]"] = filters["elastic"].value;
      return;
    }
    if ([
      "applicationType",
      "connectedEmailStatus",
      "creationType",
      "currencyCode",
      "currency",
      "defaultPriceType",
      "documentStatus",
      "documentStatusByAu",
      "status",
      "type",
      "scope",
      "scopeType",
      "discountType",
      "applyOn"
    ].includes(filterKey)) {
      preparedFilters[`filter[${filterKey}][in]`] = String(
        filters[filterKey].value
      );
      return;
    }
    if (filterKey === "positions") {
      preparedFilters[`filter[${filterKey}.productName][ilike]`] = String(
        current.value
      );
      return;
    }
    preparedFilters[`filter[${filterKey}][hasText]`] = String(
      escapeFilterValueForQuery(standardFilters[filterKey].value)
    );
  });
  return preparedFilters;
};
var useListFilters = ({
  initialFilters = {}
} = {}) => {
  const auth = (0, import_react10.useContext)(AuthContext);
  const [filters, dispatch] = (0, import_react10.useReducer)(reducer, {
    ...initialState,
    ...initialFilters
  });
  const addFilter = (name, value, type, relatedModule, additionalData) => {
    dispatch({
      type: "ADD_FILTER",
      payload: {
        name,
        value,
        type,
        relatedModule,
        additionalData
      }
    });
  };
  const removeFilter = (name, val) => {
    if (val !== 0 && !val) {
      dispatch({
        type: "REMOVE_FILTER",
        payload: name
      });
    } else {
      dispatch({
        type: "REMOVE_FILTER_VALUE",
        payload: {
          filterName: name,
          value: val
        }
      });
    }
  };
  const resetFilters = () => {
    dispatch({ type: "RESET_FILTERS" });
  };
  const setFilters = (newFilters) => {
    dispatch({
      type: "SET_FILTERS",
      payload: newFilters
    });
  };
  const getFilterParams = () => {
    return parseFiltersForApi(filters, auth.isUserUser, auth.user);
  };
  return {
    filters,
    getFilterParams,
    addFilter,
    setFilters,
    removeFilter,
    resetFilters
  };
};

// src/hooks/useListPagination.ts
var import_react11 = require("@xstate/react");

// src/stateMachines/paginationMachine.ts
var import_xstate = require("xstate");
var import_actions = require("xstate/lib/actions");
var paginationMachine = (0, import_xstate.createMachine)(
  {
    id: "pagination",
    initial: "awaitingTotalPages",
    context: {
      currentPage: 1
    },
    on: {
      UPDATE_TOTAL_PAGES: {
        cond: "newTotalPagesIsValidValue",
        actions: (0, import_actions.choose)([
          {
            cond: "currentPageIsAboveNewTotalPages",
            actions: ["assignTotalPagesToContext", "goToFirstPage"]
          },
          {
            actions: ["assignTotalPagesToContext"]
          }
        ]),
        target: "idle"
      }
    },
    states: {
      awaitingTotalPages: {},
      idle: {
        on: {
          NEXT_PAGE: {
            cond: "canGoToNextPage",
            actions: "goToNextPage"
          },
          PREV_PAGE: {
            cond: "canGoToPrevPage",
            actions: "goToPrevPage"
          },
          GO_TO_TARGET_PAGE: {
            actions: "goToTargetPage",
            cond: "targetPageIsWithinBounds"
          }
        }
      }
    }
  },
  {
    guards: {
      newTotalPagesIsValidValue: (context, event) => {
        if (event.type !== "UPDATE_TOTAL_PAGES")
          return false;
        return event.totalPages > 0 || event.totalPages === 0;
      },
      currentPageIsAboveNewTotalPages: (context, event) => {
        if (event.type !== "UPDATE_TOTAL_PAGES")
          return false;
        return context.currentPage > event.totalPages;
      },
      canGoToNextPage: (context) => {
        return context.currentPage < context.totalPages;
      },
      canGoToPrevPage: (context) => {
        return context.currentPage > 1;
      },
      targetPageIsWithinBounds: (context, event) => {
        if (event.type !== "GO_TO_TARGET_PAGE")
          return false;
        return event.targetPage >= 1 && event.targetPage <= context.totalPages;
      }
    },
    actions: {
      goToFirstPage: (0, import_xstate.assign)({
        currentPage: 1
      }),
      goToPrevPage: (0, import_xstate.assign)({
        currentPage: (context) => context.currentPage - 1
      }),
      goToNextPage: (0, import_xstate.assign)({
        currentPage: (context) => context.currentPage + 1
      }),
      goToTargetPage: (0, import_xstate.assign)((context, event) => {
        if (event.type !== "GO_TO_TARGET_PAGE")
          return {};
        return {
          currentPage: event.targetPage
        };
      }),
      assignTotalPagesToContext: (0, import_xstate.assign)((context, event) => {
        if (event.type !== "UPDATE_TOTAL_PAGES")
          return {};
        return {
          totalPages: event.totalPages
        };
      })
    }
  }
);
var paginationMachine_default = paginationMachine;

// src/hooks/useListPagination.ts
var useListPagination = () => {
  const [current, send] = (0, import_react11.useMachine)(paginationMachine_default);
  const handleGoToNextPage = () => {
    send({ type: "NEXT_PAGE" });
  };
  const handleGoToPrevPage = () => {
    send({ type: "PREV_PAGE" });
  };
  const handleSetPage = (page) => {
    send({ type: "GO_TO_TARGET_PAGE", targetPage: page });
  };
  const setTotalPages = (totalPages) => {
    send({
      type: "UPDATE_TOTAL_PAGES",
      totalPages
    });
  };
  return {
    currentPage: current.context.currentPage,
    totalPages: current.context.totalPages,
    handleGoToNextPage,
    handleGoToPrevPage,
    handleSetPage,
    setTotalPages
  };
};
var useListPagination_default = useListPagination;

// src/hooks/useListSorting/useListSorting.ts
var import_react12 = require("react");
var sortingFieldMap = {
  campaign: "name",
  campaignPhase: "name",
  accountUser: "firstName",
  userUser: "firstName",
  accountCompany: "name",
  product: "name",
  products: "fullName",
  servicedProducts: "fullName"
};
var getFilterFieldForRelation = (fieldId, fieldModule) => {
  return `[${fieldId}.${(sortingFieldMap == null ? void 0 : sortingFieldMap[fieldModule]) ?? "id"}]`;
};
var getSortingField = (sortEntry, metaData) => {
  var _a2, _b;
  const field = metaData.fields[sortEntry.id];
  const extraField = metaData.extra_fields[sortEntry.id];
  if (field) {
    return field.type === "relation" ? getFilterFieldForRelation(sortEntry.id, field.relatedModule) : `[${sortEntry.id}]`;
  }
  if (extraField || sortEntry.id === "company.nip") {
    return `[${sortEntry.id}]`;
  }
  const [, attributeId] = sortEntry.id.split(".");
  const attribute = !Array.isArray(metaData.extra_fields) && metaData.extra_fields.attributes.items.find(
    (attr) => attr.id === Number(attributeId)
  );
  if (attribute) {
    return `[attributes][${attributeId}]`;
  }
  const relation = (_b = (_a2 = metaData.extra_fields) == null ? void 0 : _a2.relations) == null ? void 0 : _b.properties[sortEntry.id];
  if ((relation == null ? void 0 : relation.credential) > 0) {
    return "[relations]" + getFilterFieldForRelation(sortEntry.id, sortEntry.id);
  }
  return "UNKNOWN";
};
var useListSorting = (metaData) => {
  const [sorting, setSorting] = (0, import_react12.useState)([]);
  const getSortingParams = () => {
    const sortingParams = {};
    sorting.forEach(
      (sortEntry) => sortingParams[`order${getSortingField(sortEntry, metaData)}`] = sortEntry.desc ? "DESC" : "ASC"
    );
    return sortingParams;
  };
  return { sorting, setSorting, getSortingParams };
};
var useListSorting_default = useListSorting;

// src/hooks/useMinimalAutoselect.ts
var import_react_query2 = require("react-query");
var import_get = __toESM(require("lodash/get"));
var useMinimalAutoselect = ({
  endpoint,
  labelField,
  valueField = "id",
  fields,
  labelFieldCreator,
  extraFields,
  enabled = true,
  filters,
  settings,
  additionalOptionField,
  translateCustom = false
}) => {
  const { tCustom } = useAuraTranslation_default();
  return (0, import_react_query2.useQuery)(
    ["positions", endpoint, extraFields, filters],
    () => api_default.getAutoselect(endpoint, {
      params: {
        fields: [
          ...Array.isArray(labelField) ? labelField : [labelField],
          valueField,
          ...fields ?? []
        ].filter((v) => v).join(","),
        "page[limit]": -1,
        ...extraFields && { extra_fields: extraFields.join(",") },
        ...filters,
        ...settings
      }
    }),
    {
      select: (response) => {
        var _a2;
        return ((_a2 = response == null ? void 0 : response.data) == null ? void 0 : _a2.map((item) => {
          const additionalFields = {};
          if (additionalOptionField) {
            additionalOptionField.forEach((aof) => {
              const itemValue = (0, import_get.default)(item, aof.source);
              additionalFields[aof.field] = translateCustom && aof.source === labelField ? tCustom(itemValue) : itemValue;
            });
          }
          let value = item[labelField];
          if (labelFieldCreator && Array.isArray(labelField)) {
            value = labelFieldCreator(item);
          } else if (translateCustom) {
            value = tCustom(item[labelField]);
          }
          return {
            id: item[valueField],
            value,
            ...additionalFields
          };
        })) ?? [];
      },
      refetchOnWindowFocus: false,
      staleTime: Infinity,
      enabled: enabled && !!endpoint,
      retry: false,
      keepPreviousData: true
    }
  );
};
var useMinimalAutoselect_default = useMinimalAutoselect;

// src/hooks/useOnClick/useOnClick.tsx
var import_react13 = require("react");
var useOnClick = ({
  singleClickCallback,
  doubleClickCallback,
  delay = 500
}) => {
  const timer = (0, import_react13.useRef)(null);
  const lastEvent = (0, import_react13.useRef)(null);
  const sendEvent = (0, import_react13.useCallback)(
    (event, compareFields) => {
      const isSameEvent = (compareFields == null ? void 0 : compareFields.length) ? compareFields.every(
        (field) => {
          var _a2;
          return ((_a2 = lastEvent.current) == null ? void 0 : _a2[field]) === event[field];
        }
      ) : true;
      if (!timer.current) {
        lastEvent.current = event;
        timer.current = setTimeout(() => {
          singleClickCallback == null ? void 0 : singleClickCallback(event);
          timer.current = null;
          lastEvent.current = null;
        }, delay);
      } else {
        if (isSameEvent) {
          clearTimeout(timer.current);
          timer.current = null;
          lastEvent.current = null;
          doubleClickCallback == null ? void 0 : doubleClickCallback(event);
        } else {
          clearTimeout(timer.current);
          lastEvent.current = event;
          timer.current = setTimeout(() => {
            singleClickCallback == null ? void 0 : singleClickCallback(event);
            timer.current = null;
            lastEvent.current = null;
          }, delay);
        }
      }
    },
    [singleClickCallback, doubleClickCallback, delay]
  );
  return { sendEvent };
};
var useOnClick_default = useOnClick;

// src/hooks/useSetting.ts
var import_react_query3 = require("react-query");
var useSetting = (settingKey, params) => {
  const queryKey = ["setting", settingKey];
  const { data, isLoading } = (0, import_react_query3.useQuery)(
    queryKey,
    () => api_default.getSetting(settingKey, {
      ...params ? {
        params
      } : {}
    }),
    {
      staleTime: Infinity,
      enabled: Boolean(settingKey),
      refetchOnWindowFocus: false
    }
  );
  const setting = data == null ? void 0 : data.data;
  if ((setting == null ? void 0 : setting.type) === "bol" || (setting == null ? void 0 : setting.type) === "bln") {
    setting.value = (setting == null ? void 0 : setting.value) === true || (setting == null ? void 0 : setting.value) === 1 || (setting == null ? void 0 : setting.value) === "true" ? true : false;
  }
  if ((setting == null ? void 0 : setting.type) === "int") {
    setting.value = isNaN(parseInt(setting == null ? void 0 : setting.value)) ? 0 : parseInt(setting == null ? void 0 : setting.value);
  }
  return { setting, isLoading };
};
var useSetting_default = useSetting;

// src/context/SettingsContext.tsx
var import_react14 = __toESM(require("react"));
var import_jsx_runtime = require("react/jsx-runtime");
var SettingsContext = import_react14.default.createContext({});
SettingsContext.displayName = "SettingsContext";
var SettingsProvider = ({
  value,
  children
}) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(SettingsContext.Provider, {
    value,
    children
  });
};

// src/hooks/useSettings.ts
var import_react15 = require("react");
var useSettings = () => {
  const loadedSettings = (0, import_react15.useContext)(SettingsContext);
  return loadedSettings;
};
var useSettings_default = useSettings;

// src/hooks/useUserProfiles.ts
var import_react_query4 = require("react-query");
var useUserProfiles = (enabled = true) => {
  return (0, import_react_query4.useQuery)(
    ["userProfiles"],
    () => api_default.getAutoselect("user_profiles", {
      params: {
        fields: "profileName",
        "page[limit]": -1
      }
    }),
    {
      enabled,
      refetchOnWindowFocus: false
    }
  );
};
var useUserProfiles_default = useUserProfiles;

// src/hooks/useUserSettingsWithFallback.tsx
var import_isEmpty2 = __toESM(require("lodash/isEmpty"));
var import_merge2 = __toESM(require("lodash/merge"));
var import_react16 = __toESM(require("react"));
var import_react_query5 = require("react-query");
var hasNoSettings = (settingValue) => {
  return Array.isArray(settingValue) && (0, import_isEmpty2.default)(settingValue);
};
var useUserSettingsWithFallback = (settingKeys, initialData, selectedProfileId) => {
  var _a2, _b, _c, _d;
  const [profileFallback, setProfileFallback] = (0, import_react16.useState)(
    !!selectedProfileId ? true : false
  );
  const additionalProfileParams = {
    "filter[userProfile][eq]": selectedProfileId,
    "setting[limit_to_my_settings]": false,
    "filter[name][eq]": settingKeys.join("_")
  };
  const userSettingsQueryKey = ["userSettings", ...settingKeys];
  const {
    data: userSetting,
    isLoading: isLoadingUserSetting,
    refetch: refetchUserSetting
  } = (0, import_react_query5.useQuery)(
    userSettingsQueryKey,
    () => api_default.getUserSetting(settingKeys.join("_")),
    {
      enabled: settingKeys.length > 0 && !selectedProfileId,
      refetchOnWindowFocus: false,
      onSuccess: (response) => {
        if (hasNoSettings(response.data.value)) {
          setProfileFallback(true);
        }
      },
      ...initialData ? { initialData } : {}
    }
  );
  const profileSettingsQueryKey = [
    "profileSettings",
    ...settingKeys,
    selectedProfileId
  ];
  const {
    data: profileSetting,
    isLoading: isLoadingProfileSetting,
    refetch: refetchProfileSetting
  } = (0, import_react_query5.useQuery)(
    profileSettingsQueryKey,
    () => !!selectedProfileId ? api_default.getSelectedProfileSetting({
      params: additionalProfileParams
    }) : api_default.getProfileSetting(settingKeys.join("_")),
    { enabled: profileFallback }
  );
  const { mutate: updateUserSetting } = (0, import_react_query5.useMutation)(
    async (vars) => {
      const newConfig = Array.isArray(vars) ? {} : vars;
      await api_default.updateUserSetting(settingKeys.join("_"), {
        value: newConfig
      });
    },
    {
      onSuccess: () => {
        if (!selectedProfileId) {
          refetchUserSetting();
          setProfileFallback(false);
        }
      }
    }
  );
  const { mutateAsync: updateProfileSetting } = (0, import_react_query5.useMutation)(
    async ({ setting, profileId }) => {
      const newConfig = (0, import_merge2.default)(
        Array.isArray((profileSetting == null ? void 0 : profileSetting.value) ?? []) ? {} : profileSetting.value,
        setting
      );
      await api_default.updateProfileSetting(settingKeys.join("_"), profileId, {
        data: {
          value: newConfig
        },
        setting: {
          limit_to_my_settings: false,
          force_update_user_settings: true
        }
      });
    },
    {
      onSuccess: () => {
        refetchProfileSetting();
      }
    }
  );
  const setUserSetting = (0, import_react16.useCallback)(
    (setting) => {
      updateUserSetting(setting);
    },
    [updateUserSetting]
  );
  const setProfileSetting = (0, import_react16.useCallback)(
    (setting, profileId) => {
      return updateProfileSetting({ setting, profileId });
    },
    [updateProfileSetting]
  );
  return import_react16.default.useMemo(
    () => {
      var _a3, _b2, _c2, _d2;
      return {
        settings: profileFallback ? ((_a3 = profileSetting == null ? void 0 : profileSetting.data) == null ? void 0 : _a3.value) ?? ((_c2 = (_b2 = profileSetting == null ? void 0 : profileSetting.data) == null ? void 0 : _b2[0]) == null ? void 0 : _c2.value) ?? [] : ((_d2 = userSetting == null ? void 0 : userSetting.data) == null ? void 0 : _d2.value) ?? [],
        isLoading: isLoadingUserSetting || isLoadingProfileSetting,
        setUserSetting,
        setProfileSetting
      };
    },
    [
      isLoadingProfileSetting,
      isLoadingUserSetting,
      profileFallback,
      (_a2 = profileSetting == null ? void 0 : profileSetting.data) == null ? void 0 : _a2.value,
      (_c = (_b = profileSetting == null ? void 0 : profileSetting.data) == null ? void 0 : _b[0]) == null ? void 0 : _c.value,
      profileSetting,
      setUserSetting,
      (_d = userSetting == null ? void 0 : userSetting.data) == null ? void 0 : _d.value
    ]
  );
};
var useUserSettingsWithFallback_default = useUserSettingsWithFallback;

// src/hooks/useResponsive.ts
var import_react17 = require("@chakra-ui/react");
var useResponsive = () => {
  const theme = (0, import_react17.useTheme)();
  const [isSm, isMd, isLg, isXl] = (0, import_react17.useMediaQuery)([
    `(min-width: 0px)`,
    `(min-width: ${theme.breakpoints.md})`,
    `(min-width: ${theme.breakpoints.lg})`,
    `(min-width: ${theme.breakpoints.xl})`
  ]);
  return [isSm, isMd, isLg, isXl];
};
var useResponsive_default = useResponsive;

// src/hooks/useTemplates.tsx
var import_react18 = require("react");
var import_react_query6 = require("react-query");
var import_orderBy = __toESM(require("lodash/orderBy"));
var useTemplates = (type) => {
  const [hiddenDefaultTabs, setHiddenDefaultTabs] = (0, import_react18.useState)([]);
  const { data, isLoading } = (0, import_react_query6.useQuery)(
    ["product_templates", type],
    () => api_default.getEndpoint(`product_templates`, {
      params: {
        "filter[type][eq]": type,
        "order[priority]": "ASC",
        "order[name]": "ASC"
      }
    }),
    {
      select: (data2) => (data2 == null ? void 0 : data2.data) && (0, import_orderBy.default)(data2 == null ? void 0 : data2.data, ["priority"]),
      onSuccess: (data2) => {
        let hiddenIds = [];
        data2 == null ? void 0 : data2.forEach(
          (template) => {
            var _a2, _b;
            return (_b = (_a2 = template == null ? void 0 : template.options) == null ? void 0 : _a2.split(",")) == null ? void 0 : _b.forEach((id) => hiddenIds.push(Number(id)));
          }
        );
        (hiddenIds == null ? void 0 : hiddenIds.length) && setHiddenDefaultTabs(hiddenIds);
      }
    }
  );
  return { data, isLoading, hiddenDefaultTabs };
};
var useTemplates_default = useTemplates;

// src/hooks/usePersistedState.ts
var import_use_persisted_state = __toESM(require("use-persisted-state"));
var usePersistedState = (key, initialValue) => {
  const useCustomPersistedState = (0, import_use_persisted_state.default)(key);
  const [persistedState, setPersistedState] = useCustomPersistedState(initialValue);
  return {
    persistedState,
    setPersistedState
  };
};
var usePersistedState_default = usePersistedState;

// src/hooks/useFilesUpdateValidate.ts
var useFilesUpdateValidate = () => {
  const { t } = useAuraTranslation_default();
  const { setting } = useSetting_default("upload_limits", {
    "setting[parse_setting_value]": true
  });
  const uploadLimits = setting == null ? void 0 : setting.value;
  const translatedLimitSize = (uploadLimits == null ? void 0 : uploadLimits.maxAllowedSize) && Math.floor((uploadLimits == null ? void 0 : uploadLimits.maxAllowedSize) / 1048576);
  const validate3 = (filesToUpload) => {
    if ((filesToUpload == null ? void 0 : filesToUpload.length) > (uploadLimits == null ? void 0 : uploadLimits.maxFiles)) {
      throw new AuraErrorResolverException(
        `${t("ERROR_UPLOAD_FILE_MAX_COUNT")} (${uploadLimits == null ? void 0 : uploadLimits.maxFiles})`
      );
    }
    const totalSize = Array.from(filesToUpload).reduce(
      (total, file) => total + file.size,
      0
    );
    if (totalSize > (uploadLimits == null ? void 0 : uploadLimits.maxAllowedSize)) {
      throw new AuraErrorResolverException(
        `${t("ERROR_UPLOAD_FILE_MAX_SIZE")} (${translatedLimitSize}) MB`
      );
    }
  };
  return {
    validate: validate3
  };
};
var useFilesUpdateValidate_default = useFilesUpdateValidate;

// src/hooks/useDatera.ts
var import_react22 = require("react");

// src/context/DateraContext.tsx
var import_react19 = require("@chakra-ui/react");
var import_react20 = require("react");
var import_react_query7 = require("react-query");
var import_axios2 = __toESM(require("axios"));
var import_react21 = __toESM(require("@mdi/react"));
var import_js2 = require("@mdi/js");
var import_jsx_runtime = require("react/jsx-runtime");
var DateraContext = (0, import_react20.createContext)({
  call: (phoneNumber) => {
  },
  enableCall: false
});
var DateraProvider = ({
  children,
  enableCall = false
}) => {
  const { isOpen, onOpen, onClose } = (0, import_react19.useDisclosure)();
  const toast = (0, import_react19.useToast)();
  const { t } = useAuraTranslation_default();
  const [enableCallState, setEnableCallState] = (0, import_react20.useState)(enableCall);
  const [numberToConfirm, setNumberToConfirm] = (0, import_react20.useState)("");
  const cancelRef = (0, import_react20.useRef)(null);
  const { mutate: callAccountUser } = (0, import_react_query7.useMutation)(
    async (phoneNumberToCall) => {
      const url = `/accountCompany/ajaxMakeCall`;
      onClose();
      try {
        const response = await (0, import_axios2.default)({
          method: "POST",
          url,
          params: {
            destination: phoneNumberToCall
          }
        });
        if (!(response == null ? void 0 : response.data)) {
          throw new Error("No response data received");
        }
        return response.data;
      } catch (error) {
        if (import_axios2.default.isCancel(error)) {
          console.info("Request was cancelled for makeCall:", error.message);
          throw new Error("Request cancelled");
        }
        throw error;
      }
    },
    {
      onSuccess: (data) => {
        var _a2, _b, _c, _d, _e, _f, _g;
        const responseMsg = (_c = (_b = (_a2 = data.result) == null ? void 0 : _a2.result) == null ? void 0 : _b.response) == null ? void 0 : _c.message;
        if (data.status === true && ((_f = (_e = (_d = data.result) == null ? void 0 : _d.result) == null ? void 0 : _e.response) == null ? void 0 : _f.makecall) === true) {
          toast({
            title: t("CONNECTION_INITIATED"),
            description: t(responseMsg || "CONNECTION_INITIATED"),
            status: "success"
          });
        } else {
          if ((_g = data.messages) == null ? void 0 : _g.error) {
            toast({
              title: t(data.messages.error),
              description: t(responseMsg || ""),
              status: "error"
            });
            console.error(data.messages.error);
          } else if (responseMsg) {
            toast({
              title: t("An unexpected error occured."),
              status: "error"
            });
            console.error(responseMsg);
          } else {
            toast({
              title: t("AN_UNKNOWN_ERROR_OCCURRED_WHILE_TRYING_TO_CONNECT"),
              description: t(
                "AN_UNKNOWN_ERROR_OCCURRED_WHILE_TRYING_TO_CONNECT"
              ),
              status: "error"
            });
            console.error("Unknown response error:", data);
          }
        }
      },
      onError: (error) => {
        if (error.message !== "Request cancelled") {
          toast({
            title: t("An error occured during connection"),
            description: t(error.message || "ERROR_UNKNOWN"),
            status: "error"
          });
          console.error("Error during callAccountUser:", error);
        } else {
          console.info("Call request was intentionally cancelled.");
        }
      }
    }
  );
  const call = (phoneNumber) => {
    if (!enableCallState) {
      console.log("Calling is disabled.");
      return;
    }
    setNumberToConfirm(phoneNumber);
    onOpen();
  };
  const handleConfirmCall = () => {
    if (numberToConfirm) {
      callAccountUser(numberToConfirm);
    }
    onClose();
    setNumberToConfirm(null);
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(DateraContext.Provider, {
    value: {
      call,
      enableCall: enableCallState
    },
    children: [
      children,
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react19.AlertDialog, {
        isOpen,
        onClose,
        leastDestructiveRef: cancelRef,
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react19.AlertDialogOverlay, {
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react19.AlertDialogContent, {
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react19.AlertDialogHeader, {
                fontSize: "lg",
                fontWeight: "bold",
                children: t("CONFIRM_CONNECTION")
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react19.AlertDialogBody, {
                children: [
                  t("ARE_YOU_SURE_YOU_WANT_TO_CONNECT_TO"),
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Header_default, {
                    fontWeight: "bold",
                    children: formatPhoneNumber(numberToConfirm || "")
                  })
                ]
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react19.AlertDialogFooter, {
                children: [
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react19.Button, {
                    ref: cancelRef,
                    onClick: onClose,
                    children: t("CANCEL")
                  }),
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react19.Button, {
                    colorScheme: "green",
                    onClick: handleConfirmCall,
                    ml: 3,
                    leftIcon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react21.default, {
                      path: import_js2.mdiPhone,
                      size: "24px"
                    }),
                    children: t("CONNECT")
                  })
                ]
              })
            ]
          })
        })
      })
    ]
  });
};

// src/hooks/useDatera.ts
var useDatera = () => {
  const context = (0, import_react22.useContext)(DateraContext);
  return context;
};
var useDatera_default = useDatera;

// src/hooks/useClearElasticFilter.tsx
var import_react23 = require("react");
var useClearElasticFilter = ({
  filters = {},
  removeFunction
}) => {
  (0, import_react23.useEffect)(() => {
    if (Object.keys(filters).length > 1 && filters.elastic) {
      removeFunction("elastic");
    }
  }, [filters]);
};
var useClearElasticFilter_default = useClearElasticFilter;

// src/hooks/useCheckCompanyTax/useCheckCompanyTax.tsx
var import_react27 = require("react");
var import_use_debounce = require("use-debounce");

// src/consts.ts
var USED_SETTINGS = [
  "cookie_notice",
  "sell_by_price",
  "shop_title",
  "database_version",
  "enable_multilingualism",
  "inventory_thumbnail_height",
  "inventory_thumbnail_width",
  "company_search_for_user_user",
  "searchbar_account_user"
];
var UNRESET_SCSS = `
/**
 * Unreset CSS
 *
 * Copyright (C) 2016 Kite (ixkaito@gmail.com)
 * License MIT
 * Version 1.0.0
 *
 * Unreset CSS restores browsers' default element styles which are reset by
 * Eric Meyer's Reset CSS, YUI 3 Reset CSS, HTML5 Reset Stylesheet of HTML5
 * Doctor, or Tim Murtaugh's HTML5 Reset.
 */

/**
 * 
 * html {
 *   box-sizing: content-box;
 * }
 * 
 * body {
 *   margin: 8px;
 *   line-height: normal;
 * }
 * 
 */

p {
	margin: 1em 0;
}

blockquote,
figure {
	margin: 1em 40px;
}

q {
	quotes: "\u201C" "\u201D" "\u2018" "\u2019";

	&:before {
		content: open-quote;
	}

	&:after {
		content: close-quote;
	}
}

hr {
	border: 1px inset;
	box-sizing: border-box;
	margin: 0.5em auto;
}

h1 {
	font-size: 2em;
	font-weight: bold;
	margin: 0.67em 0;
}

h2 {
	font-size: 1.5em;
	font-weight: bold;
	margin: 0.83em 0;
}

h3 {
	font-size: 1.17em;
	font-weight: bold;
	margin: 1em 0;
}

h4 {
	font-size: 1.00em;
	font-weight: bold;
	margin: 1.33em 0;
}

h5 {
	font-size: 0.83em;
	font-weight: bold;
	margin: 1.67em 0;
}

h6 {
	font-size: 0.67em;
	font-weight: bold;
	margin: 2.33em 0;
}

article, aside, nav, section {

	h1 {
		font-size: 1.5em;
		font-weight: bold;
		margin: 0.83em 0;
	}

	article, aside, nav, section {

		h1 {
			font-size: 1.17em;
			font-weight: bold;
			margin: 1em 0;
		}

		article, aside, nav, section {

			h1 {
				font-size: 1.00em;
				font-weight: bold;
				margin: 1.33em 0;
			}

			article, aside, nav, section {

				h1 {
					font-size: 0.83em;
					font-weight: bold;
					margin: 1.67em 0;
				}

				article, aside, nav, section {

					h1 {
						font-size: 0.67em;
						font-weight: bold;
						margin: 2.33em 0;
					}
				}
			}
		}
	}
}

table {
	border-collapse: separate;
	border-spacing: 2px;
	border-color: gray;
}

thead,
tbody,
tfoot,
tr {
	border-color: inherit;
	vertical-align: middle;
}

td, th {
	padding: 1px;
	vertical-align: inherit;
}

th {
	font-weight: bold
}

caption {
	text-align: center;
}

ul, menu {
	list-style-type: disc;
	margin: 1em 0;
	padding: 0 0 0 40px;
}

ol {
	list-style-type: decimal;
	margin: 1em 0;
	padding: 0 0 0 40px;
}

ul, ol {

	ul {
		list-style-type: circle;
	}

	ul, ol {

		ul {
			list-style-type: square;
		}
	}
}

dd {
	margin: 0 0 0 40px;
}

dl {
	margin: 1em 0;
}

ul, ol, menu, dl {

	ul, ol, menu, dl {
		margin: 0;
	}
}

legend {
	padding: 0 2px;
}

fieldset {
	border-style: groove;
	border-width: 2px;
	border: 2px groove ThreeDFace;
	margin: 0 2px;
	padding: 0 2px 3px;
	-webkit-padding-before: 0.35em;
	-webkit-padding-start: 0.75em;
	-webkit-padding-end: 0.75em;
	-webkit-padding-after: 0.625em;
}

ins {
	background-color: transparent;
	font-weight: inherit;
	text-decoration: underline;
}

b, strong {
	font-weight: bold;
}

i, cite, em, var, address, dfn {
	font-style: italic;
	font-weight: inherit;
}

abbr[title], dfn[title] {
	border-bottom: 0;
	cursor: default;
	font-weight: inherit;
}

tt, code, kbd, samp {
	font-family: monospace;
	font-weight: inherit;
}

pre {
	font-family: monospace;
	margin: 1em 0;
	white-space: pre;
}

mark {
	background-color: yellow;
	color: black;
	font-style: normal;
	font-weight: inherit;
}

big {
	font-size: larger;
	font-weight: inherit;
}

small {
	font-size: smaller;
	font-weight: inherit;
}

sub, sup {
	font-weight: inherit;
	line-height: inherit;
	position: static;
}

sub {
	font-size: smaller;
	bottom: 0;
	vertical-align: sub;
}

sup {
	font-size: smaller;
	top: 0;
	vertical-align: super;
}

ruby {

	> rt {
		font-size: 50%;
	}
}

iframe {
	border: 2px inset;
}
`;
var DATE_FORMAT_DOTS = "dd.MM.yyyy";
var DATETIME_FORMAT_DOTS = "dd.MM.yyyy HH:mm";
var HOUR_MINUTE_FORMAT = "HH:mm";
var DATE_DAY_MONTH_FORMAT = "dd.MM";
var DEFAULT_LIMIT_AVAILABLE_PRODUCTS = 1e8;
var COPY_PRODUCTS_STORAGE_KEY = "copyProducts";
var WRAP_LINES_IN_LISTS = 4;
var ACCOUNT_COMPANY_CREATION_TYPE = /* @__PURE__ */ ((ACCOUNT_COMPANY_CREATION_TYPE2) => {
  ACCOUNT_COMPANY_CREATION_TYPE2[ACCOUNT_COMPANY_CREATION_TYPE2["DatasourceImport"] = 1] = "DatasourceImport";
  ACCOUNT_COMPANY_CREATION_TYPE2[ACCOUNT_COMPANY_CREATION_TYPE2["RegistrationForm"] = 2] = "RegistrationForm";
  ACCOUNT_COMPANY_CREATION_TYPE2[ACCOUNT_COMPANY_CREATION_TYPE2["Manual"] = 3] = "Manual";
  return ACCOUNT_COMPANY_CREATION_TYPE2;
})(ACCOUNT_COMPANY_CREATION_TYPE || {});
var ACCOUNT_COMPANY_VAT_HANDLING = /* @__PURE__ */ ((ACCOUNT_COMPANY_VAT_HANDLING2) => {
  ACCOUNT_COMPANY_VAT_HANDLING2["Standard"] = "STANDARD";
  ACCOUNT_COMPANY_VAT_HANDLING2["NotApplied"] = "NOT_APPLIED";
  return ACCOUNT_COMPANY_VAT_HANDLING2;
})(ACCOUNT_COMPANY_VAT_HANDLING || {});
var MODULE_MAP = /* @__PURE__ */ ((MODULE_MAP2) => {
  MODULE_MAP2[MODULE_MAP2["commissions"] = 5] = "commissions";
  return MODULE_MAP2;
})(MODULE_MAP || {});
var DOCUMENT_POSITION_TYPES = /* @__PURE__ */ ((DOCUMENT_POSITION_TYPES2) => {
  DOCUMENT_POSITION_TYPES2[DOCUMENT_POSITION_TYPES2["product"] = 1] = "product";
  DOCUMENT_POSITION_TYPES2[DOCUMENT_POSITION_TYPES2["separatorHeader"] = 2] = "separatorHeader";
  DOCUMENT_POSITION_TYPES2[DOCUMENT_POSITION_TYPES2["separatorSummary"] = 3] = "separatorSummary";
  DOCUMENT_POSITION_TYPES2[DOCUMENT_POSITION_TYPES2["delivery"] = 4] = "delivery";
  return DOCUMENT_POSITION_TYPES2;
})(DOCUMENT_POSITION_TYPES || {});
var LANGUAGES = /* @__PURE__ */ ((LANGUAGES2) => {
  LANGUAGES2["PL"] = "pl";
  LANGUAGES2["EN"] = "en";
  LANGUAGES2["DE"] = "de";
  LANGUAGES2["RU"] = "ru";
  return LANGUAGES2;
})(LANGUAGES || {});
var TAGS_TYPES = /* @__PURE__ */ ((TAGS_TYPES2) => {
  TAGS_TYPES2[TAGS_TYPES2["commission"] = 1] = "commission";
  TAGS_TYPES2[TAGS_TYPES2["accountCompany"] = 2] = "accountCompany";
  TAGS_TYPES2[TAGS_TYPES2["accountUser"] = 3] = "accountUser";
  TAGS_TYPES2[TAGS_TYPES2["userForm"] = 4] = "userForm";
  TAGS_TYPES2[TAGS_TYPES2["campaignOpportunity"] = 5] = "campaignOpportunity";
  TAGS_TYPES2[TAGS_TYPES2["campaignOpportunityLostCause"] = 6] = "campaignOpportunityLostCause";
  return TAGS_TYPES2;
})(TAGS_TYPES || {});
var CAMPAIGN_STATUSES = /* @__PURE__ */ ((CAMPAIGN_STATUSES2) => {
  CAMPAIGN_STATUSES2[CAMPAIGN_STATUSES2["planned"] = 0] = "planned";
  CAMPAIGN_STATUSES2[CAMPAIGN_STATUSES2["active"] = 1] = "active";
  CAMPAIGN_STATUSES2[CAMPAIGN_STATUSES2["closed"] = 2] = "closed";
  return CAMPAIGN_STATUSES2;
})(CAMPAIGN_STATUSES || {});
var CAMPAIGN_OPPORTUNITY_STATUSES = /* @__PURE__ */ ((CAMPAIGN_OPPORTUNITY_STATUSES2) => {
  CAMPAIGN_OPPORTUNITY_STATUSES2["open"] = "O";
  CAMPAIGN_OPPORTUNITY_STATUSES2["won"] = "W";
  CAMPAIGN_OPPORTUNITY_STATUSES2["lost"] = "L";
  CAMPAIGN_OPPORTUNITY_STATUSES2["hold"] = "H";
  return CAMPAIGN_OPPORTUNITY_STATUSES2;
})(CAMPAIGN_OPPORTUNITY_STATUSES || {});
var KSEF_STATUSES = {
  SENT: "KSEF_STATUS_SENT",
  PROCESSING: "KSEF_STATUS_PROCESSING",
  ENQUEUED: "KSEF_STATUS_ENQUEUED",
  ERROR: "KSEF_STATUS_ERROR",
  NOT_SENT: "KSEF_STATUS_NOT_SENT"
};
var TAX_TYPES = {
  NIP: 1,
  VAT_EU: 2,
  OTHER: 3,
  NONE: 4
};
var TAX_UE_COUNTRIES = /* @__PURE__ */ ((TAX_UE_COUNTRIES2) => {
  TAX_UE_COUNTRIES2["AT"] = "AT";
  TAX_UE_COUNTRIES2["BE"] = "BE";
  TAX_UE_COUNTRIES2["BG"] = "BG";
  TAX_UE_COUNTRIES2["CY"] = "CY";
  TAX_UE_COUNTRIES2["CZ"] = "CZ";
  TAX_UE_COUNTRIES2["DE"] = "DE";
  TAX_UE_COUNTRIES2["DK"] = "DK";
  TAX_UE_COUNTRIES2["EE"] = "EE";
  TAX_UE_COUNTRIES2["EL"] = "EL";
  TAX_UE_COUNTRIES2["ES"] = "ES";
  TAX_UE_COUNTRIES2["EU"] = "EU";
  TAX_UE_COUNTRIES2["FI"] = "FI";
  TAX_UE_COUNTRIES2["FR"] = "FR";
  TAX_UE_COUNTRIES2["HR"] = "HR";
  TAX_UE_COUNTRIES2["HU"] = "HU";
  TAX_UE_COUNTRIES2["IE"] = "IE";
  TAX_UE_COUNTRIES2["IT"] = "IT";
  TAX_UE_COUNTRIES2["LT"] = "LT";
  TAX_UE_COUNTRIES2["LU"] = "LU";
  TAX_UE_COUNTRIES2["LV"] = "LV";
  TAX_UE_COUNTRIES2["MT"] = "MT";
  TAX_UE_COUNTRIES2["NL"] = "NL";
  TAX_UE_COUNTRIES2["PT"] = "PT";
  TAX_UE_COUNTRIES2["RO"] = "RO";
  TAX_UE_COUNTRIES2["SE"] = "SE";
  TAX_UE_COUNTRIES2["SI"] = "SI";
  TAX_UE_COUNTRIES2["SK"] = "SK";
  TAX_UE_COUNTRIES2["XI"] = "XI";
  return TAX_UE_COUNTRIES2;
})(TAX_UE_COUNTRIES || {});
var TAX_NON_UE_COUNTRIES = /* @__PURE__ */ ((TAX_NON_UE_COUNTRIES2) => {
  TAX_NON_UE_COUNTRIES2["AD"] = "AD";
  TAX_NON_UE_COUNTRIES2["AE"] = "AE";
  TAX_NON_UE_COUNTRIES2["AF"] = "AF";
  TAX_NON_UE_COUNTRIES2["AG"] = "AG";
  TAX_NON_UE_COUNTRIES2["AI"] = "AI";
  TAX_NON_UE_COUNTRIES2["AL"] = "AL";
  TAX_NON_UE_COUNTRIES2["AM"] = "AM";
  TAX_NON_UE_COUNTRIES2["AO"] = "AO";
  TAX_NON_UE_COUNTRIES2["AQ"] = "AQ";
  TAX_NON_UE_COUNTRIES2["AR"] = "AR";
  TAX_NON_UE_COUNTRIES2["AS"] = "AS";
  TAX_NON_UE_COUNTRIES2["AU"] = "AU";
  TAX_NON_UE_COUNTRIES2["AW"] = "AW";
  TAX_NON_UE_COUNTRIES2["AX"] = "AX";
  TAX_NON_UE_COUNTRIES2["AZ"] = "AZ";
  TAX_NON_UE_COUNTRIES2["BA"] = "BA";
  TAX_NON_UE_COUNTRIES2["BB"] = "BB";
  TAX_NON_UE_COUNTRIES2["BD"] = "BD";
  TAX_NON_UE_COUNTRIES2["BF"] = "BF";
  TAX_NON_UE_COUNTRIES2["BH"] = "BH";
  TAX_NON_UE_COUNTRIES2["BI"] = "BI";
  TAX_NON_UE_COUNTRIES2["BJ"] = "BJ";
  TAX_NON_UE_COUNTRIES2["BL"] = "BL";
  TAX_NON_UE_COUNTRIES2["BM"] = "BM";
  TAX_NON_UE_COUNTRIES2["BN"] = "BN";
  TAX_NON_UE_COUNTRIES2["BO"] = "BO";
  TAX_NON_UE_COUNTRIES2["BQ"] = "BQ";
  TAX_NON_UE_COUNTRIES2["BR"] = "BR";
  TAX_NON_UE_COUNTRIES2["BS"] = "BS";
  TAX_NON_UE_COUNTRIES2["BT"] = "BT";
  TAX_NON_UE_COUNTRIES2["BV"] = "BV";
  TAX_NON_UE_COUNTRIES2["BW"] = "BW";
  TAX_NON_UE_COUNTRIES2["BY"] = "BY";
  TAX_NON_UE_COUNTRIES2["BZ"] = "BZ";
  TAX_NON_UE_COUNTRIES2["CA"] = "CA";
  TAX_NON_UE_COUNTRIES2["CC"] = "CC";
  TAX_NON_UE_COUNTRIES2["CD"] = "CD";
  TAX_NON_UE_COUNTRIES2["CF"] = "CF";
  TAX_NON_UE_COUNTRIES2["CG"] = "CG";
  TAX_NON_UE_COUNTRIES2["CH"] = "CH";
  TAX_NON_UE_COUNTRIES2["CI"] = "CI";
  TAX_NON_UE_COUNTRIES2["CK"] = "CK";
  TAX_NON_UE_COUNTRIES2["CL"] = "CL";
  TAX_NON_UE_COUNTRIES2["CM"] = "CM";
  TAX_NON_UE_COUNTRIES2["CN"] = "CN";
  TAX_NON_UE_COUNTRIES2["CO"] = "CO";
  TAX_NON_UE_COUNTRIES2["CR"] = "CR";
  TAX_NON_UE_COUNTRIES2["CU"] = "CU";
  TAX_NON_UE_COUNTRIES2["CV"] = "CV";
  TAX_NON_UE_COUNTRIES2["CW"] = "CW";
  TAX_NON_UE_COUNTRIES2["CX"] = "CX";
  TAX_NON_UE_COUNTRIES2["DJ"] = "DJ";
  TAX_NON_UE_COUNTRIES2["DM"] = "DM";
  TAX_NON_UE_COUNTRIES2["DO"] = "DO";
  TAX_NON_UE_COUNTRIES2["DZ"] = "DZ";
  TAX_NON_UE_COUNTRIES2["EC"] = "EC";
  TAX_NON_UE_COUNTRIES2["EG"] = "EG";
  TAX_NON_UE_COUNTRIES2["EH"] = "EH";
  TAX_NON_UE_COUNTRIES2["ER"] = "ER";
  TAX_NON_UE_COUNTRIES2["ET"] = "ET";
  TAX_NON_UE_COUNTRIES2["FJ"] = "FJ";
  TAX_NON_UE_COUNTRIES2["FK"] = "FK";
  TAX_NON_UE_COUNTRIES2["FM"] = "FM";
  TAX_NON_UE_COUNTRIES2["FO"] = "FO";
  TAX_NON_UE_COUNTRIES2["GA"] = "GA";
  TAX_NON_UE_COUNTRIES2["GB"] = "GB";
  TAX_NON_UE_COUNTRIES2["GD"] = "GD";
  TAX_NON_UE_COUNTRIES2["GE"] = "GE";
  TAX_NON_UE_COUNTRIES2["GF"] = "GF";
  TAX_NON_UE_COUNTRIES2["GG"] = "GG";
  TAX_NON_UE_COUNTRIES2["GH"] = "GH";
  TAX_NON_UE_COUNTRIES2["GI"] = "GI";
  TAX_NON_UE_COUNTRIES2["GL"] = "GL";
  TAX_NON_UE_COUNTRIES2["GM"] = "GM";
  TAX_NON_UE_COUNTRIES2["GN"] = "GN";
  TAX_NON_UE_COUNTRIES2["GP"] = "GP";
  TAX_NON_UE_COUNTRIES2["GQ"] = "GQ";
  TAX_NON_UE_COUNTRIES2["GS"] = "GS";
  TAX_NON_UE_COUNTRIES2["GT"] = "GT";
  TAX_NON_UE_COUNTRIES2["GU"] = "GU";
  TAX_NON_UE_COUNTRIES2["GW"] = "GW";
  TAX_NON_UE_COUNTRIES2["GY"] = "GY";
  TAX_NON_UE_COUNTRIES2["HK"] = "HK";
  TAX_NON_UE_COUNTRIES2["HM"] = "HM";
  TAX_NON_UE_COUNTRIES2["HN"] = "HN";
  TAX_NON_UE_COUNTRIES2["HT"] = "HT";
  TAX_NON_UE_COUNTRIES2["ID"] = "ID";
  TAX_NON_UE_COUNTRIES2["IL"] = "IL";
  TAX_NON_UE_COUNTRIES2["IM"] = "IM";
  TAX_NON_UE_COUNTRIES2["IN"] = "IN";
  TAX_NON_UE_COUNTRIES2["IO"] = "IO";
  TAX_NON_UE_COUNTRIES2["IQ"] = "IQ";
  TAX_NON_UE_COUNTRIES2["IR"] = "IR";
  TAX_NON_UE_COUNTRIES2["IS"] = "IS";
  TAX_NON_UE_COUNTRIES2["JE"] = "JE";
  TAX_NON_UE_COUNTRIES2["JM"] = "JM";
  TAX_NON_UE_COUNTRIES2["JO"] = "JO";
  TAX_NON_UE_COUNTRIES2["JP"] = "JP";
  TAX_NON_UE_COUNTRIES2["KE"] = "KE";
  TAX_NON_UE_COUNTRIES2["KG"] = "KG";
  TAX_NON_UE_COUNTRIES2["KH"] = "KH";
  TAX_NON_UE_COUNTRIES2["KI"] = "KI";
  TAX_NON_UE_COUNTRIES2["KM"] = "KM";
  TAX_NON_UE_COUNTRIES2["KN"] = "KN";
  TAX_NON_UE_COUNTRIES2["KP"] = "KP";
  TAX_NON_UE_COUNTRIES2["KR"] = "KR";
  TAX_NON_UE_COUNTRIES2["KW"] = "KW";
  TAX_NON_UE_COUNTRIES2["KY"] = "KY";
  TAX_NON_UE_COUNTRIES2["KZ"] = "KZ";
  TAX_NON_UE_COUNTRIES2["LA"] = "LA";
  TAX_NON_UE_COUNTRIES2["LB"] = "LB";
  TAX_NON_UE_COUNTRIES2["LC"] = "LC";
  TAX_NON_UE_COUNTRIES2["LI"] = "LI";
  TAX_NON_UE_COUNTRIES2["LK"] = "LK";
  TAX_NON_UE_COUNTRIES2["LR"] = "LR";
  TAX_NON_UE_COUNTRIES2["LS"] = "LS";
  TAX_NON_UE_COUNTRIES2["LY"] = "LY";
  TAX_NON_UE_COUNTRIES2["MA"] = "MA";
  TAX_NON_UE_COUNTRIES2["MC"] = "MC";
  TAX_NON_UE_COUNTRIES2["MD"] = "MD";
  TAX_NON_UE_COUNTRIES2["ME"] = "ME";
  TAX_NON_UE_COUNTRIES2["MF"] = "MF";
  TAX_NON_UE_COUNTRIES2["MG"] = "MG";
  TAX_NON_UE_COUNTRIES2["MH"] = "MH";
  TAX_NON_UE_COUNTRIES2["MK"] = "MK";
  TAX_NON_UE_COUNTRIES2["ML"] = "ML";
  TAX_NON_UE_COUNTRIES2["MM"] = "MM";
  TAX_NON_UE_COUNTRIES2["MN"] = "MN";
  TAX_NON_UE_COUNTRIES2["MO"] = "MO";
  TAX_NON_UE_COUNTRIES2["MP"] = "MP";
  TAX_NON_UE_COUNTRIES2["MQ"] = "MQ";
  TAX_NON_UE_COUNTRIES2["MR"] = "MR";
  TAX_NON_UE_COUNTRIES2["MS"] = "MS";
  TAX_NON_UE_COUNTRIES2["MU"] = "MU";
  TAX_NON_UE_COUNTRIES2["MV"] = "MV";
  TAX_NON_UE_COUNTRIES2["MW"] = "MW";
  TAX_NON_UE_COUNTRIES2["MX"] = "MX";
  TAX_NON_UE_COUNTRIES2["MY"] = "MY";
  TAX_NON_UE_COUNTRIES2["MZ"] = "MZ";
  TAX_NON_UE_COUNTRIES2["NA"] = "NA";
  TAX_NON_UE_COUNTRIES2["NC"] = "NC";
  TAX_NON_UE_COUNTRIES2["NE"] = "NE";
  TAX_NON_UE_COUNTRIES2["NF"] = "NF";
  TAX_NON_UE_COUNTRIES2["NG"] = "NG";
  TAX_NON_UE_COUNTRIES2["NI"] = "NI";
  TAX_NON_UE_COUNTRIES2["NO"] = "NO";
  TAX_NON_UE_COUNTRIES2["NP"] = "NP";
  TAX_NON_UE_COUNTRIES2["NR"] = "NR";
  TAX_NON_UE_COUNTRIES2["NU"] = "NU";
  TAX_NON_UE_COUNTRIES2["NZ"] = "NZ";
  TAX_NON_UE_COUNTRIES2["OM"] = "OM";
  TAX_NON_UE_COUNTRIES2["PA"] = "PA";
  TAX_NON_UE_COUNTRIES2["PE"] = "PE";
  TAX_NON_UE_COUNTRIES2["PF"] = "PF";
  TAX_NON_UE_COUNTRIES2["PG"] = "PG";
  TAX_NON_UE_COUNTRIES2["PH"] = "PH";
  TAX_NON_UE_COUNTRIES2["PK"] = "PK";
  TAX_NON_UE_COUNTRIES2["PM"] = "PM";
  TAX_NON_UE_COUNTRIES2["PN"] = "PN";
  TAX_NON_UE_COUNTRIES2["PR"] = "PR";
  TAX_NON_UE_COUNTRIES2["PS"] = "PS";
  TAX_NON_UE_COUNTRIES2["PW"] = "PW";
  TAX_NON_UE_COUNTRIES2["PY"] = "PY";
  TAX_NON_UE_COUNTRIES2["QA"] = "QA";
  TAX_NON_UE_COUNTRIES2["RE"] = "RE";
  TAX_NON_UE_COUNTRIES2["RS"] = "RS";
  TAX_NON_UE_COUNTRIES2["RU"] = "RU";
  TAX_NON_UE_COUNTRIES2["RW"] = "RW";
  TAX_NON_UE_COUNTRIES2["SA"] = "SA";
  TAX_NON_UE_COUNTRIES2["SB"] = "SB";
  TAX_NON_UE_COUNTRIES2["SC"] = "SC";
  TAX_NON_UE_COUNTRIES2["SD"] = "SD";
  TAX_NON_UE_COUNTRIES2["SG"] = "SG";
  TAX_NON_UE_COUNTRIES2["SH"] = "SH";
  TAX_NON_UE_COUNTRIES2["SJ"] = "SJ";
  TAX_NON_UE_COUNTRIES2["SL"] = "SL";
  TAX_NON_UE_COUNTRIES2["SM"] = "SM";
  TAX_NON_UE_COUNTRIES2["SN"] = "SN";
  TAX_NON_UE_COUNTRIES2["SO"] = "SO";
  TAX_NON_UE_COUNTRIES2["SR"] = "SR";
  TAX_NON_UE_COUNTRIES2["SS"] = "SS";
  TAX_NON_UE_COUNTRIES2["ST"] = "ST";
  TAX_NON_UE_COUNTRIES2["SV"] = "SV";
  TAX_NON_UE_COUNTRIES2["SX"] = "SX";
  TAX_NON_UE_COUNTRIES2["SY"] = "SY";
  TAX_NON_UE_COUNTRIES2["SZ"] = "SZ";
  TAX_NON_UE_COUNTRIES2["TC"] = "TC";
  TAX_NON_UE_COUNTRIES2["TD"] = "TD";
  TAX_NON_UE_COUNTRIES2["TF"] = "TF";
  TAX_NON_UE_COUNTRIES2["TG"] = "TG";
  TAX_NON_UE_COUNTRIES2["TH"] = "TH";
  TAX_NON_UE_COUNTRIES2["TJ"] = "TJ";
  TAX_NON_UE_COUNTRIES2["TK"] = "TK";
  TAX_NON_UE_COUNTRIES2["TL"] = "TL";
  TAX_NON_UE_COUNTRIES2["TM"] = "TM";
  TAX_NON_UE_COUNTRIES2["TN"] = "TN";
  TAX_NON_UE_COUNTRIES2["TO"] = "TO";
  TAX_NON_UE_COUNTRIES2["TR"] = "TR";
  TAX_NON_UE_COUNTRIES2["TT"] = "TT";
  TAX_NON_UE_COUNTRIES2["TV"] = "TV";
  TAX_NON_UE_COUNTRIES2["TW"] = "TW";
  TAX_NON_UE_COUNTRIES2["TZ"] = "TZ";
  TAX_NON_UE_COUNTRIES2["UA"] = "UA";
  TAX_NON_UE_COUNTRIES2["UG"] = "UG";
  TAX_NON_UE_COUNTRIES2["UM"] = "UM";
  TAX_NON_UE_COUNTRIES2["US"] = "US";
  TAX_NON_UE_COUNTRIES2["UY"] = "UY";
  TAX_NON_UE_COUNTRIES2["UZ"] = "UZ";
  TAX_NON_UE_COUNTRIES2["VA"] = "VA";
  TAX_NON_UE_COUNTRIES2["VC"] = "VC";
  TAX_NON_UE_COUNTRIES2["VE"] = "VE";
  TAX_NON_UE_COUNTRIES2["VG"] = "VG";
  TAX_NON_UE_COUNTRIES2["VI"] = "VI";
  TAX_NON_UE_COUNTRIES2["VN"] = "VN";
  TAX_NON_UE_COUNTRIES2["VU"] = "VU";
  TAX_NON_UE_COUNTRIES2["WF"] = "WF";
  TAX_NON_UE_COUNTRIES2["WS"] = "WS";
  TAX_NON_UE_COUNTRIES2["YE"] = "YE";
  TAX_NON_UE_COUNTRIES2["YT"] = "YT";
  TAX_NON_UE_COUNTRIES2["ZA"] = "ZA";
  TAX_NON_UE_COUNTRIES2["ZM"] = "ZM";
  TAX_NON_UE_COUNTRIES2["ZW"] = "ZW";
  return TAX_NON_UE_COUNTRIES2;
})(TAX_NON_UE_COUNTRIES || {});
var CHANGELOG_FIELD_TYPES = /* @__PURE__ */ ((CHANGELOG_FIELD_TYPES2) => {
  CHANGELOG_FIELD_TYPES2[CHANGELOG_FIELD_TYPES2["standard"] = 1] = "standard";
  CHANGELOG_FIELD_TYPES2[CHANGELOG_FIELD_TYPES2["attribute"] = 2] = "attribute";
  CHANGELOG_FIELD_TYPES2[CHANGELOG_FIELD_TYPES2["positionField"] = 3] = "positionField";
  CHANGELOG_FIELD_TYPES2[CHANGELOG_FIELD_TYPES2["positionAttribute"] = 4] = "positionAttribute";
  return CHANGELOG_FIELD_TYPES2;
})(CHANGELOG_FIELD_TYPES || {});
var DOCUMENT_TYPES = /* @__PURE__ */ ((DOCUMENT_TYPES2) => {
  DOCUMENT_TYPES2[DOCUMENT_TYPES2["documentSaleInvoice"] = 1] = "documentSaleInvoice";
  DOCUMENT_TYPES2[DOCUMENT_TYPES2["documentPurchaseInvoice"] = 2] = "documentPurchaseInvoice";
  DOCUMENT_TYPES2[DOCUMENT_TYPES2["documentStore"] = 3] = "documentStore";
  DOCUMENT_TYPES2[DOCUMENT_TYPES2["documentPayment"] = 4] = "documentPayment";
  DOCUMENT_TYPES2[DOCUMENT_TYPES2["commission"] = 5] = "commission";
  DOCUMENT_TYPES2[DOCUMENT_TYPES2["documentSalesReport"] = 6] = "documentSalesReport";
  DOCUMENT_TYPES2[DOCUMENT_TYPES2["documentOrder"] = 7] = "documentOrder";
  DOCUMENT_TYPES2[DOCUMENT_TYPES2["documentOfferQuestion"] = 8] = "documentOfferQuestion";
  DOCUMENT_TYPES2[DOCUMENT_TYPES2["internalDocumentOrder"] = 10] = "internalDocumentOrder";
  DOCUMENT_TYPES2[DOCUMENT_TYPES2["documentInventory"] = 11] = "documentInventory";
  DOCUMENT_TYPES2[DOCUMENT_TYPES2["shipping"] = 12] = "shipping";
  DOCUMENT_TYPES2[DOCUMENT_TYPES2["task"] = 13] = "task";
  DOCUMENT_TYPES2[DOCUMENT_TYPES2["campaignOpportunity"] = 14] = "campaignOpportunity";
  DOCUMENT_TYPES2[DOCUMENT_TYPES2["accountCompany"] = 15] = "accountCompany";
  return DOCUMENT_TYPES2;
})(DOCUMENT_TYPES || {});
var COMMISSION_SCOPE_TYPES = /* @__PURE__ */ ((COMMISSION_SCOPE_TYPES2) => {
  COMMISSION_SCOPE_TYPES2[COMMISSION_SCOPE_TYPES2["parent"] = 1] = "parent";
  COMMISSION_SCOPE_TYPES2[COMMISSION_SCOPE_TYPES2["child"] = 2] = "child";
  COMMISSION_SCOPE_TYPES2[COMMISSION_SCOPE_TYPES2["parallelStart"] = 3] = "parallelStart";
  COMMISSION_SCOPE_TYPES2[COMMISSION_SCOPE_TYPES2["parallelEnd"] = 4] = "parallelEnd";
  return COMMISSION_SCOPE_TYPES2;
})(COMMISSION_SCOPE_TYPES || {});
var COMMISSION_SCOPE_TYPE_LABELS = {
  [2 /* child */]: "child",
  [1 /* parent */]: "parent",
  [3 /* parallelStart */]: "parallelStart",
  [4 /* parallelEnd */]: "parallelEnd"
};
var MESSAGE_FETCH_INTERVAL = 6e4;
var LOCAL_STORAGE_MESSAGES_LAST_FETCH = "messages-last-fetch";
var RECEIVER_GROUP_USERS_TYPES = /* @__PURE__ */ ((RECEIVER_GROUP_USERS_TYPES2) => {
  RECEIVER_GROUP_USERS_TYPES2[RECEIVER_GROUP_USERS_TYPES2["userUser"] = 1] = "userUser";
  RECEIVER_GROUP_USERS_TYPES2[RECEIVER_GROUP_USERS_TYPES2["accountUser"] = 2] = "accountUser";
  return RECEIVER_GROUP_USERS_TYPES2;
})(RECEIVER_GROUP_USERS_TYPES || {});
var CURRENCY_CHANGE_CONFIRM_DIALOG_TYPES = /* @__PURE__ */ ((CURRENCY_CHANGE_CONFIRM_DIALOG_TYPES2) => {
  CURRENCY_CHANGE_CONFIRM_DIALOG_TYPES2["CURRENCY"] = "CURRENCY";
  CURRENCY_CHANGE_CONFIRM_DIALOG_TYPES2["EXCHANGE_RATIO"] = "EXCHANGE_RATIO";
  CURRENCY_CHANGE_CONFIRM_DIALOG_TYPES2["DOCUMENT_DATE"] = "DOCUMENT_DATE";
  return CURRENCY_CHANGE_CONFIRM_DIALOG_TYPES2;
})(CURRENCY_CHANGE_CONFIRM_DIALOG_TYPES || {});
var DOCUMENT_INVOICE_TYPES = /* @__PURE__ */ ((DOCUMENT_INVOICE_TYPES2) => {
  DOCUMENT_INVOICE_TYPES2[DOCUMENT_INVOICE_TYPES2["SELL"] = 1] = "SELL";
  DOCUMENT_INVOICE_TYPES2[DOCUMENT_INVOICE_TYPES2["PURCHASE"] = 2] = "PURCHASE";
  return DOCUMENT_INVOICE_TYPES2;
})(DOCUMENT_INVOICE_TYPES || {});
var NIP_BLOCKING_MODE = /* @__PURE__ */ ((NIP_BLOCKING_MODE2) => {
  NIP_BLOCKING_MODE2[NIP_BLOCKING_MODE2["NONE"] = 0] = "NONE";
  NIP_BLOCKING_MODE2[NIP_BLOCKING_MODE2["BLOCK"] = 1] = "BLOCK";
  NIP_BLOCKING_MODE2[NIP_BLOCKING_MODE2["WARN"] = 2] = "WARN";
  return NIP_BLOCKING_MODE2;
})(NIP_BLOCKING_MODE || {});

// src/hooks/useCheckCompanyTax/useCheckCompanyTax.tsx
var import_react_query8 = require("react-query");
var import_isEmpty3 = __toESM(require("lodash/isEmpty"));

// src/components/TaxCheckAlert/TaxCheckAlert.tsx
var import_react24 = require("@chakra-ui/react");
var import_js3 = require("@mdi/js");
var import_react25 = __toESM(require("@mdi/react"));
var import_react26 = require("react");
var import_jsx_runtime = require("react/jsx-runtime");
var TaxCheckAlert = ({
  isInvalid,
  message,
  hasDuplicates,
  onShowDuplicates
}) => {
  const { t } = useAuraTranslation_default();
  const { isOpen, onOpen, onClose } = (0, import_react24.useDisclosure)({ defaultIsOpen: true });
  (0, import_react26.useEffect)(() => {
    if (isInvalid) {
      onOpen();
    }
  }, [isInvalid, message]);
  const handleOnClickShowDuplicates = () => {
    onClose();
    onShowDuplicates == null ? void 0 : onShowDuplicates();
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react24.Popover, {
    isOpen: !!isInvalid && isOpen,
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react24.Portal, {
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react24.PopoverContent, {
        position: "fixed",
        left: "50%",
        transform: "translateX(-50%) !important",
        bottom: { base: "6px", md: "24px" },
        borderRadius: "6px",
        backgroundColor: "red.500",
        color: "white",
        fontSize: "15px",
        lineHeight: "24px",
        w: "fit-content",
        maxW: "calc(100% - 24px)",
        border: "none",
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react24.PopoverBody, {
          px: "16px",
          py: "12px",
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react24.HStack, {
            alignItems: "flex-start",
            spacing: 3,
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react24.Flex, {
                alignItems: "center",
                h: "100%",
                children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react25.default, {
                  path: import_js3.mdiAlertCircle,
                  size: "24px"
                })
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react24.Box, {
                children: [
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react24.Text, {
                    fontWeight: 700,
                    letterSpacing: "0.25px",
                    children: t("ERROR")
                  }),
                  message && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react24.Text, {
                    letterSpacing: "0.25px",
                    children: t(message)
                  }),
                  hasDuplicates && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react24.Box, {
                    pt: 3,
                    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react24.Button, {
                      size: "sm",
                      variant: "outline",
                      colorScheme: "white",
                      onClick: handleOnClickShowDuplicates,
                      "aria-label": "Show duplicates",
                      children: t("COMPANY_TAX_SHOW_DUPLICATES")
                    })
                  })
                ]
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react24.Box, {
                position: "relative",
                children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react24.CloseButton, {
                  size: "sm",
                  onClick: onClose,
                  position: "absolute",
                  top: -2,
                  right: -2,
                  "aria-label": "Close duplicates error"
                })
              })
            ]
          })
        })
      })
    })
  });
};
var TaxCheckAlert_default = TaxCheckAlert;

// src/hooks/useCheckCompanyTax/useCheckCompanyTax.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var useCheckCompanyTax = ({
  onResult,
  onPreviewDuplicates
} = {}) => {
  var _a2;
  const [result, setResult] = (0, import_react27.useState)();
  const settings = useSettings_default();
  const checkTaxSetting = ((_a2 = settings == null ? void 0 : settings.settings) == null ? void 0 : _a2.validateNipOnCreateOrEdit) ?? (settings == null ? void 0 : settings.validate_nip_on_create_or_edit) ?? 0 /* NONE */;
  const isCheckEnabled = Number(checkTaxSetting) === 2 /* WARN */ || Number(checkTaxSetting) === 1 /* BLOCK */;
  const isBlockingModeEnabled = Number(checkTaxSetting) === 1 /* BLOCK */;
  const { mutateAsync, isLoading } = (0, import_react_query8.useMutation)(
    (args) => api_default.postEndpoint("/account_companies/checkTax", {
      data: args
    }),
    {
      onSettled: (res) => {
        const parsedRes = parseResponse(res, isBlockingModeEnabled);
        setResult(parsedRes);
        onResult == null ? void 0 : onResult(parsedRes);
      }
    }
  );
  const checkTax = (0, import_use_debounce.useDebouncedCallback)(mutateAsync, 500);
  const checkTaxImmediately = async (args) => {
    const res = await mutateAsync(args);
    return parseResponse(res, isBlockingModeEnabled);
  };
  const Alert2 = () => {
    var _a3;
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TaxCheckAlert_default, {
      isInvalid: result && !(result == null ? void 0 : result.isValid),
      message: result == null ? void 0 : result.message,
      hasDuplicates: !!((_a3 = result == null ? void 0 : result.duplicates) == null ? void 0 : _a3.length),
      onShowDuplicates: onPreviewDuplicates
    });
  };
  return {
    checkTax,
    checkTaxImmediately,
    isLoading,
    result,
    isCheckEnabled,
    isBlockingModeEnabled,
    Alert: Alert2
  };
};
var parseResponse = (res, isBlockingModeEnabled) => {
  var _a2, _b;
  return {
    isValid: (0, import_isEmpty3.default)(res == null ? void 0 : res.errors) && (0, import_isEmpty3.default)(res == null ? void 0 : res.warnings),
    message: (_a2 = res == null ? void 0 : res.data) == null ? void 0 : _a2.status,
    duplicates: (_b = res == null ? void 0 : res.data) == null ? void 0 : _b.duplicates,
    canSave: (0, import_isEmpty3.default)(res == null ? void 0 : res.errors) && (0, import_isEmpty3.default)(res == null ? void 0 : res.warnings) || !isBlockingModeEnabled
  };
};
var useCheckCompanyTax_default = useCheckCompanyTax;

// src/components/FilterFields/CellWrapper.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var CellWrapper = import_react28.default.memo(({ children, ...props }) => {
  var _a2;
  const [isTruncated, setIsTruncated] = (0, import_react28.useState)(false);
  const textRef = import_react28.default.useRef(null);
  const settings = useSettings_default();
  const wrapLinesInLists = ((_a2 = settings == null ? void 0 : settings.settings) == null ? void 0 : _a2.newLookWrapLinesInLists) || (settings == null ? void 0 : settings.new_look_wrap_lines_in_lists) === "true";
  const handleResize = () => {
    if (!wrapLinesInLists && textRef.current.offsetWidth < textRef.current.scrollWidth) {
      setIsTruncated(true);
    } else if (wrapLinesInLists && textRef.current.offsetHeight < textRef.current.scrollHeight) {
      setIsTruncated(true);
    } else {
      setIsTruncated(false);
    }
  };
  (0, import_react28.useEffect)(() => {
    handleResize();
    const observer = new MutationObserver(handleResize);
    const parentNode = textRef.current.offsetParent;
    if (parentNode && textRef) {
      observer.observe(parentNode, { attributes: true });
    }
    return () => {
      observer.disconnect();
    };
  }, []);
  const baseProps = (0, import_react28.useMemo)(() => {
    if (wrapLinesInLists) {
      return { noOfLines: WRAP_LINES_IN_LISTS, ...props };
    }
    return { ...props, isTruncated: true };
  }, [props, wrapLinesInLists]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, {
    children: isTruncated ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react29.Tooltip, {
      hasArrow: true,
      px: "12px",
      py: "8px",
      placement: "bottom-start",
      label: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react29.Text, {
        noOfLines: 10,
        sx: {
          a: {
            color: "#fff"
          }
        },
        children
      }),
      rounded: "4px",
      openDelay: 500,
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react29.Text, {
        ref: textRef,
        className: "table-cell-wrapper",
        as: "span",
        display: "inline-block",
        w: "full",
        wordBreak: "break-word",
        whiteSpace: "normal",
        ...baseProps,
        children
      })
    }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react29.Text, {
      ref: textRef,
      className: "table-cell-wrapper",
      as: "span",
      display: "inline-block",
      w: "full",
      wordBreak: "break-word",
      whiteSpace: "normal",
      ...baseProps,
      children
    })
  });
});
var CellWrapper_default = CellWrapper;

// src/components/List/PriceTypeDisplay/PriceTypeDisplay.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var PriceTypeDisplay = ({ value }) => {
  const { tCustom } = useAuraTranslation_default();
  const { data } = useMinimalAutoselect_default({
    endpoint: "price_types",
    labelField: "fullName"
  });
  if (!data) {
    return null;
  }
  const priceType = data == null ? void 0 : data.find((priceType2) => priceType2.id === value - 1);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CellWrapper_default, {
    children: tCustom(priceType == null ? void 0 : priceType.value)
  });
};
var PriceTypeDisplay_default = PriceTypeDisplay;

// src/utils/listUtils.tsx
var import_axios3 = __toESM(require("axios"));
var import_isEmpty4 = __toESM(require("lodash/isEmpty"));

// src/components/List/consts.tsx
var excludedFieldsListAccountUser = ["company", "company.nip"];

// src/context/BasketContext.tsx
var import_react30 = __toESM(require("react"));
var import_react_query9 = require("react-query");
var import_api8 = require("@questy/api");
var import_jsx_runtime = require("react/jsx-runtime");
var BasketContext = (0, import_react30.createContext)({
  selectBasket: () => {
  },
  basketContent: [],
  basketInfo: null,
  addToBasket: () => Promise.resolve(),
  clearBasket: () => {
  },
  updateDiscountCode: () => {
  },
  refreshBasket: () => {
  },
  allBaskets: [],
  messages: [],
  isLoading: false
});
var BasketContextProvider = ({ children }) => {
  var _a2, _b, _c;
  const queryClient = (0, import_react_query9.useQueryClient)();
  const { isUserUser } = (0, import_react30.useContext)(AuthContext);
  const stayOnList = ((_a2 = useSettings_default()) == null ? void 0 : _a2.stay_on_list) === "true";
  const getBasketIdFromUrl = () => {
    if (typeof window === "undefined")
      return void 0;
    const match = window.location.pathname.match(/basket_id\/(\d+)/);
    return match ? parseInt(match[1], 10) : void 0;
  };
  const [selectedBasketId, setSelectedBasketId] = (0, import_react30.useState)(
    () => getBasketIdFromUrl()
  );
  const { data: baskets, isLoading: isLoadingBaskets } = (0, import_react_query9.useQuery)(
    ["baskets"],
    () => (0, import_api8.getBaskets)({
      settings: {
        withRelations: true
      }
    }),
    {
      enabled: !isUserUser,
      select: (data) => data == null ? void 0 : data.data,
      onSuccess: (data) => {
        var _a3;
        const basketIdFromUrl = getBasketIdFromUrl();
        if (!selectedBasketId && !basketIdFromUrl) {
          setSelectedBasketId((_a3 = data == null ? void 0 : data[0]) == null ? void 0 : _a3.id);
        }
      },
      refetchOnWindowFocus: false,
      keepPreviousData: true
    }
  );
  const selectedBasketData = (0, import_react30.useMemo)(
    () => {
      var _a3;
      return (_a3 = baskets == null ? void 0 : baskets.filter((basket) => basket.id === selectedBasketId)) == null ? void 0 : _a3[0];
    },
    [selectedBasketId, baskets]
  );
  const { data: basketPositions, isLoading: isLoadingBasketContent } = (0, import_react_query9.useQuery)(
    ["basket_positions", selectedBasketId],
    () => api_default.getBasketPositions(selectedBasketId, {
      "order[id]": "ASC",
      extra_fields: "product.availability,product.estimatedAvailability,product.prices,hasDiscountCode"
    }),
    {
      enabled: !isLoadingBaskets && !!selectedBasketId,
      refetchOnWindowFocus: false,
      keepPreviousData: true
    }
  );
  const basketContent = (0, import_react30.useMemo)(() => basketPositions == null ? void 0 : basketPositions.data, [basketPositions]);
  const messages = (0, import_react30.useMemo)(
    () => {
      var _a3;
      return (_a3 = basketPositions == null ? void 0 : basketPositions.messages) == null ? void 0 : _a3.item_0;
    },
    [basketPositions]
  );
  const { data: discountCode, isLoading: isLoadingDiscountCode } = (0, import_react_query9.useQuery)(
    ["discountCode", selectedBasketId, (_b = selectedBasketData == null ? void 0 : selectedBasketData.discountCode) == null ? void 0 : _b.id],
    () => {
      var _a3;
      return api_default.getEndpoint("discount_codes", {
        params: {
          fields: "code",
          "filter[id][eq]": (_a3 = selectedBasketData == null ? void 0 : selectedBasketData.discountCode) == null ? void 0 : _a3.id
        }
      });
    },
    {
      enabled: !!((_c = selectedBasketData == null ? void 0 : selectedBasketData.discountCode) == null ? void 0 : _c.id),
      refetchOnWindowFocus: false,
      select: (data) => {
        var _a3;
        return (_a3 = data == null ? void 0 : data.data) == null ? void 0 : _a3[0];
      }
    }
  );
  const { mutateAsync: updateDiscountCode2 } = (0, import_react_query9.useMutation)(
    (code) => (0, import_api8.updateBasket)(selectedBasketId, {
      data: {
        discountCode: code
      }
    }),
    {
      onSettled: () => {
        queryClient.invalidateQueries(["baskets"]);
        queryClient.invalidateQueries(["basket_positions", selectedBasketId]);
      }
    }
  );
  const addToBasketContent = ({
    productId,
    quantity = 1,
    positionId,
    basketId = selectedBasketId,
    autoRedirect
  }) => {
    if (positionId) {
      const payload = {
        id: positionId,
        quantity
      };
      return api_default.updateBasketPosition({ basketId, positionId, payload });
    } else {
      const payload = {
        product: productId,
        quantity
      };
      if (basketId) {
        return api_default.addBasketPosition({ basketId, payload });
      } else {
        return api_default.createBasketPosition({ payload });
      }
    }
  };
  const handleRedirectToBasket = (basketId) => {
    if (!stayOnList) {
      const url = `/basketContent/list/basket_id/${basketId}`;
      document.location.assign(url);
    }
  };
  const { mutateAsync: addToBasket } = (0, import_react_query9.useMutation)(addToBasketContent, {
    onSettled: () => {
      queryClient.invalidateQueries(["baskets"]);
      queryClient.invalidateQueries(["basket_positions", selectedBasketId]);
    },
    onSuccess: (data, variables) => {
      var _a3, _b2, _c2;
      const redirectToBasketId = (_c2 = (_b2 = (_a3 = data == null ? void 0 : data.data) == null ? void 0 : _a3[0]) == null ? void 0 : _b2.basket) == null ? void 0 : _c2.id;
      if (redirectToBasketId && (variables == null ? void 0 : variables.autoRedirect) && !(variables == null ? void 0 : variables.positionId)) {
        handleRedirectToBasket(redirectToBasketId);
      }
    }
  });
  const { mutateAsync: clearBasket } = (0, import_react_query9.useMutation)(clearBasketContent, {
    onSettled: () => {
      queryClient.invalidateQueries(["basket_positions", selectedBasketId]);
    }
  });
  const refreshBasket = (0, import_react30.useCallback)(
    (id) => {
      return api_default.getBasketPositions(id || selectedBasketId);
    },
    [selectedBasketId]
  );
  const value = import_react30.default.useMemo(
    () => ({
      selectBasket: (id) => setSelectedBasketId(id),
      basketContent,
      basketInfo: { ...selectedBasketData, discountCode },
      addToBasket,
      clearBasket: clearBasketContent,
      updateDiscountCode: updateDiscountCode2,
      allBaskets: baskets,
      refreshBasket,
      messages,
      isLoading: isLoadingBaskets || isLoadingBasketContent || isLoadingDiscountCode
    }),
    [
      basketContent,
      baskets,
      addToBasket,
      clearBasket,
      updateDiscountCode2,
      selectedBasketData,
      messages,
      isLoadingBaskets,
      isLoadingBasketContent,
      discountCode
    ]
  );
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(BasketContext.Provider, {
    value,
    children
  });
};
var useBasketContent = () => {
  const basketContext = (0, import_react30.useContext)(BasketContext);
  if (basketContext === void 0) {
    throw new Error("useBasketContent must be used within a BasketContext");
  }
  return basketContext;
};
var clearBasketContent = (id) => {
  return Promise.all([
    api_default.clearBasketFromPositions({ id }),
    (0, import_api8.updateBasket)(id, {
      data: {
        discountCode: null
      }
    })
  ]);
};

// src/context/CustomizerContext.tsx
var import_react31 = require("react");
var import_jsx_runtime = require("react/jsx-runtime");
var CustomizerContext = (0, import_react31.createContext)(null);
var CustomizerContextProvider = ({ value = null, moduleName = null, children, ...props }) => {
  value.moduleName = moduleName;
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CustomizerContext.Provider, {
    value,
    children
  });
};
var CustomizerContext_default = CustomizerContextProvider;

// src/context/ExternalMarkersContext.tsx
var import_react32 = require("react");
var import_jsx_runtime = require("react/jsx-runtime");
var ExternalMarkersContext = (0, import_react32.createContext)(null);
var ExternalMarkersProvider = ({
  value,
  children
}) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ExternalMarkersContext.Provider, {
    value,
    children
  });
};
var useExternalMarkers = () => {
  const context = (0, import_react32.useContext)(ExternalMarkersContext);
  if (typeof context === "undefined") {
    throw new Error(
      "useExternalMarkers must be used inside ExternalMarkersProvider"
    );
  }
  return context;
};
var ExternalMarkersContext_default = ExternalMarkersProvider;

// src/context/LanguageContext.tsx
var import_react33 = __toESM(require("react"));
var import_locale = require("date-fns/locale");
var import_jsx_runtime = require("react/jsx-runtime");
var locales = {
  be: import_locale.be,
  bg: import_locale.bg,
  bs: import_locale.bs,
  ca: import_locale.ca,
  cs: import_locale.cs,
  da: import_locale.da,
  de: import_locale.de,
  el: import_locale.el,
  enGB: import_locale.enGB,
  es: import_locale.es,
  et: import_locale.et,
  eu: import_locale.eu,
  fi: import_locale.fi,
  fr: import_locale.fr,
  gl: import_locale.gl,
  hr: import_locale.hr,
  hu: import_locale.hu,
  is: import_locale.is,
  it: import_locale.it,
  lt: import_locale.lt,
  lv: import_locale.lv,
  mk: import_locale.mk,
  nb: import_locale.nb,
  nl: import_locale.nl,
  pl: import_locale.pl,
  pt: import_locale.pt,
  ro: import_locale.ro,
  ru: import_locale.ru,
  sk: import_locale.sk,
  sl: import_locale.sl,
  sq: import_locale.sq,
  sr: import_locale.sr,
  sv: import_locale.sv,
  uk: import_locale.uk
};
var initialLanguage = "pl";
var LanguageContext = (0, import_react33.createContext)({
  language: initialLanguage,
  changeLanguage: () => Promise.resolve(),
  currentLocale: null
});
var setUserLanguage = async (lang) => {
  await api_default.updateLanguage({ language: lang });
};
var _a;
if (typeof window !== "undefined") {
  const language = (_a = document.documentElement) == null ? void 0 : _a.lang;
  initialLanguage = language;
}
var getLocaleForLanguageCode = (languageCode) => {
  switch (languageCode) {
    case "en":
      return "enGB";
    default:
      return languageCode;
  }
};
var LanguageProvider = ({
  language = initialLanguage,
  i18nextInstance = null,
  ...props
}) => {
  const { i18n } = useAuraTranslation_default();
  const currentLanguageI18n = i18n == null ? void 0 : i18n.language;
  const [currentLanguage, setCurrentLanguage] = (0, import_react33.useState)(null);
  const [currentLocale, setCurrentLocale] = (0, import_react33.useState)(import_locale.pl);
  (0, import_react33.useEffect)(() => {
    setCurrentLanguage(language);
  }, [language]);
  (0, import_react33.useEffect)(() => {
    const setDefaultLocale = async () => {
      const localeName = getLocaleForLanguageCode(
        currentLanguageI18n ?? language
      );
      const defaultLocale = loadLocale(localeName);
      if (defaultLocale) {
        setCurrentLocale(defaultLocale);
      }
    };
    setDefaultLocale();
  }, [language, currentLanguageI18n]);
  const changeLanguage = async (lang) => {
    await setUserLanguage(lang);
    setCurrentLanguage(lang);
    if (i18nextInstance) {
      i18nextInstance.changeLanguage(lang);
    }
  };
  const loadLocale = (locale) => {
    try {
      const localeData = locales[locale];
      return localeData;
    } catch (error) {
      return void 0;
    }
  };
  const contextValue = (0, import_react33.useMemo)(
    () => ({
      language: currentLanguage,
      changeLanguage,
      currentLocale
    }),
    [currentLanguage, currentLocale]
  );
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(LanguageContext.Provider, {
    value: contextValue,
    ...props
  });
};
var useLanguage = () => {
  const context = import_react33.default.useContext(LanguageContext);
  if (context === void 0) {
    throw new Error("useLanguage must be used within a LanguageProvider");
  }
  return context;
};

// src/context/ListFiltersContext.tsx
var import_react34 = require("react");
var import_jsx_runtime = require("react/jsx-runtime");
var ListFiltersContext = (0, import_react34.createContext)(null);
var ListFiltersContextProvider = ({
  value,
  children
}) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ListFiltersContext.Provider, {
    value,
    children
  });
};
var ListFiltersContext_default = ListFiltersContextProvider;

// src/context/MessagesContext.tsx
var import_react35 = require("@chakra-ui/react");
var import_api10 = require("@questy/api");
var import_debounce = __toESM(require("lodash/debounce"));
var import_react36 = require("react");
var import_react_query10 = require("react-query");
var import_jsx_runtime = require("react/jsx-runtime");
var MessagesContext = (0, import_react36.createContext)({
  threads: {
    data: [],
    totalCount: void 0,
    isLoading: false,
    isLoadingFiltered: false,
    isLoadingMore: false,
    loadMore: () => {
    },
    hasMore: false,
    refetch: () => {
    }
  },
  openThread: (id) => {
  },
  newMessage: () => {
  },
  filterThreads: (value) => {
  },
  unreadThreadsCount: void 0
});
var MessageContextProvider = ({ children }) => {
  var _a2;
  const appSettings = useSettings_default();
  const isNewLookCommunicatorEnabled = ["true", true].includes(
    (appSettings == null ? void 0 : appSettings.new_look_system_communicator) ?? ((_a2 = appSettings == null ? void 0 : appSettings.settings) == null ? void 0 : _a2.newLookSystemCommunicator)
  );
  const [id, setId] = (0, import_react36.useState)();
  const [newMessageThreadRelations, setNewMessageThreadRelations] = (0, import_react36.useState)();
  const [newMessageThreadRecipients, setNewMessageThreadRecipients] = (0, import_react36.useState)();
  const onMessageSentRef = (0, import_react36.useRef)();
  const onAfterCloseRef = (0, import_react36.useRef)();
  const { isOpen, onOpen, onClose } = (0, import_react35.useDisclosure)();
  const [searchInput, setSearchInput] = (0, import_react36.useState)();
  const [unreadThreadsCount, setUnreadThreadsCount] = (0, import_react36.useState)(null);
  const openThread = (idThread, props) => {
    setId(idThread);
    if (typeof (props == null ? void 0 : props.onMessageSent) === "function") {
      onMessageSentRef.current = props == null ? void 0 : props.onMessageSent;
    }
    if (typeof (props == null ? void 0 : props.onAfterClose) === "function") {
      onAfterCloseRef.current = props == null ? void 0 : props.onAfterClose;
    }
    onOpen();
  };
  const newMessage = (props) => {
    if (props == null ? void 0 : props.relations) {
      setNewMessageThreadRelations(props.relations);
    }
    if (props == null ? void 0 : props.recipients) {
      setNewMessageThreadRecipients(props.recipients);
    }
    if (typeof (props == null ? void 0 : props.onMessageSent) === "function") {
      onMessageSentRef.current = props == null ? void 0 : props.onMessageSent;
    }
    if (typeof (props == null ? void 0 : props.onAfterClose) === "function") {
      onAfterCloseRef.current = props == null ? void 0 : props.onAfterClose;
    }
    onOpen();
  };
  (0, import_react36.useEffect)(() => {
    if (!isOpen) {
      setId(void 0);
      setNewMessageThreadRelations(void 0);
      onMessageSentRef.current = void 0;
      if (typeof (onAfterCloseRef == null ? void 0 : onAfterCloseRef.current) === "function") {
        onAfterCloseRef.current();
        onAfterCloseRef.current = void 0;
      }
    }
  }, [isOpen]);
  const {
    data: threads,
    isLoading: isLoadingThreads,
    isFetching: isFetchingThreads,
    hasNextPage: hasNextPageThreads,
    fetchNextPage,
    isFetchingNextPage,
    refetch: refetchMessageThreads
  } = (0, import_react_query10.useInfiniteQuery)(
    ["messageThreads", isNewLookCommunicatorEnabled],
    ({ pageParam = 1 }) => (0, import_api10.getMessageThreads)({
      order: { hasBeenRead: "ASC", lastMessageDate: "DESC" },
      page: { number: pageParam },
      settings: {
        withRelations: true
      },
      extraFields: ["hasBeenRead", "notificationsEnabled"]
    }),
    {
      getNextPageParam: (lastPage, pages) => {
        var _a3, _b, _c, _d, _e, _f;
        if (((_b = (_a3 = lastPage == null ? void 0 : lastPage.meta) == null ? void 0 : _a3.page) == null ? void 0 : _b.number) < ((_d = (_c = lastPage == null ? void 0 : lastPage.meta) == null ? void 0 : _c.page) == null ? void 0 : _d.total_number)) {
          return ((_f = (_e = lastPage == null ? void 0 : lastPage.meta) == null ? void 0 : _e.page) == null ? void 0 : _f.number) + 1;
        }
        return void 0;
      },
      refetchOnWindowFocus: false,
      enabled: isNewLookCommunicatorEnabled
    }
  );
  const { data: unreadThreads, refetch: refetchUnreadThreadsCount } = (0, import_react_query10.useQuery)(
    ["unreadThreadsCount"],
    () => {
      const lastFetch = Number(
        localStorage.getItem(LOCAL_STORAGE_MESSAGES_LAST_FETCH)
      );
      if (Date.now() - lastFetch < MESSAGE_FETCH_INTERVAL) {
        return;
      }
      localStorage.setItem(
        LOCAL_STORAGE_MESSAGES_LAST_FETCH,
        Date.now().toString()
      );
      return api_default.getEndpoint("message_threads/unreadCount", {});
    },
    {
      refetchOnWindowFocus: false,
      refetchIntervalInBackground: false,
      refetchInterval: MESSAGE_FETCH_INTERVAL,
      enabled: isNewLookCommunicatorEnabled
    }
  );
  const refetchAllMessageThreads = (0, import_react36.useCallback)(() => {
    localStorage.setItem(
      LOCAL_STORAGE_MESSAGES_LAST_FETCH,
      (Date.now() - 6e4).toString()
    );
    refetchMessageThreads();
    refetchUnreadThreadsCount();
  }, []);
  (0, import_react36.useEffect)(() => {
    refetchAllMessageThreads();
  }, []);
  const preparedThreads = (0, import_react36.useMemo)(
    () => {
      var _a3, _b, _c, _d;
      return {
        data: ((_a3 = threads == null ? void 0 : threads.pages) == null ? void 0 : _a3.some((page) => {
          var _a4;
          return (_a4 = page == null ? void 0 : page.data) == null ? void 0 : _a4.length;
        })) ? (_b = threads == null ? void 0 : threads.pages) == null ? void 0 : _b.flatMap((page) => page.data) : [],
        meta: (_d = (_c = threads == null ? void 0 : threads.pages) == null ? void 0 : _c[0]) == null ? void 0 : _d.meta
      };
    },
    [threads]
  );
  (0, import_react36.useEffect)(() => {
    if (unreadThreads !== void 0) {
      const newCount = unreadThreads == null ? void 0 : unreadThreads.count;
      if (newCount !== unreadThreadsCount) {
        refetchMessageThreads();
      }
      setUnreadThreadsCount(newCount);
    }
  }, [unreadThreads]);
  const {
    data: filteredThreads,
    isLoading: isLoadingFilteredThreads,
    isFetching: isFetchingFilteredThreads,
    hasNextPage: hasNextPageFilteredThreads,
    fetchNextPage: fetchNextPageFilteredThreads,
    isFetchingNextPage: isFetchingNextPageFilteredThreads
  } = (0, import_react_query10.useInfiniteQuery)(
    ["messageThreads", searchInput, isNewLookCommunicatorEnabled],
    ({ pageParam = 1 }) => (0, import_api10.getMessageThreads)({
      page: { number: pageParam },
      order: { hasBeenRead: "ASC", lastMessageDate: "DESC" },
      settings: {
        withRelations: true
      },
      extraFields: ["hasBeenRead", "notificationsEnabled"],
      rawParams: {
        "filter[messages.content][hasText]": searchInput
      }
    }),
    {
      getNextPageParam: (lastPage) => {
        var _a3, _b, _c, _d, _e, _f;
        if (((_b = (_a3 = lastPage == null ? void 0 : lastPage.meta) == null ? void 0 : _a3.page) == null ? void 0 : _b.number) < ((_d = (_c = lastPage == null ? void 0 : lastPage.meta) == null ? void 0 : _c.page) == null ? void 0 : _d.total_number)) {
          return ((_f = (_e = lastPage == null ? void 0 : lastPage.meta) == null ? void 0 : _e.page) == null ? void 0 : _f.number) + 1;
        }
        return void 0;
      },
      keepPreviousData: false,
      refetchOnWindowFocus: false,
      enabled: !!(searchInput == null ? void 0 : searchInput.length) && isNewLookCommunicatorEnabled
    }
  );
  const foundFilteredThreads = (0, import_react36.useMemo)(
    () => {
      var _a3, _b, _c, _d;
      return !!(searchInput == null ? void 0 : searchInput.length) ? {
        data: ((_a3 = filteredThreads == null ? void 0 : filteredThreads.pages) == null ? void 0 : _a3.some(
          (page) => {
            var _a4;
            return (_a4 = page == null ? void 0 : page.data) == null ? void 0 : _a4.length;
          }
        )) ? (_b = filteredThreads == null ? void 0 : filteredThreads.pages) == null ? void 0 : _b.flatMap((page) => page.data) : [],
        meta: (_d = (_c = filteredThreads == null ? void 0 : filteredThreads.pages) == null ? void 0 : _c[0]) == null ? void 0 : _d.meta
      } : [];
    },
    [filteredThreads, searchInput]
  );
  const filterThreads = (0, import_debounce.default)((value2) => setSearchInput(value2), 300);
  const handleFetchNextPage = searchInput ? fetchNextPageFilteredThreads : fetchNextPage;
  const hasNextPage = searchInput ? hasNextPageFilteredThreads : hasNextPageThreads;
  const isLoading = (0, import_react36.useMemo)(
    () => isLoadingThreads || isFetchingThreads,
    [isLoadingThreads, isFetchingThreads]
  );
  const isLoadingFiltered = (0, import_react36.useMemo)(
    () => isLoadingFilteredThreads || isFetchingFilteredThreads,
    [isLoadingFilteredThreads, isFetchingFilteredThreads]
  );
  const listThreadsData = (0, import_react36.useMemo)(() => {
    if (!!(searchInput == null ? void 0 : searchInput.length)) {
      if (isLoadingFilteredThreads) {
        return {};
      } else {
        return foundFilteredThreads ?? {};
      }
    }
    return preparedThreads;
  }, [
    searchInput,
    isLoadingFilteredThreads,
    foundFilteredThreads,
    preparedThreads
  ]);
  const value = (0, import_react36.useMemo)(
    () => {
      var _a3, _b;
      return {
        threads: {
          data: listThreadsData == null ? void 0 : listThreadsData.data,
          totalCount: (_b = (_a3 = listThreadsData == null ? void 0 : listThreadsData.meta) == null ? void 0 : _a3.page) == null ? void 0 : _b.total_count,
          isLoading,
          isLoadingFiltered,
          isLoadingMore: isFetchingNextPage || isFetchingNextPageFilteredThreads,
          loadMore: handleFetchNextPage,
          hasMore: hasNextPage,
          refetch: refetchAllMessageThreads
        },
        openThread,
        newMessage,
        filterThreads,
        unreadThreadsCount
      };
    },
    [
      listThreadsData,
      isLoading,
      isLoadingFiltered,
      isFetchingNextPage,
      isFetchingFilteredThreads,
      unreadThreadsCount
    ]
  );
  (0, import_react36.useEffect)(() => {
    refetchAllMessageThreads();
  }, []);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(MessagesContext.Provider, {
    value,
    children: [
      children,
      isNewLookCommunicatorEnabled && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ModalMessageThread_default, {
        id,
        newMessageThreadRelations,
        newMessageThreadRecipients,
        onMessageSent: onMessageSentRef == null ? void 0 : onMessageSentRef.current,
        isOpen,
        onClose,
        onOpen,
        refetch: refetchAllMessageThreads
      })
    ]
  });
};
var useMessages = () => {
  const messageContext = (0, import_react36.useContext)(MessagesContext);
  if (messageContext === void 0) {
    throw new Error("useMessages must be used within a MessageContext");
  }
  return messageContext;
};
var MessagesContext_default = MessageContextProvider;

// src/context/ModalVisibilityContext.tsx
var import_react37 = __toESM(require("react"));
var import_jsx_runtime = require("react/jsx-runtime");
var ModalVisibilityContext = (0, import_react37.createContext)(null);
var ModalVisibilityProvider = ({ isHidden, setIsHidden, children }) => {
  const hideModal = (0, import_react37.useCallback)(() => {
    setIsHidden(true);
  }, [setIsHidden]);
  const showModal = (0, import_react37.useCallback)(() => {
    setIsHidden(false);
  }, [setIsHidden]);
  const toggleModal = (0, import_react37.useCallback)(() => {
    setIsHidden((state) => !state);
  }, [setIsHidden]);
  const value = (0, import_react37.useMemo)(() => {
    return {
      isHidden,
      hideModal,
      showModal,
      toggleModal
    };
  }, [hideModal, isHidden]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ModalVisibilityContext.Provider, {
    value,
    children
  });
};
var useModalVisibilityContext = () => {
  const context = import_react37.default.useContext(ModalVisibilityContext);
  return context;
};

// src/context/LinkContext.tsx
var import_react38 = require("react");
var import_jsx_runtime = require("react/jsx-runtime");
var LinkContext = (0, import_react38.createContext)({ Link: null });
var LinkContextProvider = ({
  value,
  children
}) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(LinkContext.Provider, {
    value,
    children
  });
};
var useLink = () => {
  const context = (0, import_react38.useContext)(LinkContext);
  if (context === void 0) {
    throw new Error("useLink must be used within a LinkContextProvider");
  }
  return context;
};

// src/components/AuraTranslation/AuraTranslation.tsx
var AuraTranslation = ({ ...props }) => {
  const { ns, children, ...options } = props;
  const { t } = useAuraTranslation_default();
  return children(t);
};
var AuraCustomTranslation = ({ children }) => {
  const { tCustom } = useAuraTranslation_default();
  return children(tCustom);
};
var AuraTranslation_default = AuraTranslation;

// src/utils/listUtils.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var getFormattedPlaceLabel = (placeField, options) => {
  return Array.isArray(placeField) ? placeField.map((place) => formatPlaceLabel(place, options)).filter((label) => !!(label == null ? void 0 : label.length)).join(", ") : formatPlaceLabel(placeField, options);
};
var formatPlaceLabel = (place, options) => {
  const street = (place == null ? void 0 : place.streetAddress) ?? "";
  const streetNumber = (place == null ? void 0 : place.streetNumber) ?? "";
  const localNumber = (place == null ? void 0 : place.localNumber) ?? "";
  const postalCode = (place == null ? void 0 : place.postalCode) ?? "";
  const city = (place == null ? void 0 : place.city) ?? "";
  const country = (options == null ? void 0 : options.withCountry) ? (place == null ? void 0 : place.country) ?? "" : "";
  const labelAdress = `${street && street}${streetNumber && (street ? " " : "") + streetNumber}${localNumber && street ? (streetNumber ? "/" : " /") + localNumber : ""}${postalCode && (streetNumber || street || localNumber ? ", " : "") + postalCode}${city && (!postalCode && (streetNumber || street || localNumber) ? ", " : " ") + city}${country && ", " + country}`;
  return labelAdress;
};
var getPrefixedName = (name, prefix) => {
  return prefix ? `${prefix}${name}` : name;
};
var getListFiltersConfig = (moduleMeta, namePrefix, options) => {
  var _a2, _b, _c, _d, _e, _f, _g, _h, _i;
  if (!moduleMeta) {
    return null;
  }
  if ((options == null ? void 0 : options.includedFields) && (options == null ? void 0 : options.excludedFields)) {
    throw new Error(
      "Cannot use both includedFields and excludedFields in getListFiltersConfig"
    );
  }
  let nipColumnFilter = [];
  if ((_a2 = moduleMeta.fields) == null ? void 0 : _a2.company) {
    nipColumnFilter.push({
      id: "company.nip",
      name: getPrefixedName("nip", namePrefix),
      type: "string",
      additionalData: {
        additionalProps: {
          filterName: "company.nip"
        }
      }
    });
  }
  const fields = Object.entries(moduleMeta == null ? void 0 : moduleMeta.fields).filter((field) => {
    var _a3, _b2;
    if (options == null ? void 0 : options.excludedFields) {
      return !((_a3 = options == null ? void 0 : options.excludedFields) == null ? void 0 : _a3.includes(field[0]));
    } else if (options == null ? void 0 : options.includedFields) {
      return (_b2 = options == null ? void 0 : options.includedFields) == null ? void 0 : _b2.includes(field[0]);
    } else {
      return true;
    }
  }).map((field) => {
    var _a3, _b2;
    const fieldName = field[0];
    const fieldConfig = field[1];
    const prefixedName = getPrefixedName(fieldName, namePrefix);
    if (!(0, import_isEmpty4.default)((_b2 = (_a3 = options == null ? void 0 : options.fieldOverrides) == null ? void 0 : _a3[fieldName]) == null ? void 0 : _b2.filter)) {
      return options.fieldOverrides[fieldName].filter;
    }
    if (fieldName === "creationType") {
      return {
        id: fieldName,
        name: prefixedName,
        type: "list",
        additionalData: {
          positions: [
            {
              id: 1 /* DatasourceImport */,
              value: "LIST_AC_CT_DATASOURCE_IMPORT",
              ordering: 1
            },
            {
              id: 2 /* RegistrationForm */,
              value: "LIST_AC_CT_REGISTRATION_FORM",
              ordering: 2
            },
            {
              id: 3 /* Manual */,
              value: "LIST_AC_CT_MANUAL",
              ordering: 3
            }
          ]
        }
      };
    }
    if (fieldName === "defaultPriceType") {
      return {
        id: fieldName,
        name: prefixedName,
        type: "defaultPriceType",
        additionalData: {
          additionalProps: {
            endpoint: "price_types",
            labelField: ["fullName"],
            valueField: "indexUpper",
            filters: { "filter[active]": true }
          }
        }
      };
    }
    if (["documentStatusByAu", "documentStatus"].includes(fieldName)) {
      return {
        id: fieldName,
        name: prefixedName,
        type: "list",
        additionalData: {
          positions: documentStatusPositions
        }
      };
    }
    if (fieldName === "vatHandling") {
      return {
        id: fieldName,
        name: prefixedName,
        type: "list",
        additionalData: {
          positions: [
            {
              id: "STANDARD" /* Standard */,
              value: "LIST_AC_VH_STANDARD",
              ordering: 1
            },
            {
              id: "NOT_APPLIED" /* NotApplied */,
              value: "LIST_AC_VH_NOT_APPLIED",
              ordering: 2
            }
          ]
        }
      };
    }
    if (["currency", "currencyCode"].includes(fieldName)) {
      return {
        id: fieldName,
        name: prefixedName,
        type: "list",
        additionalData: {
          positions: [
            {
              id: "PLN",
              value: "PLN"
            },
            {
              id: "GBP",
              value: "GBP"
            },
            {
              id: "USD",
              value: "USD"
            },
            {
              id: "EUR",
              value: "EUR"
            },
            {
              id: "CHF",
              value: "CHF"
            },
            {
              id: "RUB",
              value: "RUB"
            }
          ]
        }
      };
    }
    if (fieldName === "documentSeriesDefinition" && (options == null ? void 0 : options.endpoint) !== null) {
      return {
        id: fieldName,
        name: prefixedName,
        type: fieldConfig.type,
        relatedModule: fieldConfig.relatedModule,
        additionalData: {
          filter: {
            "filter[documentType][eq]": MODULE_MAP[options == null ? void 0 : options.endpoint]
          }
        }
      };
    }
    return {
      id: fieldName,
      name: prefixedName,
      type: fieldConfig.type,
      relatedModule: fieldConfig.relatedModule
    };
  });
  const extraFields = Object.entries((moduleMeta == null ? void 0 : moduleMeta.extra_fields) ?? {}).filter((field) => {
    var _a3, _b2;
    if (options == null ? void 0 : options.excludedFields) {
      return !((_a3 = options == null ? void 0 : options.excludedFields) == null ? void 0 : _a3.includes(field[0]));
    } else if (options == null ? void 0 : options.includedFields) {
      return (_b2 = options == null ? void 0 : options.includedFields) == null ? void 0 : _b2.includes(field[0]);
    } else {
      return true;
    }
  }).map((field) => {
    var _a3, _b2;
    const fieldName = field[0];
    const fieldConfig = field[1];
    const prefixedName = getPrefixedName(fieldName, namePrefix);
    if (!(0, import_isEmpty4.default)((_b2 = (_a3 = options == null ? void 0 : options.fieldOverrides) == null ? void 0 : _a3[fieldName]) == null ? void 0 : _b2.filter)) {
      return options.fieldOverrides[fieldName].filter;
    }
    return {
      id: fieldName,
      name: prefixedName,
      type: fieldConfig.type,
      relatedModule: fieldConfig.relatedModule
    };
  });
  const extraFieldRelations = ((_c = (_b = moduleMeta == null ? void 0 : moduleMeta.extra_fields) == null ? void 0 : _b.relations) == null ? void 0 : _c.properties) && !Array.isArray((_e = (_d = moduleMeta == null ? void 0 : moduleMeta.extra_fields) == null ? void 0 : _d.relations) == null ? void 0 : _e.properties) ? Object.keys((_g = (_f = moduleMeta == null ? void 0 : moduleMeta.extra_fields) == null ? void 0 : _f.relations) == null ? void 0 : _g.properties).filter(
    (relation) => {
      var _a3;
      return (_a3 = options.includedExtraFieldRelations) == null ? void 0 : _a3.includes(relation);
    }
  ).map((relation) => {
    var _a3, _b2, _c2, _d2;
    if (!(0, import_isEmpty4.default)((_b2 = (_a3 = options == null ? void 0 : options.fieldOverrides) == null ? void 0 : _a3[relation]) == null ? void 0 : _b2.filter)) {
      return (_d2 = (_c2 = options == null ? void 0 : options.fieldOverrides) == null ? void 0 : _c2[relation]) == null ? void 0 : _d2.filter;
    }
    return {
      id: relation,
      name: getPrefixedName(relation, namePrefix),
      type: "relation",
      relatedModule: relation
    };
  }) : [];
  const attributeFields = Array.isArray(moduleMeta == null ? void 0 : moduleMeta.extra_fields) ? [] : ((_i = (_h = moduleMeta.extra_fields) == null ? void 0 : _h.attributes) == null ? void 0 : _i.items.filter((attr) => {
    var _a3;
    return !((_a3 = options == null ? void 0 : options.excludedAttributeTypes) == null ? void 0 : _a3.includes(attr.type));
  }).sort(attributeSorting).map((attr) => {
    var _a3, _b2;
    return {
      id: String(attr.id),
      name: attr.name,
      type: attr.type,
      relatedModule: "attributes",
      additionalData: {
        displayName: attr.name,
        ...(attr == null ? void 0 : attr.positions) ? { positions: attr.positions } : {},
        ...(attr == null ? void 0 : attr.options) ? { options: attr.options } : {},
        ...getAttributeAdditionalProps(attr.type),
        ...((_b2 = (_a3 = options == null ? void 0 : options.fieldOverrides) == null ? void 0 : _a3[`attribute.${attr.type}`]) == null ? void 0 : _b2.filter) ?? {}
      }
    };
  })) ?? [];
  const extraFieldsColumns = Array.isArray(options == null ? void 0 : options.extraColumns) ? options == null ? void 0 : options.extraColumns : [];
  return [
    ...fields,
    ...nipColumnFilter,
    ...extraFields,
    ...(options == null ? void 0 : options.customFilters) ?? [],
    ...extraFieldRelations,
    ...attributeFields,
    ...extraFieldsColumns
  ];
};
var attributeSorting = (attribute1, attribute2) => {
  var _a2, _b, _c, _d, _e, _f, _g, _h;
  if (((_a2 = attribute1 == null ? void 0 : attribute1.options) == null ? void 0 : _a2.displayPriority) !== ((_b = attribute2 == null ? void 0 : attribute2.options) == null ? void 0 : _b.displayPriority)) {
    return ((_c = attribute1 == null ? void 0 : attribute1.options) == null ? void 0 : _c.displayPriority) - ((_d = attribute2 == null ? void 0 : attribute2.options) == null ? void 0 : _d.displayPriority);
  }
  if (((_e = attribute1 == null ? void 0 : attribute1.options) == null ? void 0 : _e.ordering) !== ((_f = attribute2 == null ? void 0 : attribute2.options) == null ? void 0 : _f.ordering)) {
    return ((_g = attribute1 == null ? void 0 : attribute1.options) == null ? void 0 : _g.ordering) - ((_h = attribute2 == null ? void 0 : attribute2.options) == null ? void 0 : _h.ordering);
  }
  return attribute1 == null ? void 0 : attribute1.name.localeCompare(attribute2 == null ? void 0 : attribute2.name);
};
var getAttributeAdditionalProps = (type) => {
  switch (type) {
    case "company":
      return {
        endpoint: "account_companies",
        labelField: "displayName",
        extraFields: ["displayName"]
      };
    default:
      return {};
  }
};
var getModuleHref = (module2, id) => {
  switch (module2) {
    case "accountCompany":
    case "accountCompanies":
      return `/accountCompany/show/company_id/${id}`;
    case "accountUser":
    case "accountUsers":
      return `/accountUser/show/user_id/${id}`;
    case "campaign":
    case "campaigns":
      return `/campaign/show/campaign_id/${id}`;
    case "campaignOpportunity":
    case "campaignOpportunities":
      return `/campaignOpportunity/show/opportunity_id/${id}`;
    case "commission":
    case "commissions":
      return `/commission/show/commission_id/${id}`;
    case "product":
    case "products":
    case "productList":
      return `/product/show/productid/${id}`;
    case "servicedProduct":
    case "servicedProducts":
      return `/servicedProduct/show/serviced_product_id/${id}`;
    case "userUser":
    case "userUsers":
      return `/userUser/show/userid/${id}`;
    case "documentOrder":
    case "documentOrders":
      return `/documentOrder/listProcess/document_id/${id}`;
    case "documentOffer":
    case "documentOffers":
      return `/documentOffer/listProcess/document_id/${id}`;
    case "documentOfferQuestion":
    case "documentOfferQuestions":
      return `/documentOfferQuestion/listProcess/document_id/${id}`;
    case "documentStore":
    case "documentStores":
      return `/documentStorePosition/list/document_id/${id}`;
    case "internalDocumentOrder":
    case "internalDocumentOrders":
      return `/internalDocumentOrder/listProcess/document_id/${id}`;
    case "documentInvoice":
    case "documentInvoices":
      return `/documentInvoicePosition/list/document_id/${id}`;
    case "documentPayment":
    case "documentPayments":
      return `/documentPayment/show/document_id/${id}`;
    case "priceProductGroup":
    case "priceProductGroups":
      return `/priceProductGroup/edit/product_group_id/${id}`;
    case "productCategory":
    case "productCategories":
      return `/product/list?category=${id}`;
    default:
      return "#";
  }
};
var getAttributeTagTypeForModule = (module2) => {
  switch (module2) {
    case "commission":
      return 1;
    case "accountCompany":
      return 2;
    case "accountUser":
      return 3;
    case "userForm":
      return 4;
    case "campaignOpportunity":
      return 5;
    default:
      return 1;
  }
};
var ModuleLink = ({ module: module2, id, children, isTooltip = true }) => {
  var _a2;
  const settings = useSettings_default();
  const wrapLinesInLists = ((_a2 = settings == null ? void 0 : settings.settings) == null ? void 0 : _a2.newLookWrapLinesInLists) || (settings == null ? void 0 : settings.new_look_wrap_lines_in_lists) === "true";
  const baseProps = (0, import_react40.useMemo)(() => {
    const props = {
      textDecoration: "none",
      color: "#3182CE",
      href: getModuleHref(module2, id)
    };
    if (isTooltip && wrapLinesInLists) {
      props["noOfLines"] = WRAP_LINES_IN_LISTS;
    }
    if (!wrapLinesInLists) {
      props["isTruncated"] = true;
    }
    return props;
  }, [wrapLinesInLists]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, {
    children: isTooltip ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react39.Tooltip, {
      px: "12px",
      py: "8px",
      label: children,
      openDelay: 500,
      placement: "bottom-start",
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react39.Link, {
        ...baseProps,
        children
      })
    }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react39.Link, {
      ...baseProps,
      children
    })
  });
};
var TooltipWrapper = ({
  tooltipLabel,
  cellLabel
}) => {
  var _a2;
  const [isTruncated, setIsTruncated] = (0, import_react40.useState)(false);
  const textRef = import_react40.default.useRef(null);
  const settings = useSettings_default();
  const wrapLinesInLists = ((_a2 = settings == null ? void 0 : settings.settings) == null ? void 0 : _a2.newLookWrapLinesInLists) || (settings == null ? void 0 : settings.new_look_wrap_lines_in_lists) === "true";
  const handleResize = () => {
    if (!wrapLinesInLists && textRef.current.offsetWidth < textRef.current.scrollWidth) {
      setIsTruncated(true);
    } else if (wrapLinesInLists && textRef.current.offsetHeight < textRef.current.scrollHeight) {
      setIsTruncated(true);
    } else {
      setIsTruncated(false);
    }
  };
  (0, import_react40.useEffect)(() => {
    handleResize();
    const observer = new MutationObserver(handleResize);
    const parentNode = textRef.current.offsetParent;
    if (parentNode && textRef) {
      observer.observe(parentNode, { attributes: true });
    }
    return () => {
      observer.disconnect();
    };
  }, []);
  const cellText = (0, import_react40.useMemo)(
    () => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react39.Text, {
      ref: textRef,
      as: wrapLinesInLists ? "div" : "span",
      ...wrapLinesInLists ? { noOfLines: WRAP_LINES_IN_LISTS } : { isTruncated: true, display: "inline-block" },
      w: "full",
      children: cellLabel
    }),
    [cellLabel, wrapLinesInLists, textRef]
  );
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, {
    children: isTruncated ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react39.Tooltip, {
      px: "12px",
      py: "8px",
      label: tooltipLabel,
      openDelay: 500,
      placement: "bottom-start",
      className: "tooltip-wrapper",
      children: cellText
    }) : cellText
  });
};
var checkTitleCell = (value, row, fieldName, fieldConfig, moduleName) => {
  if (fieldConfig.type === "string" && fieldName === "title") {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraCustomTranslation, {
      children: (t) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CellWrapper_default, {
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ModuleLink, {
          module: "campaignOpportunity",
          id: row.original.id,
          isTooltip: false,
          children: t(value)
        })
      }, row.original.id)
    });
  }
  if ((fieldConfig.type === "string" || fieldConfig.type === "text") && fieldName === "documentHeader") {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CellWrapper_default, {
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ModuleLink, {
        module: moduleName,
        id: row.original.id,
        isTooltip: false,
        children: value
      })
    }, row.original.id);
  }
  if (fieldConfig.type === "string" && fieldName === "commissionNumber") {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CellWrapper_default, {
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ModuleLink, {
        module: "commission",
        id: row.original.id,
        isTooltip: false,
        children: value
      })
    }, row.original.id);
  }
  if (fieldConfig.type === "string" && fieldName === "serialCode") {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CellWrapper_default, {
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ModuleLink, {
        module: "servicedProduct",
        id: row.original.id,
        isTooltip: false,
        children: value
      })
    }, row.original.id);
  }
  if (moduleName === "productList" && ["name", "code"].includes(fieldName)) {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CellWrapper_default, {
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ModuleLink, {
        module: "productList",
        id: row.original.id,
        isTooltip: false,
        children: value
      })
    }, row.original.id);
  }
  if ((fieldConfig.type === "string" || fieldConfig.type === "text") && fieldName === "displayName") {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CellWrapper_default, {
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ModuleLink, {
        module: "accountCompany",
        id: row.original.id,
        isTooltip: false,
        children: value
      })
    }, row.original.id);
  }
  if (["firstName", "lastName"].includes(fieldName) && moduleName === "accountUser") {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CellWrapper_default, {
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ModuleLink, {
        module: "accountUser",
        id: row.original.id,
        children: value
      })
    }, row.original.id);
  }
  if (fieldConfig.type === "relation" && fieldConfig.relatedModule === "campaign") {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraCustomTranslation, {
      children: (t) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CellWrapper_default, {
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ModuleLink, {
          module: "campaign",
          id: value.id,
          isTooltip: false,
          children: t(value.name)
        })
      }, value.id)
    });
  }
  if (fieldConfig.type === "relation" && fieldConfig.relatedModule === "product") {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CellWrapper_default, {
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ModuleLink, {
        module: "product",
        id: value.id,
        isTooltip: false,
        children: value.name
      })
    }, value.id);
  }
  let tooltipLabelContent = [];
  if (fieldConfig.type === "relation" && fieldConfig.relatedModule === "accountCompany") {
    const newValue = Array.isArray(value) ? value : [value];
    if (Array.isArray(newValue)) {
      const companies = newValue.map((ac, index, array) => {
        tooltipLabelContent.push(ac.displayName);
        const isCommaVisible = isCommaSeparatorVisible(index, array.length);
        return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react40.default.Fragment, {
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ModuleLink, {
              module: "accountCompany",
              id: ac.id,
              isTooltip: false,
              children: ac.displayName + (isCommaVisible ? "," : "")
            }),
            isCommaVisible ? " " : ""
          ]
        }, ac.id);
      });
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TooltipWrapper, {
        tooltipLabel: tooltipLabelContent.join(", "),
        cellLabel: companies
      });
    }
  }
  if (fieldConfig.type === "relation" && fieldConfig.relatedModule === "userUser") {
    const newValue = Array.isArray(value) ? value : [value];
    if (Array.isArray(newValue)) {
      const users = newValue.map((uu, index, array) => {
        const isCommaVisible = isCommaSeparatorVisible(index, array.length);
        tooltipLabelContent.push(`${uu.firstName} ${uu.lastName}`);
        return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react40.default.Fragment, {
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ModuleLink, {
              module: "userUser",
              id: uu.id,
              isTooltip: false,
              children: `${uu.firstName} ${uu.lastName}${isCommaVisible ? "," : ""}`
            }),
            isCommaVisible ? " " : ""
          ]
        }, uu.id);
      });
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TooltipWrapper, {
        tooltipLabel: tooltipLabelContent.join(", "),
        cellLabel: users
      });
    }
  }
  if (fieldConfig.type === "relation" && fieldConfig.relatedModule === "accountUser") {
    const newValue = Array.isArray(value) ? value : [value];
    if (Array.isArray(newValue)) {
      const users = newValue.map((au, index, array) => {
        tooltipLabelContent.push(`${au.firstName} ${au.lastName}`);
        const isCommaVisible = isCommaSeparatorVisible(index, array.length);
        return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react40.default.Fragment, {
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ModuleLink, {
              module: "accountUser",
              id: au.id,
              isTooltip: false,
              children: `${au.firstName} ${au.lastName}${isCommaVisible ? "," : ""}`
            }),
            isCommaVisible ? " " : ""
          ]
        }, au.id);
      });
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TooltipWrapper, {
        tooltipLabel: tooltipLabelContent.join(", "),
        cellLabel: users
      });
    }
  }
  return null;
};
var formatFieldCell = (value, row, fieldName, fieldConfig, moduleName) => {
  if ((0, import_isNil.default)(value)) {
    return "";
  }
  const titleCell = checkTitleCell(
    value,
    row,
    fieldName,
    fieldConfig,
    moduleName
  );
  if (titleCell) {
    return titleCell;
  }
  if (fieldConfig.type === "integer" && fieldName === "creationType") {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraTranslation_default, {
      children: (t) => /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(CellWrapper_default, {
        children: [
          value === 1 /* DatasourceImport */ && t("LIST_AC_CT_DATASOURCE_IMPORT"),
          value === 2 /* RegistrationForm */ && t("LIST_AC_CT_REGISTRATION_FORM"),
          value === 3 /* Manual */ && t("LIST_AC_CT_MANUAL")
        ]
      })
    });
  }
  if (fieldConfig.type === "string" && fieldName === "vatHandling") {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraTranslation_default, {
      children: (t) => /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(CellWrapper_default, {
        children: [
          value === "STANDARD" /* Standard */ && t("LIST_AC_VH_STANDARD"),
          value === "NOT_APPLIED" /* NotApplied */ && t("LIST_AC_VH_NOT_APPLIED")
        ]
      })
    });
  }
  if (fieldConfig.type === "integer" && fieldName === "defaultPriceType") {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(PriceTypeDisplay_default, {
      value
    });
  }
  if (["datetime", "datetimetz"].includes(fieldConfig.type)) {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CellWrapper_default, {
      textAlign: "right",
      children: (0, import_date_fns2.format)(new Date(value), DATETIME_FORMAT_DOTS)
    });
  }
  if ([
    "value",
    "valueNetto",
    "valueBrutto",
    "valueVat",
    "paymentToPay",
    "paymentPayed",
    "valueNettoBeforeDiscount",
    "priceNetto"
  ].includes(fieldName)) {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CellWrapper_default, {
      textAlign: "right",
      children: priceFormatter(value, "none", {}, 2)
    });
  }
  if (["documentStatusByAu", "documentStatus"].includes(fieldName)) {
    const foundObject = documentStatusPositions.find((obj) => obj.id === value);
    const preparedValue = foundObject.value ?? null;
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraTranslation_default, {
      children: (t) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CellWrapper_default, {
        textAlign: "right",
        children: t(preparedValue)
      })
    });
  }
  if (fieldConfig.type === "date") {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CellWrapper_default, {
      textAlign: "right",
      children: (0, import_date_fns2.format)(new Date(value), DATE_FORMAT_DOTS)
    });
  }
  if (fieldConfig.type === "boolean") {
    if ([
      "isActive",
      "removeExpired",
      "useDate",
      "newsletterActive",
      "authorizedToMakeOrders",
      "consentProcessingPersonalData"
    ].includes(fieldName)) {
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CellWrapper_default, {
        children: value ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react39.Box, {
          mx: "auto",
          color: "green.500",
          as: import_fa2.FaCheck
        }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react39.Box, {
          mx: "auto",
          color: "red.500",
          as: import_fa2.FaTimes
        })
      });
    } else {
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraTranslation_default, {
        children: (t) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CellWrapper_default, {
          textAlign: "center",
          children: value ? t("YES") : t("NO")
        })
      });
    }
  }
  if (["integer", "bigint", "decimal", "float", "smallint"].includes(
    fieldConfig.type
  )) {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CellWrapper_default, {
      textAlign: "right",
      children: value
    });
  }
  if (["string", "text"].includes(fieldConfig.type)) {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CellWrapper_default, {
      children: stripHtmlTags(value)
    });
  }
  if (fieldConfig.type === "relation") {
    switch (fieldConfig.relatedModule) {
      case "userUser":
      case "accountUser":
        return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CellWrapper_default, {
          children: Array.isArray(value) ? value.map((user) => `${user.firstName} ${user.lastName}`).join(", ") : `${value.firstName} ${value.lastName}`
        });
      case "campaignPhase":
      case "deliveryType":
      case "documentSeriesDefinition":
      case "paymentType":
        return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraCustomTranslation, {
          children: (t) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CellWrapper_default, {
            children: t(value.name)
          })
        });
      case "places": {
        const formattedPlaces = getFormattedPlaceLabel(value);
        return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CellWrapper_default, {
          isTruncated: true,
          maxW: "500px",
          title: formattedPlaces,
          children: formattedPlaces
        });
      }
      case "commissionPhase":
        return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraCustomTranslation, {
          children: (t) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CellWrapper_default, {
            children: t(value.phaseName)
          })
        });
      case "taskType":
        return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraCustomTranslation, {
          children: (t) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CellWrapper_default, {
            children: t(value.typeName)
          })
        });
      default:
        logger_default.warn(
          `Cannot format cell for ${fieldName} from module ${fieldConfig.relatedModule}`
        );
        return null;
    }
  }
  logger_default.warn(`Cannot format cell for ${fieldName} of type ${fieldConfig.type}`);
  return null;
};
var formatAttributeCell = (value, attributeConfig) => {
  if ((0, import_isNil.default)(value)) {
    return null;
  }
  switch (attributeConfig.type) {
    case "text":
    case "phone":
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CellWrapper_default, {
        children: stripHtmlTags(value)
      });
    case "date":
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CellWrapper_default, {
        textAlign: "right",
        children: (0, import_date_fns2.format)(new Date(value), DATE_FORMAT_DOTS)
      });
    case "datetime":
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CellWrapper_default, {
        textAlign: "right",
        children: (0, import_date_fns2.format)(new Date(value), DATETIME_FORMAT_DOTS)
      });
    case "tags":
    case "email":
      return value.length > 0 ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CellWrapper_default, {
        children: value.join(", ")
      }) : null;
    case "bool":
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CellWrapper_default, {
        children: value ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react39.Box, {
          mx: "auto",
          color: "green.500",
          as: import_fa2.FaCheck
        }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react39.Box, {
          mx: "auto",
          color: "red.500",
          as: import_fa2.FaTimes
        })
      });
    case "numeric":
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CellWrapper_default, {
        textAlign: "right",
        children: value
      });
    case "file":
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CellWrapper_default, {
        children: value.map((file, index, array) => {
          var _a2;
          const isCommaVisible = isCommaSeparatorVisible(index, array.length);
          return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react40.default.Fragment, {
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react39.Link, {
                textDecoration: "none",
                color: "crmBlue",
                href: (_a2 = file == null ? void 0 : file.uris) == null ? void 0 : _a2.get,
                children: file.fileName + (isCommaVisible ? "," : "")
              }),
              isCommaVisible ? " " : ""
            ]
          }, file.id);
        })
      });
    case "list": {
      const listValue = value == null ? void 0 : value.find((opt) => opt.selected);
      if (!listValue) {
        return null;
      }
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraCustomTranslation, {
        children: (t) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CellWrapper_default, {
          children: t(listValue.value)
        })
      });
    }
    case "listMulti": {
      const listValue = value.filter((opt) => opt.selected);
      if (listValue.length < 1) {
        return null;
      }
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraCustomTranslation, {
        children: (t) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CellWrapper_default, {
          children: listValue.map((val) => t(val.value)).join(", ")
        })
      });
    }
    case "company": {
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CellWrapper_default, {
        children: value.map((ac, index, array) => {
          const isCommaVisible = isCommaSeparatorVisible(index, array.length);
          return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react40.default.Fragment, {
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react39.Link, {
                textDecoration: "none",
                color: "crmBlue",
                href: getModuleHref("accountCompany", ac.id),
                children: ac.value + (isCommaVisible ? "," : "")
              }),
              isCommaVisible ? " " : ""
            ]
          }, ac.id);
        })
      });
    }
    case "accountUser": {
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CellWrapper_default, {
        children: value.map((au, index, array) => {
          const isCommaVisible = isCommaSeparatorVisible(index, array.length);
          return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react40.default.Fragment, {
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react39.Link, {
                textDecoration: "none",
                color: "crmBlue",
                href: getModuleHref("accountUser", au.id),
                children: ((au == null ? void 0 : au.name) ?? (au == null ? void 0 : au.fullName)) + (isCommaVisible ? "," : "")
              }),
              isCommaVisible ? " " : ""
            ]
          }, au.id);
        })
      });
    }
    default:
      logger_default.warn(
        `Cannot format attribute cell for attribute ${attributeConfig.name} of type ${attributeConfig.type}`
      );
      return null;
  }
};
var relationFieldCellMap = {
  accountCompanies: {
    module: "accountCompany",
    value: (elem) => elem.value
  },
  accountUsers: {
    module: "accountUser",
    value: (elem) => `${elem.firstName} ${elem.lastName}`
  },
  products: {
    module: "product",
    value: (elem) => elem.fullName
  },
  excludedProducts: {
    module: "product",
    value: (elem) => elem.fullName
  },
  servicedProducts: {
    module: "servicedProduct",
    value: (elem) => elem.fullName
  },
  productCategories: {
    module: null,
    value: (elem) => elem.name
  }
};
var formatRelationFieldCell = (value, row, relation) => {
  if ((0, import_isNil.default)(value)) {
    return "";
  }
  if (relationFieldCellMap[relation]) {
    const newValue = Array.isArray(value) ? value : [value];
    if (Array.isArray(newValue)) {
      const relationFieldNames = [];
      const relationFields = newValue.map((elem, index, array) => {
        relationFieldNames.push(relationFieldCellMap[relation].value(elem));
        const isCommaVisible = isCommaSeparatorVisible(index, array.length);
        return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react40.default.Fragment, {
          children: [
            relationFieldCellMap[relation].module ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ModuleLink, {
              module: elem.type || relationFieldCellMap[relation].module,
              id: elem.id,
              isTooltip: false,
              children: relationFieldCellMap[relation].value(elem) + (isCommaVisible ? "," : "")
            }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, {
              children: relationFieldCellMap[relation].value(elem) + (isCommaVisible ? "," : "")
            }),
            isCommaVisible ? " " : ""
          ]
        }, elem.id);
      });
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TooltipWrapper, {
        tooltipLabel: relationFieldNames.join(", "),
        cellLabel: relationFields
      });
    }
  }
  logger_default.warn(`Cannot format relation field cell for relation ${relation}`);
  return null;
};
var formatHeader = (fieldName, fieldConfig, {
  alignment,
  prefix = "LIST_COLUMN_"
} = {
  alignment: "left"
}) => {
  if (["datetime", "date", "datetimetz", "integer", "bigint", "decimal"].includes(
    fieldConfig == null ? void 0 : fieldConfig.type
  )) {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraTranslation_default, {
      children: (t) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react39.Text, {
        w: "full",
        as: "span",
        display: "block",
        textAlign: "right",
        children: t(`${prefix}${fieldName}`)
      })
    });
  }
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraTranslation_default, {
    children: (t) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react39.Text, {
      w: "full",
      as: "span",
      display: "block",
      textAlign: alignment,
      children: t(`${prefix}${fieldName}`)
    })
  });
};
var formatRelationHeader = (relationName, {
  alignment
} = {
  alignment: "left"
}) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraTranslation_default, {
    children: (t) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react39.Text, {
      textAlign: alignment,
      children: t(`LIST_COLUMN_${relationName}`)
    })
  });
};
var formatAttributeHeader = (attribute, {
  alignment
} = {}) => {
  if (["datetime", "date", "integer", "bigint", "decimal", "numeric"].includes(
    attribute == null ? void 0 : attribute.type
  )) {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraCustomTranslation, {
      children: (t) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react39.Text, {
        as: "span",
        display: "block",
        float: "right",
        children: t(`${attribute.name}`)
      })
    });
  }
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraCustomTranslation, {
    children: (t) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react39.Text, {
      textAlign: alignment,
      children: t(`${attribute.name}`)
    })
  });
};
var getProductFieldsAccessor = (fieldName) => {
  switch (fieldName) {
    case "priceBrutto":
    case "priceNetto":
      return "prices";
    default:
      return fieldName;
  }
};
var parseMetaToColumns = (moduleMeta, options, moduleName) => {
  var _a2, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n;
  if (!moduleMeta) {
    return null;
  }
  let nipColumn = [];
  if ((_a2 = moduleMeta.fields) == null ? void 0 : _a2.company) {
    const nipSettings = {
      ...moduleMeta.fields["company"],
      type: "string"
    };
    nipColumn.push({
      id: "company.nip",
      Header: () => {
        return formatHeader("nip", nipSettings);
      },
      accessor: "company.nip",
      Cell: ({ value, row }) => {
        return formatFieldCell(value, row, "nip", nipSettings, moduleName);
      }
    });
  }
  const baseFieldsColumns = Object.keys(
    moduleMeta.fields
  ).filter((field) => {
    var _a3;
    return !((_a3 = options == null ? void 0 : options.excludedFields) == null ? void 0 : _a3.includes(field));
  }).map((field) => {
    var _a3, _b2, _c2, _d2, _e2, _f2, _g2, _h2;
    if (((_b2 = (_a3 = options == null ? void 0 : options.fieldOverrides) == null ? void 0 : _a3[field]) == null ? void 0 : _b2.column) && ((_e2 = (_d2 = (_c2 = options == null ? void 0 : options.fieldOverrides) == null ? void 0 : _c2[field]) == null ? void 0 : _d2.column) == null ? void 0 : _e2.isPartial) !== true) {
      return options.fieldOverrides[field].column;
    }
    return {
      id: field,
      Header: (options2) => {
        return formatHeader(field, moduleMeta.fields[field], options2);
      },
      accessor: moduleName === "product" ? getProductFieldsAccessor(field) : field,
      Cell: ({ value, row }) => {
        return formatFieldCell(
          value,
          row,
          field,
          moduleMeta.fields[field],
          moduleName
        );
      },
      ...((_g2 = (_f2 = options == null ? void 0 : options.fieldOverrides) == null ? void 0 : _f2[field]) == null ? void 0 : _g2.column) ? (_h2 = options.fieldOverrides) == null ? void 0 : _h2[field].column : {}
    };
  });
  const baseExtraFieldsColumns = Object.keys(
    (moduleMeta == null ? void 0 : moduleMeta.extra_fields) ?? {}
  ).filter((extraField) => !["attributes", "relations"].includes(extraField)).filter((extraField) => {
    var _a3;
    return !((_a3 = options == null ? void 0 : options.excludedFields) == null ? void 0 : _a3.includes(extraField));
  }).map((extraField) => {
    var _a3, _b2;
    if ((_b2 = (_a3 = options == null ? void 0 : options.fieldOverrides) == null ? void 0 : _a3[extraField]) == null ? void 0 : _b2.column) {
      return options.fieldOverrides[extraField].column;
    }
    return {
      id: extraField,
      Header: (options2) => {
        return formatHeader(
          extraField,
          moduleMeta.extra_fields[extraField],
          options2
        );
      },
      accessor: extraField,
      Cell: ({ value, row }) => {
        return formatFieldCell(
          value,
          row,
          extraField,
          moduleMeta.extra_fields[extraField],
          moduleName
        );
      }
    };
  });
  const extraFieldRelations = ((_c = (_b = moduleMeta == null ? void 0 : moduleMeta.extra_fields) == null ? void 0 : _b.relations) == null ? void 0 : _c.properties) && !Array.isArray((_e = (_d = moduleMeta == null ? void 0 : moduleMeta.extra_fields) == null ? void 0 : _d.relations) == null ? void 0 : _e.properties) ? Object.keys((_g = (_f = moduleMeta == null ? void 0 : moduleMeta.extra_fields) == null ? void 0 : _f.relations) == null ? void 0 : _g.properties).filter(
    (relation) => {
      var _a3;
      return (_a3 = options.includedExtraFieldRelations) == null ? void 0 : _a3.includes(relation);
    }
  ).map((relation) => {
    var _a3, _b2, _c2, _d2;
    if (!(0, import_isEmpty4.default)((_b2 = (_a3 = options == null ? void 0 : options.fieldOverrides) == null ? void 0 : _a3[relation]) == null ? void 0 : _b2.column)) {
      return (_d2 = (_c2 = options == null ? void 0 : options.fieldOverrides) == null ? void 0 : _c2[relation]) == null ? void 0 : _d2.column;
    }
    return {
      id: relation,
      Header: () => formatRelationHeader(relation),
      fieldType: "relation",
      fieldName: relation,
      accessor: (originalRow) => {
        var _a4;
        return (_a4 = originalRow.relations) == null ? void 0 : _a4[relation];
      },
      Cell: ({ value, row }) => {
        return formatRelationFieldCell(value, row, relation);
      }
    };
  }) : [];
  const attributesColumns = !Array.isArray((_h = moduleMeta == null ? void 0 : moduleMeta.extra_fields) == null ? void 0 : _h.attributes) && ((_k = (_j = (_i = moduleMeta == null ? void 0 : moduleMeta.extra_fields) == null ? void 0 : _i.attributes) == null ? void 0 : _j.items) == null ? void 0 : _k.length) ? (_n = (_m = (_l = moduleMeta == null ? void 0 : moduleMeta.extra_fields) == null ? void 0 : _l.attributes) == null ? void 0 : _m.items) == null ? void 0 : _n.filter(
    (attribute) => {
      var _a3;
      return !((_a3 = options == null ? void 0 : options.excludedAttributeTypes) == null ? void 0 : _a3.includes(attribute.type));
    }
  ).map((attribute) => ({
    id: `attribute.${attribute.id}`,
    Header: () => {
      return formatAttributeHeader(attribute);
    },
    fieldType: "attribute",
    fieldName: attribute.name,
    accessor: (originalRow) => {
      var _a3;
      const accessedAttribute = (_a3 = originalRow == null ? void 0 : originalRow.attributes) == null ? void 0 : _a3.find(
        (attr) => attr.id === attribute.id
      );
      return accessedAttribute == null ? void 0 : accessedAttribute.value;
    },
    Cell: ({ value, row }) => {
      var _a3, _b2, _c2;
      return formatAttributeCell(
        value,
        !Array.isArray(moduleMeta.extra_fields) ? (_c2 = (_b2 = (_a3 = moduleMeta == null ? void 0 : moduleMeta.extra_fields) == null ? void 0 : _a3.attributes) == null ? void 0 : _b2.items) == null ? void 0 : _c2.find(
          (attr) => attr.id === attribute.id
        ) : null
      );
    }
  })) : [];
  const extraFieldsColumns = Array.isArray(options == null ? void 0 : options.extraColumns) ? options == null ? void 0 : options.extraColumns : [];
  return [
    ...baseFieldsColumns,
    ...nipColumn,
    ...baseExtraFieldsColumns,
    ...extraFieldRelations,
    ...attributesColumns,
    ...extraFieldsColumns
  ];
};
var getVisibleColumnsParams = (columns, hiddenColumns, activeFilters, initialParams) => {
  if (!columns || (columns == null ? void 0 : columns.length) < 1) {
    return null;
  }
  let activeFilterAttributes = [];
  let activeFilterFields = [];
  if (activeFilters) {
    Object.keys(activeFilters).forEach((filter) => {
      if (activeFilters[filter].module === "attributes") {
        activeFilterAttributes.push(`attributes.${filter}`);
      } else {
        activeFilterFields.push(filter);
      }
    });
  }
  const visibleColumns = (0, import_xor.default)(hiddenColumns ?? [], columns ?? []);
  const [attributes, fields] = (0, import_partition.default)(
    visibleColumns,
    (column) => column.startsWith("attribute.")
  );
  const attributesParams = attributes.map(
    (attr) => attr.replace("attribute.", "attributes.")
  );
  const mergedFields = (initialParams == null ? void 0 : initialParams.fields) ? (0, import_uniq.default)([
    ...initialParams.fields.split(","),
    ...fields,
    ...activeFilterFields
  ]) : (0, import_uniq.default)([...fields, ...activeFilterFields]);
  const mergedExtraFields = (initialParams == null ? void 0 : initialParams.extra_fields) ? (0, import_uniq.default)([
    ...initialParams.extra_fields.split(","),
    ...attributesParams,
    ...activeFilterAttributes
  ]) : (0, import_uniq.default)([...attributesParams, ...activeFilterAttributes]);
  return {
    ...mergedFields.length ? {
      fields: mergedFields == null ? void 0 : mergedFields.join(",")
    } : {},
    ...mergedExtraFields.length ? {
      extra_fields: mergedExtraFields == null ? void 0 : mergedExtraFields.join(",")
    } : {}
  };
};
var downloadXlsxDocument = (apiParams, signal, module2, userType, onModalLoaderClose) => {
  var _a2, _b, _c, _d, _e;
  const { endpoint, params } = apiParams;
  const preparedParams = ((_b = (_a2 = params == null ? void 0 : params.fields) == null ? void 0 : _a2.split(",")) == null ? void 0 : _b.length) > 0 && [1 /* accountUser */, 3 /* guest */].includes(userType) ? {
    ...params,
    fields: (_e = (_d = (_c = params == null ? void 0 : params.fields) == null ? void 0 : _c.split(",")) == null ? void 0 : _d.filter(
      (fieldName) => !excludedFieldsListAccountUser.includes(fieldName)
    )) == null ? void 0 : _e.join(",")
  } : params;
  const urlSearchParams = new URLSearchParams({
    ...preparedParams,
    "setting[export_to_xlsx]": "true",
    "page[limit]": -1
  });
  const url = `${document.location.origin}/api/${endpoint}?${urlSearchParams}`;
  import_axios3.default.get(url, {
    signal,
    responseType: "blob"
  }).then((response) => {
    const url2 = URL.createObjectURL(response.data);
    const linkElement = document.createElement("a");
    linkElement.href = url2;
    linkElement.style.display = "none";
    linkElement.download = `${module2}_list`;
    document.body.appendChild(linkElement);
    linkElement.click();
    document.body.removeChild(linkElement);
    URL.revokeObjectURL(url2);
    setTimeout(() => {
      onModalLoaderClose == null ? void 0 : onModalLoaderClose();
    }, 2e3);
  }).catch((err) => {
    onModalLoaderClose == null ? void 0 : onModalLoaderClose();
    return false;
  });
  return url;
};
var disableSortingColumns = (columns, disabledSortingColumns) => {
  return columns == null ? void 0 : columns.map((c) => {
    if (disabledSortingColumns.includes(c.id)) {
      c.disableSortBy = true;
    }
    return c;
  });
};
var filterGlobalExcludedFields = (items, userType) => {
  if ([1 /* accountUser */, 3 /* guest */].includes(userType)) {
    return items.filter(
      (item) => !excludedFieldsListAccountUser.includes(item.id)
    );
  }
  return items;
};
var isCommaSeparatorVisible = (index, arrayLength) => {
  return index < arrayLength - 1 && arrayLength > 1;
};
var documentStatusPositions = [
  { id: 0, value: "tworzenie" },
  { id: 1, value: "z\u0142o\u017Cone" },
  { id: 2, value: "z\u0142o\u017Cone - potwierdzone" },
  { id: 3, value: "rozpatrzone" },
  { id: 4, value: "odrzucone" },
  { id: 6, value: "zrealizowane" },
  { id: 7, value: "zrealizowane wielokrotnie" },
  { id: 8, value: "usuni\u0119te" },
  { id: 9, value: "anulowane" },
  { id: 10, value: "zamkni\u0119te" },
  { id: 14, value: "wys\u0142ane" },
  { id: 15, value: "weryfikacja" },
  { id: 16, value: "do poprawienia" },
  { id: 17, value: "cz\u0119\u015Bciowo zrealizowane" },
  { id: 18, value: "potwierdzony" },
  { id: 19, value: "autoryzacja klienta" },
  { id: 20, value: "w buforze" },
  { id: 21, value: "op\u0142acony" },
  { id: 22, value: "zrezygnowano" }
];
var documentInvoiceStatus = [
  { id: 0, value: "tworzenie" },
  { id: 1, value: "z\u0142o\u017Cone" },
  { id: 2, value: "anulowane" },
  { id: 4, value: "w buforze" }
];

// src/utils/apiUtils.ts
var import_date_fns3 = require("date-fns");
var normalizeSettings = (settings) => {
  const parsedSetting = {};
  settings == null ? void 0 : settings.forEach((setting) => {
    parsedSetting[setting.name] = fixSettingValueType(setting);
  });
  return parsedSetting;
};
var fixSettingValueType = (setting) => {
  var _a2;
  switch (setting.name) {
    case "cookie_notice":
    case "enable_multilingualism":
    case "enable_seo_urls":
    case "company_search_for_user_user":
    case "searchbar_account_user":
    case "currency_active":
    case "new_look_menu_headers":
      return setting.value === "1" || setting.value === "true";
    case "company_short_name_enabled":
      return parseInt((_a2 = setting.value) == null ? void 0 : _a2.toString());
    default:
      return setting.value;
  }
};
var formatDateForApi = (date) => {
  if (!date) {
    return null;
  }
  const dateToFormat = typeof date === "string" ? new Date(date) : date;
  return (0, import_date_fns3.formatISO)(dateToFormat);
};
var escapeFilterValueForQuery = (value) => {
  if (!value)
    return "";
  return value.replace(/\\/g, "\\\\").replace(/%/g, "\\%").replace(/_/g, "\\_");
};

// src/utils/taskUtils.ts
var import_sortBy = __toESM(require("lodash/sortBy"));
var import_reverse = __toESM(require("lodash/reverse"));
var import_isEqual = __toESM(require("date-fns/isEqual"));
var import_endOfDay = __toESM(require("date-fns/endOfDay"));
var import_addDays = __toESM(require("date-fns/addDays"));
var import_addMilliseconds = __toESM(require("date-fns/addMilliseconds"));
var import_differenceInMilliseconds = __toESM(require("date-fns/differenceInMilliseconds"));
var import_date_fns4 = require("date-fns");
var import_rrule = require("rrule");
var DTSTART_EXTRACTOR = new RegExp("(?:^DTSTART.*)", "m");
var RRULE_EXTRACTOR = new RegExp("(?:^RRULE.*)", "m");
var EXDATE_EXTRACTOR = new RegExp("(?:^EXDATE.*)", "gm");
var mapRelationTasksToTaskFields = (tasks) => tasks.map((t) => {
  var _a2, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n;
  const user = {
    id: (_a2 = t == null ? void 0 : t.performer) == null ? void 0 : _a2.id,
    avatar: (_b = t == null ? void 0 : t.performer) == null ? void 0 : _b.avatar,
    fullName: ((_c = t == null ? void 0 : t.performer) == null ? void 0 : _c.fullName) ?? (((_d = t == null ? void 0 : t.performer) == null ? void 0 : _d.firstName) && ((_e = t == null ? void 0 : t.performer) == null ? void 0 : _e.lastName)) ? `${t.performer.firstName} ${t.performer.lastName}` : (_f = t.performer) == null ? void 0 : _f.name,
    defaultCallendarColor: (_g = t == null ? void 0 : t.performer) == null ? void 0 : _g.defaultCallendarColor,
    firstName: (_h = t == null ? void 0 : t.performer) == null ? void 0 : _h.firstName,
    lastName: (_i = t == null ? void 0 : t.performer) == null ? void 0 : _i.lastName,
    isDeleted: (_j = t == null ? void 0 : t.performer) == null ? void 0 : _j.isDeleted
  };
  return {
    taskName: t.name,
    id: t.id,
    isCompleted: false,
    taskDescription: t.description,
    beginDate: t.beginDate,
    endDate: t.endDate,
    type: {
      id: t.typeId,
      typeName: t.typeName,
      isEvent: t.subtype === "event",
      icon: t.icon,
      iconColor: t.iconColor
    },
    user,
    recurrenceParentBeginDate: null,
    recurrenceActive: t.recurrenceActive,
    recurrenceUuid: (_k = t == null ? void 0 : t.recurrence) == null ? void 0 : _k.uuid,
    calendarData: t == null ? void 0 : t.calendarData,
    recurrenceExDates: (_l = t == null ? void 0 : t.recurrence) == null ? void 0 : _l.excludedDates,
    recurrencePattern: (_m = t == null ? void 0 : t.recurrence) == null ? void 0 : _m.patternType,
    recurrenceInterval: (_n = t == null ? void 0 : t.recurrence) == null ? void 0 : _n.intervalType
  };
});
var sortTasks = (tasks, isEvent) => {
  const sortedTasks = (0, import_sortBy.default)(tasks, ["beginDate", "id"]);
  return isEvent ? (0, import_reverse.default)(sortedTasks) : sortedTasks;
};
var expandRecurringTasks = ({
  tasks,
  includePreviousDays,
  includeNextDaysCount
}) => {
  let newTasks = [];
  tasks == null ? void 0 : tasks.forEach((task) => {
    var _a2, _b;
    if (!task.recurrenceActive) {
      newTasks.push(task);
      return;
    }
    try {
      const dtStartString = (_a2 = task.calendarData.match(
        DTSTART_EXTRACTOR
      )) == null ? void 0 : _a2[0];
      const rruleString = (_b = task.calendarData.match(
        RRULE_EXTRACTOR
      )) == null ? void 0 : _b[0];
      const exdates = task.calendarData.matchAll(EXDATE_EXTRACTOR);
      const fullRRuleString = `${dtStartString}
${rruleString}${exdates ? `
${[...exdates].join("\n")}` : ""}`;
      if (!rruleString) {
        throw new Error("No RRULE found in recurring task");
      }
      const rrule = (0, import_rrule.rrulestr)(fullRRuleString);
      const taskOcurrances = rrule == null ? void 0 : rrule.between(
        includePreviousDays ? new Date(0) : (0, import_endOfDay.default)((0, import_addDays.default)(new Date(), -1)),
        includeNextDaysCount ? (0, import_endOfDay.default)((0, import_addDays.default)(new Date(), includeNextDaysCount)) : (0, import_endOfDay.default)(new Date())
      );
      taskOcurrances == null ? void 0 : taskOcurrances.forEach((taskOccurrenceDate) => {
        const isParentTask = (0, import_isEqual.default)(
          taskOccurrenceDate,
          new Date(task.beginDate)
        );
        let taskDateDifference = null;
        if (task.endDate && task.beginDate) {
          taskDateDifference = (0, import_differenceInMilliseconds.default)(
            new Date(task == null ? void 0 : task.endDate),
            new Date(task == null ? void 0 : task.beginDate)
          );
        }
        const virtualTask = {
          ...task,
          id: isParentTask ? task.id : null,
          calendarData: null,
          recurrenceParentBeginDate: formatDateForApi(taskOccurrenceDate),
          beginDate: formatDateForApi(taskOccurrenceDate),
          recurrenceActive: isParentTask ? true : false,
          endDate: taskDateDifference ? formatDateForApi(
            (0, import_addMilliseconds.default)(taskOccurrenceDate, taskDateDifference)
          ) : null
        };
        newTasks.push(virtualTask);
      });
    } catch (error) {
      console.error(`Task ${task.id} calendarData invalid.`);
    }
  });
  return newTasks;
};
var prepareAllTasks = ({
  tasks,
  settings,
  limit
}) => {
  var _a2, _b, _c, _d, _e, _f;
  let result = tasks;
  let beginDate = {};
  if (((_a2 = settings == null ? void 0 : settings.beginDate) == null ? void 0 : _a2.max) > -1) {
    let day = new Date();
    if (((_b = settings.beginDate.maxType) == null ? void 0 : _b.id) === 2) {
      day.setDate(day.getDate() + parseInt(settings.beginDate.max));
      beginDate["to"] = (0, import_endOfDay.default)(day);
    } else {
      day.setDate(day.getDate() - parseInt(settings.beginDate.max));
      beginDate["from"] = (0, import_date_fns4.startOfDay)(day);
    }
  } else {
    if ((_c = settings == null ? void 0 : settings.beginDate) == null ? void 0 : _c.from) {
      beginDate["from"] = (0, import_date_fns4.startOfDay)(new Date((_d = settings == null ? void 0 : settings.beginDate) == null ? void 0 : _d.from));
    }
    if ((_e = settings == null ? void 0 : settings.beginDate) == null ? void 0 : _e.to) {
      beginDate["to"] = (0, import_endOfDay.default)(new Date((_f = settings == null ? void 0 : settings.beginDate) == null ? void 0 : _f.to));
    }
  }
  if (beginDate.from) {
    result = result.filter(
      (task) => new Date(task.beginDate) > new Date(beginDate.from)
    );
  }
  if (beginDate.to) {
    result = result.filter(
      (task) => new Date(task.beginDate) < new Date(beginDate.to)
    );
  }
  if (Array.isArray(settings == null ? void 0 : settings.sorting) && settings.sorting.length > 0) {
    settings.sorting.reverse().forEach((element) => {
      if (element == null ? void 0 : element.value) {
        const sortField = element.value.split("_");
        result = result.sort((a, b) => {
          return sortField[1] === "ASC" ? prepareSortFields(sortField[0], a[sortField[0]]) - prepareSortFields(sortField[0], b[sortField[0]]) : prepareSortFields(sortField[0], b[sortField[0]]) - prepareSortFields(sortField[0], a[sortField[0]]);
        });
      }
    });
  }
  return result.slice(0, limit);
};
var prepareSortFields = (fieldName, fieldValue) => {
  if (["beginDate"].includes(fieldName)) {
    return new Date(fieldValue);
  }
  return fieldValue;
};
var prepareObjectRelationTasks = ({
  tasks,
  includePreviousDays,
  includeNextDaysCount,
  limit,
  sort
}) => {
  const transformedTasks = mapRelationTasksToTaskFields(tasks);
  const expandedRecurringTasks = expandRecurringTasks({
    tasks: transformedTasks,
    includePreviousDays,
    includeNextDaysCount
  });
  const preparedSortType = (sort == null ? void 0 : sort.beginDate) ?? "ASC";
  return prepareAllTasks({
    tasks: expandedRecurringTasks,
    limit,
    settings: {
      sorting: [{ label: "", value: `beginDate_${preparedSortType}` }]
    }
  });
};
var prepareObjectRelationEvents = ({
  events,
  limit,
  sort
}) => {
  const transformedTasks = mapRelationTasksToTaskFields(events);
  const preparedSortType = (sort == null ? void 0 : sort.beginDate) ?? "ASC";
  return prepareAllTasks({
    tasks: transformedTasks,
    limit,
    settings: {
      sorting: [{ label: "", value: `beginDate_${preparedSortType}` }]
    }
  });
};
var checkIsVirtualTask = (task) => Boolean(
  !idExists(task.id) && (task == null ? void 0 : task.recurrenceUuid) && (task == null ? void 0 : task.recurrenceParentBeginDate)
);

// src/utils/documentUtils.ts
var getDocumentRelationName = (objectName) => {
  if (objectName === "campaignOpportunity") {
    return "campaignOpportunities";
  }
  return objectName + "s";
};
var auraParseFloat = (value) => {
  if (typeof value === "number") {
    if (isNaN(value)) {
      return 0;
    } else {
      return value;
    }
  }
  return value ? parseFloat(value.replace(",", ".").replace(/\s/g, "")) : 0;
};
var auraParseDisplayValue = (value) => {
  var _a2;
  if (value && ["string", "number"].includes(typeof value)) {
    return (_a2 = value == null ? void 0 : value.toString()) == null ? void 0 : _a2.replace(".", ",");
  }
  return value;
};
var setValueWithPriceFormat = (fieldName, value, setValue) => {
  if (!isNaN(value)) {
    setValue(fieldName, priceFormatter(value, "none", {}, 2));
  }
};
var getAvailabilityProductLabel = (availability, measureUnitLabel) => {
  if (availability === void 0)
    return "";
  return `${availability} ${measureUnitLabel}`;
};
var isAppliedVatForCompany = (vatHandling) => {
  return vatHandling !== "NOT_APPLIED" /* NotApplied */;
};

// src/components/ActiveFilterDisplay/FiltersDisplayItem/FiltersDisplayItem.tsx
var import_react42 = __toESM(require("@mdi/react"));
var import_jsx_runtime = require("react/jsx-runtime");
var MultiFilterDisplay = ({
  filterName,
  multiFilter,
  endpoint,
  labelField,
  extraFields,
  valueField = "id",
  removeFilter,
  positions,
  filters,
  translateCustom = false
}) => {
  const { data, isLoading } = useMinimalAutoselect_default({
    endpoint,
    labelField,
    extraFields,
    valueField,
    enabled: !positions,
    filters,
    translateCustom
  });
  const { t } = useAuraTranslation_default();
  const newPositions = data ?? positions;
  if (isLoading || !newPositions) {
    return null;
  }
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react41.Box, {
    "data-testid": `multifilter-${filterName}`,
    children: multiFilter.value.map((val) => {
      const option = newPositions.find(
        (pos) => pos.value === val || pos.id === val || pos.id === Number(val)
      );
      if (!option) {
        logger_default.error(
          `Could not get value for MultiFilterDisplay ${filterName}: ${JSON.stringify(
            val
          )}`
        );
      }
      const optionValue = t(`${option.value}`);
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TagDisplay, {
        value: optionValue,
        onFilterRemove: () => {
          removeFilter(filterName);
        }
      }, val);
    })
  });
};
var UserFilterDisplay = ({
  filterName,
  multiFilter,
  endpoint,
  labelField = "fullName",
  valueField = "id",
  removeFilter
}) => {
  const { data, isLoading } = useMinimalAutoselect_default({
    endpoint,
    labelField,
    valueField,
    extraFields: ["fullName"]
  });
  if (isLoading || !data) {
    return null;
  }
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, {
    children: multiFilter.value.map((val) => {
      const option = data.find((pos) => pos.id === val);
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TagDisplay, {
        value: option.value,
        ...removeFilter ? { onFilterRemove: () => removeFilter(filterName, option.id) } : {}
      }, val);
    })
  });
};
var FiltersDisplayItem = ({
  value,
  filterName,
  filterDisplayName,
  ml,
  removeFilter,
  module: module2,
  ...props
}) => {
  var _a2, _b, _c, _d, _e;
  const { t } = useAuraTranslation_default();
  const externalMarkers = useExternalMarkers();
  if (value.type === "custom" && value.additionalData.displayComponent) {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FilterDisplayItemWrapper, {
      ml,
      ...props,
      children: value.additionalData.displayComponent({
        filterName,
        filterDisplayName,
        value,
        removeFilter
      })
    });
  }
  if (value.type === "custom" || value.type === "company") {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(FilterDisplayItemWrapper, {
      ml,
      ...props,
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FilterName, {
          name: filterDisplayName
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(MultiFilterDisplay, {
          filterName,
          multiFilter: value,
          removeFilter,
          positions: (_a2 = value == null ? void 0 : value.additionalData) == null ? void 0 : _a2.positions,
          endpoint: (_b = value == null ? void 0 : value.additionalData) == null ? void 0 : _b.endpoint,
          labelField: (_c = value == null ? void 0 : value.additionalData) == null ? void 0 : _c.labelField,
          filters: (_d = value == null ? void 0 : value.additionalData) == null ? void 0 : _d.additionalParams
        })
      ]
    });
  }
  if (value.type === "list" && filterName === "defaultPriceType") {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(FilterDisplayItemWrapper, {
      ml,
      ...props,
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FilterName, {
          name: filterDisplayName
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(MultiFilterDisplay, {
          filterName,
          multiFilter: value,
          removeFilter,
          endpoint: value.additionalData.endpoint,
          labelField: value.additionalData.labelField,
          filters: value.additionalData.filter
        })
      ]
    });
  }
  if (value.type === "list" && filterName === "vatHandling") {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(FilterDisplayItemWrapper, {
      ml,
      ...props,
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FilterName, {
          name: filterDisplayName
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(MultiFilterDisplay, {
          filterName,
          multiFilter: value,
          removeFilter,
          positions: value.additionalData.positions
        })
      ]
    });
  }
  if (value.type === "text" || value.type === "string") {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(FilterDisplayItemWrapper, {
      ml,
      ...props,
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FilterName, {
          name: filterDisplayName
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TagDisplay, {
          value: value.value,
          onFilterRemove: () => removeFilter(filterName)
        })
      ]
    });
  }
  if (value.type === "boolean" || value.type === "bool") {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(FilterDisplayItemWrapper, {
      ml,
      ...props,
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FilterName, {
          name: filterDisplayName
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TagDisplay, {
          value: value.value ? `${t("Yes")}` : `${t("No")}`,
          onFilterRemove: () => removeFilter(filterName)
        })
      ]
    });
  }
  if (value.type === "integer" || value.type === "bigint" || value.type === "float" || value.type === "numeric" || value.type === "decimal") {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(FilterDisplayItemWrapper, {
      ml,
      ...props,
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FilterName, {
          name: filterDisplayName
        }),
        !(0, import_isNil2.default)(value.value.from) ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TagDisplay, {
          valuePrefix: t("VALUE_FROM"),
          value: value.value.from,
          onFilterRemove: () => removeFilter(filterName, "from")
        }) : null,
        !(0, import_isNil2.default)(value.value.to) ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TagDisplay, {
          valuePrefix: t("VALUE_TO"),
          value: value.value.to,
          onFilterRemove: () => removeFilter(filterName, "to")
        }) : null,
        !(0, import_isNil2.default)(value.value.notZero) ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TagDisplay, {
          value: value.value.notZero ? t("ONLY_AVAILABLE") : null,
          onFilterRemove: () => removeFilter(filterName, "notZero")
        }) : null
      ]
    });
  }
  if (value.type === "list") {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(FilterDisplayItemWrapper, {
      ml,
      ...props,
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FilterName, {
          name: filterDisplayName
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(MultiFilterDisplay, {
          filterName,
          multiFilter: value,
          removeFilter,
          positions: value == null ? void 0 : value.additionalData.positions
        })
      ]
    });
  }
  if (value.type === "listMulti") {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(FilterDisplayItemWrapper, {
      ml,
      ...props,
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FilterName, {
          name: filterDisplayName
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(MultiFilterDisplay, {
          filterName,
          multiFilter: value,
          removeFilter,
          positions: (_e = value == null ? void 0 : value.additionalData) == null ? void 0 : _e.positions
        })
      ]
    });
  }
  if (value.type === "tags") {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(FilterDisplayItemWrapper, {
      ml,
      ...props,
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FilterName, {
          name: filterDisplayName
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(MultiFilterDisplay, {
          filterName,
          multiFilter: value,
          removeFilter,
          endpoint: "markers",
          labelField: "value",
          filters: { "filter[type][eq]": getAttributeTagTypeForModule(module2) }
        })
      ]
    });
  }
  if (value.type === "date" || value.type === "datetime" || value.type === "datetimetz") {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(FilterDisplayItemWrapper, {
      ml,
      ...props,
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FilterName, {
          name: filterDisplayName
        }),
        !(0, import_isNil2.default)(value.value.from) ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TagDisplay, {
          valuePrefix: t("VALUE_FROM"),
          value: (0, import_date_fns5.format)(
            value.value.from,
            value.type === "datetime" || value.type === "datetimetz" ? DATETIME_FORMAT_DOTS : DATE_FORMAT_DOTS
          ),
          onFilterRemove: () => removeFilter(filterName, "from")
        }) : null,
        !(0, import_isNil2.default)(value.value.to) ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TagDisplay, {
          valuePrefix: t("VALUE_TO"),
          value: (0, import_date_fns5.format)(
            value.value.to,
            value.type === "datetime" || value.type === "datetimetz" ? DATETIME_FORMAT_DOTS : DATE_FORMAT_DOTS
          ),
          onFilterRemove: () => removeFilter(filterName, "to")
        }) : null
      ]
    });
  }
  if (value.type === "relation") {
    if (value.module === "paymentType") {
      return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(FilterDisplayItemWrapper, {
        ml,
        ...props,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FilterName, {
            name: filterDisplayName
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(MultiFilterDisplay, {
            filterName,
            multiFilter: value,
            endpoint: "payment_types",
            labelField: "name",
            removeFilter,
            translateCustom: true
          })
        ]
      });
    }
    if (value.module === "deliveryType") {
      return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(FilterDisplayItemWrapper, {
        ml,
        ...props,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FilterName, {
            name: filterDisplayName
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(MultiFilterDisplay, {
            filterName,
            multiFilter: value,
            endpoint: "delivery_types",
            labelField: "name",
            removeFilter,
            translateCustom: true
          })
        ]
      });
    }
    if (value.module === "documentSeriesDefinition") {
      return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(FilterDisplayItemWrapper, {
        ml,
        ...props,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FilterName, {
            name: filterDisplayName
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(MultiFilterDisplay, {
            filterName,
            multiFilter: value,
            endpoint: "document_series_definitions",
            labelField: "name",
            removeFilter,
            translateCustom: true
          })
        ]
      });
    }
    if (value.module === "commissionPhase") {
      return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(FilterDisplayItemWrapper, {
        ml,
        ...props,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FilterName, {
            name: filterDisplayName
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(MultiFilterDisplay, {
            filterName,
            multiFilter: value,
            endpoint: "commission_phases",
            labelField: "phaseName",
            removeFilter,
            translateCustom: true
          })
        ]
      });
    }
    if (value.module === "priceProductGroup") {
      return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(FilterDisplayItemWrapper, {
        ml,
        ...props,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FilterName, {
            name: filterDisplayName
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(MultiFilterDisplay, {
            filterName,
            multiFilter: value,
            endpoint: "price_product_groups",
            labelField: "name",
            removeFilter
          })
        ]
      });
    }
    if (value.module === "defaultPriceType") {
      return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(FilterDisplayItemWrapper, {
        ml,
        ...props,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FilterName, {
            name: filterDisplayName
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(UserFilterDisplay, {
            filterName,
            multiFilter: value,
            endpoint: "price_types",
            removeFilter
          })
        ]
      });
    }
    if (value.module === "accountUser") {
      return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(FilterDisplayItemWrapper, {
        ml,
        ...props,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FilterName, {
            name: filterDisplayName
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(UserFilterDisplay, {
            filterName,
            multiFilter: value,
            endpoint: "account_users",
            removeFilter
          })
        ]
      });
    }
    if (value.module === "userUser") {
      return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(FilterDisplayItemWrapper, {
        ml,
        ...props,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FilterName, {
            name: filterDisplayName
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(UserFilterDisplay, {
            filterName,
            multiFilter: value,
            endpoint: "user_users",
            removeFilter
          })
        ]
      });
    }
    if (value.module === "externalMarker") {
      return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(FilterDisplayItemWrapper, {
        ml,
        ...props,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FilterName, {
            name: filterDisplayName
          }),
          value.value.map((val) => {
            const externalMarker = externalMarkers.find(
              (pos) => pos.id === val
            );
            return externalMarker && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TagDisplay, {
              value: String(
                externalMarker.label && externalMarker.label !== "" ? t(`${externalMarker.label}`) : externalMarker.symbol
              ),
              onFilterRemove: () => removeFilter(filterName, val)
            }, val);
          })
        ]
      });
    }
    if (value.module === "campaignPhase") {
      return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(FilterDisplayItemWrapper, {
        ml,
        ...props,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FilterName, {
            name: filterDisplayName
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(MultiFilterDisplay, {
            filterName,
            multiFilter: value,
            endpoint: "campaign_phases",
            labelField: "name",
            removeFilter,
            translateCustom: true
          })
        ]
      });
    }
    if (value.module === "campaign") {
      return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(FilterDisplayItemWrapper, {
        ml,
        ...props,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FilterName, {
            name: filterDisplayName
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(MultiFilterDisplay, {
            filterName,
            multiFilter: value,
            endpoint: "campaigns",
            labelField: "name",
            removeFilter,
            translateCustom: true
          })
        ]
      });
    }
    if (value.module === "accountCompany") {
      return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(FilterDisplayItemWrapper, {
        ml,
        ...props,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FilterName, {
            name: filterDisplayName
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(MultiFilterDisplay, {
            filterName,
            multiFilter: value,
            endpoint: "account_companies",
            extraFields: ["displayName"],
            removeFilter
          })
        ]
      });
    }
    if (value.module === "taskType") {
      return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(FilterDisplayItemWrapper, {
        ml,
        ...props,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FilterName, {
            name: filterDisplayName
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(MultiFilterDisplay, {
            filterName,
            multiFilter: value,
            endpoint: "task_types",
            labelField: "typeName",
            removeFilter,
            translateCustom: true
          })
        ]
      });
    }
    if (value.module === "storehouse") {
      return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(FilterDisplayItemWrapper, {
        ml,
        ...props,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FilterName, {
            name: filterDisplayName
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(MultiFilterDisplay, {
            filterName,
            multiFilter: value,
            endpoint: "storehouses",
            labelField: "name",
            removeFilter
          })
        ]
      });
    }
    if (process.env.NODE_ENV === "development") {
      logger_default.warn(
        `[ActiveFilterDisplay] no component for filter type ${value.type}${(value == null ? void 0 : value.module) ? " and module " + value.module : null}`
      );
    }
    return null;
  }
  if (process.env.NODE_ENV === "development") {
    logger_default.warn(
      `[ActiveFilterDisplay] no component for filter type ${value.type}`
    );
  }
  return null;
};
var FilterDisplayItemWrapper = ({ children, ...props }) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react41.Stack, {
    rowGap: 3,
    maxW: "full",
    flexWrap: "wrap",
    className: "filter-display__item",
    direction: "row",
    align: "center",
    spacing: 4,
    ...props,
    children
  });
};
var FilterName = ({ name, ...props }) => {
  const { t } = useAuraTranslation_default();
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react41.Text, {
    as: "span",
    fontSize: "md",
    fontWeight: "500",
    mr: -2,
    ...props,
    children: `${t(
      name
    )}:`
  });
};
var TagDisplay = ({
  value,
  valuePrefix,
  onFilterRemove,
  ...props
}) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TagButton, {
    mr: 4,
    ...onFilterRemove ? { onClick: onFilterRemove } : {},
    ...props,
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react41.Stack, {
      direction: "row",
      spacing: 1,
      align: "center",
      justifyContent: "space-between",
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react41.Text, {
          as: "span",
          pl: 1,
          fontSize: "sm",
          children: `${valuePrefix ? valuePrefix + ": " : ""}${value}`
        }),
        onFilterRemove && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react41.Box, {
          color: "gray.400",
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react42.default, {
            path: import_js4.mdiClose,
            size: "16px"
          })
        })
      ]
    })
  });
};
var TagButton = ({ onClick, children, ...props }) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react41.Button, {
    borderRadius: "6px",
    variant: "outline",
    size: "xs",
    px: "8px",
    py: "0",
    fontWeight: "400",
    fontSize: "13px",
    color: "blue.900",
    onClick,
    ...props,
    children
  });
};
var FiltersDisplayItem_default = FiltersDisplayItem;

// src/components/ActiveFilterDisplay/ActiveFilterDisplay.tsx
var import_react46 = __toESM(require("@mdi/react"));
var import_js5 = require("@mdi/js");

// src/components/ButtonAction/ButtonAction.tsx
var import_react43 = require("@chakra-ui/react");
var import_react44 = require("@emotion/react");
var import_jsx_runtime = require("react/jsx-runtime");
var ButtonAction = (props) => {
  const size = (0, import_react43.useBreakpointValue)({ base: "md", md: "sm" });
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react43.Button, {
    css: import_react44.css`
        & .chakra-button__icon,
        & .chakra-button__icon > svg {
          width: 20px;
          height: 20px;
        }
      `,
    fontWeight: "medium",
    size,
    fontSize: "sm",
    variant: "outline",
    px: 4,
    py: "10px",
    ...props
  });
};
var ButtonAction_default = ButtonAction;

// src/components/ActiveFilterDisplay/ActiveFilterDisplay.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var ActiveFilterDisplay = ({
  filters,
  clearAllFilters,
  clearFilter,
  filterPrefix,
  module: module2,
  buttonModalFilters,
  buttonModalSorting,
  ...props
}) => {
  var _a2;
  const { t } = useAuraTranslation_default();
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react45.Flex, {
    className: "filter-display",
    alignItems: "center",
    flexWrap: "wrap",
    gap: 3,
    ...props,
    children: [
      buttonModalFilters,
      !((0, import_isNil3.default)(filters) || (0, import_isEmpty5.default)(filters)) && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(ButtonAction_default, {
            size: "md",
            leftIcon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react46.default, {
              path: import_js5.mdiFilterOffOutline,
              size: "20px"
            }),
            onClick: clearAllFilters,
            mr: 1,
            fontSize: "sm",
            lineHeight: "20px",
            letterSpacing: "0.25px",
            color: "gray.700",
            children: [
              t("KANBAN_MODAL_CLEAR_FILTERS"),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react45.Text, {
                ml: 1,
                as: "span",
                fontSize: "sm",
                letterSpacing: "0.25px",
                color: "blackAlpha.500",
                children: `(${(_a2 = Object.keys(filters)) == null ? void 0 : _a2.length})`
              })
            ]
          }),
          Object.keys(filters).map((filter, index) => {
            var _a3, _b, _c, _d;
            return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FiltersDisplayItem_default, {
              mr: 1,
              lineHeight: "24px",
              filterName: filter,
              filterDisplayName: ((_b = (_a3 = filters[filter]) == null ? void 0 : _a3.additionalData) == null ? void 0 : _b.displayName) ? t((_d = (_c = filters[filter]) == null ? void 0 : _c.additionalData) == null ? void 0 : _d.displayName) : t(`${filterPrefix ?? "LIST_COLUMN_"}${filter}`),
              value: filters[filter],
              removeFilter: clearFilter,
              module: module2
            }, filter);
          })
        ]
      }),
      buttonModalSorting
    ]
  });
};
var ActiveFilterDisplay_default = ActiveFilterDisplay;

// src/components/ActiveFilters/ActiveFilters.tsx
var import_react51 = require("@chakra-ui/react");
var import_js6 = require("@mdi/js");
var import_react52 = __toESM(require("@mdi/react"));
var import_isEmpty6 = __toESM(require("lodash/isEmpty"));
var import_isNil5 = __toESM(require("lodash/isNil"));
var import_react_error_boundary = require("react-error-boundary");

// src/components/ActiveFilters/ActiveFilter/ActiveFilter.tsx
var import_react49 = require("@chakra-ui/react");
var import_date_fns7 = require("date-fns");
var import_isNil4 = __toESM(require("lodash/isNil"));
var import_react50 = __toESM(require("react"));

// src/components/ModalDiscount/consts.ts
var DiscountScopeTypes = /* @__PURE__ */ ((DiscountScopeTypes2) => {
  DiscountScopeTypes2[DiscountScopeTypes2["all"] = 0] = "all";
  DiscountScopeTypes2[DiscountScopeTypes2["accountCompany"] = 1] = "accountCompany";
  return DiscountScopeTypes2;
})(DiscountScopeTypes || {});
var DiscountApplyOnTypes = /* @__PURE__ */ ((DiscountApplyOnTypes2) => {
  DiscountApplyOnTypes2[DiscountApplyOnTypes2["productCategory"] = 0] = "productCategory";
  DiscountApplyOnTypes2[DiscountApplyOnTypes2["product"] = 1] = "product";
  DiscountApplyOnTypes2[DiscountApplyOnTypes2["productGroup"] = 2] = "productGroup";
  DiscountApplyOnTypes2[DiscountApplyOnTypes2["everything"] = 3] = "everything";
  return DiscountApplyOnTypes2;
})(DiscountApplyOnTypes || {});
var DISCOUNT_SCOPES = [
  { value: 0 /* all */, label: "DISCOUNT_SCOPE_ALL" },
  {
    value: 1 /* accountCompany */,
    label: "DISCOUNT_SCOPE_ACCOUNT_COMPANY"
  }
];
var DISCOUNT_APPLY_ON = [
  {
    value: 0 /* productCategory */,
    label: "DISCOUNT_APPLY_ON_PRODUCT_CATEGORY"
  },
  { value: 1 /* product */, label: "DISCOUNT_APPLY_ON_PRODUCT" },
  {
    value: 2 /* productGroup */,
    label: "DISCOUNT_APPLY_ON_PRODUCT_GROUP"
  },
  {
    value: 3 /* everything */,
    label: "DISCOUNT_APPLY_ON_EVERYTHING"
  }
];

// src/components/ModalDiscount/ModalDiscount.tsx
var import_react47 = require("@chakra-ui/react");
var import_api11 = require("@questy/api");
var import_lib = require("@questy/lib");
var import_date_fns6 = require("date-fns");
var import_react48 = require("react");
var import_react_hook_form = require("react-hook-form");
var import_react_query11 = require("react-query");

// src/components/ModalDiscount/utils.ts
var prepareDataForApi = (data) => {
  var _a2, _b, _c, _d, _e, _f;
  const applyOnValue = (_a2 = data.applyOn) == null ? void 0 : _a2.value;
  const scopeValue = (_b = data == null ? void 0 : data.scopeType) == null ? void 0 : _b.value;
  const useDateValue = data.useDate;
  let preparedData = {
    name: data.name,
    applyOn: applyOnValue,
    scopeType: scopeValue,
    value: data.value,
    useDate: useDateValue,
    isActive: data.isActive
  };
  if (applyOnValue === 1 /* product */) {
    preparedData.product = (_c = data == null ? void 0 : data.product) == null ? void 0 : _c.value;
  } else if (applyOnValue === 0 /* productCategory */) {
    preparedData.category = (_d = data == null ? void 0 : data.category) == null ? void 0 : _d.value;
  } else if (applyOnValue === 2 /* productGroup */) {
    preparedData.priceProductGroup = (_e = data == null ? void 0 : data.priceProductGroup) == null ? void 0 : _e.value;
  }
  if (scopeValue === 1 /* accountCompany */) {
    preparedData.company = (_f = data.company) == null ? void 0 : _f.value;
  }
  if (useDateValue) {
    preparedData.startDate = data.startDate;
    preparedData.endDate = data.endDate;
    if (!!preparedData.endDate) {
      preparedData.removeExpired = data.removeExpired;
    } else {
      preparedData.removeExpired = false;
    }
  } else {
    preparedData.removeExpired = false;
  }
  return preparedData;
};

// src/components/ModalDiscount/ModalDiscount.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var withCredentials = (Component) => {
  return ({ ...props }) => {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_lib.CredentialContextProvider, {
      module: "discounts",
      initialModuleParams: {},
      ...props.initialCredentials && {
        initialCredentials: props.initialCredentials
      },
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Component, {
        ...props
      })
    });
  };
};
var ModalDiscount = ({
  id,
  isOpen,
  onClose,
  afterSuccess,
  companyId,
  isReadOnly = false
}) => {
  const { t } = useAuraTranslation_default();
  const { data, isLoading, isFetching } = (0, import_react_query11.useQuery)(
    ["discount", id],
    () => (0, import_api11.getDiscount)(id, {
      extraFields: ["company.displayName"],
      settings: {
        withRelations: true
      }
    }),
    {
      enabled: idExists(id) && isOpen,
      refetchOnWindowFocus: false,
      cacheTime: 0,
      select: (res) => res == null ? void 0 : res.data
    }
  );
  const { data: accountCompany, isLoading: isLoadingAccountCompany } = (0, import_react_query11.useQuery)(
    ["account_companies", companyId],
    () => (0, import_api11.getAccountCompany)(companyId, {
      fields: ["id"],
      extraFields: ["displayName"]
    }),
    {
      enabled: !idExists(id) && isOpen && idExists(companyId),
      refetchOnWindowFocus: false,
      select: (res) => res == null ? void 0 : res.data
    }
  );
  const defaultDataCreateForCompany = (0, import_react48.useMemo)(
    () => ({
      scopeType: 1,
      company: accountCompany
    }),
    [accountCompany]
  );
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(AuraModal, {
    size: "lg",
    isOpen,
    onClose,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalOverlay, {}),
      isLoading || isFetching || isLoadingAccountCompany ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSpinner_default, {}) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ModalDiscountContent, {
        isOpen,
        defaultData: data ?? defaultDataCreateForCompany,
        onClose,
        afterSuccess,
        isReadOnly
      })
    ]
  });
};
var ModalDiscountContent = ({
  isOpen,
  defaultData,
  onClose,
  afterSuccess,
  isReadOnly: isReadOnlyProp
}) => {
  var _a2, _b, _c, _d, _e, _f, _g, _h;
  const { t } = useAuraTranslation_default();
  const { resolveApiError } = useAuraErrorResolver_default();
  const toast = (0, import_react47.useToast)();
  const id = defaultData == null ? void 0 : defaultData.id;
  const isEditing = idExists(id);
  const isReadOnly = isReadOnlyProp || (defaultData == null ? void 0 : defaultData.startDate) && ((0, import_date_fns6.isPast)(new Date(defaultData == null ? void 0 : defaultData.startDate)) || (0, import_date_fns6.isToday)(new Date(defaultData == null ? void 0 : defaultData.startDate)));
  const [isSubmitBtnDisabled, setIsSubmitBtnDisabled] = (0, import_react48.useState)(false);
  const translatedDiscountScopes = (0, import_react48.useMemo)(
    () => translateOptions(DISCOUNT_SCOPES, t),
    [t]
  );
  const translatedApplyOn = (0, import_react48.useMemo)(
    () => translateOptions(DISCOUNT_APPLY_ON, t),
    [t]
  );
  const { hasModuleCredential } = (0, import_lib.useCredentials)();
  const {
    register,
    control,
    formState,
    handleSubmit,
    reset,
    resetField,
    setError,
    setValue,
    getValues,
    watch,
    clearErrors
  } = (0, import_react_hook_form.useForm)({
    defaultValues: {
      ...defaultData ? {
        ...defaultData,
        ...defaultData.hasOwnProperty("scopeType") && {
          scopeType: translatedDiscountScopes.find(
            (scopeType) => scopeType.value === defaultData.scopeType
          )
        },
        ...defaultData.hasOwnProperty("applyOn") && {
          applyOn: translatedApplyOn.find(
            (applyOn) => applyOn.value === defaultData.applyOn
          )
        },
        ...(defaultData == null ? void 0 : defaultData.startDate) && {
          startDate: new Date(defaultData == null ? void 0 : defaultData.startDate)
        },
        ...(defaultData == null ? void 0 : defaultData.endDate) && {
          endDate: new Date(defaultData == null ? void 0 : defaultData.endDate)
        },
        ...(defaultData == null ? void 0 : defaultData.company) && {
          company: {
            value: (_a2 = defaultData == null ? void 0 : defaultData.company) == null ? void 0 : _a2.id,
            label: (_b = defaultData == null ? void 0 : defaultData.company) == null ? void 0 : _b.displayName
          }
        },
        ...(defaultData == null ? void 0 : defaultData.product) && {
          product: {
            value: (_c = defaultData == null ? void 0 : defaultData.product) == null ? void 0 : _c.id,
            label: (_d = defaultData == null ? void 0 : defaultData.product) == null ? void 0 : _d.name
          }
        },
        ...(defaultData == null ? void 0 : defaultData.category) && {
          category: {
            value: (_e = defaultData == null ? void 0 : defaultData.category) == null ? void 0 : _e.id,
            label: (_f = defaultData == null ? void 0 : defaultData.category) == null ? void 0 : _f.name
          }
        },
        ...(defaultData == null ? void 0 : defaultData.priceProductGroup) && {
          priceProductGroup: {
            value: (_g = defaultData == null ? void 0 : defaultData.priceProductGroup) == null ? void 0 : _g.id,
            label: (_h = defaultData == null ? void 0 : defaultData.priceProductGroup) == null ? void 0 : _h.name
          }
        }
      } : {
        scopeType: translatedDiscountScopes[0],
        applyOn: translatedApplyOn[3],
        startDate: new Date(),
        endDate: new Date()
      }
    }
  });
  (0, import_react48.useEffect)(() => {
    return () => {
      reset({});
    };
  }, []);
  const screenPhone = (0, import_react47.useBreakpointValue)({
    base: true,
    md: false
  });
  const handleSubmitForm = async (formData) => {
    setIsSubmitBtnDisabled(true);
    if (isEditing) {
      editObj(formData);
    } else {
      createObj(formData);
    }
  };
  const createObj = async (data) => {
    var _a3, _b2, _c2, _d2, _e2, _f2;
    try {
      const response = await (0, import_api11.createDiscount)({
        data: prepareDataForApi(data)
      });
      if (response.errors === null) {
        toast({
          title: t("NOTICE_SAVE_SUCCESS"),
          status: "success"
        });
        afterSuccess == null ? void 0 : afterSuccess();
        onClose();
      }
    } catch (error) {
      resolveApiError(error);
      if ((_b2 = (_a3 = error == null ? void 0 : error.response) == null ? void 0 : _a3.data) == null ? void 0 : _b2.errors) {
        setError(
          (_d2 = (_c2 = error.response.data.errors) == null ? void 0 : _c2["item_0"]) == null ? void 0 : _d2[0].field,
          {
            type: "manual",
            message: `DISCOUNT_${(_f2 = (_e2 = error.response.data.errors) == null ? void 0 : _e2["item_0"]) == null ? void 0 : _f2[0].type}`
          },
          {
            shouldFocus: true
          }
        );
        setIsSubmitBtnDisabled(false);
      }
    }
  };
  const editObj = async (data) => {
    try {
      const response = await (0, import_api11.updateDiscount)(defaultData.id, {
        data: prepareDataForApi(data)
      });
      if (response.errors === null) {
        toast({
          title: t("NOTICE_SAVE_SUCCESS"),
          status: "success"
        });
        afterSuccess == null ? void 0 : afterSuccess();
        onClose();
      }
    } catch (error) {
      resolveApiError(error);
      setIsSubmitBtnDisabled(false);
    }
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(AuraModalContent, {
    as: "form",
    onSubmit: handleSubmit(handleSubmitForm),
    className: "discount__create-modal",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalHeader, {
        showBorders: false,
        className: "discount__create-modal__header",
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react47.Text, {
          isTruncated: true,
          as: screenPhone ? "h5" : "h4",
          textStyle: { base: "h5", md: "h4" },
          children: isEditing ? t("Discount") : t("NEW_DISCOUNT")
        })
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalBody, {
        overflowY: "visible",
        className: "discount__create-modal__body",
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(DiscountForm, {
          control,
          register,
          resetField,
          formState,
          setValue,
          getValues,
          defaultData,
          watch,
          setError,
          clearErrors,
          isReadOnly,
          isNameDisabled: isReadOnlyProp
        })
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalFooter, {
        className: "discount__create-modal__footer",
        showBorders: false,
        children: hasModuleCredential("create") && !isReadOnly && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react47.Button, {
          className: "discount__create-modal__footer__button-create",
          isLoading: formState.isSubmitting || isSubmitBtnDisabled,
          type: "submit",
          colorScheme: "blue",
          textTransform: "capitalize",
          children: t("SAVE")
        })
      })
    ]
  });
};
var DiscountForm = ({
  control,
  defaultData,
  formState,
  watch,
  setValue,
  getValues,
  isReadOnly,
  isNameDisabled,
  resetField,
  clearErrors,
  setError
}) => {
  var _a2, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p;
  const { language } = (0, import_react48.useContext)(LanguageContext);
  const { hasCredential } = (0, import_lib.useCredentials)();
  const { t } = useAuraTranslation_default();
  const availableScopeTypes = ((_c = (_b = (_a2 = useSettings_default()) == null ? void 0 : _a2.settings) == null ? void 0 : _b.discountScopeTypes) == null ? void 0 : _c.map(
    (i) => Number(i)
  )) ?? [];
  const availableApplyToProductTypes = ((_f = (_e = (_d = useSettings_default()) == null ? void 0 : _d.settings) == null ? void 0 : _e.discountApplyToProductTypes) == null ? void 0 : _f.map(
    (i) => Number(i)
  )) ?? [];
  const translatedDiscountScopes = (0, import_react48.useMemo)(() => {
    var _a3;
    const availableOptions = (_a3 = DISCOUNT_SCOPES) == null ? void 0 : _a3.filter(
      (scope) => availableScopeTypes.includes(scope.value)
    );
    return translateOptions(availableOptions, t);
  }, [t, availableScopeTypes]);
  const translatedApplyOn = (0, import_react48.useMemo)(() => {
    var _a3;
    const availableOptions = (_a3 = DISCOUNT_APPLY_ON) == null ? void 0 : _a3.filter(
      (scope) => availableApplyToProductTypes.includes(scope.value)
    );
    return translateOptions(availableOptions, t);
  }, [t, availableScopeTypes]);
  const selectedScope = watch("scopeType");
  const selectedApplyOn = watch("applyOn");
  const useDate = watch("useDate");
  const removeExpired = watch("removeExpired");
  const startDate = watch("startDate");
  const endDate = watch("endDate");
  const isSetAnyDate = (0, import_react48.useMemo)(
    () => !!startDate || !!endDate,
    [startDate, endDate]
  );
  (0, import_react48.useEffect)(() => {
    const endDate2 = getValues("endDate");
    if (!endDate2) {
      return;
    }
    if (new Date(endDate2) < new Date(startDate)) {
      setValue("endDate", (0, import_date_fns6.addDays)(new Date(startDate), 1));
    }
  }, [startDate]);
  (0, import_react48.useEffect)(() => {
    if (isSetAnyDate && !removeExpired) {
      clearErrors(["startDate", "endDate"]);
    } else if (removeExpired) {
      clearErrors("startDate");
    } else if (!isSetAnyDate && (formState == null ? void 0 : formState.isSubmitted)) {
      setError("startDate");
      setError("endDate");
    }
  }, [isSetAnyDate, removeExpired, startDate, formState == null ? void 0 : formState.isSubmitted]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react47.Stack, {
    spacing: 4,
    "data-testid": "create-discount-form",
    className: "discount__create-modal__form",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react47.Flex, {
        justifyContent: "flex-end",
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react47.Text, {
            textStyle: "bodyInput",
            color: "red.500",
            mr: "16px",
            children: "*"
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react47.Text, {
            textStyle: "bodyInput",
            color: "blackAlpha.500",
            children: t("REQUIRED")
          })
        ]
      }),
      hasCredential("name", "field", "show") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react47.FormControl, {
        isInvalid: !!((_g = formState == null ? void 0 : formState.errors) == null ? void 0 : _g.name),
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react47.FormLabel, {
            htmlFor: "name",
            children: t("NAME")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form.Controller, {
            control,
            name: "name",
            render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraInput_default, {
              isReadOnly: isNameDisabled,
              ...field
            })
          })
        ]
      }),
      hasCredential("applyOn", "field", "show") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react47.FormControl, {
        isRequired: true,
        isInvalid: !!((_h = formState == null ? void 0 : formState.errors) == null ? void 0 : _h.applyOn),
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react47.FormLabel, {
            htmlFor: "applyOn",
            children: t("DISCOUNT_APPLY_ON")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form.Controller, {
            control,
            name: "applyOn",
            rules: {
              required: true
            },
            render: ({ field }) => {
              var _a3;
              return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSelect_default, {
                options: translatedApplyOn,
                isClearable: false,
                ...field,
                isReadOnly,
                isError: (_a3 = formState == null ? void 0 : formState.errors) == null ? void 0 : _a3.applyOn
              });
            }
          })
        ]
      }),
      hasCredential("product", "field", "show") && (selectedApplyOn == null ? void 0 : selectedApplyOn.value) === 1 /* product */ && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react47.FormControl, {
        isRequired: true,
        isInvalid: !!((_i = formState == null ? void 0 : formState.errors) == null ? void 0 : _i.product),
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react47.FormLabel, {
            htmlFor: "product",
            children: t("PRODUCT")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form.Controller, {
            control,
            name: "product",
            rules: {
              required: true
            },
            render: ({ field }) => {
              var _a3;
              return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSelect_default, {
                loadDataProps: {
                  endpoint: "products",
                  labelField: "name",
                  autoselect: false,
                  additionalNameAccessor: "code",
                  settings: {
                    "order[_q]": "DESC",
                    "order[name]": "ASC"
                  }
                },
                components: {
                  Option: CustomProductOption_default
                },
                ...field,
                isReadOnly,
                isError: (_a3 = formState == null ? void 0 : formState.errors) == null ? void 0 : _a3.product
              });
            }
          })
        ]
      }),
      hasCredential("category", "field", "show") && (selectedApplyOn == null ? void 0 : selectedApplyOn.value) === 0 /* productCategory */ && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react47.FormControl, {
        isRequired: true,
        isInvalid: !!((_j = formState == null ? void 0 : formState.errors) == null ? void 0 : _j.category),
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react47.FormLabel, {
            htmlFor: "category",
            children: t("CATEGORY")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form.Controller, {
            control,
            name: "category",
            rules: {
              required: true
            },
            render: ({ field }) => {
              var _a3;
              return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSelect_default, {
                loadDataProps: {
                  endpoint: "product_categories",
                  autoselect: false,
                  labelField: "name",
                  queryField: "name",
                  settings: {
                    "order[name]": "ASC"
                  }
                },
                ...field,
                isReadOnly,
                isError: (_a3 = formState == null ? void 0 : formState.errors) == null ? void 0 : _a3.category
              });
            }
          })
        ]
      }),
      hasCredential("priceProductGroup", "field", "show") && (selectedApplyOn == null ? void 0 : selectedApplyOn.value) === 2 /* productGroup */ && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react47.FormControl, {
        isRequired: true,
        isInvalid: !!((_k = formState == null ? void 0 : formState.errors) == null ? void 0 : _k.priceProductGroup),
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react47.FormLabel, {
            htmlFor: "priceProductGroup",
            children: t("DISCOUNT_PRICE_PRODUCT_GROUP")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form.Controller, {
            control,
            name: "priceProductGroup",
            rules: {
              required: true
            },
            render: ({ field }) => {
              var _a3;
              return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSelect_default, {
                loadDataProps: {
                  endpoint: "price_product_groups",
                  autoselect: false,
                  labelField: "name",
                  queryField: "name",
                  settings: {
                    "order[name]": "ASC"
                  },
                  defaultOptionsEnabled: true
                },
                ...field,
                isReadOnly,
                isError: (_a3 = formState == null ? void 0 : formState.errors) == null ? void 0 : _a3.priceProductGroup
              });
            }
          })
        ]
      }),
      hasCredential("scopeType", "field", "show") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react47.FormControl, {
        isRequired: true,
        isInvalid: !!((_l = formState == null ? void 0 : formState.errors) == null ? void 0 : _l.scopeType),
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react47.FormLabel, {
            htmlFor: "scopeType",
            children: t("DISCOUNT_SCOPE_TYPE")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form.Controller, {
            control,
            name: "scopeType",
            rules: {
              required: true
            },
            render: ({ field }) => {
              var _a3;
              return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSelect_default, {
                options: translatedDiscountScopes,
                isClearable: false,
                ...field,
                isReadOnly,
                isError: (_a3 = formState == null ? void 0 : formState.errors) == null ? void 0 : _a3.scopeType
              });
            }
          })
        ]
      }),
      hasCredential("company", "field", "show") && (selectedScope == null ? void 0 : selectedScope.value) === 1 /* accountCompany */ && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react47.FormControl, {
        isRequired: true,
        isInvalid: !!((_m = formState == null ? void 0 : formState.errors) == null ? void 0 : _m.company),
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react47.FormLabel, {
            htmlFor: "company",
            children: t("CONTRACTOR")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form.Controller, {
            control,
            name: "company",
            rules: {
              required: true
            },
            render: ({ field }) => {
              var _a3;
              return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSelect_default, {
                optionAllEnabled: true,
                loadDataProps: {
                  endpoint: "account_companies",
                  labelField: "displayName",
                  settings: {
                    "order[_q]": "DESC",
                    "order[name]": "ASC",
                    extra_fields: "displayName"
                  }
                },
                ...field,
                isReadOnly,
                isError: (_a3 = formState == null ? void 0 : formState.errors) == null ? void 0 : _a3.company
              });
            }
          })
        ]
      }),
      hasCredential("value", "field", "show") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react47.FormControl, {
        isRequired: true,
        isInvalid: !!((_n = formState == null ? void 0 : formState.errors) == null ? void 0 : _n.value),
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react47.FormLabel, {
            htmlFor: "value",
            children: t("Value")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form.Controller, {
            control,
            name: "value",
            rules: {
              required: true
            },
            render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react47.InputGroup, {
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraInput_default, {
                  ...field,
                  onChange: (e) => {
                    e.target.value = e.target.value.replace(/[^\d.\,]/g, "");
                    field.onChange(e);
                  },
                  isRequired: false,
                  onBlur: (e) => {
                    var _a3;
                    const parsedToFloat = auraParseFloat((_a3 = e == null ? void 0 : e.target) == null ? void 0 : _a3.value);
                    const fixedValue = Number(parsedToFloat == null ? void 0 : parsedToFloat.toFixed(2));
                    if (fixedValue > 100) {
                      field.onChange(100);
                    } else {
                      field.onChange(fixedValue);
                    }
                  },
                  isReadOnly,
                  borderRadius: "6px 0 0 6px"
                }),
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react47.InputRightAddon, {
                  children: "%"
                })
              ]
            })
          })
        ]
      }),
      hasCredential("useDate", "field", "show") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react47.FormControl, {
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react47.FormLabel, {
            htmlFor: "useDate",
            children: t("DISCOUNT_USE_DATE")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form.Controller, {
            control,
            name: "useDate",
            render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AttributeBoolean_default, {
              isReadOnly,
              ...field
            })
          })
        ]
      }),
      hasCredential("startDate", "field", "show") && useDate && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react47.FormControl, {
        isInvalid: !!((_o = formState == null ? void 0 : formState.errors) == null ? void 0 : _o.startDate),
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react47.FormLabel, {
            htmlFor: "startDate",
            children: t("START_DATE")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form.Controller, {
            control,
            name: "startDate",
            rules: {
              required: !isSetAnyDate && !!!endDate && !removeExpired
            },
            render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(DateInput_default, {
              id: "start-date",
              className: "discount__create-modal__start-date",
              lang: language,
              isClearable: false,
              ...field,
              isDisabled: isReadOnly
            })
          })
        ]
      }),
      hasCredential("endDate", "field", "show") && useDate && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react47.FormControl, {
        isInvalid: !!((_p = formState == null ? void 0 : formState.errors) == null ? void 0 : _p.endDate),
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react47.FormLabel, {
            htmlFor: "endDate",
            children: t("END_DATE")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form.Controller, {
            control,
            name: "endDate",
            rules: {
              required: !isSetAnyDate || removeExpired
            },
            render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(DateInput_default, {
              id: "end-date",
              className: "discount__create-modal__end-date",
              lang: language,
              isClearable: false,
              ...field,
              isDisabled: isReadOnly,
              minDate: startDate && new Date(startDate)
            })
          })
        ]
      }),
      hasCredential("removeExpired", "field", "show") && useDate && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react47.FormControl, {
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react47.FormLabel, {
            htmlFor: "removeExpired",
            children: t("DISCOUNT_REMOVE_EXPIRED")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form.Controller, {
            control,
            name: "removeExpired",
            render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AttributeBoolean_default, {
              isReadOnly,
              ...field
            })
          })
        ]
      }),
      hasCredential("isActive", "field", "show") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react47.FormControl, {
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react47.FormLabel, {
            htmlFor: "isActive",
            children: t("DISCOUNT_IS_ACTIVE")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form.Controller, {
            control,
            name: "isActive",
            render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AttributeBoolean_default, {
              isReadOnly,
              ...field
            })
          })
        ]
      })
    ]
  });
};
var ModalDiscount_default = withCredentials(ModalDiscount);

// src/components/ActiveFilters/ActiveFilter/ActiveFilter.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var TextFilterActive = ({
  filterName,
  filter,
  onRemoveFilter
}) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react49.WrapItem, {
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(ActiveFilterTag, {
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react49.TagLabel, {
          children: filter == null ? void 0 : filter.value
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react49.TagCloseButton, {
          ml: 1,
          onClick: () => onRemoveFilter(filterName)
        })
      ]
    })
  });
};
var prepareValue = (value, t) => {
  if (value === "today") {
    return t("TODAY");
  }
  return (0, import_date_fns7.format)(value, DATE_FORMAT_DOTS);
};
var DateFilterActive = ({
  filterName,
  filter,
  onRemoveFilter
}) => {
  const { t } = useAuraTranslation_default();
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
    children: [
      !(0, import_isNil4.default)(filter == null ? void 0 : filter.value.from) ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react49.WrapItem, {
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(ActiveFilterTag, {
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react49.TagLabel, {
              children: `${t("VALUE_FROM")}: ${prepareValue(
                filter == null ? void 0 : filter.value.from,
                t
              )}`
            }),
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react49.TagCloseButton, {
              ml: 1,
              onClick: () => onRemoveFilter(filterName, "from")
            })
          ]
        })
      }) : null,
      !(0, import_isNil4.default)(filter == null ? void 0 : filter.value.to) ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react49.WrapItem, {
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(ActiveFilterTag, {
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react49.TagLabel, {
              children: `${t("VALUE_TO")}: ${prepareValue(
                filter == null ? void 0 : filter.value.to,
                t
              )}`
            }),
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react49.TagCloseButton, {
              ml: 1,
              onClick: () => onRemoveFilter(filterName, "to")
            })
          ]
        })
      }) : null
    ]
  });
};
var NumericFilterActive = ({
  filterName,
  filter,
  onRemoveFilter
}) => {
  const { t } = useAuraTranslation_default();
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
    children: [
      !(0, import_isNil4.default)(filter == null ? void 0 : filter.value.from) ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react49.WrapItem, {
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(ActiveFilterTag, {
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react49.TagLabel, {
              children: `${t("VALUE_FROM")}: ${filter == null ? void 0 : filter.value.from}`
            }),
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react49.TagCloseButton, {
              ml: 1,
              onClick: () => onRemoveFilter(filterName, "from")
            })
          ]
        })
      }) : null,
      !(0, import_isNil4.default)(filter == null ? void 0 : filter.value.to) ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react49.WrapItem, {
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(ActiveFilterTag, {
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react49.TagLabel, {
              children: `${t("VALUE_TO")}: ${filter == null ? void 0 : filter.value.to}`
            }),
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react49.TagCloseButton, {
              ml: 1,
              onClick: () => onRemoveFilter(filterName, "to")
            })
          ]
        })
      }) : null
    ]
  });
};
var BooleanFilterActive = ({
  filterName,
  filter,
  onRemoveFilter
}) => {
  const { t } = useAuraTranslation_default();
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react49.WrapItem, {
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(ActiveFilterTag, {
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react49.TagLabel, {
          children: (filter == null ? void 0 : filter.value) ? t("Yes") : t("No")
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react49.TagCloseButton, {
          ml: 1,
          onClick: () => onRemoveFilter(filterName)
        })
      ]
    })
  });
};
var getFiltersForEndpoint = (endpoint, filter) => {
  var _a2, _b;
  switch (endpoint) {
    case "markers":
      return {
        "filter[value][in]": filter.value,
        ...(_b = (_a2 = filter.additionalData) == null ? void 0 : _a2.additionalProps) == null ? void 0 : _b.filters
      };
    case "price_types":
      return {
        "filter[indexUpper][in]": filter.value
      };
    default:
      return { "filter[id][in]": filter.value };
  }
};
var addExtraOptions = (data, endpoint, value, t, isUserUser) => {
  if (!data) {
    return data;
  }
  if (endpoint !== "user_users") {
    return data;
  }
  let meOption = [];
  if (isUserUser && (value == null ? void 0 : value.some((id) => id === 0 || id === "0"))) {
    meOption = [{ value: t("ME"), id: 0 }];
  }
  return [...data, ...meOption];
};
var ListFilterActive = ({
  filter,
  filterName,
  endpoint,
  labelField,
  valueField = "id",
  extraFields,
  onRemoveFilter,
  translateCustom = false,
  additionalParameters,
  additionalOptionField
}) => {
  var _a2, _b, _c;
  const { isUserUser } = (0, import_react50.useContext)(AuthContext);
  const isMultiValueActiveFilter = Array.isArray(filter == null ? void 0 : filter.value);
  const positions = (_a2 = filter.additionalData) == null ? void 0 : _a2.positions;
  const { data, isLoading, isFetching } = useMinimalAutoselect_default({
    endpoint,
    labelField,
    valueField,
    extraFields,
    enabled: !positions,
    filters: getFiltersForEndpoint(endpoint, filter),
    translateCustom,
    settings: additionalParameters,
    additionalOptionField
  });
  const { t } = useAuraTranslation_default();
  const newPositions = addExtraOptions(data, endpoint, filter.value, t, isUserUser) ?? positions;
  const handleGoToFilter = () => {
    const element = document.querySelector(`.filter-${filterName}`);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  };
  if (isMultiValueActiveFilter && (isLoading || isFetching || !newPositions)) {
    return null;
  }
  const shouldTranslateValue = ["currencyCode"].includes(filterName) ? false : true;
  if (typeof filter.value === "string") {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react49.WrapItem, {
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(ActiveFilterTag, {
        cursor: "pointer",
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react49.TagLabel, {
            onClick: handleGoToFilter,
            children: filter.value
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react49.TagCloseButton, {
            ml: 1,
            onClick: () => onRemoveFilter(filterName)
          })
        ]
      })
    }, filterName);
  }
  if ((((_b = filter.value) == null ? void 0 : _b.length) ?? 0) > 3) {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react49.WrapItem, {
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(ActiveFilterTag, {
        cursor: "pointer",
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react49.TagLabel, {
            onClick: handleGoToFilter,
            children: `${t("SELECTED")}: ${((_c = filter.value) == null ? void 0 : _c.length) ?? 0}`
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react49.TagCloseButton, {
            ml: 1,
            onClick: () => onRemoveFilter(filterName)
          })
        ]
      })
    }, filterName);
  }
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, {
    children: filter.value.map((val) => {
      const option = newPositions.find(
        (pos) => pos.value === val || pos.id === val || pos.id === Number(val)
      );
      if (!option) {
        logger_default.error(
          `Could not get value for MultiFilterDisplay ${filterName}: ${JSON.stringify(
            val
          )}`
        );
      }
      const optionValue = shouldTranslateValue ? t(`${option == null ? void 0 : option.value}`) : `${option == null ? void 0 : option.value}`;
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react49.WrapItem, {
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(ActiveFilterTag, {
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react49.TagLabel, {
              ...(option == null ? void 0 : option.isDeleted) && {
                textDecoration: "line-through",
                color: "gray.500"
              },
              children: optionValue
            }),
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react49.TagCloseButton, {
              ml: 1,
              onClick: () => onRemoveFilter(
                filterName,
                endpoint === "markers" ? option.value : option.id
              )
            })
          ]
        })
      }, val);
    })
  });
};
var RelationFilterActive = ({ filterName, filter, ...props }) => {
  const baseProps = {
    filter,
    filterName,
    labelField: "name",
    ...props
  };
  if (["accountCompany", "accountCompanies"].includes(filter.module)) {
    if (typeof filter.value === "string") {
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TextFilterActive, {
        ...baseProps
      });
    }
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ListFilterActive, {
      endpoint: "account_companies",
      extraFields: ["displayName"],
      ...baseProps,
      labelField: "displayName"
    });
  }
  if (filter.module === "places") {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ListFilterActive, {
      ...baseProps
    });
  }
  if (filter.module === "accountUser") {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ListFilterActive, {
      endpoint: "account_users",
      extraFields: ["fullName"],
      ...baseProps,
      labelField: "fullName",
      additionalParameters: {
        "setting[with_deleted]": 1,
        fields: "isDeleted"
      },
      additionalOptionField: [
        { field: "id", source: "id" },
        { field: "value", source: "fullName" },
        { field: "isDeleted", source: "isDeleted" }
      ]
    });
  }
  if (filter.module === "campaign") {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ListFilterActive, {
      endpoint: "campaigns",
      ...baseProps,
      translateCustom: true
    });
  }
  if (filter.module === "commissionPhase") {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ListFilterActive, {
      endpoint: "commission_phases",
      ...baseProps,
      labelField: "phaseName",
      translateCustom: true
    });
  }
  if (filter.module === "campaignPhase") {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ListFilterActive, {
      endpoint: "campaign_phases",
      ...baseProps,
      translateCustom: true
    });
  }
  if (filter.module === "deliveryType") {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ListFilterActive, {
      endpoint: "delivery_types",
      ...baseProps,
      translateCustom: true
    });
  }
  if (filter.module === "documentSeriesDefinition") {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ListFilterActive, {
      endpoint: "document_series_definitions",
      ...baseProps,
      translateCustom: true
    });
  }
  if (filter.module === "paymentType") {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ListFilterActive, {
      endpoint: "payment_types",
      ...baseProps,
      translateCustom: true
    });
  }
  if (filter.module === "priceProductGroup") {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ListFilterActive, {
      endpoint: "price_product_groups",
      ...baseProps
    });
  }
  if (filter.module === "productCategories") {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ListFilterActive, {
      endpoint: "product_categories",
      ...baseProps,
      translateCustom: true
    });
  }
  if (filter.module === "taskType") {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ListFilterActive, {
      endpoint: "task_types",
      ...baseProps,
      labelField: "typeName",
      translateCustom: true
    });
  }
  if (filter.module === "userUser") {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ListFilterActive, {
      endpoint: "user_users",
      extraFields: ["fullName"],
      ...baseProps,
      labelField: "fullName",
      additionalParameters: {
        "setting[with_deleted]": 1,
        fields: "isDeleted"
      },
      additionalOptionField: [
        { field: "id", source: "id" },
        { field: "value", source: "fullName" },
        { field: "isDeleted", source: "isDeleted" }
      ]
    });
  }
  if (filter.module === "userProfile") {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ListFilterActive, {
      endpoint: "user_profiles",
      ...baseProps,
      labelField: "profileName",
      additionalOptionField: [
        { field: "id", source: "userProfileId" },
        { field: "value", source: "profileName" }
      ]
    });
  }
  if (["product", "products", "excludedProducts"].includes(filter.module)) {
    if (typeof filter.value === "string") {
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TextFilterActive, {
        ...baseProps
      });
    }
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ListFilterActive, {
      endpoint: "products",
      ...baseProps
    });
  }
  if (filter.module === "servicedProducts") {
    if (typeof filter.value === "string") {
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TextFilterActive, {
        ...baseProps
      });
    }
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ListFilterActive, {
      endpoint: "serviced_products",
      extraFields: ["fullName"],
      ...baseProps,
      labelField: "fullName"
    });
  }
  if (filter.module === "defaultPriceType") {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ListFilterActive, {
      ...baseProps,
      endpoint: "price_types",
      labelField: "fullName",
      valueField: "indexUpper"
    });
  }
};
var CustomFilterActive = ({
  filterName,
  filter,
  onRemoveFilter,
  currentLocale,
  ...props
}) => {
  var _a2, _b;
  const { t } = useAuraTranslation_default();
  if (filterName === "status" && (filter == null ? void 0 : filter.additionalData)) {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, {
      children: filter.value.map((val) => {
        const filterValue = filter.additionalData.positions.find(
          (position) => val === position.id
        ).value;
        return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react49.WrapItem, {
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(ActiveFilterTag, {
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react49.TagLabel, {
                children: t(filterValue)
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react49.TagCloseButton, {
                ml: 1,
                onClick: () => onRemoveFilter(filterName, val)
              })
            ]
          })
        });
      })
    });
  }
  if (filterName === "lang" && (filter == null ? void 0 : filter.additionalData)) {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, {
      children: filter.value.map((val) => {
        const filterValue = filter.additionalData.positions.find(
          (position) => val === position.id
        ).value;
        return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react49.WrapItem, {
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(ActiveFilterTag, {
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react49.TagLabel, {
                children: filterValue
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react49.TagCloseButton, {
                ml: 1,
                onClick: () => onRemoveFilter(filterName, val)
              })
            ]
          })
        });
      })
    });
  }
  if (filterName === "applyOn" && (filter == null ? void 0 : filter.additionalData)) {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, {
      children: filter.value.map((val) => {
        const filterValue = DISCOUNT_APPLY_ON.find(
          (opt) => val == opt.value
        ).label;
        return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react49.WrapItem, {
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(ActiveFilterTag, {
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react49.TagLabel, {
                children: t(filterValue)
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react49.TagCloseButton, {
                ml: 1,
                onClick: () => onRemoveFilter(filterName, val)
              })
            ]
          })
        });
      })
    });
  }
  if (filterName === "ksefStatus" && (filter == null ? void 0 : filter.additionalData)) {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, {
      children: filter.value.map((val) => {
        var _a3;
        const filterValue = (_a3 = filter == null ? void 0 : filter.value) == null ? void 0 : _a3.map(
          (ksefStatus) => KSEF_STATUSES[ksefStatus]
        );
        return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react49.WrapItem, {
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(ActiveFilterTag, {
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react49.TagLabel, {
                children: t(filterValue)
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react49.TagCloseButton, {
                ml: 1,
                onClick: () => onRemoveFilter(filterName, val)
              })
            ]
          })
        });
      })
    });
  }
  if (filterName === "addressCountry") {
    const regionNames = new Intl.DisplayNames([(currentLocale == null ? void 0 : currentLocale.code) ?? "pl"], {
      type: "region"
    });
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, {
      children: filter.value.map((val) => {
        return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react49.WrapItem, {
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(ActiveFilterTag, {
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react49.TagLabel, {
                children: regionNames.of(val)
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react49.TagCloseButton, {
                ml: 1,
                onClick: () => onRemoveFilter(filterName, val)
              })
            ]
          })
        });
      })
    });
  }
  if ((filterName === "defaultCurrency" || filterName === "activeCurrency") && ((_b = (_a2 = filter == null ? void 0 : filter.additionalData) == null ? void 0 : _a2.positions) == null ? void 0 : _b.length) > 0) {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, {
      children: filter.value.map((val) => {
        const filterValue = filter.additionalData.positions.find(
          (position) => val === position.id
        ).value;
        return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react49.WrapItem, {
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(ActiveFilterTag, {
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react49.TagLabel, {
                children: filterValue
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react49.TagCloseButton, {
                ml: 1,
                onClick: () => onRemoveFilter(filterName, val)
              })
            ]
          })
        });
      })
    });
  }
  return null;
};
var filterTypeMap = {
  string: {
    component: TextFilterActive
  },
  text: {
    component: TextFilterActive
  },
  phone: {
    component: TextFilterActive
  },
  email: {
    component: TextFilterActive
  },
  date: {
    component: DateFilterActive
  },
  datetime: {
    component: DateFilterActive
  },
  datetimetz: {
    component: DateFilterActive
  },
  numeric: {
    component: NumericFilterActive
  },
  integer: {
    component: NumericFilterActive
  },
  float: {
    component: NumericFilterActive
  },
  smallint: {
    component: NumericFilterActive
  },
  bigint: {
    component: NumericFilterActive
  },
  decimal: {
    component: NumericFilterActive
  },
  bool: {
    component: BooleanFilterActive
  },
  boolean: {
    component: BooleanFilterActive
  },
  list: {
    component: ListFilterActive
  },
  listMulti: {
    component: ListFilterActive
  },
  file: {
    component: TextFilterActive
  },
  company: {
    component: ListFilterActive,
    params: {
      endpoint: "account_companies",
      extraFields: ["displayName"],
      labelField: "displayName"
    }
  },
  accountUser: {
    component: ListFilterActive,
    params: {
      endpoint: "account_users",
      extraFields: ["fullName"],
      labelField: "fullName"
    }
  },
  defaultPriceType: {
    component: ListFilterActive,
    params: {
      endpoint: "price_types",
      labelField: "fullName",
      valueField: "indexUpper",
      filters: { "filter[active]": true }
    }
  },
  tags: {
    component: ListFilterActive,
    params: {
      endpoint: "markers",
      labelField: "value"
    }
  },
  relation: {
    component: RelationFilterActive
  },
  custom: {
    component: CustomFilterActive
  }
};
var ActiveFilterTag = ({ children, ...props }) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react49.Tag, {
    fontWeight: 400,
    color: "blue.900",
    bg: "none",
    border: "1px solid",
    borderColor: "gray.200",
    borderRadius: "6px",
    fontStyle: "sm",
    px: 2,
    ...props,
    children
  });
};
var ActiveFilter = ({
  filterName,
  filter,
  filterNamePrefix = "",
  valuePrefix,
  onRemoveFilter,
  currentLocale
}) => {
  var _a2, _b;
  const { t } = useAuraTranslation_default();
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react49.WrapItem, {
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react49.Text, {
          as: "span",
          fontSize: "md",
          fontWeight: 500,
          lineHeight: "24px",
          letterSpacing: "0.15px",
          children: `${((_a2 = filter == null ? void 0 : filter.additionalData) == null ? void 0 : _a2.displayName) ? t(filter.additionalData.displayName) : t(filterNamePrefix + filterName)}:`
        })
      }),
      import_react50.default.createElement(filterTypeMap[filter.type].component, {
        filterName,
        filter,
        valuePrefix,
        onRemoveFilter,
        currentLocale,
        ...(_b = filterTypeMap[filter.type]) == null ? void 0 : _b.params
      })
    ]
  });
};
var ActiveFilter_default = ActiveFilter;

// src/components/ActiveFilters/ActiveFilters.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var ActiveFilters = ({
  filters = {},
  filterNamePrefix,
  onRemoveFilter,
  onClearAllFilters,
  currentLocale,
  children,
  ...props
}) => {
  var _a2;
  const { t } = useAuraTranslation_default();
  if ((0, import_isNil5.default)(filters) || (0, import_isEmpty6.default)(filters)) {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react51.Wrap, {
      color: "gray.700",
      spacing: 4,
      align: "center",
      ...props,
      children: children ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react51.WrapItem, {
        children
      }) : null
    });
  }
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react51.Wrap, {
    className: "active-filters",
    color: "gray.700",
    spacing: 4,
    align: "center",
    mt: "8px",
    ...props,
    children: [
      children ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react51.WrapItem, {
        children
      }) : null,
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react51.WrapItem, {
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(ButtonAction_default, {
          size: "sm",
          leftIcon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react52.default, {
            path: import_js6.mdiFilterOffOutline,
            size: "20px"
          }),
          onClick: onClearAllFilters,
          mr: 2,
          className: "active-filters__clear-all-button",
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react51.Text, {
              as: "span",
              fontSize: "sm",
              lineHeight: "20px",
              letterSpacing: "0.25px",
              color: "gray.700",
              children: t("FILTER_CLEAR_ALL")
            }),
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react51.Text, {
              ml: 1,
              as: "span",
              fontSize: "sm",
              lineHeight: "20px",
              letterSpacing: "0.25px",
              color: "blackAlpha.500",
              children: `(${(_a2 = Object.keys(filters)) == null ? void 0 : _a2.length})`
            })
          ]
        })
      }),
      Object.keys(filters).map((filterKey) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_error_boundary.ErrorBoundary, {
        FallbackComponent: (error) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react51.WrapItem, {
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react51.Tag, {
            colorScheme: "red",
            children: [
              "Error - filterName: ",
              filterKey,
              ", filterType:",
              " ",
              filters[filterKey].type
            ]
          })
        }),
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ActiveFilter_default, {
          filterNamePrefix,
          filterName: filterKey,
          filter: filters[filterKey],
          onRemoveFilter,
          currentLocale
        })
      }, filterKey))
    ]
  });
};
var ActiveFilters_default = ActiveFilters;

// src/components/Information/Information.tsx
var import_react53 = require("@chakra-ui/react");
var import_react54 = __toESM(require("@mdi/react"));
var import_js7 = require("@mdi/js");
var import_jsx_runtime = require("react/jsx-runtime");
var Information = ({
  icon,
  label,
  link,
  onClick,
  iconSize
}) => {
  const displayIcon = icon ?? import_js7.mdiInformationOutline;
  let displayContent;
  let content;
  const isMobileScreen = (0, import_react53.useBreakpointValue)({
    base: true,
    lg: false
  });
  if (link) {
    displayContent = /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react53.Link, {
      href: link,
      color: "crmBlue",
      noOfLines: 1,
      className: "information__link",
      children: label
    });
  } else if (typeof onClick === "function") {
    displayContent = /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react53.Button, {
      h: "fit-content",
      variant: "unstyled",
      as: import_react53.Link,
      onClick,
      color: "crmBlue",
      noOfLines: 1,
      className: "information__button",
      fontWeight: 400,
      userSelect: "contain",
      children: label
    });
  } else {
    displayContent = /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react53.Text, {
      className: "information__label",
      mb: "0",
      children: label
    });
  }
  content = /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react53.Box, {
        mr: "12px",
        color: "gray.500",
        className: "information__container__icon-box",
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react54.default, {
          size: iconSize ?? "24px",
          path: displayIcon,
          className: "information__container__icon-box__icon"
        })
      }),
      displayContent
    ]
  });
  const similarProps = {
    textStyle: "bodyInput",
    className: "information__container"
  };
  if (isMobileScreen)
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react53.Box, {
      ...similarProps,
      children: content
    });
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react53.Flex, {
    alignItems: "center",
    ...similarProps,
    children: content
  });
};
var Information_default = Information;

// src/components/Address/Address.tsx
var import_react55 = require("@chakra-ui/react");
var import_js8 = require("@mdi/js");
var import_react56 = __toESM(require("@mdi/react"));
var import_jsx_runtime = require("react/jsx-runtime");
var AdditionalAddressData = ({ label }) => {
  const baseStyle = {
    textStyle: "bodyInput",
    color: "gray.500",
    ps: "33px"
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react55.Box, {
    ...baseStyle,
    className: "address__additional-address",
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react55.Text, {
      children: label
    })
  });
};
var Address = ({
  label,
  icon,
  link,
  addressCommunity,
  addressProvince,
  onClickBtnLocation
}) => {
  const { t } = useAuraTranslation_default();
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react55.HStack, {
    w: "full",
    justifyContent: "space-between",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react55.VStack, {
        alignItems: "start",
        spacing: "8px",
        className: "address",
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Information_default, {
            icon,
            label,
            link
          }),
          addressCommunity && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AdditionalAddressData, {
            label: addressCommunity
          }),
          addressProvince && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AdditionalAddressData, {
            label: addressProvince
          })
        ]
      }),
      typeof onClickBtnLocation === "function" && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react55.VStack, {
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react55.Tooltip, {
          label: t("SHOW_ON_MAP"),
          openDelay: 500,
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react55.IconButton, {
            onClick: onClickBtnLocation,
            "aria-label": "button",
            icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react56.default, {
              size: "24px",
              path: import_js8.mdiMapMarkerOutline
            })
          })
        })
      })
    ]
  });
};
var Address_default = Address;

// src/components/AttributeBoolean/AttributeBoolean.tsx
var import_react57 = require("@chakra-ui/react");
var import_js9 = require("@mdi/js");
var import_react58 = __toESM(require("@mdi/react"));
var import_jsx_runtime = require("react/jsx-runtime");
var AttributeBoolean = ({
  id,
  prefix,
  value,
  onChange,
  isReadOnly = false,
  isInvalid = false
}) => {
  let iconSize = "100%";
  if (!value && !isInvalid)
    iconSize = "0";
  const type = "bool";
  const attributeId = getAttributeId(id, type, prefix);
  const icon = /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react58.default, {
    size: iconSize,
    path: import_js9.mdiCheck
  });
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react57.Box, {
    ...id && {
      id: `${attributeId}`
    },
    className: getAttributeClass(type),
    children: isReadOnly ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react57.Checkbox, {
      size: "lg",
      icon,
      iconColor: "gray.500",
      isChecked: value,
      disabled: true,
      className: "attribute-boolean__checkbox-readonly"
    }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react57.Checkbox, {
      size: "lg",
      icon,
      isChecked: value,
      onChange,
      isInvalid,
      className: "attribute-boolean__checkbox-editable"
    })
  });
};
var AttributeBoolean_default = AttributeBoolean;

// src/components/AttributeChecklist/AttributeChecklist.tsx
var import_react67 = require("@chakra-ui/react");
var import_react68 = require("react");

// src/components/AttributeText/AttributeText.tsx
var import_react59 = require("@chakra-ui/react");
var import_react60 = require("react");
var import_react_textarea_autosize = __toESM(require("react-textarea-autosize"));
var import_jsx_runtime = require("react/jsx-runtime");
var AttributeText = (0, import_react60.forwardRef)((props, ref) => {
  const type = "text";
  const attributeId = getAttributeId(props == null ? void 0 : props.id, type, props == null ? void 0 : props.prefix);
  const borderColor = !(props == null ? void 0 : props.isReadOnly) ? "crmBlue" : "gray.200";
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react59.Textarea, {
    minH: "unset",
    overflow: "hidden",
    w: "100%",
    resize: "vertical",
    ref,
    minRows: 1,
    height: "unset",
    as: import_react_textarea_autosize.default,
    _readOnly: { backgroundColor: "gray.50" },
    _focus: {
      outline: "none",
      border: "1px solid",
      borderColor
    },
    _hover: {
      borderColor
    },
    ...props,
    ...(props == null ? void 0 : props.id) && {
      id: `${attributeId}`
    },
    className: getAttributeClass(type)
  });
});
var AttributeText_default = AttributeText;

// src/components/SimpleTable/SimpleTable.tsx
var import_react63 = require("@chakra-ui/react");
var import_react64 = require("@emotion/react");
var import_js10 = require("@mdi/js");
var import_react65 = __toESM(require("@mdi/react"));
var import_react66 = require("react");

// src/hooks/useShadedScroll.ts
var import_react61 = require("@chakra-ui/react");
var import_react62 = __toESM(require("react"));
var BUTTON_SCROLL_FACTOR = 0.25;
var useShadedScroll = () => {
  const elementRef = import_react62.default.useRef(null);
  const dimensions = (0, import_react61.useDimensions)(elementRef, true);
  const elementWidth = (dimensions == null ? void 0 : dimensions.borderBox.width) ?? 0;
  const [isLeftScrollVisible, setIsLeftScrollVisible] = (0, import_react62.useState)(false);
  const [isRightScrollVisible, setIsRightScrollVisible] = (0, import_react62.useState)(false);
  const updateOnScroll = () => {
    const containerWidth = elementRef.current.clientWidth;
    const content = elementRef.current.firstChild;
    const contentWidth = content.clientWidth;
    if (containerWidth === contentWidth) {
      setIsLeftScrollVisible(false);
      setIsRightScrollVisible(false);
      return;
    }
    const scrollLeft2 = Math.ceil(
      (elementRef.current.scrollLeft >= contentWidth - containerWidth - 2 && elementRef.current.scrollLeft <= contentWidth - containerWidth - 1 ? elementRef.current.scrollLeft + 1 : elementRef.current.scrollLeft > contentWidth - containerWidth ? elementRef.current.scrollLeft - 1 : elementRef.current.scrollLeft) ?? 0
    );
    if (contentWidth > containerWidth && scrollLeft2 === 0) {
      setIsLeftScrollVisible(false);
      setIsRightScrollVisible(true);
    } else if (contentWidth > containerWidth && contentWidth - containerWidth !== scrollLeft2) {
      setIsLeftScrollVisible(true);
      setIsRightScrollVisible(true);
    } else if (contentWidth > containerWidth && contentWidth - containerWidth === scrollLeft2) {
      setIsLeftScrollVisible(true);
      setIsRightScrollVisible(false);
    } else {
      setIsLeftScrollVisible(false);
      setIsRightScrollVisible(false);
    }
  };
  (0, import_react62.useEffect)(() => {
    updateOnScroll();
  }, [elementWidth]);
  const scrollLeft = () => {
    var _a2;
    const { current } = elementRef;
    const elementRefWidth = ((_a2 = elementRef == null ? void 0 : elementRef.current) == null ? void 0 : _a2.clientWidth) ?? 0;
    current.scroll({
      left: current.scrollLeft - elementRefWidth * BUTTON_SCROLL_FACTOR,
      behavior: "smooth"
    });
  };
  const scrollRight = () => {
    var _a2;
    const { current } = elementRef;
    const elementWidth2 = ((_a2 = elementRef == null ? void 0 : elementRef.current) == null ? void 0 : _a2.clientWidth) ?? 0;
    current.scroll({
      left: current.scrollLeft + elementWidth2 * BUTTON_SCROLL_FACTOR,
      behavior: "smooth"
    });
  };
  return {
    elementRef,
    isLeftScrollVisible,
    isRightScrollVisible,
    onScroll: updateOnScroll,
    scrollLeft,
    scrollRight
  };
};
var useShadedScroll_default = useShadedScroll;

// src/components/SimpleTable/SimpleTable.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var getOffsetTopHeight = (container) => {
  if (!container) {
    return 0;
  }
  const containerDetails = container == null ? void 0 : container.getBoundingClientRect();
  if (containerDetails.bottom < 0 || containerDetails.top > screen.height) {
    return 0;
  }
  const visibleTop = Math.max(containerDetails.top, 0);
  const visibleBottom = Math.min(containerDetails.bottom, screen.height);
  return (visibleTop + visibleBottom) / 2 - containerDetails.top;
};
var ScrollButtons = ({
  showLeftButton,
  showRightButton,
  onScrollLeft,
  onScrollRight
}) => {
  const containerRef = (0, import_react66.useRef)();
  const [offsetTopHeight, setOffsetTopHeight] = (0, import_react66.useState)(0);
  (0, import_react66.useEffect)(() => {
    function updateOffsetTop() {
      setOffsetTopHeight(getOffsetTopHeight(containerRef.current));
    }
    updateOffsetTop();
    window.addEventListener("scroll", updateOffsetTop);
    return () => window.removeEventListener("scroll", updateOffsetTop);
  }, []);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react63.Flex, {
    className: "simple-table-scroll-buttons__wrapper",
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    zIndex: 1,
    pointerEvents: "none",
    ref: containerRef,
    overflow: "auto",
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react63.Flex, {
      alignSelf: "flex-start",
      className: "simple-table-scroll-buttons__sticky-wrapper",
      position: "sticky",
      top: offsetTopHeight - 24,
      display: "inline-flex",
      height: "max-content",
      justifyContent: "space-between",
      alignItems: "center",
      pointerEvents: "none",
      w: "full",
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react63.Flex, {
          flex: 1,
          justifyContent: "flex-start",
          children: showLeftButton ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react63.IconButton, {
            className: "simple-table-scroll-buttons__left",
            size: "lg",
            rounded: "full",
            pointerEvents: "all",
            "aria-label": "",
            color: "gray.700",
            bg: "white",
            boxShadow: "md",
            icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react65.default, {
              size: "28.8px",
              path: import_js10.mdiChevronLeft
            }),
            onClick: onScrollLeft
          }) : null
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react63.Flex, {
          flex: 1,
          justifyContent: "flex-end",
          children: showRightButton ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react63.IconButton, {
            className: "simple-table-scroll-buttons__right",
            size: "lg",
            rounded: "full",
            pointerEvents: "all",
            "aria-label": "",
            color: "gray.700",
            bg: "white",
            boxShadow: "md",
            icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react65.default, {
              size: "28.8px",
              path: import_js10.mdiChevronRight
            }),
            onClick: onScrollRight
          }) : null
        })
      ]
    })
  });
};
var TableContainer = ({
  children,
  wrapperProps,
  ...props
}) => {
  const {
    elementRef,
    isLeftScrollVisible,
    isRightScrollVisible,
    onScroll,
    scrollLeft,
    scrollRight
  } = useShadedScroll_default();
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react63.Box, {
    position: "relative",
    className: "simple-table-wrapper",
    ...wrapperProps,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react63.TableContainer, {
        ref: elementRef,
        border: 1,
        borderStyle: "solid",
        borderColor: "gray.200",
        borderRadius: "6px",
        onScroll,
        _before: {
          pointerEvents: "none",
          content: "''",
          position: "absolute",
          top: 0,
          right: "75%",
          bottom: 0,
          left: 0,
          backgroundImage: isLeftScrollVisible ? `linear-gradient(to left, rgba(255,0,0,0), rgba(255,255,255,1))` : "none"
        },
        _after: {
          pointerEvents: "none",
          content: "''",
          position: "absolute",
          top: 0,
          right: 0,
          bottom: 0,
          left: "75%",
          backgroundImage: isRightScrollVisible ? `linear-gradient(to right, rgba(255,0,0,0), rgba(255,255,255,1))` : "none"
        },
        css: import_react64.css`
          & {
            -ms-overflow-style: none; /* for Internet Explorer, Edge */
            scrollbar-width: none; /* for Firefox */
          }

          &::-webkit-scrollbar {
            display: none; /* for Chrome, Safari, and Opera */
          }
        `,
        ...props,
        children
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ScrollButtons, {
        showLeftButton: isLeftScrollVisible,
        showRightButton: isRightScrollVisible,
        onScrollLeft: scrollLeft,
        onScrollRight: scrollRight
      })
    ]
  });
};
var Table = ({ children, ...props }) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react63.Table, {
    ...props,
    children
  });
};
var Thead = ({ children, ...props }) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react63.Thead, {
    background: "gray.100",
    fontWeight: 500,
    textTransform: "none",
    ...props,
    children
  });
};
var Tbody = ({ children, ...props }) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react63.Tbody, {
    ...props,
    children
  });
};
var Tfoot = ({ children, ...props }) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react63.Tfoot, {
    height: 14,
    fontWeight: 400,
    ...props,
    children
  });
};
var Tr = ({ children, ...props }) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react63.Tr, {
    ...props,
    children
  });
};
var Th = ({ children, ...props }) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react63.Th, {
    color: "gray.600",
    fontSize: "md",
    fontWeight: "inherit",
    borderColor: "gray.200",
    background: "inherit",
    textTransform: "inherit",
    height: 12,
    ...props,
    children
  });
};
var Td = ({ children, ...props }) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react63.Td, {
    fontSize: "md",
    fontWeight: 400,
    color: "gray.700",
    borderColor: "gray.200",
    height: 14,
    ...props,
    children
  });
};

// src/components/AttributeChecklist/AttributeChecklist.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var getSelectedValue = (row) => {
  if (row.yes === true) {
    return true;
  }
  if (row.no === true) {
    return false;
  }
  return null;
};
var exteriorBorder = {
  border: "1px solid",
  borderColor: "gray.200",
  borderRadius: "6px",
  sx: {
    "tbody > tr:last-child > td": {
      borderBottom: 0,
      borderBottomColor: "gray.200"
    }
  }
};
var AttributeChecklist = ({
  id,
  prefix,
  value,
  onChange,
  isReadOnly
}) => {
  const { t } = useAuraTranslation_default();
  const type = "checklist";
  const attributeId = getAttributeId(id, type, prefix);
  const isSm = (0, import_react67.useBreakpointValue)({
    base: true,
    md: false
  });
  let initialCheckboxState = {};
  let initialCommentState = {};
  value == null ? void 0 : value.forEach((element) => {
    initialCheckboxState[element.id.toString()] = {
      yes: element.selected === true,
      no: element.selected === false
    };
    initialCommentState[element.id.toString()] = element.comment;
  });
  const [checkboxState, setCheckboxState] = (0, import_react68.useState)(initialCheckboxState);
  const [commentState, setCommentState] = (0, import_react68.useState)(initialCommentState);
  const handleAddComment = (positionId, newValue) => {
    const rowId = positionId.toString();
    setCommentState((prevState) => ({
      ...prevState,
      [rowId]: newValue
    }));
    onChange({
      id: positionId,
      comment: newValue ?? "",
      selected: getSelectedValue(checkboxState[rowId])
    });
  };
  const handleChangeCheckbox = (positionId, newValue, name) => {
    const rowId = positionId.toString();
    if (name === "yes" && newValue) {
      setCheckboxState((prevState) => ({
        ...prevState,
        [rowId]: { yes: true, no: false }
      }));
      onChange({
        id: positionId,
        comment: commentState[rowId] ?? "",
        selected: true
      });
    }
    if (name === "no" && newValue) {
      setCheckboxState((prevState) => ({
        ...prevState,
        [rowId]: { yes: false, no: true }
      }));
      onChange({
        id: positionId,
        comment: commentState[rowId] ?? "",
        selected: false
      });
    }
    if (!newValue) {
      setCheckboxState((prevState) => ({
        ...prevState,
        [rowId]: { yes: false, no: false }
      }));
      onChange({
        id: positionId,
        comment: commentState[rowId] ?? "",
        selected: null
      });
    }
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react67.Box, {
    ...id && {
      id: `${attributeId}`
    },
    className: getAttributeClass(type),
    children: isSm ? /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react67.Stack, {
      className: "attribute-checklist__list",
      ...exteriorBorder,
      spacing: "0",
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react67.Box, {
          h: "44px",
          w: "full",
          bg: "gray.100"
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react67.Accordion, {
          allowMultiple: true,
          reduceMotion: true,
          children: value == null ? void 0 : value.map((row) => {
            const rowId = row.id.toString();
            return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react67.AccordionItem, {
              className: "attribute-checklist__list-row",
              letterSpacing: "0.5px",
              children: ({ isExpanded }) => /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
                children: [
                  /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react67.AccordionButton, {
                    justifyContent: "space-between",
                    p: "0",
                    _expanded: { bg: "gray.50" },
                    children: [
                      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react67.Text, {
                        px: "24px",
                        py: "16px",
                        textAlign: "left",
                        letterSpacing: "0.5px",
                        children: t(row.value)
                      }),
                      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react67.AccordionIcon, {
                        mr: "8px"
                      })
                    ]
                  }),
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react67.AccordionPanel, {
                    p: "0",
                    children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react67.Stack, {
                      spacing: "0",
                      children: [
                        /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react67.Stack, {
                          className: "attribute-checklist__list-row__yes",
                          isInline: true,
                          w: "full",
                          justifyContent: "space-between",
                          children: [
                            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react67.Text, {
                              px: "24px",
                              py: "16px",
                              fontWeight: 500,
                              children: t("YES")
                            }),
                            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react67.Checkbox, {
                              "aria-label": `attribute-checklist-${row.id}-yes`,
                              size: "lg",
                              isDisabled: isReadOnly,
                              isChecked: checkboxState[rowId].yes,
                              onChange: (e) => handleChangeCheckbox(
                                row.id,
                                e.target.checked,
                                "yes"
                              ),
                              px: "24px"
                            })
                          ]
                        }),
                        /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react67.Stack, {
                          className: "attribute-checklist__list-row__no",
                          isInline: true,
                          justifyContent: "space-between",
                          children: [
                            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react67.Text, {
                              px: "24px",
                              py: "16px",
                              fontWeight: 500,
                              children: t("NO")
                            }),
                            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react67.Checkbox, {
                              "aria-label": `attribute-checklist-${row.id}-no`,
                              size: "lg",
                              placeholder: t("COMMENTS"),
                              isDisabled: isReadOnly,
                              isChecked: checkboxState[rowId].no,
                              onChange: (e) => handleChangeCheckbox(
                                row.id,
                                e.target.checked,
                                "no"
                              ),
                              px: "24px"
                            })
                          ]
                        }),
                        (!isReadOnly || row.comment) && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react67.Box, {
                          className: "attribute-checklist__list-row__textarea",
                          px: "24px",
                          py: "8px",
                          children: isExpanded && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AttributeText_default, {
                            "aria-label": `attribute-checklist-${row.id}-comment`,
                            placeholder: t("COMMENTS"),
                            isReadOnly,
                            onBlur: (event) => event.target.value !== commentState[row.id] && handleAddComment(row.id, event.target.value),
                            defaultValue: commentState[rowId],
                            letterSpacing: "0.5px"
                          })
                        })
                      ]
                    })
                  })
                ]
              })
            }, row.id);
          })
        })
      ]
    }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react67.TableContainer, {
      className: "attribute-checklist__table",
      ...exteriorBorder,
      whiteSpace: "initial",
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Table, {
        variant: "simple",
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Thead, {
            children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Tr, {
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Th, {}),
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Th, {
                  children: t("YES")
                }),
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Th, {
                  children: t("NO")
                }),
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Th, {
                  minW: "250px",
                  children: t("COMMENTS")
                })
              ]
            })
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Tbody, {
            children: value == null ? void 0 : value.map((row) => {
              const rowId = row.id.toString();
              return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Tr, {
                className: "attribute-checklist__table-row",
                children: [
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Td, {
                    letterSpacing: "0.5px",
                    verticalAlign: "baseline",
                    children: t(row.value)
                  }),
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Td, {
                    className: "attribute-checklist__table-row__yes",
                    verticalAlign: "baseline",
                    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react67.Checkbox, {
                      "aria-label": `attribute-checklist-${row.id}-yes`,
                      size: "lg",
                      isDisabled: isReadOnly,
                      isChecked: checkboxState[rowId].yes,
                      onChange: (e) => handleChangeCheckbox(row.id, e.target.checked, "yes")
                    })
                  }),
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Td, {
                    className: "attribute-checklist__table-row__no",
                    verticalAlign: "baseline",
                    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react67.Checkbox, {
                      "aria-label": `attribute-checklist-${row.id}-no`,
                      size: "lg",
                      isDisabled: isReadOnly,
                      isChecked: checkboxState[rowId].no,
                      onChange: (e) => handleChangeCheckbox(row.id, e.target.checked, "no")
                    })
                  }),
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Td, {
                    className: "attribute-checklist__table-row__textarea",
                    py: "8px",
                    children: (!isReadOnly || row.comment) && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AttributeText_default, {
                      "aria-label": `attribute-checklist-${row.id}-comment`,
                      isReadOnly,
                      onBlur: (event) => event.target.value !== commentState[row.id] && handleAddComment(row.id, event.target.value),
                      minH: "full",
                      defaultValue: commentState[rowId],
                      letterSpacing: "0.5px"
                    })
                  })
                ]
              }, row.id);
            })
          })
        ]
      })
    })
  });
};
var AttributeChecklist_default = AttributeChecklist;

// src/components/AttributeDate/AttributeDate.tsx
var import_react72 = require("@chakra-ui/react");
var import_js11 = require("@mdi/js");
var import_react73 = __toESM(require("@mdi/react"));
var import_react74 = __toESM(require("react"));
var import_react_datepicker = __toESM(require("react-datepicker"));

// src/components/AuraInput/AuraInput.tsx
var import_react69 = require("@chakra-ui/react");
var import_react70 = __toESM(require("@mdi/react"));
var import_react71 = __toESM(require("react"));
var import_jsx_runtime = require("react/jsx-runtime");
var AuraInput = import_react71.default.forwardRef(
  ({ isReadOnly = false, children, ...props }, ref) => {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react69.Input, {
      ref,
      isReadOnly,
      isDisabled: isReadOnly,
      ...baseInputStyle,
      ...props
    });
  }
);
var AuraInputCompact = import_react71.default.forwardRef(
  ({
    isReadOnly = false,
    leftIcon,
    isLoading,
    ...props
  }, ref) => {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react69.InputGroup, {
      children: [
        leftIcon && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react69.InputLeftElement, {
          pointerEvents: "none",
          color: "gray.300",
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react70.default, {
            size: "24px",
            path: leftIcon
          })
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react69.Input, {
          ref,
          isReadOnly,
          isDisabled: isReadOnly,
          ...baseInputStyle,
          ...props
        }),
        isLoading && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react69.InputRightElement, {
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react69.Spinner, {
            size: "md",
            color: "gray.400"
          })
        })
      ]
    });
  }
);
var baseInputStyle = {
  _readOnly: {
    bgColor: "gray.50",
    borderColor: "gray.100",
    _focus: { borderColor: "gray.100" },
    _hover: { cursor: "default" }
  },
  _disabled: {
    bgColor: "gray.50",
    borderColor: "gray.100",
    _focus: { borderColor: "gray.100" },
    _hover: { cursor: "default" }
  },
  _invalid: {
    borderColor: "red.500",
    borderWidth: "2px",
    _focus: { borderColor: "red.500", boxShadow: "0 0 0 1px #E53E3E" },
    boxShadow: "0 0 0 1px #E53E3E"
  },
  borderRadius: "6px"
};
var AuraInput_default = AuraInput;

// src/components/AttributeDate/AttributeDate.tsx
var import_debounce2 = __toESM(require("lodash/debounce"));
var import_jsx_runtime = require("react/jsx-runtime");
var getDefaultDateFormat = (withTime) => {
  return withTime ? DATETIME_FORMAT_DOTS : DATE_FORMAT_DOTS;
};
var AttributeDate = ({
  id,
  prefix,
  value,
  onChange,
  withTime,
  isLoading,
  isReadOnly,
  leftIconPlaceholder,
  ...props
}) => {
  const { t } = useAuraTranslation_default();
  const { currentLocale } = (0, import_react74.useContext)(LanguageContext);
  const type = withTime ? "datetime" : "date";
  const attributeId = getAttributeId(id, type, prefix);
  const dateFormatCurrent = props.dateFormat ?? getDefaultDateFormat(withTime);
  const dateValue = (0, import_react74.useMemo)(() => {
    if (!value)
      return null;
    const parsedDate = value instanceof Date ? value : new Date(value);
    return !isNaN(parsedDate.getTime()) ? parsedDate : null;
  }, [value]);
  const isDisabled = props.disabled || isReadOnly || isLoading;
  const [allowUpdate, setAllowUpdate] = (0, import_react74.useState)(true);
  const prevDateValue = (0, import_react74.useRef)(dateValue);
  const handleCalendarClose = (0, import_debounce2.default)(
    () => {
      var _a2;
      if (allowUpdate) {
        (_a2 = props == null ? void 0 : props.onCalendarClose) == null ? void 0 : _a2.call(props);
        setAllowUpdate(false);
      }
    },
    300,
    {
      leading: true
    }
  );
  (0, import_react74.useEffect)(() => {
    if (prevDateValue.current !== dateValue) {
      setAllowUpdate(true);
      prevDateValue.current = dateValue;
    }
  }, [dateValue]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_datepicker.default, {
    ...id && {
      id: `${attributeId}`
    },
    className: getAttributeClass(type),
    selected: dateValue,
    popperPlacement: "bottom",
    popperModifiers: [
      {
        name: "preventOverflow",
        options: {
          rootBoundary: "viewport",
          tether: true,
          padding: { right: withTime ? 85 : 0 }
        }
      }
    ],
    popperProps: { strategy: "fixed" },
    minDate: props.minDate,
    maxDate: props.maxDate,
    todayButton: t("TODAY"),
    locale: currentLocale,
    showTimeSelect: withTime,
    showYearDropdown: true,
    dateFormat: dateFormatCurrent,
    timeCaption: t("TIME"),
    onChange,
    onBlur: handleCalendarClose,
    disabled: isDisabled,
    customInput: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CustomInput, {
      loadingLabel: t("LOADING"),
      isDisabled,
      isLoading,
      leftIconPlaceholder: leftIconPlaceholder && t(leftIconPlaceholder)
    }),
    ...props,
    onCalendarClose: handleCalendarClose
  });
};
var CustomInput = import_react74.default.forwardRef(
  ({
    isDisabled,
    isLoading,
    loadingLabel,
    size = "md",
    leftIconPlaceholder,
    ...props
  }, ref) => {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react72.InputGroup, {
      className: "attribute-date",
      position: "relative",
      zIndex: 0,
      size,
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react72.InputLeftElement, {
          className: "attribute-date__icon",
          pointerEvents: "none",
          zIndex: 2,
          color: "gray.300",
          pl: 4,
          children: leftIconPlaceholder ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react72.Text, {
            children: leftIconPlaceholder
          }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react73.default, {
            path: import_js11.mdiCalendarBlankOutline,
            size: "24px"
          })
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraInput_default, {
          isDisabled,
          _disabled: {
            bgColor: "gray.50",
            borderColor: "gray.100"
          },
          type: "text",
          ref,
          pl: 12,
          ...props
        }),
        isLoading && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react72.InputRightElement, {
          className: "attribute-date__loader",
          title: loadingLabel,
          pointerEvents: "none",
          zIndex: 2,
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react72.IconButton, {
            "aria-label": "loading",
            as: "div",
            variant: "ghost",
            isLoading: true
          })
        })
      ]
    });
  }
);
CustomInput.displayName = "CustomInput";
var AttributeDate_default = AttributeDate;

// src/components/AttributeChat/AttributeChat.tsx
var import_react96 = require("react");
var import_react97 = require("@chakra-ui/react");

// src/components/MessageItem/MessageItem.tsx
var import_react93 = require("@chakra-ui/react");
var import_js17 = require("@mdi/js");
var import_react94 = __toESM(require("@mdi/react"));
var import_date_fns8 = require("date-fns");
var import_react95 = require("react");

// src/components/MessageItem/MessageAttachments/MessageAttachments.tsx
var import_react91 = require("@chakra-ui/react");
var import_js16 = require("@mdi/js");
var import_react92 = __toESM(require("@mdi/react"));
var import_filesize2 = __toESM(require("filesize"));

// src/components/AttributeFile/AttributeFile.tsx
var import_react77 = require("@chakra-ui/react");
var import_isEmpty7 = __toESM(require("lodash/isEmpty"));

// src/components/AttributeFile/EmptyFiles/EmptyFiles.tsx
var import_react75 = require("@chakra-ui/react");
var import_react76 = __toESM(require("@mdi/react"));
var import_js12 = require("@mdi/js");
var import_jsx_runtime = require("react/jsx-runtime");
var EmptyFiles = ({ ...props }) => {
  const { t } = useAuraTranslation_default();
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react75.Flex, {
    color: "gray.300",
    alignItems: "center",
    gap: "17px",
    p: "16px",
    ...props,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react75.Box, {
        boxSize: "40px",
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react76.default, {
          size: "100%",
          path: import_js12.mdiFileSearch
        })
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react75.Text, {
        color: "gray.400",
        children: t("ATTRIBUTE_FILE_EMPTY")
      })
    ]
  });
};

// src/components/AttributeFile/AttributeFile.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var AttributeFile = ({
  id,
  prefix,
  children,
  onFileDelete,
  ...props
}) => {
  const type = "file";
  const attributeId = getAttributeId(id, type, prefix);
  if (!(0, import_isEmpty7.default)(children)) {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react77.VStack, {
      ...id && {
        id: `${attributeId}`
      },
      className: getAttributeClass(type),
      spacing: 0,
      w: "full",
      ...props,
      children
    });
  } else {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(EmptyFiles, {
      ...id && {
        id: `${attributeId}`
      },
      className: getAttributeClass(type)
    });
  }
};
var AttributeFile_default = AttributeFile;

// src/components/AttributeFile/AttributeFileItem/AttributeFileItem.tsx
var import_react89 = require("@chakra-ui/react");
var import_js15 = require("@mdi/js");
var import_react90 = __toESM(require("@mdi/react"));
var import_filesize = __toESM(require("filesize"));
var import_react_truncate_string = __toESM(require("react-truncate-string"));

// src/components/AuraDropdownMenu/AuraDropdownMenu.tsx
var import_react79 = require("@chakra-ui/react");
var import_react80 = __toESM(require("@mdi/react"));
var import_react81 = __toESM(require("react"));

// src/components/AuraMenuItem/AuraMenuItem.tsx
var import_react78 = require("@chakra-ui/react");
var import_jsx_runtime = require("react/jsx-runtime");
var AuraMenuItem = (0, import_react78.forwardRef)((props, ref) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react78.MenuItem, {
    ref,
    iconSpacing: 2,
    sx: {
      "& .chakra-menu__icon-wrapper": {
        color: "gray.500"
      }
    },
    px: 6,
    fontSize: "md",
    h: "40px",
    ...props
  });
});
var AuraMenuItem_default = AuraMenuItem;

// src/components/AuraDropdownMenu/AuraDropdownMenu.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var AuraDropdownMenu = ({
  children,
  menuItems,
  ...props
}) => {
  if (!menuItems) {
    return null;
  }
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react79.Menu, {
    ...props,
    children: [
      children,
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react79.MenuList, {
        py: 3,
        children: menuItems.map((item, index) => {
          const {
            className,
            customElement,
            icon,
            label,
            onClick,
            ...itemProps
          } = item;
          if (customElement) {
            return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react81.default.Fragment, {
              children: customElement
            }, index);
          }
          if (icon) {
            return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraMenuItem_default, {
              icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react80.default, {
                path: icon,
                size: "24px"
              }),
              onClick,
              ...itemProps,
              children: label
            }, index);
          }
          return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraMenuItem_default, {
            onClick,
            className,
            ...itemProps,
            children: label
          }, index);
        })
      })
    ]
  });
};
var AuraDropdownMenu_default = AuraDropdownMenu;

// src/components/MoreIconButton/MoreIconButton.tsx
var import_react82 = require("@chakra-ui/react");
var import_js13 = require("@mdi/js");
var import_react83 = __toESM(require("react"));
var import_react84 = __toESM(require("@mdi/react"));
var import_jsx_runtime = require("react/jsx-runtime");
var MoreIconButton = import_react83.default.forwardRef(
  (props, ref) => {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react82.IconButton, {
      ref,
      variant: "ghost",
      size: "md",
      fontSize: "28px",
      icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react84.default, {
        path: import_js13.mdiDotsVertical,
        size: "28px"
      }),
      ...props
    });
  }
);
var MoreIconButton_default = MoreIconButton;

// src/components/AttributeFile/AttributeFileItem/FilePreview/FilePreview.tsx
var import_react85 = require("@chakra-ui/react");
var import_js14 = require("@mdi/js");
var import_react86 = __toESM(require("@mdi/react"));
var import_react87 = require("react");
var import_react88 = require("@chakra-ui/react");
var import_react_image_lightbox = __toESM(require("react-image-lightbox"));
var import_jsx_runtime = require("react/jsx-runtime");
var FilePreview = ({ file, files }) => {
  var _a2, _b;
  const [imageLoaded, setImageLoaded] = (0, import_react87.useState)(false);
  const { isOpen, onClose, onOpen } = (0, import_react85.useDisclosure)();
  const { id, mimeType, dbName, fileName, uris } = file;
  const [index, setIndex] = (0, import_react87.useState)(0);
  const imageFiles = files == null ? void 0 : files.filter(
    (file2) => file2.mimeType.startsWith("image/")
  );
  const lightBoxExtended = files && {
    prevSrc: (_a2 = imageFiles[(index + imageFiles.length - 1) % imageFiles.length]) == null ? void 0 : _a2.uris.show,
    nextSrc: (_b = imageFiles[(index + 1) % imageFiles.length]) == null ? void 0 : _b.uris.show,
    onMovePrevRequest: () => {
      setIndex((index + imageFiles.length - 1) % imageFiles.length);
    },
    onMoveNextRequest: () => {
      setIndex((index + 1) % imageFiles.length);
    }
  };
  const actualFileIndex = imageFiles == null ? void 0 : imageFiles.findIndex((file2) => (file2 == null ? void 0 : file2.id) === id);
  if (isImage(mimeType)) {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react88.Image, {
          border: "1px solid",
          borderColor: "gray.200",
          borderRadius: "4px",
          src: process.env.NODE_ENV !== "production" ? getImageUrl(dbName, "thmb") : uris.show,
          alt: fileName,
          style: {
            height: "100%",
            objectFit: "cover",
            display: imageLoaded ? "block" : "none"
          },
          onLoad: () => setImageLoaded(true),
          onClick: () => {
            onOpen();
          }
        }),
        isOpen && imageLoaded ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_image_lightbox.default, {
          imageTitle: imageFiles[index].fileName,
          onCloseRequest: onClose,
          mainSrc: imageFiles[index].uris.show,
          onAfterOpen: () => setIndex(actualFileIndex),
          reactModalStyle: {
            overlay: {
              zIndex: 1801
            }
          },
          ...imageFiles.length > 1 && lightBoxExtended
        }) : null,
        !imageLoaded ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react86.default, {
          size: "100%",
          path: import_js14.mdiFile
        }) : null
      ]
    });
  } else {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react86.default, {
      size: "100%",
      path: import_js14.mdiFile
    });
  }
};

// src/components/AttributeFile/AttributeFileItem/AttributeFileItem.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var gridTemplateSmall = `"date date date"
"preview details actions"`;
var gridTemplateLarge = `"preview date actions"
"preview details actions"`;
var AttributeFileItem = ({
  file,
  files,
  onDelete,
  isReadOnly = false
}) => {
  const { t } = useAuraTranslation_default();
  const isLg = (0, import_react89.useBreakpointValue)({ base: false, lg: true });
  const attributeDownload = {
    customElement: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraMenuItem_default, {
      as: "a",
      download: true,
      icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react90.default, {
        path: import_js15.mdiFileDownloadOutline,
        size: "24px"
      }),
      href: file.uris.get,
      children: t("ATTRIBUTE_FILE_DOWNLOAD")
    })
  };
  const attributeDelete = {
    label: t("ATTRIBUTE_FILE_DELETE"),
    icon: import_js15.mdiTrashCanOutline,
    onClick: () => onDelete == null ? void 0 : onDelete(file.id)
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react89.SimpleGrid, {
    gridTemplate: {
      base: gridTemplateSmall,
      lg: gridTemplateLarge
    },
    className: "attribute-file",
    w: "full",
    gridRowGap: { base: 3, lg: 2 },
    gridColumnGap: 4,
    gridAutoColumns: "auto 1fr auto",
    py: 3,
    px: 2,
    paddingInlineEnd: 0,
    borderBottom: "1px solid",
    borderColor: "gray.200",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react89.Box, {
        className: "attribute-file__date",
        gridArea: "date",
        lineHeight: "20px",
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(DateTag_default, {
          value: file.createdDate
        })
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react89.Box, {
        className: "attribute-file__preview",
        gridArea: "preview",
        color: "gray.300",
        boxSize: { base: 12, lg: 20 },
        ...file.mimeType.startsWith("image/") && { cursor: "pointer" },
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FilePreview, {
          file,
          files
        })
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react89.VStack, {
        className: "attribute-file__details",
        spacing: 1,
        gridArea: "details",
        justifyContent: "space-between",
        textAlign: "left",
        minW: 0,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react89.Flex, {
            className: "attribute-file__name",
            w: "full",
            h: 6,
            children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_truncate_string.default, {
              text: file.fileName
            })
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react89.Box, {
            className: "attribute-file__size",
            fontSize: "sm",
            color: "gray.500",
            w: "full",
            lineHeight: "24px",
            children: (0, import_filesize.default)(file.size)
          })
        ]
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react89.Flex, {
        className: "attribute-file__actions",
        gridArea: "actions",
        alignItems: "center",
        children: isLg ? /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react89.ButtonGroup, {
          color: "gray.700",
          spacing: 2,
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react89.IconButton, {
              "aria-label": t("ATTRIBUTE_FILE_DOWNLOAD"),
              icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react90.default, {
                size: "24px",
                path: import_js15.mdiFileDownloadOutline
              }),
              as: "a",
              color: "gray.700",
              download: true,
              href: file.uris.get
            }),
            !isReadOnly && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react89.IconButton, {
              "aria-label": t("ATTRIBUTE_FILE_DELETE"),
              icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react90.default, {
                size: "24px",
                path: import_js15.mdiTrashCanOutline
              }),
              onClick: () => onDelete == null ? void 0 : onDelete(file.id)
            })
          ]
        }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraDropdownMenu_default, {
          menuItems: isReadOnly ? [attributeDownload] : [attributeDownload, attributeDelete],
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react89.MenuButton, {
            bg: "gray.100",
            color: "gray.700",
            as: MoreIconButton_default,
            "aria-label": t("ATTRIBUTE_FILE_ACTIONS")
          })
        })
      })
    ]
  });
};
var AttributeFileItem_default = AttributeFileItem;

// src/components/AttributeFile/utils.ts
var import_api12 = require("@questy/api");
var transformApiResponse = import_api12.FileSchema.partial().transform((file) => ({
  id: file.id,
  fileName: file.fileName,
  dbName: file.dbName,
  mimeType: file.mimeType,
  size: file.fileSize,
  createdDate: new Date(file.dateCreate),
  uris: {
    get: file.uris.get,
    show: file.uris.show
  }
}));

// src/components/MessageItem/MessageAttachments/MessageAttachments.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var MessageAttachments = ({ files }) => {
  const { t } = useAuraTranslation_default();
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react91.VStack, {
    className: "message-attachments-list",
    w: "full",
    py: 3,
    pl: 2,
    overflow: "hidden",
    children: files == null ? void 0 : files.map((file) => /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react91.HStack, {
      w: "full",
      spacing: 3,
      alignSelf: "stretch",
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react91.Center, {
          className: "message-attachments-list__preview",
          color: "gray.300",
          w: "48px",
          minW: "48px",
          h: "48px",
          ...file.mimeType.startsWith("image/") && { cursor: "pointer" },
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FilePreview, {
            file,
            files
          })
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react91.VStack, {
          className: "message-attachments-list__details",
          spacing: 1,
          justifyContent: "space-between",
          textAlign: "left",
          w: "full",
          mb: 2,
          overflow: "hidden",
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react91.Text, {
              textAlign: "left",
              isTruncated: true,
              noOfLines: 1,
              lineHeight: "24px",
              letterSpacing: "0.5px",
              color: "crmBlue",
              w: "full",
              children: file.fileName
            }),
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react91.Box, {
              className: "message-attachments-list__size",
              fontSize: "sm",
              color: "gray.500",
              w: "full",
              lineHeight: "24px",
              children: (0, import_filesize2.default)(file.size ?? (file == null ? void 0 : file.fileSize))
            })
          ]
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react91.IconButton, {
          "aria-label": t("ATTRIBUTE_FILE_DOWNLOAD"),
          icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react92.default, {
            size: "24px",
            path: import_js16.mdiFileDownloadOutline
          }),
          as: "a",
          color: "gray.700",
          download: true,
          href: file.uris.get,
          mb: 0
        })
      ]
    }))
  });
};
var MessageAttachments_default = MessageAttachments;

// src/components/MessageItem/MessageItem.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var MessageItem = ({
  username,
  avatarUrl,
  title,
  content,
  createdDate,
  users,
  onClick,
  disableContentLimit = false,
  variant = "base",
  showAvatar = true,
  files,
  userDefaultCallendarColor,
  ...props
}) => {
  const [isOpen, setIsOpen] = (0, import_react95.useState)(false);
  const toggleIsOpen = () => setIsOpen(!isOpen);
  const avatarBaseProps = {
    name: username,
    src: avatarUrl,
    ...userDefaultCallendarColor ? { bgColor: userDefaultCallendarColor } : {}
  };
  const forMessageThread = variant === "messageThread";
  const usersLabel = forMessageThread ? `${showAvatar ? users + ", " : ""}${createdDate ? (0, import_date_fns8.format)(createdDate, HOUR_MINUTE_FORMAT) : ""}` : users;
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react93.HStack, {
    className: "message-item",
    spacing: 0,
    alignItems: "flex-start",
    ...props,
    ...onClick ? { as: "button", onClick, textAlign: "left", w: "full" } : {},
    children: [
      showAvatar && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react93.Flex, {
        display: { base: "none", lg: "flex" },
        className: "message-item__avatar-container",
        w: "44px",
        justifyContent: "flex-start",
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react93.Avatar, {
          ...avatarBaseProps,
          className: "message-item__avatar-aside",
          size: "sm",
          mt: forMessageThread ? 0 : "34px"
        })
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react93.Stack, {
        className: "message-item__content",
        minH: forMessageThread ? "auto" : "104px",
        boxShadow: "0px 0.5px 4px rgba(0, 0, 0, 0.1), 0px 2px 2px rgba(0, 0, 0, 0.06);",
        direction: "column",
        flex: 1,
        px: 4,
        py: 3,
        borderRadius: "6px",
        spacing: 2,
        overflow: "hidden",
        children: [
          !forMessageThread && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react93.Box, {
            lineHeight: "20px",
            maxH: "20px",
            children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(DateTag_default, {
              value: createdDate,
              className: "message-item__time-badge"
            })
          }),
          (showAvatar || usersLabel) && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react93.Stack, {
            isInline: true,
            align: "center",
            spacing: 0,
            children: [
              showAvatar && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react93.Avatar, {
                ...avatarBaseProps,
                className: "message-item__avatar",
                display: { base: "flex", lg: "none" },
                size: "sm",
                mr: forMessageThread ? 2 : 4,
                ml: forMessageThread ? 0 : 2
              }),
              usersLabel && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react93.Text, {
                className: "message-item__users",
                as: "span",
                fontSize: "sm",
                lineHeight: "20px",
                letterSpacing: "0.25px",
                fontWeight: 400,
                color: "gray.500",
                noOfLines: 1,
                children: usersLabel
              })
            ]
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react93.Stack, {
            direction: "column",
            spacing: 1,
            children: [
              title ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react93.Text, {
                className: "message-item__title",
                fontWeight: 400,
                fontSize: "md",
                lineHeight: "24px",
                letterSpacing: "0.5px",
                color: "gray.800",
                noOfLines: 1,
                children: title
              }) : null,
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Linkify_default, {
                children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react93.Text, {
                  className: "message-item__text",
                  fontWeight: 400,
                  fontSize: "md",
                  lineHeight: "24px",
                  letterSpacing: "0.5px",
                  color: "gray.600",
                  wordBreak: "break-word",
                  whiteSpace: "pre-line",
                  ...disableContentLimit ? {} : { noOfLines: 2 },
                  children: content
                })
              }),
              (files == null ? void 0 : files.length) && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react93.VStack, {
                className: "message-item__attachments-show",
                children: [
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react93.HStack, {
                    w: "full",
                    justifyContent: "flex-end",
                    children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react93.Center, {
                      position: "relative",
                      children: [
                        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react93.IconButton, {
                          boxSize: "40px",
                          icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react94.default, {
                            path: import_js17.mdiPaperclip,
                            size: "24px"
                          }),
                          "aria-label": "show attachments",
                          onClick: toggleIsOpen,
                          bgColor: isOpen ? "gray.300" : "gray.100"
                        }),
                        (files == null ? void 0 : files.length) > 0 && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CountBadge_default, {
                          value: files == null ? void 0 : files.length,
                          position: "absolute",
                          left: "-3px",
                          top: "-3px",
                          "data-testid": "files-count",
                          bgColor: "gray.500"
                        })
                      ]
                    })
                  }),
                  isOpen && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(MessageAttachments_default, {
                    files
                  })
                ]
              })
            ]
          })
        ]
      })
    ]
  });
};
var MessageItem_default = MessageItem;

// src/components/AttributeChat/AttributeChat.tsx
var import_react98 = __toESM(require("@mdi/react"));
var import_js18 = require("@mdi/js");
var import_orderBy2 = __toESM(require("lodash/orderBy"));
var import_react_textarea_autosize2 = __toESM(require("react-textarea-autosize"));
var import_jsx_runtime = require("react/jsx-runtime");
var InputBox = ({
  messageText,
  handleMessageText,
  isLoading,
  handleSendAction
}) => {
  const { t } = useAuraTranslation_default();
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react97.Flex, {
    width: "100%",
    flexDir: "row",
    alignItems: "flex-end",
    className: "attribute-chat__input-box",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_textarea_autosize2.default, {
        style: {
          width: "100%",
          padding: "0.5rem",
          border: "1px solid",
          borderRadius: "6px",
          borderColor: "inherit",
          outlineColor: "#3182ce"
        },
        rows: 1,
        minRows: 1,
        maxRows: 10,
        value: messageText,
        onChange: handleMessageText,
        placeholder: t("ATTRIBUTE_CHAT_TYPE_MESSAGE"),
        disabled: isLoading
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react97.IconButton, {
        w: "40px",
        h: "40px",
        ml: "8px",
        isLoading,
        onClick: handleSendAction,
        "aria-label": "Send message",
        icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react98.default, {
          path: import_js18.mdiSend,
          size: "20px"
        })
      })
    ]
  });
};
var AttributeChat = ({
  id,
  value,
  onChange,
  isReadOnly = true,
  isLoading = false,
  maxHeight = "616px",
  ...props
}) => {
  const [messageText, setMessageText] = (0, import_react96.useState)("");
  const [isScrollVisible, setIsScrollVisible] = (0, import_react96.useState)(false);
  const containerRef = (0, import_react96.useRef)();
  const type = "chat";
  const attributeId = getAttributeId(id, type);
  const handleMessageText = (e) => setMessageText(e.target.value);
  const handleSendAction = async () => {
    await onChange(messageText);
    setMessageText("");
  };
  const sortedMessages = value && (0, import_orderBy2.default)(value, "createdDate", "asc");
  const displayMessages = sortedMessages == null ? void 0 : sortedMessages.map(
    ({ username, avatarUrl, createdDate, content }, index) => {
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(MessageItem_default, {
        username,
        avatarUrl,
        createdDate,
        content,
        users: username,
        disableContentLimit: true
      }, index);
    }
  );
  const checkScroll = () => {
    const hasScroll = containerRef.current.scrollHeight > containerRef.current.clientHeight;
    setIsScrollVisible(hasScroll);
  };
  (0, import_react96.useEffect)(() => {
    if (containerRef == null ? void 0 : containerRef.current) {
      containerRef.current.scrollTop = containerRef.current.scrollHeight;
      checkScroll();
    }
  }, [value, containerRef]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react97.Stack, {
    spacing: "16px",
    className: getAttributeClass(type),
    ...id && {
      id: `${attributeId}`
    },
    ...props,
    children: [
      (displayMessages == null ? void 0 : displayMessages.length) && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react97.VStack, {
        maxH: maxHeight,
        ref: containerRef,
        overflowY: "auto",
        spacing: "16px",
        align: "stretch",
        pe: isScrollVisible ? "12px" : "2px",
        py: "4px",
        className: "attribute-chat__messages",
        children: displayMessages
      }),
      !isReadOnly && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(InputBox, {
        messageText,
        handleMessageText,
        isLoading,
        handleSendAction
      })
    ]
  });
};
var AttributeChat_default = AttributeChat;

// src/components/AttributeHtml/AttributeHtml.tsx
var import_react99 = require("@chakra-ui/react");
var import_ckeditor4_react = __toESM(require("ckeditor4-react"));
var import_jsx_runtime = require("react/jsx-runtime");
if (process.env.NODE_ENV === "development") {
  import_ckeditor4_react.default.editorUrl = "https://cdn.ckeditor.com/4.11.4/standard-all/ckeditor.js";
} else {
  import_ckeditor4_react.default.editorUrl = "/utils/ckeditor/ckeditor.js";
}
var AttributeHtml = ({
  id,
  prefix,
  value,
  isReadOnly = true,
  language,
  editorConfig = {},
  ...props
}) => {
  const type = "text";
  const attributeId = getAttributeId(id, type, prefix);
  const config = { ...defaultEditorConfig, ...editorConfig };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react99.Box, {
    ...id && {
      id: `${attributeId}`
    },
    className: getAttributeClass(type),
    children: !isReadOnly ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react99.Box, {
      className: "attribute-html__ckeditor__container",
      "data-testid": "ckeditor",
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ckeditor4_react.default, {
        data: value,
        config: {
          ...config,
          defaultLanguage: "pl",
          language
        },
        ...props
      })
    }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react99.Box, {
      className: "attribute-html__content",
      dangerouslySetInnerHTML: {
        __html: value
      }
    })
  });
};
var AttributeHtml_default = AttributeHtml;
var defaultEditorConfig = {
  toolbar: [
    {
      name: "clipboard",
      groups: ["clipboard", "undo"],
      items: [
        "Cut",
        "Copy",
        "Paste",
        "PasteText",
        "PasteFromWord",
        "-",
        "Undo",
        "Redo"
      ]
    },
    {
      name: "editing",
      groups: ["find", "selection", "spellchecker"],
      items: ["Find", "Replace", "-", "SelectAll", "-", "Scayt"]
    },
    { name: "links", items: ["Link", "Unlink", "Anchor"] },
    {
      name: "insert",
      items: [
        "Image",
        "Table",
        "HorizontalRule",
        "Smiley",
        "SpecialChar",
        "PageBreak",
        "Iframe"
      ]
    },
    { name: "document", groups: ["mode"], items: ["Source"] },
    { name: "tools", items: ["Maximize"] },
    "/",
    { name: "styles", items: ["Styles", "Format", "Font", "FontSize"] },
    {
      name: "basicstyles",
      groups: ["basicstyles"],
      items: ["Bold", "Italic", "Underline"]
    },
    {
      name: "paragraph",
      groups: ["list", "indent", "blocks", "align"],
      items: [
        "NumberedList",
        "BulletedList",
        "-",
        "Outdent",
        "Indent",
        "-",
        "Blockquote",
        "-",
        "JustifyLeft",
        "JustifyCenter",
        "JustifyRight",
        "JustifyBlock"
      ]
    },
    { name: "colors", items: ["TextColor", "BGColor"] },
    { name: "others", items: ["-"] }
  ],
  format_tags: "p;h1;h2;h3;pre",
  removeDialogTabs: "image:advanced;link:advanced",
  disableNativeSpellChecker: false,
  scayt_autoStartup: false,
  allowedContent: true,
  extraPlugins: "widget",
  removePlugins: "liststyle,tableselection,tabletools,tableresize,contextmenu,wsc",
  heigh: 800
};

// src/components/AttributeLabel/AttributeLabel.tsx
var import_react101 = __toESM(require("react"));
var import_react102 = require("@chakra-ui/react");
var import_react103 = __toESM(require("@mdi/react"));
var import_js19 = require("@mdi/js");

// src/components/AuraRequiredIndicator/AuraRequiredIndicator.tsx
var import_react100 = require("@chakra-ui/react");
var import_jsx_runtime = require("react/jsx-runtime");
var AuraRequiredIndicator = () => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react100.Text, {
    as: "span",
    ml: "12px",
    textStyle: "bodyInput",
    color: "red.500",
    children: "*"
  });
};
var AuraRequiredIndicator_default = AuraRequiredIndicator;

// src/components/AttributeLabel/AttributeLabel.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var NumberBox = ({
  number,
  ...props
}) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react102.Badge, {
  backgroundColor: "crmBlue",
  borderRadius: "10px",
  fontSize: "sm",
  h: "20px",
  px: "9px",
  fontWeight: 600,
  color: "#ffffff",
  lineHeight: "20px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  className: "attribute-label__box__number",
  ...props,
  children: number
});
var TooltipInformation = ({ content }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react102.Tooltip, {
  hasArrow: true,
  label: content,
  bg: "gray.700",
  color: "#ffffff",
  px: "12px",
  py: "8px",
  fontStyle: "caption",
  borderRadius: "4px",
  fontWeight: 500,
  maxW: "320px",
  className: "attribute-label__tooltip-content",
  children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react102.Flex, {
    className: "attribute-label__tooltip-box",
    boxSize: "20px",
    justifyContent: "center",
    alignItems: "center",
    mr: "16px",
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react103.default, {
      color: "#3182CE",
      size: "20px",
      path: import_js19.mdiInformation,
      className: "attribute-label__tooltip-box__icon"
    })
  })
});
var UploadFilesButton = ({ id, isLoading, onClick }) => {
  const { t } = useAuraTranslation_default();
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(ButtonAction_default, {
    height: {
      base: "40px",
      lg: "32px"
    },
    m: 0,
    mr: "16px",
    cursor: "pointer",
    as: import_react102.FormLabel,
    leftIcon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react103.default, {
      path: import_js19.mdiFilePlusOutline
    }),
    htmlFor: `attribute-label__file-input${id}`,
    isLoading,
    className: "attribute-label__file-input",
    children: [
      t(`${"ADD"}`),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react102.Input, {
        id: `attribute-label__file-input${id}`,
        type: "file",
        hidden: true,
        onChange: onClick,
        multiple: true
      })
    ]
  });
};
var DownloadFilesButton = ({ onClick }) => {
  const { t } = useAuraTranslation_default();
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ButtonAction_default, {
    height: {
      base: "40px",
      lg: "32px"
    },
    m: 0,
    mr: "16px",
    cursor: "pointer",
    as: import_react102.FormLabel,
    leftIcon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react103.default, {
      path: import_js19.mdiTrayArrowDown
    }),
    className: "attribute-label__files-download",
    onClick,
    children: t("FILE_DOWNLOAD_ALL")
  });
};
var baseHeight = {
  base: "40px",
  lg: "32px"
};
var AttributeLabel = ({
  id,
  text,
  numberAlerts,
  tooltipContent,
  buttonContent,
  isEditButton,
  onClick,
  isSaving,
  isError,
  isSuccess,
  isRequired,
  onClickUploadFiles,
  isUploadFilesButton,
  isUploadFilesLoading,
  onClickDownloadAll,
  customTranslation = false,
  noOfLines = 2,
  ...props
}) => {
  const { t, tCustom } = useAuraTranslation_default();
  const [isTruncated, setIsTruncated] = (0, import_react101.useState)(false);
  const textRef = import_react101.default.useRef(null);
  const handleResize = () => {
    if (!textRef.current)
      return;
    const { scrollHeight, clientHeight } = textRef.current;
    setIsTruncated(scrollHeight > clientHeight);
  };
  (0, import_react101.useEffect)(() => {
    handleResize();
    const observer = new MutationObserver(handleResize);
    const parentNode = textRef.current.offsetParent;
    if (parentNode && textRef) {
      observer.observe(parentNode, { attributes: true });
    }
    return () => {
      observer.disconnect();
    };
  }, []);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react102.Stack, {
    className: "attribute-label",
    alignItems: "center",
    flexWrap: "wrap",
    flexDir: "row",
    spacing: 0,
    rowGap: 2,
    ...props,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react102.Flex, {
        alignItems: "center",
        justifySelf: "center",
        className: "attribute-label__box",
        maxW: "full",
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react102.HStack, {
            spacing: "8px",
            mr: "16px",
            maxW: "full",
            children: [
              isTruncated ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react102.Tooltip, {
                hasArrow: true,
                px: "12px",
                py: "8px",
                placement: "bottom-start",
                label: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react102.Text, {
                  noOfLines: 10,
                  children: t(text)
                }),
                openDelay: 500,
                rounded: "4px",
                children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react102.Text, {
                  ref: textRef,
                  textStyle: "subtitleLabel",
                  my: "0",
                  noOfLines,
                  wordBreak: "break-word",
                  children: customTranslation ? tCustom(text) : t(text)
                })
              }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react102.Text, {
                ref: textRef,
                textStyle: "subtitleLabel",
                my: "0",
                noOfLines,
                wordBreak: "break-word",
                children: customTranslation ? tCustom(text) : t(text)
              }),
              numberAlerts && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(NumberBox, {
                number: numberAlerts
              })
            ]
          }),
          tooltipContent && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TooltipInformation, {
            content: t(tooltipContent)
          })
        ]
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react102.Flex, {
        alignItems: "center",
        className: "attribute-label__box",
        mt: "0",
        flexWrap: "wrap",
        rowGap: 2,
        children: [
          buttonContent && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ButtonAction_default, {
            height: baseHeight,
            mr: "16px",
            textStyle: "buttonSmall",
            leftIcon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react103.default, {
              path: import_js19.mdiPlus
            }),
            onClick,
            className: "attribute-label__box__button",
            children: t(buttonContent)
          }),
          isUploadFilesButton && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(UploadFilesButton, {
            id,
            isLoading: isUploadFilesLoading,
            onClick: onClickUploadFiles
          }),
          typeof onClickDownloadAll === "function" && numberAlerts > 1 && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(DownloadFilesButton, {
            onClick: onClickDownloadAll
          }),
          isEditButton && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react102.IconButton, {
            "aria-label": "attribute-label__box__button-edit",
            size: "xs",
            mr: "16px",
            icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react103.default, {
              size: "20px",
              path: import_js19.mdiPencilOutline
            }),
            onClick,
            className: "attribute-label__box__button-edit"
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ActionBadge_default, {
            isLoading: isSaving,
            isError,
            isSuccess,
            noAnimation: true
          })
        ]
      }),
      isRequired && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraRequiredIndicator_default, {})
    ]
  });
};
var AttributeLabel_default = AttributeLabel;

// src/components/AttributeList/AttributeList.tsx
var import_react104 = require("@chakra-ui/react");
var import_xor2 = __toESM(require("lodash/xor"));
var import_debounce3 = __toESM(require("lodash/debounce"));
var import_findIndex = __toESM(require("lodash/findIndex"));
var import_sortBy2 = __toESM(require("lodash/sortBy"));
var import_react105 = require("react");
var import_jsx_runtime = require("react/jsx-runtime");
var AttributeList = ({
  id,
  prefix,
  value,
  options,
  onChange,
  isReadOnly,
  maxVisible = 5,
  toForm,
  ...props
}) => {
  const { t } = useAuraTranslation_default();
  const { isOpen, onToggle } = (0, import_react104.useDisclosure)({ defaultIsOpen: false });
  const [tempValue, setTempValue] = (0, import_react105.useState)(value);
  const type = "listMulti";
  const attributeId = getAttributeId(id, type, prefix);
  const sortedPositions = (0, import_sortBy2.default)(
    options,
    (el2) => -(0, import_findIndex.default)(value, (v) => v === el2.id)
  );
  const visibleItems = sortedPositions.slice(
    0,
    Math.max(maxVisible, value.length)
  );
  const hiddenItems = sortedPositions.slice(Math.max(maxVisible, value.length));
  const hasHiddenItems = hiddenItems.length > 0;
  const debounced = (0, import_react105.useCallback)(
    (0, import_debounce3.default)((value2) => {
      onChange(value2);
    }, 650),
    []
  );
  const handleOnChange = (value2) => {
    if (toForm) {
      onChange(value2);
    } else {
      setTempValue(value2 == null ? void 0 : value2.map((i) => Number(i)));
      debounced(value2);
    }
  };
  const displayValue = (0, import_react105.useMemo)(
    () => toForm ? value : (0, import_xor2.default)(value, tempValue) ? tempValue : value,
    [value, tempValue]
  );
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react104.CheckboxGroup, {
    value: displayValue,
    onChange: handleOnChange,
    ...props,
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react104.Box, {
      ...id && {
        id: `${attributeId}`
      },
      className: getAttributeClass(type),
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react104.Stack, {
          spacing: 4,
          fontSize: "md",
          fontWeight: 400,
          lineHeight: "24px",
          sx: {
            ".attribute-list__checkbox :nth-child(2)": {
              width: "20px",
              height: "20px"
            }
          },
          children: hasHiddenItems ? /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
            children: [
              visibleItems == null ? void 0 : visibleItems.map((option) => {
                return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react104.Checkbox, {
                  id: `${attributeId}-${option.id}`,
                  value: option.id,
                  isDisabled: isReadOnly,
                  className: "attribute-list__checkbox",
                  children: option.label
                }, option.id);
              }),
              isOpen ? hiddenItems == null ? void 0 : hiddenItems.map((option) => {
                return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react104.Checkbox, {
                  id: `${attributeId}-${option.id}`,
                  value: option.id,
                  isDisabled: isReadOnly,
                  className: "attribute-list__checkbox",
                  children: option.label
                }, option.id);
              }) : null
            ]
          }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, {
            children: options == null ? void 0 : options.map((option) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react104.Checkbox, {
              id: `${attributeId}-${option.id}`,
              value: option.id,
              isDisabled: isReadOnly,
              className: "attribute-list__checkbox",
              children: option.label
            }, option.id))
          })
        }),
        hasHiddenItems && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react104.Button, {
          variant: "link",
          fontWeight: 500,
          fontSize: "sm",
          lineHeight: "20px",
          letterSpacing: "0.25px",
          color: "blue.500",
          onClick: onToggle,
          mt: 4,
          children: isOpen ? t("ATTRIBUTE_MULTI_LESS") : `${t("ATTRIBUTE_MULTI_MORE")} (+${hiddenItems.length})`
        })
      ]
    })
  });
};
var AttributeList_default = AttributeList;

// src/components/AttributeNumber/AttributeNumber.tsx
var import_react106 = require("@chakra-ui/react");
var import_num_parse = __toESM(require("num-parse"));
var import_react107 = require("react");
var import_react_query12 = require("react-query");
var import_jsx_runtime = require("react/jsx-runtime");
var validateAttribute = (oldValue, newValue) => {
  if (+oldValue === +newValue) {
    return false;
  }
  return true;
};
var AttributeNumber = ({
  id,
  prefix,
  value,
  onChange,
  isReadOnly
}) => {
  const [attributeValue, setAttributeValue] = (0, import_react107.useState)("");
  const type = "numeric";
  const attributeId = getAttributeId(id, type, prefix);
  (0, import_react107.useEffect)(() => {
    setAttributeValue(
      typeof value !== "undefined" && value !== null ? value : ""
    );
  }, [value]);
  const handleValueChange = ({
    target: { value: value2 }
  }) => {
    setAttributeValue(value2.replace(/[^\d.\,]/g, ""));
  };
  const handleBlur = (e) => {
    const {
      target: { value: inputValue }
    } = e;
    const parsedNumber = (0, import_num_parse.default)(inputValue.replace(",", "."));
    const finalNumber = isNaN(parsedNumber) ? "" : parsedNumber;
    if (validateAttribute(value, finalNumber)) {
      setAttributeValue(finalNumber);
      mutate(finalNumber);
    }
  };
  const { mutate, isLoading, isError, isSuccess } = (0, import_react_query12.useMutation)((newValue) => {
    return onChange(newValue, id);
  });
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react106.InputGroup, {
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react106.Input, {
      className: getAttributeClass(type),
      isDisabled: isReadOnly,
      _disabled: {
        bgColor: "gray.50",
        borderColor: "gray.100"
      },
      pl: 2,
      value: attributeValue,
      ...id && {
        id: `${attributeId}`
      },
      type: "text",
      onBlur: handleBlur,
      onChange: handleValueChange
    })
  });
};
var AttributeNumber_default = AttributeNumber;

// src/components/Attributes/Attributes.tsx
var import_lib2 = require("@questy/lib");
var import_sortBy3 = __toESM(require("lodash/sortBy"));
var import_isEmpty8 = __toESM(require("lodash/isEmpty"));

// src/components/Attributes/AttributeCompany/AttributeCompany.tsx
var import_react109 = require("@chakra-ui/react");
var import_react_query13 = require("react-query");

// src/components/Attributes/AttributesErrorContext.tsx
var import_react108 = require("react");
var import_jsx_runtime = require("react/jsx-runtime");
var AttributesErrorContext = (0, import_react108.createContext)({});
var AttributesErrorProvider = ({
  children,
  value = []
}) => {
  const checkIsAttributeError = (attributeId, type) => {
    var _a2;
    const isInvalid = Array.isArray(value) && !!((_a2 = value == null ? void 0 : value.filter((field) => {
      if ((field == null ? void 0 : field.id) === getAttributeId(attributeId, type)) {
        return true;
      }
    })) == null ? void 0 : _a2.length);
    return isInvalid;
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AttributesErrorContext.Provider, {
    value: { errors: value, checkIsAttributeError },
    children
  });
};
var useAttributeError = (id, type) => {
  const context = (0, import_react108.useContext)(AttributesErrorContext);
  return {
    ...context,
    ...id && type && typeof (context == null ? void 0 : context.checkIsAttributeError) === "function" ? {
      isInvalid: context.checkIsAttributeError(id, type)
    } : {}
  };
};

// src/components/Attributes/AttributeCompany/AttributeCompany.tsx
var import_react_select = require("react-select");
var import_jsx_runtime = require("react/jsx-runtime");
var AttributeCompany = ({
  id,
  name,
  type,
  value,
  options,
  handleChange,
  isReadOnly
}) => {
  const { t } = useAuraTranslation_default();
  const attributeIdHtml = getAttributeId(id, type);
  const attributeValue = buildOptions(value, "value", "id");
  const { isInvalid } = useAttributeError(id, type);
  const updateAttribute = (args) => {
    var _a2;
    if (args.action === "select-option" && args.option.value > 0) {
      return handleChange(args.option.value, id, {
        setting: { mode_relations_add: 1 }
      });
    } else if (args.action === "remove-value" || args.action === "pop-value" && ((_a2 = args.removedValue) == null ? void 0 : _a2.value) > 0) {
      return handleChange(args.removedValue.value, id, {
        setting: { mode_relations_remove: 1 }
      });
    } else {
      throw new Error(
        `Unsupported action ${args == null ? void 0 : args.action} for attribute company`
      );
    }
  };
  const { mutate, isLoading, isError, isSuccess } = (0, import_react_query13.useMutation)((args) => {
    return updateAttribute(args);
  });
  const MultiValueLabel3 = (props) => {
    const { data } = props;
    let url = `/accountCompany/show/company_id/${data.value}`;
    const handleOnClick = () => window.location.assign(url);
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_select.components.MultiValueLabel, {
      ...props,
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react109.Link, {
        href: url,
        onTouchStart: handleOnClick,
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react109.Text, {
          _hover: { textDecoration: "underline", cursor: "pointer" },
          fontWeight: 400,
          children: data.label
        })
      })
    });
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react109.FormControl, {
    isDisabled: isLoading,
    isInvalid: isInvalid || !!isError,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react109.FormLabel, {
        htmlFor: attributeIdHtml,
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AttributeLabel_default, {
          text: name,
          customTranslation: true,
          isSaving: isLoading,
          isError: !!isError && !isLoading,
          isSuccess,
          tooltipContent: options == null ? void 0 : options.tooltip
        })
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSelect_default, {
        inputId: attributeIdHtml,
        className: getAttributeClass(type),
        isClearable: false,
        onChange: (e, args) => mutate(args),
        value: attributeValue,
        noOptionsMessage: () => t("NOTHING_FOUND"),
        placeholder: t("COMPANIES"),
        isMulti: true,
        isReadOnly,
        components: {
          MultiValueLabel: MultiValueLabel3
        },
        isError: isInvalid,
        loadDataProps: {
          endpoint: "account_companies",
          labelField: "displayName",
          autoselect: false,
          settings: {
            fields: "id",
            extra_fields: "displayName",
            "setting[with_relations]": true,
            "order[_q]": "DESC"
          }
        }
      })
    ]
  });
};
var AttributeCompany_default = AttributeCompany;

// src/components/Attributes/AttributeDateField/AttributeDateField.tsx
var import_react110 = require("@chakra-ui/react");
var import_date_fns9 = require("date-fns");
var import_react111 = require("react");
var import_react_query14 = require("react-query");
var import_jsx_runtime = require("react/jsx-runtime");
var AttributeDateField = ({
  id,
  name,
  type,
  value,
  options,
  handleChange,
  isReadOnly
}) => {
  const attributeIdHtml = getAttributeId(id, type);
  const attributeValue = value && new Date(value) || value;
  const [tempValue, setTempValue] = (0, import_react111.useState)(attributeValue);
  const { isInvalid } = useAttributeError(id, type);
  const updateAttribute = (newValue) => {
    const newTime = newValue && new Date(newValue);
    const stringNewTime = newTime && (0, import_date_fns9.format)(newTime, "yyyy-MM-dd HH:mm");
    const actualTime = value && new Date(value);
    const actualTimeString = actualTime && (0, import_date_fns9.format)(actualTime, "yyyy-MM-dd HH:mm");
    if (stringNewTime === actualTimeString)
      return null;
    return handleChange(stringNewTime, id);
  };
  const { mutate, isLoading, isError, isSuccess } = (0, import_react_query14.useMutation)((newValue) => {
    return updateAttribute(newValue);
  });
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react110.FormControl, {
    isDisabled: isLoading,
    isInvalid: isInvalid || !!isError,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react110.FormLabel, {
        htmlFor: attributeIdHtml,
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AttributeLabel_default, {
          text: name,
          customTranslation: true,
          isSaving: isLoading,
          isError: !!isError && !isLoading,
          isSuccess,
          tooltipContent: options == null ? void 0 : options.tooltip
        })
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AttributeDate_default, {
        id,
        withTime: type === "datetime",
        readOnly: isReadOnly,
        value: tempValue,
        onChange: (val) => {
          setTempValue(val && (0, import_date_fns9.format)(val, "yyyy-MM-dd HH:mm"));
        },
        onCalendarClose: () => mutate(tempValue),
        isClearable: false
      })
    ]
  });
};
var AttributeDateField_default = AttributeDateField;

// src/components/Attributes/Attributes.tsx
var import_react172 = require("@chakra-ui/react");
var import_react_error_boundary2 = require("react-error-boundary");

// src/components/Attributes/AttributeEmail/AttributeEmail.tsx
var import_react112 = require("@chakra-ui/react");
var import_axios4 = __toESM(require("axios"));
var import_debounce_promise = __toESM(require("debounce-promise"));
var import_react_query15 = require("react-query");
var import_async_creatable = __toESM(require("react-select/async-creatable"));
var import_validate = __toESM(require("validate.js"));
var import_jsx_runtime = require("react/jsx-runtime");
var loadOptions = async (query) => {
  const params = {
    fields: "email",
    "filter[email][hasText]": query,
    "filter[email][isNotNull]": "",
    "filter[email][neq]": ""
  };
  const userUserEmail = import_axios4.default.get("/api/account_users", { params });
  const accountUserEmail = import_axios4.default.get("/api/user_users", { params });
  const allEmails = await Promise.all([userUserEmail, accountUserEmail]);
  const userUserEmailForInput = buildOptions(
    allEmails[0].data.data,
    "email",
    "id"
  );
  const accountUserEmailForInput = buildOptions(
    allEmails[1].data.data,
    "email",
    "id"
  );
  return new Promise((resolve, reject) => {
    resolve([...userUserEmailForInput, ...accountUserEmailForInput]);
  });
};
var isOptionUnique = (inputValue, selectOptions) => {
  if (inputValue.trim().length === 0 || selectOptions.find((option) => option.email === inputValue)) {
    return false;
  }
  return true;
};
var AttributeEmail = ({
  id,
  name,
  type,
  value,
  options,
  handleChange,
  isReadOnly
}) => {
  const { t } = useAuraTranslation_default();
  const attributeIdHtml = getAttributeId(id, type);
  const attributeValue = buildOptions(value);
  const { isInvalid } = useAttributeError(id, type);
  const debouncedLoadOptions = (0, import_debounce_promise.default)(loadOptions, 500, {
    leading: true
  });
  const updateAttribute = async (args) => {
    if (args.action === "remove-value") {
      const valueToRemove = args.removedValue.label;
      await handleChange(valueToRemove, id, {
        setting: {
          mode_relations_remove: 1
        }
      });
      return;
    }
    if (args.action === "create-option") {
      const valueToAdd = args.option.label;
      await handleChange(valueToAdd, id, {
        setting: { mode_relations_add: 1 }
      });
      return;
    }
    if (args.action === "select-option") {
      const valueToAdd = args.option.label;
      await handleChange(valueToAdd, id, {
        setting: { mode_relations_add: 1 }
      });
      return;
    }
  };
  const { mutate, isLoading, isError, isSuccess } = (0, import_react_query15.useMutation)((args) => {
    return updateAttribute(args);
  });
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react112.FormControl, {
    isDisabled: isLoading,
    isInvalid: isInvalid || !!isError,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react112.FormLabel, {
        htmlFor: attributeIdHtml,
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AttributeLabel_default, {
          text: name,
          customTranslation: true,
          isSaving: isLoading,
          isError: !!isError && !isLoading,
          isSuccess,
          tooltipContent: options == null ? void 0 : options.tooltip
        })
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_async_creatable.default, {
        inputId: attributeIdHtml,
        className: getAttributeClass(type),
        isClearable: false,
        onChange: (e, args) => mutate(args),
        loadOptions: (inputValue) => debouncedLoadOptions(inputValue),
        value: attributeValue,
        loadingMessage: () => t("LOADING"),
        noOptionsMessage: () => t("NOTHING_FOUND"),
        formatCreateLabel: (inputValue) => `${t("ADD_EMAIL")} "${inputValue}"`,
        placeholder: t("EMAILS"),
        isValidNewOption: (inputValue, selectValue, selectOptions) => !import_validate.default.single(inputValue, { email: true }) && isOptionUnique(inputValue, selectOptions),
        isMulti: true,
        cacheOptions: true,
        isDisabled: isReadOnly
      })
    ]
  });
};
var AttributeEmail_default = AttributeEmail;

// src/components/Attributes/AttributeHTML/AttributeHTML.tsx
var import_react113 = require("@chakra-ui/react");
var import_react114 = require("react");
var import_react_query16 = require("react-query");
var import_jsx_runtime = require("react/jsx-runtime");
var AttributeHTML = ({
  id,
  name,
  type,
  value,
  options,
  handleChange,
  isReadOnly
}) => {
  const { language } = (0, import_react114.useContext)(LanguageContext);
  const [editing, setEditing] = (0, import_react114.useState)(false);
  const attributeIdHtml = getAttributeId(id, type);
  const updateAttribute = (newValue) => {
    if (newValue === value)
      return;
    return handleChange(newValue, id);
  };
  const { mutate, isLoading, isError, isSuccess } = (0, import_react_query16.useMutation)((newValue) => {
    return updateAttribute(newValue);
  });
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react113.FormControl, {
    isDisabled: isLoading,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react113.FormLabel, {
        htmlFor: attributeIdHtml,
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AttributeLabel_default, {
          text: name,
          customTranslation: true,
          isEditButton: !isReadOnly,
          onClick: () => setEditing(!editing),
          isSaving: isLoading,
          isError: !!isError && !isLoading,
          isSuccess,
          tooltipContent: options == null ? void 0 : options.tooltip
        })
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AttributeHtml_default, {
        id,
        value,
        isReadOnly: !editing,
        language,
        onBlur: (event) => mutate(event.editor.getData())
      })
    ]
  });
};
var AttributeHTML_default = AttributeHTML;

// src/components/Attributes/AttributeTextField/AttributeTextField.tsx
var import_react115 = require("@chakra-ui/react");
var import_react116 = require("react");
var import_react_query17 = require("react-query");
var import_jsx_runtime = require("react/jsx-runtime");
var validateAttributeText = (oldValue, newValue) => {
  if (oldValue === newValue) {
    return false;
  }
  if (oldValue === null && newValue) {
    return true;
  }
  if (oldValue !== null && oldValue !== newValue) {
    return true;
  }
  return false;
};
var AttributeTextField = ({
  id,
  name,
  type,
  value,
  options,
  handleChange,
  isReadOnly
}) => {
  const attributeIdHtml = getAttributeId(id, type);
  const [attributeValue, setAttributeValue] = (0, import_react116.useState)(value);
  const { isInvalid } = useAttributeError(id, type);
  (0, import_react116.useEffect)(() => {
    setAttributeValue(value);
  }, [value]);
  const { mutate, isLoading, isError, isSuccess } = (0, import_react_query17.useMutation)((newValue) => {
    return handleChange(newValue, id);
  });
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react115.FormControl, {
    isDisabled: isLoading,
    isInvalid: isInvalid || !!isError,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react115.FormLabel, {
        htmlFor: attributeIdHtml,
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AttributeLabel_default, {
          text: name,
          customTranslation: true,
          isSaving: isLoading,
          isError: !!isError && !isLoading,
          isSuccess,
          tooltipContent: options == null ? void 0 : options.tooltip
        })
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AttributeText_default, {
        pl: 2,
        onChange: (e) => setAttributeValue(e.target.value),
        onBlur: (e) => {
          if (!isReadOnly) {
            validateAttributeText(value, e.target.value) && mutate(e.target.value);
          }
        },
        value: attributeValue || "",
        id,
        isReadOnly
      })
    ]
  });
};
var AttributeTextField_default = AttributeTextField;

// src/components/Attributes/AttributeNumberField/AttributeNumberField.tsx
var import_react117 = require("@chakra-ui/react");
var import_react_query18 = require("react-query");
var import_jsx_runtime = require("react/jsx-runtime");
var AttributeNumberField = ({
  id,
  name,
  type,
  value,
  options,
  handleChange,
  isReadOnly
}) => {
  const attributeIdHtml = getAttributeId(id, type);
  const { isInvalid } = useAttributeError(id, type);
  const { mutate, isLoading, isError, isSuccess } = (0, import_react_query18.useMutation)((newValue) => {
    return handleChange(newValue, id);
  });
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react117.FormControl, {
    isInvalid: isInvalid ?? isError,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react117.FormLabel, {
        htmlFor: attributeIdHtml,
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AttributeLabel_default, {
          text: name,
          customTranslation: true,
          isSaving: isLoading,
          isError: !!isError && !isLoading,
          isSuccess,
          tooltipContent: options == null ? void 0 : options.tooltip
        })
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AttributeNumber_default, {
        id,
        value,
        isReadOnly,
        onChange: (e) => mutate(e)
      })
    ]
  });
};
var AttributeNumberField_default = AttributeNumberField;

// src/components/Attributes/AttributeAttachments/AttributeAttachments.tsx
var import_react118 = require("@chakra-ui/react");
var import_react119 = __toESM(require("react"));

// src/hooks/useFileUpload.tsx
var import_react_query19 = require("react-query");
var fileUpload = async (formData) => {
  return api_default.uploadFile(formData, {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });
};
var handleFileUploadSequential = async (event) => {
  const filesToUpload = event.target.files;
  if (!filesToUpload) {
    return;
  }
  const formData = new FormData();
  Array.from(filesToUpload).forEach((file, index) => {
    formData.append(`data_files[${index}]`, file);
  });
  return fileUpload(formData);
};
var useFileUpload = ({
  attributeId,
  handleFileConnect,
  allFileDetails
}) => {
  const { resolveApiError } = useAuraErrorResolver_default();
  const { validate: validate3 } = useFilesUpdateValidate_default();
  const handleUpload = async (event) => {
    var _a2;
    validate3((_a2 = event == null ? void 0 : event.target) == null ? void 0 : _a2.files);
    return handleFileUploadSequential(event);
  };
  return (0, import_react_query19.useMutation)(handleUpload, {
    onSuccess: async (response) => {
      var _a2;
      if (typeof handleFileConnect !== "function") {
        return;
      }
      await handleFileConnect(
        (_a2 = response == null ? void 0 : response.data) == null ? void 0 : _a2.map((file) => allFileDetails ? file : file.id),
        attributeId,
        {
          setting: { mode_relations_add: 1 }
        }
      );
    },
    onError: (error) => {
      resolveApiError(error, { customTitle: "ERROR_UPLOADING_FILE" });
    }
  });
};

// src/components/Attributes/AttributeAttachments/AttributeAttachments.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var prepareFiles = (files) => {
  var _a2;
  return (_a2 = files == null ? void 0 : files.map((file) => ({
    ...file,
    size: file.fileSize,
    createdDate: new Date(file.dateCreate)
  }))) == null ? void 0 : _a2.sort((fileA, fileB) => {
    return fileA.createdDate.getTime() - fileB.createdDate.getTime() || fileA.id - fileB.id;
  });
};
var AttributeAttachments = ({
  id,
  name,
  value = [],
  type,
  options,
  handleChange,
  isReadOnly,
  module: module2,
  moduleItemId
}) => {
  const attributeIdHtml = getAttributeId(id, type);
  const { t } = useAuraTranslation_default();
  const { resolveApiError } = useAuraErrorResolver_default();
  const [files, setFiles] = (0, import_react119.useState)(value && prepareFiles([...value]));
  (0, import_react119.useEffect)(() => {
    setFiles(value && prepareFiles([...value]));
  }, [value]);
  const { mutate, isLoading, isError, isSuccess } = useFileUpload({
    attributeId: id,
    handleFileConnect: handleChange
  });
  const handleFileDelete = async (fileId) => {
    const shouldDelete = confirm(t("PROCESS_DELETE_FILE_CONFIRM"));
    if (!shouldDelete) {
      return;
    }
    try {
      await handleChange(fileId, id, {
        setting: { mode_relations_remove: 1 }
      });
    } catch (error) {
      if (error) {
        resolveApiError(error, { customTitle: "ERROR_DELETING_FILE" });
      }
    }
  };
  const handleDownloadAllFiles = async () => {
    const url = getDownloadUrlForModule(module2, moduleItemId, id);
    if (url) {
      window.open(url, "_self");
    }
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react118.FormControl, {
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react118.FormLabel, {
        htmlFor: attributeIdHtml,
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AttributeLabel_default, {
          id,
          text: name,
          customTranslation: true,
          numberAlerts: files == null ? void 0 : files.length,
          isUploadFilesButton: !isReadOnly,
          onClickUploadFiles: (files2) => {
            return mutate(files2);
          },
          isSaving: isLoading,
          isError: !!isError && !isLoading,
          isSuccess,
          tooltipContent: options == null ? void 0 : options.tooltip,
          ...isAvailableDownloadAllForModule(module2) ? { onClickDownloadAll: handleDownloadAllFiles } : {}
        })
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AttributeFile_default, {
        id,
        onFileDelete: handleFileDelete,
        children: files.map(
          (file) => import_react119.default.createElement(AttributeFileItem_default, {
            files,
            file,
            onDelete: handleFileDelete,
            key: file.id,
            isReadOnly
          })
        )
      })
    ]
  });
};
var isAvailableDownloadAllForModule = (module2) => {
  const availableModules = ["commissions"];
  if (availableModules.includes(module2)) {
    return true;
  }
  return false;
};
var getDownloadUrlForModule = (module2, moduleItemId, attributeId) => {
  let url;
  switch (module2) {
    case "commissions":
      url = `/api/commissions/${moduleItemId}/attributes/${attributeId}/downloadAll`;
      break;
    default:
      console.warn(`No file download support for module ${module2}`);
      break;
  }
  return url;
};
var AttributeAttachments_default = AttributeAttachments;

// src/components/Attributes/AttributeListOne/AttributeListOne.tsx
var import_react120 = require("@chakra-ui/react");
var import_react_query20 = require("react-query");
var import_jsx_runtime = require("react/jsx-runtime");
var AttributeListOne = ({
  id,
  name,
  type,
  value,
  options,
  handleChange,
  isReadOnly
}) => {
  const { tCustom } = useAuraTranslation_default();
  const attributeIdHtml = getAttributeId(id, type);
  const { isInvalid } = useAttributeError(id, type);
  const searchingForOptions = options == null ? void 0 : options.searchingForOptions;
  const selectOptions = value && [...value].sort((a, b) => {
    return a.ordering - b.ordering;
  }).map((option) => ({
    value: option.id,
    label: tCustom(option.value),
    selected: option.selected,
    "data-option-id": option.id
  }));
  const selectedValue = selectOptions && selectOptions.find((option) => option.selected === true);
  const updateAttribute = (args) => {
    if (args === null) {
      return handleChange(null, id);
    }
    const newValue = args.value;
    return handleChange(newValue, id);
  };
  const { mutate, isLoading, isError, isSuccess } = (0, import_react_query20.useMutation)((args) => {
    return updateAttribute(args);
  });
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react120.FormControl, {
    isDisabled: isLoading,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react120.FormLabel, {
        htmlFor: attributeIdHtml,
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AttributeLabel_default, {
          text: name,
          customTranslation: true,
          isSaving: isLoading,
          isError,
          isSuccess,
          tooltipContent: options == null ? void 0 : options.tooltip
        })
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSelect_default, {
        inputId: attributeIdHtml,
        className: getAttributeClass(type),
        value: selectedValue,
        options: selectOptions,
        defaultOption: !searchingForOptions,
        onChange: (args) => mutate(args),
        isReadOnly,
        isError: isInvalid
      })
    ]
  });
};
var AttributeListOne_default = AttributeListOne;

// src/components/Attributes/AttributeListMulti/AttributeListMulti.tsx
var import_react138 = require("@chakra-ui/react");
var import_react139 = require("react");
var import_react_query21 = require("react-query");

// src/components/AuraSelect/AuraSelect.tsx
var import_react134 = require("@chakra-ui/react");
var import_react135 = require("@emotion/react");
var import_js24 = require("@mdi/js");
var import_react136 = __toESM(require("@mdi/react"));
var import_react137 = require("react");
var import_react_select6 = __toESM(require("react-select"));

// src/components/AuraSelect/CustomSingleValue/CustomSingleValue.tsx
var import_react123 = require("@chakra-ui/react");
var import_js20 = require("@mdi/js");
var import_react124 = __toESM(require("@mdi/react"));
var import_react_select2 = require("react-select");

// src/components/QAvatar/QAvatar.tsx
var import_react121 = require("@chakra-ui/react");
var import_react122 = require("@emotion/react");
var import_jsx_runtime = require("react/jsx-runtime");
var QAvatar = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react121.Avatar, {
    css: import_react122.css`
        & > img {
          background: white;
        }
      `,
    ...props
  });
};
var QAvatar_default = QAvatar;

// src/components/AuraSelect/CustomSingleValue/CustomSingleValue.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var CustomSingleValue = ({
  children,
  ...props
}) => {
  const { t } = useAuraTranslation_default();
  const { data, selectProps } = props;
  const { withAvatar } = selectProps;
  const preparedAvatar = (data == null ? void 0 : data.isDeleted) ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react123.Tooltip, {
    label: t("DELETED"),
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react123.Box, {
      className: "select__single-value__avatar-deleted",
      color: "gray.500",
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react124.default, {
        size: "24px",
        path: import_js20.mdiAccountOffOutline
      })
    })
  }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(QAvatar_default, {
    size: "xs",
    className: "select__single-value__avatar",
    name: data.label,
    src: (data == null ? void 0 : data.avatarCustomUrl) ?? getImageUrl(data.avatar, "thmb"),
    ...(data == null ? void 0 : data.defaultCallendarColor) && { bg: data.defaultCallendarColor }
  });
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_select2.components.SingleValue, {
    ...props,
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react123.Stack, {
      isInline: true,
      align: "center",
      children: [
        withAvatar && preparedAvatar,
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react123.Text, {
          as: "span",
          isTruncated: true,
          whiteSpace: "nowrap",
          className: "select__single-value__label",
          ...(data == null ? void 0 : data.isDeleted) && {
            textDecoration: "line-through",
            color: "gray.500"
          },
          children
        })
      ]
    })
  });
};
var CustomSingleValue_default = CustomSingleValue;

// src/components/AuraSelect/CustomOption/CustomOption.tsx
var import_react125 = require("@chakra-ui/react");
var import_js21 = require("@mdi/js");
var import_react126 = __toESM(require("@mdi/react"));
var import_jsx_runtime = require("react/jsx-runtime");
var CustomOption = (props) => {
  const {
    children,
    className,
    cx,
    getStyles,
    isDisabled,
    isFocused,
    isSelected,
    innerRef,
    innerProps,
    selectProps,
    data,
    isMulti
  } = props;
  const { withAvatar, withCheckbox, withDeleted } = selectProps;
  if (!withDeleted && !isSelected && (data == null ? void 0 : data.isDeleted)) {
    return null;
  }
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react125.Box, {
    className: "select__option",
    bgColor: isFocused ? "gray.100" : "#fff",
    color: "gray.700",
    fontSize: "15px",
    py: "10px",
    px: "16px",
    cursor: "pointer",
    ref: innerRef,
    ...innerProps,
    ...data["data-option-id"] && {
      "data-option-id": data["data-option-id"]
    },
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react125.Stack, {
      overflowX: "hidden",
      isInline: true,
      spacing: "0",
      alignItems: "center",
      children: [
        isMulti && withCheckbox && !(data == null ? void 0 : data.hideCheckbox) ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react125.Checkbox, {
          size: "md",
          mr: "16px",
          isChecked: isSelected,
          pointerEvents: "none"
        }) : null,
        withAvatar && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react125.Box, {
          className: "select__option__user-avatar",
          children: data.isDeleted ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react125.Box, {
            w: "32px",
            mr: "8px",
            pl: "4px",
            className: "selected__avatar-deleted",
            children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react126.default, {
              size: "24px",
              path: import_js21.mdiAccountOffOutline
            })
          }) : data.value === 0 || data.value === -1 ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react125.Circle, {
            size: "32px",
            bg: "#ffffff",
            color: "gray.500",
            border: "1px solid",
            borderColor: "gray.200",
            mr: "8px",
            children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react126.default, {
              size: "20px",
              path: data.value === -1 ? import_js21.mdiAccountGroup : import_js21.mdiAccountOutline
            })
          }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(QAvatar_default, {
            mr: "8px",
            title: data.label,
            name: data.label,
            size: "sm",
            src: (data == null ? void 0 : data.avatarCustomUrl) ?? getImageUrl(data.avatar, "thmb"),
            ...(data == null ? void 0 : data.defaultCallendarColor) && {
              bg: data.defaultCallendarColor
            }
          })
        }),
        typeof (data == null ? void 0 : data.additionalLabel) === "string" ? /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react125.Box, {
          w: "fit-content",
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react125.Text, {
              as: "span",
              className: "select__option__label",
              "data-testid": "select-option-label",
              display: "inline-block",
              lineHeight: "24px",
              whiteSpace: "normal",
              w: "full",
              ...withAvatar ? { noOfLines: 2 } : {},
              children: data.label
            }),
            typeof (data == null ? void 0 : data.additionalLabel) === "string" && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react125.Text, {
              as: "span",
              mt: "4px",
              fontSize: "sm",
              letterSpacing: "0.25px",
              color: "gray.500",
              lineHeight: "20px",
              className: "select__option__additional-label",
              "data-testid": "select-option-additional-label",
              w: "full",
              children: data.additionalLabel
            })
          ]
        }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react125.Text, {
          as: "span",
          className: "select__option__label",
          "data-testid": "select-option-label",
          display: "inline-block",
          lineHeight: "24px",
          whiteSpace: "normal",
          ...withAvatar ? { noOfLines: 2 } : {},
          ...(data == null ? void 0 : data.isDeleted) && {
            textDecoration: "line-through",
            color: "gray.500"
          },
          children: data.label
        })
      ]
    })
  });
};
var CustomOption_default = CustomOption;

// src/components/AuraSelect/CustomValueContainer/AvatarValueContainer/AvatarValueContainer.tsx
var import_react127 = require("@chakra-ui/react");
var import_jsx_runtime = require("react/jsx-runtime");
var AvatarValueContainer = ({
  valueContainerChildren,
  maxAvatars
}) => {
  let name = null;
  let additionalProps = {};
  try {
    if (Array.isArray(valueContainerChildren) && Array.isArray(valueContainerChildren[0]) && valueContainerChildren[0].length === 1) {
      const user = valueContainerChildren == null ? void 0 : valueContainerChildren[0][0].props.data;
      name = user.label;
      if (user.isDeleted) {
        additionalProps = { textDecoration: "line-through", color: "gray.500" };
      }
    }
  } catch (error) {
    console.error(error);
  }
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react127.Stack, {
    flex: 1,
    overflowX: "hidden",
    isInline: true,
    spacing: "0",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react127.AvatarGroup, {
        mr: "8px",
        max: maxAvatars,
        size: "xs",
        className: "selected__avatar-group",
        zIndex: 0,
        flexDir: "row",
        ps: "2px",
        sx: {
          "*:not(:last-child)": {
            marginEnd: "-10px"
          },
          ".chakra-avatar__excess": {
            marginStart: "2px",
            zIndex: 100,
            order: 100,
            fontSize: "13px",
            marginEnd: "0px"
          }
        },
        children: valueContainerChildren
      }),
      name && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react127.Text, {
        lineHeight: "26px",
        as: "span",
        isTruncated: true,
        whiteSpace: "nowrap",
        ...additionalProps,
        children: name
      })
    ]
  });
};
var AvatarValueContainer_default = AvatarValueContainer;

// src/components/AuraSelect/CustomValueContainer/CustomValueContainer.tsx
var import_react128 = require("@chakra-ui/react");
var import_react_select3 = require("react-select");
var import_jsx_runtime = require("react/jsx-runtime");
var CustomValueContainer = ({
  children,
  ...props
}) => {
  const { isMulti, selectProps, hasValue } = props;
  if (isMulti) {
    if (selectProps.withAvatar && hasValue) {
      const [Avatars, Input9] = children;
      return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react_select3.components.ValueContainer, {
        ...props,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AvatarValueContainer_default, {
            valueContainerChildren: [Avatars],
            maxAvatars: selectProps.maxAvatars
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react128.Box, {
            children: Input9
          })
        ]
      });
    } else {
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_select3.components.ValueContainer, {
        ...props,
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react128.Flex, {
          gap: "10px",
          flexWrap: "wrap",
          pr: "8px",
          maxWidth: "100%",
          children
        })
      });
    }
  }
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_select3.components.ValueContainer, {
    ...props,
    children
  });
};
var CustomValueContainer_default = CustomValueContainer;

// src/components/AuraSelect/CustomMultiValue/CustomMultiValue.tsx
var import_react129 = require("@chakra-ui/react");
var import_js22 = require("@mdi/js");
var import_react130 = __toESM(require("@mdi/react"));
var import_react_select4 = require("react-select");
var import_jsx_runtime = require("react/jsx-runtime");
var CustomMultiValue = ({
  children,
  ...props
}) => {
  var _a2;
  const { data, selectProps } = props;
  const { withAvatar } = selectProps;
  const meOption = ((_a2 = selectProps.rawOptions) == null ? void 0 : _a2.find(
    (option) => option.value === data.value
  )) ?? { avatar: void 0 };
  if (withAvatar) {
    const {
      size,
      ml,
      zIndex,
      showBorder,
      borderColor,
      marginEnd
    } = props;
    const avatarGroupProps = {
      size,
      ml,
      zIndex,
      showBorder,
      borderColor,
      marginEnd
    };
    if (data.value === -1 || data.value === 0 && !meOption.avatar) {
      return renderSpecialAvatar({
        label: data.label,
        value: data.value,
        avatarProps: { ...avatarGroupProps }
      });
    } else if (data == null ? void 0 : data.isDeleted) {
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react129.Box, {
        className: "selected__avatar-deleted",
        as: "span",
        position: "relative",
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react129.Circle, {
          size: "24px",
          bg: "#ffffff",
          color: "gray.500",
          border: "1px solid",
          borderColor: "gray.200",
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react130.default, {
            size: "24px",
            path: import_js22.mdiAccountOffOutline
          })
        })
      });
    } else {
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(QAvatar_default, {
        ...avatarGroupProps,
        size,
        className: "selected__avatar",
        name: data.label,
        src: (data == null ? void 0 : data.avatarCustomUrl) ? data.avatarCustomUrl : getImageUrl(data.avatar, "thmb") || meOption.avatar,
        borderWidth: "1px",
        borderColor: "gray.200",
        ...(data == null ? void 0 : data.defaultCallendarColor) && {
          bg: data.defaultCallendarColor
        }
      });
    }
  }
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_select4.components.MultiValue, {
    ...props,
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react129.Text, {
      isTruncated: true,
      mb: "0",
      fontWeight: "400",
      ...data.isDeleted && {
        textDecoration: "line-through",
        color: "gray.500"
      },
      children
    })
  });
};
var renderSpecialAvatar = ({
  value,
  label,
  avatarProps
}) => {
  if (value === 0 || value === -1) {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(QAvatar_default, {
      ...avatarProps,
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react129.Circle, {
        size: "24px",
        bg: "#ffffff",
        color: "gray.500",
        border: "1px solid",
        borderColor: "gray.200",
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react130.default, {
          size: "15px",
          path: value === -1 ? import_js22.mdiAccountGroup : import_js22.mdiAccountOutline
        })
      })
    });
  }
  return null;
};
var CustomMultiValue_default = CustomMultiValue;

// src/components/AuraSelect/CustomMenuList/CustomMenuList.tsx
var import_react131 = require("react");
var import_react132 = require("@chakra-ui/react");
var import_react133 = __toESM(require("@mdi/react"));
var import_js23 = require("@mdi/js");
var import_react_select5 = require("react-select");
var import_jsx_runtime = require("react/jsx-runtime");
var isOptionsGrouped = (opts) => {
  if (opts === void 0) {
    return false;
  }
  return opts.every((option) => {
    if (option.hasOwnProperty("options")) {
      return true;
    }
    return false;
  });
};
var CustomMenuList = (props) => {
  var _a2;
  const { t } = useAuraTranslation_default();
  const {
    loadDataProps: loadDataProps2,
    additionalActionProps,
    inputValue,
    loadMoreOptions,
    isSelectedAll,
    setIsSelectedAll,
    totalCount,
    isLoading,
    isMulti
  } = props.selectProps;
  const handleSetAll = () => {
    if (isOptionsGrouped(props.options)) {
      if (isSelectedAll) {
        props.setValue([], "select-option");
      } else {
        const preparedOptions = [];
        props.options.forEach((group) => {
          group.options.forEach((option) => {
            preparedOptions.push(option);
          });
        });
        props.setValue(preparedOptions, "select-option");
      }
    } else {
      if (isSelectedAll) {
        props.setValue([], "select-option");
      } else {
        props.setValue(props.options, "select-option");
      }
    }
    setIsSelectedAll((prevValue) => !prevValue);
  };
  (0, import_react131.useEffect)(() => {
    if (!props.hasValue) {
      setIsSelectedAll(false);
      return;
    }
    const value = props.getValue();
    if (value.length != props.options.length) {
      setIsSelectedAll(false);
      return;
    }
    setIsSelectedAll(true);
  }, []);
  const actionPreparedTitle = (additionalActionProps == null ? void 0 : additionalActionProps.titleLabel) ?? t("ADD_NEW");
  const actionButtonLabel = inputValue ? `${actionPreparedTitle} "${inputValue}"` : actionPreparedTitle;
  const loadDataPropsPreparedTitle = (loadDataProps2 == null ? void 0 : loadDataProps2.titleLabel) ?? t("LOAD_MORE");
  const isAdditionalActionAlwaysVisible = (additionalActionProps == null ? void 0 : additionalActionProps.alwaysVisible) ? inputValue == null ? void 0 : inputValue.length : props.children.length;
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react_select5.components.MenuList, {
    ...props,
    children: [
      ((_a2 = props.children) == null ? void 0 : _a2.length) && isMulti ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react132.Button, {
        className: "select-all",
        variant: "unstyled",
        color: "blue.500",
        fontWeight: "400",
        letterSpacing: "0.25px",
        fontStyle: "caption",
        mx: "16px",
        onClick: () => {
          handleSetAll();
        },
        children: isSelectedAll && props.hasValue ? t("DESELECT_ALL") : t("SELECT_ALL")
      }) : null,
      props.children,
      !isLoading && loadDataProps2 && props.options.length > 0 && props.options.length < totalCount ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CustomButtonOption, {
        titleLabel: loadDataPropsPreparedTitle,
        icon: import_js23.mdiMagnify,
        onClickAction: loadMoreOptions
      }) : null,
      additionalActionProps && isAdditionalActionAlwaysVisible ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CustomButtonOption, {
        titleLabel: actionButtonLabel,
        icon: import_js23.mdiPlus,
        onClickAction: additionalActionProps.handleAction
      }) : null
    ]
  });
};
var CustomButtonOption = ({
  titleLabel,
  icon,
  onClickAction
}) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react132.Button, {
    width: "full",
    minH: "44px",
    fontWeight: "400",
    p: "10px 16px",
    justifyContent: "flex-start",
    borderRadius: "0s",
    backgroundColor: "transparent",
    _hover: {
      bg: "gray.100"
    },
    onClick: onClickAction,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react132.Box, {
        me: "10px",
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react133.default, {
          color: "#2D3748",
          size: "24px",
          path: icon
        })
      }),
      titleLabel
    ]
  });
};
var CustomMenuList_default = CustomMenuList;

// src/components/AuraSelect/AuraSelect.tsx
var import_immer2 = __toESM(require("immer"));
var import_async = __toESM(require("react-select/async"));
var import_axios5 = __toESM(require("axios"));
var import_isUndefined = __toESM(require("lodash/isUndefined"));

// src/components/AuraSelect/config.ts
var auraSelectFilterConfig = {
  ignoreCase: true,
  ignoreAccents: true,
  matchFrom: "any",
  stringify: (option) => {
    var _a2;
    return `${option.label} ${(_a2 = option.data) == null ? void 0 : _a2.additionalName}`;
  },
  trim: true
};

// src/components/AuraSelect/AuraSelect.tsx
var import_use_deep_compare_effect2 = require("use-deep-compare-effect");
var import_spark_md5 = __toESM(require("spark-md5"));
var import_jsx_runtime = require("react/jsx-runtime");
var fetchData2 = async (endpoint, config = {}) => {
  const url = `/api/${endpoint}`;
  const response = await (0, import_axios5.default)({
    method: "GET",
    url,
    ...config
  });
  return response.data;
};
var isOptionsGrouped2 = (opts) => {
  if (opts === void 0) {
    return false;
  }
  return opts.every((option) => {
    if (option.hasOwnProperty("options")) {
      return true;
    }
    return false;
  });
};
var prepareKey = (limitData, additionalData) => {
  const data = JSON.stringify(additionalData || "");
  const dataMD5 = import_spark_md5.default.hash(data);
  const dataHash = dataMD5.replace(/\w/, "1");
  return dataHash + limitData;
};
var AuraSelect = (0, import_react137.forwardRef)(
  ({
    isReadOnly,
    withAvatars,
    withCheckbox,
    optionAllEnabled,
    optionMeEnabled,
    isEnabledSelectAll,
    optionAllLabel,
    optionMeLabel,
    defaultOption,
    defaultInputValue,
    onChange,
    forceOnChange,
    onBlur,
    icon,
    loadDataProps: loadDataProps2,
    loadOptions: customLoadOptions,
    additionalActionProps,
    components: components13,
    customComponentsProps,
    customStyles,
    clientFilterDisabled,
    ...props
  }, ref) => {
    const { t } = useAuraTranslation_default();
    const theme = (0, import_react135.useTheme)();
    const defaultLimit = 20;
    const increaseLimit = 20;
    const [selectedOptions, setSelectedOptions] = (0, import_react137.useState)([]);
    const [limitData, setLimitData] = (0, import_react137.useState)(defaultLimit);
    const [isSelectedAll, setIsSelectedAll] = (0, import_react137.useState)(false);
    const [inputValue, setInputValue] = (0, import_react137.useState)(
      defaultInputValue ?? ""
    );
    const [open, setOpen] = (0, import_react137.useState)(false);
    const [totalCount, setTotalCount] = (0, import_react137.useState)(0);
    const [isLoading, setIsLoading] = (0, import_react137.useState)(false);
    const [abortController, setAbortController] = (0, import_react137.useState)(null);
    const [abortQuery, setAbortQuery] = (0, import_react137.useState)("");
    const [asyncKey, setAsyncKey] = (0, import_react137.useState)(
      (loadDataProps2 == null ? void 0 : loadDataProps2.defaultOptionsEnabled) ? prepareKey(limitData, loadDataProps2 == null ? void 0 : loadDataProps2.settings) : limitData
    );
    (0, import_use_deep_compare_effect2.useDeepCompareEffectNoCheck)(() => {
      if (!(loadDataProps2 == null ? void 0 : loadDataProps2.defaultOptionsEnabled) && limitData <= defaultLimit) {
        return;
      }
      setAsyncKey(prepareKey(limitData, loadDataProps2 == null ? void 0 : loadDataProps2.settings));
    }, [loadDataProps2 == null ? void 0 : loadDataProps2.settings, limitData]);
    const handleChange = (selectValue, actionMeta) => {
      var _a2;
      switch (actionMeta.action) {
        case "remove-value":
          if (Array.isArray(selectValue)) {
            setSelectedOptions((opts) => {
              const newValue = opts == null ? void 0 : opts.filter(
                (option) => option.value !== actionMeta.removedValue.value
              );
              onChange(newValue, actionMeta);
              return newValue;
            });
          } else {
            setSelectedOptions(selectValue ?? []);
            onChange(selectValue, actionMeta);
          }
          break;
        case "deselect-option":
          setSelectedOptions(selectValue ?? []);
          onChange(selectValue ?? [], actionMeta);
          break;
        case "select-option":
          if (props == null ? void 0 : props.isMulti) {
            const isAll = ((_a2 = actionMeta == null ? void 0 : actionMeta.option) == null ? void 0 : _a2.value) === -1;
            if (optionAllEnabled && isAll) {
              setSelectedOptions([actionMeta.option]);
              onChange([actionMeta.option], actionMeta);
              break;
            }
            const newValue = Array.isArray(selectValue) && optionAllEnabled ? selectValue == null ? void 0 : selectValue.filter((option) => option.value !== -1) : selectValue;
            setSelectedOptions(newValue ?? []);
            onChange(newValue, actionMeta);
          } else {
            let newValue = selectValue;
            if ((selectedOptions == null ? void 0 : selectedOptions.value) === (selectValue == null ? void 0 : selectValue.value)) {
              newValue = null;
            }
            onChange(newValue, actionMeta);
            setSelectedOptions(newValue);
          }
          break;
        case "clear":
          setSelectedOptions([]);
          setInputValue("");
          onChange((props == null ? void 0 : props.isMulti) ? [] : null, actionMeta);
          break;
        case "pop-value":
          setSelectedOptions((currentOpts) => {
            return currentOpts == null ? void 0 : currentOpts.filter(
              (option) => option.value !== actionMeta.removedValue.value
            );
          });
          onChange(selectValue, actionMeta);
          break;
        default:
          break;
      }
    };
    const sortOptions = (options) => {
      if (!options) {
        return [];
      }
      const sortOptions2 = (a, b) => {
        let selectedIds = [];
        if (Array.isArray(selectedOptions)) {
          selectedIds = selectedOptions.map((opt) => opt.value);
        } else {
          selectedIds = [selectedOptions == null ? void 0 : selectedOptions.value];
        }
        if (selectedIds.includes(a.value)) {
          return -1;
        }
        if (selectedIds.includes(b.value)) {
          return 1;
        }
        return 0;
      };
      let newOptions;
      if ((options == null ? void 0 : options.length) > 0 && isOptionsGrouped2(options)) {
        newOptions = (0, import_immer2.default)(options, (draft) => {
          draft.forEach((group) => {
            var _a2;
            (_a2 = group == null ? void 0 : group.options) == null ? void 0 : _a2.sort(sortOptions2);
          });
        });
      } else {
        newOptions = (0, import_immer2.default)(options, (draft) => {
          draft == null ? void 0 : draft.sort(sortOptions2);
        });
      }
      const optionAll = { label: optionAllLabel ?? t("ALL_USERS"), value: -1 };
      if (optionAllEnabled) {
        newOptions = [optionAll, ...newOptions];
      }
      const optionMe = { label: optionMeLabel ?? t("ME"), value: 0 };
      if (optionMeEnabled) {
        newOptions = [optionMe, ...newOptions];
      }
      return newOptions;
    };
    props.options = sortOptions(props.options);
    const handleLoadMore = () => {
      setLimitData((limit) => limit + increaseLimit);
    };
    const defaultLoadOptions = typeof customLoadOptions === "function" ? false : true;
    const debouncedLoadOptions = (query, callback) => {
      if (abortController && query !== abortQuery) {
        abortController.abort();
      }
      const newController = new AbortController();
      setAbortController(newController);
      setAbortQuery(query);
      const signal = newController.signal;
      try {
        setTimeout(loadOptions4, 500, query, callback, signal);
      } catch {
        callback(null);
      }
    };
    const loadOptions4 = async (query, callback, signal) => {
      if (!query && !(loadDataProps2 == null ? void 0 : loadDataProps2.defaultOptionsEnabled)) {
        callback(null);
        return;
      }
      setIsLoading(true);
      const endpoint = loadDataProps2 == null ? void 0 : loadDataProps2.endpoint;
      const additionalNameAccessor = loadDataProps2 == null ? void 0 : loadDataProps2.additionalNameAccessor;
      const isAutoselect = !(0, import_isUndefined.default)(loadDataProps2 == null ? void 0 : loadDataProps2.autoselect) ? loadDataProps2 == null ? void 0 : loadDataProps2.autoselect : true;
      const params = {
        fields: `${loadDataProps2 == null ? void 0 : loadDataProps2.labelField}${additionalNameAccessor ? "," + additionalNameAccessor : ""}` ?? "value",
        ...query ? { [`filter[${loadDataProps2.queryField ?? "_q"}][hasText]`]: query } : null,
        ...query === "" && isAutoselect && {
          [`filter[${loadDataProps2.queryField ?? "_q"}][hasText]`]: "*"
        },
        "page[limit]": limitData,
        ...(loadDataProps2 == null ? void 0 : loadDataProps2.settings) ?? {}
      };
      const url = `${endpoint}${isAutoselect ? "/autoselect" : ""}`;
      try {
        const { data, meta } = await fetchData2(url, {
          params,
          signal
        });
        setTotalCount(meta.page.total_count);
        const preparedData = (loadDataProps2 == null ? void 0 : loadDataProps2.customPrepareData) ? loadDataProps2.customPrepareData(data) : prepareLoadedData(data, loadDataProps2).map((opt) => ({
          ...opt,
          label: t(opt == null ? void 0 : opt.label)
        }));
        callback(preparedData);
      } catch (error) {
        callback(null);
        return;
      }
      setIsLoading(false);
    };
    const prepareLoadedData = (data, loadDataProps3) => {
      let preparedData = data;
      if ((loadDataProps3 == null ? void 0 : loadDataProps3.additionalNameAccessor) && (data == null ? void 0 : data.length)) {
        preparedData = data.map((item) => ({
          ...item,
          additionalName: loadDataProps3.additionalNameAccessor.split(".").reduce((acc, key) => acc == null ? void 0 : acc[key], item)
        }));
      }
      return buildOptions(
        preparedData,
        loadDataProps3.labelField,
        "id",
        props.withDeleted ? ["isDeleted"] : null
      );
    };
    (0, import_react137.useEffect)(() => {
      const defaultValue = props == null ? void 0 : props.defaultValue;
      if (!(selectedOptions == null ? void 0 : selectedOptions.length) && defaultValue) {
        setSelectedOptions(defaultValue);
      } else if (!(selectedOptions == null ? void 0 : selectedOptions.length) && (props == null ? void 0 : props.value)) {
        setSelectedOptions(props.value);
      }
    }, []);
    const colors = theme.colors;
    const placeholderText = (props == null ? void 0 : props.placeholder) ? props.placeholder : t("BEGIN_WRITING_TO_SEARCH");
    const customComponentsForSelect = {
      ValueContainer: CustomValueContainer_default,
      SingleValue: CustomSingleValue_default,
      MultiValue: CustomMultiValue_default,
      MultiValueContainer: CustomMultiValueContainer,
      MultiValueRemove: CustomMultiValueRemove,
      ClearIndicator: CustomClearIndicator,
      DropdownIndicator: CustomDropdownIndicator,
      Option: CustomOption_default,
      MenuList: CustomMenuList_default,
      Control: CustomControl,
      ...components13
    };
    const stylesSelect = {
      ...customStyles,
      multiValue: (base) => ({
        ...base,
        backgroundColor: "initial",
        button: {
          width: "24px",
          height: "24px",
          borderRadius: "6px",
          color: "#A0AEC0"
        },
        height: "28px",
        display: "flex",
        alignItems: "center"
      }),
      multiValueLabel: (base) => ({
        ...base,
        alignItems: "center",
        color: colors.gray[700],
        display: "flex",
        fontSize: "13px"
      }),
      indicatorSeparator: () => ({
        display: "none"
      }),
      input: (base) => ({
        ...base,
        margin: 0,
        padding: 0,
        lineHeight: "24px",
        fontSize: "15px"
      }),
      control: (base, { isDisabled, isFocused }) => ({
        ...base,
        backgroundColor: isDisabled ? colors.gray[50] : "initial",
        border: !props.isError ? `1px solid ${colors.gray[200]}` : `1.5px solid ${colors.red[500]}`,
        ...props.isError ? {
          boxShadow: `0 0 0 1px ${colors.red[500]}`
        } : {},
        borderRadius: "6px",
        minHeight: "40px",
        padding: "5px 11px 5px 15px",
        "&:hover .select__remove-all": {
          display: "flex"
        },
        ...isFocused ? {
          boxShadow: "none",
          border: `1px solid ${colors.blue[500]}`
        } : {
          "&:hover": {
            borderColor: colors.gray[300]
          }
        },
        ...customStyles == null ? void 0 : customStyles.control
      }),
      valueContainer: (base) => ({
        ...base,
        padding: 0
      }),
      singleValue: (base) => ({
        ...base,
        color: colors.gray[700],
        marginLeft: 0
      }),
      groupHeading: (base) => ({
        ...base,
        letterSpacing: "0.15px",
        color: colors.gray[800],
        fontSize: "15px",
        fontWeight: "500",
        textTransform: "capitalize"
      }),
      menuList: (base) => {
        var _a2;
        return {
          ...base,
          "button.select-all": {
            display: `${!isEnabledSelectAll || !((_a2 = props.options) == null ? void 0 : _a2.length) ? "none" : "block"}  `
          }
        };
      },
      menuPortal: (base) => ({
        ...base,
        zIndex: 3
      }),
      loadingIndicator: (base) => ({
        ...base,
        display: "none"
      }),
      placeholder: (base, { isFocused }) => ({
        ...base,
        position: "absolute",
        display: isFocused ? "none" : "block"
      })
    };
    const handleFilterOption = ["products", "account_companies"].includes(loadDataProps2 == null ? void 0 : loadDataProps2.endpoint) || clientFilterDisabled ? () => true : (0, import_react_select6.createFilter)(auraSelectFilterConfig);
    const baseProps = {
      isClearable: true,
      inputValue,
      placeholder: null,
      value: selectedOptions,
      onChange: forceOnChange ? onChange : handleChange,
      hideSelectedOptions: !props.isMulti || !withCheckbox ? true : false,
      loadMoreOptions: handleLoadMore,
      isSelectedAll,
      setIsSelectedAll,
      withAvatar: withAvatars,
      withCheckbox,
      icon,
      components: customComponentsForSelect,
      additionalActionProps,
      customComponentsProps,
      styles: stylesSelect,
      menuPosition: "fixed",
      filterOption: handleFilterOption
    };
    return !(loadDataProps2 == null ? void 0 : loadDataProps2.endpoint) && typeof customLoadOptions !== "function" ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_select6.default, {
      ref,
      noOptionsMessage: () => {
        var _a2;
        return (inputValue == null ? void 0 : inputValue.length) === 0 && defaultOption === false && ((_a2 = props == null ? void 0 : props.options) == null ? void 0 : _a2.length) > 0 ? t("BEGIN_WRITING_TO_SEARCH") : t("NOTHING_FOUND");
      },
      loadingMessage: () => t("LOADING"),
      closeMenuOnSelect: !props.isMulti,
      ...baseProps,
      ...props,
      onInputChange: (newValue, actionMeta) => {
        if (typeof (props == null ? void 0 : props.onInputChange) === "function") {
          !["input-blur", "menu-close"].includes(actionMeta.action) && setInputValue(newValue);
          props.onInputChange(newValue, actionMeta);
        } else {
          setInputValue(newValue);
        }
      },
      options: defaultOption === false && (inputValue == null ? void 0 : inputValue.length) === 0 ? [] : props == null ? void 0 : props.options,
      isDisabled: isReadOnly
    }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_async.default, {
      defaultOptions: defaultOption ?? true,
      menuIsOpen: open,
      autoFocus: open ?? true,
      onFocus: () => setOpen(true),
      blurInputOnSelect: !(props == null ? void 0 : props.isMulti),
      cacheOptions: false,
      onBlur: (e) => {
        onBlur && onBlur(e);
        setOpen(false);
      },
      onMenuClose: () => setLimitData(defaultLimit),
      totalCount,
      limitData,
      increaseLimit,
      ref,
      noOptionsMessage: (elem) => (elem == null ? void 0 : elem.inputValue) === "" && !(loadDataProps2 == null ? void 0 : loadDataProps2.defaultOptionsEnabled) ? placeholderText : t("NOTHING_FOUND"),
      loadingMessage: () => inputValue || (loadDataProps2 == null ? void 0 : loadDataProps2.defaultOptionsEnabled) ? t("LOADING") : placeholderText,
      isDisabled: isReadOnly,
      ...!isReadOnly && {
        loadOptions: defaultLoadOptions ? debouncedLoadOptions : customLoadOptions
      },
      ...baseProps,
      ...props,
      onInputChange: (newValue, actionMeta) => {
        if (typeof (props == null ? void 0 : props.onInputChange) === "function") {
          !["input-blur", "menu-close"].includes(actionMeta.action) && setInputValue(newValue);
          setLimitData(defaultLimit);
          props.onInputChange(newValue, actionMeta);
        } else {
          setInputValue(newValue);
          setLimitData(defaultLimit);
        }
      },
      ...!isReadOnly && {
        ...{
          loadDataProps: loadDataProps2,
          isLoading
        }
      }
    }, asyncKey ?? limitData);
  }
);
var CustomControl = (props) => {
  const { icon } = props.selectProps;
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react_select6.components.Control, {
    ...props,
    children: [
      icon && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react134.Box, {
        me: "10px",
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react136.default, {
          color: "#CBD5E0",
          size: "24px",
          path: icon
        })
      }),
      props.children
    ]
  });
};
var CustomMultiValueContainer = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react134.Tag, {
    className: "select__multi-value-container",
    height: "28px",
    px: "2px",
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_select6.components.MultiValueContainer, {
      ...props
    })
  });
};
var customBaseProps = {
  variant: "unstyled",
  size: "xs",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: "gray.700",
  cursor: "pointer"
};
var CustomMultiValueRemove = (props) => {
  if (props.selectProps.isDisabled) {
    return null;
  }
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react134.IconButton, {
    ...customBaseProps,
    ml: "4px",
    _hover: {
      color: "blue.400"
    },
    "aria-label": props.innerProps["aria-label"],
    ...props.innerProps,
    className: "select__remove-one",
    onClick: props.innerProps.onClick,
    onMouseDown: props.innerProps.onMouseDown,
    onTouchEnd: props.innerProps.onTouchEnd,
    icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react136.default, {
      size: "17.15px",
      path: import_js24.mdiClose
    })
  });
};
var CustomClearIndicator = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react134.IconButton, {
    ...customBaseProps,
    className: "select__remove-all",
    display: { base: "flex", lg: "none" },
    _hover: {
      color: "gray.700",
      backgroundColor: "gray.100"
    },
    "aria-label": "select__remove-all",
    onClick: props.innerProps.onClick,
    onMouseDown: props.innerProps.onMouseDown,
    onTouchEnd: props.innerProps.onTouchEnd,
    icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react136.default, {
      size: "16px",
      path: import_js24.mdiClose
    })
  });
};
var CustomDropdownIndicator = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react134.IconButton, {
    ...customBaseProps,
    ...props.isDisabled && { display: "none" },
    ml: "8px",
    className: "select__dropdown-button",
    _hover: {
      color: "gray.700"
    },
    "aria-label": props.innerProps["aria-label"],
    onClick: props.innerProps.onClick,
    onMouseDown: props.innerProps.onMouseDown,
    onTouchEnd: props.innerProps.onTouchEnd,
    icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react136.default, {
      size: "20px",
      path: import_js24.mdiChevronDown
    })
  });
};
var AuraSelect_default = AuraSelect;

// src/components/Attributes/AttributeListMulti/AttributeListMulti.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var AttributeListMulti = ({
  id,
  name,
  type,
  value,
  options,
  handleChange,
  isReadOnly
}) => {
  const { t, tCustom } = useAuraTranslation_default();
  const { isInvalid } = useAttributeError(id, type);
  const searchingForOptions = options == null ? void 0 : options.searchingForOptions;
  const attributeIdHtml = getAttributeId(id, type);
  const asTag = (options == null ? void 0 : options.asTag) ?? false;
  const attributeValue = [...value].filter((opt) => opt.selected).map((opt) => opt.id);
  const selectOptions = [...value].sort((a, b) => {
    return a.ordering - b.ordering;
  }).map((opt) => ({ ...opt, label: opt.value, value: opt.id }));
  const updateAttribute = (newValues) => {
    const newValue = newValues.map(
      (value2) => typeof value2 === "number" ? value2 : parseInt(value2)
    );
    return handleChange(newValue, id);
  };
  const { mutate, isLoading, isError, isSuccess } = (0, import_react_query21.useMutation)(
    (args) => {
      return updateAttribute(args);
    }
  );
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react138.FormControl, {
    isDisabled: isLoading,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react138.FormLabel, {
        htmlFor: attributeIdHtml,
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AttributeLabel_default, {
          text: name,
          customTranslation: true,
          isSaving: isLoading,
          isError: !!isError && !isLoading,
          isSuccess,
          tooltipContent: options == null ? void 0 : options.tooltip
        })
      }),
      asTag === true ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AttributeListMultiAsTag, {
        t,
        selectOptions,
        attributeId: attributeIdHtml,
        attributeValue,
        mutate,
        isReadOnly,
        isInvalid,
        searchingForOptions
      }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AttributeList_default, {
        id,
        value: attributeValue,
        options: selectOptions.map((e) => {
          return { ...e, label: tCustom(e.label) };
        }),
        onChange: (e) => {
          mutate(e);
        },
        isReadOnly
      })
    ]
  });
};
function AttributeListMultiAsTag({
  t,
  selectOptions,
  attributeValue,
  mutate,
  attributeId,
  isReadOnly,
  isInvalid,
  searchingForOptions
}) {
  const parsedOptions = (0, import_react139.useMemo)(
    () => translateOptions(selectOptions, t),
    [selectOptions]
  );
  const selectedValue = (0, import_react139.useMemo)(
    () => translateOptions(
      selectOptions.filter((e) => attributeValue.includes(e.id)),
      t
    ),
    [selectOptions]
  );
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSelect_default, {
    isEnabledSelectAll: true,
    isClearable: true,
    withCheckbox: true,
    inputId: attributeId,
    value: selectedValue ?? [],
    onChange: (e) => mutate(e.map((v) => v.value ?? 0)),
    isMulti: true,
    options: parsedOptions,
    defaultOption: !searchingForOptions,
    isReadOnly,
    isError: isInvalid
  });
}
var AttributeListMulti_default = AttributeListMulti;

// src/components/Attributes/AttributeBooleanField/AttributeBooleanField.tsx
var import_react140 = require("@chakra-ui/react");
var import_react_query22 = require("react-query");
var import_jsx_runtime = require("react/jsx-runtime");
var AttributeBooleanField = ({
  id,
  name,
  type,
  value,
  options,
  handleChange,
  isReadOnly
}) => {
  const attributeIdHtml = getAttributeId(id, type);
  const { isInvalid } = useAttributeError(id, type);
  const { mutate, isLoading, isError, isSuccess } = (0, import_react_query22.useMutation)((newValue) => {
    return handleChange(newValue, id);
  });
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react140.FormControl, {
    isDisabled: isLoading,
    isInvalid: isInvalid || !!isError,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react140.FormLabel, {
        htmlFor: attributeIdHtml,
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AttributeLabel_default, {
          text: name,
          customTranslation: true,
          isSaving: isLoading,
          isError: !!isError && !isLoading,
          isSuccess,
          tooltipContent: options == null ? void 0 : options.tooltip
        })
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AttributeBoolean_default, {
        id,
        onChange: (e) => {
          mutate(e.target.checked);
        },
        value,
        isReadOnly
      })
    ]
  });
};
var AttributeBooleanField_default = AttributeBooleanField;

// src/components/Attributes/AttributeTagsField/AttributeTagsField.tsx
var import_react141 = require("@chakra-ui/react");
var import_js25 = require("@mdi/js");
var import_react142 = __toESM(require("@mdi/react"));
var import_react143 = require("react");
var import_react_query23 = require("react-query");
var import_jsx_runtime = require("react/jsx-runtime");
var buildOptionsTags = (object) => {
  return object && object.map((tag) => ({
    value: tag,
    label: tag
  }));
};
var buildOptionsResponse = (object) => {
  return object && object.map((item) => {
    return {
      value: item.value,
      label: item.value
    };
  });
};
var getTagTypePerModule = (module2) => {
  switch (module2) {
    case "commissions":
      return 1 /* commission */;
    case "account_companies":
      return 2 /* accountCompany */;
    case "account_users":
      return 3 /* accountUser */;
    case "campaign_opportunities":
      return 5 /* campaignOpportunity */;
    default:
      return 1;
  }
};
var AttributeTagsField = ({
  id,
  name,
  type,
  value,
  options,
  handleChange,
  isReadOnly,
  module: module2
}) => {
  const attributeIdHtml = getAttributeId(id, type);
  const attributeValue = buildOptionsTags(value);
  const [inputValue, setInputValue] = (0, import_react143.useState)("");
  const { onCopy, hasCopied } = (0, import_react141.useClipboard)(value && value.join(", "));
  const { t } = useAuraTranslation_default();
  const { isInvalid } = useAttributeError(id, type);
  const preparedTagType = module2 ? getTagTypePerModule(module2) : 1;
  const { data, isFetching } = useMinimalAutoselect_default({
    endpoint: "markers",
    labelField: ["value"],
    valueField: "id",
    settings: { "page[limit]": 20 },
    filters: {
      "filter[_q][hasText]": inputValue,
      "order[_q]": "DESC",
      "filter[type][eq]": preparedTagType
    },
    translateCustom: true,
    enabled: inputValue != ""
  });
  const parsedOptions = (0, import_react143.useMemo)(() => buildOptionsResponse(data), [data]);
  const updateAttribute = async (newValue) => {
    const labels = newValue == null ? void 0 : newValue.map((val) => val.label);
    if (!newValue) {
      handleChange(null, id);
    } else {
      handleChange(labels, id);
    }
  };
  const handleCreate = async (newValue) => {
    await handleChange(newValue, id, {
      setting: {
        mode_relations_add: true
      }
    });
    setInputValue("");
  };
  const { mutate, isLoading, isError, isSuccess } = (0, import_react_query23.useMutation)((args) => {
    return updateAttribute(args);
  });
  const {
    mutate: mutateCreate,
    isLoading: isLoadingCreate,
    isError: isErrorCreate,
    isSuccess: isSuccessCreate
  } = (0, import_react_query23.useMutation)((args) => {
    return handleCreate(args);
  });
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react141.FormControl, {
    isDisabled: isLoading,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react141.FormLabel, {
        htmlFor: attributeIdHtml,
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AttributeLabel_default, {
          text: name,
          customTranslation: true,
          isSaving: isLoading || isLoadingCreate,
          isError: !!isError || !!isErrorCreate && !isLoading,
          isSuccess: isSuccess || isSuccessCreate,
          tooltipContent: options == null ? void 0 : options.tooltip
        })
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react141.Stack, {
        w: "full",
        isInline: true,
        align: "center",
        spacing: "8px",
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react141.Box, {
            flex: "1",
            children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSelect_default, {
              inputId: attributeIdHtml,
              inputValue,
              className: getAttributeClass(type),
              value: attributeValue ?? [],
              onChange: (e) => mutate(e),
              isMulti: true,
              options: parsedOptions,
              onInputChange: (value2) => setInputValue(value2),
              isLoading: isFetching,
              isReadOnly,
              isError: isInvalid,
              ...!isReadOnly ? {
                additionalActionProps: {
                  titleLabel: t("ADD_TAG"),
                  handleAction: () => mutateCreate(inputValue),
                  alwaysVisible: true
                }
              } : {}
            })
          }),
          !!(attributeValue == null ? void 0 : attributeValue.length) && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react141.IconButton, {
            "aria-label": "copy",
            onClick: onCopy,
            size: "md",
            icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react142.default, {
              path: hasCopied ? import_js25.mdiClipboardCheck : import_js25.mdiClipboardOutline,
              size: "20px"
            })
          })
        ]
      })
    ]
  });
};
var AttributeTagsField_default = AttributeTagsField;

// src/components/Attributes/AttributeChecklistField/AttributeChecklistField.tsx
var import_react144 = require("@chakra-ui/react");
var import_react_query24 = require("react-query");
var import_jsx_runtime = require("react/jsx-runtime");
var AttributeChecklistField = ({
  id,
  name,
  type,
  value,
  options,
  positions,
  handleChange,
  isReadOnly
}) => {
  const attributeIdHtml = getAttributeId(id, type);
  const updateAttribute = (newValue) => {
    return handleChange([newValue], id, {
      setting: {
        mode_relations_add: 1
      }
    });
  };
  const { mutate, isLoading, isError, isSuccess } = (0, import_react_query24.useMutation)(
    (args) => updateAttribute(args)
  );
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react144.FormControl, {
    isDisabled: isLoading,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react144.FormLabel, {
        htmlFor: attributeIdHtml,
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AttributeLabel_default, {
          text: name,
          customTranslation: true,
          isSaving: isLoading,
          isError: !!isError && !isLoading,
          isSuccess,
          tooltipContent: options == null ? void 0 : options.tooltip
        })
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AttributeChecklist_default, {
        id,
        value,
        onChange: mutate,
        isReadOnly
      })
    ]
  });
};
var AttributeChecklistField_default = AttributeChecklistField;

// src/components/Attributes/FormAttributes/FormAttributeTextField/FormAttributeTextField.tsx
var import_react145 = require("@chakra-ui/react");
var import_react_hook_form2 = require("react-hook-form");

// src/components/Attributes/FormAttributes/utils.ts
var parseAttributeNameFormPrefix = (attributeNamePrefix) => {
  var _a2, _b;
  return (_b = (_a2 = attributeNamePrefix == null ? void 0 : attributeNamePrefix.split(".")) == null ? void 0 : _a2.filter((element) => element.trim() !== "")) == null ? void 0 : _b.join("-");
};
var preparePositionAttributesWithValues = (meta, attributes, forceIsReadOnly = false) => {
  return meta == null ? void 0 : meta.map((attr) => {
    var _a2;
    const value = (_a2 = attributes == null ? void 0 : attributes.find(
      (attribute) => attribute.column.id === `attribute.${attr.id}`
    )) == null ? void 0 : _a2.value;
    return {
      ...attr,
      isReadOnly: forceIsReadOnly ? true : attr.credential === 1,
      value
    };
  });
};
var prepareAttributeFormValues = ({
  attributes
}) => {
  return attributes == null ? void 0 : attributes.reduce((acc, attr) => {
    var _a2, _b, _c, _d, _e;
    const key = getAttributeId(attr == null ? void 0 : attr.id, attr == null ? void 0 : attr.type);
    if (attr.type === "list") {
      acc[key] = (_c = (_b = (_a2 = attr == null ? void 0 : attr.value) == null ? void 0 : _a2.filter((opt) => opt.selected === true)) == null ? void 0 : _b.map((opt) => opt == null ? void 0 : opt.id)) == null ? void 0 : _c[0];
    } else if (attr.type === "listMulti") {
      acc[key] = (_e = (_d = attr == null ? void 0 : attr.value) == null ? void 0 : _d.filter((opt) => opt.selected === true)) == null ? void 0 : _e.map((opt) => opt == null ? void 0 : opt.id);
    } else {
      acc[key] = attr == null ? void 0 : attr.value;
    }
    return acc;
  }, {});
};

// src/components/Attributes/FormAttributes/FormAttributeTextField/FormAttributeTextField.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var AttributeTextField2 = ({
  id,
  name,
  type,
  value,
  options,
  handleChange,
  isReadOnly,
  isInline,
  attributeNamePrefix = ""
}) => {
  var _a2, _b;
  const { t } = useAuraTranslation_default();
  const attributeId = `${attributeNamePrefix}attribute__${type}-${id}`;
  const attributeIdForController = attributeNamePrefix ? `${attributeNamePrefix}attributes.${id}` : `attributes.${attributeId}`;
  const attributeIdHtml = getAttributeId(
    id,
    type,
    parseAttributeNameFormPrefix(attributeNamePrefix)
  );
  const {
    control,
    formState: { errors }
  } = (0, import_react_hook_form2.useFormContext)();
  const formError = attributeNamePrefix ? (_a2 = errors == null ? void 0 : errors[`${attributeNamePrefix}attributes`]) == null ? void 0 : _a2.id : (_b = errors == null ? void 0 : errors.attributes) == null ? void 0 : _b[attributeId];
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react145.FormControl, {
    isInvalid: !!formError,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react145.FormLabel, {
        htmlFor: attributeIdHtml,
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AttributeLabel_default, {
          text: name,
          customTranslation: true,
          isRequired: options == null ? void 0 : options.isRequired
        })
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form2.Controller, {
        name: attributeIdForController,
        control,
        ...(options == null ? void 0 : options.isRequired) && {
          rules: {
            required: {
              value: true,
              message: "ERROR_FIELD_IS_EMPTY"
            }
          }
        },
        render: ({ field }) => {
          return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AttributeText_default, {
            pl: 2,
            id,
            isReadOnly,
            prefix: parseAttributeNameFormPrefix(attributeNamePrefix),
            ...field,
            value: field.value ?? "",
            ...attributeNamePrefix !== "" && {
              w: isInline ? "500px" : "full"
            },
            onChange: (value2) => {
              field.onChange(value2);
              field.onBlur();
            }
          });
        }
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react145.FormErrorMessage, {
        children: t(formError == null ? void 0 : formError.message)
      })
    ]
  });
};
var FormAttributeTextField_default = AttributeTextField2;

// src/components/Attributes/Attributes.tsx
var import_isUndefined2 = __toESM(require("lodash/isUndefined"));

// src/components/Attributes/FormAttributes/FormAttributeNumberField/FormAttributeNumberField.tsx
var import_react146 = require("@chakra-ui/react");
var import_react_hook_form3 = require("react-hook-form");
var import_jsx_runtime = require("react/jsx-runtime");
var FormAttributeNumberField = ({
  id,
  name,
  type,
  value,
  options,
  handleChange,
  isReadOnly,
  isInline,
  attributeNamePrefix = ""
}) => {
  var _a2, _b;
  const { t } = useAuraTranslation_default();
  const attributeId = `${attributeNamePrefix}attribute__${type}-${id}`;
  const attributeIdForController = attributeNamePrefix ? `${attributeNamePrefix}attributes.${id}` : `attributes.${attributeId}`;
  const attributeIdHtml = getAttributeId(
    id,
    type,
    parseAttributeNameFormPrefix(attributeNamePrefix)
  );
  const {
    control,
    formState: { errors }
  } = (0, import_react_hook_form3.useFormContext)();
  const formError = attributeNamePrefix ? (_a2 = errors == null ? void 0 : errors[`${attributeNamePrefix}attributes`]) == null ? void 0 : _a2.id : (_b = errors == null ? void 0 : errors.attributes) == null ? void 0 : _b[attributeId];
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react146.FormControl, {
    ...attributeNamePrefix !== "" && { w: isInline ? "245px" : "full" },
    isInvalid: !!formError,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react146.FormLabel, {
        htmlFor: attributeIdHtml,
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AttributeLabel_default, {
          text: name,
          customTranslation: true,
          isRequired: options == null ? void 0 : options.isRequired
        })
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form3.Controller, {
        name: attributeIdForController,
        control,
        ...(options == null ? void 0 : options.isRequired) && {
          rules: {
            required: {
              value: true,
              message: "ERROR_FIELD_IS_EMPTY"
            }
          }
        },
        render: ({ field }) => {
          return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AttributeNumber_default, {
            id,
            prefix: parseAttributeNameFormPrefix(attributeNamePrefix),
            isReadOnly,
            ...field,
            onChange: (value2) => {
              field.onChange(value2);
              field.onBlur();
            }
          });
        }
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react146.FormErrorMessage, {
        children: t(formError == null ? void 0 : formError.message)
      })
    ]
  });
};
var FormAttributeNumberField_default = FormAttributeNumberField;

// src/components/Attributes/FormAttributes/FormAttributeDateField/FormAttributeDateField.tsx
var import_react147 = require("@chakra-ui/react");
var import_react_hook_form4 = require("react-hook-form");
var import_jsx_runtime = require("react/jsx-runtime");
var FormAttributeDateField = ({
  id,
  name,
  type,
  value,
  options,
  handleChange,
  isReadOnly,
  isInline,
  attributeNamePrefix = ""
}) => {
  var _a2, _b;
  const { t } = useAuraTranslation_default();
  const attributeId = `${attributeNamePrefix}attribute__${type}-${id}`;
  const attributeIdForController = attributeNamePrefix ? `${attributeNamePrefix}attributes.${id}` : `attributes.${attributeId}`;
  const parsedPrefix = parseAttributeNameFormPrefix(attributeNamePrefix);
  const attributeIdHtml = getAttributeId(id, type, parsedPrefix);
  const {
    control,
    formState: { errors }
  } = (0, import_react_hook_form4.useFormContext)();
  const formError = attributeNamePrefix ? (_a2 = errors == null ? void 0 : errors[`${attributeNamePrefix}attributes`]) == null ? void 0 : _a2.id : (_b = errors == null ? void 0 : errors.attributes) == null ? void 0 : _b[attributeId];
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react147.FormControl, {
    ...attributeNamePrefix !== "" && { w: isInline ? "245px" : "full" },
    isInvalid: !!formError,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react147.FormLabel, {
        htmlFor: attributeIdHtml,
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AttributeLabel_default, {
          text: name,
          customTranslation: true,
          isRequired: options == null ? void 0 : options.isRequired
        })
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form4.Controller, {
        name: attributeIdForController,
        control,
        ...(options == null ? void 0 : options.isRequired) && {
          rules: {
            required: {
              value: true,
              message: "ERROR_FIELD_IS_EMPTY"
            }
          }
        },
        render: ({ field }) => {
          return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AttributeDate_default, {
            id,
            isReadOnly,
            prefix: parsedPrefix,
            ...field,
            onChange: (value2) => {
              field.onChange(value2);
              field.onBlur();
            }
          });
        }
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react147.FormErrorMessage, {
        children: t(formError == null ? void 0 : formError.message)
      })
    ]
  });
};
var FormAttributeDateField_default = FormAttributeDateField;

// src/components/Attributes/FormAttributes/FormAttributeListOne/FormAttributeListOne.tsx
var import_react148 = require("@chakra-ui/react");
var import_react_hook_form5 = require("react-hook-form");
var import_find = __toESM(require("lodash/find"));
var import_jsx_runtime = require("react/jsx-runtime");
var FormAttributeListOne = ({
  id,
  name,
  type,
  value,
  options,
  positions,
  handleChange,
  isReadOnly,
  isInline,
  attributeNamePrefix = ""
}) => {
  var _a2, _b;
  const { t, tCustom } = useAuraTranslation_default();
  const searchingForOptions = options == null ? void 0 : options.searchingForOptions;
  const attributeId = `${attributeNamePrefix}attribute__${type}-${id}`;
  const attributeIdForController = attributeNamePrefix ? `${attributeNamePrefix}attributes.${id}` : `attributes.${attributeId}`;
  const attributeIdHtml = getAttributeId(
    id,
    type,
    parseAttributeNameFormPrefix(attributeNamePrefix)
  );
  const {
    control,
    formState: { errors }
  } = (0, import_react_hook_form5.useFormContext)();
  const selectOptions = positions && [...positions].sort((a, b) => {
    return a.ordering - b.ordering;
  }).map((option) => ({
    value: option.id,
    label: tCustom(option.value),
    selected: value === option.id,
    "data-option-id": option.id
  }));
  const formError = attributeNamePrefix ? (_a2 = errors == null ? void 0 : errors[`${attributeNamePrefix}attributes`]) == null ? void 0 : _a2.id : (_b = errors == null ? void 0 : errors.attributes) == null ? void 0 : _b[attributeId];
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react148.FormControl, {
    ...attributeNamePrefix !== "" && {
      w: isInline ? "245px" : "full",
      contentEditable: !isReadOnly,
      suppressContentEditableWarning: true
    },
    isInvalid: !!formError,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react148.FormLabel, {
        htmlFor: attributeIdHtml,
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AttributeLabel_default, {
          text: name,
          customTranslation: true,
          isRequired: options == null ? void 0 : options.isRequired
        })
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form5.Controller, {
        name: attributeIdForController,
        control,
        ...(options == null ? void 0 : options.isRequired) && {
          rules: {
            required: {
              value: true,
              message: "ERROR_FIELD_IS_EMPTY"
            }
          }
        },
        render: ({ field }) => {
          const selectedValue = (0, import_find.default)(selectOptions, {
            value: field.value
          });
          return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSelect_default, {
            inputId: attributeIdHtml,
            className: getAttributeClass(type),
            options: selectOptions,
            defaultOption: !searchingForOptions,
            isReadOnly,
            ...field,
            value: selectedValue,
            onChange: (value2) => {
              field.onChange((value2 == null ? void 0 : value2.value) ?? null);
              field.onBlur();
            },
            isError: !!formError
          });
        }
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react148.FormErrorMessage, {
        children: t(formError == null ? void 0 : formError.message)
      })
    ]
  });
};
var FormAttributeListOne_default = FormAttributeListOne;

// src/components/Attributes/FormAttributes/FormAttributeListMulti/FormAttributeListMulti.tsx
var import_react149 = require("@chakra-ui/react");
var import_react_hook_form6 = require("react-hook-form");
var import_jsx_runtime = require("react/jsx-runtime");
var FormAttributeListMulti = ({
  id,
  name,
  type,
  value,
  options,
  positions,
  isReadOnly,
  isInline,
  attributeNamePrefix = ""
}) => {
  var _a2, _b, _c;
  const { t, tCustom } = useAuraTranslation_default();
  const searchingForOptions = options == null ? void 0 : options.searchingForOptions;
  const attributeId = `${attributeNamePrefix}attribute__${type}-${id}`;
  const attributeIdForController = attributeNamePrefix ? `${attributeNamePrefix}attributes.${id}` : `attributes.${attributeId}`;
  const parsedPrefix = parseAttributeNameFormPrefix(attributeNamePrefix);
  const attributeIdHtml = getAttributeId(id, type, parsedPrefix);
  const asTag = (options == null ? void 0 : options.asTag) ?? false;
  const {
    control,
    formState: { errors }
  } = (0, import_react_hook_form6.useFormContext)();
  const initialValue = (_a2 = value == null ? void 0 : value.map((val) => val.selected)) == null ? void 0 : _a2.map((val) => val.id);
  const selectOptions = positions && [...positions].sort((a, b) => {
    return a.ordering - b.ordering;
  }).map((option) => ({
    value: option.id,
    label: tCustom(option.value),
    selected: initialValue == null ? void 0 : initialValue.includes(option.id)
  }));
  const formError = attributeNamePrefix ? (_b = errors == null ? void 0 : errors[`${attributeNamePrefix}attributes`]) == null ? void 0 : _b.id : (_c = errors == null ? void 0 : errors.attributes) == null ? void 0 : _c[attributeId];
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react149.FormControl, {
    ...attributeNamePrefix !== "" && {
      w: isInline ? "245px" : "full",
      ...asTag && {
        contentEditable: !isReadOnly,
        suppressContentEditableWarning: true
      }
    },
    isInvalid: !!formError,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react149.FormLabel, {
        htmlFor: attributeIdHtml,
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AttributeLabel_default, {
          text: name,
          customTranslation: true,
          isRequired: options == null ? void 0 : options.isRequired
        })
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form6.Controller, {
        name: attributeIdForController,
        control,
        ...(options == null ? void 0 : options.isRequired) && {
          rules: {
            required: {
              value: true,
              message: "ERROR_FIELD_IS_EMPTY"
            }
          }
        },
        render: ({ field }) => {
          const selectedValue = selectOptions == null ? void 0 : selectOptions.filter(
            (opt) => {
              var _a3;
              return (_a3 = field.value) == null ? void 0 : _a3.includes(opt.value);
            }
          );
          return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, {
            children: asTag ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSelect_default, {
              inputId: attributeIdHtml,
              options: selectOptions,
              defaultOption: !searchingForOptions,
              isReadOnly,
              ...field,
              value: selectedValue,
              onChange: (newValue) => {
                const preparedValues = newValue == null ? void 0 : newValue.map(
                  (item) => item.value
                );
                field.onChange(preparedValues ?? null);
                field.onBlur();
              },
              isMulti: true
            }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AttributeList_default, {
              id,
              prefix: parsedPrefix,
              options: selectOptions.map((opt) => {
                return { id: opt.value, label: tCustom(opt.label) };
              }),
              isReadOnly,
              ...field,
              value: field.value ?? [],
              onChange: (newValue) => {
                const preparedValues = newValue == null ? void 0 : newValue.map(
                  (opt) => Number.parseInt(opt)
                );
                field.onChange(preparedValues);
                field.onBlur();
              },
              toForm: true
            })
          });
        }
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react149.FormErrorMessage, {
        children: t(formError == null ? void 0 : formError.message)
      })
    ]
  });
};
var FormAttributeListMulti_default = FormAttributeListMulti;

// src/components/Attributes/FormAttributes/FormAttributeAttachments/FormAttributeAttachments.tsx
var import_react150 = require("@chakra-ui/react");
var import_react151 = require("react");
var import_react_hook_form7 = require("react-hook-form");
var import_jsx_runtime = require("react/jsx-runtime");
var FormAttributeAttachments = ({
  id,
  name,
  value = [],
  type,
  options,
  handleChange,
  isReadOnly,
  isInline,
  attributeNamePrefix = ""
}) => {
  var _a2, _b;
  const { t } = useAuraTranslation_default();
  const {
    control,
    setValue,
    formState: { errors },
    getValues
  } = (0, import_react_hook_form7.useFormContext)();
  const attributeId = `${attributeNamePrefix}attribute__${type}-${id}`;
  const attributeIdForController = attributeNamePrefix ? `${attributeNamePrefix}attributes.${id}` : `attributes.${attributeId}`;
  const parsedPrefix = parseAttributeNameFormPrefix(attributeNamePrefix);
  const attributeIdHtml = getAttributeId(id, type, parsedPrefix);
  const [files, setFiles] = (0, import_react151.useState)(value && prepareFiles([...value]));
  const setAttributeFormValue = (newValue, shouldDirty = true, shouldTouch) => {
    setValue(attributeIdForController, newValue, { shouldDirty, shouldTouch });
  };
  (0, import_react151.useEffect)(() => {
    const initialValue = (value == null ? void 0 : value.length) ? value : getValues(attributeIdForController);
    if (initialValue == null ? void 0 : initialValue.length) {
      setAttributeFormValue(initialValue, false, false);
      setFiles(prepareFiles([...initialValue]));
    } else {
      setAttributeFormValue([], false, false);
      setFiles([]);
    }
  }, []);
  const handleFileConnect = (responseData) => {
    const preparedFiles = [...files, ...prepareFiles(responseData)];
    setFiles(preparedFiles);
    setAttributeFormValue(preparedFiles, true, true);
  };
  const handleFileDelete = async (removeFileId) => {
    const shouldDelete = confirm(t("PROCESS_DELETE_FILE_CONFIRM"));
    if (!shouldDelete) {
      return;
    }
    const preparedFiles = files == null ? void 0 : files.filter(
      (file) => file.id !== removeFileId
    );
    setAttributeFormValue(preparedFiles, true, true);
    setFiles(preparedFiles);
  };
  const { mutate } = useFileUpload({
    attributeId: id,
    handleFileConnect,
    allFileDetails: true
  });
  const formError = attributeNamePrefix ? (_a2 = errors == null ? void 0 : errors[`${attributeNamePrefix}attributes`]) == null ? void 0 : _a2.id : (_b = errors == null ? void 0 : errors.attributes) == null ? void 0 : _b[attributeId];
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react150.FormControl, {
    isInvalid: !!formError,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react150.FormLabel, {
        htmlFor: attributeIdHtml,
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AttributeLabel_default, {
          id: attributeIdForController,
          text: name,
          customTranslation: true,
          numberAlerts: files == null ? void 0 : files.length,
          isUploadFilesButton: !isReadOnly,
          onClickUploadFiles: (files2) => {
            return mutate(files2);
          },
          isRequired: options == null ? void 0 : options.isRequired
        })
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form7.Controller, {
        name: attributeIdForController,
        control,
        ...(options == null ? void 0 : options.isRequired) && {
          rules: {
            required: {
              value: true,
              message: "ERROR_FIELD_IS_EMPTY"
            }
          }
        },
        render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AttributeFile_default, {
          id,
          onFileDelete: handleFileDelete,
          prefix: parsedPrefix,
          children: files == null ? void 0 : files.map((file) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AttributeFileItem_default, {
            files,
            file,
            onDelete: handleFileDelete,
            isReadOnly
          }, file.id))
        })
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react150.FormErrorMessage, {
        children: t(formError == null ? void 0 : formError.message)
      })
    ]
  });
};
var FormAttributeAttachments_default = FormAttributeAttachments;

// src/components/Attributes/FormAttributes/FormAttributeHTML/FormAttributeHTML.tsx
var import_react152 = require("@chakra-ui/react");
var import_react153 = require("react");
var import_react_hook_form8 = require("react-hook-form");
var import_jsx_runtime = require("react/jsx-runtime");
var FormAttributeHTML = ({
  id,
  name,
  type,
  value,
  options,
  handleChange,
  isReadOnly,
  isInline,
  attributeNamePrefix = ""
}) => {
  const { language } = (0, import_react153.useContext)(LanguageContext);
  const [editing, setEditing] = (0, import_react153.useState)(false);
  const attributeId = `${attributeNamePrefix}attribute__${type}-${id}`;
  const attributeIdForController = attributeNamePrefix ? `${attributeNamePrefix}attributes.${id}` : `attributes.${attributeId}`;
  const parsedPrefix = parseAttributeNameFormPrefix(attributeNamePrefix);
  const attributeIdHtml = getAttributeId(id, type, parsedPrefix);
  const { control, setValue } = (0, import_react_hook_form8.useFormContext)();
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react152.FormControl, {
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react152.FormLabel, {
        htmlFor: attributeIdHtml,
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AttributeLabel_default, {
          text: name,
          customTranslation: true,
          isEditButton: !isReadOnly,
          onClick: () => setEditing(!editing),
          isRequired: options == null ? void 0 : options.isRequired
        })
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form8.Controller, {
        name: attributeIdForController,
        control,
        render: ({ field }) => {
          return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AttributeHtml_default, {
            id,
            ...attributeNamePrefix && {
              prefix: parsedPrefix
            },
            isReadOnly: !editing,
            language,
            value: field.value,
            onChange: (event) => {
              setValue(attributeIdForController, event.editor.getData(), {
                shouldDirty: true,
                shouldTouch: true
              });
            },
            ...attributeNamePrefix !== "" && {
              w: isInline ? "500px" : "full"
            }
          });
        }
      })
    ]
  });
};
var FormAttributeHTML_default = FormAttributeHTML;

// src/components/Attributes/AttributePhone/AttributePhone.tsx
var import_react154 = require("@chakra-ui/react");
var import_react155 = require("react");
var import_react_query25 = require("react-query");
var import_jsx_runtime = require("react/jsx-runtime");
var validateAttributePhone = (oldValue, newValue) => {
  if (oldValue === newValue) {
    return false;
  }
  if (oldValue === null && newValue) {
    return true;
  }
  if (oldValue !== null && oldValue !== newValue) {
    return true;
  }
  return false;
};
var AttributePhone = ({
  id,
  name,
  type,
  value,
  options,
  handleChange,
  isReadOnly
}) => {
  const attributeIdHtml = getAttributeId(id, type);
  const [attributeValue, setAttributeValue] = (0, import_react155.useState)(value);
  const { isInvalid } = useAttributeError(id, type);
  (0, import_react155.useEffect)(() => {
    setAttributeValue(value);
  }, [value]);
  const { mutate, isLoading, isError, isSuccess } = (0, import_react_query25.useMutation)((newValue) => {
    return handleChange(newValue, id);
  });
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react154.FormControl, {
    isDisabled: isLoading,
    isInvalid: isInvalid || !!isError,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react154.FormLabel, {
        htmlFor: attributeIdHtml,
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AttributeLabel_default, {
          text: name,
          customTranslation: true,
          isSaving: isLoading,
          isError: !!isError && !isLoading,
          isSuccess,
          tooltipContent: options == null ? void 0 : options.tooltip
        })
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraInput_default, {
        pl: 2,
        onChange: (e) => setAttributeValue(e.target.value),
        onBlur: (e) => validateAttributePhone(value, e.target.value) && mutate(e.target.value),
        value: attributeValue || "",
        id: `${id}`,
        isReadOnly,
        type: "tel"
      })
    ]
  });
};
var AttributePhone_default = AttributePhone;

// src/components/Attributes/AttributeSignature/AttributeSignature.tsx
var import_react156 = require("@chakra-ui/react");
var import_axios6 = __toESM(require("axios"));
var import_react157 = require("react");
var import_react_query26 = require("react-query");
var import_react_signature_canvas = __toESM(require("react-signature-canvas"));
var import_react158 = __toESM(require("@mdi/react"));
var import_js26 = require("@mdi/js");
var import_jsx_runtime = require("react/jsx-runtime");
var AttributeSignature = ({
  id,
  name,
  type,
  value,
  options,
  handleChange,
  isReadOnly
}) => {
  const { t } = useAuraTranslation_default();
  const attributeIdHtml = getAttributeId(id, type);
  const { isInvalid } = useAttributeError(id, type);
  const { isOpen, onOpen, onClose } = (0, import_react156.useDisclosure)();
  const [fileUploadError, setFileUploadError] = (0, import_react157.useState)(false);
  const [signaturePadRef, setSignaturePadRef] = (0, import_react157.useState)(null);
  const handleSaveSignature = async () => {
    const formData = new FormData();
    const blob = await new Promise((resolve, reject) => {
      signaturePadRef.getCanvas().toBlob((blob2) => {
        resolve(blob2);
      });
    });
    formData.append(`data_files`, blob, `signature-${name}-${id}.png`);
    const fileResponse = await import_axios6.default.post("/api/files/upload", formData);
    if (fileResponse.data.errors) {
      onClose();
      setFileUploadError(true);
      return;
    }
    onClose();
    setFileUploadError(false);
    return handleChange(fileResponse.data.data[0].id, id, {
      mode_relations_add: 1
    });
  };
  const { mutate, isLoading, isError, isSuccess } = (0, import_react_query26.useMutation)(() => {
    return handleSaveSignature();
  });
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react156.FormControl, {
        isDisabled: isLoading,
        isInvalid: !!isError || fileUploadError || isInvalid,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react156.FormLabel, {
            htmlFor: attributeIdHtml,
            children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AttributeLabel_default, {
              text: name,
              customTranslation: true,
              isSaving: isLoading,
              isError: !!isError && !isLoading || fileUploadError,
              isSuccess,
              ...isReadOnly ? {} : {
                buttonContent: t("ADD_SIGNATURE"),
                onClick: onOpen
              },
              tooltipContent: options == null ? void 0 : options.tooltip
            })
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react156.Box, {
            opacity: isLoading ? 0.4 : 1,
            children: value && /* @__PURE__ */ (0, import_jsx_runtime.jsx)("img", {
              src: `/file/show/file/${value.dbName}`,
              alt: "podpis"
            })
          })
        ]
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(AuraModal, {
        size: "xl",
        isOpen,
        onClose,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalOverlay, {}),
          /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(AuraModalContent, {
            as: "form",
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalHeader, {
                children: t("ADD_SIGNATURE")
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalBody, {
                display: "flex",
                justifyContent: "center",
                children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react156.Box, {
                  w: "400px",
                  height: "200px",
                  borderRadius: "6px",
                  border: 1,
                  borderStyle: "solid",
                  borderColor: "gray.200",
                  ...!!isError || fileUploadError ? {
                    border: "1px solid #E53E3E",
                    boxShadow: "0 0 0 1px #E53E3E"
                  } : null,
                  children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_signature_canvas.default, {
                    ref: (ref) => {
                      setSignaturePadRef(ref);
                    },
                    canvasProps: { width: 400, height: 200 }
                  })
                })
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(AuraModalFooter, {
                showBorders: false,
                display: "flex",
                justifyContent: "space-between",
                children: [
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react156.IconButton, {
                    icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react158.default, {
                      path: import_js26.mdiEraser,
                      size: "24px"
                    }),
                    "aria-label": "clear signature",
                    onClick: () => signaturePadRef.clear()
                  }),
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react156.Button, {
                    textTransform: "capitalize",
                    isLoading,
                    colorScheme: "blue",
                    onClick: () => mutate(),
                    children: t("SAVE")
                  })
                ]
              })
            ]
          })
        ]
      })
    ]
  });
};
var AttributeSignature_default = AttributeSignature;

// src/components/Attributes/AttributeChat/AttributeChat.tsx
var import_react159 = require("@chakra-ui/react");
var import_react160 = require("react");
var import_react_query27 = require("react-query");
var import_date_fns10 = require("date-fns");
var import_jsx_runtime = require("react/jsx-runtime");
var AttributeChat2 = ({
  id,
  name,
  type,
  value,
  options,
  handleChange,
  isReadOnly
}) => {
  const attributeIdHtml = getAttributeId(id, type);
  const { isInvalid } = useAttributeError(id, type);
  const { mutate, isLoading, isError, isSuccess } = (0, import_react_query27.useMutation)((newValue) => {
    return handleChange(newValue, id);
  });
  const preparedData = (0, import_react160.useMemo)(
    () => value == null ? void 0 : value.map((item) => {
      var _a2, _b, _c, _d;
      return {
        id: item.id,
        username: (_a2 = item == null ? void 0 : item.sender) == null ? void 0 : _a2.fullName,
        avatarUrl: (_d = (_c = (_b = item == null ? void 0 : item.sender) == null ? void 0 : _b.avatar) == null ? void 0 : _c.uris) == null ? void 0 : _d.show,
        createdDate: (0, import_date_fns10.parseISO)(item == null ? void 0 : item.sentDate),
        content: item == null ? void 0 : item.message
      };
    }),
    [value]
  );
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react159.FormControl, {
    isDisabled: isLoading,
    isInvalid: isInvalid || !!isError,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react159.FormLabel, {
        htmlFor: attributeIdHtml,
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AttributeLabel_default, {
          text: name,
          customTranslation: true,
          isSaving: isLoading,
          isError: !!isError && !isLoading,
          isSuccess,
          tooltipContent: options == null ? void 0 : options.tooltip
        })
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AttributeChat_default, {
        id,
        value: preparedData,
        onChange: (value2) => mutate(value2),
        isReadOnly,
        isLoading
      })
    ]
  });
};
var AttributeChat_default2 = AttributeChat2;

// src/components/Attributes/Attributes.tsx
var import_react_hook_form17 = require("react-hook-form");

// src/components/Attributes/FormAttributes/FormAttributeUser/FormAttributeUser.tsx
var import_react161 = require("@chakra-ui/react");
var import_react_hook_form9 = require("react-hook-form");
var import_jsx_runtime = require("react/jsx-runtime");
var FormAttributeUser = ({
  id,
  name,
  type,
  value,
  options,
  positions,
  handleChange,
  isReadOnly,
  isInline,
  attributeNamePrefix = ""
}) => {
  var _a2, _b;
  const { t } = useAuraTranslation_default();
  const {
    control,
    formState: { errors }
  } = (0, import_react_hook_form9.useFormContext)();
  const attributeId = `${attributeNamePrefix}attribute__${type}-${id}`;
  const attributeIdForController = attributeNamePrefix ? `${attributeNamePrefix}attributes.${id}` : `attributes.${attributeId}`;
  const attributeIdHtml = getAttributeId(
    id,
    type,
    parseAttributeNameFormPrefix(attributeNamePrefix)
  );
  const { data: userUsers } = useMinimalAutoselect_default({
    endpoint: "user_users",
    labelField: "fullName",
    valueField: "id",
    extraFields: ["fullName"],
    fields: ["avatar", "defaultCallendarColor"],
    additionalOptionField: [
      { field: "avatar", source: "avatar" },
      { field: "label", source: "fullName" },
      { field: "value", source: "id" },
      { field: "defaultCallendarColor", source: "defaultCallendarColor" }
    ]
  });
  const formError = attributeNamePrefix ? (_a2 = errors == null ? void 0 : errors[`${attributeNamePrefix}attributes`]) == null ? void 0 : _a2.id : (_b = errors == null ? void 0 : errors.attributes) == null ? void 0 : _b[attributeId];
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react161.FormControl, {
    ...attributeNamePrefix !== "" && {
      w: isInline ? "245px" : "full",
      contentEditable: !isReadOnly,
      suppressContentEditableWarning: true
    },
    isInvalid: !!formError,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react161.FormLabel, {
        htmlFor: attributeIdHtml,
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AttributeLabel_default, {
          text: name,
          customTranslation: true,
          isRequired: options == null ? void 0 : options.isRequired
        })
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form9.Controller, {
        name: attributeIdForController,
        control,
        ...(options == null ? void 0 : options.isRequired) && {
          rules: {
            required: {
              value: true,
              message: "ERROR_FIELD_IS_EMPTY"
            }
          }
        },
        render: ({ field }) => {
          const selectedValues = userUsers == null ? void 0 : userUsers.filter(
            (opt) => {
              var _a3;
              return (_a3 = field.value) == null ? void 0 : _a3.includes(opt.value);
            }
          );
          return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSelect_default, {
            inputId: attributeIdHtml,
            isMulti: true,
            withAvatars: true,
            withCheckbox: true,
            className: getAttributeClass(type),
            options: userUsers,
            isReadOnly,
            ...field,
            value: selectedValues,
            onChange: (newValue) => {
              const preparedValues = newValue == null ? void 0 : newValue.map((item) => item.value);
              field.onChange(preparedValues ?? null);
              field.onBlur();
            },
            isError: !!formError
          });
        }
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react161.FormErrorMessage, {
        children: t(formError == null ? void 0 : formError.message)
      })
    ]
  });
};
var FormAttributeUser_default = FormAttributeUser;

// src/components/Attributes/FormAttributes/FormAttributeTagsField/FormAttributeTagsField.tsx
var import_react162 = require("@chakra-ui/react");
var import_js27 = require("@mdi/js");
var import_react163 = __toESM(require("@mdi/react"));
var import_react164 = require("react");
var import_react_hook_form10 = require("react-hook-form");
var import_jsx_runtime = require("react/jsx-runtime");
var buildOptionsTags2 = (object) => {
  return object && object.map((tag) => ({
    value: tag,
    label: tag
  }));
};
var buildOptionsResponse2 = (object) => {
  return object && object.map((item) => {
    return {
      value: item.value,
      label: item.value
    };
  });
};
var getTagTypePerModule2 = (module2) => {
  switch (module2) {
    case "commissions":
      return 1 /* commission */;
    case "account_companies":
      return 2 /* accountCompany */;
    case "account_users":
      return 3 /* accountUser */;
    case "campaign_opportunities":
      return 5 /* campaignOpportunity */;
    default:
      return 1;
  }
};
var AttributeTagsField2 = ({
  id,
  name,
  type,
  value,
  options,
  handleChange,
  isReadOnly,
  module: module2,
  isInline,
  attributeNamePrefix = ""
}) => {
  var _a2, _b;
  const { t } = useAuraTranslation_default();
  const attributeId = `${attributeNamePrefix}attribute__${type}-${id}`;
  const attributeIdForController = attributeNamePrefix ? `${attributeNamePrefix}attributes.${id}` : `attributes.${attributeId}`;
  const attributeIdHtml = getAttributeId(
    id,
    type,
    parseAttributeNameFormPrefix(attributeNamePrefix)
  );
  const {
    control,
    formState: { errors },
    getValues
  } = (0, import_react_hook_form10.useFormContext)();
  const initialValue = value ?? getValues(attributeIdForController) ?? [];
  const [attributeValue, setAttributeValue] = (0, import_react164.useState)(
    buildOptionsTags2(initialValue)
  );
  const [inputValue, setInputValue] = (0, import_react164.useState)("");
  const { onCopy, hasCopied } = (0, import_react162.useClipboard)(value && value.join(", "));
  const formError = attributeNamePrefix ? (_a2 = errors == null ? void 0 : errors[`${attributeNamePrefix}attributes`]) == null ? void 0 : _a2.id : (_b = errors == null ? void 0 : errors.attributes) == null ? void 0 : _b[attributeId];
  const preparedTagType = module2 ? getTagTypePerModule2(module2) : 1;
  const { data, isFetching } = useMinimalAutoselect_default({
    endpoint: "markers",
    labelField: ["value"],
    valueField: "id",
    settings: { "page[limit]": 20 },
    filters: {
      "filter[_q][hasText]": inputValue,
      "order[_q]": "DESC",
      "filter[type][eq]": preparedTagType
    },
    translateCustom: true,
    enabled: inputValue != ""
  });
  const parsedOptions = (0, import_react164.useMemo)(() => buildOptionsResponse2(data), [data]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react162.FormControl, {
    isInvalid: !!formError,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react162.FormLabel, {
        htmlFor: attributeIdHtml,
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AttributeLabel_default, {
          text: name,
          customTranslation: true,
          tooltipContent: options == null ? void 0 : options.tooltip,
          isRequired: options == null ? void 0 : options.isRequired
        })
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form10.Controller, {
        name: attributeIdForController,
        control,
        ...(options == null ? void 0 : options.isRequired) && {
          rules: {
            required: {
              value: true,
              message: "ERROR_FIELD_IS_EMPTY"
            }
          }
        },
        render: ({ field }) => {
          return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react162.Stack, {
            w: "full",
            isInline: true,
            align: "center",
            spacing: "8px",
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react162.Box, {
                flex: "1",
                children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSelect_default, {
                  inputId: attributeIdHtml,
                  inputValue,
                  className: getAttributeClass(type),
                  isMulti: true,
                  options: parsedOptions,
                  onInputChange: (value2) => setInputValue(value2),
                  isLoading: isFetching,
                  isReadOnly,
                  isError: !!formError,
                  ...field,
                  value: attributeValue ?? [],
                  onChange: (value2) => {
                    const parsedValue = value2 == null ? void 0 : value2.map(
                      (item) => item.value
                    );
                    field.onChange(parsedValue);
                    field.onBlur();
                    setAttributeValue(value2);
                  }
                })
              }),
              !(options == null ? void 0 : options.hideCopyAction) && !!(attributeValue == null ? void 0 : attributeValue.length) && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react162.IconButton, {
                "aria-label": "copy",
                onClick: onCopy,
                size: "md",
                icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react163.default, {
                  path: hasCopied ? import_js27.mdiClipboardCheck : import_js27.mdiClipboardOutline,
                  size: "20px"
                })
              })
            ]
          });
        }
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react162.FormErrorMessage, {
        children: t(formError == null ? void 0 : formError.message)
      })
    ]
  });
};
var FormAttributeTagsField_default = AttributeTagsField2;

// src/components/Attributes/FormAttributes/FormAttributeBooleanField/FormAttributeBooleanField.tsx
var import_react165 = require("@chakra-ui/react");
var import_react_hook_form11 = require("react-hook-form");
var import_jsx_runtime = require("react/jsx-runtime");
var FormAttributeBooleanField = ({
  id,
  name,
  type,
  value,
  options,
  handleChange,
  isReadOnly,
  isInline,
  attributeNamePrefix = ""
}) => {
  var _a2, _b;
  const { t } = useAuraTranslation_default();
  const attributeId = `${attributeNamePrefix}attribute__${type}-${id}`;
  const attributeIdForController = attributeNamePrefix ? `${attributeNamePrefix}attributes.${id}` : `attributes.${attributeId}`;
  const parsedPrefix = parseAttributeNameFormPrefix(attributeNamePrefix);
  const attributeIdHtml = getAttributeId(id, type, parsedPrefix);
  const {
    control,
    formState: { errors }
  } = (0, import_react_hook_form11.useFormContext)();
  const formError = attributeNamePrefix ? (_a2 = errors == null ? void 0 : errors[`${attributeNamePrefix}attributes`]) == null ? void 0 : _a2.id : (_b = errors == null ? void 0 : errors.attributes) == null ? void 0 : _b[attributeId];
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react165.FormControl, {
    ...attributeNamePrefix !== "" && { w: isInline ? "145px" : "full" },
    isInvalid: !!formError,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react165.FormLabel, {
        htmlFor: attributeIdHtml,
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AttributeLabel_default, {
          text: name,
          customTranslation: true,
          isRequired: options == null ? void 0 : options.isRequired
        })
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form11.Controller, {
        name: attributeIdForController,
        control,
        ...(options == null ? void 0 : options.isRequired) && {
          rules: {
            required: {
              value: true,
              message: "ERROR_FIELD_IS_EMPTY"
            }
          }
        },
        render: ({ field }) => {
          return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AttributeBoolean_default, {
            id,
            isReadOnly,
            isInvalid: !!formError,
            ...field,
            onChange: (value2) => {
              field.onChange(value2);
              field.onBlur();
            }
          });
        }
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react165.FormErrorMessage, {
        children: t(formError == null ? void 0 : formError.message)
      })
    ]
  });
};
var FormAttributeBooleanField_default = FormAttributeBooleanField;

// src/components/Attributes/AttributeAccountUser/AttributeAccountUser.tsx
var import_react166 = require("@chakra-ui/react");
var import_react_query28 = require("react-query");
var import_react_select7 = require("react-select");
var import_jsx_runtime = require("react/jsx-runtime");
var AttributeAccountUser = ({
  id,
  name,
  type,
  value,
  options,
  handleChange,
  isReadOnly
}) => {
  const { t } = useAuraTranslation_default();
  const attributeIdHtml = getAttributeId(id, type);
  const attributeValue = buildOptions(value, "displayName", "id");
  const { isInvalid } = useAttributeError(id, type);
  const updateAttribute = (args) => {
    var _a2;
    if (args.action === "select-option" && args.option.value > 0) {
      return handleChange(args.option.value, id, {
        setting: { mode_relations_add: 1 }
      });
    } else if (args.action === "remove-value" || args.action === "pop-value" && ((_a2 = args.removedValue) == null ? void 0 : _a2.value) > 0) {
      return handleChange(args.removedValue.value, id, {
        setting: { mode_relations_remove: 1 }
      });
    } else {
      throw new Error(
        `Unsupported action ${args == null ? void 0 : args.action} for attribute accountUser`
      );
    }
  };
  const { mutate, isLoading, isError, isSuccess } = (0, import_react_query28.useMutation)((args) => {
    return updateAttribute(args);
  });
  const MultiValueLabel3 = (props) => {
    const { data } = props;
    let url = getModuleHref("accountUser", data == null ? void 0 : data.value);
    const handleOnClick = () => window.location.assign(url);
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_select7.components.MultiValueLabel, {
      ...props,
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react166.Link, {
        href: url,
        onTouchStart: handleOnClick,
        title: data.label,
        isTruncated: true,
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react166.Text, {
          _hover: { textDecoration: "underline", cursor: "pointer" },
          fontWeight: 400,
          children: data.label
        })
      })
    });
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react166.FormControl, {
    isDisabled: isLoading,
    isInvalid: isInvalid || !!isError,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react166.FormLabel, {
        htmlFor: attributeIdHtml,
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AttributeLabel_default, {
          text: name,
          customTranslation: true,
          isSaving: isLoading,
          isError: !!isError && !isLoading,
          isSuccess,
          tooltipContent: options == null ? void 0 : options.tooltip
        })
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSelect_default, {
        inputId: attributeIdHtml,
        className: getAttributeClass(type),
        isClearable: false,
        onChange: (e, args) => mutate(args),
        value: attributeValue,
        placeholder: t("CONTACT_PERSON"),
        isMulti: true,
        isReadOnly,
        components: {
          MultiValueLabel: MultiValueLabel3,
          Option: CustomSelectOption_default
        },
        loadDataProps: {
          endpoint: "account_users",
          labelField: "fullName",
          settings: {
            fields: "id,fullName,company.displayName",
            extra_fields: "fullName,company.displayName",
            "setting[with_relations]": true,
            "order[_q]": "DESC"
          },
          defaultOptionsEnabled: true,
          customPrepareData
        },
        clientFilterDisabled: true
      })
    ]
  });
};
var customPrepareData = (data) => {
  if (!data)
    return [];
  const options = data == null ? void 0 : data.map((item) => {
    var _a2;
    return {
      value: item == null ? void 0 : item.id,
      label: item == null ? void 0 : item.fullName,
      additionalName: ((_a2 = item == null ? void 0 : item.company) == null ? void 0 : _a2.displayName) ?? ""
    };
  });
  return options;
};
var AttributeAccountUser_default = AttributeAccountUser;

// src/components/Attributes/FormAttributes/FormAttributeAccountUser/FormAttributeAccountUser.tsx
var import_react167 = require("@chakra-ui/react");
var import_react_hook_form12 = require("react-hook-form");
var import_react_select8 = require("react-select");
var import_jsx_runtime = require("react/jsx-runtime");
var FormAttributeAccountUser = ({
  id,
  name,
  type,
  value,
  options,
  positions,
  handleChange,
  isReadOnly,
  isInline,
  attributeNamePrefix = ""
}) => {
  var _a2, _b;
  const { t } = useAuraTranslation_default();
  const {
    control,
    formState: { errors }
  } = (0, import_react_hook_form12.useFormContext)();
  const attributeId = `${attributeNamePrefix}attribute__${type}-${id}`;
  const attributeIdForController = attributeNamePrefix ? `${attributeNamePrefix}attributes.${id}` : `attributes.${attributeId}`;
  const attributeIdHtml = getAttributeId(
    id,
    type,
    parseAttributeNameFormPrefix(attributeNamePrefix)
  );
  const {
    data: accountUsers,
    isLoading,
    isFetching
  } = useMinimalAutoselect_default({
    endpoint: "account_users",
    labelField: "fullName",
    valueField: "id",
    extraFields: ["fullName", "company.displayName"],
    fields: ["avatar", "company.id"],
    additionalOptionField: [
      { field: "avatar", source: "avatar" },
      { field: "label", source: "fullName" },
      { field: "value", source: "id" },
      { field: "additionalName", source: "company.displayName" }
    ],
    settings: { "setting[with_relations]": true }
  });
  const formError = attributeNamePrefix ? (_a2 = errors == null ? void 0 : errors[`${attributeNamePrefix}attributes`]) == null ? void 0 : _a2.id : (_b = errors == null ? void 0 : errors.attributes) == null ? void 0 : _b[attributeId];
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react167.FormControl, {
    ...attributeNamePrefix !== "" && {
      w: isInline ? "245px" : "full",
      contentEditable: !isReadOnly,
      suppressContentEditableWarning: true
    },
    isInvalid: !!formError,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react167.FormLabel, {
        htmlFor: attributeIdHtml,
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AttributeLabel_default, {
          text: name,
          customTranslation: true,
          isRequired: options == null ? void 0 : options.isRequired
        })
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form12.Controller, {
        name: attributeIdForController,
        control,
        ...(options == null ? void 0 : options.isRequired) && {
          rules: {
            required: {
              value: true,
              message: "ERROR_FIELD_IS_EMPTY"
            }
          }
        },
        render: ({ field }) => {
          const selectedValues = accountUsers == null ? void 0 : accountUsers.filter(
            (opt) => {
              var _a3;
              return (_a3 = field.value) == null ? void 0 : _a3.includes(opt.value);
            }
          );
          return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSelect_default, {
            inputId: attributeIdHtml,
            isMulti: true,
            isLoading: isLoading || isFetching,
            className: getAttributeClass(type),
            options: accountUsers,
            isReadOnly,
            ...field,
            value: selectedValues,
            onChange: (newValue) => {
              const preparedValues = newValue == null ? void 0 : newValue.map((item) => item.value);
              field.onChange(preparedValues ?? null);
              field.onBlur();
            },
            isError: !!formError,
            components: {
              MultiValueLabel,
              Option: CustomSelectOption_default
            }
          });
        }
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react167.FormErrorMessage, {
        children: t(formError == null ? void 0 : formError.message)
      })
    ]
  });
};
var MultiValueLabel = (props) => {
  const { data } = props;
  let url = getModuleHref("accountUser", data == null ? void 0 : data.value);
  const handleOnClick = () => window.open(url, "_blank");
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_select8.components.MultiValueLabel, {
    ...props,
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react167.Link, {
      href: url,
      target: "_blank",
      onTouchStart: handleOnClick,
      title: data.label,
      isTruncated: true,
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react167.Text, {
        _hover: { textDecoration: "underline", cursor: "pointer" },
        fontWeight: 400,
        children: data.label
      })
    })
  });
};
var FormAttributeAccountUser_default = FormAttributeAccountUser;

// src/components/Attributes/FormAttributes/FormAttributeCompany/FormAttributeCompany.tsx
var import_react168 = require("@chakra-ui/react");
var import_react_hook_form13 = require("react-hook-form");
var import_react_select9 = require("react-select");
var import_jsx_runtime = require("react/jsx-runtime");
var FormAttributeCompany = ({
  id,
  name,
  type,
  value,
  options,
  positions,
  handleChange,
  isReadOnly,
  isInline,
  attributeNamePrefix = ""
}) => {
  var _a2, _b;
  const { t } = useAuraTranslation_default();
  const {
    control,
    formState: { errors }
  } = (0, import_react_hook_form13.useFormContext)();
  const attributeId = `${attributeNamePrefix}attribute__${type}-${id}`;
  const attributeIdForController = attributeNamePrefix ? `${attributeNamePrefix}attributes.${id}` : `attributes.${attributeId}`;
  const attributeIdHtml = getAttributeId(
    id,
    type,
    parseAttributeNameFormPrefix(attributeNamePrefix)
  );
  const {
    data: accountCompanies,
    isLoading,
    isFetching
  } = useMinimalAutoselect_default({
    endpoint: "account_companies",
    labelField: "displayName",
    valueField: "id",
    extraFields: ["displayName"],
    fields: ["id"],
    additionalOptionField: [
      { field: "label", source: "displayName" },
      { field: "value", source: "id" }
    ]
  });
  const formError = attributeNamePrefix ? (_a2 = errors == null ? void 0 : errors[`${attributeNamePrefix}attributes`]) == null ? void 0 : _a2.id : (_b = errors == null ? void 0 : errors.attributes) == null ? void 0 : _b[attributeId];
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react168.FormControl, {
    ...attributeNamePrefix !== "" && {
      w: isInline ? "245px" : "full",
      contentEditable: !isReadOnly,
      suppressContentEditableWarning: true
    },
    isInvalid: !!formError,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react168.FormLabel, {
        htmlFor: attributeIdHtml,
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AttributeLabel_default, {
          text: name,
          customTranslation: true,
          isRequired: options == null ? void 0 : options.isRequired
        })
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form13.Controller, {
        name: attributeIdForController,
        control,
        ...(options == null ? void 0 : options.isRequired) && {
          rules: {
            required: {
              value: true,
              message: "ERROR_FIELD_IS_EMPTY"
            }
          }
        },
        render: ({ field }) => {
          const selectedValues = accountCompanies == null ? void 0 : accountCompanies.filter(
            (opt) => {
              var _a3;
              return (_a3 = field.value) == null ? void 0 : _a3.includes(opt.value);
            }
          );
          return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSelect_default, {
            inputId: attributeIdHtml,
            isMulti: true,
            className: getAttributeClass(type),
            options: accountCompanies,
            isReadOnly,
            isLoading: isLoading || isFetching,
            ...field,
            value: selectedValues,
            onChange: (newValue) => {
              const preparedValues = newValue == null ? void 0 : newValue.map((item) => item.value);
              field.onChange(preparedValues ?? null);
              field.onBlur();
            },
            isError: !!formError,
            components: {
              MultiValueLabel: MultiValueLabel2
            }
          });
        }
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react168.FormErrorMessage, {
        children: t(formError == null ? void 0 : formError.message)
      })
    ]
  });
};
var MultiValueLabel2 = (props) => {
  const { data } = props;
  let url = `/accountCompany/show/company_id/${data.value}`;
  const handleOnClick = () => window.open(url, "_blank");
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_select9.components.MultiValueLabel, {
    ...props,
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react168.Link, {
      href: url,
      onTouchStart: handleOnClick,
      target: "_blank",
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react168.Text, {
        _hover: { textDecoration: "underline", cursor: "pointer" },
        fontWeight: 400,
        children: data.label
      })
    })
  });
};
var FormAttributeCompany_default = FormAttributeCompany;

// src/components/Attributes/FormAttributes/FormAttributePhone/FormAttributePhone.tsx
var import_react169 = require("@chakra-ui/react");
var import_react_hook_form14 = require("react-hook-form");
var import_jsx_runtime = require("react/jsx-runtime");
var FormAttributePhone = ({
  id,
  name,
  type,
  value,
  options,
  handleChange,
  isReadOnly,
  isInline,
  attributeNamePrefix = ""
}) => {
  var _a2, _b;
  const { t } = useAuraTranslation_default();
  const attributeId = `${attributeNamePrefix}attribute__${type}-${id}`;
  const attributeIdForController = attributeNamePrefix ? `${attributeNamePrefix}attributes.${id}` : `attributes.${attributeId}`;
  const attributeIdHtml = getAttributeId(
    id,
    type,
    parseAttributeNameFormPrefix(attributeNamePrefix)
  );
  const {
    control,
    formState: { errors }
  } = (0, import_react_hook_form14.useFormContext)();
  const formError = attributeNamePrefix ? (_a2 = errors == null ? void 0 : errors[`${attributeNamePrefix}attributes`]) == null ? void 0 : _a2.id : (_b = errors == null ? void 0 : errors.attributes) == null ? void 0 : _b[attributeId];
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react169.FormControl, {
    ...attributeNamePrefix !== "" && { w: isInline ? "245px" : "full" },
    isInvalid: !!formError,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react169.FormLabel, {
        htmlFor: attributeIdHtml,
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AttributeLabel_default, {
          text: name,
          customTranslation: true,
          isRequired: options == null ? void 0 : options.isRequired
        })
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form14.Controller, {
        name: attributeIdForController,
        control,
        ...(options == null ? void 0 : options.isRequired) && {
          rules: {
            required: {
              value: true,
              message: "ERROR_FIELD_IS_EMPTY"
            }
          }
        },
        render: ({ field }) => {
          return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraInput_default, {
            id: attributeIdHtml,
            prefix: parseAttributeNameFormPrefix(attributeNamePrefix),
            isReadOnly,
            type: "tel",
            ...field,
            onChange: (value2) => {
              field.onChange(value2);
              field.onBlur();
            }
          });
        }
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react169.FormErrorMessage, {
        children: t(formError == null ? void 0 : formError.message)
      })
    ]
  });
};
var FormAttributePhone_default = FormAttributePhone;

// src/components/Attributes/FormAttributes/FormAttributeEmail/FormAttributeEmail.tsx
var import_react170 = require("@chakra-ui/react");
var import_axios7 = __toESM(require("axios"));
var import_react_hook_form15 = require("react-hook-form");
var import_validate2 = __toESM(require("validate.js"));
var import_debounce4 = __toESM(require("lodash/debounce"));
var import_jsx_runtime = require("react/jsx-runtime");
var FormAttributeAccountUser2 = ({
  id,
  name,
  type,
  value,
  options,
  positions,
  handleChange,
  isReadOnly,
  isInline,
  attributeNamePrefix = ""
}) => {
  var _a2, _b;
  const { t } = useAuraTranslation_default();
  const {
    control,
    formState: { errors }
  } = (0, import_react_hook_form15.useFormContext)();
  const attributeId = `${attributeNamePrefix}attribute__${type}-${id}`;
  const attributeIdForController = attributeNamePrefix ? `${attributeNamePrefix}attributes.${id}` : `attributes.${attributeId}`;
  const attributeIdHtml = getAttributeId(
    id,
    type,
    parseAttributeNameFormPrefix(attributeNamePrefix)
  );
  const formError = attributeNamePrefix ? (_a2 = errors == null ? void 0 : errors[`${attributeNamePrefix}attributes`]) == null ? void 0 : _a2.id : (_b = errors == null ? void 0 : errors.attributes) == null ? void 0 : _b[attributeId];
  const debouncedLoadOptions = (0, import_debounce4.default)(loadOptions2, 500, {
    leading: true
  });
  const prepareCurrentValue = (data) => {
    if (data.every((item) => typeof item === "string")) {
      return data == null ? void 0 : data.map((item) => ({ label: item, value: item }));
    } else {
      return data ?? [];
    }
  };
  const prepareNewValue = (data) => {
    var _a3;
    return ((_a3 = data == null ? void 0 : data.filter((item) => {
      if (import_validate2.default.single(item, { email: true })) {
        return true;
      }
      return false;
    })) == null ? void 0 : _a3.map((item) => item == null ? void 0 : item.value)) ?? null;
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react170.FormControl, {
    ...attributeNamePrefix !== "" && {
      w: isInline ? "245px" : "full",
      contentEditable: !isReadOnly,
      suppressContentEditableWarning: true
    },
    isInvalid: !!formError,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react170.FormLabel, {
        htmlFor: attributeIdHtml,
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AttributeLabel_default, {
          text: name,
          customTranslation: true,
          isRequired: options == null ? void 0 : options.isRequired
        })
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form15.Controller, {
        name: attributeIdForController,
        control,
        ...(options == null ? void 0 : options.isRequired) && {
          rules: {
            required: {
              value: true,
              message: "ERROR_FIELD_IS_EMPTY"
            }
          }
        },
        render: ({ field }) => {
          const currentValue = prepareCurrentValue((field == null ? void 0 : field.value) ?? []);
          return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSelect_default, {
            inputId: attributeIdHtml,
            isMulti: true,
            isClearable: false,
            loadOptions: (inputValue) => debouncedLoadOptions(inputValue),
            className: getAttributeClass(type),
            isReadOnly,
            isError: !!formError,
            ...field,
            value: currentValue,
            onChange: (newValue) => {
              field.onChange(prepareNewValue(newValue));
              field.onBlur();
            }
          });
        }
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react170.FormErrorMessage, {
        children: t(formError == null ? void 0 : formError.message)
      })
    ]
  });
};
var loadOptions2 = async (query) => {
  const params = {
    fields: "email",
    "filter[email][hasText]": query,
    "filter[email][isNotNull]": "",
    "filter[email][neq]": ""
  };
  const userUserEmail = import_axios7.default.get("/api/account_users", { params });
  const accountUserEmail = import_axios7.default.get("/api/user_users", { params });
  const allEmails = await Promise.all([userUserEmail, accountUserEmail]);
  const userUserEmailForInput = buildOptions(
    allEmails[0].data.data,
    "email",
    "email"
  );
  const accountUserEmailForInput = buildOptions(
    allEmails[1].data.data,
    "email",
    "email"
  );
  return new Promise((resolve, reject) => {
    resolve([...userUserEmailForInput, ...accountUserEmailForInput]);
  });
};
var FormAttributeEmail_default = FormAttributeAccountUser2;

// src/components/Attributes/FormAttributes/FormAttributeChecklist/FormAttributeChecklist.tsx
var import_react171 = require("@chakra-ui/react");
var import_react_hook_form16 = require("react-hook-form");
var import_jsx_runtime = require("react/jsx-runtime");
var FormAttributeChecklist = ({
  id,
  name,
  type,
  value,
  options,
  positions,
  handleChange,
  isReadOnly,
  isInline,
  attributeNamePrefix = ""
}) => {
  var _a2, _b;
  const { t } = useAuraTranslation_default();
  const attributeId = `${attributeNamePrefix}attribute__${type}-${id}`;
  const attributeIdForController = attributeNamePrefix ? `${attributeNamePrefix}attributes.${id}` : `attributes.${attributeId}`;
  const attributeIdHtml = getAttributeId(
    id,
    type,
    parseAttributeNameFormPrefix(attributeNamePrefix)
  );
  const {
    control,
    formState: { errors }
  } = (0, import_react_hook_form16.useFormContext)();
  const formError = attributeNamePrefix ? (_a2 = errors == null ? void 0 : errors[`${attributeNamePrefix}attributes`]) == null ? void 0 : _a2.id : (_b = errors == null ? void 0 : errors.attributes) == null ? void 0 : _b[attributeId];
  const prepareCurrentValue = (data) => {
    if (data == null ? void 0 : data.some(
      (item) => (item == null ? void 0 : item.hasOwnProperty("selected")) || (item == null ? void 0 : item.hasOwnProperty("comment"))
    )) {
      return data;
    } else {
      return positions;
    }
  };
  const prepareNewValue = (currentValue, data) => {
    return currentValue == null ? void 0 : currentValue.map((item) => {
      if ((item == null ? void 0 : item.id) === (data == null ? void 0 : data.id)) {
        return {
          ...item,
          ...data
        };
      } else
        return item;
    });
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react171.FormControl, {
    ...attributeNamePrefix !== "" && { w: isInline ? "245px" : "full" },
    isInvalid: !!formError,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react171.FormLabel, {
        htmlFor: attributeIdHtml,
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AttributeLabel_default, {
          text: name,
          customTranslation: true,
          isRequired: options == null ? void 0 : options.isRequired
        })
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form16.Controller, {
        name: attributeIdForController,
        control,
        ...(options == null ? void 0 : options.isRequired) && {
          rules: {
            required: {
              value: true,
              message: "ERROR_FIELD_IS_EMPTY"
            }
          }
        },
        render: ({ field }) => {
          const currentValue = prepareCurrentValue(field == null ? void 0 : field.value);
          return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AttributeChecklist_default, {
            id,
            prefix: parseAttributeNameFormPrefix(attributeNamePrefix),
            isReadOnly,
            ...field,
            value: currentValue,
            onChange: (value2) => {
              field.onChange(prepareNewValue(currentValue, value2));
              field.onBlur();
            }
          });
        }
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react171.FormErrorMessage, {
        children: t(formError == null ? void 0 : formError.message)
      })
    ]
  });
};
var FormAttributeChecklist_default = FormAttributeChecklist;

// src/components/Attributes/Attributes.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var chooseComponent = (attribute, toForm, hasCredential, handleAttributeChange, isInline, attributeNamePrefix, module2, moduleItemId) => {
  const isReadOnly = (0, import_isUndefined2.default)(attribute.isReadOnly) ? !hasCredential(attribute.uuid || attribute.id, "attribute", "edit") : attribute.isReadOnly;
  const baseProps = {
    ...attribute,
    isReadOnly,
    handleChange: handleAttributeChange,
    isInline,
    attributeNamePrefix
  };
  switch (attribute.type) {
    case "text":
      if (attribute.options.asHTML) {
        return toForm ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FormAttributeHTML_default, {
          ...baseProps
        }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AttributeHTML_default, {
          ...baseProps
        });
      } else {
        return toForm ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FormAttributeTextField_default, {
          ...baseProps
        }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AttributeTextField_default, {
          ...baseProps
        });
      }
    case "numeric":
      return toForm ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FormAttributeNumberField_default, {
        ...baseProps
      }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AttributeNumberField_default, {
        ...baseProps
      });
    case "bool":
      return toForm ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FormAttributeBooleanField_default, {
        ...baseProps
      }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AttributeBooleanField_default, {
        ...baseProps
      });
    case "date":
    case "datetime":
      return toForm ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FormAttributeDateField_default, {
        ...baseProps
      }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AttributeDateField_default, {
        ...baseProps
      });
    case "list":
      return toForm ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FormAttributeListOne_default, {
        ...baseProps
      }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AttributeListOne_default, {
        ...baseProps
      });
    case "listMulti":
      return toForm ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FormAttributeListMulti_default, {
        ...baseProps
      }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AttributeListMulti_default, {
        ...baseProps
      });
    case "tags":
      return toForm ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FormAttributeTagsField_default, {
        module: module2,
        ...baseProps
      }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AttributeTagsField_default, {
        module: module2,
        ...baseProps
      });
    case "file":
      return toForm ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FormAttributeAttachments_default, {
        ...baseProps
      }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AttributeAttachments_default, {
        module: module2,
        moduleItemId,
        ...baseProps
      });
    case "email":
      return toForm ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FormAttributeEmail_default, {
        ...baseProps
      }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AttributeEmail_default, {
        ...baseProps
      });
    case "phone":
      return toForm ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FormAttributePhone_default, {
        ...baseProps
      }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AttributePhone_default, {
        ...baseProps
      });
    case "company":
      return toForm ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FormAttributeCompany_default, {
        ...baseProps
      }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AttributeCompany_default, {
        ...baseProps
      });
    case "checklist":
      return toForm ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FormAttributeChecklist_default, {
        ...baseProps
      }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AttributeChecklistField_default, {
        ...baseProps
      });
    case "signature":
      return toForm ? null : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AttributeSignature_default, {
        ...baseProps
      });
    case "chat":
      return toForm ? null : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AttributeChat_default2, {
        ...baseProps
      });
    case "userUser":
      return toForm ? null : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FormAttributeUser_default, {
        ...baseProps
      });
    case "accountUser":
      return toForm ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FormAttributeAccountUser_default, {
        ...baseProps
      }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AttributeAccountUser_default, {
        ...baseProps
      });
    default:
      logger_default.warn("No component for type ", attribute == null ? void 0 : attribute.type);
      return null;
  }
};
var Attributes = ({
  attributes,
  updateAttribute,
  toForm = false,
  attributeNamePrefix,
  errors,
  formMethods,
  module: module2,
  moduleItemId,
  ...props
}) => {
  const { hasCredential } = (0, import_lib2.useCredentials)();
  const handleAttributeChange = async (value, id, additionalParams) => {
    const payload = {
      id,
      value
    };
    return updateAttribute && updateAttribute(payload, "attributes", additionalParams);
  };
  const getComponent = (attribute) => {
    return chooseComponent(
      attribute,
      toForm,
      hasCredential,
      handleAttributeChange,
      props.isInline,
      attributeNamePrefix,
      module2,
      moduleItemId
    ) ?? null;
  };
  if ((0, import_isEmpty8.default)(attributes)) {
    return null;
  }
  const sortedAttributes = (0, import_sortBy3.default)(attributes, ["options.displayPriority"]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FormProviderWrapper, {
    formMethods,
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AttributesErrorProvider, {
      value: errors,
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react172.Stack, {
        spacing: "16px",
        ...props,
        children: sortedAttributes.map((attribute) => {
          const validAttribute = getComponent(attribute);
          return validAttribute ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react172.Box, {
            id: getAttributeContainerId(attribute.id),
            children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_error_boundary2.ErrorBoundary, {
              fallbackRender: (fallbackProps) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AttributeError, {
                attributeId: attribute.id,
                ...fallbackProps
              }),
              children: validAttribute
            })
          }, attribute.id) : null;
        })
      })
    })
  });
};
var AttributeError = ({
  attributeId
}) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react172.Alert, {
    status: "error",
    variant: "left-accent",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react172.AlertIcon, {}),
      "Problem z wy\u015Bwietleniem atrybutu o id ",
      attributeId,
      "."
    ]
  });
};
var FormProviderWrapper = ({
  formMethods,
  children
}) => {
  if (formMethods) {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form17.FormProvider, {
      ...formMethods,
      children
    });
  }
  return children;
};
var Attributes_default = Attributes;

// src/components/AuraDatePicker/AuraDatePicker.tsx
var import_react_datepicker2 = __toESM(require("react-datepicker"));
var import_jsx_runtime = require("react/jsx-runtime");
var AuraDatePicker = (props) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_datepicker2.default, {
  ...props
});
var AuraDatePicker_default = AuraDatePicker;

// src/components/AuraDrawer/AuraDrawer.tsx
var import_react173 = require("@chakra-ui/react");
var import_jsx_runtime = require("react/jsx-runtime");
var AuraDrawer = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react173.Drawer, {
    ...props
  });
};
var AuraDrawerBody = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react173.DrawerBody, {
    py: 5,
    px: 6,
    ...props
  });
};
var AuraDrawerFooter = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react173.DrawerFooter, {
    ...props
  });
};
var AuraDrawerHeader = ({
  showCloseButton = true,
  children,
  ...props
}) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react173.DrawerHeader, {
    borderBottom: "1px solid",
    borderColor: "gray.200",
    maxH: 16,
    py: 5,
    px: 4,
    alignItems: "center",
    display: "flex",
    ...props,
    children: [
      children,
      showCloseButton ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraDrawerCloseButton, {
        color: "gray.700",
        size: "lg",
        fontSize: "13px",
        ml: "auto"
      }) : null
    ]
  });
};
var AuraDrawerOverlay = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react173.DrawerOverlay, {
    ...props
  });
};
var AuraDrawerCloseButton = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react173.DrawerCloseButton, {
    position: "initial",
    ...props
  });
};
var AuraDrawerContent = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react173.DrawerContent, {
    ...props
  });
};

// src/components/AuraFormLabel/AuraFormLabel.tsx
var import_react174 = require("@chakra-ui/react");
var import_jsx_runtime = require("react/jsx-runtime");
var AuraFormLabel = ({ children, ...props }) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react174.FormLabel, {
    textStyle: "subtitleLabel",
    color: "gray.700",
    ...props,
    children
  });
};
var AuraFormLabel_default = AuraFormLabel;

// src/components/AuraTabs/AuraTabs.tsx
var import_react176 = require("@chakra-ui/react");
var import_react177 = require("react");

// src/components/ContentBox/ContentBox.tsx
var import_react175 = require("@chakra-ui/react");
var import_jsx_runtime = require("react/jsx-runtime");
var ContentBox = ({ children, ...props }) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react175.Box, {
    bg: "white",
    boxShadow: "base",
    p: {
      base: 4,
      lg: 6
    },
    borderRadius: 10,
    ...props,
    children
  });
};
var ContentBox_default = ContentBox;

// src/components/AuraTabs/AuraTabs.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var AuraTabs = ({ name, data }) => {
  const storageName = `auraTabIndex_${name}`;
  const [tabIndex, setTabIndex] = (0, import_react177.useState)(
    localStorage.getItem(storageName) ? parseInt(localStorage.getItem(storageName)) : 0
  );
  const handleChangeTab = (index) => {
    setTabIndex(index);
    localStorage.setItem(storageName, index.toString());
  };
  const handleSelectChange = (option) => {
    handleChangeTab(parseInt(option.value));
  };
  const showSelector = (0, import_react176.useBreakpointValue)({
    base: true,
    lg: false
  });
  const listContentBoxProps = {
    w: "full",
    ml: { lg: "16px" },
    overflow: "hidden"
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, {
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react176.Tabs, {
      onChange: handleChangeTab,
      index: tabIndex,
      isLazy: true,
      orientation: "vertical",
      variant: "unstyled",
      alignItems: "flex-start",
      children: [
        !showSelector && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ContentBox_default, {
          w: { lg: "288px", xl: "448px" },
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react176.TabList, {
            children: data.map((tab, index) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react176.Tab, {
              justifyContent: "flex-start",
              px: "16px",
              py: "12px",
              borderRadius: "6px",
              _selected: { bgColor: "gray.100" },
              textAlign: "left",
              children: tab.label
            }, index))
          })
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react176.Box, {
          w: "full",
          overflow: "hidden",
          children: [
            showSelector && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ContentBox_default, {
              ...listContentBoxProps,
              mb: "16px",
              children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react176.Box, {
                w: { base: "full", md: "fit-content" },
                children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSelect_default, {
                  onChange: handleSelectChange,
                  value: { label: data[tabIndex].label, value: tabIndex },
                  customStyles: {
                    control: {
                      backgroundColor: "#EDF2F7"
                    }
                  },
                  isSearchable: false,
                  isClearable: false,
                  options: buildOptions(data, "label", "arrayIndex")
                })
              })
            }),
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ContentBox_default, {
              ...listContentBoxProps,
              children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react176.TabPanels, {
                children: data.map((tab, index) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react176.TabPanel, {
                  p: 0,
                  children: tab.content
                }, index))
              })
            })
          ]
        })
      ]
    })
  });
};
var AuraTabs_default = AuraTabs;

// src/components/AuraTextarea/AuraTextarea.tsx
var import_react178 = require("@chakra-ui/react");
var import_react179 = __toESM(require("react"));
var import_jsx_runtime = require("react/jsx-runtime");
var AuraTextarea = import_react179.default.forwardRef(
  ({ isReadOnly = false, children, ...props }, ref) => {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react178.Textarea, {
      ref,
      isReadOnly,
      isDisabled: isReadOnly,
      _readOnly: {
        bgColor: "gray.50",
        borderColor: "gray.100",
        _focus: { borderColor: "gray.100" },
        _hover: { cursor: "default" }
      },
      _disabled: {
        bgColor: "gray.50",
        borderColor: "gray.100",
        _focus: { borderColor: "gray.100" },
        _hover: { cursor: "default" }
      },
      borderRadius: "6px",
      ...props
    });
  }
);
var AuraTextarea_default = AuraTextarea;

// src/components/AuraModal/AuraModal.tsx
var import_react180 = require("@chakra-ui/react");
var import_jsx_runtime = require("react/jsx-runtime");
var AuraModal = (props) => {
  const isSm = (0, import_react180.useBreakpointValue)({
    base: true,
    md: false
  });
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react180.Modal, {
    size: isSm ? "full" : "lg",
    ...props
  });
};
var AuraModalHeader = ({
  showBorders = false,
  children,
  ...props
}) => {
  const isSm = (0, import_react180.useBreakpointValue)({
    base: true,
    md: false
  });
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react180.ModalHeader, {
    ...showBorders ? { borderBottom: "1px solid", borderColor: "gray.200" } : {},
    py: "12px",
    alignItems: "center",
    display: "flex",
    justifyContent: "space-between",
    letterSpacing: "0.15px",
    ...props,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react180.Text, {
        isTruncated: true,
        as: isSm ? "h5" : "h4",
        textStyle: { base: "h5", md: "h4" },
        children
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalCloseButton, {
        color: "gray.700",
        size: "lg",
        fontSize: "13px"
      })
    ]
  });
};
var AuraModalFooter = ({
  showBorders = true,
  ...props
}) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react180.ModalFooter, {
    ...showBorders ? {
      boxShadow: "0px -10px 15px -3px rgba(0, 0, 0, 0.06), 0px -4px 6px -2px rgba(0, 0, 0, 0.05)"
    } : {},
    pt: "16px",
    pb: "32px",
    px: "24px",
    gap: "12px",
    ...props
  });
};
var AuraModalBody = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react180.ModalBody, {
    py: "16px",
    px: "24px",
    overflowY: "auto",
    fontSize: "md",
    ...props
  });
};
var AuraModalContent = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react180.ModalContent, {
    my: { base: 0, md: "3.75rem" },
    ...props
  });
};
var AuraModalOverlay = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react180.ModalOverlay, {
    ...props
  });
};
var AuraModalCloseButton = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react180.DrawerCloseButton, {
    position: "initial",
    ...props
  });
};

// src/components/AuraSpinner/AuraSpinner.tsx
var import_react181 = require("@chakra-ui/react");
var import_jsx_runtime = require("react/jsx-runtime");
var AuraSpinner = ({ ...props }) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react181.Center, {
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react181.Spinner, {
      size: "xl",
      color: "blue.500",
      ...props
    })
  });
};
var AuraSpinner_default = AuraSpinner;

// src/components/BackwardNavigation/BackwardNavigation.tsx
var import_react182 = require("@chakra-ui/react");
var import_js28 = require("@mdi/js");
var import_react183 = __toESM(require("@mdi/react"));
var import_jsx_runtime = require("react/jsx-runtime");
var BackwardNavigation = ({ children, ...props }) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react182.Link, {
    display: "inline-block",
    _hover: {
      textDecoration: "none"
    },
    ...props,
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react182.HStack, {
      alignItems: "center",
      spacing: 1,
      color: "gray.500",
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react183.default, {
          size: "20px",
          path: import_js28.mdiChevronLeft
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react182.Text, {
          color: "blue.500",
          fontWeight: 500,
          fontSize: "md",
          letterSpacing: "0.15px",
          as: "span",
          lineHeight: 6,
          children
        })
      ]
    })
  });
};
var BackwardNavigation_default = BackwardNavigation;

// src/components/BlockedDisabledInfo/BlockedDisabledInfo.tsx
var import_react184 = require("@chakra-ui/react");
var import_js29 = require("@mdi/js");
var import_react185 = __toESM(require("@mdi/react"));
var import_jsx_runtime = require("react/jsx-runtime");
var BlockedDisabledInfo = ({ label }) => {
  const { t } = useAuraTranslation_default();
  const showLabel = (0, import_react184.useBreakpointValue)({
    base: false,
    md: true
  });
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react184.Stack, {
    color: "red.500",
    py: "2px",
    isInline: true,
    spacing: "8px",
    className: "blocked-disabled-info",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react185.default, {
        size: "20px",
        path: import_js29.mdiLockOutline,
        className: "blocked-disabled-info__icon"
      }),
      showLabel && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react184.Text, {
        textStyle: "buttonSmall",
        className: "blocked-disabled-info__label",
        children: t(label)
      })
    ]
  });
};
var BlockedDisabledInfo_default = BlockedDisabledInfo;

// src/components/BoxCollapse/BoxCollapse.tsx
var import_react186 = require("@chakra-ui/react");
var import_jsx_runtime = require("react/jsx-runtime");
var BoxCollapse = (props) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react186.Accordion, {
  allowToggle: true,
  ...props
});
var BoxCollapseItem = (props) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react186.AccordionItem, {
  border: 0,
  ...props
});
var BoxCollapseButton = (props) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react186.AccordionButton, {
  height: "40px",
  pl: 0,
  pr: 3,
  _hover: {
    bg: "initial"
  },
  ...props
});
var BoxCollapseContent = (props) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react186.AccordionPanel, {
  pt: 4,
  px: 0,
  pb: 0,
  ...props
});
var BoxIcon = import_react186.AccordionIcon;
var BoxCollapseItemCompact = ({
  title,
  onClick,
  visibleNumber,
  buttons,
  ...props
}) => /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(BoxCollapseItem, {
  position: "relative",
  ...props,
  children: [
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(BoxCollapseButton, {
      position: "absolute",
      alignItems: "flex-start",
      justifyContent: "flex-end",
      minH: "40px",
      py: "0",
      onClick,
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react186.AccordionIcon, {
        mt: "6px"
      })
    }),
    buttons ? /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react186.Flex, {
      verticalAlign: "center",
      gap: "16px",
      rowGap: "8px",
      flexDir: "row",
      wrap: "wrap",
      me: "32px",
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react186.HStack, {
          verticalAlign: "center",
          w: "fit-content",
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react186.Text, {
              as: "h5",
              textStyle: "h5",
              letterSpacing: "basic",
              children: title
            }),
            visibleNumber && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(NumberBox, {
              number: visibleNumber
            })
          ]
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react186.Flex, {
          gap: "16px",
          rowGap: "8px",
          wrap: "wrap",
          w: "fit-content",
          maxW: "full",
          children: buttons
        })
      ]
    }) : /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react186.HStack, {
      verticalAlign: "center",
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react186.Text, {
          as: "h5",
          textStyle: "h5",
          letterSpacing: "basic",
          children: title
        }),
        visibleNumber && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(NumberBox, {
          number: visibleNumber
        })
      ]
    }),
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(BoxCollapseContent, {
      children: props == null ? void 0 : props.children
    })
  ]
});

// src/components/Breadcrumbs/Breadcrumbs.tsx
var import_react187 = require("@chakra-ui/react");
var import_react188 = require("@emotion/react");
var import_react189 = __toESM(require("react"));
var import_react190 = __toESM(require("@mdi/react"));
var import_js30 = require("@mdi/js");
var import_jsx_runtime = require("react/jsx-runtime");
var Breadcrumbs = ({ items, ...props }) => {
  const theme = (0, import_react188.useTheme)();
  const containerRef = import_react189.default.useRef(null);
  const breadcrumbsRef = import_react189.default.useRef(null);
  const [isLeftScrollVisible, setIsLeftScrollVisible] = (0, import_react189.useState)(false);
  const [isRightScrollVisible, setIsRightScrollVisible] = (0, import_react189.useState)(false);
  (0, import_react189.useEffect)(() => {
    var _a2;
    if ((_a2 = containerRef == null ? void 0 : containerRef.current) == null ? void 0 : _a2.scroll) {
      containerRef.current.scroll({
        left: 9999,
        behavior: "smooth"
      });
    }
  }, [items]);
  const updateOnScroll = () => {
    const containerWidth = containerRef.current.offsetWidth;
    const breadcrumbsWidth = breadcrumbsRef.current.scrollWidth;
    if (breadcrumbsWidth > containerWidth && containerRef.current.scrollLeft === 0) {
      setIsLeftScrollVisible(false);
      setIsRightScrollVisible(true);
    } else if (breadcrumbsWidth > containerWidth && breadcrumbsWidth - containerWidth !== containerRef.current.scrollLeft) {
      setIsLeftScrollVisible(true);
      setIsRightScrollVisible(true);
    } else if (breadcrumbsWidth > containerWidth && breadcrumbsWidth - containerWidth === containerRef.current.scrollLeft) {
      setIsLeftScrollVisible(true);
      setIsRightScrollVisible(false);
    } else {
      setIsLeftScrollVisible(false);
      setIsRightScrollVisible(false);
    }
  };
  (0, import_react189.useLayoutEffect)(() => {
    updateOnScroll();
  }, []);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react187.Box, {
    className: "breadcrumbs__container",
    position: "relative",
    ...props,
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react187.Box, {
      ref: containerRef,
      className: "breadcrumbs__scroll-container",
      css: import_react188.css`
          & {
            -ms-overflow-style: none; /* for Internet Explorer, Edge */
            scrollbar-width: none; /* for Firefox */
            overflow-y: scroll;
          }

          &::-webkit-scrollbar {
            display: none; /* for Chrome, Safari, and Opera */
          }
        `,
      overflowX: "scroll",
      overflowY: "hidden",
      onScroll: updateOnScroll,
      _before: {
        pointerEvents: "none",
        content: "''",
        position: "absolute",
        top: 0,
        right: "75%",
        bottom: 0,
        left: 0,
        backgroundImage: isLeftScrollVisible ? `linear-gradient(to left, rgba(255,0,0,0), rgba(255,255,255,1))` : "none"
      },
      _after: {
        pointerEvents: "none",
        content: "''",
        position: "absolute",
        top: 0,
        right: 0,
        bottom: 0,
        left: "75%",
        backgroundImage: isRightScrollVisible ? `linear-gradient(to right, rgba(255,0,0,0), rgba(255,255,255,1))` : "none"
      },
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react187.Breadcrumb, {
        ref: breadcrumbsRef,
        height: "24px",
        display: "flex",
        alignItems: "center",
        className: "breadcrumbs",
        whiteSpace: "nowrap",
        color: "crmBlue",
        separator: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react190.default, {
          path: import_js30.mdiChevronRight,
          size: "20px"
        }),
        children: items.map((item, index) => {
          return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react187.BreadcrumbItem, {
            className: "breadcrumbs__item",
            fontSize: "md",
            letterSpacing: "wider",
            children: [
              item.href && !item.fn ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react187.BreadcrumbLink, {
                fontWeight: "medium",
                color: "crmBlue",
                href: item.href,
                children: item.label
              }) : null,
              item.fn && !item.href ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react187.BreadcrumbLink, {
                fontWeight: "medium",
                color: "crmBlue",
                onClick: () => item.fn(item),
                children: item.label
              }) : null,
              !item.href && !item.fn ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react187.BreadcrumbLink, {
                fontWeight: "medium",
                color: "crmBlue",
                href: "#",
                children: item.label
              }) : null
            ]
          }, item.id);
        })
      })
    })
  });
};
var Breadcrumbs_default = Breadcrumbs;

// src/components/ButtonFavorite/ButtonFavorite.tsx
var import_react191 = require("@chakra-ui/react");
var import_js31 = require("@mdi/js");
var import_react192 = __toESM(require("@mdi/react"));
var import_jsx_runtime = require("react/jsx-runtime");
var ButtonFavorite = ({ isChecked, onClick }) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react191.IconButton, {
    icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react192.default, {
      size: "24px",
      path: isChecked ? import_js31.mdiHeart : import_js31.mdiHeartOutline
    }),
    "aria-label": "Add to favorites",
    variant: "unstyled",
    className: "button-favorite",
    "data-testid": "button-favorite",
    "data-favorite": isChecked,
    color: isChecked ? "red.500" : "gray.400",
    _focus: {
      outline: "none"
    },
    sx: {
      svg: {
        margin: "0 auto"
      }
    },
    onClick
  });
};
var ButtonFavorite_default = ButtonFavorite;

// src/components/ButtonManage2FA/ButtonManage2FA.tsx
var import_react193 = require("@chakra-ui/react");
var import_react194 = require("react");
var import_react_query29 = require("react-query");
var import_react_qr_code = __toESM(require("react-qr-code"));
var import_js32 = require("@mdi/js");
var import_react195 = __toESM(require("@mdi/react"));
var import_jsx_runtime = require("react/jsx-runtime");
var ButtonManage2FA = ({ onSaveSecret }) => {
  const { t } = useAuraTranslation_default();
  const toast = (0, import_react193.useToast)();
  const { isOpen, onOpen, onClose } = (0, import_react193.useDisclosure)();
  const { resolveApiError } = useAuraErrorResolver_default();
  const [qrContent, setQrContent] = (0, import_react194.useState)("");
  const [totpSecret, setTotpSecret] = (0, import_react194.useState)("");
  const { onCopy, hasCopied } = (0, import_react193.useClipboard)(totpSecret);
  const { isFetching: isFetchingSecret, refetch: getSecret } = (0, import_react_query29.useQuery)(
    "generateTotpSecret",
    () => api_default.getEndpoint("me/generateTotpSecret", {}),
    {
      enabled: false,
      cacheTime: 0,
      keepPreviousData: false,
      onSettled: (data) => {
        if (data == null ? void 0 : data.message) {
          onClose();
          const error = new AuraErrorResolverException(data.message);
          resolveApiError(error);
        } else {
          setQrContent((data == null ? void 0 : data.qrContent) ?? null);
          setTotpSecret((data == null ? void 0 : data.totpSecret) ?? null);
        }
      }
    }
  );
  const { mutate: saveSecret, isLoading: isLoadingSaveSecret } = (0, import_react_query29.useMutation)(
    () => onSaveSecret(totpSecret),
    {
      onSuccess: () => {
        onClose();
        toast({
          title: t("Your modifications have been saved"),
          status: "success"
        });
      },
      onError: (error) => resolveApiError(error)
    }
  );
  const handleOpenModal = () => {
    getSecret();
    onOpen();
  };
  (0, import_react194.useEffect)(() => {
    return () => {
      setQrContent(void 0);
      setTotpSecret(void 0);
    };
  }, []);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react193.Button, {
        className: "btn-2fa-manage",
        colorScheme: "blue",
        bgColor: "crmBlue",
        onClick: handleOpenModal,
        children: t("PAIR_WITH_APP_2FA_LOGIN")
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(AuraModal, {
        isOpen,
        onClose,
        closeOnOverlayClick: false,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalOverlay, {}),
          /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(AuraModalContent, {
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalHeader, {
                children: t("TURN_ON_2FA_LOGIN")
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalBody, {
                children: isFetchingSecret ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSpinner_default, {}) : /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react193.VStack, {
                  spacing: "24px",
                  children: [
                    (qrContent == null ? void 0 : qrContent.length) && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react193.Center, {
                      w: "full",
                      "data-testid": "totp-qr-code",
                      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_qr_code.default, {
                        value: qrContent,
                        size: 270
                      })
                    }),
                    (totpSecret == null ? void 0 : totpSecret.length) && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
                      children: [
                        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react193.Text, {
                          w: "full",
                          children: t("PAIR_WITH_APP_2FA_INSTRUCTION")
                        }),
                        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react193.Divider, {}),
                        /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react193.HStack, {
                          w: "full",
                          alignItems: "flex-start",
                          children: [
                            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AttributeText_default, {
                              value: totpSecret,
                              isReadOnly: true,
                              fontFamily: "monospace",
                              letterSpacing: "0.4px",
                              resize: "none"
                            }),
                            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react193.IconButton, {
                              "aria-label": "Copy code",
                              icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react195.default, {
                                path: hasCopied ? import_js32.mdiClipboardCheck : import_js32.mdiClipboardOutline,
                                size: "20px"
                              }),
                              onClick: onCopy
                            })
                          ]
                        })
                      ]
                    })
                  ]
                })
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalFooter, {
                showBorders: false,
                children: totpSecret && qrContent && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react193.Button, {
                  colorScheme: "blue",
                  isLoading: isLoadingSaveSecret,
                  onClick: () => saveSecret(),
                  children: t("CONTINUE")
                })
              })
            ]
          })
        ]
      })
    ]
  });
};
var ButtonManage2FA_default = ButtonManage2FA;

// src/components/ColorPicker/ColorPicker.tsx
var import_react196 = require("react");
var import_react197 = require("@chakra-ui/react");
var import_use_debounce2 = require("use-debounce");
var import_jsx_runtime = require("react/jsx-runtime");
var ColorPicker = ({
  value,
  onChange,
  isReadOnly
}) => {
  const [color, setColor] = (0, import_react196.useState)(value);
  const handleColor = (e) => {
    const value2 = e.target.value;
    value2.length <= 9 && setColor(value2);
    if (value2.length === 7 || value2.length === 9) {
      onChange(value2);
    }
  };
  const [isNotClicked, setIsNotClicked] = (0, import_react196.useState)(!value);
  const debounced = (0, import_use_debounce2.useDebouncedCallback)((e) => {
    handleColor(e);
  }, 1e3);
  const { t } = useAuraTranslation_default();
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react197.FormLabel, {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    borderRadius: "6px",
    border: "1px solid",
    borderColor: "gray.200",
    height: "40px",
    px: "16px",
    me: 0,
    mb: 0,
    className: "color-picker",
    htmlFor: "color_input",
    onClick: () => setIsNotClicked(false),
    ...isReadOnly && { bgColor: "gray.50" },
    children: [
      !isNotClicked && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraInput_default, {
        id: "color_input",
        onChange: debounced,
        isReadOnly,
        type: "color",
        defaultValue: color,
        className: "color-picker__input-color",
        px: 0,
        border: 0,
        w: "30px",
        h: "34px",
        _focus: { border: "0" }
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraInput_default, {
        ml: "8px",
        zIndex: color !== "" ? "0" : "-1",
        textStyle: "bodyInput",
        placeholder: t("COLOR_PICKER_CHOOSE_COLOR"),
        value: color,
        onChange: debounced,
        color: "gray.700",
        variant: "unstyled",
        className: "color-picker__input-text",
        isReadOnly,
        borderWidth: 0
      })
    ]
  });
};
var ColorPicker_default = ColorPicker;

// src/components/ConfirmDialog/ConfirmDialog.tsx
var import_react198 = __toESM(require("react"));
var import_react_confirm = require("react-confirm");
var import_react199 = require("@chakra-ui/react");
var import_jsx_runtime = require("react/jsx-runtime");
var ConfirmDialog = ({
  show,
  proceed,
  dismiss,
  confirmation,
  header,
  okButton,
  cancelButton,
  options
}) => {
  const cancelRef = import_react198.default.useRef(null);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react199.ChakraProvider, {
    theme: customTheme,
    resetCSS: false,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CustomCSSReset_default, {}),
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react199.AlertDialog, {
        leastDestructiveRef: cancelRef,
        isOpen: show,
        onClose: dismiss,
        onOverlayClick: () => proceed(false),
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react199.AlertDialogOverlay, {}),
          /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react199.AlertDialogContent, {
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react199.AlertDialogHeader, {
                fontSize: "lg",
                fontWeight: "bold",
                children: header
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react199.AlertDialogBody, {
                children: confirmation
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react199.AlertDialogFooter, {
                children: [
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react199.Button, {
                    colorScheme: "blue",
                    onClick: () => proceed(true),
                    ...options == null ? void 0 : options.okButtonProps,
                    children: okButton
                  }),
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react199.Button, {
                    ref: cancelRef,
                    onClick: () => proceed(false),
                    ml: 3,
                    ...options == null ? void 0 : options.cancelButtonProps,
                    children: cancelButton
                  })
                ]
              })
            ]
          })
        ]
      })
    ]
  });
};
var confirm2 = (0, import_react_confirm.createConfirmation)((0, import_react_confirm.confirmable)(ConfirmDialog));
var confirmWrapper = ({
  confirmation,
  header,
  okButton,
  cancelButton,
  options
}) => {
  return confirm2({ confirmation, header, okButton, cancelButton, options });
};
var ConfirmDialog_default = (0, import_react_confirm.confirmable)(ConfirmDialog);

// src/components/CommunicatorThreads/CommunicatorThreads.tsx
var import_react202 = require("@chakra-ui/react");
var import_react203 = __toESM(require("@mdi/react"));
var import_js33 = require("@mdi/js");

// src/components/CommunicatorThreads/ThreadList/ThreadList.tsx
var import_react200 = require("@chakra-ui/react");
var import_react201 = require("react");

// src/components/ModalMessageThread/utils.ts
var getSenderUserTypeName = (user) => {
  if ((user == null ? void 0 : user.type) === 1 /* accountUser */) {
    return "senderAccountUser";
  }
  if ((user == null ? void 0 : user.type) === 2 /* userUser */) {
    return "senderUser";
  }
  return "";
};
var getUsersDataForAddToThread = (data, lastReadMessageId) => {
  let preparedData;
  if (Array.isArray(data)) {
    preparedData = data == null ? void 0 : data.map((user) => {
      const userTypeKeyName = getUserThreadNameKey(user == null ? void 0 : user.userType);
      return {
        userType: user == null ? void 0 : user.userType,
        [`${userTypeKeyName}`]: user == null ? void 0 : user.value,
        ...idExists(lastReadMessageId) ? { lastReadMessage: lastReadMessageId } : {}
      };
    });
  } else {
    const userTypeKeyName = getUserThreadNameKey(data == null ? void 0 : data.userType);
    preparedData = {
      userType: data == null ? void 0 : data.userType,
      [`${userTypeKeyName}`]: data == null ? void 0 : data.value,
      ...idExists(lastReadMessageId) ? { lastReadMessage: lastReadMessageId } : {}
    };
  }
  return preparedData;
};
var getSelfMessageThreadUserId = (users, selfUserId) => {
  var _a2;
  const id = (_a2 = users == null ? void 0 : users.find((user) => (user == null ? void 0 : user.userId) === selfUserId)) == null ? void 0 : _a2.id;
  return id ?? null;
};
var getUserThreadNameKey = (userType) => {
  return userType === 2 /* userUser */ ? "userUser" : "accountUser";
};
var getLastMessageUserId = (thread) => {
  var _a2, _b, _c, _d;
  const id = ((_b = (_a2 = thread == null ? void 0 : thread.lastMessage) == null ? void 0 : _a2.senderUser) == null ? void 0 : _b.id) || ((_d = (_c = thread == null ? void 0 : thread.lastMessage) == null ? void 0 : _c.senderAccountUser) == null ? void 0 : _d.id);
  return id;
};
var openThreadRelation = ({
  relations,
  settings,
  handleHideModal,
  onOpen
}) => {
  var _a2, _b;
  const isNewLookEmailMessage = ((_a2 = settings == null ? void 0 : settings.settings) == null ? void 0 : _a2.newLookEmailMessage) || (settings == null ? void 0 : settings.new_look_email_message) === "true";
  for (const key in relations) {
    const relationItem = (_b = relations[key]) == null ? void 0 : _b[0];
    const id = relationItem == null ? void 0 : relationItem.id;
    if (idExists(id)) {
      if (key === "emailMessages") {
        handleHideModal();
        openRelationEmail({
          isNewLookEmailMessage,
          emailMessage: relationItem,
          onAfterClose: onOpen
        });
      } else if (key === "tasks") {
        handleHideModal();
        auraEditTask({ id: relationItem == null ? void 0 : relationItem.id, callbackAfterClose: onOpen });
      } else {
        const url = getModuleHref(key, id);
        window.open(url, "_blank");
      }
    }
  }
};
var openRelationEmail = ({
  isNewLookEmailMessage,
  emailMessage,
  onAfterClose
}) => {
  isNewLookEmailMessage ? window.Dialog.load({
    url: `emailMessage/properties?email_message_id=${emailMessage.id}&account_id=${emailMessage.accountId}&from_database=true&type=outcome`,
    size: "modal-xl"
  }).on("closed.dialog", (...props) => {
    onAfterClose();
  }) : emailMessage.subtype === "emailOutcomeMessage" ? window.Dialog.load({
    url: `emailMessage/properties?email_message_id=${emailMessage.id}&account_id=${emailMessage.accountId}&from_database=true&type=outcome`,
    size: "modal-xl"
  }).on("closed.dialog", (...props) => {
    onAfterClose();
  }) : window.Dialog.load({
    url: `/emailMessage/properties?imap_id=${emailMessage.imapId}&account_id=${emailMessage.accountId}&folder=${emailMessage.folder}`,
    size: "modal-xl"
  }).on("closed.dialog", (...props) => {
    onAfterClose();
  });
};
var hasAnyRelations = (relations) => {
  if (!relations)
    return false;
  return Object.values(relations).some(
    (value) => Array.isArray(value) && value.length > 0
  );
};

// src/components/CommunicatorThreads/ThreadList/ThreadList.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var ThreadList = ({
  userId,
  data,
  onClick,
  loadMore,
  isLoadingMore,
  showNotFoundNotification,
  showEmptyNotification,
  hasMore,
  ...props
}) => {
  const { t } = useAuraTranslation_default();
  const ref = (0, import_react201.useRef)(null);
  const maxHeight = (0, import_react200.useBreakpointValue)({
    base: "auto",
    md: "510px"
  });
  (0, import_react201.useEffect)(() => {
    const el2 = ref.current;
    if (!el2)
      return;
    const handleScroll = () => {
      const { scrollTop, scrollHeight, clientHeight } = el2;
      const scrollPercent = scrollTop / (scrollHeight - clientHeight);
      if (scrollPercent >= 0.7 && hasMore && !isLoadingMore) {
        loadMore();
      }
    };
    el2.addEventListener("scroll", handleScroll);
    return () => {
      el2.removeEventListener("scroll", handleScroll);
    };
  }, [loadMore, isLoadingMore, hasMore]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react200.VStack, {
    w: "full",
    spacing: 0,
    maxH: maxHeight,
    overflowY: "auto",
    className: "thread-list",
    ref,
    ...props,
    children: [
      showEmptyNotification && !showNotFoundNotification && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react200.Text, {
        w: "full",
        textAlign: "center",
        textStyle: "bodyInput",
        color: "gray.500",
        children: t("NO_MESSAGES")
      }),
      showNotFoundNotification ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react200.Text, {
        w: "full",
        textAlign: "center",
        textStyle: "bodyInput",
        color: "gray.500",
        children: t("NOTHING_FOUND")
      }) : data == null ? void 0 : data.map((thread, index) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ThreadListItem, {
        userId,
        data: thread,
        isLast: (data == null ? void 0 : data.length) > 0 && (data == null ? void 0 : data.length) === index + 1,
        onClick
      }, thread == null ? void 0 : thread.id)),
      isLoadingMore && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSpinner_default, {})
    ]
  });
};
var ThreadListItem = ({
  userId,
  data,
  onClick,
  isLast = true
}) => {
  var _a2, _b;
  const { t } = useAuraTranslation_default();
  const isSelfUser = userId === ((_b = (_a2 = data == null ? void 0 : data.lastMessage) == null ? void 0 : _a2.senderUser) == null ? void 0 : _b.id);
  const markAsUnread = !(data == null ? void 0 : data.hasBeenRead) && (data == null ? void 0 : data.notificationsEnabled);
  const lastMessageUserData = (0, import_react201.useMemo)(() => {
    var _a3;
    const lastMessageAuthorId = getLastMessageUserId(data);
    const preparedData = ((_a3 = data == null ? void 0 : data.users) == null ? void 0 : _a3.find((user) => (user == null ? void 0 : user.userId) === lastMessageAuthorId)) ?? {};
    return preparedData;
  }, [data]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react200.HStack, {
    w: "full",
    h: "84px",
    py: 4,
    px: 2,
    justifyContent: "space-between",
    spacing: 4,
    opacity: markAsUnread ? "1" : "0.7",
    "data-testid": `communication-thread-list-item-${data == null ? void 0 : data.id}`,
    onClick: () => onClick(data == null ? void 0 : data.id),
    _hover: {
      bgColor: "gray.100",
      cursor: "pointer"
    },
    ...isLast ? {} : { borderBottom: "1px solid", borderColor: "gray.200" },
    className: "thread-list__item",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react200.Avatar, {
        size: "sm",
        name: data == null ? void 0 : data.lastSenderName,
        src: getImageUrl(lastMessageUserData == null ? void 0 : lastMessageUserData.avatar, "thmb"),
        bgColor: (lastMessageUserData == null ? void 0 : lastMessageUserData.defaultCallendarColor) ?? "gray.200",
        className: "thread-list__item__avatar"
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react200.Box, {
        overflow: "hidden",
        w: "full",
        className: "thread-list__item__header",
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react200.HStack, {
            textStyle: "caption",
            letterSpacing: "0.25px",
            color: "gray.500",
            mb: "8px",
            spacing: 2,
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react200.Tooltip, {
                hasArrow: true,
                label: getUsersLabel(data == null ? void 0 : data.users, userId, t),
                openDelay: 500,
                children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react200.Text, {
                  isTruncated: true,
                  position: "relative",
                  noOfLines: 1,
                  children: getUsersLabel(data == null ? void 0 : data.users, userId, t)
                })
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react200.Text, {
                "data-testid": `communication-thread-${data == null ? void 0 : data.id}-users-count`,
                children: (data == null ? void 0 : data.userCount) > 1 && `(${data == null ? void 0 : data.userCount})`
              })
            ]
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react200.Text, {
            textStyle: "bodyInput",
            letterSpacing: "mediumWide",
            isTruncated: true,
            noOfLines: 1,
            "data-testid": `communication-thread-${data == null ? void 0 : data.id}-message`,
            className: "thread-list__item__content",
            children: [
              isSelfUser ? t("MESSAGE_SELF_LABEL") : data == null ? void 0 : data.lastSenderName,
              ":",
              " ",
              data == null ? void 0 : data.lastMessageContent
            ]
          })
        ]
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react200.Circle, {
        size: "8px",
        bg: "crmBlue",
        visibility: markAsUnread ? "visible" : "hidden",
        "data-testid": `communication-thread-${data == null ? void 0 : data.id}-message-read-status`,
        className: "thread-list__item__read-status",
        "aria-label": markAsUnread ? "message threads message unread" : "message threads message read"
      })
    ]
  });
};
var getUsersLabel = (users, selfUserId, t) => {
  if (!(users == null ? void 0 : users.length))
    return null;
  const isUserBelongToThread = users.some((user) => user.userId === selfUserId);
  let userNameLabels = users.filter((user) => user.userId !== selfUserId).map((user) => user.fullName);
  if (isUserBelongToThread) {
    userNameLabels.unshift(t("MESSAGE_SELF_LABEL"));
  }
  return userNameLabels.join(", ");
};
var ThreadList_default = ThreadList;

// src/components/CommunicatorThreads/CommunicatorThreads.tsx
var import_react204 = require("react");
var import_jsx_runtime = require("react/jsx-runtime");
var CommunicatorThreads = ({
  userId,
  data,
  onClickThread,
  onInputSearch,
  onClickCreate,
  totalCount = 0,
  isLoading,
  isLoadingFiltered,
  loadMore,
  isLoadingMore,
  hasMore
}) => {
  const { t } = useAuraTranslation_default();
  const [inputValue, setInputValue] = (0, import_react204.useState)();
  const isSm = (0, import_react202.useBreakpointValue)({
    base: true,
    md: false
  });
  const uiContext = isSm ? safeUseModalContext() : safeUsePopoverContext();
  const handleOnChange = (e) => {
    const value = e.target.value;
    setInputValue(value);
    onInputSearch(value);
  };
  (0, import_react204.useEffect)(() => {
    if (!(uiContext == null ? void 0 : uiContext.isOpen)) {
      setInputValue("");
      onInputSearch("");
    }
  }, [uiContext == null ? void 0 : uiContext.isOpen]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react202.VStack, {
    spacing: 4,
    className: "communication-threads",
    w: "full",
    "aria-label": "message threads popover",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react202.HStack, {
        justifyContent: "space-between",
        className: "communication-threads__header",
        w: "full",
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react202.Text, {
            textStyle: "bodyInput",
            fontWeight: 400,
            letterSpacing: "0.25px",
            color: "gray.500",
            className: "communication-threads__header__count-info",
            "data-testid": "communication-threads-count-info",
            ...(uiContext == null ? void 0 : uiContext.isOpen) ? {
              visibility: totalCount < 1 ? "hidden" : "visible"
            } : {},
            maxW: "50%",
            children: [
              t("DISPLAYED"),
              " ",
              /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react202.Text, {
                as: "span",
                whiteSpace: "nowrap",
                children: [
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)("span", {
                    children: data == null ? void 0 : data.length
                  }),
                  " ",
                  t("OF"),
                  " ",
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)("span", {
                    children: totalCount
                  })
                ]
              })
            ]
          }),
          typeof onClickCreate === "function" && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react202.Button, {
            letterSpacing: "basic",
            textStyle: "bodyInput",
            variant: "solid",
            bgColor: "crmBlue",
            color: "#fff",
            maxW: "116px",
            leftIcon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react203.default, {
              path: import_js33.mdiPencilOutline,
              size: "24px"
            }),
            className: "communication-threads__header__btn-create",
            "data-testid": "communication-threads-btn-new-message",
            "aria-label": "message threads new message button",
            onClick: onClickCreate,
            children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react202.Text, {
              w: "full",
              isTruncated: true,
              children: t("THREADS_NEW_MESSAGE_LABEL")
            })
          })
        ]
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react202.HStack, {
        w: "full",
        className: "communication-threads__search-bar",
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraInputCompact, {
          "aria-label": "message threads search bar",
          value: inputValue,
          leftIcon: import_js33.mdiMagnify,
          onChange: handleOnChange,
          isLoading: isLoadingFiltered
        })
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ThreadList_default, {
        userId,
        data,
        className: "communication-threads__list",
        "aria-label": "message threads list",
        onClick: onClickThread,
        loadMore,
        isLoadingMore,
        showNotFoundNotification: (inputValue == null ? void 0 : inputValue.length) && !isLoading && !isLoadingFiltered && totalCount < 1,
        showEmptyNotification: !(inputValue == null ? void 0 : inputValue.length) && !isLoading && !isLoadingFiltered && totalCount < 1,
        hasMore
      })
    ]
  });
};
var safeUseModalContext = () => {
  try {
    return (0, import_react202.useModalContext)();
  } catch {
    return null;
  }
};
var safeUsePopoverContext = () => {
  try {
    return (0, import_react202.usePopoverContext)();
  } catch {
    return null;
  }
};
var CommunicatorThreads_default = CommunicatorThreads;

// src/components/ConnectedCampaignOpportunity/ConnectedCampaignOpportunity.tsx
var import_react206 = require("react");
var import_react207 = require("@chakra-ui/react");
var import_js34 = require("@mdi/js");
var import_react208 = __toESM(require("@mdi/react"));

// src/components/ConnectedCampaignOpportunity/Milestones/Milestones.tsx
var import_react205 = require("@chakra-ui/react");
var import_jsx_runtime = require("react/jsx-runtime");
var Milestones = ({
  stage,
  countMilestones,
  ...props
}) => {
  const steps = [...Array(countMilestones).keys()].map((val, index) => {
    if (index <= stage) {
      return "blue.500";
    }
    return "";
  });
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react205.Box, {
    bg: "gray.200",
    borderRadius: 4,
    overflow: "hidden",
    ...props,
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react205.List, {
      as: "ul",
      display: "flex",
      flexWrap: "nowrap",
      overflow: "hidden",
      styleType: "none",
      fontSize: "10px",
      maxHeight: "1em",
      m: 0,
      children: steps.map((step, index) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react205.ListItem, {
        cursor: "pointer",
        flexGrow: 1,
        height: "1em",
        position: "relative",
        color: "white",
        bg: step,
        as: "li",
        userSelect: "none",
        _hover: {
          cursor: "default"
        },
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react205.Box, {
          bg: steps[index !== 0 ? index - 1 : index],
          "data-testid": "single-milestone",
          _before: {
            position: "absolute",
            content: `""`,
            height: "1em",
            width: "0.5em",
            backgroundColor: "white",
            transform: "translate(-2px)",
            clipPath: `polygon(
                  40% 0,
                  100% 50%,
                  40% 100%,
                  0% 100%,
                  60% 50%,
                  0% 0%
                )`
          },
          _after: {
            clipPath: `polygon(0 0, 0 100%, 50% 50%)`,
            backgroundColor: "inherit",
            transform: "translateX(-2px)",
            position: "absolute",
            content: `""`,
            height: "1em",
            width: "0.5em",
            border: "0 solid transparent"
          },
          display: index === 0 && "none",
          position: "absolute",
          left: 0,
          top: 0,
          as: "span"
        })
      }, index))
    })
  });
};
var Milestones_default = Milestones;

// src/components/ConnectedCampaignOpportunity/ConnectedCampaignOpportunity.tsx
var import_react_query30 = require("react-query");
var import_format = __toESM(require("date-fns/format"));
var import_date_fns11 = require("date-fns");
var import_jsx_runtime = require("react/jsx-runtime");
var statusCampaignOpportunity = {
  O: {
    color: "blue.500",
    title: "CAMPAIGN_OPPORTUNITY_STATUS_OPEN"
  },
  W: {
    color: "green.500",
    title: "CAMPAIGN_OPPORTUNITY_STATUS_WON"
  },
  L: {
    color: "red.500",
    title: "CAMPAIGN_OPPORTUNITY_STATUS_LOST"
  },
  H: {
    color: "orange.500",
    title: "CAMPAIGN_OPPORTUNITY_STATUS_HOLD"
  }
};
var ConnectedCampaignOpportunity = ({
  id,
  index,
  status,
  title,
  company,
  connectedUser,
  value,
  createdAt,
  estimatedCloseDate,
  progress,
  campaignPhaseId,
  campaignId,
  onRemove,
  isReadOnly
}) => {
  var _a2, _b, _c, _d;
  const isMobile = (0, import_react207.useBreakpointValue)({
    base: true,
    lg: false
  });
  const { t, tCustom } = useAuraTranslation_default();
  const [isLoading, setIsLoading] = (0, import_react206.useState)(false);
  const { data: campaignPhases, isLoading: isLoadingCampaignPhases } = (0, import_react_query30.useQuery)(
    ["campaignPhases", "countStages", campaignId],
    () => api_default.getList("campaign_phases", {
      params: {
        fields: "name,campaign.id,campaign.name",
        "setting[with_relations]": true,
        "filter[campaign.id][eq]": campaignId
      }
    }),
    {
      select: (response) => response == null ? void 0 : response.data,
      enabled: !!id && !!campaignId
    }
  );
  const countMilestones = (0, import_react206.useMemo)(
    () => campaignPhases == null ? void 0 : campaignPhases.length,
    [campaignPhases]
  );
  const actualPhase = (0, import_react206.useMemo)(
    () => {
      var _a3;
      return (_a3 = campaignPhases == null ? void 0 : campaignPhases.filter((item) => (item == null ? void 0 : item.id) === campaignPhaseId)) == null ? void 0 : _a3[0];
    },
    [campaignPhases, campaignPhaseId]
  );
  const preparedValue = (value == null ? void 0 : value.worth) && priceFormatter(value == null ? void 0 : value.worth, value == null ? void 0 : value.currency);
  const preparedCreatedAt = createdAt && (0, import_format.default)((0, import_date_fns11.parseISO)(createdAt), DATE_FORMAT_DOTS);
  const preparedEstimatedCloseDate = estimatedCloseDate && (0, import_format.default)((0, import_date_fns11.parseISO)(estimatedCloseDate), DATE_FORMAT_DOTS);
  const handleOnRemove = async () => {
    setIsLoading(true);
    await onRemove();
    setIsLoading(false);
  };
  const removeButton = () => {
    if (typeof onRemove !== "function") {
      return null;
    }
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react207.IconButton, {
      onClick: handleOnRemove,
      "aria-label": "undo chance",
      icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react208.default, {
        path: import_js34.mdiLinkVariantOff,
        size: "24px"
      }),
      isLoading,
      className: "connected-opportunity__remove"
    });
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react207.Flex, {
    p: {
      base: "16px 0 16px 8px",
      lg: "24px 0 24px 16px"
    },
    className: "connected-opportunity",
    gap: 3,
    flexDirection: { base: "column", lg: "row" },
    alignItems: "center",
    borderTop: index === 0 ? 0 : 1,
    borderStyle: "solid",
    borderColor: "gray.200",
    w: "100%",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react207.Flex, {
        flexDirection: "row",
        w: "full",
        alignItems: "center",
        flex: 1,
        children: [
          connectedUser && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react207.Box, {
            className: "connected-opportunity__avatar",
            display: { base: "none", md: "block" },
            children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react207.Tooltip, {
              label: connectedUser == null ? void 0 : connectedUser.fullName,
              children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react207.Avatar, {
                size: "sm",
                me: "16px",
                name: connectedUser.fullName,
                src: getImageUrl(connectedUser == null ? void 0 : connectedUser.avatar, "thmb"),
                ...(connectedUser == null ? void 0 : connectedUser.defaultCallendarColor) && {
                  bg: connectedUser.defaultCallendarColor
                }
              })
            })
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react207.HStack, {
            justifyContent: "space-between",
            w: "full",
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react207.Flex, {
                flexDirection: "column",
                gap: 3,
                w: "full",
                sx: {
                  ".information__container": {
                    fontSize: "13px"
                  },
                  ".information__container__icon-box": {
                    mr: "8px",
                    color: "gray.300"
                  },
                  ".information__link": {
                    lineHeight: "20px"
                  }
                },
                children: [
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react207.Link, {
                    href: `/campaignOpportunity/show/opportunity_id/${id}`,
                    color: "crmBlue",
                    letterSpacing: "0.5px",
                    lineHeight: "24px",
                    w: "fit-content",
                    fontSize: "15px",
                    className: "connected-opportunity__header",
                    wordBreak: "break-word",
                    children: tCustom(title)
                  }),
                  /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react207.HStack, {
                    spacing: "12px",
                    justifyContent: { base: "space-between", md: "flex-start" },
                    w: "full",
                    children: [
                      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react207.Badge, {
                        bgColor: "red.500",
                        backgroundColor: (_a2 = statusCampaignOpportunity[status]) == null ? void 0 : _a2.color,
                        px: "36px",
                        color: "white",
                        textTransform: "lowercase",
                        letterSpacing: "0.4px",
                        fontWeight: "600",
                        borderRadius: "4px",
                        lineHeight: "20px",
                        h: "20px",
                        alignItems: "center",
                        w: "fit-content",
                        className: "connected-opportunity__status",
                        children: t((_b = statusCampaignOpportunity[status]) == null ? void 0 : _b.title)
                      }),
                      preparedValue && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react207.Text, {
                        lineHeight: "24px",
                        fontSize: "15px",
                        children: preparedValue
                      })
                    ]
                  }),
                  (company == null ? void 0 : company.id) && (company == null ? void 0 : company.name) ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Information_default, {
                    label: company.name,
                    link: `/accountCompany/show/company_id/${company.id}`,
                    icon: import_js34.mdiOfficeBuilding,
                    iconSize: "20px"
                  }) : null
                ]
              }),
              isMobile && !isReadOnly ? removeButton() : null
            ]
          })
        ]
      }),
      !isMobile && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, {
        children: preparedCreatedAt || preparedEstimatedCloseDate ? /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react207.Flex, {
          flex: 1,
          wrap: "wrap",
          fontSize: "15px",
          className: "connected-opportunity__dates",
          justifyContent: "flex-start",
          sx: {
            span: {
              fontWeight: 400
            }
          },
          letterSpacing: "0.5px",
          children: [
            preparedCreatedAt && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react207.HStack, {
              mb: 2,
              children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react207.Text, {
                fontWeight: "600",
                noOfLines: 1,
                children: [
                  t("LIST_COLUMN_createdAt"),
                  ":",
                  " ",
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)("span", {
                    children: preparedCreatedAt
                  })
                ]
              })
            }),
            preparedEstimatedCloseDate && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react207.HStack, {
              children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react207.Text, {
                fontWeight: "600",
                children: [
                  t("LIST_COLUMN_estimatedCloseDate"),
                  ":",
                  " ",
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)("span", {
                    children: preparedEstimatedCloseDate
                  })
                ]
              })
            })
          ]
        }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, {})
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react207.Flex, {
        h: "fit-content",
        w: "full",
        flex: 1,
        flexDirection: "row",
        justifyContent: "space-between",
        className: "connected-opportunity__stage",
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react207.Flex, {
            flexDirection: "column",
            w: "full",
            gap: 2,
            pe: isMobile ? 0 : 3,
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react207.Flex, {
                flexDirection: "column",
                w: "full",
                children: [
                  ((_c = actualPhase == null ? void 0 : actualPhase.campaign) == null ? void 0 : _c.name) && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react207.Link, {
                    letterSpacing: "0.5px",
                    className: "connected-opportunity__stage__title",
                    fontSize: "15px",
                    color: "crmBlue",
                    href: `/campaign/show/campaign_id/${actualPhase.campaign.id}`,
                    children: t((_d = actualPhase == null ? void 0 : actualPhase.campaign) == null ? void 0 : _d.name)
                  }),
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react207.Text, {
                    letterSpacing: "0.5px",
                    className: "connected-opportunity__stage__title",
                    fontSize: "15px",
                    children: t(actualPhase == null ? void 0 : actualPhase.name)
                  })
                ]
              }),
              !isLoadingCampaignPhases && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Milestones_default, {
                stage: progress,
                countMilestones,
                className: "connected-opportunity__stage__milestones"
              })
            ]
          }),
          !isMobile && !isReadOnly ? removeButton() : null
        ]
      })
    ]
  });
};
var ConnectedCampaignOpportunity_default = ConnectedCampaignOpportunity;

// src/components/ConnectedDocument/ConnectedDocument.tsx
var import_react209 = require("@chakra-ui/react");
var import_js35 = require("@mdi/js");
var import_react210 = __toESM(require("@mdi/react"));
var import_date_fns12 = require("date-fns");
var import_react211 = require("react");
var import_jsx_runtime = require("react/jsx-runtime");
var ConnectedDocument = ({
  name,
  url,
  date,
  onDisconnect
}) => {
  const { tCustom } = useAuraTranslation_default();
  const [isLoading, setIsLoading] = (0, import_react211.useState)(false);
  const removeConnectedDocument = async () => {
    setIsLoading(true);
    await onDisconnect();
    setIsLoading(false);
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react209.Stack, {
    className: "connected-document",
    direction: "row",
    align: "center",
    py: 2,
    pl: 4,
    borderBottom: "1px solid",
    borderColor: "gray.200",
    fontSize: "md",
    letterSpacing: "0.5px",
    fontWeight: "400",
    spacing: 1,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react209.Link, {
        className: "connected-document__link",
        flex: 1,
        color: "blue.500",
        lineHeight: "24px",
        href: url,
        children: tCustom(name)
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react209.Box, {
        w: "124px",
        display: { base: "none", md: "block" },
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react209.Text, {
          className: "connected-document__date",
          lineHeight: "24px",
          children: (0, import_date_fns12.format)(date, DATE_FORMAT_DOTS)
        })
      }),
      onDisconnect ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react209.IconButton, {
        size: "md",
        icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react210.default, {
          path: import_js35.mdiLinkVariantOff,
          size: "20px"
        }),
        "aria-label": "disconnect",
        isLoading,
        onClick: removeConnectedDocument
      }) : null
    ]
  });
};
var ConnectedDocument_default = ConnectedDocument;

// src/components/ConnectedProcess/ConnectedProcess.tsx
var import_react216 = require("@chakra-ui/react");
var import_js36 = require("@mdi/js");
var import_react217 = __toESM(require("@mdi/react"));
var import_react218 = require("react");

// src/components/DateTag/DateTag.tsx
var import_react212 = require("@chakra-ui/react");
var import_date_fns13 = require("date-fns");
var import_jsx_runtime = require("react/jsx-runtime");
var getTagColor = (value) => {
  if ((0, import_date_fns13.isPast)(value)) {
    return "red";
  }
  if ((0, import_date_fns13.isToday)(value)) {
    return "blue";
  }
  return "green";
};
var DateTag = ({
  value,
  withColors = false,
  withTime = true,
  variantDisplay = "tag",
  ...props
}) => {
  const parsedValue = value && new Date(value);
  const invalidDateValue = !value || parsedValue.toString() === "Invalid Date";
  const dateValue = invalidDateValue ? "-" : (0, import_date_fns13.format)(parsedValue, withTime ? DATETIME_FORMAT_DOTS : DATE_FORMAT_DOTS);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, {
    children: variantDisplay === "tag" ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react212.Tag, {
      className: "date-tag",
      fontFamily: "body",
      fontWeight: "normal",
      colorScheme: !invalidDateValue && withColors ? getTagColor(parsedValue) : "gray",
      variant: withColors ? "solid" : "subtle",
      cursor: "default",
      size: "sm",
      fontSize: "sm",
      justifyContent: "center",
      ...invalidDateValue && { minW: "50px" },
      ...props,
      children: dateValue
    }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react212.Badge, {
      className: "date-tag",
      variant: withColors ? "solid" : "subtle",
      colorScheme: !invalidDateValue && withColors ? getTagColor(parsedValue) : "gray",
      whiteSpace: "normal",
      textStyle: "caption",
      fontWeight: "400",
      noOfLines: 1,
      ...props,
      children: dateValue
    })
  });
};
var DateTag_default = DateTag;

// src/components/ConnectedProcess/Milestones/Milestones.tsx
var import_react213 = require("@chakra-ui/react");
var import_jsx_runtime = require("react/jsx-runtime");
var Milestones2 = ({
  maxStages,
  stage,
  color,
  ...props
}) => {
  if (!maxStages) {
    return null;
  }
  const steps = [...Array(maxStages).keys()].map((val, index) => {
    if (index < stage - 1) {
      return "green.500";
    }
    if (index === stage - 1) {
      return `${color}.500`;
    }
    return "";
  });
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react213.Box, {
    bg: "gray.200",
    borderRadius: 4,
    overflow: "hidden",
    ...props,
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react213.List, {
      as: "ul",
      display: "flex",
      flexWrap: "nowrap",
      overflow: "hidden",
      styleType: "none",
      fontSize: "10px",
      maxHeight: "1em",
      m: 0,
      children: steps.map((step, index) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react213.ListItem, {
        cursor: "pointer",
        flexGrow: 1,
        height: "1em",
        position: "relative",
        color: "white",
        bg: step,
        as: "li",
        userSelect: "none",
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react213.Box, {
          bg: steps[index !== 0 ? index - 1 : index],
          _before: {
            position: "absolute",
            content: `""`,
            height: "1em",
            width: "0.5em",
            backgroundColor: "white",
            transform: "translate(-2px)",
            clipPath: `polygon(
                  40% 0,
                  100% 50%,
                  40% 100%,
                  0% 100%,
                  60% 50%,
                  0% 0%
                )`
          },
          _after: {
            clipPath: `polygon(0 0, 0 100%, 50% 50%)`,
            backgroundColor: "inherit",
            transform: "translateX(-2px)",
            position: "absolute",
            content: `""`,
            height: "1em",
            width: "0.5em",
            border: "0 solid transparent"
          },
          display: index === 0 && "none",
          position: "absolute",
          left: 0,
          top: 0,
          as: "span"
        })
      }, index))
    })
  });
};
var Milestones_default2 = Milestones2;

// src/components/ConnectedProcess/TagsList/TagsList.tsx
var import_react215 = require("@chakra-ui/react");

// src/components/SmallTag/SmallTag.tsx
var import_react214 = require("@chakra-ui/react");
var import_jsx_runtime = require("react/jsx-runtime");
var SmallTag = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react214.Tag, {
    fontFamily: "body",
    fontWeight: "normal",
    colorScheme: "gray",
    variant: "subtle",
    cursor: "default",
    size: "md",
    ...props
  });
};
var SmallTag_default = SmallTag;

// src/components/ConnectedProcess/TagsList/TagsList.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var TagsList = ({ tags, ...props }) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react215.Wrap, {
    className: "taglist",
    mt: -1,
    flexWrap: "wrap",
    gap: 2,
    ...props,
    children: tags.map((tag, index) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react215.WrapItem, {
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(SmallTag_default, {
        className: "tag",
        children: tag
      })
    }, index))
  });
};
var TagsList_default = TagsList;

// src/components/ConnectedProcess/ConnectedProcess.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var ConnectedProcess = ({
  commission,
  index,
  maxStages,
  commissionUserAvatars,
  onRemove
}) => {
  var _a2, _b, _c;
  const { t, tCustom } = useAuraTranslation_default();
  const {
    id,
    commissionName,
    relationName,
    relatedPhase,
    relatedSystemAttributes,
    startDate,
    endDate
  } = commission;
  const [isExpanded, setIsExpanded] = (0, import_react218.useState)(false);
  const [isLoading, setIsLoading] = (0, import_react218.useState)(false);
  const screenPhone = (0, import_react216.useBreakpointValue)({
    base: true,
    md: false
  });
  const screenPc = (0, import_react216.useBreakpointValue)({
    base: false,
    lg: true
  });
  const removeConnectedProcess = async () => {
    setIsLoading(true);
    await onRemove();
    setIsLoading(false);
  };
  const tags = relatedSystemAttributes == null ? void 0 : relatedSystemAttributes.find(
    (attribute) => attribute.uuid === "e087dd7a-d926-405d-8511-bd88a1f341a3"
  );
  const description = relatedSystemAttributes == null ? void 0 : relatedSystemAttributes.find(
    (attribute) => attribute.uuid === "942dd38d-8023-4efc-8c26-b0b535a241d4"
  );
  const tagsValue = tags ? tags.value : [];
  const descriptionValue = description ? description.value : null;
  const commissionWithAvatar = commissionUserAvatars == null ? void 0 : commissionUserAvatars.find(
    (c) => c.id === commission.id
  );
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react216.Flex, {
    className: "connected-process",
    role: "group",
    wrap: "wrap",
    justify: "space-evenly",
    align: "center",
    w: "100%",
    p: "24px 0px 24px 16px",
    flexDirection: "column",
    borderTop: index === 0 ? 0 : 1,
    borderStyle: "solid",
    borderColor: "gray.200",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react216.Flex, {
        width: "100%",
        justify: {
          base: "space-between",
          md: !!(tags == null ? void 0 : tags.length) || (relatedPhase == null ? void 0 : relatedPhase.phaseName) ? "space-between" : "flex-start"
        },
        align: "center",
        gap: "4px",
        children: [
          ((_a2 = commissionWithAvatar == null ? void 0 : commissionWithAvatar.user) == null ? void 0 : _a2.fullName) ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react216.Tooltip, {
            label: commissionWithAvatar.user.fullName,
            children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react216.Avatar, {
              size: "sm",
              name: commissionWithAvatar.user.fullName,
              src: getImageUrl((_b = commissionWithAvatar == null ? void 0 : commissionWithAvatar.user) == null ? void 0 : _b.avatar, "thmb"),
              ...((_c = commissionWithAvatar == null ? void 0 : commissionWithAvatar.user) == null ? void 0 : _c.defaultCallendarColor) && {
                bg: commissionWithAvatar.user.defaultCallendarColor
              }
            })
          }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react216.Avatar, {
            className: "connected-process__avatar",
            size: "sm"
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react216.Flex, {
            px: "8px",
            wrap: "wrap",
            textAlign: "center",
            w: 40,
            justifyContent: "center",
            children: [
              startDate || endDate ? /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react216.VStack, {
                w: "full",
                spacing: 2,
                mb: "12px",
                mx: 4,
                children: [
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react216.Tooltip, {
                    label: t("DATE_START"),
                    openDelay: 500,
                    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react216.Flex, {
                      w: "full",
                      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(DateTag_default, {
                        value: startDate,
                        variantDisplay: "badge",
                        w: "full"
                      })
                    })
                  }),
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react216.Tooltip, {
                    label: t("DATE_END"),
                    openDelay: 500,
                    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react216.Flex, {
                      w: "full",
                      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(DateTag_default, {
                        value: endDate,
                        variantDisplay: "badge",
                        w: "full"
                      })
                    })
                  })
                ]
              }) : null,
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react216.Link, {
                className: "connected-process__name",
                wordBreak: "break-word",
                color: "crmBlue",
                href: `/commission/show/commission_id/${id}`,
                children: !commissionName || commissionName.trim().length === 0 ? /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react216.Text, {
                  as: "span",
                  color: "gray.600",
                  children: [
                    "[",
                    t("NO_NAME"),
                    "]"
                  ]
                }) : commissionName
              }),
              relationName && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react216.Badge, {
                className: "connected-process__relation",
                width: "100%",
                mx: 4,
                mt: "12px",
                textTransform: "initial",
                variant: "subtle",
                colorScheme: "gray",
                whiteSpace: "normal",
                textStyle: "caption",
                fontWeight: "400",
                children: t(relationName)
              })
            ]
          }),
          screenPc && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ConnectedProcessMilestones, {
            relatedPhase,
            maxStages
          }),
          !screenPhone && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ConnectedProcessTags, {
            tags: tagsValue
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react216.Stack, {
            isInline: true,
            align: "center",
            spacing: "12px",
            children: [
              onRemove && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react216.Box, {
                children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react216.IconButton, {
                  className: "connected-process__remove",
                  "aria-label": "connected-process__remove",
                  isDisabled: isLoading,
                  isLoading,
                  size: "md",
                  variant: "solid",
                  icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react217.default, {
                    path: import_js36.mdiLinkVariantOff,
                    size: "24px"
                  }),
                  onClick: () => removeConnectedProcess(),
                  px: "8px",
                  "data-testid": "remove-button"
                })
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react216.IconButton, {
                className: "connected-process__description-dropdown",
                "aria-label": "connected-process__description-dropdown",
                size: "md",
                variant: "ghost",
                onClick: () => setIsExpanded(!isExpanded),
                visibility: descriptionValue ? "visible" : "hidden",
                icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react217.default, {
                  path: isExpanded ? import_js36.mdiChevronUp : import_js36.mdiChevronDown,
                  size: "20px"
                })
              })
            ]
          })
        ]
      }),
      !screenPc && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ConnectedProcessMilestones, {
        relatedPhase,
        maxStages
      }),
      screenPhone && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ConnectedProcessTags, {
        tags: tagsValue
      }),
      descriptionValue && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react216.Box, {
        w: "full",
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react216.Collapse, {
          in: isExpanded,
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react216.Stack, {
            className: "connected-process__description",
            w: "full",
            spacing: "8px",
            mt: "24px",
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react216.Text, {
                fontWeight: "semibold",
                as: "p",
                children: tCustom(description.name)
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react216.Text, {
                whiteSpace: "pre-wrap",
                as: "p",
                children: descriptionValue
              })
            ]
          })
        })
      })
    ]
  });
};
var ConnectedProcessMilestones = ({ relatedPhase, maxStages }) => {
  const { tCustom } = useAuraTranslation_default();
  const stage = relatedPhase == null ? void 0 : relatedPhase.stage;
  const phaseColor = relatedPhase == null ? void 0 : relatedPhase.color;
  const isEmptyContainer = !!!(relatedPhase == null ? void 0 : relatedPhase.phaseName);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react216.Box, {
    className: "connected-process__milestones",
    maxW: "full",
    flex: 1,
    w: { base: "full", lg: "initial" },
    ...!isEmptyContainer ? {
      mt: { base: "24px", lg: 0 }
    } : {},
    px: { base: 0, lg: "8px" },
    "data-testid": "phase-with-milestones",
    children: (relatedPhase == null ? void 0 : relatedPhase.phaseName) && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react216.Text, {
          as: "p",
          whiteSpace: "pre-wrap",
          maxW: "full",
          children: tCustom(relatedPhase.phaseName)
        }),
        (stage || phaseColor !== "") && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Milestones_default2, {
          mt: "12px",
          maxStages,
          stage,
          color: phaseColor
        })
      ]
    })
  });
};
var ConnectedProcessTags = ({ tags }) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react216.Box, {
    className: "connected-process__tags",
    flex: 1,
    mt: { base: "24px", md: 0 },
    px: { base: 0, md: "8px" },
    w: "full",
    children: (tags == null ? void 0 : tags.length) > 0 && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TagsList_default, {
      tags
    })
  });
};
var ConnectedProcess_default = ConnectedProcess;

// src/components/ConnectedProcessesPopover/ConnectedProcessesPopover.tsx
var import_react221 = require("@chakra-ui/react");
var import_js37 = require("@mdi/js");

// src/components/ConnectedProcessPopover/ConnectedProcessPopover.tsx
var import_react219 = require("@chakra-ui/react");
var import_react220 = __toESM(require("@mdi/react"));
var import_jsx_runtime = require("react/jsx-runtime");
var ConnectedProcessPopover = ({
  data = null,
  config,
  label,
  icon,
  iconSize = "md",
  ...props
}) => {
  const filteredData = data;
  if (!config) {
    return null;
  }
  const iconPixels = iconSize === "xs" ? "24px" : "20px";
  if (!filteredData || filteredData.length < 1) {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react219.IconButton, {
      "aria-label": "no-connection",
      isDisabled: true,
      variant: "ghost",
      size: iconSize,
      color: "gray.700",
      icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react220.default, {
        path: icon,
        size: iconPixels
      })
    });
  }
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react219.Box, {
    cursor: "pointer",
    ...props,
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react219.Popover, {
      closeOnBlur: true,
      returnFocusOnClose: true,
      trigger: "hover",
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react219.PopoverTrigger, {
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react219.IconButton, {
            "aria-label": "connection-type",
            variant: "solid",
            size: iconSize,
            color: "gray.700",
            icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react220.default, {
              path: icon,
              size: iconPixels
            })
          })
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react219.PopoverContent, {
          zIndex: 4,
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react219.PopoverArrow, {}),
            /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react219.PopoverHeader, {
              children: [
                label,
                ":"
              ]
            }),
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react219.PopoverBody, {
              children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react219.List, {
                children: filteredData.map(({ commissionName, id }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react219.ListItem, {
                  children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react219.Link, {
                    href: `/commission/show/commission_id/${id}`,
                    noOfLines: 1,
                    className: "connected-process__link",
                    children: commissionName
                  })
                }, id))
              })
            })
          ]
        })
      ]
    })
  });
};
var ConnectedProcessPopover_default = ConnectedProcessPopover;

// src/components/ConnectedProcessesPopover/ConnectedProcessesPopover.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var ConnectedProcessesPopover = ({
  data,
  credentials,
  iconSize = "md",
  ...props
}) => {
  const { t } = useAuraTranslation_default();
  if (!data || data.length < 1) {
    return null;
  }
  const parallelProcesses = data.filter(
    (relation) => ["parallelStart", "parallelEnd"].includes(relation == null ? void 0 : relation.subtype)
  );
  const parentProcesses = data.filter(
    (relation) => (relation == null ? void 0 : relation.subtype) === "parent"
  );
  const childProcesses = data.filter(
    (relation) => (relation == null ? void 0 : relation.subtype) === "child"
  );
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react221.Stack, {
    isInline: true,
    spacing: 1,
    justify: "end",
    className: "connected-processes-popover",
    ...props,
    children: [
      (credentials == null ? void 0 : credentials.parallel) && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ConnectedProcessPopover_default, {
        className: "connected-processes__parallel",
        label: t("RELATED_PROCESSES_PARALLEL"),
        icon: import_js37.mdiArrowRight,
        config: parallelProcesses.length > 0,
        data: parallelProcesses,
        iconSize
      }),
      (credentials == null ? void 0 : credentials.parent) && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ConnectedProcessPopover_default, {
        className: "connected-processes__parent",
        label: t("RELATED_PROCESSES_PARENT"),
        icon: import_js37.mdiArrowUp,
        config: parentProcesses.length > 0,
        data: parentProcesses,
        iconSize
      }),
      (credentials == null ? void 0 : credentials.child) && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ConnectedProcessPopover_default, {
        className: "connected-processes__child",
        label: t("RELATED_PROCESSES_CHILD"),
        icon: import_js37.mdiArrowDown,
        config: childProcesses.length > 0,
        data: childProcesses,
        iconSize
      })
    ]
  });
};
var ConnectedProcessesPopover_default = ConnectedProcessesPopover;

// src/components/ConnectedServicedProduct/ConnectedServicedProduct.tsx
var import_react222 = require("@chakra-ui/react");
var import_react223 = require("react");
var import_js38 = require("@mdi/js");
var import_react224 = __toESM(require("@mdi/react"));
var import_jsx_runtime = require("react/jsx-runtime");
var ConnectedServicedProduct = ({
  id,
  serialCode,
  productName,
  onRemove,
  hasDeleteCredential = true
}) => {
  const [isLoading, setIsLoading] = (0, import_react223.useState)(false);
  const removeConnectedServicedProduct = async () => {
    setIsLoading(true);
    await onRemove();
    setIsLoading(false);
  };
  const baseStyleText = {
    flex: 1,
    color: "blue.500",
    isTruncated: true
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react222.Flex, {
    className: "connected-serviced-product",
    borderBottom: "1px solid",
    borderColor: "gray.200",
    ps: "16px",
    py: "8px",
    textStyle: "bodyInput",
    alignItems: "center",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react222.Text, {
        className: "connected-serviced-product__serial-code",
        mr: "16px",
        ...baseStyleText,
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react222.Link, {
          href: `/servicedProduct/show/serviced_product_id/${id}`,
          children: serialCode
        })
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react222.Text, {
        className: "connected-serviced-product__product-name",
        mr: "8px",
        ...baseStyleText,
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react222.Link, {
          href: `/servicedProduct/show/serviced_product_id/${id}`,
          children: productName
        })
      }),
      hasDeleteCredential && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react222.IconButton, {
        className: "connected-serviced-product__remove",
        "aria-label": "connected-serviced-product__remove",
        variant: "solid",
        isDisabled: isLoading,
        isLoading,
        size: "md",
        onClick: removeConnectedServicedProduct,
        icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react224.default, {
          path: import_js38.mdiLinkVariantOff,
          size: "24px"
        })
      })
    ]
  });
};
var ConnectedServicedProduct_default = ConnectedServicedProduct;

// src/components/ConnectedTaskAndEvent/ConnectedTaskAndEvent.tsx
var import_react229 = require("react");
var import_react230 = require("@chakra-ui/react");
var import_react231 = __toESM(require("@mdi/react"));
var import_js41 = require("@mdi/js");

// src/components/ConnectedTaskAndEvent/TaskAndEventIcon/TaskAndEventIcon.tsx
var import_react225 = require("@chakra-ui/react");
var import_react226 = __toESM(require("@mdi/react"));
var import_js39 = require("@mdi/js");
var import_jsx_runtime = require("react/jsx-runtime");
var TaskAndEventIcon = ({
  icon,
  iconColor,
  typeName
}) => {
  const { tCustom } = useAuraTranslation_default();
  const STANDARD_ICONS2 = {
    default: import_js39.mdiHelp,
    "glyphicon-phone-alt": import_js39.mdiPhone,
    "glyphicon-star": import_js39.mdiStar,
    "glyphicon-briefcase": import_js39.mdiBriefcase,
    "glyphicon-flag": import_js39.mdiFlagVariant,
    "glyphicon-fire": import_js39.mdiFire
  };
  const standardIconKey = !icon ? "default" : Object.keys(STANDARD_ICONS2).find((key) => icon.match(key));
  if (standardIconKey) {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react225.Tooltip, {
      label: tCustom(typeName),
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react225.Circle, {
        size: "24px",
        bg: "transparent",
        border: "1px solid #CBD5E0",
        me: "16px",
        className: "connected-task-and-event__type-icon",
        color: iconColor ?? "#2D3748",
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react226.default, {
          path: STANDARD_ICONS2[standardIconKey],
          size: "15px"
        })
      })
    });
  } else {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react225.Box, {
      display: "inline-block",
      className: "connected-task-and-event__type-icon",
      dangerouslySetInnerHTML: {
        __html: `<span style="fill: ${iconColor}" title="${tCustom(
          typeName
        )}">${icon}</span>`
      },
      p: "0",
      me: "16px"
    });
  }
};
var TaskAndEventIcon_default = TaskAndEventIcon;

// src/components/ConnectedTaskAndEvent/ResponsibleUnit/ResponsibleUnit.tsx
var import_react227 = require("@chakra-ui/react");
var import_react228 = __toESM(require("@mdi/react"));
var import_js40 = require("@mdi/js");
var import_jsx_runtime = require("react/jsx-runtime");
var ResponsibleUnit = ({ data, type }) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react227.Flex, {
    alignItems: "flex-start",
    color: "gray.300",
    mt: "8px",
    className: "connected-task-and-event__responsible-unit",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react227.Box, {
        boxSize: "20px",
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react228.default, {
          size: "20px",
          path: type === "company" ? import_js40.mdiOfficeBuildingOutline : import_js40.mdiAccountOutline
        })
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react227.Flex, {
        justifyContent: "flex-start",
        flexDir: "column",
        children: data.map((el2, index) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react227.Text, {
          fontStyle: "caption",
          fontSize: "13px",
          color: "crmBlue",
          ms: "8px",
          letterSpacing: "0.25px",
          mt: index > 0 && "8px",
          mb: "0",
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react227.Link, {
            href: type === "company" ? `/accountCompany/show/company_id/${el2.id}` : `/accountUser/show/user_id/${el2.id}`,
            children: el2.fullName
          })
        }, index))
      })
    ]
  });
};
var ResponsibleUnit_default = ResponsibleUnit;

// src/components/ConnectedTaskAndEvent/ConnectedTaskAndEvent.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var ConnectedTaskAndEvent = ({
  isTask,
  isExecutable,
  taskName,
  taskDescription,
  user,
  contractorUsers = [],
  companies = [],
  date,
  type,
  handleEditTaskAura,
  handleCompleteTaskAura,
  ...props
}) => {
  const { t } = useAuraTranslation_default();
  const [isTooltipActive, setTooltipActive] = (0, import_react229.useState)(true);
  const isMobileScreen = (0, import_react230.useBreakpointValue)({
    base: true,
    lg: false
  });
  const descriptionToDisplay = stripHtmlTags(taskDescription ?? "");
  const userName = user ? user.fullName : "";
  const ref = (0, import_react229.useRef)();
  (0, import_react230.useOutsideClick)({
    ref,
    handler: () => setTooltipActive(true)
  });
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react230.HStack, {
    alignItems: "flex-start",
    className: "connected-task-and-event",
    position: "relative",
    py: "12px",
    ps: "16px",
    spacing: "12px",
    pe: { base: "16px", lg: "52px" },
    borderBottom: "solid 1px",
    borderBottomColor: "gray.200",
    "data-testid": `connected-${isTask ? "task" : "event"}`,
    ...props,
    children: [
      !isMobileScreen && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react230.Tooltip, {
        label: `${userName}`,
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react230.Avatar, {
          size: "sm",
          name: `${userName}`,
          src: getImageUrl(user == null ? void 0 : user.avatar, "thmb"),
          alignSelf: "center",
          className: "connected-task-and-event__avatar",
          ...(user == null ? void 0 : user.defaultCallendarColor) && {
            bg: user.defaultCallendarColor
          }
        })
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react230.Box, {
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(DateTag_default, {
            value: date,
            withColors: isTask,
            className: "connected-task-and-event__begin-date",
            mb: "8px"
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react230.Flex, {
            alignItems: "center",
            my: { base: 0, lg: "4px" },
            children: [
              isMobileScreen && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react230.Avatar, {
                size: "sm",
                name: `${userName}`,
                src: getImageUrl(user == null ? void 0 : user.avatar, "thmb"),
                me: "16px",
                className: "connected-task-and-event__avatar",
                ...(user == null ? void 0 : user.defaultCallendarColor) && {
                  bg: user.defaultCallendarColor
                }
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TaskAndEventIcon_default, {
                icon: type == null ? void 0 : type.icon,
                iconColor: type == null ? void 0 : type.iconColor,
                typeName: type == null ? void 0 : type.typeName
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react230.Text, {
                fontStyle: "subtitleLabel",
                letterSpacing: "0.15px",
                className: "connected-task-and-event__task-name",
                mb: "0",
                children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react230.Link, {
                  onClick: () => handleEditTaskAura(),
                  children: taskName
                })
              })
            ]
          }),
          descriptionToDisplay && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react230.Text, {
            mt: { base: "8px", lg: "12px" },
            className: "connected-task-and-event__task-description",
            noOfLines: 1,
            mb: "0",
            children: descriptionToDisplay
          }),
          contractorUsers.length > 0 && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ResponsibleUnit_default, {
            data: contractorUsers,
            type: "user"
          }),
          companies.length > 0 && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ResponsibleUnit_default, {
            data: companies,
            type: "company"
          })
        ]
      }),
      isTask && isExecutable ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react230.Tooltip, {
        label: isTooltipActive ? t("EXECUTE") : "",
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react230.IconButton, {
          ref,
          boxSize: "40px",
          position: "absolute",
          right: "0",
          top: "50%",
          transform: "translateY(-50%)",
          backgroundColor: "crmBlue",
          color: "#ffffff",
          icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react231.default, {
            path: import_js41.mdiCalendarCheckOutline,
            size: "24px"
          }),
          onClick: () => {
            handleCompleteTaskAura();
            setTooltipActive(false);
          },
          "aria-label": "connected-task-and-event__button",
          className: "connected-task-and-event__button"
        })
      }) : null
    ]
  });
};
var ConnectedTaskAndEvent_default = ConnectedTaskAndEvent;

// src/components/CookieNotice/CookieNotice.tsx
var import_react232 = require("@chakra-ui/react");
var import_react_query31 = require("react-query");
var import_js42 = require("@mdi/js");
var import_react233 = __toESM(require("@mdi/react"));
var import_react234 = require("react");
var import_jsx_runtime = require("react/jsx-runtime");
var localStorageName = "AuraCookiesAccepted";
var CookieNotice = () => {
  var _a2, _b;
  const cookiesAccepted = localStorage.getItem(localStorageName);
  const [isOpen, setIsOpen] = (0, import_react234.useState)(false);
  const { data: cookieTemplateContent } = (0, import_react_query31.useQuery)(
    ["getCookieNoticeTemplate"],
    () => api_default.getTemplates({
      params: {
        fields: "name,value,type",
        "filter[type][eq]": 68,
        "page[limit]": 1
      }
    }),
    {
      enabled: Boolean(!cookiesAccepted),
      refetchOnWindowFocus: false
    }
  );
  const handleClose = () => {
    setIsOpen(false);
  };
  const handleAcceptCookies = () => {
    localStorage.setItem(localStorageName, "true");
    handleClose();
  };
  const notificationContent = (_b = (_a2 = cookieTemplateContent == null ? void 0 : cookieTemplateContent.data) == null ? void 0 : _a2[0]) == null ? void 0 : _b.value;
  (0, import_react234.useEffect)(() => {
    setIsOpen(notificationContent ? true : false);
  }, [notificationContent]);
  if (cookiesAccepted || !notificationContent) {
    return null;
  } else {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react232.Popover, {
      returnFocusOnClose: false,
      isOpen,
      placement: "right",
      closeOnBlur: false,
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react232.PopoverTrigger, {
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, {})
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react232.Portal, {
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react232.PopoverContent, {
            position: "fixed",
            bottom: "0",
            w: "full",
            className: "cookie-notice",
            children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(NotificationBar, {
              content: notificationContent,
              acceptOnClick: handleAcceptCookies,
              onClose: handleClose
            })
          })
        })
      ]
    });
  }
};
var buttonProps = {
  fontWeight: 600,
  fontSize: "15px",
  letterSpacing: "0.15px",
  lineHeight: "24px"
};
var NotificationBar = ({
  content,
  acceptOnClick,
  onClose
}) => {
  const { t } = useAuraTranslation_default();
  const showIcon = (0, import_react232.useBreakpointValue)({
    base: false,
    md: true
  });
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react232.Flex, {
    className: "cookie-notice__notification-bar",
    w: "100vw",
    py: "16px",
    px: "24px",
    backgroundColor: "gray.100",
    justifyContent: "center",
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react232.Flex, {
      maxW: { base: "full", lg: "1530px" },
      alignItems: "center",
      gap: "16px",
      direction: { base: "column", lg: "row" },
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react232.Stack, {
          spacing: "20px",
          isInline: true,
          children: [
            showIcon && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react233.default, {
              className: "cookie-notice__icon",
              path: import_js42.mdiAlertCircle,
              size: "24px",
              style: {
                minWidth: "24px",
                marginTop: "4px"
              }
            }),
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react232.Text, {
              className: "cookie-notice__content",
              fontSize: "18px",
              fontWeight: 400,
              lineHeight: "32px",
              letterSpacing: "0.15px",
              dangerouslySetInnerHTML: { __html: content },
              sx: { p: { mb: "0" } }
            })
          ]
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react232.Flex, {
          className: "cookie-notice__buttons",
          direction: { base: "column-reverse", md: "row" },
          alignSelf: { base: "end", lg: "center" },
          width: { base: "full", md: "initial" },
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react232.Button, {
              className: "cookie-notice__button-remember-later",
              onClick: () => {
                onClose();
              },
              variant: "ghost",
              ...buttonProps,
              children: t("COOKIE_NOTICE_REMEMBER_LATER")
            }),
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react232.Button, {
              className: "cookie-notice__button-accept",
              onClick: () => {
                acceptOnClick();
              },
              variant: "solid",
              backgroundColor: "blue.500",
              color: "white",
              ...buttonProps,
              children: t("COOKIE_NOTICE_ACCEPT")
            })
          ]
        })
      ]
    })
  });
};
var CookieNotice_default = CookieNotice;

// src/components/CountBadge/CountBadge.tsx
var import_react235 = require("@chakra-ui/react");
var import_jsx_runtime = require("react/jsx-runtime");
var CountBadge = ({ value, ...props }) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react235.Circle, {
    bg: "blue.500",
    minW: "18px",
    px: "2px",
    color: "#fff",
    bgColor: "crmBlue",
    display: "flex",
    alignItems: "center",
    className: "count-badge",
    "data-testid": "count-badge",
    ...props,
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react235.Text, {
      fontWeight: "600",
      fontSize: "xs",
      letterSpacing: "0.4px",
      lineHeight: "18px",
      children: value <= 99 ? value : `${99}+`
    })
  });
};
var CountBadge_default = CountBadge;

// src/components/CredentialsCompact/CredentialsCompact.tsx
var import_react236 = require("@chakra-ui/react");
var import_js43 = require("@mdi/js");
var import_react237 = __toESM(require("@mdi/react"));
var import_lib3 = require("@questy/lib");
var import_react238 = __toESM(require("react"));
var import_jsx_runtime = require("react/jsx-runtime");
var getCredentialToSet = (profiles, profileId, credential) => {
  var _a2;
  const isAccountUserProfile = ((_a2 = profiles.find((p) => p.id === profileId)) == null ? void 0 : _a2.userType) === 2 /* AccountUser */;
  return isAccountUserProfile && credential === import_lib3.FieldCredential.Edit ? import_lib3.FieldCredential.Show : credential;
};
var CredentialsCompact = ({
  credentials,
  isReadOnly,
  onCredentialChange,
  profiles = [],
  ...props
}) => {
  var _a2;
  const { t, tCustom } = useAuraTranslation_default();
  const [currentCredentials, setCurrentCredentials] = import_react238.default.useState(credentials);
  const [selectedProfiles, setSelectedProfiles] = import_react238.default.useState();
  const [selectedCredential, setSelectedCredential] = import_react238.default.useState(import_lib3.FieldCredential.Show);
  const handleCredentialChange = (credential, profileId) => {
    const credentialToSet = getCredentialToSet(profiles, profileId, credential);
    const newCredentials = currentCredentials.map((c) => {
      if (c.profile === profileId) {
        return {
          ...c,
          credential: credentialToSet
        };
      }
      return c;
    });
    setCurrentCredentials(newCredentials);
  };
  const handleAddCredentials = (profileId, credential) => {
    setCurrentCredentials((credentials2) => {
      const newCredentials = [...credentials2];
      profileId == null ? void 0 : profileId.forEach((profileId2) => {
        const credentialToSet = getCredentialToSet(
          profiles,
          profileId2,
          credential
        );
        const credentialIndex = newCredentials.findIndex(
          (credential2) => credential2.profile === profileId2
        );
        if (credentialIndex === -1) {
          newCredentials.push({
            profile: profileId2,
            credential: credentialToSet
          });
        } else {
          newCredentials[credentialIndex].credential = credentialToSet;
        }
      });
      return newCredentials;
    });
    setSelectedCredential(import_lib3.FieldCredential.Show);
  };
  const options = (0, import_react238.useMemo)(() => {
    let groupedOptions = [
      {
        label: t("CREDENTIAL_PROFILE_GROUP_USER_USER"),
        options: []
      },
      {
        label: t("CREDENTIAL_PROFILE_GROUP_ACCOUNT_USER"),
        options: []
      }
    ];
    profiles.forEach((profile) => {
      if (profile.userType === 2 /* AccountUser */) {
        groupedOptions[1].options.push({
          value: profile.id,
          label: tCustom(profile.profileName)
        });
      }
      if (profile.userType === 1 /* UserUser */) {
        groupedOptions[0].options.push({
          value: profile.id,
          label: tCustom(profile.profileName)
        });
      }
    });
    return groupedOptions;
  }, [profiles, t, tCustom]);
  const value = (0, import_react238.useMemo)(() => {
    if (!selectedProfiles) {
      return [];
    }
    const selectedUserUserOptions = options[0].options.filter(
      (option) => selectedProfiles.includes(option.value)
    );
    const selectedAccountUserOptions = options[1].options.filter(
      (option) => selectedProfiles.includes(option.value)
    );
    return [...selectedUserUserOptions, ...selectedAccountUserOptions];
  }, [options, selectedProfiles]);
  (0, import_react238.useEffect)(() => {
    onCredentialChange(currentCredentials);
  }, [currentCredentials, onCredentialChange]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react236.Box, {
    maxW: "576px",
    fontSize: "md",
    ...props,
    children: [
      isReadOnly ? null : /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react236.FormControl, {
        mb: 14,
        className: "credential-add-control",
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react236.FormLabel, {
            fontSize: "md",
            fontWeight: "medium",
            htmlFor: "credential-add-select",
            children: t("ADD_CREDENTIAL_LABEL")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react236.Wrap, {
            spacing: 4,
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react236.WrapItem, {
                w: { base: "full", md: "unset" },
                flex: 1,
                children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react236.Box, {
                  width: "full",
                  children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSelect_default, {
                    inputId: "credential-add-select",
                    className: "profile-selector",
                    isClearable: false,
                    isMulti: true,
                    options,
                    value,
                    onChange: (newValue) => {
                      setSelectedProfiles(
                        newValue.map((v) => v.value)
                      );
                    },
                    placeholder: t("CREDENTIAL_PROFILE"),
                    noOptionsMessage: () => t("NO_OPTIONS"),
                    menuPosition: "fixed"
                  })
                })
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react236.WrapItem, {
                w: { base: "full", md: "unset" },
                children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react236.Stack, {
                  isInline: true,
                  w: "full",
                  spacing: 4,
                  children: [
                    /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react236.Select, {
                      value: selectedCredential,
                      className: "credential-selector",
                      w: { base: "100%", md: "160px" },
                      maxW: { base: "full", md: "160px" },
                      onChange: (e) => {
                        setSelectedCredential(
                          Number(e.target.value)
                        );
                      },
                      children: [
                        /* @__PURE__ */ (0, import_jsx_runtime.jsx)("option", {
                          value: import_lib3.FieldCredential.Show,
                          children: t("CREDENTIAL_SHOW")
                        }),
                        /* @__PURE__ */ (0, import_jsx_runtime.jsx)("option", {
                          value: import_lib3.FieldCredential.Edit,
                          children: t("CREDENTIAL_EDIT")
                        })
                      ]
                    }),
                    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react236.IconButton, {
                      colorScheme: "blue",
                      "aria-label": t("ADD_CREDENTIAL"),
                      icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react237.default, {
                        size: 1,
                        path: import_js43.mdiPlus
                      }),
                      onClick: () => handleAddCredentials(selectedProfiles, selectedCredential)
                    })
                  ]
                })
              })
            ]
          })
        ]
      }),
      currentCredentials ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react236.Stack, {
        spacing: 4,
        className: "credential-list",
        children: (_a2 = currentCredentials == null ? void 0 : currentCredentials.filter((c) => c.credential !== import_lib3.FieldCredential.None)) == null ? void 0 : _a2.map((credential) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CredentialRow, {
          isReadOnly,
          profiles,
          credential,
          onCredentialChange: handleCredentialChange
        }, `${credential.profile}${credential.credential}`))
      }) : null
    ]
  });
};
var CredentialRow = ({
  profiles,
  credential,
  isReadOnly,
  onCredentialChange
}) => {
  var _a2;
  const { t, tCustom } = useAuraTranslation_default();
  if (!credential) {
    return null;
  }
  const profileName = (_a2 = profiles.find(
    (profile) => profile.id === credential.profile
  )) == null ? void 0 : _a2.profileName;
  const shouldShowEditCredential = (0, import_react238.useMemo)(
    () => profiles.find((profile) => profile.id === credential.profile).userType === 1 /* UserUser */,
    [credential.profile]
  );
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react236.FormControl, {
    className: "credential-row",
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react236.Stack, {
      isInline: true,
      spacing: 4,
      align: "center",
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react236.FormLabel, {
          flex: 1,
          fontWeight: 400,
          htmlFor: `credential-select-${credential.profile}`,
          children: tCustom(profileName)
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react236.Select, {
          disabled: isReadOnly,
          id: `credential-select-${credential.profile}`,
          className: "credential-selector",
          maxW: "160px",
          defaultValue: credential.credential,
          onChange: (e) => {
            const newCredential = Number(e.target.value);
            onCredentialChange(newCredential, credential.profile);
          },
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)("option", {
              value: import_lib3.FieldCredential.Show,
              children: t("CREDENTIAL_SHOW")
            }),
            shouldShowEditCredential ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)("option", {
              value: import_lib3.FieldCredential.Edit,
              children: t("CREDENTIAL_EDIT")
            }) : null
          ]
        }),
        isReadOnly ? null : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react236.IconButton, {
          color: "gray.700",
          "aria-label": t("REMOVE_CREDENTIAL"),
          icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react237.default, {
            size: 1,
            path: import_js43.mdiTrashCanOutline
          }),
          onClick: () => {
            onCredentialChange(import_lib3.FieldCredential.None, credential.profile);
          }
        })
      ]
    })
  });
};
var CredentialsCompact_default = CredentialsCompact;

// src/components/CustomCSSReset/CustomCSSReset.tsx
var import_react239 = require("@emotion/react");
var import_jsx_runtime = require("react/jsx-runtime");
var CSSReset = () => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react239.Global, {
  styles: `
    @layer chakra-reset {
      html {
        line-height: 1.5;
        -webkit-text-size-adjust: 100%;
        font-family: system-ui, sans-serif;
        -webkit-font-smoothing: antialiased;
        text-rendering: optimizeLegibility;
        -moz-osx-font-smoothing: grayscale;
        touch-action: manipulation;
      }
      
      body {
        position: relative;
        min-height: 100%;
        font-feature-settings: "kern";
        margin: 0;
      }
      
        *,
        *::before,
        *::after {
          border-width: 0;
          border-style: solid;
          box-sizing: border-box;
        }
        main {
          display: block;
        }
        hr {
          border-top-width: 1px;
          box-sizing: content-box;
          height: 0;
          overflow: visible;
        }
      
        pre,
        code,
        kbd,
        samp {
          font-family: SFMono-Regular, Menlo, Monaco, Consolas, monospace;
          font-size: 1em;
        }
      
        a {
          background-color: transparent;
          color: inherit;
          text-decoration: inherit;
        }
      
        abbr[title] {
          border-bottom: none;
          text-decoration: underline;
          -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
        }
      
        b,
        strong {
          font-weight: bold;
        }
      
        small {
          font-size: 80%;
        }
      
        sub,
        sup {
          font-size: 75%;
          line-height: 0;
          position: relative;
          vertical-align: baseline;
        }
      
        sub {
          bottom: -0.25em;
        }
      
        sup {
          top: -0.5em;
        }
      
        img {
          border-style: none;
        }
      
        button,
        input,
        optgroup,
        select,
        textarea {
          font-family: inherit;
          font-size: 100%;
          line-height: 1.15;
          margin: 0;
        }
      
        button,
        input {
          overflow: visible;
        }
      
        button,
        select {
          text-transform: none;
        }
      
        button::-moz-focus-inner,
        [type="button"]::-moz-focus-inner,
        [type="reset"]::-moz-focus-inner,
        [type="submit"]::-moz-focus-inner {
          border-style: none;
          padding: 0;
        }
      
        fieldset {
          padding: 0.35em 0.75em 0.625em;
        }
      
        legend {
          box-sizing: border-box;
          color: inherit;
          display: table;
          max-width: 100%;
          padding: 0;
          white-space: normal;
        }
      
        progress {
          vertical-align: baseline;
        }
      
        textarea {
          overflow: auto;
        }
      
        [type="checkbox"],
        [type="radio"] {
          box-sizing: border-box;
          padding: 0;
        }
      
        [type="number"]::-webkit-inner-spin-button,
        [type="number"]::-webkit-outer-spin-button {
          -webkit-appearance: none !important;
        }
      
        input[type="number"] {
          -moz-appearance: textfield;
        }
      
        [type="search"] {
          -webkit-appearance: textfield;
          outline-offset: -2px;
        }
      
        [type="search"]::-webkit-search-decoration {
          -webkit-appearance: none !important;
        }
      
        ::-webkit-file-upload-button {
          -webkit-appearance: button;
          font: inherit;
        }
      
        details {
          display: block;
        }
      
        summary {
          display: list-item;
        }
      
        template {
          display: none;
        }
      
        [hidden] {
          display: none !important;
        }
      
        blockquote,
        dl,
        dd,
        h1,
        h2,
        h3,
        h4,
        h5,
        h6,
        hr,
        figure,
        p,
        pre {
          margin: 0;
        }
      
        button {
          background: transparent;
          padding: 0;
        }
      
        fieldset {
          margin: 0;
          padding: 0;
        }
      
        ol,
        ul {
          margin: 0;
          padding: 0;
        }
      
        textarea {
          resize: vertical;
        }
      
        button,
        [role="button"] {
          cursor: pointer;
        }
      
        button::-moz-focus-inner {
          border: 0 !important;
        }
      
        table {
          border-collapse: collapse;
        }
      
        h1,
        h2,
        h3,
        h4,
        h5,
        h6 {
          font-size: inherit;
          font-weight: inherit;
        }
      
        button,
        input,
        optgroup,
        select,
        textarea {
          padding: 0;
          line-height: inherit;
          color: inherit;
        }
      
        img,
        svg,
        video,
        canvas,
        audio,
        iframe,
        embed,
        object {
          display: block;
        }
      
        img,
        video {
          max-width: 100%;
          height: auto;
        }
      
        [data-js-focus-visible] :focus:not([data-focus-visible-added]) {
          outline: none;
          box-shadow: none;
        }
      
        select::-ms-expand {
          display: none;
        }
    }
    `
});
var CustomCSSReset_default = CSSReset;

// src/hooks/useCustomScript.ts
var import_lib4 = require("@questy/lib");
var import_react240 = require("react");
var import_test_utils = __toESM(require("react-dom/test-utils"));
var { waitElement, waitDisappearElement } = require("@questy/wait-element");
var triggerChangeWithBlur = (element, eventData) => {
  import_test_utils.default.Simulate.change(element, eventData);
  import_test_utils.default.Simulate.blur(element);
};
var isomorphicUseLayoutEffect = typeof window !== "undefined" ? import_react240.useLayoutEffect : import_react240.useEffect;
var useCustomScript = () => {
  var _a2;
  const appContext = (0, import_react240.useContext)(CustomizerContext);
  const credentials = (0, import_lib4.useCredentials)();
  const auth = (0, import_react240.useContext)(AuthContext);
  const { t, tCustom } = useAuraTranslation_default();
  const newContext = { [appContext == null ? void 0 : appContext.moduleName]: { ...appContext } };
  let gruppedContext = { ...newContext };
  if (typeof window !== "undefined" && ((_a2 = window.auraCustom) == null ? void 0 : _a2.appContext)) {
    gruppedContext = {
      ...window.auraCustom.appContext,
      ...newContext
    };
  }
  const auraCustom = (0, import_react240.useMemo)(
    () => ({
      appContext: gruppedContext,
      auth,
      credentials,
      waitElement,
      waitDisappearElement,
      trigger: {
        ...import_test_utils.default.Simulate,
        change: triggerChangeWithBlur
      },
      translate: t,
      translateCustom: tCustom
    }),
    [gruppedContext, auth, credentials]
  );
  if (typeof window !== "undefined") {
    window.auraCustom = auraCustom;
  }
  isomorphicUseLayoutEffect(() => {
    if (!window.customScript)
      return;
    if (!window.customScriptDone) {
      window.customScript();
      window.customScriptDone = true;
    }
    return () => {
      window.customScriptDone = false;
    };
  }, []);
  isomorphicUseLayoutEffect(() => {
    if (!window.customComponent)
      return;
    if (!window.customComponentDone) {
      window.customComponent(window.customComponentData);
      window.customComponentDone = true;
    }
    return () => {
      window.customComponentDone = false;
    };
  }, []);
};
var useCustomScript_default = useCustomScript;

// src/components/CustomizerInit/CustomizerInit.tsx
var CustomizerInit = () => {
  useCustomScript_default();
  return null;
};
var CustomizerInit_default = CustomizerInit;

// src/components/CustomSelectOption/CustomSelectOption.tsx
var import_react241 = require("@chakra-ui/react");
var import_react_select10 = require("react-select");
var import_jsx_runtime = require("react/jsx-runtime");
var CustomSelectOption = (props) => {
  const { data } = props;
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_select10.components.Option, {
    ...props,
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react241.Flex, {
      role: "group",
      direction: "row",
      align: "center",
      w: "100%",
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react241.Flex, {
        borderStyle: "solid",
        borderColor: "gray.200",
        width: "100%",
        justify: "flex-start",
        align: "center",
        flexWrap: "nowrap",
        children: [
          (data == null ? void 0 : data.withAvatar) && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(QAvatar_default, {
            size: "sm",
            showBorder: false,
            name: data.label,
            title: data.label,
            src: getImageUrl(data == null ? void 0 : data.avatar, "thmb") ?? void 0
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react241.Flex, {
            m: 1,
            mx: 3,
            wrap: "wrap",
            direction: "column",
            flex: "1 1 auto",
            overflow: "hidden",
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react241.Text, {
                as: "span",
                ...data.isDeleted && {
                  textDecoration: "line-through",
                  color: "gray.500"
                },
                children: data.label
              }),
              data.additionalName && data.additionalName.trim().length > 0 && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react241.Text, {
                w: "full",
                isTruncated: true,
                color: "gray.400",
                whiteSpace: "nowrap",
                fontSize: 12,
                as: "span",
                title: data.additionalName,
                children: data.additionalName
              })
            ]
          })
        ]
      })
    })
  });
};
var CustomSelectOption_default = CustomSelectOption;

// src/components/DataSelector/DataSelector.tsx
var import_react242 = require("react");
var import_react_select11 = __toESM(require("react-select"));
var import_jsx_runtime = require("react/jsx-runtime");
var DataSelector = (0, import_react242.forwardRef)(
  ({
    endpoint,
    labelField,
    valueField,
    fields,
    extraFields,
    options,
    params = {},
    additionalOptionField,
    getFilter,
    value,
    ...props
  }, ref) => {
    const { t } = useAuraTranslation_default();
    const [inputValue, setInputValue] = (0, import_react242.useState)("");
    const { data, isLoading } = useMinimalAutoselect_default({
      endpoint,
      labelField,
      valueField,
      fields,
      extraFields,
      filters: getFilter ? getFilter(inputValue) : { [`filter[${labelField}][hasText]`]: inputValue },
      settings: {
        "page[limit]": 10,
        ...params
      },
      enabled: (inputValue == null ? void 0 : inputValue.length) > 0,
      additionalOptionField
    });
    const parsedOptions = (0, import_react242.useMemo)(
      () => buildOptions(data, "value"),
      [data]
    );
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_select11.default, {
      value: value ?? [],
      ref,
      inputValue,
      options: options ?? parsedOptions,
      ...!options && {
        filterOption: () => true
      },
      isLoading,
      noOptionsMessage: (elem) => (elem == null ? void 0 : elem.inputValue) === "" ? t("BEGIN_WRITING_TO_SEARCH") : t("NOTHING_FOUND"),
      loadingMessage: () => t("LOADING"),
      className: "data-selector",
      styles: {
        control: (provided, state) => ({
          ...provided,
          boxShadow: state.isFocused ? "none" : provided.boxShadow,
          borderColor: "gray.200"
        })
      },
      ...props,
      onInputChange: (newValue, action) => {
        setInputValue(newValue);
        if (typeof (props == null ? void 0 : props.onInputChange) === "function") {
          props == null ? void 0 : props.onInputChange(newValue, action);
        }
      }
    });
  }
);
DataSelector.displayName = "DataSelector";
var DataSelector_default = DataSelector;

// src/components/DataSelectorFilter/DataSelectorFilter.tsx
var import_react243 = require("@chakra-ui/react");
var import_react244 = require("react");
var import_react_query32 = require("react-query");
var import_jsx_runtime = require("react/jsx-runtime");
var useSelectedOptionsFetcher = ({
  endpoint,
  value,
  additionalParams,
  labelKey
}) => {
  const { t } = useAuraTranslation_default();
  return (0, import_react_query32.useQuery)(
    [endpoint, value, additionalParams, labelKey],
    () => api_default.getAutoselect(endpoint, {
      params: {
        "filter[id][in]": value,
        fields: labelKey,
        "page[limit]": -1,
        ...additionalParams
      }
    }),
    {
      select: (response) => {
        var _a2;
        const dataToReturn = ((_a2 = response == null ? void 0 : response.data) == null ? void 0 : _a2.map((obj) => ({
          label: t(obj[labelKey]),
          value: obj.id,
          ...(obj == null ? void 0 : obj.isDeleted) && { isDeleted: obj == null ? void 0 : obj.isDeleted }
        }))) ?? [];
        return (value == null ? void 0 : value.length) > 0 ? dataToReturn : [];
      },
      enabled: (value == null ? void 0 : value.length) > 0 && !!labelKey,
      retry: false,
      refetchOnWindowFocus: false
    }
  );
};
var DataSelectorFilter = ({
  filterName,
  name,
  onChange,
  value,
  selectProps,
  loadDataProps: loadDataProps2,
  ...props
}) => {
  const [isInitialFetching, setIsInitialFetching] = (0, import_react244.useState)(!!value);
  const [tempValue, setTempValue] = (0, import_react244.useState)([]);
  const handleSetValue = (value2) => {
    let parsedValue = [];
    if (Array.isArray(value2)) {
      parsedValue = value2;
    } else {
      parsedValue = value2 ? [value2] : [];
    }
    setTempValue(parsedValue);
    const filterValue = (parsedValue == null ? void 0 : parsedValue.map((v) => v.value)) ?? [];
    onChange == null ? void 0 : onChange(filterName, filterValue);
  };
  const validAdditionalParams = (0, import_react244.useMemo)(
    () => {
      var _a2, _b;
      return (_b = (_a2 = Object.keys(loadDataProps2.settings)) == null ? void 0 : _a2.filter((key) => key !== "order[_q]")) == null ? void 0 : _b.reduce((obj, key) => {
        obj[key] = loadDataProps2.settings[key];
        return obj;
      }, {});
    },
    [loadDataProps2]
  );
  const { data: selectedOptions, isFetching } = useSelectedOptionsFetcher({
    endpoint: loadDataProps2.endpoint,
    value,
    additionalParams: validAdditionalParams,
    labelKey: loadDataProps2.labelField
  });
  if (isInitialFetching && isFetching && !selectedOptions) {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraFormLabel_default, {
          htmlFor: `input-${filterName}`,
          children: name
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSelect_default, {
          isLoading: true,
          isReadOnly: true
        })
      ]
    });
  }
  if (isInitialFetching) {
    setIsInitialFetching(false);
  }
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react243.FormControl, {
    ...props,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraFormLabel_default, {
        htmlFor: `input-${filterName}`,
        children: name
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSelect_default, {
        value: isFetching ? tempValue : selectedOptions ?? [],
        onChange: (value2) => handleSetValue(value2),
        isMulti: true,
        loadDataProps: loadDataProps2,
        isLoading: isFetching,
        ...selectProps ? selectProps : {}
      })
    ]
  });
};
var DataSelectorFilter_default = DataSelectorFilter;

// src/components/DateInput/DateInput.tsx
var import_react245 = require("@chakra-ui/react");
var import_js44 = require("@mdi/js");
var import_react246 = __toESM(require("@mdi/react"));
var import_react247 = __toESM(require("react"));
var import_jsx_runtime = require("react/jsx-runtime");
var getDefaultDateFormat2 = (withTime) => {
  return withTime ? DATETIME_FORMAT_DOTS : DATE_FORMAT_DOTS;
};
var DateInput = ({
  id,
  value,
  lang = "pl",
  onChange,
  withTime,
  timeIntervals,
  minDate,
  maxDate,
  onBlur,
  onSelect,
  isClearable = true,
  isDisabled = false,
  dateFormat,
  onCalendarClose,
  onCalendarOpen,
  leftIconPlaceholder,
  ...props
}) => {
  const { currentLocale } = (0, import_react247.useContext)(LanguageContext);
  const { t } = useAuraTranslation_default();
  const dateFormatCurrent = dateFormat ?? getDefaultDateFormat2(withTime);
  const clearValue = () => {
    onChange == null ? void 0 : onChange(null, null);
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraDatePicker_default, {
    popperPlacement: "bottom",
    popperModifiers: [
      {
        name: "preventOverflow",
        options: {
          rootBoundary: "viewport",
          tether: true,
          padding: { right: withTime ? 85 : 0 }
        }
      },
      {
        name: "flip",
        options: {
          fallbackPlacements: ["bottom"],
          allowedAutoPlacements: ["bottom"]
        }
      }
    ],
    minDate,
    maxDate,
    timeIntervals,
    todayButton: t("TODAY"),
    locale: currentLocale,
    showTimeSelect: withTime,
    showYearDropdown: true,
    id,
    dateFormat: dateFormatCurrent,
    timeCaption: t("TIME"),
    onChange,
    onCalendarClose,
    onCalendarOpen,
    onBlur,
    onSelect,
    readOnly: isDisabled,
    ...(value == null ? void 0 : value.toString()) === "today" ? { value: t("TODAY") } : { selected: value },
    customInput: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CustomInput2, {
      loadingLabel: t("LOADING"),
      isClearable: isDisabled ? false : isClearable && !!value,
      clearValue,
      leftIconPlaceholder,
      isDisabled,
      ...props
    })
  });
};
var CustomInput2 = import_react247.default.forwardRef(
  ({
    isDisabled,
    isLoading,
    isClearable,
    loadingLabel,
    size = "md",
    clearValue,
    leftIconPlaceholder,
    ...props
  }, ref) => {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react245.InputGroup, {
      position: "relative",
      zIndex: 0,
      size,
      _hover: {
        ".clear-button": {
          visibility: "visible"
        }
      },
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react245.InputLeftElement, {
          pointerEvents: "none",
          zIndex: 2,
          color: "gray.300",
          children: leftIconPlaceholder ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react245.Text, {
            textStyle: "bodyInput",
            color: "gray.300",
            mb: "0",
            children: leftIconPlaceholder
          }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react246.default, {
            path: import_js44.mdiCalendarBlankOutline,
            size: "24px",
            style: { color: "gray.300" }
          })
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraInput_default, {
          isDisabled,
          isReadOnly: isDisabled,
          type: "text",
          ref,
          pl: "40px",
          autoComplete: "off",
          ...props
        }),
        isClearable && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react245.InputRightElement, {
          className: "clear-button",
          visibility: "hidden",
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react245.IconButton, {
            size: "xs",
            variant: "ghost",
            "aria-label": "clear",
            icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react246.default, {
              path: import_js44.mdiClose,
              size: "16px"
            }),
            onClick: clearValue,
            color: "gray.700",
            "data-testid": "clear-button"
          })
        }),
        isLoading && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react245.InputRightElement, {
          title: loadingLabel,
          pointerEvents: "none",
          zIndex: 2,
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react245.IconButton, {
            "aria-label": "loading",
            as: "div",
            variant: "ghost",
            isLoading: true
          })
        })
      ]
    });
  }
);
CustomInput2.displayName = "CustomInput";
var DateInput_default = DateInput;

// src/components/ModalMassDiscount/ModalMassDiscount.tsx
var import_react248 = require("@chakra-ui/react");
var import_react249 = require("react");
var import_react_hook_form18 = require("react-hook-form");
var import_jsx_runtime = require("react/jsx-runtime");
var ModalMassDiscountContent = ({
  onClose,
  onConfirm,
  name,
  decimalPlaces = 2
}) => {
  var _a2;
  const [isLoading, setIsLoading] = (0, import_react249.useState)(false);
  const { t } = useAuraTranslation_default();
  const { control, handleSubmit, reset, formState } = (0, import_react_hook_form18.useForm)({
    defaultValues: { discount: "" }
  });
  const errors = formState.errors;
  const handleClose = () => {
    reset();
    onClose();
  };
  const onSubmit = async (data) => {
    setIsLoading(true);
    try {
      await onConfirm(auraParseFloat(data.discount));
    } finally {
      setIsLoading(false);
      handleClose();
    }
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(AuraModalContent, {
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalHeader, {
        children: t("APPLY_MASS_DISCOUNT")
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalBody, {
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react248.FormControl, {
          isInvalid: !!errors.discount,
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(AuraFormLabel_default, {
              htmlFor: "discount-modal__discount",
              children: [
                t(name),
                " (%)"
              ]
            }),
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form18.Controller, {
              name: "discount",
              control,
              rules: {
                required: t("FIELD_IS_REQUIRED"),
                validate: (value) => {
                  const num = auraParseFloat(value);
                  if (num < 0 || num > 100)
                    return t(
                      "Discount percent value must be a number between 0 and 100"
                    );
                  return true;
                }
              },
              render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraInput_default, {
                id: "discount-modal__discount",
                ...field,
                onChange: (e) => {
                  e.target.value = sanitizeDecimalInput({
                    value: e.target.value
                  });
                  field.onChange(e);
                },
                onBlur: (e) => {
                  const num = auraParseFloat(e.target.value);
                  field.onChange(
                    auraParseDisplayValue(num.toFixed(decimalPlaces))
                  );
                }
              })
            }),
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react248.FormErrorMessage, {
              children: (_a2 = errors.discount) == null ? void 0 : _a2.message
            })
          ]
        })
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalFooter, {
        showBorders: false,
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react248.Button, {
          colorScheme: "blue",
          onClick: handleSubmit(onSubmit),
          isLoading,
          children: t("Confirm")
        })
      })
    ]
  });
};
var ModalMassDiscount = ({
  useDisclosure: useDisclosure19,
  onConfirm,
  name = "DISCOUNT",
  decimalPlaces = 2
}) => {
  const { isOpen, onClose } = useDisclosure19;
  if (!isOpen) {
    return null;
  }
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(AuraModal, {
    isOpen,
    onClose,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalOverlay, {}),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ModalMassDiscountContent, {
        onClose,
        onConfirm,
        name,
        decimalPlaces
      })
    ]
  });
};
var ModalMassDiscount_default = ModalMassDiscount;

// src/components/DocumentSummary/DocumentSummary.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var DocumentSummary = ({
  data = {},
  ...props
}) => {
  const { t } = useAuraTranslation_default();
  const preparedValuesTable = Object.entries(data).map(
    ([currency, values], index) => {
      const { valueNetto, valueVat, valueBrutto, paymentPayed } = values;
      const displayValues = [
        { isVisible: isProperty("valueNetto", data), value: valueNetto },
        { isVisible: isProperty("valueVat", data), value: valueVat },
        { isVisible: isProperty("valueBrutto", data), value: valueBrutto },
        { isVisible: isProperty("paymentPayed", data), value: paymentPayed }
      ];
      return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Tr, {
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Td, {
            children: currency
          }),
          displayValues.map(
            ({ isVisible, value }, index2) => isVisible && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Td, {
              isNumeric: true,
              children: value && formatValue(value)
            }, index2)
          )
        ]
      }, index);
    }
  );
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TableContainer, {
    display: "inline-block",
    ...props,
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Table, {
      width: "auto",
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Thead, {
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Tr, {
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Th, {}),
              isProperty("valueNetto", data) && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Th, {
                isNumeric: true,
                children: t("NET_TOTAL")
              }),
              isProperty("valueVat", data) && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Th, {
                isNumeric: true,
                children: t("VAT_AMOUNT")
              }),
              isProperty("valueBrutto", data) && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Th, {
                isNumeric: true,
                children: t("GROSS_SUM")
              }),
              isProperty("paymentPayed", data) && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Th, {
                isNumeric: true,
                children: t("Payment payed")
              })
            ]
          })
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Tbody, {
          children: preparedValuesTable == null ? void 0 : preparedValuesTable.map((currency) => currency)
        })
      ]
    })
  });
};
var isProperty = (key, data) => Object.values(data).some((currency) => currency.hasOwnProperty(key));
var formatValue = (number) => {
  return new Intl.NumberFormat("pl-PL", {
    style: "decimal",
    minimumFractionDigits: 2
  }).format(Number(number));
};
var DocumentSummary_default = DocumentSummary;

// src/components/DocumentPositionTile/DocumentPositionTile.tsx
var import_react252 = require("@chakra-ui/react");
var import_js45 = require("@mdi/js");
var import_react253 = __toESM(require("@mdi/react"));
var import_react254 = require("react");
var import_react_hook_form19 = require("react-hook-form");

// src/components/NameDisplay/NameDisplay.tsx
var import_react250 = require("@chakra-ui/react");
var import_react251 = require("react");
var import_jsx_runtime = require("react/jsx-runtime");
var NameDisplay = ({
  id,
  name,
  code,
  displayTooltip = false,
  headingProps,
  ...props
}) => {
  const headingRef = (0, import_react251.useRef)();
  const [showTooltip, setShowTooltip] = (0, import_react251.useState)(false);
  (0, import_react251.useEffect)(() => {
    var _a2, _b;
    if (!displayTooltip)
      return;
    let tooltipTimeoutId;
    const widthHeading = headingRef == null ? void 0 : headingRef.current.offsetWidth;
    const widthContainer = (_b = (_a2 = headingRef == null ? void 0 : headingRef.current) == null ? void 0 : _a2.parentNode) == null ? void 0 : _b.offsetWidth;
    if (widthHeading === widthContainer) {
      tooltipTimeoutId = setTimeout(() => setShowTooltip(true), 500);
    }
    return () => {
      if (tooltipTimeoutId) {
        clearTimeout(tooltipTimeoutId);
      }
    };
  }, [headingRef, displayTooltip]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react250.Box, {
    ...props,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react250.Tooltip, {
        ref: headingRef,
        label: name,
        isOpen: displayTooltip && showTooltip,
        openDelay: 500,
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react250.Heading, {
          className: "product-item-heading-name",
          id: `product-heading-${id}`,
          ref: headingRef,
          display: "inline-block",
          size: "md",
          fontWeight: "normal",
          noOfLines: 1,
          width: "fit-content",
          zIndex: 5,
          isTruncated: true,
          maxW: "full",
          overflow: "hidden",
          whiteSpace: "pre-line",
          wordBreak: "break-all",
          textAlign: "left",
          ...headingProps,
          children: name
        })
      }),
      code && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react250.Text, {
        className: "product-item-code",
        mt: "8px",
        fontSize: "sm",
        color: "gray.400",
        textAlign: "left",
        children: code
      })
    ]
  });
};
var NameDisplay_default = NameDisplay;

// src/components/DocumentPositionTile/DocumentPositionTile.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var DocumentPositionTile = ({
  rowId,
  positionType = 1 /* product */,
  product,
  quantity,
  currencyCode = "PLN",
  checkboxField,
  attributes,
  metaAttributes,
  formMethods,
  metaFields
}) => {
  const isSm = (0, import_react252.useBreakpointValue)({
    base: true,
    md: false
  });
  const [isExpanded, setIsExpanded] = (0, import_react254.useState)(false);
  const productUrl = `/product/show/productid/${product.id}`;
  const measureUnitName = product.measureUnit;
  const preparedPositionAttributes = preparePositionAttributesWithValues(
    metaAttributes,
    attributes,
    true
  );
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react252.Stack, {
    w: "full",
    className: "document-position-tile",
    p: "16px",
    borderBottom: 1,
    borderStyle: "solid",
    borderBottomColor: "gray.100",
    ...[
      2 /* separatorHeader */,
      3 /* separatorSummary */
    ].includes(positionType) && { bgColor: "gray.200" },
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react252.HStack, {
        spacing: "16px",
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react252.Flex, {
            alignItems: "center",
            whiteSpace: "nowrap",
            children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react252.Box, {
              textStyle: "bodyInput",
              w: "full",
              children: checkboxField && checkboxField.render("Cell")
            })
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react252.Stack, {
            className: "document-position-tile__properties",
            spacing: "16px",
            flex: 1,
            alignItems: "center",
            children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react252.Stack, {
              flex: 1,
              w: "full",
              children: [
                [
                  1 /* product */,
                  4 /* delivery */
                ].includes(positionType) ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react252.Link, {
                  className: "document-position-tile__properties__product",
                  href: productUrl,
                  children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(NameDisplay_default, {
                    id: product.id,
                    name: product.name,
                    code: product.code,
                    headingProps: { size: "sm" }
                  })
                }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(NameDisplay_default, {
                  id: product.id,
                  name: product.name,
                  code: null,
                  headingProps: { size: "sm" }
                }),
                [
                  1 /* product */,
                  4 /* delivery */
                ].includes(positionType) && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react252.Text, {
                  className: "document-position-tile__properties__measure-unit",
                  color: "gray.400",
                  fontSize: "sm",
                  children: measureUnitName
                })
              ]
            })
          }),
          !isSm && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(PricesTable, {
            rowId,
            quantity,
            positionType,
            currencyCode,
            control: formMethods.control,
            metaFields
          }),
          (attributes == null ? void 0 : attributes.length) > 0 && positionType === 1 /* product */ && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react252.IconButton, {
            className: "document-position-tile__attributes-dropdown",
            "aria-label": "document-position-tile__attributes-dropdown",
            size: "md",
            variant: "ghost",
            onClick: () => setIsExpanded(!isExpanded),
            icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react253.default, {
              path: isExpanded ? import_js45.mdiChevronUp : import_js45.mdiChevronDown,
              size: "20px"
            })
          })
        ]
      }),
      isSm && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(PricesTable, {
        rowId,
        quantity,
        positionType,
        currencyCode,
        control: formMethods.control,
        metaFields
      }),
      (attributes == null ? void 0 : attributes.length) > 0 && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react252.Box, {
        w: "full",
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react252.Collapse, {
          in: isExpanded,
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react252.Stack, {
            className: "document-position-tile__attributes",
            w: "full",
            spacing: "8px",
            mt: "24px",
            children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Attributes_default, {
              attributes: preparedPositionAttributes,
              toForm: true,
              attributeNamePrefix: `position.${rowId}.`,
              formMethods
            })
          })
        })
      })
    ]
  });
};
var PricesTable = ({
  rowId,
  quantity,
  positionType,
  currencyCode,
  control,
  metaFields
}) => {
  var _a2, _b, _c, _d, _e, _f;
  const { t } = useAuraTranslation_default();
  const tableWidth = {
    sm: "full",
    md: ((_a2 = metaFields == null ? void 0 : metaFields.priceRabat) == null ? void 0 : _a2.credential) || ((_b = metaFields == null ? void 0 : metaFields.priceBruttoAfterDiscounts) == null ? void 0 : _b.credential) ? "330px" : "275px"
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react252.HStack, {
    className: "document-position-tile__prices",
    children: [
      1 /* product */,
      3 /* separatorSummary */,
      4 /* delivery */
    ].includes(positionType) && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TableContainer, {
      wrapperProps: { w: tableWidth },
      mx: "-8px",
      maxW: "none",
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Table, {
        size: "sm",
        bgColor: "white",
        children: [
          [
            1 /* product */,
            4 /* delivery */
          ].includes(positionType) && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Tr, {
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Th, {
                h: "auto",
                background: "gray.100",
                fontWeight: 500,
                children: t("LIST_COLUMN_quantity")
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Td, {
                h: "auto",
                textAlign: "right",
                children: quantity
              })
            ]
          }),
          [
            1 /* product */,
            4 /* delivery */
          ].includes(positionType) && ((_c = metaFields == null ? void 0 : metaFields.priceRabat) == null ? void 0 : _c.credential) && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(PriceRow, {
            rowId,
            label: "PRICE_NETTO_AFTER_DISCOUNTS",
            currencyCode,
            control,
            columnName: "priceRabat"
          }),
          [
            1 /* product */,
            4 /* delivery */
          ].includes(positionType) && ((_d = metaFields == null ? void 0 : metaFields.priceRabatBrutto) == null ? void 0 : _d.credential) && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(PriceRow, {
            rowId,
            label: "PRICE_BRUTTO_AFTER_DISCOUNTS",
            currencyCode,
            control,
            columnName: "priceRabatBrutto"
          }),
          ((_e = metaFields == null ? void 0 : metaFields.valueNettoAfterDiscounts) == null ? void 0 : _e.credential) && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(PriceRow, {
            rowId,
            label: "LIST_COLUMN_valueNetto",
            currencyCode,
            control,
            columnName: "valueNettoAfterDiscounts"
          }),
          ((_f = metaFields == null ? void 0 : metaFields.valueBruttoAfterDiscounts) == null ? void 0 : _f.credential) && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(PriceRow, {
            rowId,
            label: "LIST_COLUMN_valueBrutto",
            currencyCode,
            control,
            columnName: "valueBruttoAfterDiscounts"
          })
        ]
      })
    })
  });
};
var PriceRow = ({
  rowId,
  label,
  currencyCode,
  control,
  columnName
}) => {
  const { t } = useAuraTranslation_default();
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Tr, {
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Th, {
        h: "auto",
        background: "gray.100",
        fontWeight: 500,
        whiteSpace: "initial",
        children: t(label)
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Td, {
        h: "auto",
        textAlign: "right",
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form19.Controller, {
          name: `position.${rowId}.${columnName}`,
          control,
          render: ({ field }) => {
            return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react252.Box, {
              textAlign: "right",
              children: priceFormatter(
                auraParseFloat(field.value),
                currencyCode,
                {},
                2
              )
            });
          }
        })
      })
    ]
  });
};
var DocumentPositionTile_default = DocumentPositionTile;

// src/components/DocumentPositionTile/utils.ts
var import_partition2 = __toESM(require("lodash/partition"));
var prepareDocumentPositionTile = (row) => {
  var _a2, _b, _c, _d;
  const positionType = row.original.positionType ?? 1 /* product */;
  const product = {
    id: (_a2 = row.values.product) == null ? void 0 : _a2.id,
    name: row.original.productName ?? ((_b = row.values.product) == null ? void 0 : _b.name),
    code: row.values.productCode,
    measureUnit: row.original.measureUnitName ?? ((_d = (_c = row.original) == null ? void 0 : _c.measureUnit) == null ? void 0 : _d.shortName)
  };
  const [attributes, fields] = (0, import_partition2.default)(
    row.cells,
    (cell) => cell.column.fieldType === "attribute"
  );
  const checkboxField = fields[0];
  return { product, positionType, attributes, fields, checkboxField };
};

// src/components/DocumentSummaryVerticalTable/DocumentSummaryVerticalTable.tsx
var import_react255 = require("@chakra-ui/react");
var import_react_hook_form20 = require("react-hook-form");
var import_jsx_runtime = require("react/jsx-runtime");
var DocumentSummaryVerticalTable = ({
  control,
  value,
  currencyCode = "PLN",
  withDeliveryCost
}) => {
  const { t } = useAuraTranslation_default();
  const tableWidth = {
    base: "full",
    md: "330px"
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react255.HStack, {
    className: "document-positions-summary",
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TableContainer, {
      wrapperProps: { w: tableWidth },
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Table, {
        size: "sm",
        bgColor: "white",
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Tr, {
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Th, {
                h: "auto",
                background: "gray.100",
                fontWeight: 500,
                children: t("NET_TOTAL")
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Td, {
                h: "auto",
                textAlign: "right",
                isNumeric: true,
                children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form20.Controller, {
                  name: "valueNetto",
                  control,
                  defaultValue: value == null ? void 0 : value.valueNetto,
                  render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, {
                    children: priceFormatter(
                      auraParseFloat(field.value),
                      currencyCode,
                      {},
                      2
                    )
                  })
                })
              })
            ]
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Tr, {
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Th, {
                h: "auto",
                background: "gray.100",
                fontWeight: 500,
                children: t("VAT_AMOUNT")
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Td, {
                h: "auto",
                textAlign: "right",
                isNumeric: true,
                children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form20.Controller, {
                  name: "valueVat",
                  control,
                  defaultValue: (value == null ? void 0 : value.valueBrutto) - (value == null ? void 0 : value.valueNetto),
                  render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, {
                    children: priceFormatter(
                      auraParseFloat(field.value),
                      currencyCode,
                      {},
                      2
                    )
                  })
                })
              })
            ]
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Tr, {
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Th, {
                h: "auto",
                background: "gray.100",
                fontWeight: 500,
                children: t("GROSS_SUM")
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Td, {
                h: "auto",
                isNumeric: true,
                children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form20.Controller, {
                  name: "valueBrutto",
                  control,
                  defaultValue: value == null ? void 0 : value.valueBrutto,
                  render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, {
                    children: priceFormatter(
                      auraParseFloat(field.value),
                      currencyCode,
                      {},
                      2
                    )
                  })
                })
              })
            ]
          }),
          withDeliveryCost && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Tr, {
                children: [
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Th, {
                    h: "auto",
                    background: "gray.100",
                    fontWeight: 500,
                    children: t("NET_TOTAL_WITH_DELIVERY")
                  }),
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Td, {
                    h: "auto",
                    isNumeric: true,
                    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form20.Controller, {
                      name: "valueNettoWithDelivery",
                      control,
                      defaultValue: value == null ? void 0 : value.valueNetto,
                      render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, {
                        children: priceFormatter(
                          auraParseFloat(field.value),
                          currencyCode,
                          {},
                          2
                        )
                      })
                    })
                  })
                ]
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Tr, {
                children: [
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Th, {
                    h: "auto",
                    background: "gray.100",
                    fontWeight: 500,
                    children: t("VAT_AMOUNT_WITH_DELIVERY")
                  }),
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Td, {
                    h: "auto",
                    isNumeric: true,
                    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form20.Controller, {
                      name: "valueVatWithDelivery",
                      control,
                      defaultValue: (value == null ? void 0 : value.valueBrutto) - (value == null ? void 0 : value.valueNetto),
                      render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, {
                        children: priceFormatter(
                          auraParseFloat(field.value),
                          currencyCode,
                          {},
                          2
                        )
                      })
                    })
                  })
                ]
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Tr, {
                children: [
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Th, {
                    h: "auto",
                    background: "gray.100",
                    fontWeight: 500,
                    children: t("GROSS_SUM_WITH_DELIVERY")
                  }),
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Td, {
                    h: "auto",
                    isNumeric: true,
                    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form20.Controller, {
                      name: "valueBruttoWithDelivery",
                      control,
                      defaultValue: value == null ? void 0 : value.valueBrutto,
                      render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, {
                        children: priceFormatter(
                          auraParseFloat(field.value),
                          currencyCode,
                          {},
                          2
                        )
                      })
                    })
                  })
                ]
              })
            ]
          })
        ]
      })
    })
  });
};
var DocumentSummaryVerticalTable_default = DocumentSummaryVerticalTable;

// src/components/EmptyState/EmptyState.tsx
var import_react256 = require("@chakra-ui/react");
var import_js46 = require("@mdi/js");
var import_react257 = __toESM(require("@mdi/react"));
var import_jsx_runtime = require("react/jsx-runtime");
var EmptyState = ({
  label,
  isInline,
  mdiIcon,
  ...props
}) => {
  const { t } = useAuraTranslation_default();
  const styleProps = isInline ? { spacing: "16px", isInline } : { spacing: "8px" };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react256.Stack, {
    className: "empty-state",
    alignItems: "center",
    w: "full",
    color: "gray.300",
    ...styleProps,
    ...props,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react257.default, {
        className: "empty-state__icon",
        size: "40px",
        path: mdiIcon ?? import_js46.mdiTextBoxSearchOutline
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react256.Text, {
        className: "empty-state__label",
        color: "gray.400",
        fontSize: "15px",
        lineHeight: "24px",
        letterSpacing: "0.5px",
        children: label ? t(label) : t("LIST_EMPTY_HEADING")
      })
    ]
  });
};
var EmptyState_default = EmptyState;

// src/components/ExternalMarker/ExternalMarkerContainer.tsx
var import_react259 = require("@chakra-ui/react");

// src/components/ExternalMarker/ExternalMarkerLabel.tsx
var import_react258 = require("@chakra-ui/react");
var import_jsx_runtime = require("react/jsx-runtime");
var ExternalMarkerLabel = ({
  externalMarker,
  ...props
}) => {
  const { t } = useAuraTranslation_default();
  const isPromoted = externalMarker == null ? void 0 : externalMarker.isPromoted;
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react258.Button, {
    as: "span",
    px: "6px",
    py: "0",
    display: "inline-flex",
    alignItems: "center",
    verticalAlign: "middle",
    height: "20px",
    whiteSpace: "nowrap",
    borderRadius: "2px",
    fontSize: "xs",
    fontWeight: "600",
    alignSelf: "start",
    letterSpacing: "0.4px",
    backgroundColor: "blue.500",
    className: `product__externalMarker-${externalMarker.symbol}`,
    size: "xs",
    pointerEvents: "none",
    textTransform: "uppercase",
    bgColor: !isPromoted ? "white" : "blue.500",
    borderColor: "blue.500",
    color: isPromoted ? "white" : "blue.500",
    variant: isPromoted ? "solid" : "outline",
    ...props,
    children: externalMarker.label && externalMarker.label !== "" ? t(externalMarker.label) : externalMarker.symbol
  });
};
var ExternalMarkerLabel_default = ExternalMarkerLabel;

// src/components/ExternalMarker/ExternalMarkerContainer.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var ExternalMarkerContainer = ({
  externalMarkers,
  ...props
}) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react259.VStack, {
    minH: "20px",
    spacing: "8px",
    className: "product__externalMarkerContainer",
    w: "full",
    ...props,
    children: externalMarkers == null ? void 0 : externalMarkers.map((externalMarker, index) => {
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ExternalMarkerLabel_default, {
        externalMarker,
        className: `product__externalMarker-${externalMarker == null ? void 0 : externalMarker.symbol}`
      }, index);
    })
  });
};
var ExternalMarkerContainer_default = ExternalMarkerContainer;

// src/components/FileDetails/FileDetails.tsx
var import_react260 = require("@chakra-ui/react");
var import_js47 = require("@mdi/js");
var import_react261 = __toESM(require("@mdi/react"));
var import_date_fns14 = require("date-fns");
var import_filesize3 = __toESM(require("filesize"));
var import_jsx_runtime = require("react/jsx-runtime");
var FileDetails = ({
  file,
  fullWidthPreview,
  onClose,
  ...props
}) => {
  var _a2;
  const { t } = useAuraTranslation_default();
  if (!file) {
    return null;
  }
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react260.Box, {
    fontSize: "md",
    className: "file-repository__details",
    ...props,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react260.Stack, {
        spacing: 4,
        mb: 6,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react260.Flex, {
            height: {
              base: "248px",
              md: "296px",
              lg: "312px",
              xl: "400px"
            },
            align: "center",
            justify: "center",
            position: "relative",
            className: "details__preview",
            children: [
              isImage(file.mimeType) ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react260.Flex, {
                mt: {
                  lg: "64px"
                },
                maxH: "264px",
                children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react260.Image, {
                  objectFit: "contain",
                  width: fullWidthPreview ? "full" : "auto",
                  src: getImageUrl(file.dbName, "big")
                })
              }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react260.Box, {
                color: "gray.500",
                children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react261.default, {
                  size: "128px",
                  path: import_js47.mdiFile
                })
              }),
              onClose ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react260.CloseButton, {
                position: "absolute",
                top: 0,
                right: 0,
                size: "lg",
                color: "gray.700",
                onClick: onClose
              }) : null
            ]
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react260.Text, {
            "data-testid": "details_filename",
            fontWeight: "medium",
            children: file.fileName
          })
        ]
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react260.Table, {
        w: "unset",
        variant: "unstyled",
        p: 0,
        css: {
          tableLayout: "fixed"
        },
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react260.Tbody, {
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react260.Tr, {
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react260.Td, {
                  py: 2,
                  px: 0,
                  pr: 4,
                  className: "details__size-label",
                  children: `${t("FILE_REPO_FILE_SIZE")}:`
                }),
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react260.Td, {
                  py: 2,
                  px: 0,
                  pr: 4,
                  className: "details__size",
                  "data-testid": "details_size",
                  children: (0, import_filesize3.default)(file.fileSize)
                })
              ]
            }),
            /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react260.Tr, {
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react260.Td, {
                  py: 2,
                  px: 0,
                  pr: 4,
                  className: "details__date-created-label",
                  children: `${t("FILE_REPO_DATE_CREATED")}:`
                }),
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react260.Td, {
                  py: 2,
                  px: 0,
                  pr: 4,
                  className: "details__date-created",
                  "data-testid": "details_date-created",
                  children: file.dateCreate ? (0, import_date_fns14.format)(new Date(file.dateCreate), DATE_FORMAT_DOTS) : "?"
                })
              ]
            }),
            /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react260.Tr, {
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react260.Td, {
                  py: 2,
                  px: 0,
                  pr: 4,
                  className: "details__author-label",
                  children: `${t("FILE_REPO_AUTHOR")}:`
                }),
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react260.Td, {
                  py: 2,
                  px: 0,
                  pr: 4,
                  className: "details__author",
                  "data-testid": "details__author",
                  children: ((_a2 = file == null ? void 0 : file.user) == null ? void 0 : _a2.fullName) ?? ""
                })
              ]
            })
          ]
        })
      })
    ]
  });
};
var FileDetails_default = FileDetails;

// src/components/FilterFields/AccountUserFilter.tsx
var import_react262 = require("@chakra-ui/react");
var import_react263 = require("react");
var import_react_query33 = require("react-query");
var import_jsx_runtime = require("react/jsx-runtime");
var useSelectedOptionsFetcher2 = ({
  value,
  isUserUser
}) => {
  const { t } = useAuraTranslation_default();
  return (0, import_react_query33.useQuery)(
    ["account_users", value, "fullName"],
    () => api_default.getAutoselect("account_users", {
      params: {
        "filter[id][in]": value,
        fields: "fullName,isDeleted",
        extra_fields: "fullName",
        "page[limit]": -1,
        "setting[with_deleted]": 1
      }
    }),
    {
      select: (response) => {
        var _a2;
        const dataToReturn = ((_a2 = response == null ? void 0 : response.data) == null ? void 0 : _a2.map((obj) => ({
          label: t(obj["fullName"]),
          value: obj.id,
          isDeleted: obj.isDeleted
        }))) ?? [];
        return (value == null ? void 0 : value.length) > 0 ? [...dataToReturn] : [];
      },
      enabled: (value == null ? void 0 : value.length) > 0,
      retry: false,
      refetchOnWindowFocus: false
    }
  );
};
var AccountUserFilter = ({
  filterName,
  name,
  onChange,
  value,
  selectProps,
  ...props
}) => {
  const { t } = useAuraTranslation_default();
  const { isUserUser } = (0, import_react263.useContext)(AuthContext);
  const [isInitialFetching, setIsInitialFetching] = (0, import_react263.useState)(!!value);
  const [tempValue, setTempValue] = (0, import_react263.useState)([]);
  const [withDeleted, setWithDeleted] = (0, import_react263.useState)(false);
  const handleSetValue = (value2) => {
    let parsedValue = [];
    if (Array.isArray(value2)) {
      parsedValue = value2;
    } else {
      parsedValue = value2 ? [value2] : [];
    }
    setTempValue(parsedValue);
    const filterValue = (parsedValue == null ? void 0 : parsedValue.map((v) => v.value)) ?? [];
    onChange == null ? void 0 : onChange(filterName, filterValue);
  };
  const { data: selectedOptions, isFetching } = useSelectedOptionsFetcher2({
    value,
    isUserUser
  });
  const loadDataProps2 = (0, import_react263.useMemo)(
    () => ({
      endpoint: "account_users",
      labelField: "fullName",
      settings: {
        fields: "fullName,company.name,isDeleted",
        extra_fields: "fullName",
        "setting[with_relations]": true,
        "setting[with_deleted]": withDeleted,
        "order[firstName]": "ASC",
        "order[lastName]": "ASC"
      }
    }),
    [withDeleted]
  );
  if (isInitialFetching && isFetching && !selectedOptions) {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraFormLabel_default, {
          htmlFor: `input-${filterName}`,
          children: name
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSelect_default, {
          isLoading: true,
          isReadOnly: true
        })
      ]
    });
  }
  if (isInitialFetching) {
    setIsInitialFetching(false);
  }
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react262.FormControl, {
    ...props,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react262.Box, {
        display: "flex",
        justifyContent: "space-between",
        flexDirection: "row",
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraFormLabel_default, {
            htmlFor: `input-${filterName}`,
            children: name
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react262.Stack, {
            mb: 2,
            isInline: true,
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react262.FormLabel, {
                htmlFor: "account-user-filter-with-deleted",
                m: "0",
                fontWeight: 400,
                children: t("WITH_DELETED")
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react262.Switch, {
                size: "sm",
                id: "account-user-filter-with-deleted",
                alignSelf: "center",
                isChecked: withDeleted,
                onChange: () => setWithDeleted(!withDeleted)
              })
            ]
          })
        ]
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSelect_default, {
        value: isFetching ? tempValue : selectedOptions ?? [],
        onChange: (value2) => handleSetValue(value2),
        isMulti: true,
        loadDataProps: loadDataProps2,
        isLoading: isFetching,
        components: {
          Option: CustomSelectOption_default
        },
        withDeleted
      })
    ]
  });
};
var AccountUserFilter_default = AccountUserFilter;

// src/components/FilterFields/TextFilter.tsx
var import_react264 = require("@chakra-ui/react");
var import_debounce5 = __toESM(require("lodash/debounce"));
var import_react265 = require("react");

// src/components/FilterTextInput/FilterTextInput.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var FilterTextInput = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraInput_default, {
    ...props
  });
};
var FilterTextInput_default = FilterTextInput;

// src/components/FilterFields/TextFilter.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var TextFilter = ({
  name,
  filterName,
  value,
  onChange,
  ...props
}) => {
  const [filterValue, setFilterValue] = (0, import_react265.useState)("");
  const handleSetValue = (e) => {
    setFilterValue(e.target.value);
  };
  const handleOnChange = (value2) => {
    onChange(filterName, value2);
  };
  const debouncedHandleOnChange = (0, import_react265.useCallback)(
    (0, import_debounce5.default)(handleOnChange, 650),
    []
  );
  (0, import_react265.useEffect)(() => {
    if (value && typeof value === "string") {
      setFilterValue(value);
    } else {
      setFilterValue("");
    }
  }, [value]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react264.FormControl, {
    ...props,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraFormLabel_default, {
        htmlFor: `input-${filterName}`,
        children: name
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FilterTextInput_default, {
        id: `input-${filterName}`,
        value: filterValue,
        onChange: handleSetValue,
        onKeyUp: (e) => debouncedHandleOnChange(e.target.value),
        onBlur: (e) => handleOnChange(e.target.value)
      })
    ]
  });
};
var TextFilter_default = TextFilter;

// src/components/FilterFields/NumericFilter.tsx
var import_react267 = require("@chakra-ui/react");
var import_react268 = require("react");
var import_react_number_format = __toESM(require("react-number-format"));
var import_use_debounce3 = require("use-debounce");

// src/components/FilterInputSeparator/FilterInputSeparator.tsx
var import_react266 = require("@chakra-ui/react");
var import_jsx_runtime = require("react/jsx-runtime");
var FilterInputSeparator = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react266.Text, {
    color: "gray.700",
    as: "span",
    fontSize: "15px",
    lineHeight: "24px",
    fontWeight: 400,
    ...props,
    children: "\u2013"
  });
};
var FilterInputSeparator_default = FilterInputSeparator;

// src/components/FilterFields/NumericFilter.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var commonNumberFormatProps = {
  isNumericString: true,
  decimalSeparator: ",",
  customInput: AuraInput_default,
  textAlign: "center",
  type: "text"
};
var NumericFilter = ({
  name,
  filterName,
  onChange,
  isPrice,
  value,
  ...props
}) => {
  const { t } = useAuraTranslation_default();
  const [from, setFrom] = (0, import_react268.useState)("");
  const [to, setTo] = (0, import_react268.useState)("");
  const handleSetValue = (value2, type) => {
    if (type === "from") {
      setFrom(value2);
    }
    if (type === "to") {
      setTo(value2);
    }
  };
  const handleOnChange = (from2, to2) => {
    const values = {};
    if (from2 !== "") {
      values.from = from2;
    }
    if (to2 !== "") {
      values.to = to2;
    }
    onChange(filterName, values);
  };
  (0, import_react268.useEffect)(() => {
    if (!value) {
      setFrom("");
      setTo("");
    }
  }, [value]);
  (0, import_react268.useEffect)(() => {
    if (value == null ? void 0 : value.from) {
      setFrom(value.from.toString());
    } else {
      setFrom("");
    }
  }, [value == null ? void 0 : value.from]);
  (0, import_react268.useEffect)(() => {
    if (value == null ? void 0 : value.to) {
      setTo(value.to.toString());
    } else {
      setTo("");
    }
  }, [value == null ? void 0 : value.to]);
  const debounced = (0, import_use_debounce3.useDebouncedCallback)((from2, to2) => {
    handleOnChange(from2, to2);
  }, 650);
  const showSeparator = (0, import_react267.useBreakpointValue)({
    base: false,
    xl: true
  });
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react267.FormControl, {
    ...props,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraFormLabel_default, {
        htmlFor: `input-${filterName}`,
        children: name
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react267.Stack, {
        direction: { base: "column", xl: "row" },
        align: "center",
        justifyContent: "space-evenly",
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react267.InputGroup, {
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react267.InputLeftElement, {
                color: "blackAlpha.500",
                zIndex: "auto",
                children: t("from")
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_number_format.default, {
                ...commonNumberFormatProps,
                allowNegative: !isPrice,
                id: `input-${filterName}`,
                value: from,
                onValueChange: (values) => handleSetValue(values.value, "from"),
                onKeyUp: () => debounced(from, to),
                onBlur: () => {
                  handleOnChange(from, to);
                },
                "aria-label": "number input from"
              })
            ]
          }),
          showSeparator && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FilterInputSeparator_default, {}),
          /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react267.InputGroup, {
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react267.InputLeftElement, {
                color: "blackAlpha.500",
                zIndex: "auto",
                children: t("to")
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_number_format.default, {
                ...commonNumberFormatProps,
                allowNegative: !isPrice,
                value: to,
                onValueChange: (values) => handleSetValue(values.value, "to"),
                onKeyUp: () => debounced(from, to),
                onBlur: () => handleOnChange(from, to),
                "aria-label": "number input to"
              })
            ]
          })
        ]
      })
    ]
  });
};
var NumericFilter_default = NumericFilter;

// src/components/FilterFields/DatetimeFilter.tsx
var import_react269 = require("@chakra-ui/react");
var import_react270 = require("@emotion/react");
var import_debounce6 = __toESM(require("lodash/debounce"));
var import_isNil6 = __toESM(require("lodash/isNil"));
var import_react271 = require("react");
var import_jsx_runtime = require("react/jsx-runtime");
var DatetimeFilter = ({
  name,
  filterName,
  onChange,
  value,
  withTime,
  ...props
}) => {
  const { t } = useAuraTranslation_default();
  const [from, setFrom] = (0, import_react271.useState)(null);
  const [to, setTo] = (0, import_react271.useState)(null);
  const handleSetValue = (value2, type) => {
    if (type === "from") {
      setFrom(value2);
      handleOnChange(value2, null);
    }
    if (type === "to") {
      setTo(value2);
      handleOnChange(null, value2);
    }
  };
  const handleOnChange = (fromValue, toValue) => {
    const values = {};
    if (fromValue !== null || from !== null) {
      values.from = fromValue ?? from;
    }
    if (toValue !== null || to !== null) {
      values.to = toValue ?? to;
    }
    onChange(filterName, values);
  };
  (0, import_react271.useEffect)(() => {
    if (!value) {
      setFrom(null);
      setTo(null);
    }
  }, [value]);
  (0, import_react271.useEffect)(() => {
    if (value == null ? void 0 : value.from) {
      setFrom(value.from);
    } else {
      setFrom(null);
    }
  }, [value == null ? void 0 : value.from]);
  (0, import_react271.useEffect)(() => {
    if (value == null ? void 0 : value.to) {
      setTo(value.to);
    } else {
      setTo(null);
    }
  }, [value == null ? void 0 : value.to]);
  const debouncedSetFilter = (0, import_react271.useCallback)((0, import_debounce6.default)(handleOnChange, 650), []);
  (0, import_react271.useEffect)(() => {
    debouncedSetFilter(from, to);
  }, [debouncedSetFilter, from, to]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react269.FormControl, {
    ...props,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraFormLabel_default, {
        htmlFor: `input-${filterName}`,
        children: name
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react269.Stack, {
        direction: "column",
        css: import_react270.css`
          .react-datepicker-wrapper {
            width: 100%;
          }
        `,
        align: "center",
        justifyContent: "space-evenly",
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(DateInput_default, {
            value: from,
            id: `input-${filterName}`,
            onChange: (newDate) => handleSetValue(newDate, "from"),
            onSelect: (newDate) => handleSetValue(newDate, "from"),
            onKeyUp: () => debouncedSetFilter(from, to),
            onBlur: () => {
              handleOnChange(from, to);
            },
            "aria-label": "date input from",
            textAlign: "center",
            withTime: (0, import_isNil6.default)(withTime) ? true : withTime,
            leftIconPlaceholder: t("from")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(DateInput_default, {
            value: to,
            onChange: (newDate) => handleSetValue(newDate, "to"),
            onSelect: (newDate) => handleSetValue(newDate, "to"),
            onKeyUp: () => debouncedSetFilter(from, to),
            onBlur: () => handleOnChange(from, to),
            "aria-label": "date input to",
            textAlign: "center",
            withTime: (0, import_isNil6.default)(withTime) ? true : withTime,
            leftIconPlaceholder: t("to")
          })
        ]
      })
    ]
  });
};
var DatetimeFilter_default = DatetimeFilter;

// src/components/FilterFields/BooleanFilter.tsx
var import_react273 = require("@chakra-ui/react");

// src/components/FilterFormLabel/FilterFormLabel.tsx
var import_react272 = require("@chakra-ui/react");
var import_jsx_runtime = require("react/jsx-runtime");
var FilterFormLabel = ({ htmlFor, ...props }) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react272.FormLabel, {
    htmlFor,
    color: "gray.700",
    fontWeight: "500",
    isTruncated: true,
    w: "full",
    ...props
  });
};
var FilterFormLabel_default = FilterFormLabel;

// src/components/FilterFields/BooleanFilter.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var BooleanFilter = ({
  name,
  filterName,
  value,
  onChange,
  ...props
}) => {
  const { t } = useAuraTranslation_default();
  const handleOnChange = (changeValue) => {
    if (value === changeValue) {
      onChange == null ? void 0 : onChange(filterName, null);
      return;
    }
    onChange == null ? void 0 : onChange(filterName, changeValue);
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react273.FormControl, {
    ...props,
    className: "boolean-filter",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FilterFormLabel_default, {
        htmlFor: `input-${filterName}`,
        children: name
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react273.Stack, {
        spacing: 4,
        className: "boolean-filter__boolean-box",
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react273.Checkbox, {
            size: "lg",
            value: "true",
            isChecked: value === true,
            onChange: () => handleOnChange(true),
            className: "boolean-filter__boolean-box__option",
            children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react273.Text, {
              fontSize: "15px",
              lineHeight: "24px",
              mb: "0",
              children: t("Yes")
            })
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react273.Checkbox, {
            size: "lg",
            value: "false",
            isChecked: value === false,
            onChange: () => handleOnChange(false),
            className: "boolean-filter__boolean-box__option",
            children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react273.Text, {
              fontSize: "15px",
              lineHeight: "24px",
              mb: "0",
              children: t("No")
            })
          })
        ]
      })
    ]
  });
};
var BooleanFilter_default = BooleanFilter;

// src/components/FilterFields/AvailabilityFilter.tsx
var import_react274 = require("@chakra-ui/react");
var import_isFinite = __toESM(require("lodash/isFinite"));
var import_isNumber2 = __toESM(require("lodash/isNumber"));
var import_react275 = require("react");
var import_use_debounce4 = require("use-debounce");
var import_react_number_format2 = __toESM(require("react-number-format"));
var import_jsx_runtime = require("react/jsx-runtime");
var isValidNumber = (price) => {
  return (0, import_isNumber2.default)(+price) && (0, import_isFinite.default)(price);
};
var commonNumberFormatProps2 = {
  isNumericString: true,
  decimalSeparator: ",",
  customInput: AuraInput_default,
  textAlign: "center",
  type: "text",
  allowNegative: false
};
var AvailabilityFilter = ({
  name,
  filterName,
  onChange,
  value,
  ...props
}) => {
  const { t } = useAuraTranslation_default();
  const [from, setFrom] = (0, import_react275.useState)("");
  const [to, setTo] = (0, import_react275.useState)("");
  const [notZero, setNotZero] = (0, import_react275.useState)(null);
  const handleSetValue = (value2, type) => {
    if (typeof value2 === "boolean" && type === "notZero") {
      setNotZero(value2);
    }
    if (!isValidNumber(+value2)) {
      return;
    }
    if (type === "from") {
      setFrom(value2);
    }
    if (type === "to") {
      setTo(value2);
    }
  };
  const handleOnChange = (from2, to2, notZero2) => {
    const values = {};
    if (from2 !== "") {
      values.from = from2;
    }
    if (to2 !== "") {
      values.to = to2;
    }
    if (notZero2) {
      values.notZero = notZero2;
    }
    onChange(filterName, values);
  };
  (0, import_react275.useEffect)(() => {
    if (!value) {
      setFrom("");
      setTo("");
      setNotZero(false);
    }
  }, [value]);
  (0, import_react275.useEffect)(() => {
    if (value == null ? void 0 : value.from) {
      setFrom(value.from.toString());
    } else {
      setFrom("");
    }
  }, [value == null ? void 0 : value.from]);
  (0, import_react275.useEffect)(() => {
    if (value == null ? void 0 : value.to) {
      setTo(value.to.toString());
    } else {
      setTo("");
    }
  }, [value == null ? void 0 : value.to]);
  (0, import_react275.useEffect)(() => {
    if (value == null ? void 0 : value.notZero) {
      setNotZero(value.notZero);
    } else {
      setNotZero(false);
    }
  }, [value == null ? void 0 : value.notZero]);
  const debounced = (0, import_use_debounce4.useDebouncedCallback)((from2, to2, notZero2) => {
    handleOnChange(from2, to2, notZero2);
  }, 650);
  const showSeparator = (0, import_react274.useBreakpointValue)({
    base: false,
    xl: true
  });
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react274.FormControl, {
    ...props,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FilterFormLabel_default, {
        htmlFor: `input-${filterName}`,
        children: name
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react274.Stack, {
        direction: { base: "column", xl: "row" },
        align: "center",
        justifyContent: "space-evenly",
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react274.InputGroup, {
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react274.InputLeftElement, {
                color: "blackAlpha.500",
                zIndex: "auto",
                children: t("from")
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_number_format2.default, {
                ...commonNumberFormatProps2,
                id: `input-${filterName}`,
                value: from,
                onValueChange: (values) => handleSetValue(values.value, "from"),
                onKeyUp: () => debounced(from, to, notZero),
                onBlur: () => {
                  handleOnChange(from, to, notZero);
                },
                "aria-label": "number input from"
              })
            ]
          }),
          showSeparator && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FilterInputSeparator_default, {}),
          /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react274.InputGroup, {
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react274.InputLeftElement, {
                color: "blackAlpha.500",
                zIndex: "auto",
                children: t("to")
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_number_format2.default, {
                ...commonNumberFormatProps2,
                value: to,
                onValueChange: (values) => handleSetValue(values.value, "to"),
                onKeyUp: () => debounced(from, to, notZero),
                onBlur: () => handleOnChange(from, to, notZero),
                "aria-label": "number input to"
              })
            ]
          })
        ]
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react274.Checkbox, {
        mt: 2,
        size: "lg",
        isChecked: notZero,
        onChange: () => handleOnChange(from, to, !notZero),
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react274.Text, {
          fontSize: "15px",
          children: t("ONLY_AVAILABLE")
        })
      })
    ]
  });
};
var AvailabilityFilter_default = AvailabilityFilter;

// src/components/ListFilter/ListFilter.tsx
var import_react278 = require("@chakra-ui/react");
var import_debounce7 = __toESM(require("lodash/debounce"));
var import_isEmpty9 = __toESM(require("lodash/isEmpty"));
var import_xor3 = __toESM(require("lodash/xor"));
var import_react279 = require("react");

// src/components/FilterFields/MultiFilter/ListPositions/ListPositions.tsx
var import_react276 = require("@chakra-ui/react");
var import_findIndex2 = __toESM(require("lodash/findIndex"));
var import_sortBy4 = __toESM(require("lodash/sortBy"));
var import_react277 = require("react");
var import_jsx_runtime = require("react/jsx-runtime");
var ListPositions = ({ filterName, value, onChange, positions, maxVisible = 5 }) => {
  const { t } = useAuraTranslation_default();
  const [showHidden, setShowHidden] = (0, import_react277.useState)(false);
  const sortedPositions = (0, import_sortBy4.default)(
    positions,
    (el2) => -(0, import_findIndex2.default)(value, (v) => v === el2.id + "")
  );
  const visiblePostions = sortedPositions.slice(
    0,
    Math.max(maxVisible, value.length)
  );
  const hiddenPositions = sortedPositions.slice(
    Math.max(maxVisible, value.length)
  );
  const arrayOptions = hiddenPositions.length > 0 && !showHidden ? visiblePostions : sortedPositions;
  const shouldTranslateOptions = ["currencyCode"].includes(filterName) ? false : true;
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, {
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react276.CheckboxGroup, {
      value,
      onChange: (value2) => onChange(value2.map((val) => isNaN(Number(val)) ? val : Number(val))),
      colorScheme: "blue",
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react276.Stack, {
        id: `positions-${filterName}`,
        spacing: 4,
        fontSize: "md",
        fontWeight: 400,
        className: "filter-multi__select-box",
        children: [
          arrayOptions == null ? void 0 : arrayOptions.map((pos) => {
            return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react276.Checkbox, {
              pt: "2px",
              size: "lg",
              mb: 0,
              value: "" + pos.id,
              alignItems: "flex-start",
              className: "filter-multi__select-box__option",
              children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react276.Text, {
                fontSize: "15px",
                lineHeight: "24px",
                mt: "-2px",
                mb: "0",
                children: pos.rawValue && pos.rawValue !== "" ? pos.rawValue : shouldTranslateOptions ? t(pos.value) : pos.value
              })
            }, pos.id);
          }),
          hiddenPositions.length > 0 && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react276.Button, {
            w: "full",
            variant: "link",
            fontWeight: 500,
            color: "blue.500",
            fontSize: "sm",
            onClick: () => setShowHidden((state) => !state),
            justifyContent: "flex-start",
            lineHeight: "20px",
            letterSpacing: "0.25px",
            className: "filter-multi__select-box__button",
            mt: "18px !important",
            children: showHidden ? t("FILTER_HIDE_POSITIONS") : `${t("FILTER_SHOW_POSITIONS")} (+${hiddenPositions.length})`
          })
        ]
      })
    })
  });
};
var ListPositions_default = ListPositions;

// src/components/ListFilter/ListFilter.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var ListFilter = ({
  name,
  filterName,
  type,
  positions,
  value,
  onChange,
  ...props
}) => {
  const { t } = useAuraTranslation_default();
  const [filterValue, setFilterValue] = (0, import_react279.useState)(value ?? []);
  const handleChange = (val) => {
    setFilterValue((oldState) => {
      if (type === "list") {
        const diff = (0, import_xor3.default)(oldState, val);
        const newValue = diff[0] !== (oldState == null ? void 0 : oldState[0]) ? diff : val;
        handleFilterValueChange(newValue);
        return newValue;
      }
      debouncedHandleOnChange(val);
      return val;
    });
  };
  const handleFilterValueChange = (newValue) => {
    onChange(filterName, newValue);
  };
  const handleCheckAllOptions = () => {
    const allOptions = positions.map((position) => position == null ? void 0 : position.id);
    handleChange(allOptions.map((opt) => +opt));
  };
  const handleUncheckAllOptions = () => {
    handleChange([]);
  };
  const debouncedHandleOnChange = (0, import_react279.useCallback)(
    (0, import_debounce7.default)(handleFilterValueChange, 650),
    []
  );
  (0, import_react279.useEffect)(() => {
    if (value) {
      setFilterValue(value);
    } else {
      setFilterValue([]);
    }
  }, [value]);
  const checkBoxValue = (filterValue == null ? void 0 : filterValue.map((val) => "" + val)) ?? [];
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react278.FormControl, {
    ...props,
    children: [
      type === "listMulti" ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FilterFormLabel_default, {
        children: name
      }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FilterFormLabel_default, {
        htmlFor: `attribute-${filterName}`,
        children: name
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react278.Box, {
        color: "crmBlue",
        children: [
          (0, import_isEmpty9.default)(filterValue) ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react278.Button, {
            fontWeight: "500",
            fontSize: "sm",
            variant: "link",
            onClick: handleCheckAllOptions,
            mb: "16px",
            color: "blue.500",
            children: t("ATTRIBUTE_CHECK_ALL")
          }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react278.Button, {
            fontWeight: "500",
            fontSize: "sm",
            variant: "link",
            onClick: handleUncheckAllOptions,
            mb: "16px",
            color: "blue.500",
            children: t("ATTRIBUTE_UNCHECK_ALL")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ListPositions_default, {
            filterName,
            positions: positions ?? [],
            value: checkBoxValue,
            onChange: handleChange
          })
        ]
      })
    ]
  });
};
var ListFilter_default = ListFilter;

// src/components/FilterFields/ExternalMarkerFilter.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var ExternalMarkerFilter = ({ name, filterName, value, onChange }) => {
  const externalMarkers = useExternalMarkers();
  if (!externalMarkers || externalMarkers.length === 0) {
    return null;
  }
  const parsedMarkers = externalMarkers.map((marker, index) => ({
    id: marker.id,
    value: marker.label,
    rawValue: marker.label && marker.label !== "" ? null : marker.symbol,
    ordering: index
  }));
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ListFilter_default, {
    name,
    filterName,
    value,
    onChange,
    type: "listMulti",
    positions: parsedMarkers
  });
};
var ExternalMarkerFilter_default = ExternalMarkerFilter;

// src/components/FilterFields/MultiFilter/MultiFilter.tsx
var import_react280 = require("@chakra-ui/react");
var import_debounce8 = __toESM(require("lodash/debounce"));
var import_isEmpty10 = __toESM(require("lodash/isEmpty"));
var import_react281 = require("react");
var import_isNil7 = __toESM(require("lodash/isNil"));
var import_jsx_runtime = require("react/jsx-runtime");
var MultiFilter = ({
  name,
  filterName,
  value,
  onChange,
  endpoint,
  labelField,
  valueField = "id",
  positions,
  options,
  filters,
  labelFieldCreator,
  settings,
  relatedModule,
  isMulti = true,
  translateCustom = false,
  isReadOnly = false,
  ...props
}) => {
  var _a2;
  const { t } = useAuraTranslation_default();
  const [tempValue, setTempValue] = (0, import_react281.useState)([]);
  const [isUpdating, setIsUpdating] = (0, import_react281.useState)(false);
  const searchingForOptions = !!(options == null ? void 0 : options.searchingForOptions);
  const appSettings = useSettings_default();
  const newLookListFilterAsTag = (appSettings == null ? void 0 : appSettings.new_look_list_filter_as_tag) ?? ((_a2 = appSettings == null ? void 0 : appSettings.settings) == null ? void 0 : _a2.newLookListFilterAsTag) ?? false;
  const displayAsSelect = (0, import_react281.useMemo)(() => {
    if (relatedModule === "attributes") {
      return options == null ? void 0 : options.filterAsTags;
    } else {
      return newLookListFilterAsTag || newLookListFilterAsTag === "true";
    }
  }, [newLookListFilterAsTag]);
  const { data, isError, isFetching } = useMinimalAutoselect_default({
    endpoint,
    labelField,
    valueField,
    enabled: !positions,
    filters,
    labelFieldCreator,
    settings,
    translateCustom
  });
  const prepareValueForSelect = (0, import_react281.useMemo)(
    () => {
      var _a3;
      return (_a3 = [...value ?? []]) == null ? void 0 : _a3.map(
        (val) => isNaN(Number(val)) ? val : Number(val)
      );
    },
    [value]
  );
  const { data: defaultValues, isFetching: deafultIsFetching } = useMinimalAutoselect_default({
    endpoint,
    labelField,
    valueField,
    enabled: !!endpoint && !!(prepareValueForSelect == null ? void 0 : prepareValueForSelect.length),
    filters: {
      [`filter[${valueField}][in]`]: prepareValueForSelect == null ? void 0 : prepareValueForSelect.join(","),
      ...filters
    },
    labelFieldCreator,
    settings
  });
  const newPositions = data ?? positions;
  const handleChange = (newValue) => {
    if (isMulti) {
      setTempValue(newValue);
    } else {
      setTempValue([newValue]);
    }
    setIsUpdating(true);
    if (displayAsSelect && isMulti) {
      debouncedHandleOnChange(newValue == null ? void 0 : newValue.map((item) => item.value));
    } else if (displayAsSelect && !isMulti) {
      debouncedHandleOnChange(newValue == null ? void 0 : newValue.value);
    } else {
      debouncedHandleOnChange(newValue);
    }
  };
  const handleFilterValueChange = (newValue) => {
    if ((0, import_isNil7.default)(newValue)) {
      onChange(filterName, []);
    } else {
      onChange(filterName, isMulti ? newValue : [newValue]);
    }
  };
  const handleCheckAllOptions = () => {
    const allOptions = newPositions.map((position) => position == null ? void 0 : position.id);
    handleChange(
      allOptions.map((opt) => isNaN(Number(opt)) ? opt : Number(opt))
    );
  };
  const handleUncheckAllOptions = () => {
    handleChange([]);
  };
  const debouncedHandleOnChange = (0, import_react281.useCallback)(
    (0, import_debounce8.default)(handleFilterValueChange, 650),
    []
  );
  const selectOptions = (0, import_react281.useMemo)(() => {
    const options2 = buildOptions(newPositions, "value", "id");
    return options2 == null ? void 0 : options2.map((opt) => ({
      ...opt,
      label: t(opt.label)
    }));
  }, [newPositions]);
  const selectValue = (0, import_react281.useMemo)(() => {
    if (!(value == null ? void 0 : value.length)) {
      return [];
    }
    const preparedValue = !!endpoint ? buildOptions(defaultValues, "value", "id") : selectOptions == null ? void 0 : selectOptions.filter(
      (item) => prepareValueForSelect == null ? void 0 : prepareValueForSelect.includes(item.value)
    );
    return preparedValue == null ? void 0 : preparedValue.map((val) => ({
      ...val,
      label: t(val.label)
    }));
  }, [value, defaultValues, prepareValueForSelect]);
  const defaultCheckBoxValue = (0, import_react281.useMemo)(
    () => {
      var _a3;
      return isMulti ? ((_a3 = isUpdating ? tempValue : value) == null ? void 0 : _a3.map((val) => "" + val)) ?? [] : [];
    },
    [value, tempValue, isUpdating]
  );
  (0, import_react281.useEffect)(() => {
    var _a3;
    if (displayAsSelect) {
      if (isMulti && (selectValue == null ? void 0 : selectValue.length) === (tempValue == null ? void 0 : tempValue.length)) {
        setIsUpdating(false);
      } else if (!isMulti && (value == null ? void 0 : value[0]) === ((_a3 = tempValue == null ? void 0 : tempValue[0]) == null ? void 0 : _a3.value)) {
        setIsUpdating(false);
      }
    } else if ((value == null ? void 0 : value.length) === (tempValue == null ? void 0 : tempValue.length)) {
      setIsUpdating(false);
    }
  }, [value, tempValue, isUpdating, selectValue]);
  if (isError) {
    return null;
  }
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react280.FormControl, {
    ...props,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraFormLabel_default, {
        children: t(name)
      }),
      !displayAsSelect && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react280.Box, {
        mb: 4,
        children: (0, import_isEmpty10.default)(defaultCheckBoxValue) ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react280.Button, {
          className: "check-all-button",
          fontSize: "sm",
          variant: "link",
          onClick: handleCheckAllOptions,
          color: "blue.500",
          fontWeight: 500,
          lineHeight: "20px",
          children: t("ATTRIBUTE_CHECK_ALL")
        }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react280.Button, {
          className: "uncheck-all-button",
          fontSize: "sm",
          variant: "link",
          onClick: handleUncheckAllOptions,
          color: "blue.500",
          fontWeight: 500,
          lineHeight: "20px",
          children: t("ATTRIBUTE_UNCHECK_ALL")
        })
      }),
      displayAsSelect ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSelect_default, {
        value: isUpdating ? tempValue : selectValue,
        onChange: handleChange,
        classNamePrefix: "Select",
        isMulti: true,
        options: selectOptions,
        defaultOption: !searchingForOptions,
        isLoading: isFetching || deafultIsFetching,
        forceOnChange: true,
        isReadOnly,
        ...!isMulti && { isMulti: false }
      }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ListPositions_default, {
        filterName,
        positions: newPositions ?? [],
        value: defaultCheckBoxValue,
        onChange: handleChange
      })
    ]
  });
};
var MultiFilter_default = MultiFilter;

// src/components/FilterFields/TagFilter.tsx
var import_react282 = require("@chakra-ui/react");
var import_react283 = require("react");
var import_jsx_runtime = require("react/jsx-runtime");
var TagFilter = ({
  name,
  filterName,
  value,
  onChange,
  endpoint,
  labelField = "fullName",
  valueField = "id",
  filters,
  isFetchingDisabled = false,
  defaultOptions,
  defaultValues,
  ...props
}) => {
  const { t } = useAuraTranslation_default();
  const [inputValue, setInputValue] = (0, import_react283.useState)();
  const [filterValue, setFilterValue] = (0, import_react283.useState)([]);
  const [options, setOptions] = (0, import_react283.useState)();
  const { data, isFetching } = useMinimalAutoselect_default({
    endpoint,
    labelField,
    valueField,
    settings: { "page[limit]": 20 },
    filters: {
      "filter[_q][hasText]": inputValue,
      "order[_q]": "DESC",
      ...filters
    },
    enabled: !isFetchingDisabled && !!inputValue
  });
  const { data: fetchedDefaultValues, isFetching: deafultIsFetching } = useMinimalAutoselect_default({
    endpoint,
    labelField,
    valueField,
    settings: { "page[limit]": -1 },
    filters: {
      "filter[value][in]": value == null ? void 0 : value.join(","),
      ...filters
    },
    enabled: (value == null ? void 0 : value.length) > 0 && (filterValue == null ? void 0 : filterValue.length) == 0 && !isFetchingDisabled
  });
  (0, import_react283.useEffect)(() => {
    setFilterValue(
      buildOptions(defaultValues ?? fetchedDefaultValues, "value")
    );
  }, [fetchedDefaultValues, defaultValues]);
  const handleChangeFilterValue = (newValue) => {
    const labels = newValue == null ? void 0 : newValue.map((val) => val.label);
    if (!newValue) {
      onChange == null ? void 0 : onChange(filterName, null);
    } else {
      setFilterValue(newValue);
      onChange == null ? void 0 : onChange(filterName, labels);
    }
  };
  (0, import_react283.useEffect)(() => {
    setOptions(buildOptions(defaultOptions ?? data, "value"));
  }, [data, defaultOptions]);
  (0, import_react283.useEffect)(() => {
    const selectedOptions = filterValue == null ? void 0 : filterValue.filter(
      (opt) => value == null ? void 0 : value.includes(opt.label)
    );
    if (selectedOptions) {
      setFilterValue(selectedOptions);
    } else {
      setFilterValue(null);
    }
  }, [value]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react282.FormControl, {
    ...props,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraFormLabel_default, {
        children: name
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react282.Box, {
        w: "full",
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSelect_default, {
          value: filterValue ?? [],
          onInputChange: (value2) => setInputValue(value2),
          onChange: handleChangeFilterValue,
          classNamePrefix: "Select",
          noOptionsMessage: (elem) => (elem == null ? void 0 : elem.inputValue) === "" ? t("BEGIN_WRITING_TO_SEARCH") : t("NOTHING_FOUND"),
          isMulti: true,
          options,
          isLoading: !isFetchingDisabled && (isFetching || deafultIsFetching),
          onMenuClose: () => !isFetchingDisabled && setOptions([]),
          withCheckbox: true
        })
      })
    ]
  });
};
var TagFilter_default = TagFilter;

// src/components/FilterFields/CountryFilter/CountryFilter.tsx
var import_react284 = require("@chakra-ui/react");
var import_orderBy3 = __toESM(require("lodash/orderBy"));
var import_react285 = require("react");
var import_react_select_country_list2 = __toESM(require("react-select-country-list"));
var import_use_deep_compare_effect3 = __toESM(require("use-deep-compare-effect"));
var import_jsx_runtime = require("react/jsx-runtime");
var CountryFilter = ({
  name,
  filterName,
  value,
  onChange,
  ...props
}) => {
  const { currentLocale } = (0, import_react285.useContext)(LanguageContext);
  const [filterValue, setFilterValue] = (0, import_react285.useState)([]);
  const countries = (0, import_react285.useMemo)(() => {
    var _a2;
    const regionNames = new Intl.DisplayNames([(currentLocale == null ? void 0 : currentLocale.code) ?? "pl"], {
      type: "region"
    });
    return (0, import_orderBy3.default)(
      (_a2 = (0, import_react_select_country_list2.default)().getData()) == null ? void 0 : _a2.map((country) => ({
        ...country,
        label: regionNames.of(country.value)
      })),
      "label",
      "asc"
    );
  }, [currentLocale]);
  const handleSetValue = (newValue) => {
    setFilterValue(newValue);
    const filterValues = (newValue == null ? void 0 : newValue.map((v) => v.value)) ?? [];
    onChange == null ? void 0 : onChange(filterName, filterValues);
  };
  (0, import_use_deep_compare_effect3.default)(() => {
    if (value && Array.isArray(value)) {
      const values = countries.filter(
        (option) => value.includes(option.value)
      );
      setFilterValue(values);
    } else {
      setFilterValue([]);
    }
  }, [countries, value]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react284.FormControl, {
    ...props,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FilterFormLabel_default, {
        htmlFor: `input-${filterName}`,
        children: name
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSelect_default, {
        value: filterValue,
        inputId: `input-${filterName}`,
        onChange: handleSetValue,
        isMulti: true,
        options: countries
      })
    ]
  });
};
var CountryFilter_default = CountryFilter;

// src/components/GalleryItem/GalleryItem.tsx
var import_react301 = require("@chakra-ui/react");
var import_framer_motion = require("framer-motion");
var import_react302 = __toESM(require("react"));

// src/components/PriceDisplay/PriceDisplay.tsx
var import_react287 = require("@chakra-ui/react");

// src/hooks/useProductPrice/useProductPrice.ts
var import_react286 = require("react");
var getBasePrice = (prices, salePriceType, isUserUser) => {
  if (isUserUser) {
    return void 0;
  }
  const purchasePrice = prices == null ? void 0 : prices.find(
    (price) => price.priceLevel === "purchase"
  );
  const defaultPrice = prices == null ? void 0 : prices.find((price) => price.priceLevel === "default");
  if ((defaultPrice == null ? void 0 : defaultPrice[PriceNames[salePriceType]]) > ((purchasePrice == null ? void 0 : purchasePrice[PriceNames[salePriceType]]) ?? 0)) {
    return defaultPrice == null ? void 0 : defaultPrice[PriceNames[salePriceType]];
  }
};
var getSalePriceUserUser = (prices, priceLevel = "srp") => {
  return (prices == null ? void 0 : prices.find((price) => price.priceLevel === priceLevel)) ?? (prices == null ? void 0 : prices[0]);
};
var getSalePriceAccountUser = (prices, priceLevel = "purchase") => {
  return prices == null ? void 0 : prices.find((price) => price.priceLevel === priceLevel);
};
var useProductPrice = ({ prices, customPriceLevel }) => {
  const { isUserUser } = (0, import_react286.useContext)(AuthContext);
  const settings = useSettings_default();
  const sellByPrice = (0, import_react286.useMemo)(
    () => {
      var _a2;
      return ((_a2 = settings.settings) == null ? void 0 : _a2.sellByPrice) ?? (settings == null ? void 0 : settings.sell_by_price);
    },
    [settings]
  );
  const salePriceUserUser = getSalePriceUserUser(prices, customPriceLevel);
  const salePriceAccountUser = getSalePriceAccountUser(
    prices,
    customPriceLevel
  );
  const priceType = isUserUser ? "netto" : sellByPrice;
  const userUserPriceType = PriceNames[priceType];
  const accountUserPriceType = PriceNames[priceType];
  const currency = isUserUser ? salePriceUserUser == null ? void 0 : salePriceUserUser.currencyCode : salePriceAccountUser == null ? void 0 : salePriceAccountUser.currencyCode;
  const salePrice = isUserUser ? salePriceUserUser == null ? void 0 : salePriceUserUser[userUserPriceType] : salePriceAccountUser == null ? void 0 : salePriceAccountUser[accountUserPriceType];
  const salePriceAllData = isUserUser ? salePriceUserUser : salePriceAccountUser;
  const basePrice = getBasePrice(prices, sellByPrice, isUserUser);
  return {
    salePrice,
    salePriceAllData,
    basePrice,
    priceType,
    currency
  };
};
var useProductPrice_default = useProductPrice;

// src/components/PriceDisplay/PriceDisplay.tsx
var import_isFinite2 = __toESM(require("lodash/isFinite"));
var import_round = __toESM(require("lodash/round"));
var import_react288 = __toESM(require("react"));
var import_jsx_runtime = require("react/jsx-runtime");
var PriceDisplay = ({
  prices,
  isGalleryItem,
  showAllPriceData,
  showPriceSrp,
  showDiscountInfo,
  customPriceLevel,
  customPriceTag,
  ...props
}) => {
  var _a2, _b;
  const { t } = useAuraTranslation_default();
  const { salePrice, salePriceAllData, basePrice, priceType, currency } = useProductPrice_default({
    prices,
    customPriceLevel
  });
  const settings = useSettings_default();
  const sell_by_price = (0, import_react288.useMemo)(
    () => {
      var _a3;
      return ((_a3 = settings.settings) == null ? void 0 : _a3.sellByPrice) ?? (settings == null ? void 0 : settings.sell_by_price);
    },
    [settings]
  );
  const discountPercent = () => {
    if (!basePrice || !salePrice)
      return null;
    return (0, import_round.default)((basePrice - salePrice) / basePrice * 100, 0);
  };
  const shouldDisplayPriceType = (0, import_isFinite2.default)(salePrice) || (0, import_isFinite2.default)(basePrice) && !showDiscountInfo;
  const basePriceWithCurrency = priceFormatter(basePrice, currency, {
    formatToParts: true
  });
  const salePriceWithCurrency = priceFormatter(salePrice, currency, {
    formatToParts: true
  });
  const { priceValue: basePriceValue, priceCurrency: basePriceCurrency } = splitPriceParts(basePriceWithCurrency);
  const { priceValue: salePriceValue, priceCurrency: salePriceCurrency } = splitPriceParts(salePriceWithCurrency);
  const additionalSalePrice = sell_by_price === "netto" ? {
    value: salePriceAllData == null ? void 0 : salePriceAllData.priceBrutto,
    priceType: "brutto"
  } : {
    value: salePriceAllData == null ? void 0 : salePriceAllData.priceNetto,
    priceType: "netto"
  };
  const additionalSalePriceWithCurrency = priceFormatter(
    additionalSalePrice == null ? void 0 : additionalSalePrice.value,
    currency,
    {
      formatToParts: true
    }
  );
  const {
    priceValue: additionalSalePriceValue,
    priceCurrency: additionalSalePriceCurrency
  } = splitPriceParts(additionalSalePriceWithCurrency);
  const priceVatWithCurrency = priceFormatter(
    salePriceAllData == null ? void 0 : salePriceAllData.priceVat,
    currency,
    {
      formatToParts: true
    }
  );
  const { priceValue: priceVatValue, priceCurrency: priceVatValueCurrency } = splitPriceParts(priceVatWithCurrency);
  const priceSrp = (_b = (_a2 = prices == null ? void 0 : prices.filter(
    (price) => price.priceLevel === "srp"
  )) == null ? void 0 : _a2[0]) == null ? void 0 : _b.priceBrutto;
  const priceSrpWithCurrency = priceFormatter(priceSrp, currency, {
    formatToParts: true
  });
  const { priceValue: priceSrpValue, priceCurrency: priceSrpValueCurrency } = splitPriceParts(priceSrpWithCurrency);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, {
    children: !isGalleryItem ? /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react287.Stack, {
      className: "product__price-wrapper",
      spacing: 0,
      ...props,
      children: [
        (0, import_isFinite2.default)(basePrice) && showDiscountInfo && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(PriceWithCurrency, {
          price: basePriceValue,
          currency: basePriceCurrency,
          currencyCode: currency,
          discountPercent: discountPercent(),
          fontSize: "md",
          textDecoration: "line-through",
          color: "gray.400",
          customTag: customPriceTag
        }),
        (0, import_isFinite2.default)(salePrice) ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(PriceWithCurrency, {
          price: salePriceValue,
          currency: salePriceCurrency,
          currencyCode: currency,
          fontSize: "2xl",
          lineHeight: "36px",
          fontWeight: "500"
        }) : null,
        !(0, import_isFinite2.default)(salePrice) && (0, import_isFinite2.default)(basePrice) && !showDiscountInfo ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(PriceWithCurrency, {
          price: basePriceValue,
          currency: basePriceCurrency,
          currencyCode: currency,
          fontSize: "2xl",
          lineHeight: "36px",
          fontWeight: "500"
        }) : null,
        shouldDisplayPriceType && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react287.Text, {
          className: "product__price-type",
          color: "gray.400",
          fontSize: "sm",
          lineHeight: "20px",
          letterSpacing: "0.25px",
          children: t(priceType)
        }),
        showAllPriceData && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react287.HStack, {
          pt: (0, import_isFinite2.default)(salePrice) ? "16px" : "0",
          justifyContent: "flex-end",
          children: [
            (additionalSalePrice == null ? void 0 : additionalSalePrice.value) && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react287.HStack, {
              justifyContent: "flex-end",
              alignItems: "center",
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(PriceWithCurrency, {
                  price: additionalSalePriceValue,
                  currency: additionalSalePriceCurrency,
                  currencyCode: currency,
                  lineHeight: "20px"
                }),
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react287.Text, {
                  className: "product__additional-price-type",
                  color: "gray.400",
                  fontSize: "sm",
                  lineHeight: "20px",
                  letterSpacing: "0.25px",
                  children: t(additionalSalePrice == null ? void 0 : additionalSalePrice.priceType)
                })
              ]
            }),
            (salePriceAllData == null ? void 0 : salePriceAllData.priceVat) && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
              children: [
                (0, import_isFinite2.default)(additionalSalePrice == null ? void 0 : additionalSalePrice.value) && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react287.Divider, {
                  orientation: "vertical"
                }),
                /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react287.HStack, {
                  justifyContent: "flex-end",
                  alignItems: "center",
                  children: [
                    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(PriceWithCurrency, {
                      price: priceVatValue,
                      currency: priceVatValueCurrency,
                      currencyCode: currency,
                      lineHeight: "20px"
                    }),
                    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react287.Text, {
                      className: "product__additional-price-type",
                      color: "gray.400",
                      fontSize: "sm",
                      lineHeight: "20px",
                      letterSpacing: "0.25px",
                      children: t("VAT")
                    })
                  ]
                })
              ]
            })
          ]
        }),
        showPriceSrp && priceSrp && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react287.HStack, {
          justifyContent: "flex-end",
          alignItems: "center",
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react287.Text, {
              className: "product__price-srp",
              color: "gray.400",
              fontSize: "sm",
              lineHeight: "20px",
              letterSpacing: "0.25px",
              children: t("PRICE_SRP_BRUTTO")
            }),
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(PriceWithCurrency, {
              price: priceSrpValue,
              currency: priceSrpValueCurrency,
              currencyCode: currency,
              lineHeight: "20px"
            })
          ]
        })
      ]
    }) : /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react287.Stack, {
      className: `product__price-wrapper-${Math.random()}`,
      justifyContent: "flex-start",
      ...props,
      children: [
        (0, import_isFinite2.default)(basePrice) && showDiscountInfo && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react287.Flex, {
          w: "full",
          justifyContent: "flex-start",
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(PriceWithCurrency, {
            price: basePriceValue,
            currency: basePriceCurrency,
            currencyCode: currency,
            discountPercent: discountPercent(),
            fontSize: "md",
            textDecoration: "line-through",
            color: "gray.400",
            customTag: customPriceTag
          })
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react287.HStack, {
          alignItems: "flex-end",
          spacing: "0",
          children: [
            (0, import_isFinite2.default)(salePrice) && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react287.Box, {
              children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(PriceWithCurrency, {
                price: salePriceValue,
                currency: salePriceCurrency,
                currencyCode: currency,
                fontSize: "2xl",
                lineHeight: "36px",
                fontWeight: "500"
              })
            }),
            !(0, import_isFinite2.default)(salePrice) && (0, import_isFinite2.default)(basePrice) && !showDiscountInfo ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react287.Box, {
              children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(PriceWithCurrency, {
                price: basePriceValue,
                currency: basePriceCurrency,
                currencyCode: currency,
                fontSize: "2xl",
                lineHeight: "36px",
                fontWeight: "500"
              })
            }) : null,
            shouldDisplayPriceType && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react287.Flex, {
              alignItems: "flex-end",
              h: "36px",
              ps: "8px",
              pb: "1px",
              children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react287.Text, {
                className: "product__price-type",
                color: "gray.400",
                fontSize: "sm",
                lineHeight: "24px",
                letterSpacing: "0.5px",
                children: t(priceType)
              })
            })
          ]
        })
      ]
    })
  });
};
var PriceWithCurrency = import_react288.default.memo(
  ({
    price,
    currency,
    currencyCode,
    discountPercent,
    customTag,
    ...props
  }) => {
    const priceValue = price.slice(0, -1);
    const priceDivider = price.slice(-1);
    return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react287.Box, {
      as: "span",
      display: "inline-block",
      className: "product__price-value",
      ...props,
      children: [
        discountPercent > 0 && typeof discountPercent === "number" && customTag == null ? /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react287.Tag, {
          className: "product__price-percent-discount",
          bgColor: "green.500",
          variant: "success",
          color: "#fff",
          me: "8px",
          fontSize: "md",
          borderRadius: "4px",
          children: [
            discountPercent,
            "%"
          ]
        }) : null,
        customTag,
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react287.Text, {
          as: "span",
          className: "product__price",
          color: "gray.700",
          lineHeight: "24px",
          children: priceValue
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react287.Text, {
          as: "span",
          className: "product__price-divider",
          lineHeight: "24px",
          children: priceDivider
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react287.Text, {
          as: "span",
          className: "product__currency",
          "data-currency-code": currencyCode,
          color: "gray.700",
          lineHeight: "24px",
          children: currency
        })
      ]
    });
  }
);
var PriceDisplay_default = PriceDisplay;

// src/components/ProductAvailability/ProductAvailability.tsx
var import_react289 = require("@chakra-ui/react");
var import_jsx_runtime = require("react/jsx-runtime");
var ProductAvailability = ({
  availability,
  estimatedAvailability,
  withLabel = true,
  showTotalAvailability = true,
  isService,
  ...props
}) => {
  var _a2, _b;
  const { t } = useAuraTranslation_default();
  const settings = useSettings_default();
  if (!availability && !estimatedAvailability) {
    return null;
  }
  const realTotalAvailability = availability == null ? void 0 : availability.total;
  const availabilityNumber = availability == null ? void 0 : availability.available;
  const availabilityText = estimatedAvailability == null ? void 0 : estimatedAvailability.description;
  const availabilityImage = (_b = (_a2 = estimatedAvailability == null ? void 0 : estimatedAvailability.image) == null ? void 0 : _a2.uris) == null ? void 0 : _b.show;
  const availabilityImageHeight = (settings == null ? void 0 : settings.inventory_thumbnail_height) ? `${settings.inventory_thumbnail_height}px` : "24px";
  const availabilityImageWidth = (settings == null ? void 0 : settings.inventory_thumbnail_width) ? `${settings.inventory_thumbnail_width}px` : "fit-content";
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react289.VStack, {
    className: "product__availability",
    color: "gray.600",
    ...props,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react289.Stack, {
        alignItems: "center",
        direction: "row",
        w: "full",
        children: [
          withLabel && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react289.Text, {
                color: "gray.400",
                fontSize: "15px",
                letterSpacing: "mediumWide",
                lineHeight: "24px",
                children: [
                  t("PRODUCT_AVAILABILITY"),
                  ":"
                ]
              }),
              " "
            ]
          }),
          availabilityImage ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react289.Flex, {
            alignItems: "flex-end",
            justifyContent: "center",
            height: availabilityImageHeight,
            width: availabilityImageWidth,
            "data-testid": "availabilityImageWrapper",
            children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react289.Image, {
              h: "100%",
              w: "auto",
              src: availabilityImage,
              alt: t(availabilityText),
              "data-testid": "availabilityImage"
            })
          }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react289.Text, {
            textTransform: "lowercase",
            children: availabilityText ? t(availabilityText) : availabilityNumber
          })
        ]
      }),
      realTotalAvailability !== void 0 && showTotalAvailability && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react289.HStack, {
        w: "full",
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react289.Text, {
            color: "gray.400",
            fontSize: "15px",
            letterSpacing: "mediumWide",
            lineHeight: "24px",
            children: [
              t("PRODUCT_quantity"),
              ":"
            ]
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react289.Text, {
            children: isService ? t("service") : realTotalAvailability
          })
        ]
      })
    ]
  });
};
var ProductAvailability_default = ProductAvailability;

// src/components/ProductEAN/ProductEAN.tsx
var import_react290 = require("@chakra-ui/react");
var import_isString = __toESM(require("lodash/isString"));
var import_jsx_runtime = require("react/jsx-runtime");
var ProductEAN = ({ ean }) => {
  const { t } = useAuraTranslation_default();
  if ((0, import_isString.default)(ean) && ean.length > 0) {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react290.Text, {
      color: "gray.400",
      className: "product__ean",
      textAlign: "left",
      sx: {
        "&": {
          span: {
            color: "gray.700"
          }
        }
      },
      children: [
        `${t("PRODUCT_EAN")}: `,
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)("span", {
          children: ean
        })
      ]
    });
  }
  return null;
};
var ProductEAN_default = ProductEAN;

// src/components/ProductImage/ProductImage.tsx
var import_react291 = require("@chakra-ui/react");
var import_react292 = require("@emotion/react");
var import_react_cool_img = __toESM(require("react-cool-img"));
var import_js48 = require("@mdi/js");
var import_react293 = __toESM(require("@mdi/react"));
var import_jsx_runtime = require("react/jsx-runtime");
var ProductImage = ({
  defaultImage,
  name,
  externalMarkers = void 0,
  ...props
}) => {
  const imgMd = defaultImage ? getImageUrl(defaultImage.dbName, "md") : "";
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react291.Flex, {
    w: "full",
    mx: "auto",
    overflow: "hidden",
    align: "center",
    justify: "center",
    position: "relative",
    bg: "white",
    fontSize: "4xl",
    color: "gray.400",
    css: import_react292.css`
        img {
          height: 100%;
          width: 100%;
          object-fit: contain;
        }
      `,
    ...props,
    children: [
      externalMarkers && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ExternalMarkerContainer_default, {
        externalMarkers,
        position: "absolute",
        top: "0",
        left: "0"
      }),
      defaultImage ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_cool_img.default, {
        src: imgMd,
        alt: name
      }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react291.Flex, {
        maxH: "98px",
        maxW: "98px",
        w: "100%",
        color: "gray.100",
        alignItems: "center",
        justifyContent: "center",
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react293.default, {
          path: import_js48.mdiFileImageOutline
        })
      })
    ]
  });
};
var ProductImage_default = ProductImage;

// src/components/ProductQuantitySelector/ProductQuantitySelector.tsx
var import_react298 = require("@chakra-ui/react");
var import_react299 = require("react");
var import_react300 = __toESM(require("@mdi/react"));
var import_js50 = require("@mdi/js");

// src/components/QuantitySelector/QuantitySelector.tsx
var import_react296 = require("@chakra-ui/react");
var import_js49 = require("@mdi/js");
var import_react297 = require("react");

// src/components/QuantitySelector/ControlButton/ControlButton.tsx
var import_react294 = require("@chakra-ui/react");
var import_react295 = __toESM(require("@mdi/react"));
var import_jsx_runtime = require("react/jsx-runtime");
var ControlButton = ({
  increment,
  onClick,
  icon,
  ...props
}) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react294.IconButton, {
    variant: "ghost",
    "aria-label": "control-quantity-product",
    icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react295.default, {
      path: icon,
      size: "20px"
    }),
    onClick: () => onClick(increment),
    bgColor: "transparent",
    m: "0",
    ...props
  });
};
var ControlButton_default = ControlButton;

// src/components/QuantitySelector/QuantitySelector.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var QuantitySelector = ({
  value,
  onChange,
  availableQuantity = 1e5,
  controlBtnSizes = "md",
  minValue = 0,
  isDisabled,
  ...props
}) => {
  const [tempValue, setTempValue] = (0, import_react297.useState)(value);
  const [isInvalid, setIsInvalid] = (0, import_react297.useState)(false);
  const handleOnChange = (e) => {
    const prepareValue2 = e.target.value && parseInt(e.target.value);
    if (prepareValue2 <= availableQuantity && prepareValue2 >= minValue) {
      setIsInvalid(false);
      setTempValue(prepareValue2);
      onChange(prepareValue2);
    } else {
      setIsInvalid(true);
    }
  };
  const handleButtonAction = (increment) => {
    let newValue;
    if (increment && tempValue < availableQuantity) {
      newValue = tempValue + 1;
    } else if (!increment && tempValue > 0) {
      newValue = tempValue - 1;
    }
    setTempValue(newValue);
    onChange(newValue);
  };
  (0, import_react297.useEffect)(() => {
    if (availableQuantity >= 0) {
      if (value <= availableQuantity) {
        setIsInvalid(false);
      } else if (value > availableQuantity) {
        setIsInvalid(true);
      }
    }
  }, [value, availableQuantity]);
  (0, import_react297.useEffect)(() => {
    if (value !== tempValue) {
      setTempValue(value);
    }
  }, [value]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react296.HStack, {
    className: "product-quantity__selector",
    borderRadius: "6px",
    border: "1px solid",
    borderColor: "gray.200",
    w: "136px",
    spacing: 0,
    overflow: "hidden",
    width: controlBtnSizes === "lg" ? "154px" : "136px",
    ...isInvalid ? {
      borderColor: "#E53E3E",
      boxShadow: "0 0 0 1px #E53E3E"
    } : {
      borderColor: "gray.200"
    },
    ...props,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ControlButton_default, {
        onClick: () => handleButtonAction(false),
        increment: false,
        icon: import_js49.mdiMinus,
        borderRight: "1px solid",
        borderColor: "gray.200",
        borderRadius: "0",
        isDisabled: [minValue, null].includes(tempValue) || isDisabled,
        size: controlBtnSizes,
        "data-testid": "quantity-decrement"
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react296.Input, {
        type: "number",
        sx: {
          "-moz-appearance": "textfield"
        },
        border: "none",
        p: "0",
        textAlign: "center",
        value: tempValue,
        onChange: (e) => handleOnChange(e),
        onBlur: () => setIsInvalid(false),
        isDisabled: !availableQuantity || isDisabled,
        "data-testid": "quantity-input"
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ControlButton_default, {
        onClick: () => handleButtonAction(true),
        increment: true,
        icon: import_js49.mdiPlus,
        borderLeft: "1px solid",
        borderColor: "gray.200",
        borderRadius: "0",
        isDisabled: tempValue >= availableQuantity || availableQuantity < 0 || !availableQuantity || isDisabled,
        size: controlBtnSizes,
        "data-testid": "quantity-increment"
      })
    ]
  });
};
var QuantitySelector_default = QuantitySelector;

// src/components/ProductQuantitySelector/ProductQuantitySelector.tsx
var import_debounce9 = __toESM(require("lodash/debounce"));
var import_jsx_runtime = require("react/jsx-runtime");
var ProductQuantitySelector = ({
  productId,
  positionId = void 0,
  withRedirectToBasket = true,
  availableQuantity,
  extendedButton,
  withAddButton = true,
  errorMessages,
  isDisabled,
  ...props
}) => {
  var _a2, _b, _c, _d, _e, _f, _g;
  const [value, setValue] = (0, import_react299.useState)(availableQuantity > 0 ? 1 : 0);
  const { t } = useAuraTranslation_default();
  const { basketContent, addToBasket, basketInfo } = useBasketContent();
  const isLimitOrderActive = ((_a2 = useSettings_default()) == null ? void 0 : _a2.block_order_with_exceeded_quantity) === "true" || ((_c = (_b = useSettings_default()) == null ? void 0 : _b.settings) == null ? void 0 : _c.blockOrderWithExceededQuantity);
  const showExceedQuantityError = (_e = (_d = useSettings_default()) == null ? void 0 : _d.settings) == null ? void 0 : _e.showNoProducts;
  const finalAvailableQuantity = (0, import_react299.useMemo)(
    () => isLimitOrderActive ? availableQuantity : DEFAULT_LIMIT_AVAILABLE_PRODUCTS,
    [availableQuantity, isLimitOrderActive]
  );
  (0, import_react299.useEffect)(() => {
    if (!isLimitOrderActive) {
      setValue(1);
    }
  }, [isLimitOrderActive]);
  const inBasketQuantity = (positionId ? (_f = basketContent == null ? void 0 : basketContent.find((item) => (item == null ? void 0 : item.id) === positionId)) == null ? void 0 : _f.quantity : (_g = basketContent == null ? void 0 : basketContent.find((item) => {
    var _a3;
    return ((_a3 = item == null ? void 0 : item.product) == null ? void 0 : _a3.id) === productId;
  })) == null ? void 0 : _g.quantity) || null;
  const addToBasketButtonDisabled = (0, import_react299.useMemo)(
    () => isLimitOrderActive ? value < 1 || !finalAvailableQuantity : value < 1,
    [value, finalAvailableQuantity, isLimitOrderActive]
  );
  const handleAddToBasket = (quantity) => {
    if (positionId) {
      const newValue = inBasketQuantity + quantity;
      addToBasket({
        productId,
        quantity: newValue,
        positionId
      });
    } else if (quantity > 0) {
      addToBasket({ productId, quantity, autoRedirect: withRedirectToBasket });
    }
  };
  const handleAddButton = (quantity) => {
    if (productId) {
      handleAddToBasket(quantity);
      setValue(1);
    }
  };
  const debounceAddToBasket = (0, import_debounce9.default)(handleAddToBasket, 500);
  const handleDebounceAddToBasket = (newValue) => {
    let countToAdd = newValue;
    if (inBasketQuantity) {
      countToAdd = newValue - inBasketQuantity;
    }
    debounceAddToBasket(countToAdd);
  };
  (0, import_react299.useEffect)(() => {
    if (!withAddButton) {
      setValue(inBasketQuantity);
    }
  }, [inBasketQuantity]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react298.VStack, {
    w: "100%",
    justifyContent: "flex-end",
    spacing: 4,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react298.HStack, {
        spacing: extendedButton ? 4 : 2,
        className: "product-quantity",
        w: "100%",
        justifyContent: "flex-end",
        alignItems: "center",
        ...props,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react298.Flex, {
            justifyContent: "flex-end",
            flexWrap: "wrap",
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(QuantitySelector_default, {
                value,
                onChange: (newValue) => {
                  if (!withAddButton) {
                    handleDebounceAddToBasket(newValue);
                  } else {
                    setValue(newValue);
                  }
                },
                minValue: finalAvailableQuantity > 0 ? 1 : 0,
                availableQuantity: finalAvailableQuantity,
                controlBtnSizes: extendedButton ? "lg" : "md",
                sx: {
                  ...extendedButton && {
                    input: {
                      height: "48px"
                    }
                  }
                },
                isDisabled
              }),
              showExceedQuantityError ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ErrorMessages, {
                errorMessages
              }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, {})
            ]
          }),
          withAddButton && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, {
            children: extendedButton ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ButtonAction_default, {
              leftIcon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react300.default, {
                path: import_js50.mdiCartOutline,
                size: "20px"
              }),
              onClick: () => handleAddButton(value),
              isDisabled: addToBasketButtonDisabled,
              fontWeight: "600",
              letterSpacing: "0.15px",
              h: "48px",
              lineHeight: "32px",
              bgColor: "crmBlue",
              fontSize: "lg",
              color: "#fff",
              px: "24px",
              className: "product-quantity__button-extended",
              children: t("PRODUCT_ADD_TO_CART")
            }) : /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react298.Box, {
              position: "relative",
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react298.IconButton, {
                  variant: "ghost",
                  "aria-label": "control-quantity-product",
                  icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react300.default, {
                    path: import_js50.mdiCartOutline,
                    size: "20px"
                  }),
                  onClick: () => handleAddButton(value),
                  bgColor: "gray.100",
                  isDisabled: addToBasketButtonDisabled,
                  className: "product-quantity__button"
                }),
                inBasketQuantity && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react298.Circle, {
                  bg: "blue.500",
                  px: "2px",
                  minW: "18px",
                  color: "#fff",
                  display: "flex",
                  alignItems: "center",
                  position: "absolute",
                  top: "0",
                  right: "0",
                  zIndex: 3,
                  "data-testid": "small-info-quantity",
                  children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react298.Text, {
                    fontWeight: "600",
                    fontSize: "xs",
                    letterSpacing: "0.4px",
                    lineHeight: "18px",
                    children: inBasketQuantity
                  })
                })
              ]
            })
          })
        ]
      }),
      inBasketQuantity > 0 && extendedButton ? /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react298.Text, {
        w: "100%",
        textAlign: "right",
        letterSpacing: "mediumWide",
        lineHeight: "24px",
        fontSize: "md",
        color: "gray.400",
        children: [
          t("ADDED"),
          " " + inBasketQuantity + " ",
          t("TO_BASKET")
        ]
      }) : null
    ]
  });
};
var ErrorMessages = ({ errorMessages = [] }) => {
  const { t } = useAuraTranslation_default();
  const displayErrorMessages = () => errorMessages.map((message, index) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react298.Text, {
    fontSize: "sm",
    letterSpacing: "0.25px",
    lineHeight: "20px",
    color: "red.500",
    mt: "8px",
    children: t(message)
  }, index));
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react298.Box, {
    w: "full",
    children: displayErrorMessages()
  });
};
var ProductQuantitySelector_default = ProductQuantitySelector;

// src/components/GalleryItem/GalleryItem.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var imageSizeValue = { sm: "150px", md: "250px", lg: "350px" };
var GalleryItem = import_react302.default.memo(
  ({
    product,
    hidePromotedMarkers,
    omitImageSizeSetting = false,
    showOnlyPrice,
    isSelected,
    variant,
    onToggleCheckbox,
    displayImage = true,
    hideQuantitySelector,
    favoriteProps,
    showDiscountInfo,
    withRedirectToBasket = false,
    disableQuantitySelector = false,
    customPriceTag,
    customQuantityParams,
    ...props
  }) => {
    var _a2, _b, _c;
    const { Link: Link27 } = useLink();
    const { isUserUser } = (0, import_react302.useContext)(AuthContext);
    const { t } = useAuraTranslation_default();
    const theme = (0, import_react301.useTheme)();
    const settings = useSettings_default();
    const [displayTooltip, setDisplayTooltip] = (0, import_react302.useState)(false);
    const handleDisplayTooltip = () => setDisplayTooltip((prev) => !prev);
    const cardVariants = {
      hover: {
        boxShadow: theme.shadows.md
      }
    };
    const activeMarkers = getActiveMarkers(product.externalMarkers);
    const externalMarkers = hidePromotedMarkers ? activeMarkers == null ? void 0 : activeMarkers.filter((marker) => !marker.isPromoted) : activeMarkers;
    const imageSize = omitImageSizeSetting ? "200px" : imageSizeValue[settings["product_thumbnail_size_in_gallery"]] ?? "200px";
    const seoUrl = settings["enable_seo_urls"] ? prepareSeoUrlForProduct(t, (_b = (_a2 = product.categories) == null ? void 0 : _a2[0]) == null ? void 0 : _b.name, product.name) : "";
    const productUrl = `/product/show/productid/${product.id}${seoUrl}`;
    const customPriceLevel = variant === "forCompanyPriceList" ? "individual" : void 0;
    const GalleryItemLink = ({ productUrl: productUrl2, product: product2 }) => {
      const memoizedLink = (0, import_react302.useMemo)(() => {
        return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Link27, {
          href: productUrl2,
          passHref: true,
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react301.LinkOverlay, {
            children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(NameDisplay_default, {
              id: product2.id,
              name: product2 == null ? void 0 : product2.name,
              code: product2 == null ? void 0 : product2.code,
              flex: 1,
              displayTooltip
            })
          })
        });
      }, [productUrl2, product2, displayTooltip]);
      return memoizedLink;
    };
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react301.LinkBox, {
      h: "full",
      paddingBottom: "8px",
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AnimatedBox, {
        variants: cardVariants,
        whileHover: "hover",
        onAnimationComplete: (definition) => {
          if (definition === "hover")
            handleDisplayTooltip();
          else if (definition === "initial" && displayTooltip)
            handleDisplayTooltip();
        },
        animate: "initial",
        initial: "initial",
        className: "product",
        display: "flex",
        direction: "column",
        borderBottom: 1,
        borderStyle: "solid",
        borderBottomColor: "gray.100",
        cursor: "pointer",
        id: `product-${product.id}`,
        px: "24px",
        py: "16px",
        rounded: 4,
        bg: "white",
        h: "full",
        ...props,
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react301.Stack, {
          spacing: showOnlyPrice ? 0 : 2,
          w: "full",
          h: "full",
          position: "relative",
          children: [
            displayImage && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ProductImage_default, {
              height: imageSize,
              width: imageSize,
              maxW: "calc(100vw - 48px)",
              defaultImage: product.defaultImage,
              name: product.name,
              "data-testid": "product-list-gallery-image"
            }),
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ExternalMarkerContainer_default, {
              externalMarkers,
              position: "absolute",
              top: "16px",
              left: "24px"
            }),
            (favoriteProps == null ? void 0 : favoriteProps.isVisible) && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react301.Center, {
              position: "absolute",
              top: "0",
              right: "0",
              zIndex: 2,
              children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ButtonFavorite_default, {
                onClick: favoriteProps == null ? void 0 : favoriteProps.onClickFavorite,
                isChecked: product == null ? void 0 : product.favorite
              })
            }),
            Link27 ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(GalleryItemLink, {
              productUrl,
              product
            }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react301.LinkOverlay, {
              href: productUrl,
              children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(NameDisplay_default, {
                id: product.id,
                name: product == null ? void 0 : product.name,
                code: product == null ? void 0 : product.code,
                flex: 1,
                displayTooltip,
                w: "full"
              })
            }),
            !showOnlyPrice && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ProductEAN_default, {
                  ean: product.ean
                }),
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ProductAvailability_default, {
                  availability: product.availability,
                  estimatedAvailability: product.estimatedAvailability,
                  isService: product == null ? void 0 : product.isService
                })
              ]
            }),
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react301.Flex, {
              flexGrow: 1,
              alignItems: "flex-end",
              children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react301.Box, {
                className: "product__price",
                textAlign: "right",
                justifySelf: "end",
                w: "full",
                children: isUserUser ? /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react301.Flex, {
                  w: "full",
                  flexDir: "column",
                  rowGap: 4,
                  children: [
                    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react301.Stack, {
                      w: "full",
                      justifyContent: "flex-end",
                      direction: "row",
                      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(PriceDisplay_default, {
                        prices: product.prices,
                        isGalleryItem: true,
                        customPriceLevel,
                        customPriceTag
                      })
                    }),
                    typeof customQuantityParams && !hideQuantitySelector && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(QuantitySelector_default, {
                      value: customQuantityParams.quantity,
                      onChange: (newValue) => customQuantityParams.onChange(product.id, newValue)
                    })
                  ]
                }) : /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react301.Box, {
                  children: [
                    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(PriceDisplay_default, {
                      prices: product.prices,
                      isGalleryItem: true,
                      showDiscountInfo,
                      customPriceLevel,
                      customPriceTag
                    }),
                    (!showOnlyPrice || !hideQuantitySelector) && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react301.Flex, {
                      justifyContent: "flex-end",
                      mt: "16px",
                      children: [
                        typeof onToggleCheckbox === "function" && !showOnlyPrice && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react301.Checkbox, {
                          isChecked: isSelected,
                          onChange: onToggleCheckbox,
                          zIndex: 2,
                          size: "lg"
                        }),
                        !hideQuantitySelector && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ProductQuantitySelector_default, {
                          isDisabled: disableQuantitySelector,
                          productId: product == null ? void 0 : product.id,
                          positionId: product == null ? void 0 : product.positionId,
                          zIndex: 1,
                          withAddButton: variant !== "basket",
                          withRedirectToBasket,
                          availableQuantity: (product == null ? void 0 : product.isService) ? DEFAULT_LIMIT_AVAILABLE_PRODUCTS : (_c = product == null ? void 0 : product.availability) == null ? void 0 : _c.available
                        })
                      ]
                    })
                  ]
                })
              })
            })
          ]
        })
      })
    });
  }
);
GalleryItem.displayName = "GalleryItem";
var AnimatedBox = (0, import_framer_motion.motion)(import_react301.Box);
var GalleryItem_default = GalleryItem;

// src/components/Header/Header.tsx
var import_react303 = require("@chakra-ui/react");
var import_jsx_runtime = require("react/jsx-runtime");
var MainHeader = ({ children, ...props }) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react303.Text, {
    className: "header__main",
    as: "span",
    display: "inline",
    color: "gray.700",
    ...props,
    children
  });
};
var SecondaryHeader = ({ children, ...props }) => {
  if (typeof children !== "string" || children.trim().length < 1) {
    return null;
  }
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react303.Text, {
    className: "header__secondary",
    as: "span",
    display: "inline",
    color: "gray.400",
    ...props,
    children: `(${children})`
  });
};
var Header = ({ children, ...props }) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react303.Heading, {
    className: "header",
    as: "h2",
    fontSize: { base: "lg", sm: "xl" },
    fontWeight: "500",
    lineHeight: { base: "32px", sm: "36px" },
    color: "gray.700",
    sx: {
      "span:first-of-type": {
        marginRight: "0.75rem"
      }
    },
    ...props,
    children
  });
};
var Header_default = Header;

// src/components/InBasketInfo/InBasketInfo.tsx
var import_react304 = require("@chakra-ui/react");
var import_fa3 = require("react-icons/fa");
var import_jsx_runtime = require("react/jsx-runtime");
var InBasketInfo = ({ quantity, ...props }) => {
  if (!quantity || !isFinite(quantity)) {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react304.Box, {
      "data-testid": "basket-image",
      ...props,
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_fa3.FaShoppingBasket, {
        size: 20
      })
    });
  }
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react304.Box, {
    "data-testid": "basket-image-with-label",
    _after: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      position: "absolute",
      bottom: "2%",
      right: "2%",
      backgroundColor: "white",
      shadow: "md",
      padding: "0.3em",
      borderRadius: "10px",
      minWidth: "15px",
      height: "15px",
      fontWeight: "600",
      fontSize: "10px",
      fontFamily: "mono",
      content: `"${quantity > 99 ? "99+" : quantity}"`
    },
    ...props,
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_fa3.FaShoppingBasket, {
      size: 20
    })
  });
};
var InBasketInfo_default = InBasketInfo;

// src/components/InBasketText/InBasketText.tsx
var import_react305 = require("@chakra-ui/react");
var import_jsx_runtime = require("react/jsx-runtime");
var InBasketText = ({ count, ...props }) => {
  const { t } = useAuraTranslation_default();
  if (!count) {
    return null;
  }
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react305.Text, {
    as: "span",
    whiteSpace: "nowrap",
    ...props,
    children: `${t(
      "PRODUCT_IN_BASKET"
    )}: ${count}`
  });
};
var InBasketText_default = InBasketText;

// src/components/Linkify/Linkify.tsx
var import_react306 = require("@chakra-ui/react");
var import_react_linkify = __toESM(require("react-linkify"));
var import_jsx_runtime = require("react/jsx-runtime");
var Linkify = ({ children }) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_linkify.default, {
    componentDecorator: (decoratedHref, decoratedText, key) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react306.Link, {
      color: "blue.500",
      target: "_blank",
      rel: "noopener noreferrer nofollow",
      href: decoratedHref,
      children: decoratedText
    }, key),
    children
  });
};
var Linkify_default = Linkify;

// src/components/List/List.tsx
var import_react341 = require("@chakra-ui/react");
var import_react342 = require("@emotion/react");
var import_js53 = require("@mdi/js");
var import_react343 = __toESM(require("@mdi/react"));
var import_difference2 = __toESM(require("lodash/difference"));
var import_react344 = __toESM(require("react"));
var import_react_shadowed_double_scrollbar = __toESM(require("react-shadowed-double-scrollbar"));
var import_react_table = require("react-table");
var import_use_deep_compare_effect5 = require("use-deep-compare-effect");

// src/hooks/useQueryParams/useQueryParams.ts
var import_react307 = require("@xstate/react");
var import_isEmpty11 = __toESM(require("lodash/isEmpty"));
var import_qs = __toESM(require("qs"));
var import_url_pattern = __toESM(require("url-pattern"));
var import_use_deep_compare_effect4 = require("use-deep-compare-effect");
var import_xstate2 = require("xstate");
var queryParamsMachine = (0, import_xstate2.createMachine)(
  {
    id: "queryParamsMachine",
    context: {
      currentPage: null,
      currentPerPage: null,
      orderName: null,
      orderType: null,
      filterConfig: null,
      queryParams: null,
      setFilters: null,
      setPage: null,
      setPerPage: null,
      setOrder: null
    },
    initial: "idle",
    states: {
      idle: {
        on: {
          SET_IS_READY: "readingFromUrl"
        }
      },
      readingFromUrl: {
        invoke: {
          src: "readFromUrl",
          onDone: {
            target: "writingToUrl",
            actions: (0, import_xstate2.assign)({
              queryParams: (context) => context
            })
          }
        }
      },
      writingToUrl: {
        on: {
          SET_URL_FILTERS: {
            target: "settingUrlParams"
          }
        }
      },
      settingUrlParams: {
        invoke: {
          src: "writeToUrl",
          onDone: {
            target: "writingToUrl",
            actions: (0, import_xstate2.assign)((context, event) => {
              return {
                ...event.data
              };
            })
          }
        }
      }
    }
  },
  {
    services: {
      readFromUrl: async ({ setFilters, setPerPage, setPage, setOrder, filterConfig }, event) => {
        const {
          matchedUrl,
          parsedQuery,
          perPage,
          page,
          sortField,
          sortType,
          isMatchCompanyId,
          filters
        } = parseUrlParams(filterConfig);
        if (perPage) {
          setPerPage(Number(perPage));
        }
        if (page) {
          setPage(Number(page));
        }
        if (sortField && sortType) {
          setOrder([
            {
              id: sortField,
              desc: sortType === "desc"
            }
          ]);
        }
        if (isMatchCompanyId) {
          const currentUrl = new URL(window.location.href);
          currentUrl.pathname = currentUrl.pathname.replace(
            `company_id/${matchedUrl.filterValue}`,
            ""
          );
          window.history.replaceState({}, "", currentUrl.toString());
          if (!(0, import_isEmpty11.default)(filters)) {
            const query = {};
            const transformedFilters = {};
            Object.keys(filters).forEach((filterKey) => {
              transformedFilters[filterKey] = filters[filterKey].value;
            });
            query.filters = import_qs.default.stringify(transformedFilters, {
              arrayFormat: "brackets",
              indices: false
            });
            updateQueryParams(query);
          }
        }
        if (!(0, import_isEmpty11.default)(filters)) {
          setFilters(filters);
        }
        return { queryParams: parsedQuery };
      },
      writeToUrl: async ({ currentPage, currentPerPage, orderName: oN, orderType: oT }, event) => {
        const query = {};
        const pageIndex = typeof (event == null ? void 0 : event.page) === "number" ? event.page : currentPage ?? 1;
        query.page = pageIndex + 1;
        const perPage = (event == null ? void 0 : event.perPage) ? event.perPage : currentPerPage ?? 20;
        query.perPage = perPage;
        const orderName = (event == null ? void 0 : event.orderName) ?? oN;
        const orderType = (event == null ? void 0 : event.orderType) ?? oT;
        if (orderName && orderType && (event == null ? void 0 : event.orderName) !== void 0) {
          query.sortField = orderName;
          query.sortType = orderType;
        }
        const filters = (event == null ? void 0 : event.filters) ?? {};
        if (!(0, import_isEmpty11.default)(filters)) {
          const transformedFilters = {};
          Object.keys(filters).forEach((filterKey) => {
            transformedFilters[filterKey] = filters[filterKey].value;
          });
          query.filters = import_qs.default.stringify(transformedFilters, {
            arrayFormat: "brackets",
            indices: false
          });
        }
        updateQueryParams(query);
        return {
          currentPage: pageIndex,
          currentPerPage: perPage,
          orderName,
          orderType,
          filters
        };
      }
    }
  }
);
var parseUrlParams = (filterConfig) => {
  const urlPattern = new import_url_pattern.default(
    "(/index.php)/:module/:list(/:filter/:filterValue)"
  );
  const matchedUrl = urlPattern.match(window.location.pathname);
  const currentSearchParams = window.location.search.replace("?", "");
  const parsedQuery = import_qs.default.parse(currentSearchParams);
  const filters = import_qs.default.parse(parsedQuery.filters);
  const page = parsedQuery.page;
  const perPage = parsedQuery.perPage;
  const sortField = parsedQuery.sortField;
  const sortType = parsedQuery.sortType;
  const isMatchCompanyId = (matchedUrl == null ? void 0 : matchedUrl.filter) === "company_id";
  let newListFiltersValue = filters;
  if (!(0, import_isEmpty11.default)(filters) || isMatchCompanyId) {
    newListFiltersValue = getFiltersFromUrl(
      {
        ...filters,
        ...prepareCompanyFilter(isMatchCompanyId, matchedUrl)
      },
      filterConfig
    );
  }
  return {
    matchedUrl,
    parsedQuery,
    perPage,
    page,
    sortField,
    sortType,
    isMatchCompanyId,
    filters: newListFiltersValue
  };
};
var prepareCompanyFilter = (isMatchCompanyId, matchedUrl) => {
  if (!isMatchCompanyId) {
    return {};
  }
  if ((matchedUrl == null ? void 0 : matchedUrl.module) === "task") {
    return { accountCompanies: [matchedUrl.filterValue] };
  }
  return { company: [matchedUrl.filterValue] };
};
var parseValue = (filter, filterValue) => {
  switch (filter.type) {
    case "date": {
      return {
        ...(filterValue == null ? void 0 : filterValue.from) && {
          from: filterValue.from === "today" ? "today" : new Date(filterValue.from)
        },
        ...(filterValue == null ? void 0 : filterValue.to) && {
          to: filterValue.to === "today" ? "today" : new Date(filterValue.to)
        }
      };
    }
    case "datetimetz":
    case "datetime": {
      return {
        ...(filterValue == null ? void 0 : filterValue.from) && {
          from: filterValue.from === "today" ? "today" : new Date(filterValue.from)
        },
        ...(filterValue == null ? void 0 : filterValue.to) && {
          to: filterValue.to === "today" ? "today" : new Date(filterValue.to)
        }
      };
    }
    case "company": {
      return filterValue == null ? void 0 : filterValue.map((companyId) => Number(companyId));
    }
    case "relation": {
      if (filter.relatedModule === "accountCompany" && typeof filterValue === "string") {
        return filterValue;
      } else if (["product", "products", "servicedProducts"].includes(
        filter.relatedModule
      ) && typeof filterValue === "string") {
        return filterValue;
      } else if (["places"].includes(filter.id)) {
        return filterValue;
      } else {
        return filterValue == null ? void 0 : filterValue.map((id) => Number(id));
      }
    }
    case "listMulti": {
      return filterValue.map((valueId) => Number(valueId));
    }
    case "bool": {
      return filterValue === "true";
    }
    case "list": {
      if (["connectedEmailStatus", "documentStatus"].includes(filter.id)) {
        return filterValue == null ? void 0 : filterValue.map((valueId) => Number(valueId));
      }
      return filterValue;
    }
    default: {
      return filterValue;
    }
  }
};
var getFiltersFromUrl = (filters, filterConfig) => {
  const newListFiltersValue = {};
  Object.keys(filters).forEach((filterKey) => {
    const filter = filterConfig.find((f) => f.id === filterKey);
    if (filter) {
      newListFiltersValue[filterKey] = {
        value: parseValue(filter, filters[filterKey]),
        type: filter.type,
        name: filter.name,
        module: filter.relatedModule,
        additionalData: filter.additionalData
      };
    }
  });
  return newListFiltersValue;
};
var updateQueryParams = (params) => {
  const url = new URL(document.location.pathname, document.location.origin);
  Object.entries(params).forEach((param) => {
    url.searchParams.set(param[0], param[1]);
  });
  window.history.replaceState({}, "", url);
};
var useQueryParams = ({
  currentPage,
  currentPerPage,
  listFiltersConfig,
  filters,
  orderName,
  orderType,
  setOrder,
  setFilters,
  handleSetPageNumber,
  handlePageSizeChange
}) => {
  const [queryParamsState, send] = (0, import_react307.useMachine)(queryParamsMachine, {
    context: {
      currentPage,
      currentPerPage,
      orderName: orderName ?? null,
      orderType: orderType ?? null,
      filterConfig: listFiltersConfig,
      setFilters,
      setPage: handleSetPageNumber,
      setPerPage: handlePageSizeChange,
      setOrder
    }
  });
  (0, import_use_deep_compare_effect4.useDeepCompareEffectNoCheck)(() => {
    send({
      type: "SET_URL_FILTERS",
      filters,
      page: currentPage,
      perPage: currentPerPage,
      orderName,
      orderType
    });
  }, [filters, currentPage, currentPerPage, orderName, orderType]);
  const setIsReady = () => {
    send({
      type: "SET_IS_READY"
    });
  };
  return {
    setIsReady
  };
};
var useQueryParams_default = useQueryParams;

// src/components/ListFilters/ListFilters.tsx
var import_react318 = require("@chakra-ui/react");
var import_react319 = __toESM(require("react"));
var import_orderBy4 = __toESM(require("lodash/orderBy"));
var import_indexOf = __toESM(require("lodash/indexOf"));

// src/components/FilterFields/UserUserFilter/UserUserFilter.tsx
var import_react308 = require("@chakra-ui/react");
var import_react309 = require("react");
var import_react_query34 = require("react-query");
var import_jsx_runtime = require("react/jsx-runtime");
var useSelectedOptionsFetcher3 = ({
  value,
  isUserUser
}) => {
  const { t } = useAuraTranslation_default();
  let meOption = [];
  if (isUserUser && (value == null ? void 0 : value.some((id) => id === 0 || id === "0"))) {
    meOption = [{ label: t("ME"), value: 0 }];
  }
  return (0, import_react_query34.useQuery)(
    ["user_users", value, "fullName"],
    () => api_default.getAutoselect("user_users", {
      params: {
        "filter[id][in]": value,
        fields: "fullName,isDeleted",
        extra_fields: "fullName",
        "page[limit]": -1,
        "setting[with_deleted]": 1,
        "order[firstName]": "ASC",
        "order[lastName]": "ASC"
      }
    }),
    {
      select: (response) => {
        var _a2;
        const dataToReturn = ((_a2 = response == null ? void 0 : response.data) == null ? void 0 : _a2.map((obj) => ({
          label: t(obj["fullName"]),
          value: obj.id,
          isDeleted: obj.isDeleted
        }))) ?? [];
        return (value == null ? void 0 : value.length) > 0 ? [...dataToReturn, ...meOption] : [];
      },
      enabled: (value == null ? void 0 : value.length) > 0,
      retry: false,
      refetchOnWindowFocus: false
    }
  );
};
var UserUserFilter = ({
  filterName,
  name,
  onChange,
  value,
  selectProps,
  ...props
}) => {
  const { t } = useAuraTranslation_default();
  const { isUserUser } = (0, import_react309.useContext)(AuthContext);
  const [isInitialFetching, setIsInitialFetching] = (0, import_react309.useState)(!!value);
  const [tempValue, setTempValue] = (0, import_react309.useState)([]);
  const [withDeleted, setWithDeleted] = (0, import_react309.useState)(false);
  const handleSetValue = (value2) => {
    let parsedValue = [];
    if (Array.isArray(value2)) {
      parsedValue = value2;
    } else {
      parsedValue = value2 ? [value2] : [];
    }
    setTempValue(parsedValue);
    const filterValue = (parsedValue == null ? void 0 : parsedValue.map((v) => v.value)) ?? [];
    onChange == null ? void 0 : onChange(filterName, filterValue);
  };
  const { data: selectedOptions, isFetching } = useSelectedOptionsFetcher3({
    value,
    isUserUser
  });
  const { data: options } = useMinimalAutoselect_default({
    endpoint: "user_users",
    labelField: "fullName",
    valueField: "id",
    extraFields: ["fullName"],
    fields: ["avatar", "defaultCallendarColor", "isDeleted"],
    settings: {
      "setting[with_deleted]": 1,
      "order[firstName]": "ASC",
      "order[lastName]": "ASC"
    },
    additionalOptionField: [
      { field: "avatar", source: "avatar" },
      { field: "label", source: "fullName" },
      { field: "value", source: "id" },
      { field: "defaultCallendarColor", source: "defaultCallendarColor" },
      { field: "isDeleted", source: "isDeleted" }
    ]
  });
  if (isInitialFetching && isFetching && !selectedOptions) {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraFormLabel_default, {
          htmlFor: `input-${filterName}`,
          children: name
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSelect_default, {
          isLoading: true,
          isReadOnly: true
        })
      ]
    });
  }
  if (isInitialFetching) {
    setIsInitialFetching(false);
  }
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react308.FormControl, {
    ...props,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react308.Box, {
        display: "flex",
        justifyContent: "space-between",
        flexDirection: "row",
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraFormLabel_default, {
            htmlFor: `input-${filterName}`,
            children: name
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react308.Stack, {
            mb: 2,
            isInline: true,
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react308.FormLabel, {
                htmlFor: "user-filter-with-deleted",
                m: "0",
                fontWeight: 400,
                children: t("WITH_DELETED")
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react308.Switch, {
                size: "sm",
                id: "user-filter-with-deleted",
                alignSelf: "center",
                isChecked: withDeleted,
                onChange: () => setWithDeleted(!withDeleted)
              })
            ]
          })
        ]
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSelect_default, {
        options,
        value: isFetching ? tempValue : selectedOptions ?? [],
        onChange: (value2) => handleSetValue(value2),
        withCheckbox: true,
        isMulti: true,
        isLoading: isFetching,
        loadingMessage: () => t("LOADING"),
        noOptionsMessage: () => t("NOTHING_FOUND"),
        optionMeEnabled: isUserUser,
        withDeleted
      })
    ]
  });
};
var UserUserFilter_default = UserUserFilter;

// src/components/FilterFields/CompanyFilter.tsx
var import_react310 = require("@chakra-ui/react");
var import_react311 = require("react");
var import_react_query35 = require("react-query");
var import_debounce10 = __toESM(require("lodash/debounce"));
var import_jsx_runtime = require("react/jsx-runtime");
var CompanyFilter = ({
  name,
  filterName,
  value,
  onChange,
  selectProps,
  loadDataProps: loadDataProps2,
  ...props
}) => {
  const { t } = useAuraTranslation_default();
  const [isTypeText, setIsTypeText] = (0, import_react311.useState)(typeof value === "string");
  const [isInitialFetching, setIsInitialFetching] = (0, import_react311.useState)(!!value);
  const [tempValue, setTempValue] = (0, import_react311.useState)([]);
  const [filterValue, setFilterValue] = (0, import_react311.useState)("");
  const isSingleSelector = (0, import_react311.useMemo)(
    () => (selectProps == null ? void 0 : selectProps.isMulti) === false,
    [selectProps]
  );
  const handleSetValue = (value2) => {
    let parsedValue = [];
    if (Array.isArray(value2)) {
      parsedValue = value2;
    } else {
      parsedValue = value2 ? [value2] : [];
    }
    setTempValue(parsedValue);
    const filterValue2 = (parsedValue == null ? void 0 : parsedValue.map((v) => v.value)) ?? [];
    onChange == null ? void 0 : onChange(filterName, filterValue2);
  };
  const handleSetTextValue = (e) => {
    setFilterValue(e.target.value);
  };
  const handleOnChange = (value2) => {
    onChange(filterName, value2);
  };
  const debouncedHandleOnChange = (0, import_react311.useCallback)(
    (0, import_debounce10.default)(handleOnChange, 650),
    []
  );
  (0, import_react311.useEffect)(() => {
    if (value && typeof value === "string") {
      setFilterValue(value);
    } else {
      setFilterValue("");
    }
  }, [value]);
  const { data: selectedOptions, isFetching } = (0, import_react_query35.useQuery)(
    ["account_companies", value, "displayName"],
    () => api_default.getAutoselect("account_companies", {
      params: {
        "filter[id][in]": value,
        fields: "displayName",
        extra_fields: "displayName",
        "page[limit]": -1
      }
    }),
    {
      select: (response) => {
        var _a2;
        const dataToReturn = ((_a2 = response == null ? void 0 : response.data) == null ? void 0 : _a2.map((obj) => ({
          label: obj["displayName"],
          value: obj.id
        }))) ?? [];
        return (value == null ? void 0 : value.length) > 0 ? dataToReturn : [];
      },
      enabled: (value == null ? void 0 : value.length) > 0 && Array.isArray(value) && !isTypeText,
      retry: false,
      refetchOnWindowFocus: false
    }
  );
  if (isInitialFetching && isFetching && !selectedOptions) {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraFormLabel_default, {
          htmlFor: `input-${filterName}`,
          children: name
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSelect_default, {
          isLoading: true,
          isReadOnly: true
        })
      ]
    });
  }
  if (isInitialFetching) {
    setIsInitialFetching(false);
  }
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react310.FormControl, {
    ...props,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react310.Box, {
        display: "flex",
        justifyContent: "space-between",
        flexDirection: "row",
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraFormLabel_default, {
            htmlFor: `input-${filterName}`,
            children: name
          }),
          !isSingleSelector && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react310.Stack, {
            mb: 2,
            isInline: true,
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react310.FormLabel, {
                htmlFor: "company-filter-text-active",
                m: "0",
                fontWeight: 400,
                children: t("text")
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react310.Switch, {
                size: "sm",
                id: "company-filter-text-active",
                alignSelf: "center",
                isChecked: isTypeText,
                onChange: () => setIsTypeText(!isTypeText)
              })
            ]
          })
        ]
      }),
      !isSingleSelector && isTypeText ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FilterTextInput_default, {
        id: `input-${filterName}`,
        value: filterValue,
        onChange: handleSetTextValue,
        onKeyUp: (e) => debouncedHandleOnChange(e.target.value),
        onBlur: (e) => handleOnChange(e.target.value)
      }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSelect_default, {
        inputId: `input-${filterName}`,
        value: isFetching ? tempValue : selectedOptions ?? [],
        onChange: (value2) => handleSetValue(value2),
        isMulti: true,
        loadDataProps: {
          endpoint: "account_companies",
          labelField: "displayName",
          settings: {
            extra_fields: "displayName",
            "order[_q]": "DESC",
            ...(loadDataProps2 == null ? void 0 : loadDataProps2.settings) ?? {}
          }
        },
        isLoading: isFetching,
        ...selectProps ? selectProps : {}
      })
    ]
  });
};
var CompanyFilter_default = CompanyFilter;

// src/components/FilterFields/ProductFilter.tsx
var import_react312 = require("@chakra-ui/react");
var import_react313 = require("react");
var import_react_query36 = require("react-query");
var import_debounce11 = __toESM(require("lodash/debounce"));
var import_jsx_runtime = require("react/jsx-runtime");
var ProductFilter = ({
  name,
  filterName,
  value,
  onChange,
  selectProps,
  loadDataProps: loadDataProps2,
  ...props
}) => {
  const { t } = useAuraTranslation_default();
  const [isTypeText, setIsTypeText] = (0, import_react313.useState)(typeof value === "string");
  const [isInitialFetching, setIsInitialFetching] = (0, import_react313.useState)(!!value);
  const [tempValue, setTempValue] = (0, import_react313.useState)([]);
  const [filterValue, setFilterValue] = (0, import_react313.useState)("");
  const isSingleSelector = (0, import_react313.useMemo)(
    () => (selectProps == null ? void 0 : selectProps.isMulti) === false,
    [selectProps]
  );
  const handleSetValue = (value2) => {
    let parsedValue = [];
    if (Array.isArray(value2)) {
      parsedValue = value2;
    } else {
      parsedValue = value2 ? [value2] : [];
    }
    setTempValue(parsedValue);
    const filterValue2 = (parsedValue == null ? void 0 : parsedValue.map((v) => v.value)) ?? [];
    onChange == null ? void 0 : onChange(filterName, filterValue2);
  };
  const handleSetTextValue = (e) => {
    setFilterValue(e.target.value);
  };
  const handleOnChange = (value2) => {
    onChange(filterName, value2);
  };
  const debouncedHandleOnChange = (0, import_react313.useCallback)(
    (0, import_debounce11.default)(handleOnChange, 650),
    []
  );
  (0, import_react313.useEffect)(() => {
    if (value && typeof value === "string") {
      setFilterValue(value);
    } else {
      setFilterValue("");
    }
  }, [value]);
  const { data: selectedOptions, isFetching } = (0, import_react_query36.useQuery)(
    ["products", value, "name"],
    () => api_default.getAutoselect("products", {
      params: {
        "filter[id][in]": value,
        fields: "name",
        "page[limit]": -1
      }
    }),
    {
      select: (response) => {
        var _a2;
        const dataToReturn = ((_a2 = response == null ? void 0 : response.data) == null ? void 0 : _a2.map((obj) => ({
          label: obj["name"],
          value: obj.id
        }))) ?? [];
        return (value == null ? void 0 : value.length) > 0 ? dataToReturn : [];
      },
      enabled: (value == null ? void 0 : value.length) > 0 && Array.isArray(value) && !isTypeText,
      retry: false,
      refetchOnWindowFocus: false
    }
  );
  if (isInitialFetching && isFetching && !selectedOptions) {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraFormLabel_default, {
          htmlFor: `input-${filterName}`,
          children: name
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSelect_default, {
          isLoading: true,
          isReadOnly: true
        })
      ]
    });
  }
  if (isInitialFetching) {
    setIsInitialFetching(false);
  }
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react312.FormControl, {
    ...props,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react312.Box, {
        display: "flex",
        justifyContent: "space-between",
        flexDirection: "row",
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraFormLabel_default, {
            htmlFor: `input-${filterName}`,
            children: name
          }),
          !isSingleSelector && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react312.Stack, {
            mb: 2,
            isInline: true,
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react312.FormLabel, {
                htmlFor: "product-filter-text-active",
                m: "0",
                fontWeight: 400,
                children: t("text")
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react312.Switch, {
                size: "sm",
                id: "product-filter-text-active",
                alignSelf: "center",
                isChecked: isTypeText,
                onChange: () => setIsTypeText(!isTypeText)
              })
            ]
          })
        ]
      }),
      !isSingleSelector && isTypeText ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FilterTextInput_default, {
        id: `input-${filterName}`,
        value: filterValue,
        onChange: handleSetTextValue,
        onKeyUp: (e) => debouncedHandleOnChange(e.target.value),
        onBlur: (e) => handleOnChange(e.target.value)
      }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSelect_default, {
        inputId: `input-${filterName}`,
        value: isFetching ? tempValue : selectedOptions ?? [],
        onChange: (value2) => handleSetValue(value2),
        isMulti: true,
        loadDataProps: {
          endpoint: "products",
          labelField: "name",
          settings: {
            "order[_q]": "DESC",
            ...(loadDataProps2 == null ? void 0 : loadDataProps2.settings) ?? {}
          }
        },
        isLoading: isFetching,
        ...selectProps ? selectProps : {}
      })
    ]
  });
};
var ProductFilter_default = ProductFilter;

// src/components/FilterFields/ServicedProductFilter.tsx
var import_react314 = require("@chakra-ui/react");
var import_react315 = require("react");
var import_react_query37 = require("react-query");
var import_debounce12 = __toESM(require("lodash/debounce"));
var import_jsx_runtime = require("react/jsx-runtime");
var ServicedProductFilter = ({
  name,
  filterName,
  value,
  onChange,
  selectProps,
  loadDataProps: loadDataProps2,
  ...props
}) => {
  const { t } = useAuraTranslation_default();
  const [isTypeText, setIsTypeText] = (0, import_react315.useState)(typeof value === "string");
  const [isInitialFetching, setIsInitialFetching] = (0, import_react315.useState)(!!value);
  const [tempValue, setTempValue] = (0, import_react315.useState)([]);
  const [filterValue, setFilterValue] = (0, import_react315.useState)("");
  const isSingleSelector = (0, import_react315.useMemo)(
    () => (selectProps == null ? void 0 : selectProps.isMulti) === false,
    [selectProps]
  );
  const handleSetValue = (value2) => {
    let parsedValue = [];
    if (Array.isArray(value2)) {
      parsedValue = value2;
    } else {
      parsedValue = value2 ? [value2] : [];
    }
    setTempValue(parsedValue);
    const filterValue2 = (parsedValue == null ? void 0 : parsedValue.map((v) => v.value)) ?? [];
    onChange == null ? void 0 : onChange(filterName, filterValue2);
  };
  const handleSetTextValue = (e) => {
    setFilterValue(e.target.value);
  };
  const handleOnChange = (value2) => {
    onChange(filterName, value2);
  };
  const debouncedHandleOnChange = (0, import_react315.useCallback)(
    (0, import_debounce12.default)(handleOnChange, 650),
    []
  );
  (0, import_react315.useEffect)(() => {
    if (value && typeof value === "string") {
      setFilterValue(value);
    } else {
      setFilterValue("");
    }
  }, [value]);
  const { data: selectedOptions, isFetching } = (0, import_react_query37.useQuery)(
    ["serviced_products", value, "fullName"],
    () => api_default.getAutoselect("serviced_products", {
      params: {
        "filter[id][in]": value,
        extra_fields: "fullName",
        "page[limit]": -1
      }
    }),
    {
      select: (response) => {
        var _a2;
        const dataToReturn = ((_a2 = response == null ? void 0 : response.data) == null ? void 0 : _a2.map((obj) => ({
          label: obj["fullName"],
          value: obj.id
        }))) ?? [];
        return (value == null ? void 0 : value.length) > 0 ? dataToReturn : [];
      },
      enabled: (value == null ? void 0 : value.length) > 0 && Array.isArray(value) && !isTypeText,
      retry: false,
      refetchOnWindowFocus: false
    }
  );
  if (isInitialFetching && isFetching && !selectedOptions) {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraFormLabel_default, {
          htmlFor: `input-${filterName}`,
          children: name
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSelect_default, {
          isLoading: true,
          isReadOnly: true
        })
      ]
    });
  }
  if (isInitialFetching) {
    setIsInitialFetching(false);
  }
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react314.FormControl, {
    ...props,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react314.Box, {
        display: "flex",
        justifyContent: "space-between",
        flexDirection: "row",
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraFormLabel_default, {
            htmlFor: `input-${filterName}`,
            children: name
          }),
          !isSingleSelector && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react314.Stack, {
            mb: 2,
            isInline: true,
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react314.FormLabel, {
                htmlFor: "serviced-product-filter-text-active",
                m: "0",
                fontWeight: 400,
                children: t("text")
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react314.Switch, {
                size: "sm",
                id: "serviced-product-filter-text-active",
                alignSelf: "center",
                isChecked: isTypeText,
                onChange: () => setIsTypeText(!isTypeText)
              })
            ]
          })
        ]
      }),
      !isSingleSelector && isTypeText ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FilterTextInput_default, {
        id: `input-${filterName}`,
        value: filterValue,
        onChange: handleSetTextValue,
        onKeyUp: (e) => debouncedHandleOnChange(e.target.value),
        onBlur: (e) => handleOnChange(e.target.value)
      }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSelect_default, {
        inputId: `input-${filterName}`,
        value: isFetching ? tempValue : selectedOptions ?? [],
        onChange: (value2) => handleSetValue(value2),
        isMulti: true,
        loadDataProps: {
          endpoint: "serviced_products",
          labelField: "fullName",
          settings: {
            "order[_q]": "DESC",
            extra_fields: "fullName",
            ...(loadDataProps2 == null ? void 0 : loadDataProps2.settings) ?? {}
          }
        },
        isLoading: isFetching,
        ...selectProps ? selectProps : {}
      })
    ]
  });
};
var ServicedProductFilter_default = ServicedProductFilter;

// src/components/FilterFields/UserProfileFilter.tsx
var import_react316 = require("@chakra-ui/react");
var import_react317 = require("react");
var import_react_query38 = require("react-query");
var import_jsx_runtime = require("react/jsx-runtime");
var useSelectedOptionsFetcher4 = ({
  value
}) => {
  const { t } = useAuraTranslation_default();
  return (0, import_react_query38.useQuery)(
    ["user_profiles", value],
    () => api_default.getAutoselect("user_profiles", {
      params: {
        "filter[userProfileId][in]": value,
        fields: "profileName,userProfileId",
        "page[limit]": -1,
        "order[profileName]": "ASC"
      }
    }),
    {
      select: (response) => {
        var _a2;
        const dataToReturn = ((_a2 = response == null ? void 0 : response.data) == null ? void 0 : _a2.map((obj) => ({
          label: t(obj["profileName"]),
          value: obj.id
        }))) ?? [];
        return (value == null ? void 0 : value.length) > 0 ? dataToReturn : [];
      },
      enabled: (value == null ? void 0 : value.length) > 0,
      retry: false,
      refetchOnWindowFocus: false
    }
  );
};
var UserProfileFilter = ({
  filterName,
  name,
  onChange,
  value,
  onlyAccountUsers,
  onlyUsers,
  ...props
}) => {
  const { t, tCustom } = useAuraTranslation_default();
  const [isInitialFetching, setIsInitialFetching] = (0, import_react317.useState)(!!value);
  const [tempValue, setTempValue] = (0, import_react317.useState)([]);
  const [withDeleted, setWithDeleted] = (0, import_react317.useState)(false);
  const handleSetValue = (value2) => {
    let parsedValue = [];
    if (Array.isArray(value2)) {
      parsedValue = value2;
    } else {
      parsedValue = value2 ? [value2] : [];
    }
    setTempValue(parsedValue);
    const filterValue = (parsedValue == null ? void 0 : parsedValue.map((v) => v.value)) ?? [];
    onChange == null ? void 0 : onChange(filterName, filterValue);
  };
  const { data: selectedOptions, isFetching } = useSelectedOptionsFetcher4({
    value
  });
  const { data: options } = useMinimalAutoselect_default({
    endpoint: "user_profiles",
    labelField: "profileName",
    valueField: "userProfileId",
    settings: {
      "order[profileName]": "ASC",
      ...onlyUsers && { "filter[userType][eq]": 1 },
      ...onlyAccountUsers && { "filter[userType][eq]": 2 }
    },
    additionalOptionField: [
      { field: "label", source: "profileName" },
      { field: "value", source: "userProfileId" }
    ]
  });
  const preparedOptions = (0, import_react317.useMemo)(() => {
    return options == null ? void 0 : options.map((option) => ({
      ...option,
      label: tCustom(option.label)
    }));
  }, [options]);
  if (isInitialFetching && isFetching && !selectedOptions) {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraFormLabel_default, {
          htmlFor: `input-${filterName}`,
          children: name
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSelect_default, {
          isLoading: true,
          isReadOnly: true
        })
      ]
    });
  }
  if (isInitialFetching) {
    setIsInitialFetching(false);
  }
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react316.FormControl, {
    ...props,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react316.Box, {
        display: "flex",
        justifyContent: "space-between",
        flexDirection: "row",
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraFormLabel_default, {
          htmlFor: `input-${filterName}`,
          children: name
        })
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSelect_default, {
        options: preparedOptions,
        value: isFetching ? tempValue : selectedOptions ?? [],
        onChange: (value2) => handleSetValue(value2),
        withCheckbox: true,
        isMulti: true,
        isLoading: isFetching,
        loadingMessage: () => t("LOADING"),
        noOptionsMessage: () => t("NOTHING_FOUND")
      })
    ]
  });
};
var UserProfileFilter_default = UserProfileFilter;

// src/components/ListFilters/ListFilters.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var getCustomSelectProps = (additionalProps) => {
  if (!additionalProps || typeof additionalProps !== "object") {
    return {};
  }
  const selectProps = {};
  for (const paramKey in additionalProps) {
    if (paramKey === "isMulti") {
      selectProps.isMulti = additionalProps[paramKey];
    }
  }
  return selectProps;
};
var getComponentForRelations = (filter) => {
  var _a2, _b, _c, _d, _e;
  switch (filter.relatedModule) {
    case "paymentType":
      return {
        component: MultiFilter_default,
        additionalProps: {
          endpoint: "payment_types",
          labelField: "name",
          translateCustom: true
        }
      };
    case "deliveryType":
      return {
        component: MultiFilter_default,
        additionalProps: {
          endpoint: "delivery_types",
          labelField: "name",
          translateCustom: true
        }
      };
    case "documentSeriesDefinition":
      return {
        component: MultiFilter_default,
        additionalProps: {
          endpoint: "document_series_definitions",
          labelField: "name",
          ...((_a2 = filter == null ? void 0 : filter.additionalData) == null ? void 0 : _a2.filter) && {
            filters: filter.additionalData.filter
          },
          translateCustom: true
        }
      };
    case "accountUser":
      return {
        component: AccountUserFilter_default
      };
    case "userUser":
      return {
        component: UserUserFilter_default
      };
    case "userProfile":
      return {
        component: UserProfileFilter_default,
        additionalProps: {
          ...((_b = filter == null ? void 0 : filter.additionalData) == null ? void 0 : _b.additionalProps) ?? {}
        }
      };
    case "priceProductGroup":
      return {
        component: MultiFilter_default,
        additionalProps: {
          endpoint: "price_product_groups",
          labelField: "name",
          translateCustom: true
        }
      };
    case "externalMarker":
      return {
        component: ExternalMarkerFilter_default
      };
    case "campaignPhase":
      return {
        component: MultiFilter_default,
        additionalProps: {
          endpoint: "campaign_phases",
          labelField: ["name", "campaign.name"],
          labelFieldCreator: (item) => `${item.name} (${item.campaign.name})`,
          settings: {
            "setting[with_relations]": true
          },
          translateCustom: true
        }
      };
    case "accountCompany":
    case "accountCompanies":
      const additionalProps = ((_c = filter == null ? void 0 : filter.additionalData) == null ? void 0 : _c.additionalProps) ?? {};
      return {
        component: CompanyFilter_default,
        additionalProps: {
          loadDataProps: {
            settings: {
              ...(additionalProps == null ? void 0 : additionalProps.loadDataProps) ?? {}
            }
          }
        },
        selectProps: getCustomSelectProps(additionalProps)
      };
    case "places":
      return {
        component: TextFilter_default
      };
    case "campaign":
      return {
        component: MultiFilter_default,
        additionalProps: {
          endpoint: "campaigns",
          labelField: "name",
          translateCustom: true
        }
      };
    case "taskType":
      return {
        component: MultiFilter_default,
        additionalProps: {
          endpoint: "task_types",
          labelField: "typeName",
          translateCustom: true
        }
      };
    case "commissionPhase":
      return {
        component: MultiFilter_default,
        additionalProps: {
          endpoint: "commission_phases",
          labelField: "phaseName",
          translateCustom: true
        }
      };
    case "product":
    case "products":
    case "excludedProducts":
      return {
        component: ProductFilter_default,
        selectProps: getCustomSelectProps(
          ((_d = filter == null ? void 0 : filter.additionalData) == null ? void 0 : _d.additionalProps) ?? {}
        )
      };
    case "measureUnit":
      return {
        component: MultiFilter_default,
        additionalProps: {
          endpoint: "measure_units",
          labelField: ["name"],
          translateCustom: true
        }
      };
    case "productCategories":
      return {
        component: DataSelectorFilter_default,
        additionalProps: {
          loadDataProps: {
            endpoint: "product_categories",
            autoselect: false,
            labelField: "name",
            queryField: "name",
            settings: {
              "order[name]": "ASC"
            }
          }
        }
      };
    case "servicedProducts":
      return {
        component: ServicedProductFilter_default
      };
    case "storehouse":
      return {
        component: MultiFilter_default,
        additionalProps: {
          endpoint: "storehouses",
          labelField: "name",
          ...(_e = filter == null ? void 0 : filter.additionalData) == null ? void 0 : _e.additionalProps
        }
      };
    default:
      if (process.env.NODE_ENV === "development") {
        logger_default.warn(
          `No component for filter of type relation from module ${filter.relatedModule}, field: ${filter.id}`
        );
      }
      return null;
  }
};
var getComponentForFilter = (filter) => {
  var _a2, _b, _c, _d, _e, _f, _g, _h, _i;
  const additionalProps = ((_a2 = filter == null ? void 0 : filter.additionalData) == null ? void 0 : _a2.additionalProps) ?? {};
  const baseTextFilter = {
    component: ((_b = filter == null ? void 0 : filter.additionalData) == null ? void 0 : _b.filterComponent) ?? TextFilter_default,
    additionalProps
  };
  const baseNumericFilter = {
    component: ((_c = filter == null ? void 0 : filter.additionalData) == null ? void 0 : _c.filterComponent) ?? NumericFilter_default,
    additionalProps
  };
  const baseBoolFilter = {
    component: ((_d = filter == null ? void 0 : filter.additionalData) == null ? void 0 : _d.filterComponent) ?? BooleanFilter_default,
    additionalProps
  };
  const baseDatetimeFilter = {
    component: ((_e = filter == null ? void 0 : filter.additionalData) == null ? void 0 : _e.filterComponent) ?? DatetimeFilter_default,
    additionalProps
  };
  const baseListFilter = {
    component: ((_f = filter == null ? void 0 : filter.additionalData) == null ? void 0 : _f.filterComponent) ?? MultiFilter_default,
    additionalProps
  };
  const baseTagFilter = {
    component: ((_g = filter == null ? void 0 : filter.additionalData) == null ? void 0 : _g.filterComponent) ?? TagFilter_default,
    additionalProps
  };
  switch (filter.type) {
    case "custom":
      return {
        component: filter.additionalData.filterComponent,
        additionalProps: {
          ...(_h = filter.additionalData) == null ? void 0 : _h.additionalProps
        }
      };
    case "text":
      return { ...baseTextFilter };
    case "string":
      return { ...baseTextFilter };
    case "email":
      return { ...baseTextFilter };
    case "phone":
      return { ...baseTextFilter };
    case "bigint":
      return { ...baseNumericFilter };
    case "integer":
      return { ...baseNumericFilter };
    case "numeric":
      return { ...baseNumericFilter };
    case "float":
      return { ...baseNumericFilter };
    case "smallint":
      return { ...baseNumericFilter };
    case "decimal":
      return { ...baseNumericFilter };
    case "boolean":
      return { ...baseBoolFilter };
    case "bool":
      return { ...baseBoolFilter };
    case "datetime":
      return { ...baseDatetimeFilter };
    case "datetimetz":
      return { ...baseDatetimeFilter };
    case "date":
      return { ...baseDatetimeFilter, additionalProps: { withTime: false } };
    case "list":
      return {
        ...baseListFilter
      };
    case "listMulti":
      return {
        ...baseListFilter
      };
    case "tags":
      return { ...baseTagFilter };
    case "file":
      return { ...baseTextFilter };
    case "company":
      return {
        component: CompanyFilter_default
      };
    case "accountUser":
      return {
        component: DataSelectorFilter_default,
        additionalProps: {
          loadDataProps: {
            endpoint: "account_users",
            labelField: "fullName",
            settings: { extra_fields: "fullName", "setting[with_deleted]": 1 }
          }
        }
      };
    case "defaultPriceType":
      return {
        component: MultiFilter_default,
        additionalProps: {
          ...(_i = filter.additionalData) == null ? void 0 : _i.additionalProps
        }
      };
    case "relation":
      return getComponentForRelations(filter);
    default:
      if (process.env.NODE_ENV === "development") {
        logger_default.warn(`No component for filter of type ${filter.type}`);
      }
      return null;
  }
};
var skeletonStyle = {
  smallMargin: "10px",
  bigMargin: "24px",
  mediumWidth: "100px",
  checkboxWidth: "24px",
  height: "24px"
};
var labelSkeletonProps = {
  height: skeletonStyle.height,
  width: skeletonStyle.mediumWidth,
  mb: skeletonStyle.smallMargin
};
var checkboxSkeletonProps = {
  height: skeletonStyle.height,
  width: skeletonStyle.checkboxWidth,
  mr: skeletonStyle.bigMargin
};
var inputSkeletonProps = {
  height: skeletonStyle.height,
  mb: skeletonStyle.bigMargin
};
var checkoxLabelSkeletonProps = {
  height: skeletonStyle.height,
  width: skeletonStyle.mediumWidth
};
var ListFiltersSkeleton = () => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react318.Box, {
    "data-testid": "filters-skeleton",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react318.Skeleton, {
        ...labelSkeletonProps
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react318.Skeleton, {
        ...inputSkeletonProps
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react318.Skeleton, {
        ...labelSkeletonProps
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react318.Flex, {
        justifyContent: "space-between",
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react318.Skeleton, {
            width: "45%",
            float: "left",
            ...inputSkeletonProps
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react318.Skeleton, {
            width: "45%",
            float: "left",
            ...inputSkeletonProps
          })
        ]
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react318.Skeleton, {
        ...labelSkeletonProps
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react318.Skeleton, {
        ...inputSkeletonProps
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react318.Skeleton, {
        ...labelSkeletonProps
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react318.Stack, {
        isInline: true,
        mb: skeletonStyle.smallMargin,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react318.Skeleton, {
            ...checkboxSkeletonProps
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react318.Skeleton, {
            ...checkoxLabelSkeletonProps
          })
        ]
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react318.Stack, {
        isInline: true,
        mb: skeletonStyle.smallMargin,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react318.Skeleton, {
            ...checkboxSkeletonProps
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react318.Skeleton, {
            ...checkoxLabelSkeletonProps
          })
        ]
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react318.Stack, {
        isInline: true,
        mb: skeletonStyle.smallMargin,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react318.Skeleton, {
            ...checkboxSkeletonProps
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react318.Skeleton, {
            ...checkoxLabelSkeletonProps
          })
        ]
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react318.Stack, {
        isInline: true,
        mb: skeletonStyle.smallMargin,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react318.Skeleton, {
            ...checkboxSkeletonProps
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react318.Skeleton, {
            ...checkoxLabelSkeletonProps
          })
        ]
      })
    ]
  });
};
var ListFilters = import_react319.default.memo(
  ({
    filters,
    hiddenFilters,
    columnOrdering,
    additionalChildrenFirst
  }) => {
    const { t } = useAuraTranslation_default();
    const { filters: filterValues, addFilter } = (0, import_react319.useContext)(ListFiltersContext);
    if (!filters) {
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ListFiltersSkeleton, {});
    }
    const preparedFiltersToSort = columnOrdering == null ? void 0 : columnOrdering.map((el2) => {
      if (el2.startsWith("attribute."))
        return el2.slice(10);
      return el2;
    });
    return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react318.Stack, {
      spacing: 4,
      className: "list__filters",
      children: [
        additionalChildrenFirst,
        (0, import_orderBy4.default)(
          [
            ...filters.filter(
              (filter) => preparedFiltersToSort == null ? void 0 : preparedFiltersToSort.includes(filter.id)
            )
          ],
          (item) => (0, import_indexOf.default)(preparedFiltersToSort, item.id)
        ).concat([
          ...filters.filter(
            (filter) => !(preparedFiltersToSort == null ? void 0 : preparedFiltersToSort.includes(filter.id))
          )
        ]).map((filter) => {
          var _a2, _b, _c;
          const render = getComponentForFilter(filter);
          if (!(render == null ? void 0 : render.component)) {
            return null;
          }
          if (hiddenFilters == null ? void 0 : hiddenFilters.includes(filter.id)) {
            return null;
          }
          return import_react319.default.createElement(render.component, {
            key: filter.id,
            name: t(filter.name),
            filterName: filter.id,
            value: (_a2 = filterValues[filter.id]) == null ? void 0 : _a2.value,
            positions: (_b = filter.additionalData) == null ? void 0 : _b.positions,
            options: (_c = filter.additionalData) == null ? void 0 : _c.options,
            className: `filter-${filter.id}`,
            relatedModule: filter == null ? void 0 : filter.relatedModule,
            onChange: (name, value) => addFilter(
              name,
              value,
              filter.type,
              filter.relatedModule,
              filter.additionalData
            ),
            ...(render == null ? void 0 : render.additionalProps) ? render == null ? void 0 : render.additionalProps : {},
            ...(render == null ? void 0 : render.selectProps) ? { selectProps: render == null ? void 0 : render.selectProps } : {}
          });
        })
      ]
    });
  }
);
var ListFilters_default = ListFilters;

// src/components/LoadingOverlay/LoadingOverlay.tsx
var import_react320 = require("@chakra-ui/react");
var import_jsx_runtime = require("react/jsx-runtime");
var LoadingOverlay = ({ isLoading }) => {
  if (!isLoading) {
    return null;
  }
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react320.Flex, {
    justifyContent: "center",
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    backgroundColor: "whiteAlpha.600",
    zIndex: 4,
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react320.Box, {
      mt: 10,
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react320.Spinner, {
        position: "sticky",
        top: "150px",
        size: "xl"
      })
    })
  });
};
var LoadingOverlay_default = LoadingOverlay;

// src/components/List/LoadingModal/LoadingModal.tsx
var import_react321 = require("@chakra-ui/react");
var import_jsx_runtime = require("react/jsx-runtime");
var LoadingModal = ({
  handleClose,
  isOpen,
  titleText,
  messageText
}) => {
  const { t } = useAuraTranslation_default();
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(AuraModal, {
    isOpen,
    onClose: () => handleClose(true),
    scrollBehavior: "inside",
    isCentered: true,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalOverlay, {}),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalContent, {
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalBody, {
          p: 6,
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react321.Stack, {
            spacing: 6,
            direction: "column",
            textAlign: "center",
            alignItems: "center",
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react321.Spinner, {}),
              /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react321.Stack, {
                spacing: 2,
                children: [
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react321.Text, {
                    textStyle: "h5",
                    as: "h5",
                    children: t(titleText ?? "PLEASE_WAIT")
                  }),
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react321.Text, {
                    children: t(messageText ?? "LIST_XLSX_EXPORT_LOADING_MESSAGE")
                  })
                ]
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react321.Button, {
                size: "md",
                onClick: () => handleClose(),
                children: t("CANCEL")
              })
            ]
          })
        })
      })
    ]
  });
};
var LoadingModal_default = LoadingModal;

// src/components/Pagination/Pagination.tsx
var import_react322 = require("@chakra-ui/react");
var import_fa4 = require("react-icons/fa");
var import_jsx_runtime = require("react/jsx-runtime");
var Pagination = ({
  page,
  totalPages,
  nextPage,
  previousPage,
  setPage,
  ...props
}) => {
  const { t } = useAuraTranslation_default();
  const baseStyle = {
    size: "sm",
    variant: "ghost"
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react322.Stack, {
    as: "nav",
    role: "navigation",
    className: "pagination",
    isInline: true,
    justifyContent: "flex-end",
    align: "center",
    my: 0,
    ...props,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react322.IconButton, {
        "aria-label": t("PAGINATION_GO_TO_PREV_PAGE"),
        icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_fa4.FaChevronLeft, {}),
        onClick: previousPage,
        color: page > 1 ? "gray.500" : "gray.300",
        ...baseStyle
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react322.NumberInput, {
        backgroundColor: "white",
        value: page,
        h: "40px",
        maxW: "46px",
        min: 1,
        max: totalPages,
        onChange: (value) => setPage(Number(value)),
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react322.NumberInputField, {
          textAlign: "center",
          paddingInline: 0,
          borderRadius: "6px"
        })
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react322.Text, {
        as: "span",
        color: "gray.500",
        children: [
          t("OF"),
          " ",
          totalPages
        ]
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react322.IconButton, {
        "aria-label": t("PAGINATION_GO_TO_NEXT_PAGE"),
        icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_fa4.FaChevronRight, {}),
        onClick: nextPage,
        color: page < totalPages ? "gray.500" : "gray.300",
        ...baseStyle
      })
    ]
  });
};
var ObjectsPerPageSelect = ({
  resultsPerPage,
  setTotalResult,
  paginationValues = [5, 10, 15, 30, 50]
}) => {
  const { t } = useAuraTranslation_default();
  const displayNumbersPerPage = paginationValues.map((number) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)("option", {
    value: number,
    children: number
  }, number));
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react322.HStack, {
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react322.Select, {
        value: resultsPerPage,
        onChange: setTotalResult,
        textColor: "gray.700",
        w: "80px",
        h: "40px",
        borderRadius: "6px",
        border: "1px solid",
        borderColor: "gray.200",
        className: "pagination-box__select",
        children: displayNumbersPerPage
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react322.Text, {
        children: t("LIST_TOTAL_RESULTS")
      })
    ]
  });
};
var Pagination_default = Pagination;

// src/components/PanelHeading/PanelHeading.tsx
var import_react323 = require("@chakra-ui/react");
var import_jsx_runtime = require("react/jsx-runtime");
var PanelHeading = ({ text, ...props }) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react323.Heading, {
    as: "h2",
    size: "md",
    fontWeight: "500",
    mt: "0",
    ...props,
    children: text
  });
};
var PanelHeading_default = PanelHeading;

// src/components/PerPage/PerPage.tsx
var import_react324 = require("@chakra-ui/react");
var import_jsx_runtime = require("react/jsx-runtime");
var PerPage = ({
  value,
  onChange,
  perPageOptions = [20, 40, 100],
  ...props
}) => {
  const { t } = useAuraTranslation_default();
  const handleChange = (e) => {
    onChange(e.target.value);
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react324.Stack, {
    className: "per-page",
    direction: "row",
    alignItems: "center",
    maxW: "100%",
    minW: "0%",
    flex: 1,
    ml: "16px",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react324.Select, {
        backgroundColor: "white",
        width: "auto",
        size: "sm",
        value,
        onChange: handleChange,
        rounded: "6px",
        height: "40px",
        ...props,
        children: perPageOptions.map((opt) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)("option", {
          value: opt,
          children: opt
        }, opt))
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react324.Text, {
        isTruncated: true,
        maxW: "100%",
        as: "span",
        textStyle: "bodyInput",
        children: t("PAGINATION_RESULTS_PER_PAGE")
      })
    ]
  });
};
var PerPage_default = PerPage;

// src/components/SortingIndicator/SortingIndicator.tsx
var import_react325 = require("@chakra-ui/react");
var import_fa5 = require("react-icons/fa");
var import_jsx_runtime = require("react/jsx-runtime");
var SortingIndicator = ({
  isSorted,
  isSortedDesc
}) => {
  if (!isSorted) {
    return null;
  }
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react325.Flex, {
    color: "gray.300",
    children: isSortedDesc ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react325.Box, {
      color: "inherit",
      display: "inline-block",
      as: import_fa5.FaSortAmountDown
    }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react325.Box, {
      color: "inherit",
      display: "inline-block",
      as: import_fa5.FaSortAmountDownAlt
    })
  });
};
var SortingIndicator_default = SortingIndicator;

// src/components/Table/Table.tsx
var import_react326 = require("@chakra-ui/react");
var import_jsx_runtime = require("react/jsx-runtime");
var Table3 = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react326.Box, {
    as: "table",
    w: "full",
    ...props
  });
};
var Table_default = Table3;

// src/components/Table/Tbody.tsx
var import_react327 = require("@chakra-ui/react");
var import_jsx_runtime = require("react/jsx-runtime");
var Tbody3 = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react327.Box, {
    as: "tbody",
    ...props
  });
};
var Tbody_default = Tbody3;

// src/components/Table/Td.tsx
var import_react328 = require("@chakra-ui/react");
var import_jsx_runtime = require("react/jsx-runtime");
var Td3 = ({ children, ...props }) => {
  if (typeof children === "string") {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react328.Box, {
      dangerouslySetInnerHTML: { __html: children },
      p: 1,
      as: "td",
      ...props
    });
  } else {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react328.Box, {
      p: 1,
      as: "td",
      ...props,
      children
    });
  }
};
var Td_default = Td3;

// src/components/Table/Th.tsx
var import_react329 = require("@chakra-ui/react");
var import_jsx_runtime = require("react/jsx-runtime");
var Th2 = ({ children, ...props }) => {
  if (typeof children === "string") {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react329.Box, {
      fontWeight: "inherit",
      color: "gray.600",
      dangerouslySetInnerHTML: { __html: children },
      p: 2,
      as: "th",
      ...props
    });
  } else {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react329.Box, {
      p: 2,
      as: "th",
      ...props,
      children
    });
  }
};
var Th_default = Th2;

// src/components/Table/Thead.tsx
var import_react330 = require("@chakra-ui/react");
var import_jsx_runtime = require("react/jsx-runtime");
var Thead2 = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react330.Box, {
    as: "thead",
    ...props
  });
};
var Thead_default = Thead2;

// src/components/Table/Tr.tsx
var import_react331 = require("@chakra-ui/react");
var import_jsx_runtime = require("react/jsx-runtime");
var Tr3 = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react331.Box, {
    as: "tr",
    ...props
  });
};
var Tr_default = Tr3;

// src/components/List/CustomizeColumns/CustomizeColumns.tsx
var import_react332 = require("@chakra-ui/react");
var import_union = __toESM(require("lodash/union"));
var import_react_beautiful_dnd = require("react-beautiful-dnd");
var import_fa6 = require("react-icons/fa");
var import_sort_array = __toESM(require("sort-array"));
var import_jsx_runtime = require("react/jsx-runtime");
var getItemStyle = (isDragging, draggableStyle) => ({
  userSelect: "none",
  ...draggableStyle
});
var getListStyle = (isDraggingOver) => ({
  marginTop: 0
});
var reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
};
var baseStyleCheckboxHeader = {
  "span:nth-child(2)": {
    border: "#E2E8F0",
    backgroundColor: "#ffffff"
  }
};
var getColumnId = (column) => {
  if (column.fieldType === "attribute") {
    return column.id.slice(10);
  }
  return column.id;
};
var CustomizeColumns = ({
  allColumns,
  checkedColumns,
  handleCheckColumn,
  handleCheckAllColumns,
  columnsOrdering,
  setColumnOrdering,
  onBeforeDragStartCallback,
  onDragEndCallback,
  checkedFilters,
  handleCheckFilter,
  handleCheckAllFilters,
  countFilters,
  invisibleCheckboxFilter = [],
  mobileVisibleColumns = [],
  isMobileTileViewEnabled
}) => {
  const { t } = useAuraTranslation_default();
  const isSm = (0, import_react332.useBreakpointValue)({
    base: true,
    md: false
  });
  const allColumnsIds = allColumns.map((col) => col.id);
  const isChecked = checkedColumns.length === allColumnsIds.length;
  const isCheckedAllFilters = checkedFilters.length === countFilters;
  const indeterminate = checkedColumns.length > 0 ? allColumnsIds.length - checkedColumns.length : false;
  const colsOrdering = columnsOrdering.length > 0 ? (0, import_union.default)(columnsOrdering, allColumnsIds) : allColumnsIds;
  const onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }
    const items = reorder(
      colsOrdering.filter((col) => allColumnsIds.includes(col)),
      result.source.index,
      result.destination.index
    );
    setColumnOrdering(items);
    onDragEndCallback == null ? void 0 : onDragEndCallback();
  };
  const sortedColumns = (0, import_sort_array.default)(allColumns, {
    by: "id",
    order: "id",
    customOrders: { id: colsOrdering }
  });
  const isMobileVisibleColumn = (columnId) => isMobileTileViewEnabled && isSm && mobileVisibleColumns.includes(columnId);
  const isVisibleCheckboxFilter = (columnId) => !["execute", ...invisibleCheckboxFilter].includes(columnId);
  const isCheckedFilter = (column) => {
    const test = !!checkedFilters.find(
      (col) => col === getColumnId(column)
    );
    return test;
  };
  const handleCheckSingleFilter = (column) => {
    handleCheckFilter(getColumnId(column));
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react332.Stack, {
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react332.Stack, {
        id: "customize-columns",
        direction: "row",
        backgroundColor: "gray.200",
        px: 4,
        py: 2,
        roundedTop: "4",
        border: 1,
        borderStyle: "solid",
        borderColor: "gray.200",
        justifyContent: "space-between",
        pr: "48px",
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react332.Checkbox, {
            id: "customize-columns-all-columns",
            isChecked,
            isIndeterminate: !!indeterminate,
            onChange: handleCheckAllColumns,
            sx: !isChecked && baseStyleCheckboxHeader,
            children: t("KANBAN_CONFIG_COLUMNS")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react332.HStack, {
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react332.Text, {
                mb: "0",
                children: [
                  " ",
                  t("LIST_FILTERS")
                ]
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react332.Checkbox, {
                id: "customize-columns-all-filters",
                isChecked: isCheckedAllFilters,
                isIndeterminate: !!indeterminate,
                onChange: handleCheckAllFilters,
                sx: !isCheckedAllFilters && baseStyleCheckboxHeader
              })
            ]
          })
        ]
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_beautiful_dnd.DragDropContext, {
        onDragEnd,
        onBeforeDragStart: onBeforeDragStartCallback,
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_beautiful_dnd.Droppable, {
          droppableId: "droppable",
          children: (provided, snapshot) => /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("div", {
            ...provided.droppableProps,
            ref: provided.innerRef,
            style: getListStyle(snapshot.isDraggingOver),
            children: [
              sortedColumns.map((column, index) => {
                return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_beautiful_dnd.Draggable, {
                  draggableId: column.id,
                  index,
                  children: (provided2, snapshot2) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", {
                    ref: provided2.innerRef,
                    ...provided2.draggableProps,
                    style: getItemStyle(
                      snapshot2.isDragging,
                      provided2.draggableProps.style
                    ),
                    children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react332.Stack, {
                      className: "list__column-item",
                      direction: "row",
                      px: 4,
                      py: 2,
                      borderBottom: 1,
                      borderRight: 1,
                      borderLeft: 1,
                      borderStyle: "solid",
                      borderColor: "gray.200",
                      bg: "white",
                      alignItems: "center",
                      minH: "48px",
                      children: [
                        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react332.Checkbox, {
                          flex: 1,
                          id: column.id,
                          name: column.id,
                          isDisabled: isMobileVisibleColumn(column.id),
                          isTruncated: true,
                          isChecked: isMobileVisibleColumn(column.id) ? true : !!checkedColumns.find(
                            (col) => col === column.id
                          ),
                          onChange: () => handleCheckColumn(column.id),
                          children: column.fieldType === "attribute" ? t((column == null ? void 0 : column.fieldName) ?? "") : t(
                            (column == null ? void 0 : column.customNameInConfigModal) ?? `LIST_COLUMN_${column.id}`
                          )
                        }),
                        /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react332.HStack, {
                          spacing: "12px",
                          children: [
                            isVisibleCheckboxFilter(column.id) && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react332.Checkbox, {
                              "data-testid": `checkbox-filter-${column.id}`,
                              flex: 1,
                              id: column.id,
                              name: column.id,
                              isChecked: isCheckedFilter(column),
                              onChange: () => handleCheckSingleFilter(column)
                            }),
                            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react332.Box, {
                              w: "20px",
                              ...provided2.dragHandleProps,
                              children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react332.Box, {
                                as: import_fa6.FaGripLines
                              })
                            })
                          ]
                        })
                      ]
                    }, column.id)
                  })
                }, column.id);
              }),
              provided.placeholder
            ]
          })
        })
      })
    ]
  });
};
var CustomizeColumns_default = CustomizeColumns;

// src/components/List/CustomizeColumnsModal/CustomizeColumnsModal.tsx
var import_react333 = require("@chakra-ui/react");
var import_jsx_runtime = require("react/jsx-runtime");
var CustomizeColumnsModal = ({
  handleSave,
  closeOnOverlayClick,
  isOpen,
  onOpen,
  onClose,
  children,
  ...props
}) => {
  const { t } = useAuraTranslation_default();
  const handleSaveClick = () => {
    handleSave == null ? void 0 : handleSave();
    onClose();
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(AuraModal, {
    id: "customize-columns-modal",
    isOpen,
    onClose,
    closeOnOverlayClick,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalOverlay, {}),
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(AuraModalContent, {
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalHeader, {
            id: "customize-columns-modal-header",
            position: "relative",
            showBorders: true,
            children: t("Settings")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalBody, {
            id: "customize-columns-modal-body",
            overflowY: "scroll",
            children
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalFooter, {
            id: "customize-columns-modal-footer",
            children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react333.ButtonGroup, {
              children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react333.Button, {
                textTransform: "capitalize",
                colorScheme: "blue",
                onClick: handleSaveClick,
                children: t("SAVE")
              })
            })
          })
        ]
      })
    ]
  });
};
var CustomizeColumnsModal_default = CustomizeColumnsModal;

// src/components/List/EmptyList/EmptyList.tsx
var import_react334 = require("@chakra-ui/react");
var import_js51 = require("@mdi/js");
var import_react335 = __toESM(require("@mdi/react"));
var import_jsx_runtime = require("react/jsx-runtime");
var EmptyList = ({
  isLoading = false,
  showHeader = false,
  description = "LIST_EMPTY_DESCRIPTION"
}) => {
  const { t } = useAuraTranslation_default();
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react334.Stack, {
    spacing: 0,
    maxH: "500px",
    ...showHeader ? {
      rounded: 4,
      border: 1,
      borderStyle: "solid",
      borderColor: "gray.200"
    } : {},
    children: [
      showHeader && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react334.Box, {
        className: "list-empty-heading",
        bg: "gray.50",
        h: 10
      }),
      isLoading ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react334.Flex, {
        alignItems: "center",
        justifyContent: "center",
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react334.Box, {
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react334.Spinner, {
            size: "xl"
          })
        })
      }) : /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react334.Stack, {
        className: "list-empty-content",
        bg: "white",
        flex: 1,
        alignItems: "center",
        justifyContent: "center",
        spacing: 4,
        color: "gray.300",
        py: 20,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react335.default, {
            path: import_js51.mdiTextBoxSearchOutline,
            size: "80px"
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react334.VStack, {
            flex: 1,
            spacing: 3,
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react334.Heading, {
                fontWeight: "500",
                lineHeight: "32px",
                letterSpacing: "basic",
                fontSize: "lg",
                color: "gray.500",
                children: t("LIST_EMPTY_HEADING")
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react334.Text, {
                fontStyle: "bodyInput",
                fontWeight: 400,
                color: "gray.400",
                textAlign: "center",
                children: t(description)
              })
            ]
          })
        ]
      })
    ]
  });
};
var EmptyList_default = EmptyList;

// src/components/List/ProfileSaveConfigModal/ProfileSaveConfigModal.tsx
var import_react336 = require("@chakra-ui/react");
var import_react337 = require("react");
var import_jsx_runtime = require("react/jsx-runtime");
var ProfileSaveConfigModal = ({
  isOpen,
  onClose,
  saveSettingsForProfile
}) => {
  var _a2;
  const { t, tCustom } = useAuraTranslation_default();
  const { data, isLoading } = useUserProfiles_default(isOpen);
  const [selectedProfileId, setSelectedProfileId] = (0, import_react337.useState)(void 0);
  (0, import_react337.useEffect)(() => {
    var _a3, _b;
    setSelectedProfileId((_b = (_a3 = data == null ? void 0 : data.data) == null ? void 0 : _a3[0]) == null ? void 0 : _b.id);
  }, [data]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(AuraModal, {
    isOpen,
    onClose,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalOverlay, {}),
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(AuraModalContent, {
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalHeader, {
            children: t("LIST_SETTINGS_SAVE_FOR_PROFILE")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalBody, {
            children: isLoading ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSpinner_default, {}) : /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react336.FormControl, {
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react336.FormLabel, {
                  fontStyle: "bodyInput",
                  letterSpacing: "mediumWide",
                  children: t("LIST_CONFIG_SAVE_FOR_PROFILE_LABEL")
                }),
                /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react336.Select, {
                  onChange: (e) => setSelectedProfileId(Number(e.target.value)),
                  children: [
                    /* @__PURE__ */ (0, import_jsx_runtime.jsx)("option", {
                      disabled: true,
                      hidden: true
                    }),
                    (_a2 = data == null ? void 0 : data.data) == null ? void 0 : _a2.map((profile) => {
                      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)("option", {
                        value: profile.id,
                        children: tCustom(profile.profileName)
                      }, profile.id);
                    })
                  ]
                }),
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react336.FormHelperText, {
                  id: "profile-save-reset-all-users-configuration",
                  color: "red.500",
                  children: t("PROFILE_SAVE_CONFIG_WARNING")
                })
              ]
            })
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalFooter, {
            showBorders: false,
            children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react336.Button, {
              textTransform: "capitalize",
              colorScheme: "blue",
              onClick: () => saveSettingsForProfile(selectedProfileId),
              children: t("SAVE")
            })
          })
        ]
      })
    ]
  });
};
var ProfileSaveConfigModal_default = ProfileSaveConfigModal;

// src/components/List/EmptyFilters/EmptyFilters.tsx
var import_react338 = require("@chakra-ui/react");
var import_js52 = require("@mdi/js");
var import_react339 = __toESM(require("@mdi/react"));
var import_jsx_runtime = require("react/jsx-runtime");
var EmptyFilters = ({ openSettings }) => {
  const { t } = useAuraTranslation_default();
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react338.VStack, {
    spacing: "20px",
    mt: "16px",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react338.VStack, {
        spacing: "10px",
        color: "gray.300",
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react339.default, {
            path: import_js52.mdiFilterOffOutline,
            size: "35px"
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react338.Text, {
            mb: "0",
            mt: "10px",
            color: "gray.400",
            children: t("LIST_FILTERS_NO_CONFIGURATION")
          })
        ]
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react338.Button, {
        textTransform: "capitalize",
        onClick: openSettings,
        w: "full",
        backgroundColor: "gray.100",
        fontSize: "15px",
        letterSpacing: "0.15px",
        py: "8px",
        children: t("settings")
      })
    ]
  });
};
var EmptyFilters_default = EmptyFilters;

// src/components/List/List.tsx
var import_lib5 = require("@questy/lib");

// src/components/List/MobileRow/MobileRow.tsx
var import_react340 = require("@chakra-ui/react");
var import_jsx_runtime = require("react/jsx-runtime");
var MobileRow = ({ row, mobileVisibleColumns = ["id"] }) => {
  var _a2;
  const separatedCells = (_a2 = row == null ? void 0 : row.cells) == null ? void 0 : _a2.reduce(
    (data, currentValue) => {
      if (mobileVisibleColumns.includes(currentValue.column.id)) {
        data.main.push(currentValue);
      } else {
        data.separate.push(currentValue);
      }
      return data;
    },
    { main: [], separate: [] }
  );
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react340.Box, {
    my: 4,
    role: row.getRowProps().role,
    w: "calc(100vw - 24px - 32px - 16px)",
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react340.Accordion, {
      allowMultiple: true,
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react340.AccordionItem, {
        border: "none",
        children: ({ isExpanded }) => {
          var _a3, _b;
          return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react340.HStack, {
                spacing: 0,
                children: [
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react340.Box, {
                    flex: 1,
                    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TableContainer, {
                      borderBottomRadius: isExpanded ? 0 : 6,
                      ...isExpanded ? { borderBottom: "none" } : {},
                      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Table, {
                        size: "sm",
                        bgColor: "white",
                        sx: {
                          th: {
                            w: "50%"
                          }
                        },
                        children: (_a3 = separatedCells == null ? void 0 : separatedCells.main) == null ? void 0 : _a3.map(
                          (cell) => renderRow(cell)
                        )
                      })
                    })
                  }),
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react340.Button, {
                    as: import_react340.AccordionButton,
                    variant: "unstyled",
                    marginInline: "none !important",
                    _focus: {
                      bgColor: "transparent"
                    },
                    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react340.AccordionIcon, {})
                  })
                ]
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react340.AccordionPanel, {
                p: 0,
                pr: "34px",
                children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TableContainer, {
                  borderTopRadius: 0,
                  borderTop: "none",
                  children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Table, {
                    size: "sm",
                    bgColor: "white",
                    sx: {
                      th: {
                        w: "50%"
                      }
                    },
                    children: (_b = separatedCells == null ? void 0 : separatedCells.separate) == null ? void 0 : _b.map(
                      (cell) => renderRow(cell)
                    )
                  })
                })
              })
            ]
          });
        }
      })
    })
  }, row.getRowProps().key);
};
var renderRow = (cell) => {
  var _a2;
  const calculatedCellWidth = "calc((100vw / 2) - 28px - 24px - 32px - 2px)";
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Tr, {
    sx: {
      "span, p, a": {
        display: "block",
        WebkitBoxOrient: "vertical",
        WebkitLineClamp: 3,
        overflow: "hidden",
        textOverflow: "ellipsis",
        wordBreak: "keep-all",
        whiteSpace: "normal",
        lineHeight: "24px",
        float: "left",
        textAlign: "left",
        maxWidth: "100%"
      }
    },
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Th, {
        h: "auto",
        background: "gray.100",
        fontWeight: 500,
        role: cell.column.getHeaderProps().role,
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react340.Box, {
          w: calculatedCellWidth,
          children: cell.column.render("Header")
        })
      }, cell.column.getHeaderProps().key),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Td, {
        h: "auto",
        role: cell.getCellProps().role,
        w: "50%",
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react340.Box, {
          w: calculatedCellWidth,
          children: cell.render("Cell")
        })
      }, cell.getCellProps().key)
    ]
  }, `${(_a2 = cell.row.getRowProps()) == null ? void 0 : _a2.key}-${cell.getCellProps().key}`);
};
var MobileRow_default = MobileRow;

// src/components/List/List.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var getMainActionsForDropdown = (mainAction) => {
  if (!mainAction || !mainAction.length) {
    return [];
  }
  return mainAction.map((action) => {
    if (action.href) {
      return {
        customElement: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraMenuItem_default, {
          as: "a",
          href: action.href,
          ...action,
          children: action.label
        })
      };
    }
    return action;
  });
};
var List4 = ({
  columns: defaultColumns,
  data,
  summaryData,
  handleGoToNextPage,
  handleGoToPrevPage,
  handleSetPage,
  handleSetPageSize,
  isLoading,
  listFiltersConfig: defaultListFiltersConfig,
  listSorting,
  listSortingStatus,
  dependentFilters = {},
  module: module2,
  moduleName,
  pageCount: controlledPageCount,
  pageSize,
  setProfileSetting,
  setSorting,
  settings,
  setUserSetting,
  totalResults = 0,
  mainAction,
  additionalActions,
  filterContentTop = null,
  filterNamePrefix,
  apiParams,
  invisibleCheckboxFilter,
  mobileVisibleColumns,
  isMobileTileViewEnabled,
  ...props
}) => {
  var _a2, _b, _c, _d;
  const { t } = useAuraTranslation_default();
  const { resolveApiError } = useAuraErrorResolver_default();
  const { currentLocale } = (0, import_react344.useContext)(LanguageContext);
  const { isUserUser, user } = (0, import_react344.useContext)(AuthContext);
  const systemSettings = useSettings_default();
  const wrapLinesInLists = ((_a2 = systemSettings == null ? void 0 : systemSettings.settings) == null ? void 0 : _a2.newLookWrapLinesInLists) || (systemSettings == null ? void 0 : systemSettings.new_look_wrap_lines_in_lists) === "true";
  const listFiltersConfig = (0, import_react344.useMemo)(
    () => filterGlobalExcludedFields(defaultListFiltersConfig, user == null ? void 0 : user.type),
    [defaultListFiltersConfig, user]
  );
  const columns = (0, import_react344.useMemo)(
    () => filterGlobalExcludedFields(defaultColumns, user == null ? void 0 : user.type),
    [defaultColumns, user]
  );
  const defaultColumn = import_react344.default.useMemo(
    () => ({
      minWidth: 10,
      width: 150
    }),
    []
  );
  const asideFilters = (0, import_react341.useBreakpointValue)({
    base: false,
    lg: true
  });
  const isSm = (0, import_react341.useBreakpointValue)({
    base: true,
    md: false
  });
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    visibleColumns,
    allColumns,
    setHiddenColumns,
    setColumnOrder,
    state,
    page,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    setSortBy,
    resetResizing
  } = (0, import_react_table.useTable)(
    {
      columns,
      data,
      defaultColumn,
      manualSortBy: true,
      manualPagination: true,
      autoResetPage: false,
      initialState: {
        sortBy: listSorting,
        columnOrder: (settings == null ? void 0 : settings.columnOrder) ?? [],
        hiddenColumns: (settings == null ? void 0 : settings.hiddenColumns) ?? [],
        columnResizing: {
          columnWidths: (settings == null ? void 0 : settings.columnWidths) ?? {}
        }
      },
      pageCount: controlledPageCount
    },
    import_react_table.useColumnOrder,
    import_react_table.useSortBy,
    import_react_table.usePagination,
    import_react_table.useFlexLayout,
    import_react_table.useResizeColumns
  );
  const toast = (0, import_react341.useToast)();
  const { pageIndex, sortBy: sortBy5 } = state;
  const { setModuleParams, meta, hasActionCredential } = (0, import_lib5.useCredentials)();
  (0, import_react344.useEffect)(() => {
    var _a3, _b2, _c2;
    if (apiParams == null ? void 0 : apiParams.params) {
      setModuleParams({
        fields: (_a3 = apiParams == null ? void 0 : apiParams.params) == null ? void 0 : _a3.fields,
        ...((_b2 = apiParams == null ? void 0 : apiParams.params) == null ? void 0 : _b2.extra_fields) ? { extra_fields: (_c2 = apiParams == null ? void 0 : apiParams.params) == null ? void 0 : _c2.extra_fields } : {}
      });
    }
  }, [setModuleParams]);
  (0, import_react344.useEffect)(() => {
    logger_default.debug("Synchronizing sorting");
    const urlParams = new URLSearchParams(window.location.search);
    const sortField = urlParams.get("sortField");
    const sortType = urlParams.get("sortType");
    if (sortBy5 == null ? void 0 : sortBy5.length) {
      setSorting(sortBy5);
    } else {
      if (sortField) {
        setSorting([
          {
            id: sortField,
            [`desc`]: sortType === "desc" ? true : false
          }
        ]);
      } else {
        setSorting([
          {
            id: "id",
            desc: "true"
          }
        ]);
      }
    }
  }, [setSorting, sortBy5]);
  const handleSetNextPage = () => {
    nextPage();
    handleGoToNextPage();
  };
  const handleSetPrevPage = () => {
    previousPage();
    handleGoToPrevPage();
  };
  const handleSetPageNumber = (page2) => {
    logger_default.debug("handleSetPageNumber", page2);
    gotoPage(page2 - 1);
    handleSetPage(page2);
  };
  const handlePageSizeChange = (pageSize2, reset = true) => {
    setPageSize(pageSize2);
    handleSetPageSize(pageSize2);
    if (reset) {
      resetPagination();
    }
  };
  const { checkedColumns, handleCheckColumn, handleCheckAllColumns } = useListColumnsVisibility_default({
    allColumns,
    visibleColumns
  });
  const { checkedFilters, handleCheckFilter, handleCheckAllFilters } = useListFiltersVisibility_default({
    allFilters: listFiltersConfig,
    hiddenFilters: settings == null ? void 0 : settings.hiddenFilters
  });
  const { columnOrdering, setColumnOrdering } = useListColumnsOrdering_default({
    columnOrder: state.columnOrder
  });
  const getHiddenColumns = () => {
    return (0, import_difference2.default)(
      allColumns.map((col) => col.id),
      checkedColumns
    );
  };
  const dependentFiltersKeys = Object.keys(dependentFilters);
  const dependentFilterFiltersKeys = dependentFiltersKeys.map((i) => {
    return dependentFilters[i].dependents;
  }).flat();
  const getHiddenFilters = () => {
    var _a3, _b2;
    const hiddenFilters = (0, import_difference2.default)(
      listFiltersConfig.map((filter) => filter.id),
      checkedFilters
    );
    return (_b2 = (_a3 = hiddenFilters == null ? void 0 : hiddenFilters.filter((item) => !dependentFilterFiltersKeys.includes(item))) == null ? void 0 : _a3.map(
      (id) => {
        var _a4, _b3;
        return ((_b3 = (_a4 = dependentFilters == null ? void 0 : dependentFilters[id]) == null ? void 0 : _a4.dependents) == null ? void 0 : _b3.length) ? [id, ...dependentFilters[id].dependents] : id;
      }
    )) == null ? void 0 : _b2.flat();
  };
  const prepareColumnOrdering = () => {
    var _a3;
    const newColumnOrdering = (_a3 = columnOrdering == null ? void 0 : columnOrdering.filter((item) => !dependentFilterFiltersKeys.includes(item))) == null ? void 0 : _a3.map((item) => {
      if (dependentFiltersKeys.includes(item)) {
        return [item, ...dependentFilters[item].dependents];
      }
      return item;
    }).flat();
    return newColumnOrdering;
  };
  const handleSave = () => {
    const hiddenColumns = getHiddenColumns();
    setHiddenColumns(hiddenColumns);
    setColumnOrder(prepareColumnOrdering());
    const hiddenFilters = getHiddenFilters();
    setUserSetting({
      hiddenColumns,
      columnOrder: prepareColumnOrdering(),
      hiddenFilters
    });
  };
  (0, import_react344.useEffect)(() => {
    var _a3;
    if (!isMobileTileViewEnabled) {
      return;
    }
    if (isSm) {
      const hiddenColumnsForSmView = ((_a3 = settings == null ? void 0 : settings.hiddenColumns) == null ? void 0 : _a3.filter(
        (col) => !mobileVisibleColumns.includes(col)
      )) ?? [];
      setHiddenColumns(hiddenColumnsForSmView);
    } else if (settings == null ? void 0 : settings.hiddenColumns) {
      setHiddenColumns(settings == null ? void 0 : settings.hiddenColumns);
    }
  }, [
    isSm,
    mobileVisibleColumns,
    settings == null ? void 0 : settings.hiddenColumns,
    isMobileTileViewEnabled
  ]);
  (0, import_react344.useEffect)(() => {
    const allColumnsIds = allColumns == null ? void 0 : allColumns.map((column) => column == null ? void 0 : column.id);
    const shouldUpdate = !(allColumnsIds == null ? void 0 : allColumnsIds.every(
      (column) => {
        var _a3;
        return (_a3 = settings == null ? void 0 : settings.columnOrder) == null ? void 0 : _a3.includes(column);
      }
    ));
    if (shouldUpdate) {
      if (module2 === "documentInvoice" && allColumnsIds && !allColumnsIds.includes("code") && allColumnsIds.includes("positions")) {
        const index = allColumnsIds.indexOf("positions");
        allColumnsIds.splice(index + 1, 0, "code");
      }
      setUserSetting({
        hiddenColumns: (settings == null ? void 0 : settings.hiddenColumns) ?? [],
        columnOrder: allColumnsIds ?? (settings == null ? void 0 : settings.columnOrder) ?? [],
        columnWidths: state.columnResizing.columnWidths,
        hiddenFilters: (settings == null ? void 0 : settings.hiddenFilters) ?? []
      });
      return;
    }
    const debounceTimeout = setTimeout(() => {
      setUserSetting({
        hiddenColumns: (settings == null ? void 0 : settings.hiddenColumns) ?? [],
        columnOrder: (settings == null ? void 0 : settings.columnOrder) ?? [],
        columnWidths: state.columnResizing.columnWidths,
        hiddenFilters: (settings == null ? void 0 : settings.hiddenFilters) ?? []
      });
    }, 1e3);
    return () => clearTimeout(debounceTimeout);
  }, [state.columnResizing.columnWidths]);
  const resetColumnWidths = () => {
    resetResizing();
  };
  const resetPagination = () => {
    logger_default.debug("resetPagination");
    gotoPage(0);
    handleSetPage(1);
  };
  const listFilters = (0, import_react344.useContext)(ListFiltersContext);
  const updateSorting = (newSorting) => {
    setSortBy(newSorting);
    setSorting(newSorting);
  };
  (0, import_react344.useEffect)(() => {
    if (typeof controlledPageCount !== "undefined") {
      setIsReady();
    }
  }, [controlledPageCount]);
  const currentFilters = (listFilters == null ? void 0 : listFilters.filters) ?? null;
  const { setIsReady } = useQueryParams_default({
    currentPage: pageIndex,
    currentPerPage: pageSize,
    filters: currentFilters,
    listFiltersConfig,
    orderName: (_b = sortBy5[0]) == null ? void 0 : _b.id,
    orderType: ((_c = sortBy5[0]) == null ? void 0 : _c.desc) ? "desc" : "asc",
    setOrder: updateSorting,
    handlePageSizeChange: (pageSize2) => handlePageSizeChange(pageSize2, false),
    handleSetPageNumber,
    setFilters: listFilters.setFilters
  });
  const [isInitialFilters, setIsInitialFilters] = (0, import_react344.useState)(true);
  (0, import_use_deep_compare_effect5.useDeepCompareEffectNoCheck)(() => {
    !isInitialFilters && resetPagination();
    setIsInitialFilters(false);
  }, [currentFilters]);
  const { onOpen: openProfileSettingsModal, isOpen, onClose } = (0, import_react341.useDisclosure)();
  const handleSaveForProfile = async (profileId) => {
    const hiddenColumns = getHiddenColumns();
    const hiddenFilters = getHiddenFilters();
    try {
      await setProfileSetting(
        {
          hiddenColumns,
          columnOrder: columnOrdering,
          hiddenFilters
        },
        profileId
      );
      toast({
        title: t("PROFILE_SAVE_LIST_SETTINGS_SUCCESS_TITLE"),
        description: t("PROFILE_SAVE_LIST_SETTINGS_SUCCESS_DESCRIPTION"),
        status: "success"
      });
      onClose();
    } catch (error) {
      resolveApiError(error, {
        customTitle: "PROFILE_SAVE_LIST_SETTINGS_ERROR_TITLE",
        customMessage: "PROFILE_SAVE_LIST_SETTINGS_ERROR_DESCRIPTION"
      });
      onClose();
    }
  };
  const [isFiltersOpen, setIsFiltersOpen] = (0, import_react344.useState)(true);
  const [isModalClosableByOverlayClick, setIsModalClosableByOverlayClick] = (0, import_react344.useState)(true);
  const {
    isOpen: customizeColumnsModalIsOpen,
    onOpen: customizeColumnsModalOnOpen,
    onClose: customizeColumnsModalOnClose
  } = (0, import_react341.useDisclosure)();
  const {
    isOpen: isModalFiltersOpen,
    onToggle: onModalFiltersToggle,
    onClose: onModalFiltersClose
  } = (0, import_react341.useDisclosure)({
    defaultIsOpen: false
  });
  const {
    isOpen: isModalLoaderOpen,
    onOpen: onModalLoaderOnOpen,
    onClose: onModalLoaderClose
  } = (0, import_react341.useDisclosure)({
    defaultIsOpen: false
  });
  const xlsxExportAbortControllerRef = (0, import_react344.useRef)(null);
  const handleModalLoaderClose = (shouldAsk = false) => {
    const shouldClose = !shouldAsk || window.confirm(t("LIST_LOADING_MODAL_CLOSE_QUESTION"));
    if (shouldClose) {
      xlsxExportAbortControllerRef.current.abort();
      onModalLoaderClose();
    }
  };
  const handleDownloadXlsxDocument = () => {
    xlsxExportAbortControllerRef.current = new AbortController();
    onModalLoaderOnOpen();
    downloadXlsxDocument(
      apiParams,
      xlsxExportAbortControllerRef.current.signal,
      module2,
      user == null ? void 0 : user.type,
      onModalLoaderClose
    );
  };
  const menuItems = (0, import_react344.useMemo)(
    () => [
      ...isSm ? getMainActionsForDropdown(mainAction) : [],
      {
        label: t("LIST_COLUMN_CONFIG"),
        onClick: customizeColumnsModalOnOpen
      },
      ...isUserUser && hasActionCredential("save_settings_for_profile") ? [
        {
          label: t("LIST_CONFIG_SET_FOR_PROFILE"),
          onClick: openProfileSettingsModal
        }
      ] : [],
      {
        label: t("LIST_CONFIG_SET_DEFAULT_COLUMN_WIDTHS"),
        onClick: resetColumnWidths
      },
      ...hasActionCredential("xlsx_export") ? [
        {
          label: t("LIST_EXPORT_LIST_TO_XLSX"),
          onClick: handleDownloadXlsxDocument
        }
      ] : [],
      ...additionalActions ?? []
    ],
    [
      t,
      openProfileSettingsModal,
      resetColumnWidths,
      additionalActions,
      hasActionCredential
    ]
  );
  const noConfigurationFilters = (0, import_react344.useMemo)(
    () => listFiltersConfig == null ? void 0 : listFiltersConfig.every(
      (filter) => {
        var _a3;
        return (_a3 = settings == null ? void 0 : settings.hiddenFilters) == null ? void 0 : _a3.includes(filter.id);
      }
    ),
    [settings.hiddenFilters, listFiltersConfig]
  );
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react341.Grid, {
    gridTemplateColumns: "1fr",
    w: "full",
    maxW: "breakpoint.xl",
    pb: 4,
    m: "auto",
    gap: 4,
    ...props,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(ContentBox_default, {
        className: "list__header",
        display: "flex",
        flexDirection: { base: "column", sm: "row" },
        alignItems: { base: "flex-start", sm: "center" },
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react341.Flex, {
            flex: 1,
            children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react341.Heading, {
              as: "h1",
              fontSize: "2xl",
              fontWeight: "normal",
              children: moduleName
            })
          }),
          !isSm && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(MainAction, {
            mainAction
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraDropdownMenu_default, {
            id: "list__header__button-more",
            menuItems,
            children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react341.MenuButton, {
              className: "list__header__more-button",
              ml: "16px",
              as: MoreIconButton_default,
              variant: "solid",
              colorScheme: "gray"
            })
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CustomizeColumnsModal_default, {
            handleSave,
            closeOnOverlayClick: isModalClosableByOverlayClick,
            isOpen: customizeColumnsModalIsOpen,
            onOpen: customizeColumnsModalOnOpen,
            onClose: customizeColumnsModalOnClose,
            children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CustomizeColumns_default, {
              allColumns,
              checkedColumns,
              handleCheckColumn,
              handleCheckAllColumns,
              checkedFilters,
              handleCheckFilter,
              handleCheckAllFilters,
              countFilters: listFiltersConfig == null ? void 0 : listFiltersConfig.length,
              columnsOrdering: columnOrdering,
              setColumnOrdering,
              onBeforeDragStartCallback: () => {
                setIsModalClosableByOverlayClick(false);
              },
              onDragEndCallback: () => {
                setIsModalClosableByOverlayClick(true);
              },
              invisibleCheckboxFilter,
              dependentFilters,
              mobileVisibleColumns,
              isMobileTileViewEnabled
            })
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ProfileSaveConfigModal_default, {
            isOpen,
            onClose,
            saveSettingsForProfile: handleSaveForProfile
          })
        ]
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react341.Flex, {
        flexDirection: asideFilters ? "row" : "column",
        w: "full",
        minW: 0,
        children: [
          asideFilters && isFiltersOpen ? /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(ContentBox_default, {
            className: "list__filters-container",
            mb: "20rem",
            mr: "16px",
            w: { base: "full", lg: "288px", xl: "448px" },
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(PanelHeading_default, {
                text: t("LIST_FILTERS"),
                mb: 4
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react341.Flex, {
                mb: 4,
                children: filterContentTop
              }),
              noConfigurationFilters ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(EmptyFilters_default, {
                openSettings: customizeColumnsModalOnOpen
              }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ListFilters_default, {
                filters: listFiltersConfig,
                hiddenFilters: settings == null ? void 0 : settings.hiddenFilters,
                columnOrdering: settings == null ? void 0 : settings.columnOrder
              })
            ]
          }) : /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(ContentBox_default, {
            className: "list__filters-container",
            display: "none",
            mb: "16px",
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(PanelHeading_default, {
                text: t("LIST_FILTERS"),
                mb: 4
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react341.Flex, {
                mb: 4,
                children: filterContentTop
              }),
              noConfigurationFilters ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(EmptyFilters_default, {
                openSettings: customizeColumnsModalOnOpen
              }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ListFilters_default, {
                filters: listFiltersConfig,
                hiddenFilters: settings == null ? void 0 : settings.hiddenFilters,
                columnOrdering: settings == null ? void 0 : settings.columnOrder
              })
            ]
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(ContentBox_default, {
            className: "list__table-container",
            flex: 1,
            display: { base: isFiltersOpen ? "none" : "block", sm: "block" },
            position: "relative",
            minW: 0,
            mb: "auto",
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react341.Flex, {
                className: "list__table-container__top",
                mb: "16px",
                justifyContent: "space-between",
                alignItems: "center",
                children: [
                  !asideFilters ? /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
                    children: [
                      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ActiveFilters_default, {
                        filters: listFilters.filters,
                        filterNamePrefix: filterNamePrefix ?? "LIST_COLUMN_",
                        onRemoveFilter: listFilters.removeFilter,
                        onClearAllFilters: listFilters.resetFilters,
                        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ButtonAction_default, {
                          size: "sm",
                          leftIcon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react343.default, {
                            path: import_js53.mdiFilterOutline
                          }),
                          onClick: onModalFiltersToggle,
                          children: isModalFiltersOpen ? t("KANBAN_HIDE_FILTERS") : `${t("LIST_FILTERS")}${Object.keys(listFilters.filters).length > 0 ? ` (${Object.keys(listFilters.filters).length})` : " "}`
                        })
                      }),
                      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(AuraModal, {
                        isOpen: isModalFiltersOpen,
                        onClose: onModalFiltersClose,
                        scrollBehavior: "inside",
                        children: [
                          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalOverlay, {}),
                          /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(AuraModalContent, {
                            children: [
                              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalHeader, {
                                children: t("LIST_FILTERS")
                              }),
                              /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(AuraModalBody, {
                                children: [
                                  filterContentTop && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react341.Flex, {
                                    mb: 4,
                                    children: filterContentTop
                                  }),
                                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react341.Stack, {
                                    spacing: 4,
                                    direction: "column",
                                    children: noConfigurationFilters ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(EmptyFilters_default, {
                                      openSettings: customizeColumnsModalOnOpen
                                    }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ListFilters_default, {
                                      filters: listFiltersConfig,
                                      hiddenFilters: settings == null ? void 0 : settings.hiddenFilters,
                                      columnOrdering
                                    })
                                  })
                                ]
                              }),
                              !noConfigurationFilters ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalFooter, {
                                children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react341.Stack, {
                                  isInline: true,
                                  spacing: 3,
                                  maxW: "full",
                                  children: [
                                    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react341.Button, {
                                      type: "button",
                                      isTruncated: true,
                                      variant: "solid",
                                      colorScheme: "gray",
                                      onClick: () => {
                                        listFilters.resetFilters();
                                        onModalFiltersClose();
                                      },
                                      children: t("KANBAN_MODAL_CLEAR_FILTERS")
                                    }),
                                    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react341.Button, {
                                      type: "button",
                                      isTruncated: true,
                                      colorScheme: "blue",
                                      backgroundColor: "crmBlue",
                                      onClick: onModalFiltersClose,
                                      children: t("KANBAN_SHOW_RESULTS")
                                    })
                                  ]
                                })
                              }) : null
                            ]
                          })
                        ]
                      })
                    ]
                  }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react341.Box, {
                    flex: 1,
                    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ActiveFilters_default, {
                      filters: listFilters.filters,
                      filterNamePrefix: filterNamePrefix ?? "LIST_COLUMN_",
                      onRemoveFilter: listFilters.removeFilter,
                      onClearAllFilters: listFilters.resetFilters,
                      currentLocale,
                      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ButtonAction_default, {
                        size: "sm",
                        leftIcon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react343.default, {
                          path: isFiltersOpen ? import_js53.mdiEyeOffOutline : import_js53.mdiEyeOutline
                        }),
                        onClick: () => setIsFiltersOpen((val) => !val),
                        children: isFiltersOpen ? t("HIDE_FILTERS") : t("SHOW_FILTERS")
                      })
                    })
                  }),
                  visibleColumns.length < 1 || data.length < 1 ? null : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react341.Flex, {
                    alignItems: "flex-end",
                    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Pagination_default, {
                      page: pageIndex + 1,
                      totalPages: pageCount,
                      nextPage: handleSetNextPage,
                      previousPage: handleSetPrevPage,
                      setPage: handleSetPageNumber
                    })
                  })
                ]
              }),
              visibleColumns.length < 1 || data.length < 1 ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(EmptyList_default, {
                isLoading,
                showHeader: true
              }) : /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react341.Stack, {
                minW: "0%",
                sx: {
                  ".list__table th p": {
                    margin: "0"
                  },
                  "div:first-child": {
                    paddingTop: !isSm ? "1px" : 0
                  }
                },
                spacing: "16px",
                children: [
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_shadowed_double_scrollbar.default, {
                    shadowVariant: "off",
                    children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Table_default, {
                      ...!(isSm && isMobileTileViewEnabled) ? {
                        border: 1,
                        borderStyle: "solid",
                        borderColor: "gray.200"
                      } : {},
                      rounded: 6,
                      bg: "white",
                      className: "list__table",
                      sx: { borderCollapse: "separate", borderSpacing: "0" },
                      ...{
                        ...getTableProps(),
                        style: isSm && isMobileTileViewEnabled ? {} : (_d = getTableProps()) == null ? void 0 : _d.style
                      },
                      children: [
                        !(isSm && isMobileTileViewEnabled) && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Thead_default, {
                          bg: "gray.100",
                          children: headerGroups.map((headerGroup) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Tr_default, {
                            ...headerGroup.getHeaderGroupProps(),
                            children: headerGroup.headers.map((column) => /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Th_default, {
                              ...column.getHeaderProps(),
                              textStyle: "buttonSmall",
                              color: "gray.600",
                              textAlign: "left",
                              px: "24px",
                              py: "12px",
                              whiteSpace: "nowrap",
                              borderRight: "2px solid",
                              borderColor: "gray.200",
                              children: [
                                /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react341.Stack, {
                                  ...column.getSortByToggleProps({
                                    title: t("LIST_TOGGLE_SORT_BY")
                                  }),
                                  align: "center",
                                  direction: "row",
                                  width: "full",
                                  height: "full",
                                  lineHeight: "20px",
                                  css: import_react342.css`
                                  & > p,
                                  & > span {
                                    text-overflow: ellipsis;
                                    overflow: hidden;
                                    white-space: nowrap;
                                  }
                                `,
                                  children: [
                                    column.render("Header"),
                                    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(SortingIndicator_default, {
                                      isSorted: column.isSorted,
                                      isSortedDesc: column.isSortedDesc
                                    })
                                  ]
                                }),
                                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react341.Box, {
                                  _before: {
                                    content: "''",
                                    display: "inline-block",
                                    width: "12px",
                                    transform: "translateX(-50%)",
                                    height: "100%"
                                  },
                                  display: "inline-block",
                                  bg: "gray.100",
                                  w: "2px",
                                  h: "100%",
                                  position: "absolute",
                                  right: 0,
                                  top: 0,
                                  transform: "translateX(50%)",
                                  className: "resizer",
                                  ...column.getResizerProps()
                                })
                              ]
                            }))
                          }))
                        }),
                        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Tbody_default, {
                          ...getTableBodyProps(),
                          children: page.map((row) => {
                            prepareRow(row);
                            if (isSm && isMobileTileViewEnabled) {
                              return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(MobileRow_default, {
                                row,
                                mobileVisibleColumns
                              });
                            }
                            return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Tr_default, {
                              borderTop: "1px solid",
                              borderColor: "gray.200",
                              ...row.getRowProps(),
                              children: row.cells.map((cell) => {
                                var _a3;
                                return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Td_default, {
                                  px: "24px",
                                  py: "16px",
                                  className: `table-cell-${(_a3 = cell.column) == null ? void 0 : _a3.id}`,
                                  ...!wrapLinesInLists && { h: "56px" },
                                  ...cell.getCellProps(),
                                  children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react341.Flex, {
                                    css: import_react342.css`
                                    & > * {
                                      text-overflow: ellipsis;
                                      overflow: hidden;
                                      white-space: ${wrapLinesInLists ? "normal" : "nowrap"};
                                    }
                                  `,
                                    alignItems: "center",
                                    whiteSpace: "nowrap",
                                    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react341.Box, {
                                      textStyle: "bodyInput",
                                      w: "full",
                                      children: cell.render("Cell")
                                    })
                                  })
                                });
                              })
                            });
                          })
                        })
                      ]
                    })
                  }),
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(LoadingOverlay_default, {
                    isLoading
                  }),
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(LoadingModal_default, {
                    handleClose: handleModalLoaderClose,
                    isOpen: isModalLoaderOpen
                  }),
                  /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react341.Stack, {
                    direction: { base: "column-reverse", md: "row" },
                    alignItems: "center",
                    py: "12px",
                    spacing: "16px",
                    children: [
                      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(PerPage_default, {
                        value: pageSize,
                        onChange: handlePageSizeChange
                      }),
                      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react341.HStack, {
                        flex: 2,
                        w: { base: "full", md: "auto" },
                        children: [
                          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react341.Box, {
                            className: "list-items-count",
                            textAlign: "center",
                            flex: 1,
                            children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react341.Text, {
                              as: "span",
                              fontSize: "sm",
                              color: "gray.700",
                              children: [
                                totalResults,
                                " ",
                                t("LIST_TOTAL_RESULTS")
                              ]
                            })
                          }),
                          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react341.Box, {
                            flex: 1,
                            children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Pagination_default, {
                              page: pageIndex + 1,
                              totalPages: pageCount,
                              nextPage: handleSetNextPage,
                              previousPage: handleSetPrevPage,
                              setPage: handleSetPageNumber
                            })
                          })
                        ]
                      })
                    ]
                  }),
                  summaryData && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(DocumentSummary_default, {
                    data: summaryData,
                    float: "right"
                  })
                ]
              })
            ]
          })
        ]
      })
    ]
  });
};
var MainAction = ({ mainAction }) => {
  if (!mainAction || !mainAction.length) {
    return null;
  }
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react341.ButtonGroup, {
    variant: "solid",
    colorScheme: "blue",
    children: mainAction.map((action) => {
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react341.Button, {
        ...action.className && { className: action.className },
        ...action.onClick && { onClick: action.onClick },
        ...action.href && { href: action.href, as: "a" },
        colorScheme: "blue",
        children: action.label
      });
    })
  });
};
var List_default = List4;

// src/components/List/sharedCells/CreatorUserCell/CreatorUserCell.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var CreatorUserCell = (props) => {
  var _a2, _b, _c, _d, _e;
  const content = ((_a2 = props == null ? void 0 : props.value) == null ? void 0 : _a2.username) ?? ((_b = props == null ? void 0 : props.value) == null ? void 0 : _b.fullName);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CellWrapper_default, {
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ModuleLink, {
      module: (_d = props == null ? void 0 : props.value) == null ? void 0 : _d.type,
      id: (_e = props == null ? void 0 : props.value) == null ? void 0 : _e.id,
      isTooltip: false,
      children: content
    })
  }, (_c = props == null ? void 0 : props.value) == null ? void 0 : _c.id);
};
var CreatorUserCell_default = CreatorUserCell;

// src/components/List/sharedCells/BooleanCell/BooleanCell.tsx
var import_react345 = require("@chakra-ui/react");
var import_fa7 = require("react-icons/fa");
var import_jsx_runtime = require("react/jsx-runtime");
var BooleanCell = ({ value }) => {
  const { t } = useAuraTranslation_default();
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, {
    children: value ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react345.Box, {
      mx: "auto",
      color: "green.500",
      as: import_fa7.FaCheck,
      "aria-label": t("YES")
    }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react345.Box, {
      mx: "auto",
      color: "red.500",
      as: import_fa7.FaTimes,
      "aria-label": t("NO")
    })
  });
};
var BooleanCell_default = BooleanCell;

// src/components/MessageBreadcrumbs/MessageBreadcrumbs.tsx
var import_react346 = require("@chakra-ui/react");
var import_js54 = require("@mdi/js");
var import_react347 = __toESM(require("@mdi/react"));
var import_jsx_runtime = require("react/jsx-runtime");
var MessageBreadcrumbs = ({
  sender,
  recipients
}) => {
  var _a2;
  const visibleCount = 3;
  const preparedRecipients = recipients == null ? void 0 : recipients.slice(0, visibleCount);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react346.Breadcrumb, {
    separator: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react347.default, {
      path: import_js54.mdiChevronRight,
      size: "20px"
    }),
    spacing: "4px",
    letterSpacing: "0.25px",
    fontSize: "sm",
    color: "gray.500",
    mb: "0",
    sx: {
      ".chakra-breadcrumb__link:hover": {
        textDecoration: "none",
        cursor: "default"
      }
    },
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react346.BreadcrumbItem, {
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react346.BreadcrumbLink, {
          as: import_react346.Text,
          children: sender
        })
      }),
      (preparedRecipients == null ? void 0 : preparedRecipients.length) && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react346.BreadcrumbItem, {
        flexWrap: "wrap",
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react346.BreadcrumbLink, {
            as: import_react346.Text,
            children: preparedRecipients.join(", ")
          }),
          recipients.length > 3 && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react346.Tooltip, {
            label: (_a2 = recipients.slice(visibleCount)) == null ? void 0 : _a2.join(", "),
            openDelay: 500,
            children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react346.BreadcrumbLink, {
              as: import_react346.Text,
              pl: 1,
              children: `(+${recipients.length - 3})`
            })
          })
        ]
      })
    ]
  });
};
var MessageBreadcrumbs_default = MessageBreadcrumbs;

// src/components/Modal/Modal.tsx
var import_react349 = require("@chakra-ui/react");
var import_nice_modal_react = __toESM(require("@ebay/nice-modal-react"));

// src/theme.ts
var import_react348 = require("@chakra-ui/react");
var import_theme_tools = require("@chakra-ui/theme-tools");
var baseThemeExtension = {
  fonts: {
    body: 'Poppins, "Helvetica Neue", "Trebuchet MS", Helvetica, Arial, sans-serif',
    heading: 'Poppins, "Helvetica Neue", "Trebuchet MS", Helvetica, Arial, sans-serif'
  },
  components: {
    Input: {
      variants: {
        outline: {
          field: {
            "&:focus": {
              boxShadow: "none"
            }
          }
        }
      }
    }
  },
  styles: {
    global: {
      "*": {
        "--chakra-shadows-outline": "none"
      },
      body: {
        backgroundColor: "#F9F9F9",
        color: "gray.700"
      },
      "#customFormBridgeNext": {
        ".wrapper": {
          opacity: 1
        }
      },
      ".react-datepicker": {
        fontFamily: 'Poppins, "Helvetica Neue", "Trebuchet MS", Helvetica,Arial, sans-serif !important'
      },
      ".react-datepicker__time-container--with-today-button": {
        right: "-85px !important",
        top: "-1px"
      },
      ".react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box": {
        width: "100% !important"
      },
      ".react-datepicker__year-option:first-of-type, .react-datepicker__year-option:last-child": {
        height: "20px"
      },
      ".react-datepicker__year-option:first-of-type:hover, .react-datepicker__year-option:last-child:hover": {
        backgroundColor: "transparent"
      },
      ".react-datepicker__year-option .react-datepicker__navigation.react-datepicker__navigation--years": {
        borderColor: "#ccc",
        borderStyle: "solid",
        borderWidth: "3px 3px 0 0",
        content: '""',
        height: "9px",
        top: "6px",
        width: "9px"
      },
      ".react-datepicker__navigation--years-upcoming": {
        transform: "rotate(-45deg)"
      },
      ".react-datepicker__navigation--years-previous": {
        transform: "rotate(135deg)"
      },
      ".react-datepicker__year-option .react-datepicker__navigation.react-datepicker__navigation--years:hover": {
        borderColor: "#a6a6a6"
      }
    }
  }
};
var breakpoints = (0, import_theme_tools.createBreakpoints)({
  sm: "320px",
  md: "768px",
  lg: "1280px",
  xl: "1680px",
  "2xl": "1920px"
});
var themeExtensions = {
  ...baseThemeExtension,
  breakpoints,
  colors: {
    body: "#E5E5E5",
    crmBlue: "#3182CE"
  },
  fontSizes: {
    xs: "0.723rem",
    sm: "0.823rem",
    md: "0.9375rem",
    lg: "1.138rem",
    xl: "1.383rem",
    "2xl": "1.68rem",
    "3xl": "2.041rem",
    "4xl": "2.479rem",
    "5xl": "3.012rem",
    "6xl": "3.658rem",
    "7xl": "4.444rem",
    "8xl": "5.399rem",
    "9xl": "6.558rem"
  },
  textStyles: {
    h1: {
      fontWeight: 500,
      fontSize: "3xl",
      lineHeight: "3rem",
      letterSpacing: "normal"
    },
    h2: {
      fontWeight: 500,
      fontSize: "2xl",
      lineHeight: "2.25rem",
      letterSpacing: "normal"
    },
    h3: {
      fontWeight: 500,
      fontSize: "xl",
      lineHeight: "2rem",
      letterSpacing: "normal"
    },
    h4: {
      fontWeight: 500,
      fontSize: "xl",
      lineHeight: "36px",
      letterSpacing: "normal"
    },
    h5: {
      fontSize: "lg",
      fontWeight: 500,
      lineHeight: "2rem",
      letterSpacing: "normal"
    },
    h6: {
      fontSize: "lg",
      fontWeight: 400,
      lineHeight: "32px",
      letterSpacing: "normal"
    },
    buttonLarge: {
      fontWeight: 600,
      fontSize: "lg",
      lineHeight: "1.5rem",
      letterSpacing: "normal"
    },
    subtitleLabel: {
      fontWeight: 500,
      fontSize: "md",
      lineHeight: "1.5rem",
      letterSpacing: "normal"
    },
    bodyInput: {
      fontWeight: 400,
      fontSize: "md",
      lineHeight: "1.5rem",
      letterSpacing: "wider"
    },
    buttonSmall: {
      fontWeight: 500,
      fontSize: "sm",
      lineHeight: "1.25rem",
      letterSpacing: "wide"
    },
    badgeLarge: {
      fontWeight: 600,
      fontSize: "sm",
      lineHeight: "1.25rem",
      letterSpacing: "wide"
    },
    caption: {
      fontWeight: 400,
      fontSize: "sm",
      lineHeight: "1.25rem",
      letterSpacing: "wide"
    },
    badgeSmall: {
      fontWeight: 600,
      fontSize: "xs",
      lineHeight: "1.125rem",
      letterSpacing: "wider"
    }
  },
  letterSpacings: {
    normal: "0",
    basic: "0.009em",
    wide: "0.025em",
    mediumWide: "0.03125em",
    wider: "0.05em"
  },
  shadows: {
    lgTop: "0 -10px 15px -3px rgba(22, 22, 22, 0.06), 0 -4px 6px -2px rgba(22, 22, 22, 0.05)"
  }
};
var customTheme = (0, import_react348.extendTheme)(themeExtensions);
var theme_default = customTheme;

// src/components/Modal/Modal.tsx
var import_react350 = require("react");
var import_jsx_runtime = require("react/jsx-runtime");
var ManagedModal = import_nice_modal_react.default.create(
  ({ title, size = "md", afterCreate, ...props }) => {
    const [isReady, setIsReady] = (0, import_react350.useState)(false);
    const modalBodyRef = (0, import_react350.useRef)(null);
    const modalFooterRef = (0, import_react350.useRef)(null);
    const { t } = useAuraTranslation_default();
    const modal = (0, import_nice_modal_react.useModal)();
    (0, import_react350.useEffect)(() => {
      return () => {
        modal.remove();
      };
    }, []);
    (0, import_react350.useEffect)(() => {
      window.AuraModal.modalBodyRef = modalBodyRef;
      window.AuraModal.modalFooterRef = modalFooterRef;
    }, []);
    (0, import_react350.useEffect)(() => {
      if (isReady) {
        afterCreate == null ? void 0 : afterCreate({
          modal,
          modalBody: modalBodyRef,
          modalFooter: modalFooterRef
        });
      }
    }, [isReady]);
    return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react349.ChakraProvider, {
      theme: theme_default,
      resetCSS: false,
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CustomCSSReset_default, {}),
        /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react349.Modal, {
          isOpen: modal.visible,
          onClose: modal.remove,
          size,
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react349.ModalOverlay, {}),
            /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react349.ModalContent, {
              borderRadius: 4,
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react349.ModalHeader, {
                  children: title
                }),
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react349.ModalCloseButton, {}),
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react349.ModalBody, {
                  ref: modalBodyRef,
                  className: "modal-body"
                }),
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react349.ModalFooter, {
                  ref: modalFooterRef,
                  className: "modal-footer",
                  children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react349.Button, {
                    onClick: modal.remove,
                    children: t("CLOSE")
                  })
                })
              ]
            })
          ]
        }),
        modal.visible && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ReadyCheck, {
          setIsReady
        })
      ]
    });
  }
);
var ReadyCheck = ({
  setIsReady
}) => {
  (0, import_react350.useEffect)(() => {
    setIsReady(true);
  }, []);
  return null;
};
var initModal = () => {
  logger_default.debug("Modal initializing");
  const modal = {
    show: (props) => import_nice_modal_react.default.show(ManagedModal, props),
    hide: () => import_nice_modal_react.default.hide(ManagedModal),
    modalBodyRef: { current: null },
    modalFooterRef: { current: null }
  };
  if (typeof window !== "undefined") {
    window.AuraModal = modal;
    const initializeEvent = new CustomEvent("auraModalInitialized");
    document.dispatchEvent(initializeEvent);
  }
};
var Modal_default = ManagedModal;

// src/components/ModalAbsence/ModalAbsence.tsx
var import_react351 = require("@chakra-ui/react");
var import_api21 = require("@questy/api");
var import_lib6 = require("@questy/lib");
var import_react352 = require("react");
var import_react_hook_form21 = require("react-hook-form");
var import_react_query39 = require("react-query");

// src/components/ModalAbsence/consts.ts
var ABSENCE_APPLICATION_TYPES = [
  { value: 1, label: "ABSENCE_TYPE_REST" },
  { value: 2, label: "ABSENCE_TYPE_UNPAID" },
  { value: 3, label: "ABSENCE_TYPE_OCCASIONAL" },
  { value: 4, label: "ABSENCE_TYPE_CHILD_CARE" },
  { value: 5, label: "ABSENCE_TYPE_SICK" },
  { value: 6, label: "ABSENCE_TYPE_OVERTIME" }
];
var ABSENCE_STATUSES = [
  { value: 0, label: "ABSENCE_STATUS_WAITING" },
  { value: 1, label: "ABSENCE_STATUS_ACCEPTED" },
  { value: 2, label: "ABSENCE_STATUS_REJECTED" }
];

// src/components/ModalAbsence/ModalAbsence.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var withCredentials2 = (Component) => {
  return ({ ...props }) => {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_lib6.CredentialContextProvider, {
      module: "user_user_absences",
      initialModuleParams: {},
      ...props.initialCredentials && {
        initialCredentials: props.initialCredentials
      },
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Component, {
        ...props
      })
    });
  };
};
var ModalAbsence = ({
  id,
  isOpen,
  onClose,
  afterSuccess
}) => {
  const { data, isLoading } = (0, import_react_query39.useQuery)(
    ["absence", id],
    () => api_default.getEndpointById("user_user_absences", id, {
      params: {
        "setting[with_relations]": "true",
        extra_fields: "acceptingUser.fullName,user.fullName"
      }
    }),
    {
      enabled: !!id && isOpen,
      refetchOnWindowFocus: true
    }
  );
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(AuraModal, {
    size: "lg",
    isOpen,
    onClose,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalOverlay, {}),
      isLoading ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSpinner_default, {}) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ModalAbsenceContent, {
        defaultData: data == null ? void 0 : data.data,
        onClose,
        afterSuccess
      })
    ]
  });
};
var ModalAbsenceContent = ({
  defaultData,
  onClose,
  afterSuccess
}) => {
  var _a2, _b, _c, _d, _e, _f, _g;
  const { t } = useAuraTranslation_default();
  const { resolveApiError } = useAuraErrorResolver_default();
  const toast = (0, import_react351.useToast)();
  const { user } = (0, import_react352.useContext)(AuthContext);
  const id = defaultData == null ? void 0 : defaultData.id;
  const status = defaultData == null ? void 0 : defaultData.status;
  const [isSubmitBtnDisabled, setIsSubmitBtnDisabled] = (0, import_react352.useState)(false);
  const loggedUser = {
    value: user.id,
    label: user.fullName,
    avatar: user.avatar
  };
  const translatedTypes = (0, import_react352.useMemo)(
    () => ABSENCE_APPLICATION_TYPES.map((type) => ({
      ...type,
      label: t(type.label)
    })),
    [t]
  );
  const translatedStatuses = (0, import_react352.useMemo)(
    () => ABSENCE_STATUSES.map((type) => ({
      ...type,
      label: t(type.label)
    })),
    [t]
  );
  const { hasModuleCredential, hasCredential } = (0, import_lib6.useCredentials)();
  const {
    register,
    control,
    formState,
    handleSubmit,
    resetField,
    setValue,
    watch
  } = (0, import_react_hook_form21.useForm)({
    defaultValues: {
      ...defaultData,
      ...id && {
        id
      },
      ...id && (defaultData == null ? void 0 : defaultData.user) ? {
        user: {
          value: (_a2 = defaultData == null ? void 0 : defaultData.user) == null ? void 0 : _a2.id,
          label: (_b = defaultData == null ? void 0 : defaultData.user) == null ? void 0 : _b.fullName,
          avatar: (_c = defaultData == null ? void 0 : defaultData.user) == null ? void 0 : _c.avatar
        }
      } : {
        user: loggedUser
      },
      ...(defaultData == null ? void 0 : defaultData.acceptingUser) && {
        acceptingUser: {
          value: (_d = defaultData == null ? void 0 : defaultData.acceptingUser) == null ? void 0 : _d.id,
          label: (_e = defaultData == null ? void 0 : defaultData.acceptingUser) == null ? void 0 : _e.fullName,
          avatar: (_f = defaultData == null ? void 0 : defaultData.acceptingUser) == null ? void 0 : _f.avatar
        }
      },
      ...id && (defaultData == null ? void 0 : defaultData.applicationType) ? {
        applicationType: translatedTypes.find(
          (type) => type.value === defaultData.applicationType
        )
      } : { applicationType: translatedTypes[0] },
      ...(defaultData == null ? void 0 : defaultData.dateFrom) && {
        dateFrom: new Date(defaultData == null ? void 0 : defaultData.dateFrom)
      },
      ...(defaultData == null ? void 0 : defaultData.dateTo) && {
        dateTo: new Date(defaultData == null ? void 0 : defaultData.dateTo)
      },
      ...(defaultData == null ? void 0 : defaultData.status) && {
        status: translatedStatuses.find(
          (type) => type.value === defaultData.status
        )
      }
    }
  });
  const screenPhone = (0, import_react351.useBreakpointValue)({
    base: true,
    md: false
  });
  const handleSubmitForm = async (formData) => {
    setIsSubmitBtnDisabled(true);
    if (defaultData == null ? void 0 : defaultData.id) {
      editAbsence(formData);
    } else {
      createAbsence(formData);
    }
  };
  const createAbsence = async (data) => {
    try {
      const response = await (0, import_api21.createUserUserAbsence)({
        data: {
          user: { id: data.user.value },
          acceptingUser: { id: data.acceptingUser.value },
          applicationType: data.applicationType.value,
          dateFrom: data.dateFrom,
          dateTo: data.dateTo,
          applicantNotes: data.applicantNotes
        }
      });
      if (response.errors === null) {
        toast({
          title: t("NOTICE_SAVE_SUCCESS"),
          status: "success"
        });
        afterSuccess == null ? void 0 : afterSuccess();
        onClose();
      }
    } catch (error) {
      resolveApiError(error);
      setIsSubmitBtnDisabled(false);
    }
  };
  const handleAccept = async (data) => {
    editAbsence({ ...data, status: 1 });
  };
  const handleReject = async (data) => {
    editAbsence({ ...data, status: 2 });
  };
  const editAbsence = async (data) => {
    try {
      const response = await (0, import_api21.updateUserUserAbsence)(defaultData.id, {
        data: {
          accepteeNotes: data.accepteeNotes,
          ...data.status && {
            status: data.status
          }
        }
      });
      if (response.errors === null) {
        toast({
          title: t("NOTICE_SAVE_SUCCESS"),
          status: "success"
        });
        afterSuccess == null ? void 0 : afterSuccess();
        onClose();
      }
    } catch (error) {
      resolveApiError(error);
      setIsSubmitBtnDisabled(false);
    }
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(AuraModalContent, {
    as: "form",
    onSubmit: handleSubmit(handleSubmitForm),
    className: "absence__create-modal",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalHeader, {
        className: "absence__create-modal__header",
        children: id ? t("EDIT_ABSENCE") : t("NEW_ABSENCE")
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalBody, {
        overflowY: "visible",
        className: "absence__create-modal__body",
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AbsenceForm, {
          control,
          register,
          resetField,
          formState,
          setValue,
          defaultData,
          watch
        })
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(AuraModalFooter, {
        className: "absence__create-modal__footer",
        showBorders: false,
        children: [
          ![0, 1, 2].includes(status) && hasModuleCredential("create") && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react351.Button, {
            className: "absence__create-modal__footer-button-create",
            isLoading: formState.isSubmitting || isSubmitBtnDisabled,
            type: "submit",
            colorScheme: "blue",
            children: t("CREATE_ABSENCE")
          }),
          status === 0 && hasModuleCredential("edit") && hasCredential("status", "field", "edit") && (user == null ? void 0 : user.id) === ((_g = defaultData == null ? void 0 : defaultData.acceptingUser) == null ? void 0 : _g.id) && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react351.Stack, {
            isInline: true,
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react351.Button, {
                className: "absence__create-modal__footer-button-accept",
                isLoading: formState.isSubmitting || isSubmitBtnDisabled,
                onClick: handleSubmit(handleAccept),
                colorScheme: "blue",
                children: t("ACCEPT_ABSENCE")
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react351.Button, {
                className: "absence__create-modal__footer-button-reject",
                isLoading: formState.isSubmitting || isSubmitBtnDisabled,
                colorScheme: "gray",
                onClick: handleSubmit(handleReject),
                children: t("REJECT_ABSENCE")
              })
            ]
          })
        ]
      })
    ]
  });
};
var AbsenceForm = ({ control, defaultData, watch }) => {
  var _a2;
  const { language } = (0, import_react352.useContext)(LanguageContext);
  const { hasCredential } = (0, import_lib6.useCredentials)();
  const { t } = useAuraTranslation_default();
  const { user } = (0, import_react352.useContext)(AuthContext);
  const status = defaultData == null ? void 0 : defaultData.status;
  const dateFrom = watch("dateFrom");
  const loggedUser = {
    value: user.id,
    label: user.fullName,
    avatar: user.avatar
  };
  const translatedTypes = (0, import_react352.useMemo)(
    () => ABSENCE_APPLICATION_TYPES.map((type) => ({
      ...type,
      label: t(type.label)
    })),
    [t]
  );
  const { data: userUsers } = useMinimalAutoselect_default({
    endpoint: "user_users",
    labelField: "fullName",
    valueField: "id",
    extraFields: ["fullName"],
    fields: ["avatar"],
    filters: { "filter[id][notIn]": user.id },
    additionalOptionField: [
      { field: "avatar", source: "avatar" },
      { field: "label", source: "fullName" },
      { field: "value", source: "id" }
    ]
  });
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react351.Stack, {
    spacing: 4,
    "data-testid": "create-absence-form",
    className: "absence__create-modal__form",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react351.Flex, {
        justifyContent: "flex-end",
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react351.Text, {
            textStyle: "bodyInput",
            color: "red.500",
            mr: "16px",
            children: "*"
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react351.Text, {
            textStyle: "bodyInput",
            color: "blackAlpha.500",
            children: t("REQUIRED")
          })
        ]
      }),
      [1, 2].includes(status) && hasCredential("status", "field", "show") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react351.FormControl, {
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react351.FormLabel, {
            htmlFor: "absence-acceptee-status",
            children: t("ABSENCE_STATUS")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form21.Controller, {
            control,
            name: "status",
            render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSelect_default, {
              isReadOnly: true,
              ...field
            })
          })
        ]
      }),
      hasCredential("user", "field", "show") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react351.FormControl, {
        isRequired: true,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react351.FormLabel, {
            htmlFor: "absence-user",
            children: t("ABSENCE_USER")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form21.Controller, {
            control,
            name: "user",
            rules: {
              required: true
            },
            render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSelect_default, {
              inputId: "absence-user",
              options: [loggedUser],
              withAvatars: true,
              isReadOnly: true,
              ...field
            })
          })
        ]
      }),
      hasCredential("acceptingUser", "field", "show") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react351.FormControl, {
        isRequired: true,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react351.FormLabel, {
            htmlFor: "absence-accepting-user",
            children: t("ABSENCE_ACCEPTING_USER")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form21.Controller, {
            control,
            name: "acceptingUser",
            rules: {
              required: true
            },
            render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSelect_default, {
              inputId: "absence-accepting-user",
              options: userUsers,
              withAvatars: true,
              isReadOnly: [0, 1, 2].includes(status) || !hasCredential("acceptingUser", "field", "edit"),
              ...field
            })
          })
        ]
      }),
      hasCredential("applicationType", "field", "show") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react351.FormControl, {
        isRequired: true,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react351.FormLabel, {
            htmlFor: "absence-application-type",
            children: t("ABSENCE_APPLICATION_TYPE")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form21.Controller, {
            control,
            name: "applicationType",
            rules: {
              required: true
            },
            render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSelect_default, {
              inputId: "absence-application-type",
              options: translatedTypes,
              isClearable: false,
              isReadOnly: [0, 1, 2].includes(status) || !hasCredential("applicationType", "field", "edit"),
              ...field
            })
          })
        ]
      }),
      hasCredential("dateFrom", "field", "show") && hasCredential("dateTo", "field", "show") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react351.FormControl, {
        isRequired: true,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react351.FormLabel, {
            htmlFor: "absence-date-from",
            children: t("ABSENCE_DATE")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react351.Stack, {
            isInline: true,
            alignItems: "center",
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form21.Controller, {
                control,
                name: "dateFrom",
                rules: {
                  required: true
                },
                render: ({ field: { ref, ...field } }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(DateInput_default, {
                  id: "absence-date-from",
                  className: "absence__create-modal__date-from",
                  lang: language,
                  isClearable: false,
                  isDisabled: [0, 1, 2].includes(status) || !hasCredential("dateFrom", "field", "edit"),
                  ...field
                })
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react351.Text, {
                children: "-"
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form21.Controller, {
                control,
                name: "dateTo",
                rules: {
                  required: true
                },
                render: ({ field: { ref, ...field } }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(DateInput_default, {
                  id: "absence-date-to",
                  className: "absence__create-modal__date-to",
                  lang: language,
                  isClearable: false,
                  isDisabled: [0, 1, 2].includes(status) || !hasCredential("dateTo", "field", "edit"),
                  minDate: dateFrom && new Date(dateFrom),
                  ...field
                })
              })
            ]
          })
        ]
      }),
      hasCredential("applicantNotes", "field", "show") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react351.FormControl, {
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react351.FormLabel, {
            htmlFor: "absence-applicant-notes",
            children: t("ABSENCE_APPLICANT_NOTES")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form21.Controller, {
            control,
            name: "applicantNotes",
            render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraTextarea_default, {
              id: "absence-applicant-notes",
              isReadOnly: [0, 1, 2].includes(status) || !hasCredential("applicantNotes", "field", "edit"),
              ...field
            })
          })
        ]
      }),
      hasCredential("accepteeNotes", "field", "show") && (status === 0 && (user == null ? void 0 : user.id) === ((_a2 = defaultData == null ? void 0 : defaultData.acceptingUser) == null ? void 0 : _a2.id) || [1, 2].includes(status)) && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react351.FormControl, {
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react351.FormLabel, {
            htmlFor: "absence-acceptee-notes",
            children: t("ABSENCE_ACCEPTEE_NOTES")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form21.Controller, {
            control,
            name: "accepteeNotes",
            render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraTextarea_default, {
              id: "absence-acceptee-notes",
              isReadOnly: [1, 2].includes(status) || !hasCredential("accepteeNotes", "field", "edit"),
              ...field
            })
          })
        ]
      })
    ]
  });
};
var ModalAbsence_default = withCredentials2(ModalAbsence);

// src/components/ModalAbsenceLimit/ModalAbsenceLimit.tsx
var import_react353 = require("@chakra-ui/react");
var import_react354 = require("react");
var import_react_hook_form22 = require("react-hook-form");
var import_api22 = require("@questy/api");
var import_lib7 = require("@questy/lib");
var import_react_query40 = require("react-query");
var import_jsx_runtime = require("react/jsx-runtime");
var withCredentials3 = (Component) => {
  return ({ ...props }) => {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_lib7.CredentialContextProvider, {
      module: "user_user_absence_limits",
      initialModuleParams: {},
      ...props.initialCredentials && {
        initialCredentials: props.initialCredentials
      },
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Component, {
        ...props
      })
    });
  };
};
var currentYear = new Date().getFullYear();
var years = [];
for (i = currentYear - 1; i < currentYear + 4; i++) {
  years.push({
    value: i,
    label: i
  });
}
var i;
var ModalAbsenceLimit = ({
  id,
  isOpen,
  onClose,
  afterSuccess
}) => {
  const { data, isLoading } = (0, import_react_query40.useQuery)(
    ["absenceLimit", id],
    () => api_default.getEndpointById("user_user_absence_limits", id, {
      params: {
        "setting[with_relations]": "true",
        extra_fields: "user.fullName"
      }
    }),
    {
      enabled: !!id && isOpen,
      refetchOnWindowFocus: true,
      cacheTime: 0
    }
  );
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(AuraModal, {
    size: "lg",
    isOpen,
    onClose,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalOverlay, {}),
      isLoading ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSpinner_default, {}) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ModalAbsenceLimitContent, {
        isOpen,
        defaultData: data == null ? void 0 : data.data,
        onClose,
        afterSuccess
      })
    ]
  });
};
var ModalAbsenceLimitContent = ({
  isOpen,
  defaultData,
  onClose,
  afterSuccess
}) => {
  var _a2, _b;
  const { t } = useAuraTranslation_default();
  const { resolveApiError } = useAuraErrorResolver_default();
  const toast = (0, import_react353.useToast)();
  const id = defaultData == null ? void 0 : defaultData.id;
  const { hasModuleCredential } = (0, import_lib7.useCredentials)();
  const [isSubmitBtnDisabled, setIsSubmitBtnDisabled] = (0, import_react354.useState)(false);
  const { control, formState, handleSubmit, reset } = (0, import_react_hook_form22.useForm)(
    {
      defaultValues: {
        ...defaultData,
        year: {
          value: (defaultData == null ? void 0 : defaultData.year) ?? currentYear,
          label: (defaultData == null ? void 0 : defaultData.year) ?? currentYear.toString()
        },
        ...(defaultData == null ? void 0 : defaultData.user) && {
          user: {
            value: (_a2 = defaultData == null ? void 0 : defaultData.user) == null ? void 0 : _a2.id,
            label: (_b = defaultData == null ? void 0 : defaultData.user) == null ? void 0 : _b.fullName
          }
        }
      }
    }
  );
  (0, import_react354.useEffect)(() => {
    reset();
  }, [isOpen, reset]);
  const handleCreateAbsenceLimit = async (data) => {
    setIsSubmitBtnDisabled(true);
    try {
      const response = await (0, import_api22.createUserUserAbsenceLimit)({
        data: {
          user: { id: data.user.value },
          year: data.year.value,
          daysOfLeavePerYear: data.daysOfLeavePerYear
        }
      });
      if (response.errors === null) {
        toast({
          title: t("NOTICE_SAVE_SUCCESS"),
          status: "success"
        });
        afterSuccess == null ? void 0 : afterSuccess();
        onClose();
      }
    } catch (error) {
      resolveApiError(error);
      setIsSubmitBtnDisabled(false);
    }
  };
  const handleEdit = async (data) => {
    setIsSubmitBtnDisabled(true);
    try {
      const response = await (0, import_api22.updateUserUserAbsenceLimit)(defaultData.id, {
        data: {
          daysOfLeavePerYear: data.daysOfLeavePerYear
        }
      });
      if (response.errors === null) {
        toast({
          title: t("NOTICE_SAVE_SUCCESS"),
          status: "success"
        });
        afterSuccess == null ? void 0 : afterSuccess();
        onClose();
      }
    } catch (error) {
      resolveApiError(error);
      setIsSubmitBtnDisabled(false);
    }
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(AuraModalContent, {
    as: "form",
    onSubmit: handleSubmit(handleCreateAbsenceLimit),
    className: "absence-limit__create-modal",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalHeader, {
        className: "absence-limit__create-modal__header",
        children: id ? t("EDIT_ABSENCE_LIMIT") : t("NEW_ABSENCE_LIMIT")
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalBody, {
        overflowY: "visible",
        className: "absence-limit__create-modal__body",
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AbsenceLimitCreateForm, {
          control,
          defaultData
        })
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(AuraModalFooter, {
        className: "absence-limit__create-modal__footer",
        showBorders: false,
        children: [
          !id && hasModuleCredential("create") && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react353.Button, {
            className: "absence-limit__create-modal__footer-button",
            textTransform: "capitalize",
            isLoading: formState.isSubmitting || isSubmitBtnDisabled,
            type: "submit",
            colorScheme: "blue",
            children: t("SAVE")
          }),
          id && hasModuleCredential("edit") && (defaultData == null ? void 0 : defaultData.year) >= currentYear && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react353.Button, {
            className: "absence-limit__edit-modal__footer-button",
            textTransform: "capitalize",
            isLoading: formState.isSubmitting || isSubmitBtnDisabled,
            onClick: handleSubmit(handleEdit),
            colorScheme: "blue",
            children: t("SAVE")
          })
        ]
      })
    ]
  });
};
var AbsenceLimitCreateForm = ({
  control,
  defaultData
}) => {
  const { hasCredential } = (0, import_lib7.useCredentials)();
  const { errors } = (0, import_react_hook_form22.useFormState)({ control });
  const id = defaultData == null ? void 0 : defaultData.id;
  const year = defaultData == null ? void 0 : defaultData.year;
  const { t } = useAuraTranslation_default();
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react353.Stack, {
    spacing: 4,
    "data-testid": "create-absence-limit-form",
    className: "absence-limit__create-modal__form",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react353.Flex, {
        justifyContent: "flex-end",
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react353.Text, {
            textStyle: "bodyInput",
            color: "red.500",
            mr: "16px",
            children: "*"
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react353.Text, {
            textStyle: "bodyInput",
            color: "blackAlpha.500",
            children: t("REQUIRED")
          })
        ]
      }),
      hasCredential("user", "field", "show") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react353.FormControl, {
        isRequired: true,
        isInvalid: !!(errors == null ? void 0 : errors.user),
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react353.FormLabel, {
            htmlFor: "absence-limit-user",
            children: t("ABSENCE_LIMIT_USER")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form22.Controller, {
            control,
            name: "user",
            rules: {
              required: true
            },
            render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSelect_default, {
              inputId: "absence-limit-user",
              loadDataProps: {
                endpoint: "user_users",
                labelField: "fullName",
                settings: {
                  extra_fields: "fullName",
                  "order[_q]": "DESC"
                }
              },
              closeMenuOnSelect: true,
              isReadOnly: !!id,
              ...field
            })
          })
        ]
      }),
      hasCredential("year", "field", "show") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react353.FormControl, {
        isRequired: true,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react353.FormLabel, {
            htmlFor: "absence-limit-year",
            children: t("ABSENCE_LIMIT_YEAR")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form22.Controller, {
            control,
            name: "year",
            rules: {
              required: true
            },
            render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSelect_default, {
              inputId: "absence-limit-year",
              options: years,
              isReadOnly: !!id,
              ...field
            })
          })
        ]
      }),
      hasCredential("daysOfLeavePerYear", "field", "edit") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react353.FormControl, {
        isRequired: true,
        isInvalid: !!(errors == null ? void 0 : errors.daysOfLeavePerYear),
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react353.FormLabel, {
            htmlFor: "absence-limit-days",
            children: t("ABSENCE_LIMIT_DAYS")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form22.Controller, {
            control,
            name: "daysOfLeavePerYear",
            rules: {
              required: true
            },
            render: ({ field }) => year < currentYear ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraInput_default, {
              id: "absence-limit-days",
              isReadOnly: true,
              ...field
            }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react353.NumberInput, {
              id: "absence-limit-days",
              backgroundColor: "white",
              h: "40px",
              ...field,
              children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react353.NumberInputField, {
                borderRadius: "6px"
              })
            })
          })
        ]
      })
    ]
  });
};
var ModalAbsenceLimit_default = withCredentials3(ModalAbsenceLimit);

// src/components/ModalAccountUser/ModalAccountUser.tsx
var import_react359 = require("@chakra-ui/react");
var import_api24 = require("@questy/api");
var import_lib10 = require("@questy/lib");
var import_react360 = require("react");
var import_react_hook_form25 = require("react-hook-form");
var import_react_query42 = require("react-query");

// src/components/ModalAccountUser/ModalContent/ModalContent.tsx
var import_react358 = require("@chakra-ui/react");
var import_lib9 = require("@questy/lib");
var import_react_hook_form24 = require("react-hook-form");

// src/components/ModalAccountUser/FormFields/FormFields.tsx
var import_react355 = require("@chakra-ui/react");
var import_js55 = require("@mdi/js");
var import_react356 = __toESM(require("@mdi/react"));
var import_lib8 = require("@questy/lib");
var import_react357 = require("react");
var import_react_hook_form23 = require("react-hook-form");
var import_react_query41 = require("react-query");
var import_jsx_runtime = require("react/jsx-runtime");
var FormFields = ({
  allowCreateNewCompany,
  onOpenModalCompany
}) => {
  var _a2, _b, _c, _d, _e, _f, _g, _h;
  const { t } = useAuraTranslation_default();
  const {
    control,
    formState: { errors }
  } = (0, import_react_hook_form23.useFormContext)();
  const { hasCredential, meta } = (0, import_lib8.useCredentials)();
  const availableAttributes = (0, import_react357.useMemo)(
    () => {
      var _a3, _b2, _c2, _d2;
      return (_d2 = (_c2 = (_b2 = (_a3 = meta == null ? void 0 : meta.extra_fields) == null ? void 0 : _a3.attributes) == null ? void 0 : _b2.items) == null ? void 0 : _c2.filter((attr) => (attr == null ? void 0 : attr.credential) > 1)) == null ? void 0 : _d2.map((attr) => {
        if ((attr == null ? void 0 : attr.type) === "tags") {
          return {
            ...attr,
            options: {
              ...(attr == null ? void 0 : attr.options) ?? {},
              hideCopyAction: true
            }
          };
        }
        return attr;
      });
    },
    [meta]
  );
  const { data: moduleAccountCompanyCredential } = (0, import_react_query41.useQuery)(
    ["accountCompany", "meta", "moduleCredential"],
    () => api_default.getMeta("account_companies"),
    {
      select: (data) => {
        var _a3;
        return (_a3 = data == null ? void 0 : data.data) == null ? void 0 : _a3.module.credential;
      }
    }
  );
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react355.VStack, {
    children: [
      hasCredential("firstName", "field", "show") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react355.FormControl, {
        isInvalid: !!errors.firstName,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react355.FormLabel, {
            htmlFor: "account-user__first-name",
            children: [
              t("LIST_COLUMN_firstName"),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraRequiredIndicator_default, {})
            ]
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form23.Controller, {
            control,
            name: "firstName",
            rules: {
              required: {
                value: true,
                message: "ERROR_FIELD_IS_EMPTY"
              }
            },
            render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraInput_default, {
              id: "account-user__first-name",
              ...field
            })
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react355.FormErrorMessage, {
            children: t((_a2 = errors == null ? void 0 : errors.firstName) == null ? void 0 : _a2.message)
          })
        ]
      }),
      hasCredential("lastName", "field", "show") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react355.FormControl, {
        isInvalid: !!errors.lastName,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react355.FormLabel, {
            htmlFor: "account-user__last-name",
            children: [
              t("LIST_COLUMN_lastName"),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraRequiredIndicator_default, {})
            ]
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form23.Controller, {
            control,
            name: "lastName",
            rules: {
              required: {
                value: true,
                message: "ERROR_FIELD_IS_EMPTY"
              }
            },
            render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraInput_default, {
              id: "account-user__last-name",
              ...field
            })
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react355.FormErrorMessage, {
            children: t((_b = errors == null ? void 0 : errors.lastName) == null ? void 0 : _b.message)
          })
        ]
      }),
      hasCredential("phoneNumber", "field", "show") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react355.FormControl, {
        isInvalid: !!errors.phoneNumber,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react355.FormLabel, {
            htmlFor: "account-user__phone-number",
            children: t("LIST_COLUMN_phoneNumber")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form23.Controller, {
            control,
            name: "phoneNumber",
            render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraInput_default, {
              id: "account-user__phone-number",
              ...field
            })
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react355.FormErrorMessage, {
            children: t((_c = errors == null ? void 0 : errors.phoneNumber) == null ? void 0 : _c.message)
          })
        ]
      }),
      hasCredential("mobileNumber", "field", "show") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react355.FormControl, {
        isInvalid: !!errors.mobileNumber,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react355.FormLabel, {
            htmlFor: "account-user__mobile-number",
            children: t("LIST_COLUMN_mobileNumber")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form23.Controller, {
            control,
            name: "mobileNumber",
            render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraInput_default, {
              id: "account-user__mobile-number",
              ...field
            })
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react355.FormErrorMessage, {
            children: t((_d = errors == null ? void 0 : errors.mobileNumber) == null ? void 0 : _d.message)
          })
        ]
      }),
      hasCredential("email", "field", "show") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react355.FormControl, {
        isInvalid: !!errors.email,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react355.FormLabel, {
            htmlFor: "account-user__email",
            children: t("LIST_COLUMN_email")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form23.Controller, {
            control,
            name: "email",
            render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraInput_default, {
              id: "account-user__email",
              type: "email",
              ...field
            })
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react355.FormErrorMessage, {
            children: t((_e = errors == null ? void 0 : errors.email) == null ? void 0 : _e.message)
          })
        ]
      }),
      hasCredential("company", "field", "show") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react355.FormControl, {
        isInvalid: !!errors.company,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react355.FormLabel, {
            htmlFor: "account-user__company",
            children: t("LIST_COLUMN_company")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form23.Controller, {
            control,
            name: "company",
            render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react355.HStack, {
              w: "full",
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react355.Box, {
                  w: "full",
                  children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSelect_default, {
                    id: "account-user__company",
                    isClearable: true,
                    isError: !!errors.company,
                    loadDataProps: {
                      endpoint: "account_companies",
                      labelField: "displayName",
                      settings: {
                        fields: "id",
                        extra_fields: "displayName",
                        "order[_q]": "DESC"
                      }
                    },
                    isReadOnly: !allowCreateNewCompany,
                    ...field
                  })
                }),
                moduleAccountCompanyCredential > 2 && allowCreateNewCompany && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, {
                  children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react355.Tooltip, {
                    label: t("ADD_NEW"),
                    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react355.IconButton, {
                      w: "40px",
                      h: "40px",
                      "aria-label": "Create new company",
                      icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react356.default, {
                        path: import_js55.mdiPlus,
                        size: "20px"
                      }),
                      onClick: onOpenModalCompany
                    })
                  })
                })
              ]
            })
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react355.FormErrorMessage, {
            children: t((_f = errors == null ? void 0 : errors.company) == null ? void 0 : _f.message)
          })
        ]
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react355.Box, {
        w: "full",
        id: "account-user__attributes",
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Attributes_default, {
          toForm: true,
          attributes: availableAttributes,
          module: "account_users"
        })
      }),
      hasCredential("consentProcessingPersonalData", "field", "show") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react355.FormControl, {
        isInvalid: !!errors.consentProcessingPersonalData,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react355.FormLabel, {
            htmlFor: "account-user__consent-processing-personal-data",
            children: t("LIST_COLUMN_consentProcessingPersonalData")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form23.Controller, {
            control,
            name: "consentProcessingPersonalData",
            render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AttributeBoolean_default, {
              id: "account-user__consent-processing-personal-data",
              ...field
            })
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react355.FormErrorMessage, {
            children: t((_g = errors == null ? void 0 : errors.consentProcessingPersonalData) == null ? void 0 : _g.message)
          })
        ]
      }),
      hasCredential("newsletterActive", "field", "show") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react355.FormControl, {
        isInvalid: !!errors.newsletterActive,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react355.FormLabel, {
            htmlFor: "account-user__newsletter-active",
            children: t("LIST_COLUMN_newsletterActive")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form23.Controller, {
            control,
            name: "newsletterActive",
            render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AttributeBoolean_default, {
              id: "account-user__newsletter-active",
              ...field
            })
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react355.FormErrorMessage, {
            children: t((_h = errors == null ? void 0 : errors.newsletterActive) == null ? void 0 : _h.message)
          })
        ]
      })
    ]
  });
};
var FormFields_default = FormFields;

// src/components/ModalAccountUser/ModalContent/ModalContent.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var ModalContent3 = ({
  isLoading,
  allowCreateNewCompany,
  onSubmit,
  onOpenModalCompany
}) => {
  const { t } = useAuraTranslation_default();
  const { handleSubmit, formState } = (0, import_react_hook_form24.useFormContext)();
  const { hasModuleCredential } = (0, import_lib9.useCredentials)();
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(AuraModalContent, {
    as: "form",
    onSubmit: handleSubmit(onSubmit),
    className: "account_user__create-modal",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalHeader, {
        showBorders: false,
        className: "account_user__create-modal__header",
        children: t("NEW_ACCOUNT_USER")
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalBody, {
        overflowY: "visible",
        className: "account_user__create-modal__body",
        children: isLoading ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSpinner_default, {}) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react358.Box, {
          w: "full",
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FormFields_default, {
            onOpenModalCompany,
            allowCreateNewCompany
          })
        })
      }),
      !isLoading && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalFooter, {
        className: "account_user__create-modal__footer",
        showBorders: false,
        children: hasModuleCredential("create") && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react358.Button, {
          className: "account_user__create-modal__footer__button-create",
          isLoading: formState.isSubmitting,
          type: "submit",
          colorScheme: "blue",
          textTransform: "capitalize",
          children: t("SAVE")
        })
      })
    ]
  });
};
var ModalContent_default = ModalContent3;

// src/components/ModalAccountUser/utils.ts
var prepareDataForApi2 = ({
  data,
  hasCredential,
  placeId
}) => {
  var _a2;
  const preparedAttributes = prepareAttributesForApi(
    data == null ? void 0 : data.attributes,
    hasCredential
  );
  return {
    ...(data == null ? void 0 : data.firstName) && {
      firstName: data.firstName
    },
    ...(data == null ? void 0 : data.lastName) && {
      lastName: data.lastName
    },
    ...(data == null ? void 0 : data.email) && {
      email: data.email
    },
    ...(data == null ? void 0 : data.phoneNumber) && {
      phoneNumber: data.phoneNumber
    },
    ...(data == null ? void 0 : data.mobileNumber) && {
      mobileNumber: data.mobileNumber
    },
    ...(data == null ? void 0 : data.consentProcessingPersonalData) && {
      consentProcessingPersonalData: data.consentProcessingPersonalData
    },
    ...(data == null ? void 0 : data.newsletterActive) && {
      newsletterActive: data.newsletterActive
    },
    ...idExists((_a2 = data == null ? void 0 : data.company) == null ? void 0 : _a2.value) && {
      company: data.company.value
    },
    ...idExists(placeId) && {
      place: placeId
    },
    ...!!(preparedAttributes == null ? void 0 : preparedAttributes.length) && {
      attributes: prepareAttributesForApi(data == null ? void 0 : data.attributes, hasCredential)
    }
  };
};

// src/components/ModalAccountUser/ModalAccountUser.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var withCredentials4 = (Component) => {
  return ({ ...props }) => {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_lib10.CredentialContextProvider, {
      module: "account_users",
      initialModuleParams: { extra_fields: "attributes" },
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Component, {
        ...props
      })
    });
  };
};
var ModalAccountUser = ({
  isOpen,
  onClose,
  afterSuccess,
  companyId,
  placeId
}) => {
  const useFormProps = (0, import_react_hook_form25.useForm)({
    shouldUnregister: false
  });
  const { hasCredential, isLoading: isLoadingCampaignOpportunityMeta } = (0, import_lib10.useCredentials)();
  const { t } = useAuraTranslation_default();
  const toast = (0, import_react359.useToast)();
  const { resolveApiError } = useAuraErrorResolver_default();
  const modalDisclousure = (0, import_react359.useDisclosure)();
  const modalCompanyDisclosure = (0, import_react359.useDisclosure)();
  const { data: companyData, isLoading: isLoadingCompanyData } = (0, import_react_query42.useQuery)(
    ["accountCompanies", "forNewAccountUserOpportunity", companyId, isOpen],
    () => (0, import_api24.getAccountCompany)(Number(companyId), {
      fields: ["id"],
      extraFields: ["displayName", "defaultUser.fullName"],
      settings: {
        withRelations: true
      }
    }),
    {
      enabled: idExists(companyId) && isOpen,
      select: (data) => data == null ? void 0 : data.data,
      refetchOnWindowFocus: false
    }
  );
  const onSubmit = async (data) => {
    var _a2;
    const preparedData = prepareDataForApi2({
      data,
      hasCredential,
      placeId
    });
    try {
      const response = await (0, import_api24.createAccountUser)({
        data: preparedData,
        extra_fields: ["fullName", "company.displayName", "place.fullName"],
        settings: {
          withRelations: true
        }
      });
      if (response.errors === null) {
        onClose();
        afterSuccess == null ? void 0 : afterSuccess((_a2 = response == null ? void 0 : response.data) == null ? void 0 : _a2[0]);
        toast({
          title: t("NOTICE_SAVE_SUCCESS"),
          status: "success"
        });
      }
    } catch (error) {
      resolveApiError(error);
    }
  };
  const handleOnOpenModalCompany = () => {
    modalDisclousure.onClose();
    modalCompanyDisclosure.onOpen();
  };
  const handleOnCloseModalCompany = (data) => {
    var _a2, _b, _c;
    modalCompanyDisclosure.onClose();
    modalDisclousure.onOpen();
    if (idExists((_a2 = data == null ? void 0 : data[0]) == null ? void 0 : _a2.id)) {
      useFormProps.setValue("company", {
        value: (_b = data == null ? void 0 : data[0]) == null ? void 0 : _b.id,
        label: (_c = data == null ? void 0 : data[0]) == null ? void 0 : _c.displayName,
        isNew: true
      });
      useFormProps.trigger("company");
    }
  };
  (0, import_react360.useEffect)(() => {
    if (isOpen) {
      modalDisclousure.onOpen();
      useFormProps.reset({
        ...companyData && {
          company: {
            value: companyData.id,
            label: companyData.displayName
          }
        }
      });
    } else {
      modalDisclousure.onClose();
    }
  }, [isOpen, companyData]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(AuraModal, {
        size: "lg",
        isOpen: modalDisclousure.isOpen,
        onClose,
        closeOnOverlayClick: false,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalOverlay, {}),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form25.FormProvider, {
            ...useFormProps,
            children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ModalContent_default, {
              onSubmit,
              onOpenModalCompany: handleOnOpenModalCompany,
              isLoading: isLoadingCompanyData || isLoadingCampaignOpportunityMeta,
              allowCreateNewCompany: !idExists(placeId)
            })
          })
        ]
      }),
      !idExists(placeId) && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ModalCompany_default, {
        isOpen: modalCompanyDisclosure.isOpen,
        onClose: handleOnCloseModalCompany,
        afterSuccess: handleOnCloseModalCompany
      })
    ]
  });
};
var ModalAccountUser_default = withCredentials4(ModalAccountUser);

// src/components/ModalAdditionalI18n/ModalAdditionalI18n.tsx
var import_react364 = require("@chakra-ui/react");
var import_api25 = require("@questy/api");
var import_lib11 = require("@questy/lib");
var import_react365 = require("react");
var import_react_hook_form26 = require("react-hook-form");
var import_react_query43 = require("react-query");

// src/components/CustomProductOption/CustomProductOption.tsx
var import_react361 = require("@chakra-ui/react");
var import_react362 = require("react");
var import_jsx_runtime = require("react/jsx-runtime");
var CustomProductOption = (props) => {
  const { innerRef, innerProps, data, isFocused, selectProps } = props;
  const availability = data == null ? void 0 : data.availabilityLabel;
  const withThumbnail = (0, import_react362.useMemo)(
    () => {
      var _a2;
      return ((_a2 = selectProps == null ? void 0 : selectProps.customComponentsProps) == null ? void 0 : _a2.withThumbnail) || false;
    },
    [selectProps]
  );
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react361.Box, {
    className: "select__option",
    _hover: {
      bg: "gray.100"
    },
    bgColor: isFocused ? "gray.100" : "#fff",
    color: "gray.700",
    fontSize: "15px",
    py: "10px",
    px: "16px",
    cursor: "pointer",
    fontWeight: "400",
    ref: innerRef,
    ...withThumbnail && { height: "100px" },
    ...innerProps,
    children: [
      withThumbnail && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ProductImage_default, {
        defaultImage: data == null ? void 0 : data.defaultImage,
        name: data == null ? void 0 : data.label,
        width: "80px",
        height: "80px",
        float: "left",
        mr: "2"
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react361.Box, {
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react361.Text, {
            fontSize: "md",
            display: "block",
            letterSpacing: "mediumWide",
            lineHeight: "18px",
            whiteSpace: "normal",
            overflow: "hidden",
            textOverflow: "ellipsis",
            title: data.label,
            noOfLines: 2,
            children: data.label
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react361.Text, {
            mt: 1,
            fontSize: "sm",
            letterSpacing: "0.25px",
            color: "gray.500",
            lineHeight: "20px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            title: data.additionalName,
            noOfLines: 1,
            children: data.additionalName
          }),
          availability && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react361.Text, {
            mt: 1,
            fontSize: "sm",
            letterSpacing: "0.25px",
            color: "gray.500",
            lineHeight: "20px",
            children: availability
          })
        ]
      })
    ]
  });
};
var CustomProductOption_default = CustomProductOption;

// src/components/AuraSelect/CreatableValueContainer/CreatableValueContainer.tsx
var import_react363 = require("@chakra-ui/react");
var import_react_select12 = require("react-select");
var import_jsx_runtime = require("react/jsx-runtime");
var CreatableValueContainer = ({
  children,
  ...props
}) => {
  var _a2;
  const { selectProps } = props;
  const isNewValue = (_a2 = selectProps.value) == null ? void 0 : _a2.__isNew__;
  const { t } = useAuraTranslation_default();
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_select12.components.ValueContainer, {
        ...props,
        children
      }),
      isNewValue && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react363.Badge, {
        borderRadius: "4px",
        bgColor: "green.500",
        color: "#fff",
        lineHeight: "20px",
        letterSpacing: "0.25px",
        mx: "8px",
        px: "8px",
        children: t("NEW")
      })
    ]
  });
};
var CreatableValueContainer_default = CreatableValueContainer;

// src/components/ModalAdditionalI18n/ModalAdditionalI18n.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var withCredentials5 = (Component) => {
  return ({ ...props }) => {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_lib11.CredentialContextProvider, {
      module: "additional_i18ns",
      initialModuleParams: {},
      ...props.initialCredentials && {
        initialCredentials: props.initialCredentials
      },
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Component, {
        ...props
      })
    });
  };
};
var ModalAdditionalI18n = ({
  id,
  isOpen,
  onClose,
  afterSuccess
}) => {
  const { data, isFetching } = (0, import_react_query43.useQuery)(
    ["additionalI18n", id],
    () => (0, import_api25.getAdditionalI18n)(id),
    {
      enabled: !!id && isOpen
    }
  );
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(AuraModal, {
    size: "lg",
    isOpen,
    onClose,
    closeOnOverlayClick: false,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalOverlay, {}),
      isFetching ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSpinner_default, {}) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ModalAdditionalI18nContent, {
        isOpen,
        defaultData: data == null ? void 0 : data.data,
        onClose,
        afterSuccess
      })
    ]
  });
};
var ModalAdditionalI18nContent = ({
  isOpen,
  defaultData,
  onClose,
  afterSuccess
}) => {
  var _a2;
  const { t } = useAuraTranslation_default();
  const { resolveApiError } = useAuraErrorResolver_default();
  const toast = (0, import_react364.useToast)();
  const id = defaultData == null ? void 0 : defaultData.id;
  const { hasModuleCredential } = (0, import_lib11.useCredentials)();
  const settings = useSettings_default();
  const langs = ((_a2 = settings == null ? void 0 : settings.settings) == null ? void 0 : _a2.availableLanguages) ?? {};
  const parsedObj = JSON.parse(langs);
  const availableLanguagesArray = parsedObj && Object.keys(parsedObj).map((key) => ({
    value: key,
    label: parsedObj[key]
  }));
  const defaultLangOption = availableLanguagesArray == null ? void 0 : availableLanguagesArray.find(
    (lang) => {
      var _a3;
      return lang.value === ((defaultData == null ? void 0 : defaultData.lang) ?? ((_a3 = settings == null ? void 0 : settings.settings) == null ? void 0 : _a3.defaultLanguage));
    }
  );
  const { control, formState, handleSubmit, reset, setValue } = (0, import_react_hook_form26.useForm)({
    defaultValues: {
      ...defaultData,
      ...defaultData && {
        source: { value: defaultData == null ? void 0 : defaultData.source, label: defaultData == null ? void 0 : defaultData.source }
      },
      lang: defaultLangOption
    }
  });
  (0, import_react365.useEffect)(() => {
    reset();
  }, [isOpen, reset]);
  const handleCreateAdditionalI18n = async (data) => {
    try {
      const response = await (0, import_api25.createAdditionalI18n)({
        data: {
          source: data.source.label,
          target: data.target,
          lang: data.lang.value
        }
      });
      if (response.errors === null) {
        toast({
          title: t("NOTICE_SAVE_SUCCESS"),
          status: "success"
        });
        afterSuccess == null ? void 0 : afterSuccess();
        onClose();
      }
    } catch (error) {
      resolveApiError(error);
    }
  };
  const handleEdit = async (data) => {
    try {
      const response = await (0, import_api25.updateAdditionalI18n)(defaultData.id, {
        data: {
          source: data.source.label,
          target: data.target,
          lang: data.lang.value
        }
      });
      if (response.errors === null) {
        toast({
          title: t("NOTICE_SAVE_SUCCESS"),
          status: "success"
        });
        afterSuccess == null ? void 0 : afterSuccess();
        onClose();
      }
    } catch (error) {
      resolveApiError(error);
    }
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(AuraModalContent, {
    as: "form",
    onSubmit: handleSubmit(handleCreateAdditionalI18n),
    className: "additional-i18n__create-modal",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalHeader, {
        className: "additional-i18n__create-modal__header",
        children: id ? t("TRANSLATION") : t("NEW_TRANSLATION")
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalBody, {
        overflowY: "visible",
        className: "additional-i18n__create-modal__body",
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AdditionalI18nCreateForm, {
          control,
          defaultData,
          setValue
        })
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalFooter, {
        className: "additional-i18n__create-modal__footer",
        showBorders: false,
        children: hasModuleCredential("create") && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react364.Button, {
          className: "additional-i18n__create-modal__footer-button",
          textTransform: "capitalize",
          isLoading: formState.isSubmitting,
          type: "submit",
          colorScheme: "blue",
          children: t("SAVE")
        })
      })
    ]
  });
};
var customPrepareData2 = (data) => data == null ? void 0 : data.map((item) => ({
  value: item == null ? void 0 : item.id,
  label: item == null ? void 0 : item.source,
  additionalName: item == null ? void 0 : item.lang,
  ...item
}));
var AdditionalI18nCreateForm = ({
  control,
  defaultData,
  setValue
}) => {
  var _a2, _b;
  const { t } = useAuraTranslation_default();
  const { hasCredential } = (0, import_lib11.useCredentials)();
  const { errors } = (0, import_react_hook_form26.useFormState)({ control });
  const id = defaultData == null ? void 0 : defaultData.id;
  const settings = useSettings_default();
  const availableLanguages = (0, import_react365.useMemo)(() => {
    var _a3;
    const langs = ((_a3 = settings == null ? void 0 : settings.settings) == null ? void 0 : _a3.availableLanguages) ?? {};
    const parsedObj = JSON.parse(langs);
    const availableLanguagesArray = parsedObj && Object.keys(parsedObj).map((key) => ({
      value: key,
      label: parsedObj[key]
    }));
    return buildOptions(availableLanguagesArray, "label", "value");
  }, [settings]);
  const handleInputChange = (inputValue, action) => {
    if ((inputValue || action.prevInputValue) && !["input-blur", "menu-close"].includes(action.action)) {
      setValue("source", {
        label: inputValue,
        value: inputValue,
        __isNew__: !!inputValue
      });
    }
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react364.Stack, {
    spacing: 4,
    id: "additional-i18n-create-form",
    className: "additional-i18n__create-modal__form",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react364.Flex, {
        justifyContent: "flex-end",
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react364.Text, {
            textStyle: "bodyInput",
            color: "red.500",
            mr: "16px",
            children: "*"
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react364.Text, {
            textStyle: "bodyInput",
            color: "blackAlpha.500",
            children: t("REQUIRED")
          })
        ]
      }),
      hasCredential("source", "field", "show") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react364.FormControl, {
        isInvalid: !!(errors == null ? void 0 : errors.source),
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react364.FormLabel, {
            htmlFor: "source",
            children: [
              t("LIST_COLUMN_source"),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraRequiredIndicator_default, {})
            ]
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form26.Controller, {
            control,
            name: "source",
            rules: {
              required: {
                value: true,
                message: "ERROR_FIELD_IS_EMPTY"
              }
            },
            render: ({ field }) => {
              var _a3;
              return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSelect_default, {
                inputId: "source",
                loadDataProps: {
                  endpoint: "additional_i18ns",
                  labelField: "source",
                  queryField: "source",
                  customPrepareData: customPrepareData2,
                  settings: {
                    fields: "source,target,lang"
                  }
                },
                components: {
                  Option: CustomProductOption_default,
                  ValueContainer: CreatableValueContainer_default
                },
                onInputChange: handleInputChange,
                ...field,
                onChange: (value, changedOption) => {
                  setValue("source", value);
                  setValue("target", value == null ? void 0 : value.target);
                  setValue(
                    "lang",
                    availableLanguages == null ? void 0 : availableLanguages.find(
                      (lang) => lang.value === (value == null ? void 0 : value.lang)
                    )
                  );
                  setValue("id", value == null ? void 0 : value.id);
                },
                defaultInputValue: (_a3 = field == null ? void 0 : field.value) == null ? void 0 : _a3.value
              });
            }
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react364.FormErrorMessage, {
            children: t((_a2 = errors == null ? void 0 : errors.source) == null ? void 0 : _a2.message)
          })
        ]
      }),
      hasCredential("target", "field", "show") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react364.FormControl, {
        isInvalid: !!(errors == null ? void 0 : errors.target),
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react364.FormLabel, {
            htmlFor: "target",
            children: [
              t("LIST_COLUMN_target"),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraRequiredIndicator_default, {})
            ]
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form26.Controller, {
            control,
            name: "target",
            rules: {
              required: {
                value: true,
                message: "ERROR_FIELD_IS_EMPTY"
              }
            },
            render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraInput_default, {
              id: "target",
              ...field
            })
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react364.FormErrorMessage, {
            children: t((_b = errors == null ? void 0 : errors.target) == null ? void 0 : _b.message)
          })
        ]
      }),
      hasCredential("lang", "field", "edit") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react364.FormControl, {
        isInvalid: !!(errors == null ? void 0 : errors.lang),
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react364.FormLabel, {
            htmlFor: "lang",
            children: [
              t("LIST_COLUMN_lang"),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraRequiredIndicator_default, {})
            ]
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form26.Controller, {
            control,
            name: "lang",
            rules: {
              required: true
            },
            render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSelect_default, {
              inputId: "lang",
              options: availableLanguages,
              isClearable: false,
              ...field
            })
          })
        ]
      })
    ]
  });
};
var ModalAdditionalI18n_default = withCredentials5(ModalAdditionalI18n);

// src/components/ModalAddress/ModalAddress.tsx
var import_lib12 = require("@questy/lib");
var import_react367 = require("react");
var import_react_query44 = require("react-query");
var import_api26 = require("@questy/api");
var import_react368 = require("@chakra-ui/react");
var import_react_hook_form27 = require("react-hook-form");
var import_api27 = require("@questy/api");

// src/components/AuraCountrySelect/AuraCountrySelect.tsx
var import_react366 = require("react");
var import_react_select_country_list3 = __toESM(require("react-select-country-list"));
var import_orderBy5 = __toESM(require("lodash/orderBy"));
var import_jsx_runtime = require("react/jsx-runtime");
var AuraCountrySelect = ({ value, onChange, ...props }) => {
  const { currentLocale } = (0, import_react366.useContext)(LanguageContext);
  const regionNames = new Intl.DisplayNames([(currentLocale == null ? void 0 : currentLocale.code) ?? "pl"], {
    type: "region"
  });
  const parsedValue = (0, import_react366.useMemo)(
    () => value === "POLAND" ? "PL" : value,
    [value]
  );
  const countries = (0, import_react366.useMemo)(
    () => {
      var _a2;
      return (0, import_orderBy5.default)(
        (_a2 = (0, import_react_select_country_list3.default)().getData()) == null ? void 0 : _a2.map((country) => ({
          ...country,
          label: regionNames.of(country.value)
        })),
        "label",
        "asc"
      );
    },
    []
  );
  const selectedCountry = (0, import_react366.useMemo)(
    () => countries == null ? void 0 : countries.find(
      (country) => country.value === parsedValue || country.label === parsedValue
    ),
    [countries, value, parsedValue]
  );
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSelect_default, {
    ...props,
    options: countries,
    value: selectedCountry,
    onChange: (newValue) => {
      onChange((newValue == null ? void 0 : newValue.value) ?? null);
    }
  });
};
var AuraCountrySelect_default = AuraCountrySelect;

// src/components/ModalAddress/ModalAddress.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var withCredentials6 = (Component) => {
  return ({ ...props }) => {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_lib12.CredentialContextProvider, {
      module: "places",
      initialModuleParams: { extra_fields: "attributes" },
      ...props.initialCredentials && {
        initialCredentials: props.initialCredentials
      },
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Component, {
        ...props
      })
    });
  };
};
var ModalAddress = ({
  id,
  isOpen,
  onClose,
  afterSuccess,
  companyId
}) => {
  var _a2;
  const { data, isFetching } = (0, import_react_query44.useQuery)(
    ["place", id],
    () => (0, import_api26.getPlace)(id, {
      fields: [
        "name",
        "company",
        "description",
        "streetAddress",
        "streetNumber",
        "localNumber",
        "postalCode",
        "city",
        "community",
        "county",
        "province",
        "country",
        "email",
        "phoneNumber",
        "mainAddress"
      ],
      extraFields: ["attributes"],
      settings: {
        withRelations: true
      }
    }),
    {
      enabled: idExists(id) && isOpen,
      refetchOnWindowFocus: false
    }
  );
  const { data: dataCompany, isLoading: isLoadingCompany } = (0, import_react_query44.useQuery)(
    ["company", companyId],
    () => (0, import_api27.getAccountCompany)(companyId, {
      extraFields: ["displayName"]
    }),
    {
      enabled: !idExists(id) && idExists(companyId) && isOpen
    }
  );
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(AuraModal, {
    size: "lg",
    isOpen,
    onClose,
    closeOnOverlayClick: false,
    scrollBehavior: "inside",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalOverlay, {}),
      isFetching || isLoadingCompany ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSpinner_default, {}) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ModalAddressContent, {
        defaultData: (data == null ? void 0 : data.data) ?? {
          company: {
            value: companyId,
            label: (_a2 = dataCompany == null ? void 0 : dataCompany.data) == null ? void 0 : _a2.displayName
          }
        },
        onClose,
        afterSuccess
      })
    ]
  });
};
var ModalAddressContent = ({
  defaultData,
  onClose,
  afterSuccess
}) => {
  var _a2, _b, _c, _d, _e;
  const { t } = useAuraTranslation_default();
  const { resolveApiError } = useAuraErrorResolver_default();
  const { currentLocale } = (0, import_react367.useContext)(LanguageContext);
  const toast = (0, import_react368.useToast)();
  const id = defaultData == null ? void 0 : defaultData.id;
  const { hasModuleCredential, hasCredential } = (0, import_lib12.useCredentials)();
  const countryCodeSelector = (_b = (_a2 = useSettings_default()) == null ? void 0 : _a2.settings) == null ? void 0 : _b.countryCodeSelector;
  const [formIsDirty, setFormIsDirty] = (0, import_react367.useState)(false);
  const [isSubmitBtnDisabled, setIsSubmitBtnDisabled] = (0, import_react367.useState)(false);
  const defaultValueFieldCountry = (0, import_react367.useMemo)(() => {
    const defaultValue = defaultData == null ? void 0 : defaultData.country;
    if (!(defaultData == null ? void 0 : defaultData.hasOwnProperty("country"))) {
      return countryCodeSelector ? "PL" : getCountryNameByCode("PL", currentLocale);
    } else if (defaultValue && !countryCodeSelector) {
      return getCountryNameByCode(defaultValue, currentLocale);
    }
    return defaultData == null ? void 0 : defaultData.country;
  }, [(_c = defaultData == null ? void 0 : defaultData.country) == null ? void 0 : _c.value, countryCodeSelector]);
  const { mainAddress, ...defaultDataForForm } = defaultData ?? {};
  const useFormProps = (0, import_react_hook_form27.useForm)({
    defaultValues: {
      ...defaultDataForForm,
      country: defaultValueFieldCountry,
      ...id && {
        id
      },
      ...id && (defaultData == null ? void 0 : defaultData.company) && {
        company: {
          value: (_d = defaultData == null ? void 0 : defaultData.company) == null ? void 0 : _d.id,
          label: (_e = defaultData == null ? void 0 : defaultData.company) == null ? void 0 : _e.name
        }
      },
      ...id && defaultData.attributes && {
        attributes: prepareAttributesDefaultValues(defaultData.attributes)
      }
    }
  });
  const {
    register,
    control,
    formState,
    handleSubmit,
    resetField,
    setError,
    setValue,
    watch
  } = useFormProps;
  const handleSubmitForm = async (formData) => {
    setIsSubmitBtnDisabled(true);
    const preparedData = {};
    Object.keys(formData).forEach((filterKey) => {
      if (typeof formData[filterKey] === "string" && formData[filterKey].trim() === "") {
        preparedData[filterKey] = null;
      } else {
        preparedData[filterKey] = formData[filterKey];
      }
    });
    if (defaultData == null ? void 0 : defaultData.id) {
      formIsDirty ? editPlace(preparedData) : onClose();
    } else {
      createNewPlace(preparedData);
    }
  };
  (0, import_react367.useEffect)(() => {
    formState.isDirty && setFormIsDirty(true);
  }, [formState.isDirty]);
  const createNewPlace = async (data) => {
    var _a3, _b2, _c2, _d2, _e2, _f, _g;
    const preparedAttributes = prepareAttributesForApi(
      data == null ? void 0 : data.attributes,
      hasCredential
    );
    const { attributes, ...fields } = data;
    try {
      const response = await (0, import_api27.createPlace)({
        data: {
          ...fields,
          company: data.company.value,
          country: ((_a3 = data.country) == null ? void 0 : _a3.value) ?? data.country,
          ...(preparedAttributes == null ? void 0 : preparedAttributes.length) && {
            attributes: preparedAttributes
          }
        },
        extraFields: ["fullName"]
      });
      if (response.errors === null) {
        toast({
          title: t("NOTICE_SAVE_SUCCESS"),
          status: "success"
        });
        afterSuccess == null ? void 0 : afterSuccess(response.data);
        onClose();
      }
    } catch (error) {
      resolveApiError(error);
      if ((_c2 = (_b2 = error == null ? void 0 : error.response) == null ? void 0 : _b2.data) == null ? void 0 : _c2.errors) {
        setError(
          (_e2 = (_d2 = error.response.data.errors) == null ? void 0 : _d2["item_0"]) == null ? void 0 : _e2[0].field,
          {
            type: "manual",
            message: (_g = (_f = error.response.data.errors) == null ? void 0 : _f["item_0"]) == null ? void 0 : _g[0].type
          },
          {
            shouldFocus: true
          }
        );
        setIsSubmitBtnDisabled(false);
      }
    }
  };
  const editPlace = async (data) => {
    var _a3, _b2, _c2, _d2, _e2, _f, _g;
    const preparedAttributes = prepareAttributesForApi(
      data == null ? void 0 : data.attributes,
      hasCredential
    );
    const { attributes, ...fields } = data;
    try {
      const response = await (0, import_api27.updatePlace)(defaultData.id, {
        data: {
          ...fields,
          company: data.company.value,
          country: ((_a3 = data.country) == null ? void 0 : _a3.value) ?? data.country,
          ...(preparedAttributes == null ? void 0 : preparedAttributes.length) && {
            attributes: preparedAttributes
          }
        }
      });
      if (response.errors === null) {
        toast({
          title: t("NOTICE_SAVE_SUCCESS"),
          status: "success"
        });
        afterSuccess == null ? void 0 : afterSuccess(response.data);
        onClose();
      }
    } catch (error) {
      resolveApiError(error);
      if ((_c2 = (_b2 = error == null ? void 0 : error.response) == null ? void 0 : _b2.data) == null ? void 0 : _c2.errors) {
        setError(
          (_e2 = (_d2 = error.response.data.errors) == null ? void 0 : _d2["item_0"]) == null ? void 0 : _e2[0].field,
          {
            type: "manual",
            message: (_g = (_f = error.response.data.errors) == null ? void 0 : _f["item_0"]) == null ? void 0 : _g[0].type
          },
          {
            shouldFocus: true
          }
        );
      }
    }
    setIsSubmitBtnDisabled(false);
  };
  const handleDeletePlace = async (id2) => {
    var _a3, _b2, _c2, _d2, _e2, _f;
    const shouldDelete = confirm(t("Are you sure?"));
    if (!shouldDelete) {
      return;
    }
    try {
      const response = await (0, import_api27.deletePlace)(id2);
      if (response.errors === null) {
        toast({
          title: t("NOTICE_DELETE_SUCCESS"),
          status: "success"
        });
        afterSuccess == null ? void 0 : afterSuccess(response.data);
        onClose();
      }
    } catch (error) {
      resolveApiError(error);
      if ((_b2 = (_a3 = error == null ? void 0 : error.response) == null ? void 0 : _a3.data) == null ? void 0 : _b2.errors) {
        setError(
          (_d2 = (_c2 = error.response.data.errors) == null ? void 0 : _c2["item_0"]) == null ? void 0 : _d2[0].field,
          {
            type: "manual",
            message: (_f = (_e2 = error.response.data.errors) == null ? void 0 : _e2["item_0"]) == null ? void 0 : _f[0].type
          },
          {
            shouldFocus: true
          }
        );
      }
    }
  };
  const isMainAddress = defaultData == null ? void 0 : defaultData.mainAddress;
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form27.FormProvider, {
    ...useFormProps,
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(AuraModalContent, {
      as: "form",
      onSubmit: handleSubmit(handleSubmitForm),
      className: "place__create-modal",
      h: "100%",
      maxH: { base: "100%", md: "calc(100% - 120px)" },
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalHeader, {
          className: "place__create-modal__header",
          children: id ? t("ADDRESS") : t("NEW_PLACE")
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalBody, {
          overflowY: "visible",
          className: "place__create-modal__body",
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AddressForm, {
            control,
            register,
            resetField,
            formState,
            setValue,
            defaultData,
            watch,
            isReadOnly: !hasModuleCredential("edit")
          })
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(AuraModalFooter, {
          className: "place__create-modal__footer",
          children: [
            !!id && hasModuleCredential("delete") && isMainAddress !== true && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react368.Button, {
              className: "place__create-modal__footer-button-delete",
              "aria-label": "Delete",
              variant: "ghost",
              onClick: () => handleDeletePlace(id),
              children: t("Delete")
            }),
            !id && hasModuleCredential("create") && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react368.Button, {
              className: "place__create-modal__footer-button-create",
              isLoading: formState.isSubmitting || isSubmitBtnDisabled,
              type: "submit",
              colorScheme: "blue",
              children: t("ADD")
            }),
            !!id && hasModuleCredential("edit") && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react368.Button, {
              textTransform: "capitalize",
              className: "place__create-modal__footer-button-save",
              isLoading: formState.isSubmitting || isSubmitBtnDisabled,
              type: "submit",
              colorScheme: "blue",
              children: t("SAVE")
            })
          ]
        })
      ]
    })
  });
};
var AddressForm = ({
  control,
  defaultData,
  formState,
  isReadOnly
}) => {
  var _a2, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l;
  const { hasCredential } = (0, import_lib12.useCredentials)();
  const { t } = useAuraTranslation_default();
  const { meta } = (0, import_lib12.useCredentials)();
  const company = defaultData == null ? void 0 : defaultData.company;
  const countryCodeSelector = (_b = (_a2 = useSettings_default()) == null ? void 0 : _a2.settings) == null ? void 0 : _b.countryCodeSelector;
  const attributesFromMeta = (_d = (_c = meta == null ? void 0 : meta.extra_fields) == null ? void 0 : _c.attributes) == null ? void 0 : _d.items;
  const selectedAttributes = ((_e = defaultData == null ? void 0 : defaultData.attributes) == null ? void 0 : _e.length) ? (_f = defaultData == null ? void 0 : defaultData.attributes) == null ? void 0 : _f.map((attr) => ({
    ...attr,
    isReadOnly
  })) : attributesFromMeta;
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react368.Stack, {
    spacing: 4,
    "data-testid": "create-place-form",
    className: "place__create-modal__form",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react368.Flex, {
        justifyContent: "flex-end",
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react368.Text, {
            textStyle: "bodyInput",
            color: "red.500",
            mr: "16px",
            children: "*"
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react368.Text, {
            textStyle: "bodyInput",
            color: "blackAlpha.500",
            children: t("REQUIRED")
          })
        ]
      }),
      hasCredential("name", "field", "show") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react368.FormControl, {
        id: "place__name",
        isInvalid: !!((_g = formState == null ? void 0 : formState.errors) == null ? void 0 : _g.name),
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react368.FormLabel, {
            htmlFor: "name",
            children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
              children: [
                t("NAME"),
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraRequiredIndicator_default, {})
              ]
            })
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form27.Controller, {
            control,
            name: "name",
            rules: {
              required: {
                value: true,
                message: "ERROR_FIELD_IS_EMPTY"
              }
            },
            render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraInput_default, {
              ...field,
              isReadOnly
            })
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react368.FormErrorMessage, {
            children: t((_i = (_h = formState == null ? void 0 : formState.errors) == null ? void 0 : _h.name) == null ? void 0 : _i.message)
          })
        ]
      }),
      hasCredential("company", "field", "show") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react368.FormControl, {
        id: "place__company",
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react368.FormLabel, {
            htmlFor: "company",
            children: [
              t("COMPANY"),
              " ",
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraRequiredIndicator_default, {})
            ]
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form27.Controller, {
            control,
            name: "company",
            rules: {
              required: {
                value: true,
                message: "ERROR_FIELD_IS_EMPTY"
              }
            },
            render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSelect_default, {
              options: [company],
              isReadOnly: true,
              inputId: "place__company",
              ...field
            })
          })
        ]
      }),
      hasCredential("description", "field", "show") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react368.FormControl, {
        id: "place__description",
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react368.FormLabel, {
            htmlFor: "description",
            children: t("DESCRIPTION")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form27.Controller, {
            control,
            name: "description",
            render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraTextarea_default, {
              ...field,
              isReadOnly
            })
          })
        ]
      }),
      hasCredential("streetAddress", "field", "show") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react368.FormControl, {
        id: "place__street",
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react368.FormLabel, {
            htmlFor: "streetAddress",
            children: t("DATA_STREET")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form27.Controller, {
            control,
            name: "streetAddress",
            render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraInput_default, {
              ...field,
              isReadOnly
            })
          })
        ]
      }),
      hasCredential("streetNumber", "field", "show") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react368.FormControl, {
        id: "place__number",
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react368.FormLabel, {
            htmlFor: "streetNumber",
            children: t("DATA_STREET_NUMBER")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form27.Controller, {
            control,
            name: "streetNumber",
            render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraInput_default, {
              ...field,
              isReadOnly
            })
          })
        ]
      }),
      hasCredential("localNumber", "field", "show") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react368.FormControl, {
        id: "place__local-number",
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react368.FormLabel, {
            htmlFor: "localNumber",
            children: t("DATA_LOCAL_NUMBER")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form27.Controller, {
            control,
            name: "localNumber",
            render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraInput_default, {
              ...field,
              isReadOnly
            })
          })
        ]
      }),
      hasCredential("postalCode", "field", "show") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react368.FormControl, {
        id: "place__postal-code",
        isInvalid: (_j = formState == null ? void 0 : formState.errors) == null ? void 0 : _j.postalCode,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react368.FormLabel, {
            htmlFor: "postalCode",
            children: t("DATA_ZIP_CODE")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form27.Controller, {
            control,
            name: "postalCode",
            render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraInput_default, {
              ...field,
              isReadOnly
            })
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react368.FormErrorMessage, {
            children: t((_l = (_k = formState == null ? void 0 : formState.errors) == null ? void 0 : _k.postalCode) == null ? void 0 : _l.message)
          })
        ]
      }),
      hasCredential("city", "field", "show") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react368.FormControl, {
        id: "place__city",
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react368.FormLabel, {
            htmlFor: "city",
            children: t("DATA_CITY")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form27.Controller, {
            control,
            name: "city",
            render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraInput_default, {
              ...field,
              isReadOnly
            })
          })
        ]
      }),
      hasCredential("community", "field", "show") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react368.FormControl, {
        id: "place__community",
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react368.FormLabel, {
            htmlFor: "community",
            children: t("DATA_COMMUNITY")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form27.Controller, {
            control,
            name: "community",
            render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraInput_default, {
              ...field,
              isReadOnly
            })
          })
        ]
      }),
      hasCredential("county", "field", "show") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react368.FormControl, {
        id: "place__county",
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react368.FormLabel, {
            htmlFor: "county",
            children: t("DATA_COUNTY")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form27.Controller, {
            control,
            name: "county",
            render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraInput_default, {
              ...field,
              isReadOnly
            })
          })
        ]
      }),
      hasCredential("province", "field", "show") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react368.FormControl, {
        id: "place__province",
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react368.FormLabel, {
            htmlFor: "province",
            children: t("DATA_PROVINCE")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form27.Controller, {
            control,
            name: "province",
            render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraInput_default, {
              ...field,
              isReadOnly
            })
          })
        ]
      }),
      hasCredential("country", "field", "show") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react368.FormControl, {
        id: "place__country",
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react368.FormLabel, {
            htmlFor: "country",
            children: t("DATA_COUNTRY")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form27.Controller, {
            control,
            name: "country",
            render: ({ field }) => {
              return countryCodeSelector ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraCountrySelect_default, {
                inputId: "place__country",
                ...field,
                isReadOnly
              }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraInput_default, {
                ...field,
                isReadOnly
              });
            }
          })
        ]
      }),
      hasCredential("email", "field", "show") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react368.FormControl, {
        id: "place__email",
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react368.FormLabel, {
            htmlFor: "email",
            children: t("EMAIL_CHANGED")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form27.Controller, {
            control,
            name: "email",
            render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraInput_default, {
              ...field,
              isReadOnly
            })
          })
        ]
      }),
      hasCredential("phoneNumber", "field", "show") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react368.FormControl, {
        id: "place__phone",
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react368.FormLabel, {
            htmlFor: "phoneNumber",
            children: t("PHONE_NUMBER")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form27.Controller, {
            control,
            name: "phoneNumber",
            render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraInput_default, {
              ...field,
              isReadOnly
            })
          })
        ]
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Attributes_default, {
        attributes: selectedAttributes,
        toForm: true
      })
    ]
  });
};
var ModalAddress_default = withCredentials6(ModalAddress);

// src/components/ModalCampaignOpportunity/ModalCampaignOpportunity.tsx
var import_react373 = require("@chakra-ui/react");
var import_api29 = require("@questy/api");
var import_lib15 = require("@questy/lib");
var import_react374 = require("react");
var import_react_hook_form30 = require("react-hook-form");
var import_react_query46 = require("react-query");

// src/components/ModalCampaignOpportunity/ModalContent/ModalContent.tsx
var import_react372 = require("@chakra-ui/react");
var import_lib14 = require("@questy/lib");
var import_react_hook_form29 = require("react-hook-form");

// src/components/ModalCampaignOpportunity/FormFields/FormFields.tsx
var import_react369 = require("@chakra-ui/react");
var import_js56 = require("@mdi/js");
var import_react370 = __toESM(require("@mdi/react"));
var import_lib13 = require("@questy/lib");
var import_find2 = __toESM(require("lodash/find"));
var import_isEmpty12 = __toESM(require("lodash/isEmpty"));
var import_react371 = require("react");
var import_react_hook_form28 = require("react-hook-form");
var import_react_query45 = require("react-query");

// src/components/ModalCampaignOpportunity/utils.ts
var prepareDataForApi3 = ({
  data,
  hasCredential,
  relations
}) => {
  var _a2, _b, _c, _d, _e;
  const preparedAttributes = prepareAttributesForApi(
    data == null ? void 0 : data.attributes,
    hasCredential
  );
  return {
    ...((_a2 = data == null ? void 0 : data.campaign) == null ? void 0 : _a2.value) && {
      campaign: data.campaign.value
    },
    ...((_b = data == null ? void 0 : data.accountUser) == null ? void 0 : _b.value) && {
      accountUser: data.accountUser.value
    },
    ...((_c = data == null ? void 0 : data.company) == null ? void 0 : _c.value) && {
      company: data.company.value
    },
    ...((_d = data == null ? void 0 : data.campaignPhase) == null ? void 0 : _d.value) && {
      campaignPhase: data.campaignPhase.value
    },
    ...((_e = data == null ? void 0 : data.currency) == null ? void 0 : _e.value) && {
      currency: data.currency.value
    },
    ...(data == null ? void 0 : data.estimatedCloseDate) && {
      estimatedCloseDate: data.estimatedCloseDate
    },
    ...(data == null ? void 0 : data.title) && {
      title: data.title
    },
    ...(data == null ? void 0 : data.value) && {
      value: auraParseFloat(data.value)
    },
    ...(preparedAttributes == null ? void 0 : preparedAttributes.length) && {
      attributes: preparedAttributes
    },
    ...relations && {
      relations
    }
  };
};
var prepareTitleCampaignBaseData = (objLabel, t) => `${objLabel} - ${t("Campaign Opportunity").toLowerCase()}`;

// src/components/ModalCampaignOpportunity/FormFields/FormFields.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var FormFields2 = ({
  campaigns,
  campaignMeta,
  onOpenModalCompany,
  onOpenModalAccountUser
}) => {
  var _a2, _b, _c, _d, _e, _f, _g, _h, _i, _j;
  const { t, tCustom } = useAuraTranslation_default();
  const { user } = (0, import_react371.useContext)(AuthContext);
  const { isOpen } = (0, import_react369.useModalContext)();
  const {
    control,
    setValue,
    trigger,
    watch,
    getValues,
    unregister,
    formState: { errors }
  } = (0, import_react_hook_form28.useFormContext)();
  const { hasCredential } = (0, import_lib13.useCredentials)();
  const firstField = ((_b = (_a2 = useSettings_default()) == null ? void 0 : _a2.settings) == null ? void 0 : _b.newCampaignOpportunityFirstField) ?? ((_c = useSettings_default()) == null ? void 0 : _c.new_campaign_opportunity_first_field);
  const companyFieldValue = watch("company");
  const campaignFieldValue = watch("campaign");
  const availableCurrenciesOpts = ((_d = user == null ? void 0 : user.availableCurrencies) == null ? void 0 : _d.map((code) => ({
    value: code,
    label: code
  }))) ?? [];
  const defaultUserCurrencyOpt = (user == null ? void 0 : user.currency) && {
    label: user == null ? void 0 : user.currency,
    value: user == null ? void 0 : user.currency
  };
  const { data: moduleAccountCompanyCredential } = (0, import_react_query45.useQuery)(
    ["accountCompany", "meta", "moduleCredential"],
    () => api_default.getMeta("account_companies"),
    {
      select: (data) => {
        var _a3;
        return (_a3 = data == null ? void 0 : data.data) == null ? void 0 : _a3.module.credential;
      }
    }
  );
  const { data: moduleAccountUserCredential } = (0, import_react_query45.useQuery)(
    ["accountUser", "meta", "moduleCredential"],
    () => api_default.getMeta("account_users"),
    {
      select: (data) => {
        var _a3;
        return (_a3 = data == null ? void 0 : data.data) == null ? void 0 : _a3.module.credential;
      }
    }
  );
  const { data: campaignPhasesData } = (0, import_react_query45.useQuery)(
    [
      "campaignPhases",
      "forNewCampaignOpportunity",
      isOpen,
      campaignFieldValue == null ? void 0 : campaignFieldValue.value
    ],
    () => api_default.getEndpoint("campaign_phases", {
      params: {
        fields: "name,campaign,ordering",
        "order[ordering]": "ASC",
        "setting[with_relations]": true,
        "filter[campaign.id][eq]": campaignFieldValue == null ? void 0 : campaignFieldValue.value
      }
    }),
    {
      enabled: isOpen && idExists(campaignFieldValue == null ? void 0 : campaignFieldValue.value),
      select: (res) => res == null ? void 0 : res.data,
      refetchOnWindowFocus: false
    }
  );
  const preparedCampaignOptions = (0, import_react371.useMemo)(
    () => {
      var _a3;
      return (_a3 = buildOptions(campaigns ?? [], "name", "id", [
        "redirect",
        "isValueActive"
      ])) == null ? void 0 : _a3.map((opt) => ({
        ...opt,
        label: tCustom(opt == null ? void 0 : opt.label)
      }));
    },
    [campaigns]
  );
  const preparedCampaignPhasesOptions = (0, import_react371.useMemo)(
    () => {
      var _a3;
      return (_a3 = buildOptions(campaignPhasesData ?? [], "name", "id", ["ordering"])) == null ? void 0 : _a3.map(
        (opt) => ({
          ...opt,
          label: tCustom(opt == null ? void 0 : opt.label)
        })
      );
    },
    [campaignPhasesData]
  );
  const { data: accountUsersData, isLoading: isLoadingAccountUsersData } = (0, import_react_query45.useQuery)(
    [
      "accountUsers",
      "forNewCampaignOpportunity",
      isOpen,
      companyFieldValue == null ? void 0 : companyFieldValue.value
    ],
    () => api_default.getEndpoint("account_users", {
      params: {
        fields: "firstName,company.id",
        extra_fields: "fullName,company.displayName",
        "setting[with_relations]": true,
        "order[firstName]": "ASC",
        ...firstField === "account_company" /* accountCompany */ && idExists(companyFieldValue == null ? void 0 : companyFieldValue.value) ? {
          "filter[company.id][eq]": companyFieldValue == null ? void 0 : companyFieldValue.value
        } : {}
      }
    }),
    {
      enabled: isOpen,
      select: (res) => res == null ? void 0 : res.data,
      refetchOnWindowFocus: false
    }
  );
  const preparedAccountUsersOptions = (0, import_react371.useMemo)(
    () => buildOptions(accountUsersData ?? [], "fullName", "id", ["company"]),
    [accountUsersData, companyFieldValue == null ? void 0 : companyFieldValue.value]
  );
  const availableAttributes = (0, import_react371.useMemo)(
    () => {
      var _a3, _b2, _c2, _d2;
      return ((_d2 = (_c2 = (_b2 = (_a3 = campaignMeta == null ? void 0 : campaignMeta.extra_fields) == null ? void 0 : _a3.attributes) == null ? void 0 : _b2.items) == null ? void 0 : _c2.filter((attr) => (attr == null ? void 0 : attr.creation) >= 1)) == null ? void 0 : _d2.map((attr) => ({
        ...attr,
        options: {
          ...(attr == null ? void 0 : attr.options) ?? {},
          isRequired: (attr == null ? void 0 : attr.creation) === 2
        }
      }))) ?? [];
    },
    [campaignMeta]
  );
  const onAfterChangeAccountUser = (value, actionMeta) => {
    var _a3, _b2;
    if ((actionMeta == null ? void 0 : actionMeta.action) === "clear")
      return;
    if (idExists((_a3 = value == null ? void 0 : value.company) == null ? void 0 : _a3.id)) {
      setValue("company", {
        value: value.company.id,
        label: (_b2 = value == null ? void 0 : value.company) == null ? void 0 : _b2.displayName
      });
      trigger("company");
    } else {
      setValue("company", void 0);
    }
    if (!idExists(companyFieldValue == null ? void 0 : companyFieldValue.value)) {
      autoSetTitle({ accountUserName: value == null ? void 0 : value.label });
    }
  };
  const onAfterChangeCompany = (value, actionMeta) => {
    var _a3, _b2;
    if ((actionMeta == null ? void 0 : actionMeta.action) === "clear")
      return;
    if (idExists((_a3 = value == null ? void 0 : value.defaultUser) == null ? void 0 : _a3.id)) {
      setValue("accountUser", {
        value: value == null ? void 0 : value.defaultUser.id,
        label: (_b2 = value == null ? void 0 : value.defaultUser) == null ? void 0 : _b2.fullName
      });
      trigger("accountUser");
    } else {
      setValue("accountUser", void 0);
    }
    autoSetTitle({ companyName: value == null ? void 0 : value.label });
  };
  const autoSetTitle = ({
    companyName,
    accountUserName
  }) => {
    if (companyName) {
      setValue("title", prepareTitleCampaignBaseData(companyName, t));
    } else if (accountUserName) {
      setValue("title", prepareTitleCampaignBaseData(accountUserName, t));
    } else {
      setValue("title", void 0);
      return;
    }
    trigger("title");
  };
  const CONDITIONAL_FIELDS = {
    value: (hasCredential("value", "field", "show") || hasCredential("currency", "field", "show")) && (campaignFieldValue == null ? void 0 : campaignFieldValue.isValueActive),
    currency: hasCredential("value", "field", "show") && hasCredential("currency", "field", "show") && (campaignFieldValue == null ? void 0 : campaignFieldValue.isValueActive)
  };
  (0, import_react371.useEffect)(() => {
    if (idExists(companyFieldValue == null ? void 0 : companyFieldValue.value) && (companyFieldValue == null ? void 0 : companyFieldValue.isNew)) {
      onAfterChangeCompany(companyFieldValue, "");
    }
  }, [companyFieldValue]);
  (0, import_react371.useEffect)(() => {
    var _a3;
    if ((preparedCampaignOptions == null ? void 0 : preparedCampaignOptions[0]) && !idExists((_a3 = getValues("campaign")) == null ? void 0 : _a3.value)) {
      setValue("campaign", preparedCampaignOptions[0]);
    }
  }, [preparedCampaignOptions]);
  (0, import_react371.useEffect)(() => {
    if (idExists(campaignFieldValue == null ? void 0 : campaignFieldValue.value)) {
      setValue("campaignPhase", preparedCampaignPhasesOptions[0]);
    }
  }, [preparedCampaignPhasesOptions]);
  (0, import_react371.useEffect)(() => {
    var _a3;
    Object.entries(CONDITIONAL_FIELDS).forEach(
      ([fieldName, shouldBeVisible]) => {
        if (!shouldBeVisible) {
          unregister(fieldName);
        }
      }
    );
    const attributeParams = !(0, import_isEmpty12.default)(getValues("attributes")) ? (_a3 = Object.keys(getValues("attributes"))) == null ? void 0 : _a3.map((key) => ({
      id: getAttributeIdFromHTMLId(key),
      formKey: key
    })) : [];
    attributeParams == null ? void 0 : attributeParams.forEach((attr) => {
      const isCurrentAvaiable = (0, import_find2.default)(availableAttributes, { id: attr == null ? void 0 : attr.id });
      if (!isCurrentAvaiable) {
        unregister(`attributes.${attr == null ? void 0 : attr.formKey}`);
      }
    });
  }, [availableAttributes, campaignFieldValue == null ? void 0 : campaignFieldValue.value]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react369.VStack, {
    children: [
      hasCredential("campaign", "field", "show") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react369.FormControl, {
        isInvalid: !!errors.campaign,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react369.FormLabel, {
            htmlFor: "opportunity__campaign",
            children: [
              t("LIST_COLUMN_campaign"),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraRequiredIndicator_default, {})
            ]
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form28.Controller, {
            control,
            name: "campaign",
            rules: {
              required: {
                value: true,
                message: "ERROR_FIELD_IS_EMPTY"
              }
            },
            render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSelect_default, {
              id: "opportunity__campaign",
              isClearable: false,
              isError: !!errors.campaign,
              options: preparedCampaignOptions,
              ...field,
              onChange: (value) => {
                field.onChange(value);
                setValue("campaignPhase", void 0);
              }
            })
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react369.FormErrorMessage, {
            children: t((_e = errors == null ? void 0 : errors.campaign) == null ? void 0 : _e.message)
          })
        ]
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react369.VStack, {
        w: "full",
        rowGap: 2,
        children: [
          hasCredential("accountUser", "field", "show") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react369.FormControl, {
            isInvalid: !!errors.accountUser,
            order: firstField === "account_user" /* accountUser */ ? 1 : 2,
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react369.FormLabel, {
                htmlFor: "opportunity__account-user",
                children: t("LIST_COLUMN_accountUser")
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form28.Controller, {
                control,
                name: "accountUser",
                rules: {
                  validate: (value) => {
                    if (!getValues("company") && !value) {
                      return "ERROR_FIELD_IS_EMPTY";
                    }
                    return true;
                  }
                },
                render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react369.HStack, {
                  w: "full",
                  children: [
                    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react369.Box, {
                      w: "full",
                      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSelect_default, {
                        id: "opportunity__account-user",
                        isClearable: true,
                        isError: !!errors.accountUser,
                        options: preparedAccountUsersOptions,
                        isLoading: isLoadingAccountUsersData,
                        ...field,
                        onChange: (value, actionMeta) => {
                          field.onChange(value);
                          onAfterChangeAccountUser(value, actionMeta);
                        }
                      })
                    }),
                    moduleAccountUserCredential > 2 && (companyFieldValue == null ? void 0 : companyFieldValue.value) && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react369.Tooltip, {
                      label: t("ADD_NEW"),
                      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react369.IconButton, {
                        w: "40px",
                        h: "40px",
                        "aria-label": "Open",
                        icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react370.default, {
                          path: import_js56.mdiPlus,
                          size: "20px"
                        }),
                        onClick: onOpenModalAccountUser
                      })
                    })
                  ]
                })
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react369.FormErrorMessage, {
                children: t((_f = errors == null ? void 0 : errors.accountUser) == null ? void 0 : _f.message)
              })
            ]
          }),
          hasCredential("company", "field", "show") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react369.FormControl, {
            isInvalid: !!errors.company,
            order: firstField === "account_company" /* accountCompany */ ? 1 : 2,
            mt: "0 !important",
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react369.FormLabel, {
                htmlFor: "opportunity__company",
                children: [
                  t("LIST_COLUMN_company"),
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraRequiredIndicator_default, {})
                ]
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form28.Controller, {
                control,
                name: "company",
                rules: {
                  validate: (value) => {
                    if (!getValues("accountUser") && !value) {
                      return "ERROR_FIELD_IS_EMPTY";
                    }
                    return true;
                  }
                },
                render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react369.HStack, {
                  w: "full",
                  children: [
                    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react369.Box, {
                      w: "full",
                      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSelect_default, {
                        inputId: "opportunity__company",
                        isClearable: true,
                        isError: !!errors.company,
                        loadDataProps: {
                          endpoint: "account_companies",
                          labelField: "displayName",
                          settings: {
                            fields: "id,defaultUser.id",
                            extra_fields: "displayName,defaultUser.fullName",
                            "setting[with_relations]": true,
                            "order[_q]": "DESC"
                          },
                          customPrepareData: customPrepareCompanyData
                        },
                        ...field,
                        onChange: (value, actionMeta) => {
                          field.onChange(value);
                          onAfterChangeCompany(value, actionMeta);
                        }
                      })
                    }),
                    moduleAccountCompanyCredential > 2 && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, {
                      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react369.Tooltip, {
                        label: t("ADD_NEW"),
                        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react369.IconButton, {
                          w: "40px",
                          h: "40px",
                          "aria-label": "Open",
                          icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react370.default, {
                            path: import_js56.mdiPlus,
                            size: "20px"
                          }),
                          onClick: onOpenModalCompany
                        })
                      })
                    })
                  ]
                })
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react369.FormErrorMessage, {
                children: t((_g = errors == null ? void 0 : errors.company) == null ? void 0 : _g.message)
              })
            ]
          })
        ]
      }),
      hasCredential("title", "field", "show") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react369.FormControl, {
        isInvalid: !!errors.title,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react369.FormLabel, {
            htmlFor: "opportunity__title",
            children: [
              t("LIST_COLUMN_title"),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraRequiredIndicator_default, {})
            ]
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form28.Controller, {
            control,
            name: "title",
            rules: {
              required: {
                value: true,
                message: "ERROR_FIELD_IS_EMPTY"
              }
            },
            render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraInput_default, {
              id: "opportunity__title",
              ...field
            })
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react369.FormErrorMessage, {
            children: t((_h = errors == null ? void 0 : errors.title) == null ? void 0 : _h.message)
          })
        ]
      }),
      (hasCredential("value", "field", "show") || hasCredential("currency", "field", "show")) && (campaignFieldValue == null ? void 0 : campaignFieldValue.isValueActive) ? /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react369.HStack, {
        w: "full",
        alignItems: "flex-start",
        children: [
          hasCredential("value", "field", "show") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react369.FormControl, {
            isInvalid: !!errors.value,
            flex: 2,
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react369.FormLabel, {
                htmlFor: "opportunity__value",
                children: t("LIST_COLUMN_value")
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form28.Controller, {
                control,
                name: "value",
                render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraInput_default, {
                  id: "opportunity__value",
                  ...field,
                  onChange: (e) => {
                    var _a3, _b2;
                    e.target.value = sanitizeDecimalInput({
                      value: (_a3 = e == null ? void 0 : e.target) == null ? void 0 : _a3.value,
                      decimalPlaces: 2,
                      maxIntegerDigits: 10
                    });
                    field.onChange(auraParseDisplayValue((_b2 = e == null ? void 0 : e.target) == null ? void 0 : _b2.value));
                  }
                })
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react369.FormErrorMessage, {
                children: t((_i = errors == null ? void 0 : errors.value) == null ? void 0 : _i.message)
              })
            ]
          }),
          hasCredential("currency", "field", "show") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react369.FormControl, {
            isInvalid: !!errors.currency,
            flex: 1,
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react369.FormLabel, {
                htmlFor: "opportunity__currency",
                children: t("LIST_COLUMN_currency")
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form28.Controller, {
                control,
                name: "currency",
                defaultValue: defaultUserCurrencyOpt,
                rules: {
                  validate: (value) => {
                    if (!getValues("value") && !value) {
                      return "ERROR_FIELD_IS_EMPTY";
                    }
                    return true;
                  }
                },
                render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSelect_default, {
                  id: "opportunity__currency",
                  options: availableCurrenciesOpts,
                  isError: !!errors.currency,
                  isClearable: false,
                  ...field
                })
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react369.FormErrorMessage, {
                children: t((_j = errors == null ? void 0 : errors.currency) == null ? void 0 : _j.message)
              })
            ]
          })
        ]
      }) : null,
      hasCredential("campaignPhase", "field", "show") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react369.FormControl, {
        isInvalid: !!errors.campaignPhase,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react369.FormLabel, {
            htmlFor: "opportunity__campaign-phase",
            children: [
              t("LIST_COLUMN_campaignPhase"),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraRequiredIndicator_default, {})
            ]
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form28.Controller, {
            control,
            name: "campaignPhase",
            rules: {
              required: {
                value: true,
                message: "ERROR_FIELD_IS_EMPTY"
              }
            },
            render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSelect_default, {
              id: "opportunity__campaign-phase",
              isError: !!errors.campaignPhase,
              options: preparedCampaignPhasesOptions,
              isReadOnly: true,
              isClearable: false,
              ...field
            })
          })
        ]
      }),
      hasCredential("estimatedCloseDate", "field", "show") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react369.FormControl, {
        isInvalid: !!errors.estimatedCloseDate,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react369.FormLabel, {
            htmlFor: "opportunity__estimated-date",
            children: t("LIST_COLUMN_estimatedCloseDate")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form28.Controller, {
            control,
            name: "estimatedCloseDate",
            render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(DateInput_default, {
              id: "opportunity__estimated-date",
              ...field
            })
          })
        ]
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react369.Box, {
        w: "full",
        id: "opportunity__attributes",
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Attributes_default, {
          toForm: true,
          attributes: availableAttributes,
          module: "campaign_opportunities",
          errors
        })
      })
    ]
  });
};
var customPrepareCompanyData = (data) => data == null ? void 0 : data.map((item) => ({
  value: item == null ? void 0 : item.id,
  label: item == null ? void 0 : item.displayName,
  defaultUser: item == null ? void 0 : item.defaultUser
}));
var FormFields_default2 = FormFields2;

// src/components/ModalCampaignOpportunity/ModalContent/ModalContent.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var ModalContent4 = ({
  campaigns,
  campaignMeta,
  isLoading,
  onSubmit,
  onOpenModalCompany,
  onOpenModalAccountUser
}) => {
  const { t } = useAuraTranslation_default();
  const { handleSubmit, formState } = (0, import_react_hook_form29.useFormContext)();
  const { hasModuleCredential } = (0, import_lib14.useCredentials)();
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(AuraModalContent, {
    as: "form",
    onSubmit: handleSubmit(onSubmit),
    className: "campaign-opportunity__create-modal",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalHeader, {
        showBorders: false,
        className: "campaign-opportunity__create-modal__header",
        children: t("New sales opportunity")
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(AuraModalBody, {
        overflowY: "visible",
        className: "campaign-opportunity__create-modal__body",
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSpinner_default, {
            display: isLoading ? "unset" : "none"
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react372.Box, {
            w: "full",
            display: isLoading ? "none" : "unset",
            children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FormFields_default2, {
              onOpenModalCompany,
              onOpenModalAccountUser,
              campaigns,
              campaignMeta
            })
          })
        ]
      }),
      !isLoading && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalFooter, {
        className: "campaign-opportunity__create-modal__footer",
        showBorders: false,
        children: hasModuleCredential("create") && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react372.Button, {
          className: "campaign-opportunity__create-modal__footer__button-create",
          isLoading: formState.isSubmitting,
          type: "submit",
          colorScheme: "blue",
          textTransform: "capitalize",
          children: t("SAVE")
        })
      })
    ]
  });
};
var ModalContent_default2 = ModalContent4;

// src/components/ModalCampaignOpportunity/ModalCampaignOpportunity.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var withCredentials7 = (Component) => {
  return ({ ...props }) => {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_lib15.CredentialContextProvider, {
      module: "campaign_opportunities",
      initialModuleParams: { extra_fields: "attributes" },
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Component, {
        ...props
      })
    });
  };
};
var ModalCampaignOpportunity = ({
  isOpen,
  onClose,
  afterSuccess,
  relations,
  companyId,
  defaultCampaignId
}) => {
  var _a2, _b;
  const useFormProps = (0, import_react_hook_form30.useForm)({
    shouldUnregister: false
  });
  const { hasCredential, isLoading: isLoadingCampaignOpportunityMeta } = (0, import_lib15.useCredentials)();
  const { t } = useAuraTranslation_default();
  const toast = (0, import_react373.useToast)();
  const { resolveApiError } = useAuraErrorResolver_default();
  const modalDisclosure = (0, import_react373.useDisclosure)();
  const modalCompanyDisclosure = (0, import_react373.useDisclosure)();
  const modalAccountUserDisclosure = (0, import_react373.useDisclosure)();
  const { data: companyData, isLoading: isLoadingCompanyData } = (0, import_react_query46.useQuery)(
    ["accountCompanies", "forNewCampaignOpportunity", companyId, isOpen],
    () => (0, import_api29.getAccountCompany)(companyId, {
      fields: ["id"],
      extraFields: ["displayName", "defaultUser.fullName"],
      settings: {
        withRelations: true
      }
    }),
    {
      enabled: idExists(companyId) && isOpen,
      select: (data) => data == null ? void 0 : data.data,
      refetchOnWindowFocus: false
    }
  );
  const { data: campaignsData, isLoading: isLoadingCampaignsData } = (0, import_react_query46.useQuery)(
    ["campaigns", "forNewCampaignOpportunity", isOpen],
    () => (0, import_api29.getCampaigns)({
      fields: ["name", "redirect", "isValueActive"],
      filters: { status: { eq: 1 } },
      order: { name: "ASC" }
    }),
    {
      enabled: isOpen,
      select: (data) => data == null ? void 0 : data.data,
      refetchOnWindowFocus: false
    }
  );
  const campaignFieldValueValue = ((_a2 = useFormProps.watch("campaign")) == null ? void 0 : _a2.value) ?? ((_b = campaignsData == null ? void 0 : campaignsData[0]) == null ? void 0 : _b.id);
  const currentSelectedCompanyId = useFormProps.watch("company.value");
  const { data: campaignMeta, isLoading: isLoadingCampaignMeta } = (0, import_react_query46.useQuery)(
    ["campaigns", "meta", "forCampaign", campaignFieldValueValue],
    () => api_default.getMeta("campaigns", {
      params: {
        "for[id]": campaignFieldValueValue,
        extra_fields: "attributes"
      }
    }),
    {
      enabled: idExists(campaignFieldValueValue),
      select: (data) => data == null ? void 0 : data.data
    }
  );
  const onSubmit = async (data) => {
    var _a3, _b2, _c, _d, _e, _f, _g, _h, _i;
    const preparedData = prepareDataForApi3({
      data,
      hasCredential,
      relations
    });
    try {
      const response = await (0, import_api29.createCampaignOpportunity)({
        data: preparedData
      });
      if (response.errors === null) {
        onClose();
        if (idExists((_b2 = (_a3 = response == null ? void 0 : response.data) == null ? void 0 : _a3[0]) == null ? void 0 : _b2.id) && ((_c = data == null ? void 0 : data.campaign) == null ? void 0 : _c.redirect)) {
          redirectToUrl(
            getModuleHref("campaignOpportunity", (_e = (_d = response == null ? void 0 : response.data) == null ? void 0 : _d[0]) == null ? void 0 : _e.id)
          );
        } else {
          afterSuccess == null ? void 0 : afterSuccess((_f = response == null ? void 0 : response.data) == null ? void 0 : _f[0]);
          toast({
            title: t("NOTICE_SAVE_SUCCESS"),
            status: "success"
          });
        }
      }
    } catch (error) {
      resolveApiError(error);
      const errorFields = (_i = (_h = (_g = error == null ? void 0 : error.response) == null ? void 0 : _g.data) == null ? void 0 : _h.errors) == null ? void 0 : _i.item_0;
      if (errorFields == null ? void 0 : errorFields.length) {
        errorFields.forEach((error2) => {
          useFormProps.setError(error2 == null ? void 0 : error2.field, {
            message: "ERROR_FIELD_IS_EMPTY"
          });
        });
      }
    }
  };
  const handleOnOpenModalCompany = () => {
    modalDisclosure.onClose();
    modalCompanyDisclosure.onOpen();
  };
  const handleOnOpenModalAccountUser = () => {
    modalDisclosure.onClose();
    modalAccountUserDisclosure.onOpen();
  };
  const handleOnCloseModalCompany = (data) => {
    var _a3, _b2, _c, _d, _e, _f, _g;
    modalCompanyDisclosure.onClose();
    modalDisclosure.onOpen();
    if (idExists((_a3 = data == null ? void 0 : data[0]) == null ? void 0 : _a3.id)) {
      useFormProps.setValue("company", {
        value: (_b2 = data == null ? void 0 : data[0]) == null ? void 0 : _b2.id,
        label: (_c = data == null ? void 0 : data[0]) == null ? void 0 : _c.displayName,
        isNew: true,
        defaultUser: {
          id: (_e = (_d = data == null ? void 0 : data[0]) == null ? void 0 : _d.defaultUser) == null ? void 0 : _e.id,
          fullName: (_g = (_f = data == null ? void 0 : data[0]) == null ? void 0 : _f.defaultUser) == null ? void 0 : _g.fullName
        }
      });
      useFormProps.trigger("company");
      useFormProps.trigger("accountUser");
      useFormProps.trigger("title");
    }
  };
  const handleOnCloseModalAccountUser = (data) => {
    var _a3, _b2, _c, _d, _e;
    modalAccountUserDisclosure.onClose();
    modalDisclosure.onOpen();
    if (idExists(data == null ? void 0 : data.id)) {
      useFormProps.setValue("accountUser", {
        value: data == null ? void 0 : data.id,
        label: `${data == null ? void 0 : data.firstName} ${data == null ? void 0 : data.lastName}`
      });
    }
    if (idExists((_a3 = data == null ? void 0 : data.company) == null ? void 0 : _a3.id)) {
      const selectedCompany = (_b2 = useFormProps.getValues("company")) == null ? void 0 : _b2.value;
      if (selectedCompany !== ((_c = data == null ? void 0 : data.company) == null ? void 0 : _c.id)) {
        useFormProps.setValue("company", {
          value: (_d = data == null ? void 0 : data.company) == null ? void 0 : _d.id,
          label: (_e = data == null ? void 0 : data.company) == null ? void 0 : _e.name
        });
      }
    }
  };
  (0, import_react374.useEffect)(() => {
    if (isOpen) {
      modalDisclosure.onOpen();
    } else {
      modalDisclosure.onClose();
      setTimeout(() => useFormProps.reset(), 500);
    }
  }, [isOpen]);
  (0, import_react374.useEffect)(() => {
    var _a3, _b2, _c;
    if (isOpen && companyData) {
      useFormProps.setValue("company", {
        label: companyData == null ? void 0 : companyData.displayName,
        value: companyData == null ? void 0 : companyData.id
      });
      if (idExists((_a3 = companyData == null ? void 0 : companyData.defaultUser) == null ? void 0 : _a3.id)) {
        useFormProps.setValue("accountUser", {
          label: (_b2 = companyData == null ? void 0 : companyData.defaultUser) == null ? void 0 : _b2.fullName,
          value: (_c = companyData == null ? void 0 : companyData.defaultUser) == null ? void 0 : _c.id
        });
      }
      useFormProps.setValue(
        "title",
        prepareTitleCampaignBaseData(companyData == null ? void 0 : companyData.displayName, t)
      );
    }
  }, [isOpen, companyData]);
  (0, import_react374.useEffect)(() => {
    if (!idExists(defaultCampaignId))
      return;
    const defaultCampaign = campaignsData == null ? void 0 : campaignsData.find(
      (campaign) => campaign.id === defaultCampaignId
    );
    if (isOpen && defaultCampaign) {
      useFormProps.setValue("campaign", {
        isValueActive: defaultCampaign == null ? void 0 : defaultCampaign.isValueActive,
        value: defaultCampaign == null ? void 0 : defaultCampaign.id,
        label: defaultCampaign == null ? void 0 : defaultCampaign.name
      });
    }
  }, [isOpen, defaultCampaignId, campaignsData]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(AuraModal, {
        size: "lg",
        isOpen: modalDisclosure.isOpen,
        onClose,
        closeOnOverlayClick: false,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalOverlay, {}),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form30.FormProvider, {
            ...useFormProps,
            children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ModalContent_default2, {
              onSubmit,
              onOpenModalCompany: handleOnOpenModalCompany,
              onOpenModalAccountUser: handleOnOpenModalAccountUser,
              campaigns: campaignsData,
              campaignMeta,
              isLoading: isLoadingCampaignsData || isLoadingCompanyData || isLoadingCampaignOpportunityMeta || isLoadingCampaignMeta
            })
          })
        ]
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ModalCompany_default, {
        isOpen: modalCompanyDisclosure.isOpen,
        onClose: handleOnCloseModalCompany,
        afterSuccess: handleOnCloseModalCompany
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ModalAccountUser_default, {
        isOpen: modalAccountUserDisclosure.isOpen,
        onClose: handleOnCloseModalAccountUser,
        afterSuccess: handleOnCloseModalAccountUser,
        companyId: currentSelectedCompanyId
      })
    ]
  });
};
var ModalCampaignOpportunity_default = withCredentials7(ModalCampaignOpportunity);

// src/components/ModalCommission/ModalCommission.tsx
var import_react398 = require("@chakra-ui/react");
var import_react399 = require("react");

// src/components/ModalCommission/ModalMain/ModalMain.tsx
var import_react394 = require("@chakra-ui/react");
var import_api37 = require("@questy/api");
var import_lib24 = require("@questy/lib");
var import_react395 = require("react");
var import_react_hook_form39 = require("react-hook-form");
var import_react_query51 = require("react-query");

// src/components/ModalCommission/ModalMain/ModalContent/ModalContent.tsx
var import_react386 = require("@chakra-ui/react");
var import_lib19 = require("@questy/lib");
var import_react387 = require("react");
var import_react_hook_form35 = require("react-hook-form");

// src/components/ModalCommission/ModalMain/context.tsx
var import_react375 = require("react");
var import_jsx_runtime = require("react/jsx-runtime");
var ModalMainContext = (0, import_react375.createContext)(void 0);
var ModalMainProvider = ({
  value,
  children
}) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ModalMainContext.Provider, {
    value,
    children
  });
};
var useModalMainContext = () => {
  const context = (0, import_react375.useContext)(ModalMainContext);
  if (!context) {
    throw new Error(
      "useModalMainContext must be used within a ModalMainProvider"
    );
  }
  return context;
};

// src/components/ModalCommission/ModalMain/FormFields/FormFields.tsx
var import_react384 = require("@chakra-ui/react");
var import_js58 = require("@mdi/js");
var import_react385 = __toESM(require("@mdi/react"));
var import_lib18 = require("@questy/lib");
var import_react_hook_form34 = require("react-hook-form");

// src/components/ModalCommission/ModalMain/hooks/useCreatablePermissions.ts
var import_lib16 = require("@questy/lib");
var import_react376 = require("react");
var import_react_query47 = require("react-query");
var useCreatablePermissions = () => {
  const { hasCredential } = (0, import_lib16.useCredentials)();
  const settings = useSettings_default();
  const newLookServicedProduct = (settings == null ? void 0 : settings.new_look_serviced_product) === "true";
  const newLookCompanyModal = (settings == null ? void 0 : settings.new_look_company_modal) === "true";
  const newLookAccountUserModal = (settings == null ? void 0 : settings.new_look_account_user_modal) === "true";
  const {
    data: moduleCompanyCredential,
    isLoading: isLoadingModuleCompanyCredential
  } = (0, import_react_query47.useQuery)(
    ["accountCompanies", "meta", "moduleCredential"],
    () => api_default.getMeta("account_companies"),
    {
      select: (data) => {
        var _a2;
        return (_a2 = data == null ? void 0 : data.data) == null ? void 0 : _a2.module.credential;
      },
      refetchOnWindowFocus: false
    }
  );
  const {
    data: modulePlacesCredential,
    isLoading: isLoadingModulePlacesCredential
  } = (0, import_react_query47.useQuery)(
    ["places", "meta", "moduleCredential"],
    () => api_default.getMeta("places"),
    {
      select: (data) => {
        var _a2;
        return (_a2 = data == null ? void 0 : data.data) == null ? void 0 : _a2.module.credential;
      },
      refetchOnWindowFocus: false
    }
  );
  const {
    data: moduleAccountUserCredential,
    isLoading: isLoadingModuleAccountUserCredential
  } = (0, import_react_query47.useQuery)(
    ["accountUsers", "meta", "moduleCredential"],
    () => api_default.getMeta("account_users"),
    {
      select: (data) => {
        var _a2;
        return (_a2 = data == null ? void 0 : data.data) == null ? void 0 : _a2.module.credential;
      },
      refetchOnWindowFocus: false
    }
  );
  const {
    data: moduleServicedProductCredential,
    isLoading: isLoadingModuleServicedProductCredential
  } = (0, import_react_query47.useQuery)(
    ["servicedProducts", "meta", "moduleCredential"],
    () => api_default.getMeta("account_users"),
    {
      select: (data) => {
        var _a2;
        return (_a2 = data == null ? void 0 : data.data) == null ? void 0 : _a2.module.credential;
      },
      refetchOnWindowFocus: false
    }
  );
  const {
    data: moduleProductCredential,
    isLoading: isLoadingModuleProductCredential
  } = (0, import_react_query47.useQuery)(
    ["products", "meta", "moduleCredential"],
    () => api_default.getMeta("products"),
    {
      select: (data) => {
        var _a2;
        return (_a2 = data == null ? void 0 : data.data) == null ? void 0 : _a2.module.credential;
      },
      refetchOnWindowFocus: false
    }
  );
  const canCreateCompany = (0, import_react376.useMemo)(
    () => moduleCompanyCredential > import_lib16.ModuleCredential.Edit && hasCredential("company", "field", "edit") && newLookCompanyModal,
    [moduleCompanyCredential, newLookCompanyModal]
  );
  const canCreatePlace = (0, import_react376.useMemo)(
    () => modulePlacesCredential > import_lib16.ModuleCredential.Edit && hasCredential("place", "field", "edit"),
    [modulePlacesCredential]
  );
  const canCreateAccountUser = (0, import_react376.useMemo)(
    () => moduleAccountUserCredential > import_lib16.ModuleCredential.Edit && hasCredential("accountUser", "field", "edit") && newLookAccountUserModal,
    [moduleAccountUserCredential, newLookAccountUserModal]
  );
  const canCreateServicedProduct = (0, import_react376.useMemo)(
    () => moduleServicedProductCredential > import_lib16.ModuleCredential.Edit && hasCredential("servicedProducts", "relation", "edit") && newLookServicedProduct,
    [moduleServicedProductCredential, newLookServicedProduct]
  );
  const canCreateProduct = (0, import_react376.useMemo)(
    () => moduleProductCredential > import_lib16.ModuleCredential.Edit && hasCredential("servicedProducts", "relation", "edit"),
    [moduleProductCredential]
  );
  const permissions = (0, import_react376.useMemo)(
    () => ({
      canCreateCompany,
      canCreatePlace,
      canCreateAccountUser,
      canCreateServicedProduct,
      canCreateProduct
    }),
    [
      canCreateCompany,
      canCreatePlace,
      canCreateAccountUser,
      canCreateServicedProduct,
      canCreateProduct
    ]
  );
  return {
    permissions,
    isLoading: isLoadingModuleCompanyCredential || isLoadingModulePlacesCredential || isLoadingModuleAccountUserCredential || isLoadingModuleServicedProductCredential || isLoadingModuleProductCredential
  };
};
var useCreatablePermissions_default = useCreatablePermissions;

// src/components/ModalCommission/ModalMain/hooks/useEffectEditFields/useEffectEditFields.ts
var import_api32 = require("@questy/api");
var import_lib17 = require("@questy/lib");
var useEffectEditFields = ({ useFormProps }) => {
  var _a2, _b, _c, _d;
  const { setValue, trigger, getValues, resetField } = useFormProps;
  const { resolveApiError } = useAuraErrorResolver_default();
  const { hasCredential, meta } = (0, import_lib17.useCredentials)();
  const limitServicedProductsToCustomer = (_b = (_a2 = useSetting_default(
    "limit_serviced_products_to_customer"
  )) == null ? void 0 : _a2.setting) == null ? void 0 : _b.value;
  const limitServicedProductsToLocation = (_d = (_c = useSetting_default(
    "limit_serviced_products_to_location"
  )) == null ? void 0 : _c.setting) == null ? void 0 : _d.value;
  const onServicedProductChange = async (data, actionMeta) => {
    var _a3, _b2, _c2;
    if ((actionMeta == null ? void 0 : actionMeta.action) === "clear")
      return;
    const { product, place, company } = data;
    let fetchedCompanyData;
    try {
      if (idExists(company == null ? void 0 : company.id)) {
        fetchedCompanyData = await getCompanyData(company == null ? void 0 : company.id);
      }
    } catch (error) {
      resolveApiError(error);
    }
    if (getValues("product.value") !== (product == null ? void 0 : product.id)) {
      if (hasCredential("products", "relation", "edit")) {
        setValue(
          "product",
          {
            value: product.id,
            label: product == null ? void 0 : product.fullName
          },
          effectSetValueFormParams
        );
        trigger("product");
      } else {
        resetField("product");
      }
    }
    if (limitServicedProductsToCustomer && idExists(company == null ? void 0 : company.id) && getValues("company.value") !== company.id || !idExists(getValues("company.value"))) {
      if (hasCredential("company", "field", "edit")) {
        setValue(
          "company",
          {
            value: company.id,
            label: company == null ? void 0 : company.displayName
          },
          effectSetValueFormParams
        );
        trigger("company");
      } else {
        resetField("company");
      }
    }
    if (getValues("place.value") !== (place == null ? void 0 : place.id) && hasCredential("place", "field", "edit") && hasCredential("company", "field", "edit")) {
      if (idExists(place == null ? void 0 : place.id)) {
        setValue(
          "place",
          {
            value: place.id,
            label: place == null ? void 0 : place.fullName
          },
          effectSetValueFormParams
        );
        trigger("place");
      } else if (idExists((_a3 = fetchedCompanyData == null ? void 0 : fetchedCompanyData.defaultPlace) == null ? void 0 : _a3.id) && hasCredential("company", "field", "edit")) {
        setValue(
          "place",
          {
            value: fetchedCompanyData == null ? void 0 : fetchedCompanyData.defaultPlace.id,
            label: fetchedCompanyData == null ? void 0 : fetchedCompanyData.defaultPlace.fullName
          },
          effectSetValueFormParams
        );
        trigger("place");
      } else {
        resetField("place");
      }
    }
    if (limitServicedProductsToCustomer || !idExists(getValues("accountUser.value"))) {
      if (idExists((_b2 = fetchedCompanyData == null ? void 0 : fetchedCompanyData.defaultUser) == null ? void 0 : _b2.id) && hasCredential("accountUser", "field", "edit") && hasCredential("company", "field", "edit")) {
        setValue(
          "accountUser",
          {
            value: fetchedCompanyData == null ? void 0 : fetchedCompanyData.defaultUser.id,
            label: fetchedCompanyData == null ? void 0 : fetchedCompanyData.defaultUser.fullName
          },
          effectSetValueFormParams
        );
        trigger("accountUser");
      } else if (((_c2 = fetchedCompanyData == null ? void 0 : fetchedCompanyData.defaultUser) == null ? void 0 : _c2.id) !== getValues("accountUser.value")) {
        resetField("accountUser");
      }
    }
  };
  const onProductChange = (data) => {
    const servicedProductId = getValues("servicedProduct.product.id");
    if (idExists(servicedProductId) && (data == null ? void 0 : data.value) !== servicedProductId) {
      resetField("servicedProduct", {
        keepError: true
      });
    }
  };
  const onCompanyChange = (data) => {
    var _a3, _b2, _c2, _d2;
    if (idExists((_a3 = data == null ? void 0 : data.defaultUser) == null ? void 0 : _a3.id) && hasCredential("accountUser", "field", "edit")) {
      setValue(
        "accountUser",
        {
          value: data == null ? void 0 : data.defaultUser.id,
          label: (_b2 = data == null ? void 0 : data.defaultUser) == null ? void 0 : _b2.fullName
        },
        effectSetValueFormParams
      );
      trigger("accountUser");
    } else {
      resetField("accountUser");
    }
    if (idExists((_c2 = data == null ? void 0 : data.defaultPlace) == null ? void 0 : _c2.id) && hasCredential("place", "field", "edit")) {
      setValue(
        "place",
        {
          value: data == null ? void 0 : data.defaultPlace.id,
          label: (_d2 = data == null ? void 0 : data.defaultPlace) == null ? void 0 : _d2.fullName
        },
        effectSetValueFormParams
      );
      trigger("place");
    } else {
      resetField("place");
    }
    if ((limitServicedProductsToCustomer || limitServicedProductsToLocation) && getValues("servicedProduct.company.id") !== (data == null ? void 0 : data.value)) {
      resetField("servicedProduct", {
        keepError: true
      });
    }
  };
  const onChangeAccountUser = (data, actionMeta) => {
    if ((actionMeta == null ? void 0 : actionMeta.action) === "clear") {
      return;
    }
    const newAccountUserCompany = data == null ? void 0 : data.company;
    if (getValues("company.value") !== (newAccountUserCompany == null ? void 0 : newAccountUserCompany.id)) {
      if (limitServicedProductsToCustomer) {
        resetField("servicedProduct", {
          keepError: true
        });
      }
      if (idExists(newAccountUserCompany == null ? void 0 : newAccountUserCompany.id) && hasCredential("company", "field", "edit")) {
        setValue(
          "company",
          {
            value: newAccountUserCompany.id,
            label: newAccountUserCompany == null ? void 0 : newAccountUserCompany.displayName
          },
          effectSetValueFormParams
        );
        trigger("company");
      } else {
        resetField("company", {
          keepError: true
        });
        resetField("place");
        return;
      }
    }
    const newAccountUserPlace = data == null ? void 0 : data.place;
    if (getValues("place.value") !== (newAccountUserPlace == null ? void 0 : newAccountUserPlace.id)) {
      if (limitServicedProductsToLocation) {
        resetField("servicedProduct", {
          keepError: true
        });
      }
      if (idExists(newAccountUserPlace == null ? void 0 : newAccountUserPlace.id) && hasCredential("place", "field", "edit")) {
        setValue(
          "place",
          {
            value: newAccountUserPlace.id,
            label: newAccountUserPlace == null ? void 0 : newAccountUserPlace.fullName
          },
          effectSetValueFormParams
        );
        trigger("place");
      }
    }
  };
  const onPlaceChange = (data) => {
    if (limitServicedProductsToLocation && (data == null ? void 0 : data.value) !== getValues("servicedProduct.place.id")) {
      resetField("servicedProduct", {
        keepError: true
      });
    }
  };
  return {
    onServicedProductChange,
    onProductChange,
    onCompanyChange,
    onChangeAccountUser,
    onPlaceChange
  };
};
var getCompanyData = async (companyId) => {
  var _a2;
  return await ((_a2 = (0, import_api32.getAccountCompany)(companyId, {
    fields: ["defaultUser.id", "defaultPlace.id"],
    extraFields: ["defaultUser.fullName", "defaultPlace.fullName"],
    settings: {
      withRelations: true
    }
  })) == null ? void 0 : _a2.then((res) => res == null ? void 0 : res.data));
};
var effectSetValueFormParams = {
  shouldTouch: true
};
var useEffectEditFields_default = useEffectEditFields;

// src/components/ModalCommission/ModalMain/FormFields/AccountUserField/AccountUserField.tsx
var import_react377 = require("@chakra-ui/react");
var import_js57 = require("@mdi/js");
var import_api33 = require("@questy/api");
var import_react378 = require("react");
var import_react_hook_form31 = require("react-hook-form");
var import_react_query48 = require("react-query");
var import_react379 = __toESM(require("@mdi/react"));
var import_jsx_runtime = require("react/jsx-runtime");
var AccountUserField = ({
  isDisabled,
  ...props
}) => {
  var _a2;
  const { t } = useAuraTranslation_default();
  const { isOpen } = (0, import_react377.useModalContext)();
  const { openModalCreatable } = useModalMainContext();
  const useFormProps = (0, import_react_hook_form31.useFormContext)();
  const {
    formState: { errors },
    watch
  } = useFormProps;
  const { onChangeAccountUser } = useEffectEditFields_default({
    useFormProps
  });
  const { permissions } = useCreatablePermissions_default();
  const companyFieldValue = (_a2 = watch("company")) == null ? void 0 : _a2.value;
  const { data, isLoading } = (0, import_react_query48.useQuery)(
    ["accountUsers", "forNewCommission", isOpen, companyFieldValue],
    () => (0, import_api33.getAccountUsers)({
      fields: ["firstName", "company.id", "place.id"],
      extraFields: ["fullName", "company.displayName", "place.fullName"],
      settings: {
        withRelations: true
      },
      order: {
        firstName: "ASC",
        lastName: "ASC"
      },
      page: {
        limit: -1
      },
      rawParams: {
        ...idExists(companyFieldValue) ? {
          "filter[company.id][eq]": companyFieldValue
        } : {}
      }
    }),
    {
      enabled: isOpen,
      select: (res) => res == null ? void 0 : res.data,
      refetchOnWindowFocus: false
    }
  );
  const preparedAccountUsersOptions = (0, import_react378.useMemo)(
    () => {
      var _a3;
      return (_a3 = buildOptions(data ?? [], "fullName", "id", ["company", "place"])) == null ? void 0 : _a3.map(
        (opt) => {
          var _a4;
          return {
            ...opt,
            ...idExists(companyFieldValue) ? {} : { additionalLabel: (_a4 = opt.company) == null ? void 0 : _a4.displayName }
          };
        }
      );
    },
    [data, companyFieldValue]
  );
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react377.HStack, {
    w: "full",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react377.Box, {
        w: "full",
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSelect_default, {
          inputId: "commission__account-user",
          isClearable: true,
          isError: !!errors.accountUser,
          options: preparedAccountUsersOptions,
          isLoading,
          isReadOnly: isDisabled,
          ...props,
          onChange: (value, actionMeta) => {
            props.onChange(value);
            props.onBlur();
            onChangeAccountUser(value, actionMeta);
          }
        })
      }),
      permissions.canCreateAccountUser && idExists(watch("company.value")) && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react377.Tooltip, {
        label: t("ADD_NEW"),
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react377.IconButton, {
          w: "40px",
          h: "40px",
          "aria-label": "Open",
          icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react379.default, {
            path: import_js57.mdiPlus,
            size: "20px"
          }),
          onClick: () => openModalCreatable("accountUser")
        })
      })
    ]
  });
};
var AccountUserField_default = AccountUserField;

// src/components/ModalCommission/ModalMain/FormFields/ProductField/ProductField.tsx
var import_react380 = require("react");
var import_react_hook_form32 = require("react-hook-form");
var import_jsx_runtime = require("react/jsx-runtime");
var ProductField = ({
  isDisabled,
  ...props
}) => {
  const [tempInputValue, setTempValue] = (0, import_react380.useState)();
  const [isReadOnly, setIsReadOnly] = (0, import_react380.useState)(false);
  const useFormProps = (0, import_react_hook_form32.useFormContext)();
  const {
    formState: { errors },
    setValue,
    watch
  } = useFormProps;
  const { t } = useAuraTranslation_default();
  const { permissions } = useCreatablePermissions_default();
  const { openModalCreatable } = useModalMainContext();
  (0, import_react380.useEffect)(() => {
    if (idExists(watch("servicedProduct.value")) || isDisabled) {
      setIsReadOnly(true);
    } else {
      setIsReadOnly(false);
    }
  }, [watch("servicedProduct"), isDisabled]);
  const handleOnInputChange = (value) => {
    if (!!(value == null ? void 0 : value.length)) {
      setValue("product.inputValue", value);
    }
    setTempValue(value);
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSelect_default, {
    inputId: "commission__products",
    isError: !!errors.product,
    isMulti: false,
    isClearable: true,
    inputValue: tempInputValue,
    onInputChange: handleOnInputChange,
    loadDataProps: {
      endpoint: "products",
      labelField: "name",
      additionalNameAccessor: "code",
      settings: {
        fields: "id,name,code",
        "order[_q]": "DESC",
        "order[name]": "ASC",
        "page[limit]": 50
      }
    },
    isReadOnly,
    components: {
      Option: CustomProductOption_default
    },
    ...permissions.canCreateProduct ? {
      additionalActionProps: {
        titleLabel: t("Add product"),
        handleAction: () => openModalCreatable("product"),
        alwaysVisible: true
      }
    } : {},
    ...props,
    onChange: (value) => {
      props.onChange(value);
      props.onBlur();
    }
  });
};
var ProductField_default = ProductField;

// src/components/ModalCommission/ModalMain/FormFields/ServicedProducField/ServicedProducField.tsx
var import_react381 = require("@chakra-ui/react");
var import_react382 = require("react");
var import_react_hook_form33 = require("react-hook-form");
var import_react_select13 = require("react-select");
var import_jsx_runtime = require("react/jsx-runtime");
var ServicedProductField = ({
  isDisabled,
  ...props
}) => {
  var _a2, _b, _c, _d, _e, _f, _g, _h, _i;
  const [tempInputValue, setTempValue] = (0, import_react382.useState)();
  const useFormProps = (0, import_react_hook_form33.useFormContext)();
  const {
    formState: { errors },
    watch,
    setValue
  } = useFormProps;
  const { onServicedProductChange } = useEffectEditFields_default({
    useFormProps
  });
  const { openModalCreatable } = useModalMainContext();
  const { permissions } = useCreatablePermissions_default();
  const { t } = useAuraTranslation_default();
  const limitServicedProductsToCustomer = (_b = (_a2 = useSetting_default(
    "limit_serviced_products_to_customer"
  )) == null ? void 0 : _a2.setting) == null ? void 0 : _b.value;
  const limitServicedProductsToLocation = (_d = (_c = useSetting_default(
    "limit_serviced_products_to_location"
  )) == null ? void 0 : _c.setting) == null ? void 0 : _d.value;
  const displayInactiveServicedProducts = (_f = (_e = useSetting_default(
    "display_inactive_serviced_products_in_autocomplete"
  )) == null ? void 0 : _e.setting) == null ? void 0 : _f.value;
  const companyFieldValue = (_g = watch("company")) == null ? void 0 : _g.value;
  const placeFieldValue = (_h = watch("place")) == null ? void 0 : _h.value;
  const productFieldValue = (_i = watch("product")) == null ? void 0 : _i.value;
  const handleOnInputChange = (value) => {
    if (!!(value == null ? void 0 : value.length)) {
      setValue("servicedProduct.inputValue", value);
    }
    setTempValue(value);
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSelect_default, {
    inputId: "commission__serviced-product",
    isError: !!(errors == null ? void 0 : errors.servicedProduct),
    inputValue: tempInputValue,
    onInputChange: handleOnInputChange,
    isMulti: false,
    isClearable: true,
    isReadOnly: isDisabled,
    loadDataProps: {
      endpoint: "serviced_products",
      labelField: "fullName",
      autoselect: false,
      settings: {
        fields: "name,company.id,place.id,product.id",
        extra_fields: "fullName,company.displayName,place.fullName,product.fullName",
        "setting[with_relations]": true,
        "order[_q]": "DESC",
        "page[limit]": 50,
        ...limitServicedProductsToCustomer && idExists(companyFieldValue) ? { "filter[company.id]": companyFieldValue } : {},
        ...limitServicedProductsToLocation && idExists(placeFieldValue) ? { "filter[place.id]": placeFieldValue } : {},
        ...displayInactiveServicedProducts === false ? {
          "filter[isActive][eq]": true
        } : {},
        ...idExists(productFieldValue) && {
          "filter[product.id][eq]": productFieldValue
        }
      },
      customPrepareData: customPrepareServicedProductData
    },
    components: {
      MultiValue,
      Option: CustomProductOption_default
    },
    ...permissions.canCreateServicedProduct ? {
      additionalActionProps: {
        titleLabel: t("ADD_SERVICED_PRODUCT"),
        handleAction: () => openModalCreatable("servicedProduct"),
        alwaysVisible: true
      }
    } : {},
    ...props,
    onChange: async (value, actionMeta) => {
      props.onChange(value);
      await onServicedProductChange(value, actionMeta);
      props.onBlur();
    }
  });
};
var MultiValue = (props) => {
  var _a2;
  const url = getModuleHref("servicedProduct", (_a2 = props == null ? void 0 : props.data) == null ? void 0 : _a2.value);
  const handleOnClick = () => window.open(url, "_blank");
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_select13.components.MultiValue, {
    ...props,
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react381.Link, {
      href: url,
      target: "_blank",
      onTouchStart: handleOnClick,
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react381.Text, {
        _hover: { textDecoration: "underline", cursor: "pointer" },
        fontWeight: 400,
        children: props == null ? void 0 : props.data.label
      })
    })
  });
};
var customPrepareServicedProductData = (data) => data == null ? void 0 : data.map((item) => {
  var _a2, _b, _c, _d, _e, _f, _g;
  return {
    value: item == null ? void 0 : item.id,
    label: item == null ? void 0 : item.fullName,
    additionalName: (_a2 = item == null ? void 0 : item.company) == null ? void 0 : _a2.displayName,
    place: {
      id: (_b = item == null ? void 0 : item.place) == null ? void 0 : _b.id,
      fullName: (_c = item == null ? void 0 : item.place) == null ? void 0 : _c.fullName
    },
    company: {
      id: (_d = item == null ? void 0 : item.company) == null ? void 0 : _d.id,
      displayName: (_e = item == null ? void 0 : item.company) == null ? void 0 : _e.displayName
    },
    product: {
      id: (_f = item == null ? void 0 : item.product) == null ? void 0 : _f.id,
      fullName: (_g = item == null ? void 0 : item.product) == null ? void 0 : _g.fullName
    }
  };
});
var ServicedProducField_default = ServicedProductField;

// src/components/ModalCommission/ModalMain/FormFields/UserField/UserField.tsx
var import_api34 = require("@questy/api");
var import_react383 = require("react");
var import_react_query49 = require("react-query");
var import_jsx_runtime = require("react/jsx-runtime");
var UserField = ({
  inputId,
  isMulti,
  isError,
  isDisabled,
  ...props
}) => {
  const { data } = (0, import_react_query49.useQuery)(
    ["userUsers", "forNewCommission"],
    () => (0, import_api34.getUsers)({
      fields: [
        "id",
        "fullName",
        "avatar",
        "defaultCallendarColor",
        "isDeleted"
      ],
      extraFields: ["fullName"],
      order: {
        lastName: "ASC",
        firstName: "ASC"
      },
      page: {
        limit: -1
      }
    }),
    {
      select: (res) => res == null ? void 0 : res.data
    }
  );
  const options = (0, import_react383.useMemo)(() => {
    return data == null ? void 0 : data.map((user) => ({
      value: user.id,
      label: user.fullName,
      avatar: user.avatar,
      defaultCallendarColor: user == null ? void 0 : user.defaultCallendarColor,
      isDeleted: user == null ? void 0 : user.isDeleted
    }));
  }, [data]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSelect_default, {
    inputId,
    isError,
    isMulti,
    options,
    withAvatars: true,
    withCheckbox: true,
    isClearable: false,
    closeMenuOnSelect: false,
    isReadOnly: isDisabled,
    ...props,
    onChange: (value) => {
      props.onChange(value);
      props.onBlur();
    }
  });
};
var UserField_default = UserField;

// src/components/ModalCommission/ModalMain/FormFields/FormFields.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var FormFields3 = ({ attributes }) => {
  var _a2, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l;
  const { t } = useAuraTranslation_default();
  const { openModalCreatable, shortcut } = useModalMainContext();
  const useFormProps = (0, import_react_hook_form34.useFormContext)();
  const {
    control,
    watch,
    formState: { errors }
  } = useFormProps;
  const { permissions } = useCreatablePermissions_default();
  const { onCompanyChange, onPlaceChange } = useEffectEditFields_default({
    useFormProps
  });
  const { hasCredential } = (0, import_lib18.useCredentials)();
  const companyFieldValue = watch("company");
  const isVisibleAttributes = !!(attributes == null ? void 0 : attributes.length);
  const productFieldForPhaseParams = getFieldParamsForPhase(
    (_a2 = shortcut == null ? void 0 : shortcut.commissionPhase) == null ? void 0 : _a2.productRequired
  );
  const servicedProductFieldForPhaseParams = getFieldParamsForPhase(
    (_b = shortcut == null ? void 0 : shortcut.commissionPhase) == null ? void 0 : _b.serialCodeRequired
  );
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react384.SimpleGrid, {
    columns: isVisibleAttributes ? { base: 1, md: 2 } : 1,
    columnGap: 4,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react384.GridItem, {
        sx: {
          label: {
            lineHeight: "24px"
          }
        },
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react384.VStack, {
          w: "full",
          rowGap: 2,
          children: [
            hasCredential("startDate", "field", "show") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react384.FormControl, {
              isInvalid: !!errors.startDate,
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react384.FormLabel, {
                  htmlFor: "commission__start-date",
                  children: t("LIST_COLUMN_startDate")
                }),
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form34.Controller, {
                  control,
                  name: "startDate",
                  rules: {
                    validate: (value) => {
                      const endDate = watch("endDate");
                      if (value && endDate && value >= endDate) {
                        return t("ERROR_START_DATE_AFTER_END_DATE");
                      }
                      return true;
                    }
                  },
                  render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(DateInput_default, {
                    id: "commission__start-date",
                    maxDate: watch("endDate"),
                    withTime: true,
                    isDisabled: !hasCredential("startDate", "field", "edit"),
                    ...field,
                    onChange: (value) => {
                      field.onChange(value);
                      field.onBlur();
                    }
                  })
                }),
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react384.FormErrorMessage, {
                  children: t((_c = errors == null ? void 0 : errors.startDate) == null ? void 0 : _c.message)
                })
              ]
            }),
            hasCredential("endDate", "field", "show") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react384.FormControl, {
              isInvalid: !!errors.endDate,
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react384.FormLabel, {
                  htmlFor: "commission__end-date",
                  children: t("LIST_COLUMN_endDate")
                }),
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form34.Controller, {
                  control,
                  name: "endDate",
                  rules: {
                    validate: (value) => {
                      const startDate = watch("startDate");
                      if (value && startDate && value <= startDate) {
                        return t("ERROR_END_DATE_BEFORE_START_DATE");
                      }
                      return true;
                    }
                  },
                  render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(DateInput_default, {
                    id: "commission__end-date",
                    minDate: watch("startDate"),
                    withTime: true,
                    isDisabled: !hasCredential("endDate", "field", "edit"),
                    ...field,
                    onChange: (value) => {
                      field.onChange(value);
                      field.onBlur();
                    }
                  })
                }),
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react384.FormErrorMessage, {
                  children: t((_d = errors == null ? void 0 : errors.endDate) == null ? void 0 : _d.message)
                })
              ]
            }),
            hasCredential("products", "relation", "show") && productFieldForPhaseParams.visible && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react384.FormControl, {
              isInvalid: !!errors.product,
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react384.FormLabel, {
                  htmlFor: "commission__products",
                  children: [
                    t("LIST_COLUMN_product"),
                    productFieldForPhaseParams.required && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraRequiredIndicator_default, {})
                  ]
                }),
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form34.Controller, {
                  control,
                  name: "product",
                  rules: {
                    required: {
                      value: productFieldForPhaseParams.required && hasCredential("products", "relation", "edit"),
                      message: "ERROR_FIELD_IS_EMPTY"
                    }
                  },
                  render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ProductField_default, {
                    ...field,
                    isDisabled: !hasCredential("products", "relation", "edit")
                  })
                }),
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react384.FormErrorMessage, {
                  children: t((_e = errors == null ? void 0 : errors.product) == null ? void 0 : _e.message)
                })
              ]
            }),
            hasCredential("servicedProducts", "relation", "show") && servicedProductFieldForPhaseParams.visible && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react384.FormControl, {
              isInvalid: !!errors.servicedProduct,
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react384.FormLabel, {
                  htmlFor: "commission__serviced-product",
                  children: [
                    t("Specimen"),
                    servicedProductFieldForPhaseParams.required && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraRequiredIndicator_default, {})
                  ]
                }),
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form34.Controller, {
                  control,
                  name: "servicedProduct",
                  rules: {
                    required: {
                      value: servicedProductFieldForPhaseParams.required && hasCredential("servicedProducts", "relation", "edit"),
                      message: "ERROR_FIELD_IS_EMPTY"
                    }
                  },
                  render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ServicedProducField_default, {
                    ...field,
                    isDisabled: !hasCredential("servicedProducts", "relation", "edit")
                  })
                }),
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react384.FormErrorMessage, {
                  children: t((_f = errors == null ? void 0 : errors.servicedProduct) == null ? void 0 : _f.message)
                })
              ]
            }),
            hasCredential("name", "field", "show") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react384.FormControl, {
              isInvalid: !!errors.name,
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react384.FormLabel, {
                  htmlFor: "commission__name",
                  children: t("LIST_COLUMN_name")
                }),
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form34.Controller, {
                  control,
                  name: "name",
                  render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraInput_default, {
                    id: "commission__name",
                    isDisabled: !hasCredential("name", "field", "edit"),
                    ...field
                  })
                }),
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react384.FormErrorMessage, {
                  children: t((_g = errors == null ? void 0 : errors.name) == null ? void 0 : _g.message)
                })
              ]
            }),
            hasCredential("user", "field", "show") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react384.FormControl, {
              isInvalid: !!errors.user,
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react384.FormLabel, {
                  htmlFor: "commission__user",
                  children: t("LIST_COLUMN_user")
                }),
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form34.Controller, {
                  control,
                  name: "user",
                  render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(UserField_default, {
                    inputId: "commission__user",
                    isError: !!(errors == null ? void 0 : errors.user),
                    isDisabled: !hasCredential("user", "field", "edit"),
                    ...field
                  })
                }),
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react384.FormErrorMessage, {
                  children: t((_h = errors == null ? void 0 : errors.user) == null ? void 0 : _h.message)
                })
              ]
            }),
            hasCredential("commissionsUserUsers", "field", "show") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react384.FormControl, {
              isInvalid: !!errors.commissionsUserUsers,
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react384.FormLabel, {
                  htmlFor: "commission__commissions-user-users",
                  children: t("LIST_COLUMN_commissionsUserUsers")
                }),
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form34.Controller, {
                  control,
                  name: "commissionsUserUsers",
                  render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(UserField_default, {
                    inputId: "commission__commissions-user-users",
                    isMulti: true,
                    isError: !!(errors == null ? void 0 : errors.commissionsUserUsers),
                    isDisabled: !hasCredential("commissionsUserUsers", "field", "edit"),
                    ...field
                  })
                }),
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react384.FormErrorMessage, {
                  children: t((_i = errors == null ? void 0 : errors.commissionsUserUsers) == null ? void 0 : _i.message)
                })
              ]
            }),
            hasCredential("company", "field", "show") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react384.FormControl, {
              isInvalid: !!errors.company,
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react384.FormLabel, {
                  htmlFor: "commission__company",
                  children: [
                    t("CONTRACTOR"),
                    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraRequiredIndicator_default, {})
                  ]
                }),
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form34.Controller, {
                  control,
                  name: "company",
                  rules: {
                    required: {
                      value: hasCredential("company", "field", "edit"),
                      message: "ERROR_FIELD_IS_EMPTY"
                    }
                  },
                  render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react384.HStack, {
                    w: "full",
                    children: [
                      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react384.Box, {
                        w: "full",
                        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSelect_default, {
                          inputId: "commission__company",
                          isClearable: true,
                          isError: !!errors.company,
                          isReadOnly: !hasCredential("company", "field", "edit"),
                          loadDataProps: {
                            endpoint: "account_companies",
                            labelField: "displayName",
                            settings: {
                              fields: "id,defaultUser.id,defaultPlace.id",
                              extra_fields: "displayName,defaultUser.fullName,defaultPlace.fullName",
                              "setting[with_relations]": true,
                              "order[_q]": "DESC"
                            },
                            customPrepareData: customPrepareCompanyData2
                          },
                          ...field,
                          onChange: (value) => {
                            field.onChange(value);
                            field.onBlur();
                            onCompanyChange(value);
                          }
                        })
                      }),
                      permissions.canCreateCompany && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react384.Tooltip, {
                        label: t("ADD_NEW"),
                        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react384.IconButton, {
                          w: "40px",
                          h: "40px",
                          "aria-label": "Open",
                          icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react385.default, {
                            path: import_js58.mdiPlus,
                            size: "20px"
                          }),
                          onClick: () => openModalCreatable("company")
                        })
                      })
                    ]
                  })
                }),
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react384.FormErrorMessage, {
                  children: t((_j = errors == null ? void 0 : errors.company) == null ? void 0 : _j.message)
                })
              ]
            }),
            hasCredential("place", "field", "show") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react384.FormControl, {
              isInvalid: !!errors.place,
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react384.FormLabel, {
                  htmlFor: "commission__place",
                  children: t("LIST_COLUMN_place")
                }),
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form34.Controller, {
                  control,
                  name: "place",
                  render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react384.HStack, {
                    w: "full",
                    children: [
                      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react384.Box, {
                        w: "full",
                        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSelect_default, {
                          inputId: "commission__place",
                          isClearable: true,
                          isError: !!errors.place,
                          isDisabled: !idExists(watch("company.value")) || !hasCredential("place", "field", "edit") || !hasCredential("company", "field", "edit"),
                          loadDataProps: {
                            endpoint: "places",
                            labelField: "fullName",
                            autoselect: false,
                            queryField: "fullName",
                            settings: {
                              fields: "id,company.id",
                              extra_fields: "fullName",
                              "setting[with_relations]": true,
                              "filter[company.id][eq]": companyFieldValue == null ? void 0 : companyFieldValue.value
                            }
                          },
                          ...field,
                          onChange: (value) => {
                            field.onChange(value);
                            onPlaceChange(value);
                          }
                        })
                      }),
                      permissions.canCreatePlace && idExists(watch("company.value")) && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react384.Tooltip, {
                        label: t("ADD_NEW"),
                        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react384.IconButton, {
                          w: "40px",
                          h: "40px",
                          "aria-label": "Open",
                          icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react385.default, {
                            path: import_js58.mdiPlus,
                            size: "20px"
                          }),
                          onClick: () => openModalCreatable("address")
                        })
                      })
                    ]
                  })
                }),
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react384.FormErrorMessage, {
                  children: t((_k = errors == null ? void 0 : errors.place) == null ? void 0 : _k.message)
                })
              ]
            }),
            hasCredential("accountUser", "field", "show") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react384.FormControl, {
              isInvalid: !!errors.accountUser,
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react384.FormLabel, {
                  htmlFor: "commission__account-user",
                  children: t("LIST_COLUMN_accountUser")
                }),
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form34.Controller, {
                  control,
                  name: "accountUser",
                  render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AccountUserField_default, {
                    isDisabled: !hasCredential("accountUser", "field", "edit") || !hasCredential("company", "field", "edit"),
                    ...field
                  })
                }),
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react384.FormErrorMessage, {
                  children: t((_l = errors == null ? void 0 : errors.accountUser) == null ? void 0 : _l.message)
                })
              ]
            })
          ]
        })
      }),
      isVisibleAttributes && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react384.GridItem, {
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react384.Box, {
          w: "full",
          id: "commission__attributes",
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Attributes_default, {
            toForm: true,
            attributes,
            module: "commissions",
            errors
          })
        })
      })
    ]
  });
};
var customPrepareCompanyData2 = (data) => data == null ? void 0 : data.map((item) => ({
  value: item == null ? void 0 : item.id,
  label: item == null ? void 0 : item.displayName,
  defaultUser: item == null ? void 0 : item.defaultUser,
  defaultPlace: item == null ? void 0 : item.defaultPlace
}));
var getFieldParamsForPhase = (requiredValue) => {
  return {
    required: requiredValue === 2 /* required */,
    visible: requiredValue !== void 0 && requiredValue > 0 /* inaccessible */
  };
};
var FormFields_default3 = FormFields3;

// src/components/ModalCommission/ModalMain/ModalContent/ModalContent.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var ModalContent5 = ({ isLoading, onSubmit }) => {
  var _a2;
  const { t, tCustom } = useAuraTranslation_default();
  const { handleSubmit, formState, trigger } = (0, import_react_hook_form35.useFormContext)();
  const { shortcut } = useModalMainContext();
  const header = (shortcut == null ? void 0 : shortcut.name) ?? ((_a2 = shortcut == null ? void 0 : shortcut.documentSeriesDefinition) == null ? void 0 : _a2.name);
  const { meta, hasModuleCredential } = (0, import_lib19.useCredentials)();
  const preparedAttributes = (0, import_react387.useMemo)(
    () => {
      var _a3, _b, _c;
      return (_c = (_b = (_a3 = meta == null ? void 0 : meta.extra_fields) == null ? void 0 : _a3.attributes) == null ? void 0 : _b.items) == null ? void 0 : _c.map((attr) => {
        if ((attr == null ? void 0 : attr.type) === "tags") {
          return {
            ...attr,
            options: {
              ...(attr == null ? void 0 : attr.options) ?? {},
              hideCopyAction: true
            }
          };
        }
        return attr;
      });
    },
    [meta]
  );
  const handleFormSubmit = async (e) => {
    e.preventDefault();
    await trigger();
    handleSubmit(onSubmit)(e);
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(AuraModalContent, {
    as: "form",
    onSubmit: handleFormSubmit,
    className: "commission__create-modal",
    maxW: !!(preparedAttributes == null ? void 0 : preparedAttributes.length) ? "1280px" : "512px",
    w: "full",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalHeader, {
        showBorders: false,
        className: "commission__create-modal__header",
        textTransform: "capitalize",
        children: tCustom(header)
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalBody, {
        overflowY: "visible",
        className: "commission__create-modal__body",
        children: isLoading ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSpinner_default, {}) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react386.Box, {
          w: "full",
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FormFields_default3, {
            attributes: preparedAttributes
          })
        })
      }),
      !isLoading && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalFooter, {
        className: "commission__create-modal__footer",
        showBorders: false,
        children: hasModuleCredential("create") && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react386.Button, {
          className: "commission__create-modal__footer__button-create",
          isLoading: formState.isSubmitting,
          type: "submit",
          colorScheme: "blue",
          textTransform: "capitalize",
          children: t("SAVE")
        })
      })
    ]
  });
};
var ModalContent_default3 = ModalContent5;

// src/components/ModalCommission/utils.ts
var import_isEmpty13 = __toESM(require("lodash/isEmpty"));
var prepareDataForApi4 = ({
  data,
  hasCredential,
  relations,
  scopeType,
  documentSerieDefinitionId,
  commissionPhaseId,
  delayInDays,
  dirtyFields,
  shortcut
}) => {
  var _a2, _b, _c, _d, _e, _f, _g;
  const preparedAttributes = prepareAttributesForApi(
    data == null ? void 0 : data.attributes,
    hasCredential,
    (dirtyFields == null ? void 0 : dirtyFields.attributes) ?? {}
  );
  const preparedRelations = {
    ...prepareExternalRelations(relations, scopeType, delayInDays),
    ...hasCredential("products", "relation", "edit") && idExists((_a2 = data == null ? void 0 : data.product) == null ? void 0 : _a2.value) && {
      products: [data.product.value]
    },
    ...hasCredential("servicedProducts", "relation", "edit") && idExists((_b = data == null ? void 0 : data.servicedProduct) == null ? void 0 : _b.value) && {
      servicedProducts: [data.servicedProduct.value]
    }
  };
  return {
    ...hasCredential("startDate", "field", "edit") && (data == null ? void 0 : data.startDate) && {
      startDate: data.startDate
    },
    ...hasCredential("endDate", "field", "edit") && (data == null ? void 0 : data.endDate) && {
      endDate: data.endDate
    },
    ...hasCredential("name", "field", "edit") && (data == null ? void 0 : data.name) && {
      name: data.name
    },
    ...hasCredential("user", "field", "edit") && idExists((_c = data == null ? void 0 : data.user) == null ? void 0 : _c.value) && {
      user: data.user.value
    },
    ...hasCredential("commissionsUserUsers", "field", "edit") && !!((_d = data == null ? void 0 : data.commissionsUserUsers) == null ? void 0 : _d.length) && {
      commissionsUserUsers: data.commissionsUserUsers.map((user) => ({
        id: user.value
      }))
    },
    ...hasCredential("company", "field", "edit") && idExists((_e = data == null ? void 0 : data.company) == null ? void 0 : _e.value) && {
      company: data.company.value
    },
    ...hasCredential("place", "field", "edit") && hasCredential("company", "field", "edit") && idExists((_f = data == null ? void 0 : data.place) == null ? void 0 : _f.value) && {
      place: data.place.value
    },
    ...hasCredential("accountUser", "field", "edit") && hasCredential("company", "field", "edit") && idExists((_g = data == null ? void 0 : data.accountUser) == null ? void 0 : _g.value) && {
      accountUser: data.accountUser.value
    },
    ...idExists(documentSerieDefinitionId) && {
      documentSeriesDefinition: documentSerieDefinitionId
    },
    ...idExists(commissionPhaseId) && {
      commissionPhase: commissionPhaseId
    },
    ...!(0, import_isEmpty13.default)(preparedRelations) && {
      relations: preparedRelations
    },
    ...(preparedAttributes == null ? void 0 : preparedAttributes.length) && {
      attributes: preparedAttributes
    },
    ...idExists(shortcut == null ? void 0 : shortcut.description) && {
      description: shortcut.description
    },
    commissionShortcut: shortcut == null ? void 0 : shortcut.id
  };
};
var prepareExternalRelations = (relations = {}, scopeType, delayInDays) => {
  return Object.keys(relations).reduce((acc, key) => {
    var _a2;
    const commissionId = (_a2 = relations.commissions) == null ? void 0 : _a2[0];
    if (key === "commissions" && idExists(commissionId)) {
      acc.commissions = {
        id: commissionId,
        subtype: prepareSubtypeForRelatedCommission(scopeType == null ? void 0 : scopeType.type)
      };
    } else {
      acc[key] = relations[key];
    }
    return acc;
  }, {});
};
var prepareSubtypeForRelatedCommission = (newCommissionScopeType) => {
  if (newCommissionScopeType === 1 /* parent */) {
    return COMMISSION_SCOPE_TYPE_LABELS[2 /* child */];
  }
  if (newCommissionScopeType === 2 /* child */) {
    return COMMISSION_SCOPE_TYPE_LABELS[1 /* parent */];
  }
  return COMMISSION_SCOPE_TYPE_LABELS[newCommissionScopeType];
};

// src/components/ModalCommission/ModalMain/hooks/useManageModalCreatable.ts
var import_react388 = require("@chakra-ui/react");
var useManageModalCreatable = ({
  useFormProps,
  modalMainDisclousure
}) => {
  const { setValue, trigger } = useFormProps;
  const {
    onServicedProductChange,
    onCompanyChange,
    onChangeAccountUser,
    onPlaceChange,
    onProductChange
  } = useEffectEditFields_default({
    useFormProps
  });
  const modalCompanyDisclosure = (0, import_react388.useDisclosure)();
  const modalAddressDisclosure = (0, import_react388.useDisclosure)();
  const modalAccountUserDisclosure = (0, import_react388.useDisclosure)();
  const modalServicedProductDisclosure = (0, import_react388.useDisclosure)();
  const modalProductDisclosure = (0, import_react388.useDisclosure)();
  const openModalCreatable = (type) => {
    switch (type) {
      case "company":
        modalMainDisclousure.onClose();
        modalCompanyDisclosure.onOpen();
        break;
      case "address":
        modalMainDisclousure.onClose();
        modalAddressDisclosure.onOpen();
        break;
      case "accountUser":
        modalMainDisclousure.onClose();
        modalAccountUserDisclosure.onOpen();
        break;
      case "servicedProduct":
        modalMainDisclousure.onClose();
        modalServicedProductDisclosure.onOpen();
        break;
      case "product":
        modalMainDisclousure.onClose();
        modalProductDisclosure.onOpen();
        break;
      default:
        break;
    }
  };
  const onCloseModalCompany = (data) => {
    var _a2, _b, _c, _d, _e, _f, _g, _h, _i, _j;
    modalCompanyDisclosure.onClose();
    modalMainDisclousure.onOpen();
    if (idExists((_a2 = data == null ? void 0 : data[0]) == null ? void 0 : _a2.id)) {
      const newValue = {
        value: data[0].id,
        label: (_b = data == null ? void 0 : data[0]) == null ? void 0 : _b.displayName,
        defaultUser: {
          id: (_d = (_c = data == null ? void 0 : data[0]) == null ? void 0 : _c.defaultUser) == null ? void 0 : _d.id,
          fullName: (_f = (_e = data == null ? void 0 : data[0]) == null ? void 0 : _e.defaultUser) == null ? void 0 : _f.fullName
        },
        defaultPlace: {
          id: (_h = (_g = data == null ? void 0 : data[0]) == null ? void 0 : _g.defaultPlace) == null ? void 0 : _h.id,
          fullName: (_j = (_i = data == null ? void 0 : data[0]) == null ? void 0 : _i.defaultPlace) == null ? void 0 : _j.fullName
        }
      };
      setValue("company", newValue);
      trigger("company");
      onCompanyChange(newValue);
    }
  };
  const onCloseModalAddress = (data) => {
    var _a2, _b, _c, _d;
    modalAddressDisclosure.onClose();
    modalMainDisclousure.onOpen();
    if (idExists((_a2 = data == null ? void 0 : data[0]) == null ? void 0 : _a2.id)) {
      const newValue = {
        value: data[0].id,
        label: (_b = data == null ? void 0 : data[0]) == null ? void 0 : _b.fullName,
        companyId: (_d = (_c = data == null ? void 0 : data[0]) == null ? void 0 : _c.company) == null ? void 0 : _d.id
      };
      setValue("place", newValue);
      trigger("place");
      onPlaceChange(newValue);
    }
  };
  const onCloseModalAccountUser = (data) => {
    var _a2, _b, _c, _d;
    modalAccountUserDisclosure.onClose();
    modalMainDisclousure.onOpen();
    if (idExists(data == null ? void 0 : data.id)) {
      const newValue = {
        value: data.id,
        label: data == null ? void 0 : data.fullName,
        company: {
          id: (_a2 = data == null ? void 0 : data.company) == null ? void 0 : _a2.id,
          displayName: (_b = data == null ? void 0 : data.company) == null ? void 0 : _b.displayName
        },
        place: {
          id: (_c = data == null ? void 0 : data.place) == null ? void 0 : _c.id,
          fullName: (_d = data == null ? void 0 : data.place) == null ? void 0 : _d.fullName
        }
      };
      setValue("accountUser", newValue);
      trigger("accountUser");
      onChangeAccountUser(newValue);
    }
  };
  const onCloseModalServicedProduct = async (data) => {
    var _a2, _b, _c, _d, _e, _f;
    modalServicedProductDisclosure.onClose();
    modalMainDisclousure.onOpen();
    if (idExists(data == null ? void 0 : data.id)) {
      const newValue = {
        value: data.id,
        label: data == null ? void 0 : data.fullName,
        company: {
          id: (_a2 = data == null ? void 0 : data.company) == null ? void 0 : _a2.id,
          displayName: (_b = data == null ? void 0 : data.company) == null ? void 0 : _b.displayName
        },
        place: {
          id: (_c = data == null ? void 0 : data.place) == null ? void 0 : _c.id,
          fullName: (_d = data == null ? void 0 : data.place) == null ? void 0 : _d.fullName
        },
        product: {
          id: (_e = data == null ? void 0 : data.product) == null ? void 0 : _e.id,
          fullName: (_f = data == null ? void 0 : data.product) == null ? void 0 : _f.fullName
        }
      };
      setValue("servicedProduct", newValue);
      trigger("servicedProduct");
      onServicedProductChange(newValue);
    }
  };
  const onCloseModalProduct = (data) => {
    modalProductDisclosure.onClose();
    modalMainDisclousure.onOpen();
    if (idExists(data == null ? void 0 : data.id)) {
      const newValue = {
        value: data.id,
        label: data == null ? void 0 : data.fullName
      };
      setValue("product", newValue);
      trigger("product");
      onProductChange(newValue);
    }
  };
  return {
    openModalCreatable,
    disclosures: {
      modalCompanyDisclosure,
      modalAddressDisclosure,
      modalAccountUserDisclosure,
      modalServicedProductDisclosure,
      modalProductDisclosure
    },
    onCloseHandlers: {
      onCloseModalCompany,
      onCloseModalAddress,
      onCloseModalAccountUser,
      onCloseModalServicedProduct,
      onCloseModalProduct
    }
  };
};
var useManageModalCreatable_default = useManageModalCreatable;

// src/components/ModalProduct/ModalProduct.tsx
var import_react391 = require("@chakra-ui/react");
var import_api35 = require("@questy/api");
var import_lib22 = require("@questy/lib");
var import_react392 = require("react");
var import_react_hook_form38 = require("react-hook-form");

// src/components/ModalProduct/ModalContent/ModalContent.tsx
var import_react390 = require("@chakra-ui/react");
var import_lib21 = require("@questy/lib");
var import_react_hook_form37 = require("react-hook-form");

// src/components/ModalProduct/FormFields/FormFields.tsx
var import_react389 = require("@chakra-ui/react");
var import_lib20 = require("@questy/lib");
var import_react_hook_form36 = require("react-hook-form");
var import_jsx_runtime = require("react/jsx-runtime");
var FormFields4 = () => {
  var _a2, _b;
  const { t } = useAuraTranslation_default();
  const {
    control,
    formState: { errors }
  } = (0, import_react_hook_form36.useFormContext)();
  const { hasCredential } = (0, import_lib20.useCredentials)();
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react389.VStack, {
    children: [
      hasCredential("name", "field", "show") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react389.FormControl, {
        isInvalid: !!errors.name,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react389.FormLabel, {
            htmlFor: "product__name",
            children: [
              t("LIST_COLUMN_name"),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraRequiredIndicator_default, {})
            ]
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form36.Controller, {
            control,
            name: "name",
            rules: {
              required: {
                value: true,
                message: "ERROR_FIELD_IS_EMPTY"
              }
            },
            render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraInput_default, {
              id: "product__name",
              ...field
            })
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react389.FormErrorMessage, {
            children: t((_a2 = errors == null ? void 0 : errors.name) == null ? void 0 : _a2.message)
          })
        ]
      }),
      hasCredential("code", "field", "show") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react389.FormControl, {
        isInvalid: !!errors.name,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react389.FormLabel, {
            htmlFor: "product__code",
            children: t("LIST_COLUMN_code")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form36.Controller, {
            control,
            name: "code",
            render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraInput_default, {
              id: "product__code",
              ...field
            })
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react389.FormErrorMessage, {
            children: t((_b = errors == null ? void 0 : errors.code) == null ? void 0 : _b.message)
          })
        ]
      })
    ]
  });
};
var FormFields_default4 = FormFields4;

// src/components/ModalProduct/ModalContent/ModalContent.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var ModalContent6 = ({ isLoading, onSubmit }) => {
  const { t } = useAuraTranslation_default();
  const { handleSubmit, formState } = (0, import_react_hook_form37.useFormContext)();
  const { hasModuleCredential } = (0, import_lib21.useCredentials)();
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(AuraModalContent, {
    as: "form",
    onSubmit: handleSubmit(onSubmit),
    className: "product__create-modal",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalHeader, {
        showBorders: false,
        className: "product__create-modal__header",
        children: t("LIST_ADD_NEW_PRODUCT")
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalBody, {
        overflowY: "visible",
        className: "product__create-modal__body",
        children: isLoading ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSpinner_default, {}) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react390.Box, {
          w: "full",
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FormFields_default4, {})
        })
      }),
      !isLoading && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalFooter, {
        className: "product__create-modal__footer",
        showBorders: false,
        children: hasModuleCredential("create") && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react390.Button, {
          className: "product__create-modal__footer__button-create",
          isLoading: formState.isSubmitting,
          type: "submit",
          colorScheme: "blue",
          textTransform: "capitalize",
          children: t("SAVE")
        })
      })
    ]
  });
};
var ModalContent_default4 = ModalContent6;

// src/components/ModalProduct/utils.ts
var prepareDataForApi5 = ({ data }) => {
  return {
    ...(data == null ? void 0 : data.name) && {
      name: data.name
    },
    ...(data == null ? void 0 : data.code) && {
      code: data.code
    }
  };
};

// src/components/ModalProduct/ModalProduct.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var withCredentials8 = (Component) => {
  return ({ ...props }) => {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_lib22.CredentialContextProvider, {
      module: "products",
      initialModuleParams: {},
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Component, {
        ...props
      })
    });
  };
};
var ModalProduct = ({
  isOpen,
  onClose,
  afterSuccess,
  name
}) => {
  const useFormProps = (0, import_react_hook_form38.useForm)({
    shouldUnregister: false
  });
  const { isLoading: isLoadingMeta } = (0, import_lib22.useCredentials)();
  const { t } = useAuraTranslation_default();
  const toast = (0, import_react391.useToast)();
  const { resolveApiError } = useAuraErrorResolver_default();
  const modalDisclousure = (0, import_react391.useDisclosure)();
  const onSubmit = async (data) => {
    var _a2;
    const preparedData = prepareDataForApi5({
      data
    });
    try {
      const response = await (0, import_api35.createProduct)({
        data: preparedData,
        extra_fields: ["fullName"]
      });
      if (response.errors === null) {
        onClose();
        afterSuccess == null ? void 0 : afterSuccess((_a2 = response == null ? void 0 : response.data) == null ? void 0 : _a2[0]);
        toast({
          title: t("NOTICE_SAVE_SUCCESS"),
          status: "success"
        });
      }
    } catch (error) {
      resolveApiError(error);
    }
  };
  (0, import_react392.useEffect)(() => {
    if (isOpen) {
      modalDisclousure.onOpen();
      useFormProps.reset({
        ...name && {
          name
        }
      });
    } else {
      modalDisclousure.onClose();
    }
  }, [isOpen]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(AuraModal, {
    size: "lg",
    isOpen: modalDisclousure.isOpen,
    onClose,
    closeOnOverlayClick: false,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalOverlay, {}),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form38.FormProvider, {
        ...useFormProps,
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ModalContent_default4, {
          onSubmit,
          isLoading: isLoadingMeta
        })
      })
    ]
  });
};
var ModalProduct_default = withCredentials8(ModalProduct);

// src/components/ModalCommission/ModalMain/hooks/useDefaultFormValues/useDefaultFormValues.ts
var import_api36 = require("@questy/api");
var import_react393 = require("react");
var import_react_query50 = require("react-query");
var import_lib23 = require("@questy/lib");
var import_intersectionBy = __toESM(require("lodash/intersectionBy"));
var import_isEmpty14 = __toESM(require("lodash/isEmpty"));
var useDefaultFormValues = ({
  isOpen,
  useFormProps,
  keepModalDataAfterClose,
  companyId,
  defaultValues,
  shortcut
}) => {
  const { setValue } = useFormProps;
  const { meta, isLoading: isLoadingMeta } = (0, import_lib23.useCredentials)();
  const { data: companyData, isLoading: isLoadingCompanyData } = (0, import_react_query50.useQuery)(
    ["accountCompanies", "forNewCommission", companyId, isOpen],
    () => (0, import_api36.getAccountCompany)(companyId, {
      fields: ["id", "defaultPlace.id"],
      extraFields: [
        "displayName",
        "defaultUser.fullName",
        "defaultPlace.fullName"
      ],
      settings: {
        withRelations: true
      }
    }),
    {
      enabled: idExists(companyId) && isOpen,
      select: (data) => data == null ? void 0 : data.data,
      refetchOnWindowFocus: false
    }
  );
  const setDefaultValuesBaseCompanyData = (companyData2) => {
    var _a2, _b, _c, _d;
    setValue(
      "company",
      {
        value: companyData2.id,
        label: companyData2.displayName
      },
      initialSetValueOptions
    );
    if (idExists((_a2 = companyData2 == null ? void 0 : companyData2.defaultUser) == null ? void 0 : _a2.id)) {
      setValue(
        "accountUser",
        {
          value: companyData2.defaultUser.id,
          label: (_b = companyData2.defaultUser) == null ? void 0 : _b.fullName
        },
        initialSetValueOptions
      );
    }
    if (idExists((_c = companyData2 == null ? void 0 : companyData2.defaultPlace) == null ? void 0 : _c.id)) {
      setValue(
        "place",
        {
          value: companyData2.defaultPlace.id,
          label: (_d = companyData2.defaultPlace) == null ? void 0 : _d.fullName
        },
        initialSetValueOptions
      );
    }
  };
  const setDefaultValuesBaseShortcut = (shortcut2) => {
    var _a2, _b, _c, _d, _e, _f, _g, _h;
    const currentAvailableAttributes = (0, import_intersectionBy.default)(
      shortcut2 == null ? void 0 : shortcut2.attributes,
      (_b = (_a2 = meta == null ? void 0 : meta.extra_fields) == null ? void 0 : _a2.attributes) == null ? void 0 : _b.items,
      "id"
    );
    const preparedAttributesForForm = prepareAttributeFormValues({
      attributes: currentAvailableAttributes
    });
    if (idExists((_c = shortcut2 == null ? void 0 : shortcut2.accountCompany) == null ? void 0 : _c.id)) {
      setValue(
        "company",
        {
          value: shortcut2 == null ? void 0 : shortcut2.accountCompany.id,
          label: (_d = shortcut2 == null ? void 0 : shortcut2.accountCompany) == null ? void 0 : _d.displayName
        },
        initialSetValueOptions
      );
    }
    if (idExists((_e = shortcut2 == null ? void 0 : shortcut2.accountUser) == null ? void 0 : _e.id)) {
      setValue(
        "accountUser",
        {
          value: shortcut2 == null ? void 0 : shortcut2.accountUser.id,
          label: (_f = shortcut2 == null ? void 0 : shortcut2.accountUser) == null ? void 0 : _f.fullName
        },
        initialSetValueOptions
      );
    }
    if (idExists((_g = shortcut2 == null ? void 0 : shortcut2.userUser) == null ? void 0 : _g.id)) {
      setValue(
        "user",
        {
          value: shortcut2 == null ? void 0 : shortcut2.userUser.id,
          label: (_h = shortcut2 == null ? void 0 : shortcut2.userUser) == null ? void 0 : _h.fullName
        },
        initialSetValueOptions
      );
    }
    if (!(0, import_isEmpty14.default)(preparedAttributesForForm)) {
      setValue("attributes", preparedAttributesForForm, initialSetValueOptions);
    }
  };
  (0, import_react393.useEffect)(() => {
    if (isOpen && !keepModalDataAfterClose.current) {
      if (idExists(companyData == null ? void 0 : companyData.id)) {
        setDefaultValuesBaseCompanyData(companyData);
      } else if (idExists(shortcut == null ? void 0 : shortcut.id)) {
        setDefaultValuesBaseShortcut(shortcut);
      }
      if (defaultValues == null ? void 0 : defaultValues.startDate) {
        setValue("startDate", defaultValues.startDate, initialSetValueOptions);
      }
    }
  }, [
    isOpen,
    defaultValues,
    companyData,
    shortcut,
    keepModalDataAfterClose == null ? void 0 : keepModalDataAfterClose.current,
    meta
  ]);
  return {
    isLoading: isLoadingCompanyData || isLoadingMeta
  };
};
var useDefaultFormValues_default = useDefaultFormValues;
var BASE_FORM_VALUES = {
  startDate: null,
  endDate: null,
  product: null,
  servicedProduct: null,
  name: null,
  user: null,
  commissionsUserUsers: null,
  company: null,
  place: null,
  accountUser: null,
  attributes: null
};
var initialSetValueOptions = {
  shouldDirty: true,
  shouldTouch: false
};

// src/components/ModalCommission/ModalMain/ModalMain.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var withCredentials9 = (Component) => {
  return ({ ...props }) => {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_lib24.CredentialContextProvider, {
      module: "commissions",
      initialModuleParams: {},
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Component, {
        ...props
      })
    });
  };
};
var ModalCommission = ({
  modalDisclousure,
  afterSuccess,
  relations,
  companyId,
  documentSerieDefinitionId,
  commissionPhaseId,
  delayInDays,
  scopeTypeId,
  shortcutData,
  defaultValues
}) => {
  const useFormProps = (0, import_react_hook_form39.useForm)({
    defaultValues: BASE_FORM_VALUES
  });
  const {
    formState: { isDirty, dirtyFields, touchedFields },
    watch,
    reset,
    setError
  } = useFormProps;
  const keepModalDataAfterClose = (0, import_react395.useRef)();
  const isVisibleConfirmationLeave = (0, import_react395.useRef)();
  const { isOpen, onClose } = modalDisclousure;
  const { isLoading: isLoadingDefaultValues } = useDefaultFormValues_default({
    isOpen,
    useFormProps,
    keepModalDataAfterClose,
    companyId,
    defaultValues,
    shortcut: shortcutData
  });
  const {
    hasCredential,
    setModuleParams,
    isFetching: isLoadingMeta
  } = (0, import_lib24.useCredentials)();
  const { permissions, isLoading: isLoadingCreatablePermissions } = useCreatablePermissions_default();
  const { t } = useAuraTranslation_default();
  const toast = (0, import_react394.useToast)();
  const { resolveApiError } = useAuraErrorResolver_default();
  const modalMainDisclousure = (0, import_react394.useDisclosure)();
  const { disclosures, onCloseHandlers, openModalCreatable } = useManageModalCreatable_default({
    useFormProps,
    modalMainDisclousure
  });
  const currentSelectedCompanyId = watch("company.value");
  const { data: scopeType, isLoading: isLoadingScopeType } = (0, import_react_query51.useQuery)(
    ["scopeType", "forNewCommission", scopeTypeId, isOpen],
    () => (0, import_api37.getCommissionScopeType)(scopeTypeId),
    {
      enabled: idExists(scopeTypeId) && isOpen,
      select: (data) => data == null ? void 0 : data.data,
      refetchOnWindowFocus: false
    }
  );
  const onSubmit = async (data) => {
    var _a2, _b, _c, _d, _e, _f;
    const preparedData = prepareDataForApi4({
      data,
      hasCredential,
      relations,
      scopeType,
      documentSerieDefinitionId,
      commissionPhaseId,
      delayInDays,
      dirtyFields,
      shortcut: shortcutData
    });
    try {
      const response = await (0, import_api37.createCommission)({
        data: preparedData
      });
      if (idExists((_b = (_a2 = response == null ? void 0 : response.data) == null ? void 0 : _a2[0]) == null ? void 0 : _b.id)) {
        modalMainDisclousure.onClose();
        onClose();
        afterSuccess == null ? void 0 : afterSuccess((_c = response == null ? void 0 : response.data) == null ? void 0 : _c[0]);
        toast({
          title: t("NOTICE_SAVE_SUCCESS"),
          status: "success"
        });
      }
    } catch (error) {
      resolveApiError(error);
      const errorFields = (_f = (_e = (_d = error == null ? void 0 : error.response) == null ? void 0 : _d.data) == null ? void 0 : _e.errors) == null ? void 0 : _f.item_0;
      if (errorFields == null ? void 0 : errorFields.length) {
        errorFields.forEach((error2) => {
          setError(error2 == null ? void 0 : error2.field, {
            message: "ERROR_FIELD_IS_EMPTY"
          });
        });
      }
    }
  };
  const handleOnClose = async () => {
    var _a2;
    modalMainDisclousure.onClose();
    if (isDirty) {
      keepModalDataAfterClose.current = true;
    }
    if (isVisibleConfirmationLeave.current)
      return;
    if (!!((_a2 = Object.keys(touchedFields)) == null ? void 0 : _a2.length)) {
      isVisibleConfirmationLeave.current = true;
      const shouldClose = await confirmWrapper({
        confirmation: t("MODAL_CLOSE_QUESTION"),
        header: t("CLOSE"),
        okButton: t("CLOSE"),
        cancelButton: t("CANCEL")
      });
      if (!shouldClose) {
        modalMainDisclousure.onOpen();
      } else {
        keepModalDataAfterClose.current = false;
        reset();
        onClose();
      }
    } else {
      keepModalDataAfterClose.current = false;
      modalMainDisclousure.onClose();
      onClose();
    }
    isVisibleConfirmationLeave.current = false;
  };
  (0, import_react395.useEffect)(() => {
    if (isOpen) {
      modalMainDisclousure.onOpen();
    } else {
      modalMainDisclousure.onClose();
    }
  }, [isOpen]);
  (0, import_react395.useEffect)(() => {
    if (!isOpen && isDirty) {
      setTimeout(() => {
        reset();
      }, 500);
    }
  }, [isOpen, isDirty]);
  (0, import_react395.useEffect)(() => {
    if (idExists(documentSerieDefinitionId) && idExists(commissionPhaseId)) {
      setModuleParams({
        "for[documentSeriesDefinition]": documentSerieDefinitionId,
        "for[commissionPhase]": commissionPhaseId,
        extra_fields: "attributes,relations"
      });
    }
  }, [documentSerieDefinitionId, commissionPhaseId]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(ModalMainProvider, {
    value: {
      openModalCreatable,
      shortcut: shortcutData
    },
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(AuraModal, {
        size: "auto",
        isOpen: modalMainDisclousure.isOpen,
        onClose: handleOnClose,
        onOverlayClick: handleOnClose,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalOverlay, {}),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form39.FormProvider, {
            ...useFormProps,
            children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ModalContent_default3, {
              onSubmit,
              isLoading: isLoadingDefaultValues || isLoadingMeta || isLoadingCreatablePermissions || isLoadingScopeType
            })
          })
        ]
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ModalCompany_default, {
        isOpen: disclosures.modalCompanyDisclosure.isOpen,
        onClose: onCloseHandlers.onCloseModalCompany,
        afterSuccess: onCloseHandlers.onCloseModalCompany
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ModalAddress_default, {
        isOpen: disclosures.modalAddressDisclosure.isOpen,
        onClose: onCloseHandlers.onCloseModalAddress,
        afterSuccess: onCloseHandlers.onCloseModalAddress,
        companyId: currentSelectedCompanyId
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ModalAccountUser_default, {
        isOpen: disclosures.modalAccountUserDisclosure.isOpen,
        onClose: onCloseHandlers.onCloseModalAccountUser,
        afterSuccess: onCloseHandlers.onCloseModalAccountUser,
        companyId: currentSelectedCompanyId
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ModalServicedProduct_default, {
        isOpen: disclosures.modalServicedProductDisclosure.isOpen,
        onClose: onCloseHandlers.onCloseModalServicedProduct,
        afterSuccess: onCloseHandlers.onCloseModalServicedProduct,
        company: {
          id: watch("company.value"),
          name: watch("company.label")
        },
        address: {
          id: watch("place.value"),
          name: watch("place.label")
        },
        product: {
          id: watch("product.value"),
          name: watch("product.label")
        },
        serialCode: watch("servicedProduct.inputValue")
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ModalProduct_default, {
        isOpen: disclosures.modalProductDisclosure.isOpen,
        onClose: onCloseHandlers.onCloseModalProduct,
        afterSuccess: onCloseHandlers.onCloseModalProduct,
        name: watch("product.inputValue")
      })
    ]
  });
};
var ModalMain_default = withCredentials9(ModalCommission);

// src/components/ModalCommission/ModalInitial/ModalInitial.tsx
var import_react396 = require("@chakra-ui/react");
var import_lib25 = require("@questy/lib");
var import_react397 = require("react");
var import_react_hook_form40 = require("react-hook-form");
var import_jsx_runtime = require("react/jsx-runtime");
var withCredentials10 = (Component) => {
  return ({ ...props }) => {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_lib25.CredentialContextProvider, {
      module: "commissions",
      initialModuleParams: {},
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Component, {
        ...props
      })
    });
  };
};
var ModalInitial = ({
  modalDisclousure,
  afterContinue,
  showScopeTypeField = false,
  commissionShortcuts
}) => {
  var _a2, _b;
  const useFormProps = (0, import_react_hook_form40.useForm)({
    shouldUnregister: true
  });
  const {
    formState: { errors, isSubmitting, isDirty },
    handleSubmit,
    control,
    reset
  } = useFormProps;
  const { hasModuleCredential, isLoading: isLoadingMeta } = (0, import_lib25.useCredentials)();
  const { t } = useAuraTranslation_default();
  const commissionShortcutsOptions = (0, import_react397.useMemo)(
    () => buildOptions((commissionShortcuts == null ? void 0 : commissionShortcuts.data) ?? [], "name", "id", [
      "documentSeriesDefinition"
    ]),
    [commissionShortcuts == null ? void 0 : commissionShortcuts.data]
  );
  const { data: scopeTypes, isLoading: isLoadingScopeTypes } = useMinimalAutoselect_default({
    endpoint: "commission_scope_types",
    labelField: "name",
    valueField: "id",
    enabled: true,
    settings: { "order[name]": "ASC" },
    translateCustom: true,
    fields: ["allowDelay"],
    additionalOptionField: [
      {
        field: "allowDelay",
        source: "allowDelay"
      }
    ]
  });
  const scopeTypesOptions = (0, import_react397.useMemo)(
    () => buildOptions(scopeTypes ?? [], "value", "id", ["allowDelay"]),
    [scopeTypes]
  );
  const onSubmit = (data) => {
    var _a3, _b2, _c;
    afterContinue({
      shortcutId: (_a3 = data == null ? void 0 : data.shortcut) == null ? void 0 : _a3.value,
      ...showScopeTypeField && { scopeTypeId: (_b2 = data == null ? void 0 : data.scopeType) == null ? void 0 : _b2.value },
      ...((_c = data == null ? void 0 : data.scopeType) == null ? void 0 : _c.allowDelay) && {
        delayInDays: Number(data == null ? void 0 : data.delayInDays)
      }
    });
    resetFormAfterClose();
  };
  const handleOnClose = async () => {
    modalDisclousure.onClose();
    if (isDirty) {
      const shouldClose = await confirmWrapper({
        confirmation: t("MODAL_CLOSE_QUESTION"),
        header: t("CLOSE"),
        okButton: t("CLOSE"),
        cancelButton: t("CANCEL")
      });
      if (!shouldClose) {
        modalDisclousure.onOpen();
      } else {
        resetFormAfterClose();
      }
    }
  };
  const resetFormAfterClose = () => {
    setTimeout(() => {
      reset();
    }, 500);
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(AuraModal, {
    size: "lg",
    isOpen: modalDisclousure.isOpen,
    onClose: handleOnClose,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalOverlay, {}),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalContent, {
        as: "form",
        onSubmit: handleSubmit(onSubmit),
        className: "commission__initial-create-modal",
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react_hook_form40.FormProvider, {
          ...useFormProps,
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalHeader, {
              showBorders: false,
              className: "commission__initial-create-modal__header",
              textTransform: "capitalize",
              children: t("new process")
            }),
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalBody, {
              overflowY: "visible",
              className: "commission__initial-create-modal__body",
              children: (commissionShortcuts == null ? void 0 : commissionShortcuts.isLoading) || isLoadingScopeTypes || isLoadingMeta ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSpinner_default, {}) : /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react396.VStack, {
                w: "full",
                children: [
                  /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react396.FormControl, {
                    isInvalid: !!errors.shortcut,
                    children: [
                      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form40.Controller, {
                        control,
                        name: "shortcut",
                        defaultValue: commissionShortcutsOptions[0],
                        rules: {
                          required: {
                            value: true,
                            message: "ERROR_FIELD_IS_EMPTY"
                          }
                        },
                        render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSelect_default, {
                          inputId: "commission__shortcut",
                          isError: !!errors.shortcut,
                          isMulti: false,
                          options: commissionShortcutsOptions,
                          isClearable: false,
                          ...field
                        })
                      }),
                      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react396.FormErrorMessage, {
                        children: t((_a2 = errors == null ? void 0 : errors.documentSeriesDefinition) == null ? void 0 : _a2.message)
                      })
                    ]
                  }),
                  showScopeTypeField && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react396.FormControl, {
                    isInvalid: !!errors.scopeType,
                    children: [
                      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react396.FormLabel, {
                        htmlFor: "commission__scopeType",
                        children: [
                          t("Add as"),
                          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraRequiredIndicator_default, {})
                        ]
                      }),
                      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form40.Controller, {
                        control,
                        name: "scopeType",
                        defaultValue: scopeTypesOptions[0],
                        rules: {
                          required: {
                            value: true,
                            message: "ERROR_FIELD_IS_EMPTY"
                          }
                        },
                        render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSelect_default, {
                          inputId: "commission__scopeType",
                          isError: !!errors.scopeType,
                          isMulti: false,
                          options: scopeTypesOptions,
                          isClearable: false,
                          ...field
                        })
                      }),
                      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react396.FormErrorMessage, {
                        children: t((_b = errors == null ? void 0 : errors.scopeType) == null ? void 0 : _b.message)
                      })
                    ]
                  })
                ]
              })
            }),
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalFooter, {
              className: "commission__initial-create-modal__footer",
              showBorders: false,
              children: !(commissionShortcuts == null ? void 0 : commissionShortcuts.isLoading) && !isLoadingScopeTypes && !isLoadingMeta && hasModuleCredential("create") && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react396.Button, {
                className: "commission__initial-create-modal__footer__button-create",
                isLoading: isSubmitting,
                type: "submit",
                colorScheme: "blue",
                textTransform: "capitalize",
                children: t("SAVE")
              })
            })
          ]
        })
      })
    ]
  });
};
var ModalInitial_default = withCredentials10(ModalInitial);

// src/components/ModalCommission/ModalCommission.tsx
var import_isEmpty15 = __toESM(require("lodash/isEmpty"));
var import_react_query52 = require("react-query");
var import_jsx_runtime = require("react/jsx-runtime");
var ModalCommission2 = ({
  isOpen,
  onClose,
  afterSuccess,
  scopeTypeId,
  relations,
  companyId,
  defaultValues
}) => {
  const [initialBaseParams, setInitialBaseParams] = (0, import_react399.useState)({
    scopeTypeId,
    documentSerieDefinitionId: void 0,
    commissionPhaseId: void 0,
    delayInDays: void 0,
    shortcutData: void 0
  });
  const { data: commissionShortcuts, isLoading: isLoadingCommissionShortcuts } = (0, import_react_query52.useQuery)(
    ["commissionShortcuts"],
    () => api_default.getEndpoint("commission_shortcuts", {
      params: {
        extra_fields: "attributes,accountCompany.displayName,accountUser.fullName,userUser.fullName",
        "page[limit]": -1,
        "order[name]": "DESC",
        "setting[with_relations]": true
      }
    }),
    {
      refetchOnWindowFocus: false,
      select: (res) => res == null ? void 0 : res.data
    }
  );
  const modalInitialDisclosure = (0, import_react398.useDisclosure)({
    onClose
  });
  const modalMainDisclosure = (0, import_react398.useDisclosure)({
    onClose
  });
  const handleOnContinueInitialModal = (data) => {
    var _a2, _b, _c;
    const shortcutData = commissionShortcuts == null ? void 0 : commissionShortcuts.find(
      (shortcut) => (shortcut == null ? void 0 : shortcut.id) === (data == null ? void 0 : data.shortcutId)
    );
    if (idExists((_a2 = shortcutData == null ? void 0 : shortcutData.documentSeriesDefinition) == null ? void 0 : _a2.id)) {
      setInitialBaseParams({
        scopeTypeId: data == null ? void 0 : data.scopeTypeId,
        documentSerieDefinitionId: (_b = shortcutData == null ? void 0 : shortcutData.documentSeriesDefinition) == null ? void 0 : _b.id,
        commissionPhaseId: (_c = shortcutData == null ? void 0 : shortcutData.commissionPhase) == null ? void 0 : _c.id,
        delayInDays: data == null ? void 0 : data.delayInDays,
        shortcutData
      });
    }
  };
  (0, import_react399.useEffect)(() => {
    if (isOpen) {
      modalInitialDisclosure.onOpen();
    }
  }, [isOpen]);
  (0, import_react399.useEffect)(() => {
    if (idExists(initialBaseParams == null ? void 0 : initialBaseParams.documentSerieDefinitionId)) {
      modalInitialDisclosure.onClose();
      modalMainDisclosure.onOpen();
    }
  }, [initialBaseParams]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ModalInitial_default, {
        modalDisclousure: modalInitialDisclosure,
        afterContinue: handleOnContinueInitialModal,
        showScopeTypeField: !(0, import_isEmpty15.default)(relations) && (relations == null ? void 0 : relations.hasOwnProperty("commissions")),
        commissionShortcuts: {
          data: commissionShortcuts,
          isLoading: isLoadingCommissionShortcuts
        }
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ModalMain_default, {
        modalDisclousure: modalMainDisclosure,
        documentSerieDefinitionId: initialBaseParams.documentSerieDefinitionId,
        commissionPhaseId: initialBaseParams.commissionPhaseId,
        scopeTypeId: initialBaseParams.scopeTypeId,
        delayInDays: initialBaseParams.delayInDays,
        shortcutData: initialBaseParams.shortcutData,
        relations,
        companyId,
        defaultValues,
        afterSuccess
      })
    ]
  });
};
var ModalCommission_default = ModalCommission2;

// src/components/ModalCompany/ModalCompany.tsx
var import_react408 = require("@chakra-ui/react");
var import_api40 = require("@questy/api");
var import_lib26 = require("@questy/lib");
var import_react409 = require("react");
var import_react_hook_form42 = require("react-hook-form");

// src/components/ModalCompany/PriceTypeField/PriceTypeField.tsx
var import_react400 = require("react");
var import_jsx_runtime = require("react/jsx-runtime");
var PriceTypeField = ({ ...props }) => {
  const { t } = useAuraTranslation_default();
  const { data } = useMinimalAutoselect_default({
    endpoint: "price_types",
    labelField: ["fullName"],
    valueField: "indexUpper",
    filters: { "filter[active]": true },
    translateCustom: true
  });
  const options = (0, import_react400.useMemo)(() => {
    return buildOptions(data, "value", "id");
  }, [data]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSelect_default, {
    options: options ?? [],
    loadingMessage: () => t("NOTHING_FOUND"),
    isClearable: true,
    ...props
  });
};
var PriceTypeField_default = PriceTypeField;

// src/components/ModalCompany/DeliveryTypeField/DeliveryTypeField.tsx
var import_react401 = require("react");
var import_jsx_runtime = require("react/jsx-runtime");
var DeliveryTypeField = ({ ...props }) => {
  const { t } = useAuraTranslation_default();
  const { data } = useMinimalAutoselect_default({
    endpoint: "delivery_types",
    labelField: "name"
  });
  const options = (0, import_react401.useMemo)(() => {
    const prepareData = data == null ? void 0 : data.map((opt) => ({
      ...opt,
      value: t(opt == null ? void 0 : opt.value)
    }));
    return buildOptions(prepareData, "value", "id");
  }, [data]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSelect_default, {
    options: options ?? [],
    loadingMessage: () => t("NOTHING_FOUND"),
    ...props
  });
};
var DeliveryTypeField_default = DeliveryTypeField;

// src/components/ModalCompany/PaymentTypeField/PaymentTypeField.tsx
var import_react402 = require("react");
var import_jsx_runtime = require("react/jsx-runtime");
var PaymentTypeField = ({ ...props }) => {
  const { t } = useAuraTranslation_default();
  const { data } = useMinimalAutoselect_default({
    endpoint: "payment_types",
    labelField: "name"
  });
  const options = (0, import_react402.useMemo)(() => {
    const prepareData = data == null ? void 0 : data.map((opt) => ({
      ...opt,
      value: t(opt == null ? void 0 : opt.value)
    }));
    return buildOptions(prepareData, "value", "id");
  }, [data]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSelect_default, {
    options: options ?? [],
    loadingMessage: () => t("NOTHING_FOUND"),
    ...props
  });
};
var PaymentTypeField_default = PaymentTypeField;

// src/components/ModalCompany/OrderSeriesField/OrderSeriesField.tsx
var import_react403 = require("react");
var import_jsx_runtime = require("react/jsx-runtime");
var OrderSeriesField = ({ ...props }) => {
  const { t } = useAuraTranslation_default();
  const { data } = useMinimalAutoselect_default({
    endpoint: "document_series_definitions",
    labelField: "name",
    filters: { "filter[documentType]": 7 }
  });
  const options = (0, import_react403.useMemo)(() => {
    const prepareData = data == null ? void 0 : data.map((opt) => ({
      ...opt,
      value: t(opt == null ? void 0 : opt.value)
    }));
    return buildOptions(prepareData, "value", "id");
  }, [data]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSelect_default, {
    options: options ?? [],
    loadingMessage: () => t("NOTHING_FOUND"),
    ...props
  });
};
var OrderSeriesField_default = OrderSeriesField;

// src/components/ModalCompany/LanguageTypeField/LanguageTypeField.tsx
var import_react404 = require("react");
var import_react_query53 = require("react-query");
var import_jsx_runtime = require("react/jsx-runtime");
var LanguageTypeField = ({ ...props }) => {
  const { t } = useAuraTranslation_default();
  const [options, setOptions] = (0, import_react404.useState)([]);
  const { data } = (0, import_react_query53.useQuery)(
    ["settingAvailableLanguages"],
    () => api_default.getEndpoint(`settings/available_languages`, {
      params: {
        fields: "value",
        "page[limit]": -1
      }
    }),
    {
      onSuccess: (data2) => {
        var _a2;
        const value = ((_a2 = data2 == null ? void 0 : data2.data) == null ? void 0 : _a2.value) ?? {};
        const parsedObj = JSON.parse(value);
        const availableLanguagesArray = parsedObj && Object.keys(parsedObj).map((key) => ({
          value: key,
          label: parsedObj[key]
        }));
        setOptions(buildOptions(availableLanguagesArray, "label", "value"));
      }
    }
  );
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSelect_default, {
    options: options ?? [],
    loadingMessage: () => t("NOTHING_FOUND"),
    ...props
  });
};
var LanguageTypeField_default = LanguageTypeField;

// src/components/ModalCompany/TaxSelectField/TaxSelectField.tsx
var import_react406 = require("@chakra-ui/react");
var import_react407 = require("react");
var import_react_hook_form41 = require("react-hook-form");

// src/components/ModalCompany/context.tsx
var import_react405 = require("react");
var import_jsx_runtime = require("react/jsx-runtime");
var ModalCompanyContext = (0, import_react405.createContext)(void 0);
var ModalCompanyContextProvider = ({
  value,
  children
}) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ModalCompanyContext.Provider, {
    value,
    children
  });
};
var useModalCompanyContext = () => {
  const context = (0, import_react405.useContext)(ModalCompanyContext);
  if (!context) {
    throw new Error(
      "useUser must be used within a ModalCompanyContextProvider"
    );
  }
  return context;
};

// src/components/ModalCompany/TaxSelectField/TaxSelectField.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var TaxSelectField = () => {
  var _a2;
  const { setIsSubmitBtnDisabled, taxDuplicates } = useModalCompanyContext();
  const { t } = useAuraTranslation_default();
  const {
    setValue,
    setError,
    watch,
    control,
    formState: { errors },
    clearErrors
  } = (0, import_react_hook_form41.useFormContext)();
  const taxTypes = Object.entries(TAX_TYPES).map(([key, value]) => ({
    value,
    label: t(`TAX_TYPES_${key}`)
  }));
  const ueCountries = Object.entries(TAX_UE_COUNTRIES).map(([key, value]) => ({
    value: key,
    label: value
  }));
  const nonUeCountries = Object.entries(TAX_NON_UE_COUNTRIES).map(
    ([key, value]) => ({
      value: key,
      label: value
    })
  );
  const nip = watch("nip");
  const nipType = watch("nipType");
  const nipCountry = watch("nipCountry");
  const { checkTax, result, isCheckEnabled } = useCheckCompanyTax_default({
    onResult: (result2) => {
      if (!result2.isValid) {
        setError("nip", {
          type: "sd",
          message: result2 == null ? void 0 : result2.message
        });
      } else {
        clearErrors("nip");
      }
      setIsSubmitBtnDisabled(!(result2 == null ? void 0 : result2.canSave));
      taxDuplicates.setTaxDuplicates(result2 == null ? void 0 : result2.duplicates);
    }
  });
  const handleValidateNip = async (param) => {
    const { newValNip, newValNipType, newValNipCountry } = param ?? {};
    if (isCheckEnabled && (newValNipType ?? (nipType == null ? void 0 : nipType.value)) !== 4 && (newValNip ?? nip)) {
      await checkTax({
        nip: newValNip ?? nip,
        nipType: newValNipType ?? (nipType == null ? void 0 : nipType.value),
        nipCountry: newValNipCountry ?? (nipCountry == null ? void 0 : nipCountry.value)
      });
    } else {
      clearErrors("nip");
    }
  };
  (0, import_react407.useEffect)(() => {
    if ((nipType == null ? void 0 : nipType.value) === 1 && (nipCountry == null ? void 0 : nipCountry.value) !== "PL") {
      setValue("nipCountry", { value: "PL", label: "PL" });
      return;
    }
    handleValidateNip();
  }, [nipType == null ? void 0 : nipType.value, nipCountry == null ? void 0 : nipCountry.value, setValue]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react406.Stack, {
    spacing: "8px",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react406.HStack, {
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form41.Controller, {
            control,
            name: "nipType",
            defaultValue: taxTypes[0],
            render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSelect_default, {
              ...field,
              onChange: (val) => {
                field.onChange(val);
                field.onBlur();
              },
              id: "company-create-nip-type__select",
              inputId: "company-create-nip-type__input",
              options: taxTypes,
              isClearable: false,
              customStyles: {
                control: {
                  minWidth: "80px",
                  width: "max-content",
                  padding: "5px 8px"
                }
              }
            })
          }),
          (nipType == null ? void 0 : nipType.value) === 1 && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form41.Controller, {
            control,
            name: "nipCountry",
            render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraInput_default, {
              value: "PL",
              isDisabled: true,
              w: "80px"
            })
          }),
          (nipType == null ? void 0 : nipType.value) === 2 && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form41.Controller, {
            control,
            name: "nipCountry",
            render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSelect_default, {
              ...field,
              onChange: (val) => {
                field.onChange(val);
                field.onBlur();
              },
              id: "company-create-nip-ue-country__select",
              inputId: "company-create-nip-ue-country__input",
              options: ueCountries,
              isClearable: false,
              customStyles: {
                control: {
                  width: "80px",
                  padding: "5px 8px"
                }
              }
            })
          }),
          (nipType == null ? void 0 : nipType.value) === 3 && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form41.Controller, {
            control,
            name: "nipCountry",
            render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSelect_default, {
              ...field,
              onChange: (val) => {
                field.onChange(val);
                field.onBlur();
              },
              id: "company-create-nip-non-ue-country__select",
              inputId: "company-create-nip-non-ue-country__input",
              options: nonUeCountries,
              isClearable: false,
              customStyles: {
                control: {
                  width: "80px",
                  padding: "5px 8px"
                }
              }
            })
          }),
          (nipType == null ? void 0 : nipType.value) !== 4 && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form41.Controller, {
            control,
            name: "nip",
            render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraInput_default, {
              ...field,
              id: "company-create-nip-input",
              isInvalid: !!(errors == null ? void 0 : errors.nip),
              onChange: (e) => {
                field.onChange(e.target.value);
                handleValidateNip({
                  newValNip: e.target.value
                });
              }
            })
          })
        ]
      }),
      !!((_a2 = result == null ? void 0 : result.duplicates) == null ? void 0 : _a2.length) && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react406.Button, {
        alignSelf: "flex-start",
        variant: "link",
        colorScheme: "blue",
        onClick: taxDuplicates.duplicatesTaxModalDisclosure.onOpen,
        "aria-label": "Show duplicates",
        children: t("COMPANY_TAX_SHOW_DUPLICATES")
      })
    ]
  });
};
var TaxSelectField_default = TaxSelectField;

// src/components/ModalCompany/ModalCompany.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var errorFieldsTranslations = {
  email: "defaultUser.email",
  postalCode: "defaultPlace.postalCode"
};
var withCredentials11 = (Component) => {
  return ({ ...props }) => {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_lib26.CredentialContextProvider, {
      module: "account_companies",
      initialModuleParams: { extra_fields: "attributes" },
      ...props.initialCredentials && {
        initialCredentials: props.initialCredentials
      },
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Component, {
        ...props
      })
    });
  };
};
var ModalCompany = ({ isOpen, onClose, afterSuccess }) => {
  const useFormProps = (0, import_react_hook_form42.useForm)({
    defaultValues: {
      name: void 0,
      shortName: void 0,
      nipCountry: void 0,
      nip: void 0,
      defaultUser: void 0,
      defaultPlace: void 0,
      defaultLanguage: void 0,
      ph: void 0,
      additionalPhs: void 0,
      defaultPriceType: void 0,
      defaultPaymentType: void 0,
      defaultDeliveryType: void 0,
      defaultOrderSeries: void 0,
      attributes: void 0
    }
  });
  const [isSubmitBtnDisabled, setIsSubmitBtnDisabled] = (0, import_react409.useState)(false);
  const [taxDuplicates, setTaxDuplicates] = (0, import_react409.useState)([]);
  const duplicatesTaxModalDisclosure = (0, import_react408.useDisclosure)();
  const mainModalDisclosure = (0, import_react408.useDisclosure)();
  (0, import_react409.useEffect)(() => {
    if (isOpen) {
      mainModalDisclosure.onOpen();
    } else if (!isOpen) {
      mainModalDisclosure.onClose();
      useFormProps.reset();
      setIsSubmitBtnDisabled(false);
    }
  }, [isOpen]);
  (0, import_react409.useEffect)(() => {
    if (!isOpen)
      return;
    if (duplicatesTaxModalDisclosure.isOpen) {
      mainModalDisclosure.onClose();
    } else {
      mainModalDisclosure.onOpen();
    }
  }, [duplicatesTaxModalDisclosure.isOpen]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(ModalCompanyContextProvider, {
    value: {
      isSubmitBtnDisabled,
      setIsSubmitBtnDisabled,
      taxDuplicates: {
        setTaxDuplicates,
        duplicates: taxDuplicates,
        duplicatesTaxModalDisclosure
      }
    },
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(AuraModal, {
        size: "xl",
        isOpen: mainModalDisclosure.isOpen,
        onClose,
        closeOnOverlayClick: false,
        scrollBehavior: "inside",
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalOverlay, {}),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form42.FormProvider, {
            ...useFormProps,
            children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ModalCompanyContent, {
              onClose,
              afterSuccess
            })
          })
        ]
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TaxDuplicatesModal_default, {
        isOpen: duplicatesTaxModalDisclosure.isOpen,
        onClose: duplicatesTaxModalDisclosure.onClose,
        duplicates: taxDuplicates
      })
    ]
  });
};
var ModalCompanyContent = ({
  onClose,
  afterSuccess
}) => {
  const { t } = useAuraTranslation_default();
  const { resolveApiError } = useAuraErrorResolver_default();
  const toast = (0, import_react408.useToast)();
  const { hasCredential } = (0, import_lib26.useCredentials)();
  const { isSubmitBtnDisabled, setIsSubmitBtnDisabled } = useModalCompanyContext();
  const useFormProps = (0, import_react_hook_form42.useFormContext)();
  const { handleSubmit, setError, formState, clearErrors } = useFormProps;
  const handleSubmitForm = async (formData) => {
    setIsSubmitBtnDisabled(true);
    const preparedData = {};
    Object.keys(formData).forEach((filterKey) => {
      if (typeof formData[filterKey] === "string" && formData[filterKey].trim() === "") {
        preparedData[filterKey] = null;
      } else {
        preparedData[filterKey] = formData[filterKey];
      }
    });
    createNewCompany(preparedData);
  };
  const createNewCompany = async (data) => {
    var _a2, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s;
    const preparedAttributes = prepareAttributesForApi(
      data == null ? void 0 : data.attributes,
      hasCredential
    );
    const { attributes, isIndividual, ...fields } = data;
    const nipType = isIndividual ? 4 : (_a2 = data.nipType) == null ? void 0 : _a2.value;
    const nipData = { nipType };
    if ([1, 2, 3].includes(nipType)) {
      nipData["nipCountry"] = (_b = data.nipCountry) == null ? void 0 : _b.value;
      nipData["nip"] = data.nip;
    } else if (nipType === 4) {
      nipData["nipCountry"] = null;
      nipData["nip"] = null;
    }
    try {
      const response = await (0, import_api40.createAccountCompany)({
        data: {
          ...nipData,
          ...((_c = data.name) == null ? void 0 : _c.length) && {
            name: data.name
          },
          ...((_d = data.shortName) == null ? void 0 : _d.length) && {
            shortName: data.shortName
          },
          ...(data == null ? void 0 : data.defaultUser) && {
            defaultUser: data.defaultUser
          },
          ...(data == null ? void 0 : data.defaultPlace) && {
            defaultPlace: data == null ? void 0 : data.defaultPlace
          },
          ...((_e = data.ph) == null ? void 0 : _e.value) && {
            ph: data.ph.value
          },
          ...((_f = data.additionalPhs) == null ? void 0 : _f.length) && {
            additionalPhs: data.additionalPhs.map(
              (user) => ({ id: user.id })
            )
          },
          ...((_g = data.defaultPriceType) == null ? void 0 : _g.value) && {
            defaultPriceType: data.defaultPriceType.value
          },
          ...((_h = data.defaultDeliveryType) == null ? void 0 : _h.value) && {
            defaultDeliveryType: data.defaultDeliveryType.value
          },
          ...((_i = data.defaultPaymentType) == null ? void 0 : _i.value) && {
            defaultPaymentType: data.defaultPaymentType.value
          },
          ...((_j = data.defaultOrderSeries) == null ? void 0 : _j.value) && {
            defaultOrderSeries: data.defaultOrderSeries.value
          },
          ...((_k = data.defaultLanguage) == null ? void 0 : _k.value) && {
            defaultLanguage: data.defaultLanguage.value
          },
          ...(preparedAttributes == null ? void 0 : preparedAttributes.length) && {
            attributes: preparedAttributes
          },
          ...data.isIndividual && {
            name: `${data.defaultUser.firstName} ${data.defaultUser.lastName}`
          }
        },
        extraFields: [
          "displayName",
          "defaultPlace.fullName",
          "defaultUser.fullName"
        ]
      });
      if (response.errors === null) {
        toast({
          title: t("NOTICE_SAVE_SUCCESS"),
          status: "success"
        });
        afterSuccess == null ? void 0 : afterSuccess(response.data);
        onClose();
      }
    } catch (error) {
      resolveApiError(error);
      if ((_m = (_l = error == null ? void 0 : error.response) == null ? void 0 : _l.data) == null ? void 0 : _m.errors) {
        const field = (_p = (_o = (_n = error.response.data.errors) == null ? void 0 : _n["item_0"]) == null ? void 0 : _o[0]) == null ? void 0 : _p.field;
        if (field) {
          setError(
            errorFieldsTranslations[field] ?? field,
            {
              type: "manual",
              message: (_s = (_r = (_q = error.response.data.errors) == null ? void 0 : _q["item_0"]) == null ? void 0 : _r[0]) == null ? void 0 : _s.type
            },
            { shouldFocus: true }
          );
        }
      }
      setIsSubmitBtnDisabled(false);
    }
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(AuraModalContent, {
    as: "form",
    onSubmit: handleSubmit(handleSubmitForm),
    className: "company__create-modal",
    h: "100%",
    maxH: { base: "100%", md: "calc(100% - 120px)" },
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalHeader, {
        className: "company__create-modal__header",
        children: t("NEW_COMPANY")
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalBody, {
        overflowY: "visible",
        className: "company__create-modal__body",
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CompanyForm, {})
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalFooter, {
        className: "company__create-modal__footer",
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react408.Button, {
          className: "company__create-modal__footer-button-create",
          isLoading: formState.isSubmitting,
          isDisabled: isSubmitBtnDisabled,
          type: "submit",
          colorScheme: "blue",
          children: t("ADD")
        })
      })
    ]
  });
};
var CompanyForm = () => {
  var _a2, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k;
  const {
    control,
    formState,
    getValues,
    setValue,
    formState: { errors },
    watch
  } = (0, import_react_hook_form42.useFormContext)();
  const { hasCredential, meta } = (0, import_lib26.useCredentials)();
  const { t } = useAuraTranslation_default();
  const { resolveApiError } = useAuraErrorResolver_default();
  const [isLoadingGus, setIsLoadingGus] = (0, import_react409.useState)(false);
  const toast = (0, import_react408.useToast)();
  const [isIndividual, setIsIndividual] = (0, import_react409.useState)(false);
  const settings = useSettings_default();
  const countryCodeSelector = ((_a2 = settings == null ? void 0 : settings.settings) == null ? void 0 : _a2.countryCodeSelector) || (settings == null ? void 0 : settings.country_code_selector) === "true";
  const companyShortNameEnabled = ((_b = settings == null ? void 0 : settings.settings) == null ? void 0 : _b.companyShortNameEnabled) ?? (settings == null ? void 0 : settings.company_short_name_enabled) ?? 0;
  const attributesFromMeta = (_e = (_d = (_c = meta == null ? void 0 : meta.extra_fields) == null ? void 0 : _c.attributes) == null ? void 0 : _d.items) == null ? void 0 : _e.filter(
    (attr) => {
      var _a3;
      return (_a3 = attr.options) == null ? void 0 : _a3.useWhenRegister;
    }
  );
  const nip = watch("nip");
  const nipType = watch("nipType");
  const getDataFromGus = async () => {
    setIsLoadingGus(true);
    const nip2 = getValues("nip");
    let response;
    try {
      response = await api_default.getEndpoint(`gus/search/${nip2}`, {});
    } catch (error) {
      resolveApiError(error, {
        customTitle: "COMPANY_GUS_DOWNLOAD_FAILED",
        variant: "subtle"
      });
      if (error.request.status === 404) {
        resolveApiError(error, {
          customTitle: "COMPANY_GUS_NOT_FOUND",
          variant: "subtle"
        });
      }
    }
    const gusData = response == null ? void 0 : response.data;
    if (gusData) {
      setValue("name", gusData.name);
      setValue("defaultPlace.streetAddress", gusData.addressStreet);
      setValue("defaultPlace.streetNumber", gusData.addressStreetNumber);
      setValue("defaultPlace.localNumber", gusData.addressLocalNumber);
      setValue("defaultPlace.city", gusData.addressCity);
      setValue("defaultPlace.postalCode", gusData.addressPostalCode);
      setValue("defaultPlace.province", gusData.addressProvince);
      hasCredential("addressCommunity", "field", "show") && setValue("defaultPlace.community", gusData.addressCommunity);
      hasCredential("addressCounty", "field", "show") && setValue("defaultPlace.county", gusData.addressCounty);
      setValue("defaultPlace.country", countryCodeSelector ? "PL" : "Polska");
      toast({
        description: t("COMPANY_GUS_DOWNLOAD_SUCCESS"),
        variant: "subtle",
        status: "success",
        isClosable: true
      });
    }
    if (response == null ? void 0 : response.errors) {
      resolveApiError(response, {
        customTitle: "COMPANY_GUS_DOWNLOAD_FAILED",
        variant: "subtle"
      });
    }
    setIsLoadingGus(false);
  };
  const { data: userUsers } = useMinimalAutoselect_default({
    endpoint: "user_users",
    labelField: "fullName",
    valueField: "id",
    extraFields: ["fullName"],
    fields: ["avatar", "defaultCallendarColor"],
    additionalOptionField: [
      { field: "avatar", source: "avatar" },
      { field: "label", source: "fullName" },
      { field: "value", source: "id" },
      { field: "defaultCallendarColor", source: "defaultCallendarColor" }
    ]
  });
  (0, import_react409.useEffect)(() => {
    setValue("isIndividual", isIndividual);
  }, [isIndividual]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react408.Stack, {
    spacing: 4,
    "data-testid": "create-company-form",
    className: "company__create-modal__form",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react408.Flex, {
        justifyContent: "flex-end",
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react408.Text, {
            textStyle: "bodyInput",
            color: "red.500",
            mr: "16px",
            children: "*"
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react408.Text, {
            textStyle: "bodyInput",
            color: "blackAlpha.500",
            children: t("REQUIRED")
          })
        ]
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react408.FormControl, {
        display: "flex",
        alignItems: "center",
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form42.Controller, {
          control,
          name: "isIndividual",
          render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react408.RadioGroup, {
            ...field,
            onChange: (val) => setIsIndividual(!!parseInt(val)),
            value: isIndividual ? "1" : "0",
            children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react408.Stack, {
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react408.Radio, {
                  value: "0",
                  children: t("COMPANY_REGISTER_COMPANY")
                }),
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react408.Radio, {
                  value: "1",
                  children: t("COMPANY_REGISTER_INDIVIDUAL")
                })
              ]
            })
          })
        })
      }),
      !isIndividual && hasCredential("nip", "field", "show") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react408.FormControl, {
        isInvalid: !!errors.nip,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react408.Stack, {
            isInline: true,
            justifyContent: "space-between",
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react408.FormLabel, {
                htmlFor: "company-create-nip-input",
                children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
                  children: [
                    t("NIP"),
                    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraRequiredIndicator_default, {})
                  ]
                })
              }),
              (nipType == null ? void 0 : nipType.value) === 1 && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react408.Button, {
                variant: "link",
                colorScheme: "blue",
                onClick: getDataFromGus,
                isLoading: isLoadingGus,
                isDisabled: !nip,
                children: t("COMPANY_DOWNLOAD_FROM_GUS")
              })
            ]
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TaxSelectField_default, {}),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react408.FormErrorMessage, {
            children: t((_f = errors == null ? void 0 : errors.nip) == null ? void 0 : _f.message)
          })
        ]
      }),
      !isIndividual && hasCredential("name", "field", "show") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react408.FormControl, {
        isInvalid: !!(errors == null ? void 0 : errors.name),
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react408.FormLabel, {
            htmlFor: "create-company-form-name",
            children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
              children: [
                t("NAME"),
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraRequiredIndicator_default, {})
              ]
            })
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form42.Controller, {
            control,
            name: "name",
            rules: {
              required: {
                value: true,
                message: "ERROR_FIELD_IS_EMPTY"
              }
            },
            render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraInput_default, {
              ...field,
              id: "create-company-form-name"
            })
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react408.FormErrorMessage, {
            children: t(((_g = errors == null ? void 0 : errors.name) == null ? void 0 : _g.message) ?? "ERROR")
          })
        ]
      }),
      !isIndividual && hasCredential("shortName", "field", "show") && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ShortNameForm, {
        companyShortNameEnabled,
        control,
        errors
      }),
      isIndividual && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CompanyAccountUserForm, {
        hasCredential,
        control,
        isIndividual,
        companyShortNameEnabled
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react408.Text, {
        textStyle: "h5",
        as: "h5",
        mt: "24px",
        children: t("RESPONSIBLE_USERS")
      }),
      hasCredential("ph", "field", "show") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react408.FormControl, {
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react408.FormLabel, {
            htmlFor: "create-company-form-ph",
            children: t("Ph")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form42.Controller, {
            control,
            name: "ph",
            render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSelect_default, {
              withAvatars: true,
              options: userUsers,
              closeMenuOnSelect: true,
              inputId: "create-company-form-ph",
              ...field
            })
          })
        ]
      }),
      hasCredential("additionalPhs", "field", "show") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react408.FormControl, {
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react408.FormLabel, {
            htmlFor: "create-company-form-additional-phs",
            children: t("LIST_COLUMN_additionalPhs")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form42.Controller, {
            control,
            name: "additionalPhs",
            render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSelect_default, {
              isMulti: true,
              withAvatars: true,
              withCheckbox: true,
              options: userUsers,
              inputId: "create-company-form-additional-phs",
              ...field
            })
          })
        ]
      }),
      (hasCredential("defaultPriceType", "field", "show") || hasCredential("defaultDeliveryType", "field", "show") || hasCredential("defaultPaymentType", "field", "show") || hasCredential("defaultOrderSeries", "field", "show")) && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react408.Text, {
        textStyle: "h5",
        as: "h5",
        mt: "24px",
        children: t("DELIVERIES_AND_PAYMENTS")
      }),
      hasCredential("defaultPriceType", "field", "show") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react408.FormControl, {
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react408.FormLabel, {
            htmlFor: "create-company-form-default-price-type",
            children: t("LIST_COLUMN_defaultPriceType")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form42.Controller, {
            control,
            name: "defaultPriceType",
            render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(PriceTypeField_default, {
              ...field,
              inputId: "create-company-form-default-price-type",
              isReadOnly: !hasCredential("defaultPriceType", "field", "edit")
            })
          })
        ]
      }),
      hasCredential("defaultDeliveryType", "field", "show") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react408.FormControl, {
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react408.FormLabel, {
            htmlFor: "create-company-form-default-delivery-type",
            children: t("LIST_COLUMN_defaultDeliveryType")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form42.Controller, {
            control,
            name: "defaultDeliveryType",
            render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(DeliveryTypeField_default, {
              ...field,
              inputId: "create-company-form-default-delivery-type",
              isReadOnly: !hasCredential("defaultDeliveryType", "field", "edit")
            })
          })
        ]
      }),
      hasCredential("defaultPaymentType", "field", "show") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react408.FormControl, {
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react408.FormLabel, {
            htmlFor: "create-company-form-default-payment-type",
            children: t("LIST_COLUMN_defaultPaymentType")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form42.Controller, {
            control,
            name: "defaultPaymentType",
            render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(PaymentTypeField_default, {
              ...field,
              inputId: "create-company-form-default-payment-type",
              isReadOnly: !hasCredential("defaultPaymentType", "field", "edit")
            })
          })
        ]
      }),
      hasCredential("defaultOrderSeries", "field", "show") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react408.FormControl, {
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react408.FormLabel, {
            htmlFor: "create-company-form-default-order-series",
            children: t("LIST_COLUMN_defaultOrderSeries")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form42.Controller, {
            control,
            name: "defaultOrderSeries",
            render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(OrderSeriesField_default, {
              ...field,
              inputId: "create-company-form-default-order-series",
              isReadOnly: !hasCredential("defaultOrderSeries", "field", "edit")
            })
          })
        ]
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react408.Text, {
        textStyle: "h5",
        as: "h5",
        mt: "24px",
        children: t("ADDRESS")
      }),
      hasCredential("addressStreet", "field", "show") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react408.FormControl, {
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react408.FormLabel, {
            htmlFor: "create-company-form-street-address",
            children: t("DATA_STREET")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form42.Controller, {
            control,
            name: "defaultPlace.streetAddress",
            render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraInput_default, {
              ...field,
              id: "create-company-form-street-address"
            })
          })
        ]
      }),
      hasCredential("addressStreetNumber", "field", "show") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react408.FormControl, {
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react408.FormLabel, {
            htmlFor: "create-company-form-address-street-number",
            children: t("DATA_STREET_NUMBER")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form42.Controller, {
            control,
            name: "defaultPlace.streetNumber",
            render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraInput_default, {
              ...field,
              id: "create-company-form-address-street-number"
            })
          })
        ]
      }),
      hasCredential("addressLocalNumber", "field", "show") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react408.FormControl, {
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react408.FormLabel, {
            htmlFor: "create-company-form-address-local-number",
            children: t("DATA_LOCAL_NUMBER")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form42.Controller, {
            control,
            name: "defaultPlace.localNumber",
            render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraInput_default, {
              ...field,
              id: "create-company-form-address-local-number"
            })
          })
        ]
      }),
      hasCredential("addressPostalCode", "field", "show") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react408.FormControl, {
        isInvalid: (_i = (_h = formState == null ? void 0 : formState.errors) == null ? void 0 : _h.defaultPlace) == null ? void 0 : _i.postalCode,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react408.FormLabel, {
            htmlFor: "create-company-form-address-postal-code",
            children: t("DATA_ZIP_CODE")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form42.Controller, {
            control,
            name: "defaultPlace.postalCode",
            render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraInput_default, {
              ...field,
              id: "create-company-form-address-postal-code"
            })
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react408.FormErrorMessage, {
            children: t((_k = (_j = errors == null ? void 0 : errors.defaultPlace) == null ? void 0 : _j.postalCode) == null ? void 0 : _k.message)
          })
        ]
      }),
      hasCredential("addressCity", "field", "show") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react408.FormControl, {
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react408.FormLabel, {
            htmlFor: "create-company-form-address-city",
            children: t("DATA_CITY")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form42.Controller, {
            control,
            name: "defaultPlace.city",
            render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraInput_default, {
              ...field,
              id: "create-company-form-address-city"
            })
          })
        ]
      }),
      hasCredential("addressCommunity", "field", "show") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react408.FormControl, {
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react408.FormLabel, {
            htmlFor: "create-company-form-address-community",
            children: t("DATA_COMMUNITY")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form42.Controller, {
            control,
            name: "defaultPlace.community",
            render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraInput_default, {
              ...field,
              id: "create-company-form-address-community"
            })
          })
        ]
      }),
      hasCredential("addressCounty", "field", "show") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react408.FormControl, {
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react408.FormLabel, {
            htmlFor: "create-company-form-address-county",
            children: t("DATA_COUNTY")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form42.Controller, {
            control,
            name: "defaultPlace.county",
            render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraInput_default, {
              ...field,
              id: "create-company-form-address-county"
            })
          })
        ]
      }),
      hasCredential("addressProvince", "field", "show") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react408.FormControl, {
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react408.FormLabel, {
            htmlFor: "create-company-form-address-province",
            children: t("DATA_PROVINCE")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form42.Controller, {
            control,
            name: "defaultPlace.province",
            render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraInput_default, {
              ...field,
              id: "create-company-form-address-province"
            })
          })
        ]
      }),
      hasCredential("addressCountry", "field", "show") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react408.FormControl, {
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react408.FormLabel, {
            htmlFor: "create-company-form-address-country",
            children: t("DATA_COUNTRY")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form42.Controller, {
            control,
            name: "defaultPlace.country",
            render: ({ field }) => {
              return countryCodeSelector ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraCountrySelect_default, {
                ...field,
                inputId: "create-company-form-address-country"
              }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraInput_default, {
                ...field,
                id: "create-company-form-address-country"
              });
            }
          })
        ]
      }),
      hasCredential("defaultLanguage", "field", "show") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react408.FormControl, {
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react408.FormLabel, {
            htmlFor: "create-company-form-default-language",
            children: t("LIST_COLUMN_defaultLanguage")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form42.Controller, {
            control,
            name: "defaultLanguage",
            render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(LanguageTypeField_default, {
              ...field,
              inputId: "create-company-form-default-language"
            })
          })
        ]
      }),
      !isIndividual && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react408.Text, {
            textStyle: "h5",
            as: "h5",
            mt: "24px",
            children: t("ACCOUNT_USER_CHANGED")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CompanyAccountUserForm, {
            hasCredential,
            control,
            isIndividual,
            companyShortNameEnabled
          })
        ]
      }),
      (attributesFromMeta == null ? void 0 : attributesFromMeta.length) && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react408.Text, {
            textStyle: "h5",
            as: "h5",
            children: t("ATTRIBUTES")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Attributes_default, {
            attributes: attributesFromMeta,
            toForm: true
          })
        ]
      })
    ]
  });
};
var ShortNameForm = ({ companyShortNameEnabled, control, errors }) => {
  var _a2;
  const { t } = useAuraTranslation_default();
  if (companyShortNameEnabled < 1) {
    return null;
  }
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react408.FormControl, {
    isInvalid: !!errors.shortName,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react408.FormLabel, {
        htmlFor: "create-company-form-short-name",
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
          children: [
            t("SHORT_NAME"),
            companyShortNameEnabled === 1 && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraRequiredIndicator_default, {})
          ]
        })
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form42.Controller, {
        control,
        name: "shortName",
        render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraInput_default, {
          ...field,
          id: "create-company-form-short-name"
        })
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react408.FormErrorMessage, {
        children: t((_a2 = errors == null ? void 0 : errors.shortName) == null ? void 0 : _a2.message)
      })
    ]
  });
};
var CompanyAccountUserForm = ({
  hasCredential,
  control,
  isIndividual,
  companyShortNameEnabled
}) => {
  var _a2, _b, _c, _d, _e, _f, _g, _h, _i;
  const { t } = useAuraTranslation_default();
  const { errors } = (0, import_react_hook_form42.useFormState)({ control });
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
    children: [
      hasCredential("defaultUser", "field", "show") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react408.FormControl, {
        isInvalid: !!((_a2 = errors == null ? void 0 : errors.defaultUser) == null ? void 0 : _a2.firstName),
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react408.FormLabel, {
            htmlFor: "create-company-form-default-user-first-name",
            children: [
              t("FIRST_NAME"),
              isIndividual && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraRequiredIndicator_default, {})
            ]
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form42.Controller, {
            control,
            name: "defaultUser.firstName",
            render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraInput_default, {
              ...field,
              id: "create-company-form-default-user-first-name"
            }),
            rules: isIndividual && {
              required: {
                value: true,
                message: "ERROR_FIELD_IS_EMPTY"
              }
            }
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react408.FormErrorMessage, {
            children: t((_c = (_b = errors == null ? void 0 : errors.defaultUser) == null ? void 0 : _b.firstName) == null ? void 0 : _c.message)
          })
        ]
      }),
      hasCredential("defaultUser", "field", "show") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react408.FormControl, {
        isInvalid: !!((_d = errors == null ? void 0 : errors.defaultUser) == null ? void 0 : _d.lastName),
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react408.FormLabel, {
            htmlFor: "create-company-form-default-user-last-name",
            children: [
              t("LAST_NAME"),
              isIndividual && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraRequiredIndicator_default, {})
            ]
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form42.Controller, {
            control,
            name: "defaultUser.lastName",
            render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraInput_default, {
              ...field,
              id: "create-company-form-default-user-last-name"
            }),
            rules: isIndividual && {
              required: {
                value: true,
                message: "ERROR_FIELD_IS_EMPTY"
              }
            }
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react408.FormErrorMessage, {
            children: t((_f = (_e = errors == null ? void 0 : errors.defaultUser) == null ? void 0 : _e.lastName) == null ? void 0 : _f.message)
          })
        ]
      }),
      isIndividual && hasCredential("shortName", "field", "show") && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ShortNameForm, {
        companyShortNameEnabled,
        control,
        errors
      }),
      hasCredential("defaultUser", "field", "show") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react408.FormControl, {
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react408.FormLabel, {
            htmlFor: "create-company-form-default-user-mobile-number",
            children: t("MOBILE_PHONE")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form42.Controller, {
            control,
            name: "defaultUser.mobileNumber",
            render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraInput_default, {
              ...field,
              id: "create-company-form-default-user-mobile-number"
            })
          })
        ]
      }),
      hasCredential("defaultUser", "field", "show") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react408.FormControl, {
        isInvalid: !!((_g = errors == null ? void 0 : errors.defaultUser) == null ? void 0 : _g.email),
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react408.FormLabel, {
            htmlFor: "create-company-form-default-user-email",
            children: t("EMAIL")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form42.Controller, {
            control,
            name: "defaultUser.email",
            render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraInput_default, {
              ...field,
              id: "create-company-form-default-user-email"
            })
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react408.FormErrorMessage, {
            children: t((_i = (_h = errors == null ? void 0 : errors.defaultUser) == null ? void 0 : _h.email) == null ? void 0 : _i.message)
          })
        ]
      })
    ]
  });
};
var ModalCompany_default = withCredentials11(ModalCompany);

// src/components/ModalDiscountCode/consts.ts
var DiscountCodeScopeTypes = /* @__PURE__ */ ((DiscountCodeScopeTypes2) => {
  DiscountCodeScopeTypes2[DiscountCodeScopeTypes2["all"] = 1] = "all";
  DiscountCodeScopeTypes2[DiscountCodeScopeTypes2["products"] = 2] = "products";
  DiscountCodeScopeTypes2[DiscountCodeScopeTypes2["productCategories"] = 3] = "productCategories";
  return DiscountCodeScopeTypes2;
})(DiscountCodeScopeTypes || {});
var DISCOUNT_CODES_TYPES = [
  { value: 1, label: "DISCOUNT_CODES_TYPE_PERCENTAGE" },
  { value: 2, label: "DISCOUNT_CODES_TYPE_VALUE" },
  { value: 3, label: "DISCOUNT_CODES_TYPE_FIXED_PRICE" }
];
var DISCOUNT_CODES_SCOPES = [
  { value: 1 /* all */, label: "DISCOUNT_CODES_SCOPE_ALL" },
  {
    value: 2 /* products */,
    label: "DISCOUNT_CODES_SCOPE_SELECTED_PRODUCTS"
  },
  {
    value: 3 /* productCategories */,
    label: "DISCOUNT_CODES_SCOPE_SELECTED_CATEGORIES"
  }
];

// src/components/ModalDiscountCode/ModalDiscountCode.tsx
var import_react411 = require("@chakra-ui/react");
var import_api42 = require("@questy/api");
var import_lib27 = require("@questy/lib");
var import_date_fns15 = require("date-fns");
var import_react412 = require("react");
var import_react_hook_form43 = require("react-hook-form");
var import_react_query55 = require("react-query");

// src/components/ModalDiscountCode/Code/Code.tsx
var import_react410 = require("@chakra-ui/react");
var import_react_query54 = require("react-query");
var import_jsx_runtime = require("react/jsx-runtime");
var Code = ({ setValue, isReadOnly, ...props }) => {
  const { t } = useAuraTranslation_default();
  const { resolveApiError } = useAuraErrorResolver_default();
  const { mutate, isLoading } = (0, import_react_query54.useMutation)(async () => {
    var _a2, _b;
    let response;
    try {
      response = await api_default.getEndpoint("discount_codes/generateCode", {});
      ((_a2 = response == null ? void 0 : response.data) == null ? void 0 : _a2.code) && setValue("code", (_b = response == null ? void 0 : response.data) == null ? void 0 : _b.code);
    } catch (error) {
      resolveApiError(error);
    }
    return response;
  });
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react410.Stack, {
    isInline: true,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraInput_default, {
        ...props,
        isReadOnly,
        isRequired: false
      }),
      !isReadOnly && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react410.Box, {
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react410.Button, {
          colorScheme: "blue",
          variant: "solid",
          onClick: () => mutate(),
          isLoading,
          children: t("DISCOUNT_CODE_GENERATE")
        })
      })
    ]
  });
};
var Code_default = Code;

// src/components/ModalDiscountCode/ModalDiscountCode.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var withCredentials12 = (Component) => {
  return ({ ...props }) => {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_lib27.CredentialContextProvider, {
      module: "discount_codes",
      initialModuleParams: { extra_fields: "relations" },
      ...props.initialCredentials && {
        initialCredentials: props.initialCredentials
      },
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Component, {
        ...props
      })
    });
  };
};
var prepareRelations = (data, scope) => {
  var _a2, _b, _c, _d, _e;
  const companies = (_b = (_a2 = data.accountCompanies) == null ? void 0 : _a2.filter((company) => company.value !== -1)) == null ? void 0 : _b.map((company) => company.value);
  const products = (_c = data.products) == null ? void 0 : _c.map((product) => product.value);
  const excludedProducts = (_d = data.excludedProducts) == null ? void 0 : _d.map(
    (excludedProduct) => excludedProduct.value
  );
  const productCategories = (_e = data.productCategories) == null ? void 0 : _e.map(
    (productCategory) => productCategory.value
  );
  return {
    ...(companies == null ? void 0 : companies.length) && { accountCompanies: companies },
    ...scope === 2 && (products == null ? void 0 : products.length) && { products },
    ...[1, 3].includes(scope) && (excludedProducts == null ? void 0 : excludedProducts.length) && { excludedProducts },
    ...scope === 3 && (productCategories == null ? void 0 : productCategories.length) && { productCategories }
  };
};
var ModalDiscountCode = ({
  id,
  isOpen,
  onClose,
  afterSuccess,
  companyId,
  isReadOnly = false
}) => {
  const { data, isLoading, isFetching } = (0, import_react_query55.useQuery)(
    ["discount_code", id],
    () => (0, import_api42.getDiscountCode)(id, {
      extraFields: ["relations"],
      settings: {
        withRelations: true
      }
    }),
    {
      enabled: !!id && isOpen,
      refetchOnWindowFocus: false,
      cacheTime: 0
    }
  );
  const { data: accountCompany, isLoading: isLoadingAccountCompany } = (0, import_react_query55.useQuery)(
    ["account_companies", companyId],
    () => (0, import_api42.getAccountCompany)(companyId, {
      fields: ["id"],
      extraFields: ["displayName"]
    }),
    {
      enabled: !idExists(id) && isOpen && idExists(companyId),
      refetchOnWindowFocus: false,
      select: (res) => res == null ? void 0 : res.data
    }
  );
  const defaultDataCreateForCompany = (0, import_react412.useMemo)(
    () => idExists(companyId) ? {
      relations: {
        accountCompanies: [
          {
            id: accountCompany == null ? void 0 : accountCompany.id,
            value: accountCompany == null ? void 0 : accountCompany.displayName
          }
        ]
      }
    } : void 0,
    [accountCompany, companyId]
  );
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(AuraModal, {
    size: "lg",
    isOpen,
    onClose,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalOverlay, {}),
      isLoading || isFetching || isLoadingAccountCompany ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSpinner_default, {}) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ModalDiscountCodeContent, {
        isOpen,
        defaultData: (data == null ? void 0 : data.data) ?? defaultDataCreateForCompany,
        onClose,
        afterSuccess,
        isReadOnly
      })
    ]
  });
};
var ModalDiscountCodeContent = ({
  isOpen,
  defaultData,
  onClose,
  afterSuccess,
  isReadOnly: isReadOnlyProp
}) => {
  var _a2, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l;
  const { t } = useAuraTranslation_default();
  const { resolveApiError } = useAuraErrorResolver_default();
  const toast = (0, import_react411.useToast)();
  const id = defaultData == null ? void 0 : defaultData.id;
  const isReadOnly = isReadOnlyProp || (defaultData == null ? void 0 : defaultData.startDate) && ((0, import_date_fns15.isPast)(new Date(defaultData == null ? void 0 : defaultData.startDate)) || (0, import_date_fns15.isToday)(new Date(defaultData == null ? void 0 : defaultData.startDate)));
  const [isSubmitBtnDisabled, setIsSubmitBtnDisabled] = (0, import_react412.useState)(false);
  const translatedTypes = (0, import_react412.useMemo)(
    () => DISCOUNT_CODES_TYPES.map((type) => ({
      ...type,
      label: t(type.label)
    })),
    [t]
  );
  const translatedScopes = (0, import_react412.useMemo)(
    () => DISCOUNT_CODES_SCOPES.map((type) => ({
      ...type,
      label: t(type.label)
    })),
    [t]
  );
  const { hasModuleCredential } = (0, import_lib27.useCredentials)();
  const {
    register,
    control,
    formState,
    handleSubmit,
    reset,
    resetField,
    setError,
    setValue,
    getValues,
    watch
  } = (0, import_react_hook_form43.useForm)({
    defaultValues: {
      ...defaultData ? {
        ...defaultData,
        ...(defaultData == null ? void 0 : defaultData.type) && {
          type: translatedTypes.find(
            (type) => type.value === defaultData.type
          )
        },
        ...(defaultData == null ? void 0 : defaultData.scope) && {
          scope: translatedScopes.find(
            (scope) => scope.value === defaultData.scope
          )
        },
        ...(defaultData == null ? void 0 : defaultData.startDate) && {
          startDate: new Date(defaultData == null ? void 0 : defaultData.startDate)
        },
        ...(defaultData == null ? void 0 : defaultData.endDate) && {
          endDate: new Date(defaultData == null ? void 0 : defaultData.endDate)
        },
        ...(defaultData == null ? void 0 : defaultData.createDate) && {
          createDate: new Date(defaultData == null ? void 0 : defaultData.createDate)
        },
        ...((_b = (_a2 = defaultData == null ? void 0 : defaultData.relations) == null ? void 0 : _a2.accountCompanies) == null ? void 0 : _b.length) ? {
          accountCompanies: (_c = defaultData == null ? void 0 : defaultData.relations.accountCompanies) == null ? void 0 : _c.map(
            (company) => ({
              value: company.id,
              label: company.value
            })
          )
        } : { accountCompanies: [{ label: t("ALL_USERS"), value: -1 }] },
        ...((_e = (_d = defaultData == null ? void 0 : defaultData.relations) == null ? void 0 : _d.products) == null ? void 0 : _e.length) && {
          products: (_f = defaultData == null ? void 0 : defaultData.relations.products) == null ? void 0 : _f.map(
            (product) => ({
              value: product.id,
              label: product.name
            })
          )
        },
        ...((_h = (_g = defaultData == null ? void 0 : defaultData.relations) == null ? void 0 : _g.excludedProducts) == null ? void 0 : _h.length) && {
          excludedProducts: (_i = defaultData == null ? void 0 : defaultData.relations.excludedProducts) == null ? void 0 : _i.map(
            (product) => ({
              value: product.id,
              label: product.name
            })
          )
        },
        ...((_k = (_j = defaultData == null ? void 0 : defaultData.relations) == null ? void 0 : _j.productCategories) == null ? void 0 : _k.length) && {
          productCategories: (_l = defaultData == null ? void 0 : defaultData.relations.productCategories) == null ? void 0 : _l.map(
            (categories) => ({
              value: categories.id,
              label: categories.name
            })
          )
        }
      } : {
        type: translatedTypes[0],
        scope: translatedScopes[0],
        startDate: new Date(),
        endDate: new Date(),
        accountCompanies: [{ label: t("ALL_USERS"), value: -1 }]
      }
    }
  });
  (0, import_react412.useEffect)(() => {
    reset();
  }, [isOpen, reset]);
  const screenPhone = (0, import_react411.useBreakpointValue)({
    base: true,
    md: false
  });
  const handleSubmitForm = async (formData) => {
    setIsSubmitBtnDisabled(true);
    if (defaultData == null ? void 0 : defaultData.id) {
      editObj(formData);
    } else {
      createObj(formData);
    }
  };
  const mapErrorField = (field) => {
    switch (field) {
      case "discountCodesToProducts":
        return "products";
    }
    return field;
  };
  const createObj = async (data) => {
    var _a3, _b2, _c2, _d2, _e2, _f2, _g2, _h2, _i2, _j2, _k2, _l2, _m, _n, _o;
    const relations = prepareRelations(data, (_a3 = data.scope) == null ? void 0 : _a3.value);
    try {
      const response = await (0, import_api42.createDiscountCode)({
        data: {
          code: data.code,
          name: data.name,
          value: parseFloat(data.value),
          type: (_b2 = data.type) == null ? void 0 : _b2.value,
          scope: (_c2 = data.scope) == null ? void 0 : _c2.value,
          autoAddProducts: (data == null ? void 0 : data.autoAddProducts) || false,
          autoAddDiscountCode: (data == null ? void 0 : data.autoAddDiscountCode) || false,
          startDate: data.startDate,
          endDate: data.endDate,
          usageLimit: parseInt(data.usageLimit),
          ...((_d2 = Object.keys(relations)) == null ? void 0 : _d2.length) && { relations }
        }
      });
      if (response.errors === null) {
        toast({
          title: t("NOTICE_SAVE_SUCCESS"),
          status: "success"
        });
        afterSuccess == null ? void 0 : afterSuccess();
        onClose();
      }
    } catch (error) {
      resolveApiError(error);
      if ((_f2 = (_e2 = error == null ? void 0 : error.response) == null ? void 0 : _e2.data) == null ? void 0 : _f2.errors) {
        setError(
          mapErrorField((_h2 = (_g2 = error.response.data.errors) == null ? void 0 : _g2["item_0"]) == null ? void 0 : _h2[0].field),
          {
            type: "manual",
            message: `DISCOUNT_CODE_${(_j2 = (_i2 = error.response.data.errors) == null ? void 0 : _i2["item_0"]) == null ? void 0 : _j2[0].type}`
          },
          {
            shouldFocus: true
          }
        );
        toast({
          title: `${t("ERROR")}`,
          description: t(
            (_o = (_n = (_m = (_l2 = (_k2 = error.response) == null ? void 0 : _k2.data) == null ? void 0 : _l2.errors) == null ? void 0 : _m["item_0"]) == null ? void 0 : _n[0]) == null ? void 0 : _o.message
          ),
          status: "error"
        });
      }
      setIsSubmitBtnDisabled(false);
    }
  };
  const editObj = async (data) => {
    var _a3, _b2, _c2, _d2, _e2, _f2, _g2, _h2, _i2, _j2;
    const relations = prepareRelations(data, (_a3 = data.scope) == null ? void 0 : _a3.value);
    try {
      const response = await (0, import_api42.updateDiscountCode)(defaultData.id, {
        data: {
          code: data.code,
          name: data.name,
          value: parseFloat(data.value),
          type: (_b2 = data.type) == null ? void 0 : _b2.value,
          scope: (_c2 = data.scope) == null ? void 0 : _c2.value,
          autoAddProducts: data.autoAddProducts,
          autoAddDiscountCode: data.autoAddDiscountCode,
          startDate: data.startDate,
          endDate: data.endDate,
          usageLimit: parseInt(data.usageLimit),
          ...((_d2 = Object.keys(relations)) == null ? void 0 : _d2.length) && { relations }
        }
      });
      if (response.errors === null) {
        toast({
          title: t("NOTICE_SAVE_SUCCESS"),
          status: "success"
        });
        afterSuccess == null ? void 0 : afterSuccess();
        onClose();
      }
    } catch (error) {
      resolveApiError(error);
      if ((_f2 = (_e2 = error == null ? void 0 : error.response) == null ? void 0 : _e2.data) == null ? void 0 : _f2.errors) {
        setError(
          mapErrorField((_h2 = (_g2 = error.response.data.errors) == null ? void 0 : _g2["item_0"]) == null ? void 0 : _h2[0].field),
          {
            type: "manual",
            message: `DISCOUNT_CODE_${(_j2 = (_i2 = error.response.data.errors) == null ? void 0 : _i2["item_0"]) == null ? void 0 : _j2[0].type}`
          },
          {
            shouldFocus: true
          }
        );
      }
      setIsSubmitBtnDisabled(false);
    }
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(AuraModalContent, {
    as: "form",
    onSubmit: handleSubmit(handleSubmitForm),
    className: "discount-code__create-modal",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalHeader, {
        showBorders: false,
        className: "discount-code__create-modal__header",
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react411.Text, {
          isTruncated: true,
          as: screenPhone ? "h5" : "h4",
          textStyle: { base: "h5", md: "h4" },
          children: id ? t("DISCOUNT_CODE") : t("NEW_DISCOUNT_CODE")
        })
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalBody, {
        overflowY: "visible",
        className: "discount-code__create-modal__body",
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(DiscountCodeForm, {
          control,
          register,
          resetField,
          formState,
          setValue,
          getValues,
          defaultData,
          watch,
          isReadOnly,
          isNameDisabled: isReadOnlyProp
        })
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalFooter, {
        className: "discount-code__create-modal__footer",
        showBorders: false,
        children: hasModuleCredential("create") && !isReadOnly && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react411.Button, {
          className: "discount-code__create-modal__footer__button-create",
          isLoading: formState.isSubmitting || isSubmitBtnDisabled,
          type: "submit",
          colorScheme: "blue",
          textTransform: "capitalize",
          children: t("SAVE")
        })
      })
    ]
  });
};
var DiscountCodeForm = ({
  control,
  defaultData,
  formState,
  watch,
  setValue,
  getValues,
  isReadOnly,
  isNameDisabled
}) => {
  var _a2, _b, _c, _d, _e, _f, _g;
  const { language } = (0, import_react412.useContext)(LanguageContext);
  const { hasCredential } = (0, import_lib27.useCredentials)();
  const { t } = useAuraTranslation_default();
  const translatedTypes = (0, import_react412.useMemo)(
    () => DISCOUNT_CODES_TYPES.map((type) => ({
      ...type,
      label: t(type.label)
    })),
    [t]
  );
  const translatedScopes = (0, import_react412.useMemo)(
    () => DISCOUNT_CODES_SCOPES.map((type) => ({
      ...type,
      label: t(type.label)
    })),
    [t]
  );
  const selectedType = watch("type");
  const selectedScope = watch("scope");
  const selectedCategories = watch("productCategories");
  const startDate = watch("startDate");
  const products = watch("products");
  const availableScopes = (0, import_react412.useMemo)(() => {
    if ((selectedType == null ? void 0 : selectedType.value) === 3) {
      return translatedScopes.filter(
        (scope) => scope.value === 2 /* products */
      );
    }
    return translatedScopes;
  }, [selectedType, translatedScopes]);
  (0, import_react412.useEffect)(() => {
    const currentValue = watch("value");
    if ([2, 3].includes(selectedType == null ? void 0 : selectedType.value) && currentValue && auraParseFloat(currentValue) === 0) {
      setValue("value", 0.01);
    }
  }, [selectedType, setValue]);
  (0, import_react412.useEffect)(() => {
    if ((selectedType == null ? void 0 : selectedType.value) === 3 && (selectedScope == null ? void 0 : selectedScope.value) !== 2 /* products */) {
      const productsScope = translatedScopes.find(
        (scope) => scope.value === 2 /* products */
      );
      setValue("scope", productsScope);
    }
  }, [selectedType, selectedScope, translatedScopes, setValue]);
  const showAutoAddDiscountCode = (0, import_react412.useMemo)(
    () => (products == null ? void 0 : products.length) === 1,
    [products]
  );
  const showAutoAddProducts = (0, import_react412.useMemo)(() => (products == null ? void 0 : products.length) > 0, [products]);
  (0, import_react412.useEffect)(() => {
    const scopeId = selectedScope == null ? void 0 : selectedScope.value;
    const productsCount = (products == null ? void 0 : products.length) || 0;
    if (scopeId !== 2 /* products */) {
      if (productsCount > 0) {
        setValue("products", []);
      }
      setValue("autoAddProducts", false);
      setValue("autoAddDiscountCode", false);
      return;
    }
    if (productsCount != 1) {
      setValue("autoAddDiscountCode", false);
      return;
    }
  }, [selectedScope, products]);
  (0, import_react412.useEffect)(() => {
    const endDate = getValues("endDate");
    if (!endDate) {
      return;
    }
    if (new Date(endDate) < new Date(startDate)) {
      setValue("endDate", startDate);
    }
  }, [startDate]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react411.Stack, {
    spacing: 4,
    "data-testid": "create-discount-code-form",
    className: "discount-code__create-modal__form",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react411.Flex, {
        justifyContent: "flex-end",
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react411.Text, {
            textStyle: "bodyInput",
            color: "red.500",
            mr: "16px",
            children: "*"
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react411.Text, {
            textStyle: "bodyInput",
            color: "blackAlpha.500",
            children: t("REQUIRED")
          })
        ]
      }),
      hasCredential("code", "field", "show") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react411.FormControl, {
        isRequired: true,
        isInvalid: (_a2 = formState == null ? void 0 : formState.errors) == null ? void 0 : _a2.code,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react411.FormLabel, {
            htmlFor: "code",
            children: t("DISCOUNT_CODE")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form43.Controller, {
            control,
            name: "code",
            rules: {
              required: true
            },
            render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Code_default, {
              setValue,
              ...field,
              isReadOnly: isNameDisabled
            })
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react411.FormErrorMessage, {
            children: t((_c = (_b = formState == null ? void 0 : formState.errors) == null ? void 0 : _b.code) == null ? void 0 : _c.message)
          })
        ]
      }),
      hasCredential("name", "field", "show") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react411.FormControl, {
        isRequired: true,
        isInvalid: (_d = formState == null ? void 0 : formState.errors) == null ? void 0 : _d.name,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react411.FormLabel, {
            htmlFor: "name",
            children: t("DISCOUNT_NAME")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form43.Controller, {
            control,
            name: "name",
            rules: {
              required: true
            },
            render: ({ field }) => {
              var _a3;
              return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraInput_default, {
                ...field,
                isReadOnly,
                isRequired: false,
                isInvalid: (_a3 = formState == null ? void 0 : formState.errors) == null ? void 0 : _a3.name
              });
            }
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react411.FormErrorMessage, {
            children: t((_f = (_e = formState == null ? void 0 : formState.errors) == null ? void 0 : _e.name) == null ? void 0 : _f.message)
          })
        ]
      }),
      hasCredential("type", "field", "show") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react411.FormControl, {
        isRequired: true,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react411.FormLabel, {
            htmlFor: "type",
            children: t("Type")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form43.Controller, {
            control,
            name: "type",
            render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSelect_default, {
              options: translatedTypes,
              isClearable: false,
              ...field,
              isReadOnly
            })
          })
        ]
      }),
      hasCredential("value", "field", "show") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react411.FormControl, {
        isRequired: true,
        isInvalid: (_g = formState == null ? void 0 : formState.errors) == null ? void 0 : _g.value,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react411.FormLabel, {
            htmlFor: "value",
            children: t("Value")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form43.Controller, {
            control,
            name: "value",
            rules: {
              required: true
            },
            render: ({ field }) => {
              var _a3;
              return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
                children: [
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react411.NumberInput, {
                    className: "discount-code__create-modal__value",
                    precision: 2,
                    min: (selectedType == null ? void 0 : selectedType.value) === 1 ? 0 : 0.01,
                    flex: 1,
                    ...(selectedType == null ? void 0 : selectedType.value) === 1 && { max: 100 },
                    ...field,
                    isReadOnly,
                    isRequired: false,
                    isInvalid: (_a3 = formState == null ? void 0 : formState.errors) == null ? void 0 : _a3.value,
                    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react411.NumberInputField, {
                      _readOnly: {
                        bgColor: "gray.50",
                        borderColor: "gray.100",
                        _focus: { borderColor: "gray.100" },
                        _hover: { cursor: "default" }
                      }
                    })
                  }),
                  (selectedType == null ? void 0 : selectedType.value) === 3 && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react411.FormHelperText, {
                    px: 2,
                    pb: 2,
                    children: t("DISCOUNT_CODE_TAG_VALUE_FIXED_PRICE_DESCRIPTION")
                  })
                ]
              });
            }
          })
        ]
      }),
      hasCredential("scope", "field", "show") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react411.FormControl, {
        isRequired: true,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react411.FormLabel, {
            htmlFor: "discount-code-scope-select-input",
            children: t("DISCOUNT_CODE_SCOPE")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form43.Controller, {
            control,
            name: "scope",
            "data-testid": "discount-code-scope-select",
            render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSelect_default, {
              options: availableScopes,
              isClearable: false,
              ...field,
              inputId: "discount-code-scope-select-input",
              isReadOnly
            })
          })
        ]
      }),
      hasCredential("products", "relation", "show") && (selectedScope == null ? void 0 : selectedScope.value) === 2 && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react411.FormControl, {
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react411.FormLabel, {
                htmlFor: "products",
                children: t("PRODUCTS")
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form43.Controller, {
                control,
                name: "products",
                render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSelect_default, {
                  loadDataProps: {
                    endpoint: "products",
                    labelField: "name",
                    autoselect: false,
                    additionalNameAccessor: "code",
                    settings: {
                      "order[_q]": "DESC",
                      "order[name]": "ASC"
                    }
                  },
                  components: {
                    Option: CustomProductOption_default
                  },
                  closeMenuOnSelect: true,
                  isMulti: true,
                  ...field,
                  isReadOnly
                })
              })
            ]
          }),
          showAutoAddProducts && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react411.FormControl, {
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react411.FormLabel, {
                htmlFor: "auto_add_products",
                title: t(
                  "DISCOUNT_CODES_AUTO_ADD_PRODUCTS_TO_CART_DESCRIPTION"
                ),
                children: t("DISCOUNT_CODES_AUTO_ADD_PRODUCTS_TO_CART")
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form43.Controller, {
                control,
                name: "autoAddProducts",
                defaultValue: false,
                render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AttributeBoolean_default, {
                  ...field,
                  isReadOnly
                })
              })
            ]
          }),
          showAutoAddDiscountCode && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react411.FormControl, {
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react411.FormLabel, {
                htmlFor: "auto_add_discount_code",
                title: t(
                  "DISCOUNT_CODES_AUTO_APPLY_DISCOUNT_CODE_DESCRIPTION"
                ),
                children: t("DISCOUNT_CODES_AUTO_APPLY_DISCOUNT_CODE")
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form43.Controller, {
                control,
                name: "autoAddDiscountCode",
                defaultValue: false,
                render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AttributeBoolean_default, {
                  ...field,
                  isReadOnly
                })
              })
            ]
          })
        ]
      }),
      hasCredential("productCategories", "relation", "show") && (selectedScope == null ? void 0 : selectedScope.value) === 3 && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react411.FormControl, {
        isRequired: true,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react411.FormLabel, {
            htmlFor: "productCategories",
            children: t("LIST_COLUMN_productCategories")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form43.Controller, {
            control,
            name: "productCategories",
            rules: {
              required: true
            },
            render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSelect_default, {
              loadDataProps: {
                endpoint: "product_categories",
                autoselect: false,
                labelField: "name",
                queryField: "translations",
                settings: {
                  "order[name]": "ASC",
                  extra_fields: "translations"
                }
              },
              components: {
                Option: CustomProductOption_default
              },
              closeMenuOnSelect: true,
              isMulti: true,
              ...field,
              isReadOnly
            })
          })
        ]
      }),
      hasCredential("excludedProducts", "relation", "show") && [1, 3].includes(selectedScope == null ? void 0 : selectedScope.value) && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react411.FormControl, {
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react411.FormLabel, {
            htmlFor: "excludedProducts",
            children: t("EXCLUDED_PRODUCTS")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form43.Controller, {
            control,
            name: "excludedProducts",
            render: ({ field }) => {
              var _a3;
              return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSelect_default, {
                loadDataProps: {
                  endpoint: "products",
                  labelField: "name",
                  autoselect: false,
                  additionalNameAccessor: "code",
                  settings: {
                    "order[name]": "ASC",
                    ...(selectedCategories == null ? void 0 : selectedCategories.length) && {
                      "filter[categories][in]": (_a3 = selectedCategories == null ? void 0 : selectedCategories.map((category) => category.value)) == null ? void 0 : _a3.join(","),
                      extra_fields: "categories",
                      "setting[with_relations]": "true"
                    }
                  }
                },
                components: {
                  Option: CustomProductOption_default
                },
                closeMenuOnSelect: true,
                isMulti: true,
                ...field,
                isReadOnly
              });
            }
          })
        ]
      }),
      hasCredential("startDate", "field", "show") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react411.FormControl, {
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react411.FormLabel, {
            htmlFor: "startDate",
            children: t("START_DATE")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form43.Controller, {
            control,
            name: "startDate",
            render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(DateInput_default, {
              id: "start-date",
              className: "discount-code__create-modal__start-date",
              lang: language,
              isClearable: false,
              ...field,
              isDisabled: isReadOnly
            })
          })
        ]
      }),
      hasCredential("endDate", "field", "show") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react411.FormControl, {
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react411.FormLabel, {
            htmlFor: "endDate",
            children: t("END_DATE")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form43.Controller, {
            control,
            name: "endDate",
            render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(DateInput_default, {
              id: "end-date",
              className: "discount-code__create-modal__end-date",
              lang: language,
              isClearable: false,
              ...field,
              isDisabled: isReadOnly,
              minDate: startDate && new Date(startDate)
            })
          })
        ]
      }),
      hasCredential("accountCompanies", "relation", "show") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react411.FormControl, {
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react411.FormLabel, {
            htmlFor: "accountCompanies",
            children: t("COMPANIES")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form43.Controller, {
            control,
            name: "accountCompanies",
            render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSelect_default, {
              optionAllEnabled: true,
              loadDataProps: {
                endpoint: "account_companies",
                labelField: "name",
                settings: {
                  "order[_q]": "DESC",
                  "order[name]": "ASC"
                }
              },
              closeMenuOnSelect: true,
              isMulti: true,
              ...field,
              isReadOnly
            })
          })
        ]
      }),
      hasCredential("usageLimit", "field", "show") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react411.FormControl, {
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react411.FormLabel, {
            htmlFor: "usageLimit",
            children: t("USAGE_LIMIT")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form43.Controller, {
            control,
            name: "usageLimit",
            render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react411.NumberInput, {
              className: "discount-code__create-modal__usage-limit",
              precision: 0,
              min: 0,
              flex: 1,
              ...field,
              value: field.value ?? "",
              isReadOnly,
              children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react411.NumberInputField, {
                _readOnly: {
                  bgColor: "gray.50",
                  borderColor: "gray.100",
                  _focus: { borderColor: "gray.100" },
                  _hover: { cursor: "default" }
                }
              })
            })
          })
        ]
      })
    ]
  });
};
var ModalDiscountCode_default = withCredentials12(ModalDiscountCode);

// src/components/ModalHoliday/ModalHoliday.tsx
var import_react413 = require("@chakra-ui/react");
var import_react414 = require("react");
var import_react_hook_form44 = require("react-hook-form");
var import_api43 = require("@questy/api");
var import_lib28 = require("@questy/lib");
var import_jsx_runtime = require("react/jsx-runtime");
var withCredentials13 = (Component) => {
  return ({ ...props }) => {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_lib28.CredentialContextProvider, {
      module: "holidays",
      initialModuleParams: {},
      ...props.initialCredentials && {
        initialCredentials: props.initialCredentials
      },
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Component, {
        ...props
      })
    });
  };
};
var ModalHoliday = ({
  isOpen,
  onClose,
  afterSuccess
}) => {
  const { t } = useAuraTranslation_default();
  const { hasModuleCredential } = (0, import_lib28.useCredentials)();
  const { control, formState, handleSubmit, reset } = (0, import_react_hook_form44.useForm)();
  (0, import_react414.useEffect)(() => {
    reset();
  }, [isOpen, reset]);
  const handleCreateHoliday = async (data) => {
    try {
      const response = await (0, import_api43.createHoliday)({
        data: {
          holiday: data.holiday
        }
      });
      if (response.errors === null) {
        afterSuccess == null ? void 0 : afterSuccess();
        onClose();
      }
    } catch (error) {
    }
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(AuraModal, {
    size: "lg",
    isOpen,
    onClose,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalOverlay, {}),
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(AuraModalContent, {
        as: "form",
        onSubmit: handleSubmit(handleCreateHoliday),
        className: "holiday__create-modal",
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalHeader, {
            className: "holiday__create-modal__header",
            children: t("NEW_HOLIDAY")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalBody, {
            overflowY: "visible",
            className: "holiday__create-modal__body",
            children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(HolidayCreateForm, {
              control
            })
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalFooter, {
            className: "holiday__create-modal__footer",
            showBorders: false,
            children: hasModuleCredential("create") && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react413.Button, {
              className: "holiday__create-modal__footer-button",
              textTransform: "capitalize",
              isLoading: formState.isSubmitting,
              type: "submit",
              colorScheme: "blue",
              children: t("SAVE")
            })
          })
        ]
      })
    ]
  });
};
var HolidayCreateForm = ({ control }) => {
  const { t } = useAuraTranslation_default();
  const { language } = (0, import_react414.useContext)(LanguageContext);
  const { hasCredential } = (0, import_lib28.useCredentials)();
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react413.Stack, {
    spacing: 4,
    "data-testid": "create-holiday-form",
    className: "holiday__create-modal__form",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react413.Flex, {
        justifyContent: "flex-end",
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react413.Text, {
            textStyle: "bodyInput",
            color: "red.500",
            mr: "16px",
            children: "*"
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react413.Text, {
            textStyle: "bodyInput",
            color: "blackAlpha.500",
            children: t("REQUIRED")
          })
        ]
      }),
      hasCredential("holiday", "field", "edit") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react413.FormControl, {
        isRequired: true,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react413.FormLabel, {
            htmlFor: "holiday-date-from",
            children: t("Date")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form44.Controller, {
            control,
            name: "holiday",
            rules: {
              required: true
            },
            render: ({ field: { ref, ...field } }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(DateInput_default, {
              id: "holiday-date-from",
              className: "holiday__create-modal__date-from",
              lang: language,
              isClearable: false,
              ...field
            })
          })
        ]
      })
    ]
  });
};
var ModalHoliday_default = withCredentials13(ModalHoliday);

// src/components/ModalMessageThread/ModalMessageThread.tsx
var import_react431 = require("@chakra-ui/react");
var import_api46 = require("@questy/api");
var import_lib29 = require("@questy/lib");
var import_react432 = require("react");
var import_react_query57 = require("react-query");

// src/components/ModalMessageThread/context.tsx
var import_react415 = require("react");
var import_jsx_runtime = require("react/jsx-runtime");
var ModalMessageThreadContext = (0, import_react415.createContext)(void 0);
var ModalMessageThreadProvider = ({
  value,
  children
}) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ModalMessageThreadContext.Provider, {
    value,
    children
  });
};
var useModalThreadContext = () => {
  const context = (0, import_react415.useContext)(ModalMessageThreadContext);
  if (!context) {
    throw new Error("useUser must be used within a ModalMessageThreadProvider");
  }
  return context;
};

// src/components/ModalMessageThread/hooks/useDefaultThreadRecipients.ts
var import_api44 = require("@questy/api");
var import_react416 = require("react");
var import_react_query56 = require("react-query");
var useDefaultThreadRecipients = ({
  recipients,
  setRecipientsValue,
  isOpen
}) => {
  var _a2, _b;
  const { data: userUsers, isLoading: isLoadingUserUsers } = (0, import_react_query56.useQuery)(
    ["default", "userUsers", "forNewThread", recipients == null ? void 0 : recipients.userUsers],
    () => (0, import_api44.getUsers)({
      fields: ["id"],
      extraFields: ["fullName"],
      rawParams: {
        "filter[id][in]": recipients == null ? void 0 : recipients.userUsers
      }
    }),
    {
      enabled: !!((_a2 = recipients == null ? void 0 : recipients.userUsers) == null ? void 0 : _a2.length),
      keepPreviousData: true,
      select: (res) => res == null ? void 0 : res.data
    }
  );
  const { data: accountUsers, isLoading: isLoadingAccountUsers } = (0, import_react_query56.useQuery)(
    ["default", "accountUsers", "forNewThread", recipients == null ? void 0 : recipients.accountUsers],
    () => (0, import_api44.getAccountUsers)({
      fields: ["id"],
      extraFields: ["fullName"],
      rawParams: {
        "filter[id][in]": recipients == null ? void 0 : recipients.accountUsers
      }
    }),
    {
      enabled: !!((_b = recipients == null ? void 0 : recipients.accountUsers) == null ? void 0 : _b.length),
      keepPreviousData: true,
      select: (res) => res == null ? void 0 : res.data
    }
  );
  (0, import_react416.useEffect)(() => {
    if ((!isLoadingAccountUsers || !isLoadingAccountUsers) && isOpen) {
      const preparedAccountUsers = prepareUsersData(
        accountUsers,
        1 /* accountUser */
      );
      const preparedUserUsers = prepareUsersData(userUsers, 2 /* userUser */);
      setRecipientsValue([...preparedAccountUsers, ...preparedUserUsers]);
    }
  }, [
    accountUsers,
    userUsers,
    isOpen,
    isLoadingAccountUsers,
    isLoadingUserUsers
  ]);
  return null;
};
var prepareUsersData = (data, userType) => (data == null ? void 0 : data.map((user) => ({
  label: user == null ? void 0 : user.fullName,
  value: user == null ? void 0 : user.id,
  userType
}))) ?? [];
var useDefaultThreadRecipients_default = useDefaultThreadRecipients;

// src/components/ModalMessageThread/ThreadFooter/ThreadFooter.tsx
var import_react417 = require("@chakra-ui/react");
var import_js59 = require("@mdi/js");
var import_react418 = __toESM(require("@mdi/react"));
var import_filesize4 = __toESM(require("filesize"));
var import_react419 = require("react");
var import_jsx_runtime = require("react/jsx-runtime");
var ThreadFooter = ({ isVisible }) => {
  const [isScrollVisible, setIsScrollVisible] = (0, import_react419.useState)(false);
  const {
    isSending,
    onSendMessage,
    users,
    setDynamicFooterHeight,
    tempContentValue,
    setTempContentValue,
    tempFilesValue,
    setTempFilesValue
  } = useModalThreadContext();
  const isSm = (0, import_react417.useBreakpointValue)({
    base: true,
    md: false
  });
  const refTextArea = (0, import_react419.useRef)(null);
  const handleScrollVisible = (currentHeight) => {
    if (currentHeight >= 140) {
      setIsScrollVisible(true);
    } else {
      setIsScrollVisible(false);
    }
  };
  const handleInput = (e) => {
    var _a2;
    setTempContentValue((_a2 = e == null ? void 0 : e.target) == null ? void 0 : _a2.value);
    const el2 = refTextArea.current;
    if (el2) {
      el2.style.height = "auto";
      const newHeight = Math.min(el2.scrollHeight, isSm ? 140 : 189);
      el2.style.height = `${newHeight}px`;
      handleScrollVisible(newHeight);
    }
  };
  const { mutate: handleAddFiles, isLoading: isAddingFiles } = useFileUpload({
    allFileDetails: true,
    handleFileConnect: (newFiles) => setTempFilesValue((prevVal) => [...prevVal, ...newFiles ?? []])
  });
  const handleRemoveFile = (id) => {
    setTempFilesValue(
      (prevVal) => prevVal == null ? void 0 : prevVal.filter((file) => (file == null ? void 0 : file.id) !== id)
    );
  };
  const handleSendMessage = async () => {
    await onSendMessage();
    const el2 = refTextArea.current;
    if (el2) {
      el2.style.height = `40px`;
    }
  };
  (0, import_react419.useEffect)(() => {
    if (!isVisible)
      return;
    const footerDiv = document.getElementById("modal-thread-footer");
    if (!footerDiv) {
      return;
    }
    const observer = new ResizeObserver((mutations) => {
      mutations.forEach((mutation) => {
        var _a2;
        setDynamicFooterHeight((_a2 = mutation == null ? void 0 : mutation.target) == null ? void 0 : _a2.clientHeight);
      });
    });
    observer.observe(footerDiv);
    return () => observer.disconnect();
  }, [isVisible]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react417.ModalFooter, {
    className: "modal-message-thread__footer",
    id: "modal-thread-footer",
    pb: "24px",
    px: "24px",
    pt: "12px",
    w: "full",
    bgColor: "#fff",
    minH: "76px",
    display: isVisible ? "flex" : "none",
    flexWrap: "wrap",
    overflow: "hidden",
    borderRadius: "md",
    zIndex: 1,
    boxShadow: "lgTop",
    sx: isSm ? {
      position: "fixed",
      bottom: 0
    } : {},
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react417.HStack, {
        justifyContent: "space-between",
        w: "full",
        spacing: 4,
        alignItems: "flex-end",
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AddFilesButton, {
            onChange: handleAddFiles,
            isDisabled: isSending,
            isLoading: isAddingFiles
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react417.Textarea, {
            ref: refTextArea,
            id: "new-message-input",
            "aria-label": "message input",
            value: tempContentValue,
            onChange: handleInput,
            rows: 1,
            lineHeight: "24px",
            height: "40px",
            letterSpacing: "0.5px",
            isDisabled: isSending,
            className: "modal-message-thread__footer__content",
            ...isScrollVisible ? {} : { resize: "none", overflow: "hidden" },
            ...baseInputStyle
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react417.IconButton, {
            icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react418.default, {
              path: import_js59.mdiSend,
              size: "24px"
            }),
            "aria-label": "send message",
            variant: "solid",
            colorScheme: "blue",
            onClick: handleSendMessage,
            isDisabled: !(tempContentValue == null ? void 0 : tempContentValue.length) || !(users == null ? void 0 : users.length),
            isLoading: isSending,
            className: "modal-message-thread__footer__send"
          })
        ]
      }),
      !!(tempFilesValue == null ? void 0 : tempFilesValue.length) && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react417.Box, {
        w: "full",
        mt: 4,
        px: {
          base: "0",
          md: "56px"
        },
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(MessageTempAttachments, {
          files: tempFilesValue,
          handleRemoveFile
        })
      })
    ]
  });
};
var AddFilesButton = ({
  onChange,
  isDisabled,
  isLoading
}) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react417.IconButton, {
        icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react418.default, {
          path: import_js59.mdiFilePlusOutline,
          size: "24px"
        }),
        "aria-label": "attach files",
        as: import_react417.FormLabel,
        htmlFor: "files-input",
        m: 0,
        disabled: isDisabled,
        isLoading,
        className: "modal-message-thread__footer__add-file",
        _hover: {
          cursor: "pointer",
          bgColor: "gray.200"
        }
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react417.Input, {
        id: "files-input",
        type: "file",
        hidden: true,
        onChange,
        multiple: true
      })
    ]
  });
};
var MessageTempAttachments = ({
  files,
  handleRemoveFile
}) => {
  const isSm = (0, import_react417.useBreakpointValue)({
    base: true,
    md: false
  });
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react417.VStack, {
    className: "modal-message-thread__footer__attachments",
    w: "full",
    py: 3,
    maxH: "296px",
    overflowX: "auto",
    children: files == null ? void 0 : files.map((file) => /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react417.HStack, {
      maxW: "full",
      w: "full",
      spacing: 3,
      children: [
        !isSm && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react417.Box, {
          color: "gray.300",
          boxSize: "48px",
          ...isImage(file.mimeType) && { cursor: "pointer" },
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FilePreview, {
            file,
            files
          })
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react417.HStack, {
          w: "full",
          justifyContent: "space-between",
          spacing: 4,
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react417.VStack, {
              spacing: 0,
              w: "full",
              overflow: "hidden",
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react417.Text, {
                  textAlign: "left",
                  isTruncated: true,
                  lineHeight: "24px",
                  letterSpacing: "0.5px",
                  color: "crmBlue",
                  whiteSpace: "normal",
                  w: "full",
                  noOfLines: 1,
                  children: file == null ? void 0 : file.fileName
                }),
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react417.Text, {
                  fontSize: "sm",
                  color: "gray.500",
                  w: "full",
                  lineHeight: "24px",
                  children: (0, import_filesize4.default)(file == null ? void 0 : file.fileSize)
                })
              ]
            }),
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react417.IconButton, {
              "aria-label": "remove file",
              icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react418.default, {
                size: "24px",
                path: import_js59.mdiTrashCanOutline
              }),
              color: "gray.700",
              mb: 0,
              onClick: () => handleRemoveFile(file == null ? void 0 : file.id)
            })
          ]
        })
      ]
    }))
  });
};
var ThreadFooter_default = ThreadFooter;

// src/components/ModalMessageThread/ThreadHeader/ThreadHeader.tsx
var import_react422 = require("@chakra-ui/react");
var import_js60 = require("@mdi/js");
var import_react423 = __toESM(require("@mdi/react"));
var import_react424 = require("react");

// src/components/ModalMessageThread/ThreadHeader/RecipientsSelector/RecipientsSelector.tsx
var import_debounce13 = __toESM(require("lodash/debounce"));
var import_react420 = require("react");
var import_react421 = require("@chakra-ui/react");
var import_orderBy6 = __toESM(require("lodash/orderBy"));
var import_api45 = require("@questy/api");
var import_jsx_runtime = require("react/jsx-runtime");
var loadOptions3 = (0, import_debounce13.default)(
  async (inputValue, isUserUser, currentUsersIds, setOptions, signal, setIsLoading, t, selfUserId) => {
    var _a2, _b, _c, _d, _e;
    if (!(inputValue == null ? void 0 : inputValue.length)) {
      return new Promise.reject();
    }
    const resUserUsers = await fetchData("user_users", {
      params: {
        "filter[fullName][hasText]": inputValue,
        ...((_a2 = currentUsersIds == null ? void 0 : currentUsersIds.userUsersIds) == null ? void 0 : _a2.length) ? {
          "filter[id][notIn]": currentUsersIds.userUsersIds
        } : {},
        fields: "id",
        extra_fields: "fullName",
        "page[limit]": 10
      },
      signal
    });
    const resAccountUsers = await fetchData("account_users", {
      params: {
        "filter[fullName][hasText]": inputValue,
        ...((_b = currentUsersIds == null ? void 0 : currentUsersIds.userUsersIds) == null ? void 0 : _b.length) ? {
          "filter[id][notIn]": currentUsersIds.accountUsersIds
        } : {},
        fields: "id,company.id",
        extra_fields: "fullName,company.displayName",
        "setting[with_relations]": true,
        "page[limit]": 10
      },
      signal
    });
    const receiverGroups = isUserUser ? await (0, import_api45.getReceiverGroups)({
      settings: { withRelations: true },
      fields: ["id", "name"],
      extraFields: ["matchingUsers"],
      filters: {
        userType: { eq: 1 /* userUser */ },
        isActive: { eq: true },
        name: { hasText: inputValue }
      }
    }) : [];
    const userUsersOptions = ((_c = buildOptions((resUserUsers == null ? void 0 : resUserUsers.data) ?? [], "fullName", "id")) == null ? void 0 : _c.map(
      (opt) => ({
        ...opt,
        userType: 2 /* userUser */
      })
    )) ?? [];
    const accountUsersOptions = ((_d = resAccountUsers == null ? void 0 : resAccountUsers.data) == null ? void 0 : _d.map((user) => {
      var _a3;
      return {
        label: user == null ? void 0 : user.fullName,
        additionalLabel: (_a3 = user == null ? void 0 : user.company) == null ? void 0 : _a3.displayName,
        value: user == null ? void 0 : user.id,
        userType: 1 /* accountUser */
      };
    })) ?? [];
    const receiverGroupsOptions = ((_e = receiverGroups == null ? void 0 : receiverGroups.data) == null ? void 0 : _e.map((group) => {
      var _a3, _b2;
      return {
        value: group == null ? void 0 : group.id,
        label: group == null ? void 0 : group.name,
        matchingUsers: (_b2 = (_a3 = group == null ? void 0 : group.matchingUsers) == null ? void 0 : _a3.filter(
          (user) => (user == null ? void 0 : user.isDeleted) !== true && (user == null ? void 0 : user.id) !== selfUserId
        )) == null ? void 0 : _b2.map((user) => ({
          value: user == null ? void 0 : user.id,
          label: user == null ? void 0 : user.fullName,
          userType: (user == null ? void 0 : user.type) === "userUser" ? 2 /* userUser */ : 1 /* accountUser */
        }))
      };
    }).filter((group) => {
      var _a3;
      return ((_a3 = group.matchingUsers) == null ? void 0 : _a3.length) > 0;
    })) ?? [];
    const groupedOptions = [
      {
        label: t("GROUPS"),
        options: receiverGroupsOptions
      },
      {
        label: t("USER_USERS"),
        options: userUsersOptions
      },
      {
        label: t("ACCOUNT_USERS"),
        options: accountUsersOptions
      }
    ];
    setOptions(groupedOptions);
    setIsLoading(false);
  },
  500,
  {
    leading: false
  }
);
var RecipientsSelector = () => {
  const [inputValue, setInputValue] = (0, import_react420.useState)("");
  const [options, setOptions] = (0, import_react420.useState)([]);
  const [isLoading, setIsLoading] = (0, import_react420.useState)(false);
  const { isUserUser } = (0, import_react420.useContext)(AuthContext);
  const { t } = useAuraTranslation_default();
  const { isNewThread, users, onChangeUsers, selfUserId } = useModalThreadContext();
  const value = (0, import_react420.useMemo)(() => {
    var _a2;
    if (isNewThread) {
      return users;
    } else {
      let selfUserParsedData;
      const value2 = ((_a2 = users == null ? void 0 : users.map((userData) => {
        var _a3, _b, _c;
        const userTypeKey = getUserThreadNameKey(userData == null ? void 0 : userData.userType);
        return {
          value: userData == null ? void 0 : userData.id,
          label: (_a3 = userData == null ? void 0 : userData[userTypeKey]) == null ? void 0 : _a3.fullName,
          type: userData == null ? void 0 : userData.userType,
          userId: (_b = userData == null ? void 0 : userData[userTypeKey]) == null ? void 0 : _b.id,
          isDeleted: (_c = userData == null ? void 0 : userData[userTypeKey]) == null ? void 0 : _c.isDeleted
        };
      })) == null ? void 0 : _a2.filter((parsedUser) => {
        const isSelfUser = (parsedUser == null ? void 0 : parsedUser.userId) === selfUserId;
        if (isSelfUser) {
          selfUserParsedData = parsedUser;
        }
        return !isSelfUser;
      })) ?? [];
      let sortedValue = (0, import_orderBy6.default)(value2, "label", "asc") ?? [];
      if (selfUserParsedData) {
        sortedValue == null ? void 0 : sortedValue.unshift(selfUserParsedData);
      }
      return sortedValue;
    }
  }, [users, isNewThread, selfUserId]);
  const currentUsersIds = (value == null ? void 0 : value.reduce(
    (allUsers, userOpt) => {
      if ((userOpt == null ? void 0 : userOpt.type) === 2 /* userUser */) {
        allUsers.userUsersIds.push(userOpt.userId);
      } else if ((userOpt == null ? void 0 : userOpt.type) === 1 /* accountUser */) {
        allUsers.accountUsersIds.push(userOpt.userId);
      }
      return allUsers;
    },
    { userUsersIds: [selfUserId], accountUsersIds: [selfUserId] }
  )) ?? { userUsersIds: [], accountUsersIds: [] };
  const handleOnChange = async (newValue, actionMeta) => {
    var _a2, _b, _c;
    if (actionMeta.action === "select-option" && ((_a2 = actionMeta.option) == null ? void 0 : _a2.matchingUsers)) {
      const filteredUsers = (_c = (_b = actionMeta.option) == null ? void 0 : _b.matchingUsers) == null ? void 0 : _c.filter(
        (user) => {
          return !users.some((u) => u.value === user.value);
        }
      );
      filteredUsers == null ? void 0 : filteredUsers.forEach((user) => {
        onChangeUsers(user, "add", isNewThread);
      });
      return;
    }
    if (actionMeta.action === "select-option") {
      onChangeUsers(actionMeta.option, "add", isNewThread);
    }
    if (["deselect-option", "remove-value"].includes(actionMeta.action)) {
      onChangeUsers(actionMeta.removedValue, "remove", isNewThread);
    }
  };
  (0, import_react420.useEffect)(() => {
    const controller = new AbortController();
    const signal = controller.signal;
    (async () => {
      if (inputValue == null ? void 0 : inputValue.length) {
        setIsLoading(true);
        loadOptions3(
          inputValue,
          isUserUser,
          currentUsersIds,
          setOptions,
          signal,
          setIsLoading,
          t,
          selfUserId
        );
      } else {
        setIsLoading(false);
      }
    })();
    return () => {
      controller.abort();
    };
  }, [inputValue]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSelect_default, {
    "aria-label": "message recipients",
    value,
    isMulti: true,
    isClearable: false,
    onChange: handleOnChange,
    onInputChange: (val) => setInputValue(val),
    options: !!(inputValue == null ? void 0 : inputValue.length) ? options : [],
    isLoading,
    components: {
      MultiValueRemove: (props) => MultiValueRemove(props, true)
    },
    noOptionsMessage: (elem) => (elem == null ? void 0 : elem.inputValue) === "" ? t("BEGIN_WRITING_TO_SEARCH") : t("NOTHING_FOUND")
  });
};
var MultiValueRemove = (props, allowToRemove) => {
  if (!allowToRemove) {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react421.Box, {
      ml: "3px"
    });
  }
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CustomMultiValueRemove, {
    ...props
  });
};
var RecipientsSelector_default = RecipientsSelector;

// src/components/ModalMessageThread/ThreadHeader/ThreadHeader.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var ThreadHeader = ({ onOpen, handleHideModal }) => {
  const { t } = useAuraTranslation_default();
  const settings = useSettings_default();
  const {
    isNewThread,
    thread,
    users,
    toggleNotifications,
    toggleHasBeenRead,
    selfUserId,
    isModalReady
  } = useModalThreadContext();
  const lastMessageAuthorId = getLastMessageUserId(thread);
  const canMarkAsUnread = idExists(lastMessageAuthorId) && lastMessageAuthorId !== selfUserId;
  const usersCount = users == null ? void 0 : users.length;
  const {
    isOpen: isOpenRecipients,
    onToggle: onToggleRecipients,
    onClose: onCloseRecipients
  } = (0, import_react422.useDisclosure)({ defaultIsOpen: isNewThread });
  const isSm = (0, import_react422.useBreakpointValue)({
    base: true,
    md: false
  });
  const openRelation = () => openThreadRelation({
    relations: thread == null ? void 0 : thread.relations,
    settings,
    handleHideModal,
    onOpen
  });
  const toggleNotificationsLabel = (0, import_react424.useMemo)(
    () => (thread == null ? void 0 : thread.notificationsEnabled) ? t("MESSAGE_THREAD_TURN_OFF_NOTIFICATIONS") : t("MESSAGE_THREAD_TURN_ON_NOTIFICATIONS"),
    [thread]
  );
  const menuItems = [
    {
      label: toggleNotificationsLabel,
      onClick: toggleNotifications
    },
    ...canMarkAsUnread ? [
      {
        label: t("MESSAGE_THREAD_MARK_AS_UNDREAD"),
        onClick: toggleHasBeenRead
      }
    ] : [],
    ,
  ];
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react422.ModalHeader, {
    alignItems: "center",
    display: "flex",
    flexWrap: "wrap",
    letterSpacing: "0.15px",
    id: "modal-thread-header",
    className: "modal-message-thread__header",
    py: 3,
    borderBottom: "1px solid",
    borderColor: isOpenRecipients ? "transparent" : "gray.200",
    position: "relative",
    bgColor: "#fff",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react422.HStack, {
        justifyContent: "space-between",
        w: "full",
        h: "40px",
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react422.HStack, {
            spacing: "20px",
            className: "modal-message-thread__header__title",
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react422.Text, {
                isTruncated: true,
                as: isSm ? "h5" : "h4",
                textStyle: { base: "h5", md: "h4" },
                children: isNewThread ? t("NEW_MESSAGE") : t("MESSAGE_THREAD_PREVIEW")
              }),
              isModalReady && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react422.HStack, {
                className: "modal-message-thread__header__toolbox",
                children: [
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react422.Tooltip, {
                    label: t("MESSAGE_THREAD_RECIPIENTS"),
                    openDelay: 500,
                    children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react422.Center, {
                      position: "relative",
                      children: [
                        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react422.IconButton, {
                          "aria-label": "message users",
                          icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react423.default, {
                            path: import_js60.mdiAccountMultipleOutline,
                            size: "24px"
                          }),
                          variant: "ghost",
                          onClick: onToggleRecipients,
                          bgColor: isOpenRecipients ? "gray.200" : "transparent",
                          _hover: {
                            bgColor: isOpenRecipients ? "gray.200" : "gray.100"
                          }
                        }),
                        !!usersCount && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CountBadge_default, {
                          value: usersCount,
                          position: "absolute",
                          left: "-3px",
                          top: "-3px",
                          "data-testid": "users-count",
                          "aria-label": "message users counter"
                        })
                      ]
                    })
                  }),
                  isSm && !isNewThread ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraDropdownMenu_default, {
                    menuItems,
                    onOpen: onCloseRecipients,
                    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react422.MenuButton, {
                      as: MoreIconButton_default,
                      variant: "ghost"
                    })
                  }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, {
                    children: isNewThread === false ? /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
                      children: [
                        hasAnyRelations(thread == null ? void 0 : thread.relations) && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react422.Tooltip, {
                          label: t("CONNECTED_DOCUMENTS"),
                          openDelay: 500,
                          children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react422.IconButton, {
                            "aria-label": "message connected documents",
                            icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react423.default, {
                              path: import_js60.mdiOpenInNew,
                              size: "24px"
                            }),
                            variant: "ghost",
                            onClick: openRelation
                          })
                        }),
                        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react422.Tooltip, {
                          label: toggleNotificationsLabel,
                          openDelay: 500,
                          children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react422.IconButton, {
                            "aria-label": (thread == null ? void 0 : thread.notificationsEnabled) ? "message notifications enabled" : "message notifications disabled",
                            icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react423.default, {
                              path: (thread == null ? void 0 : thread.notificationsEnabled) ? import_js60.mdiBellOutline : import_js60.mdiBellOffOutline,
                              size: "24px"
                            }),
                            variant: "ghost",
                            onClick: toggleNotifications
                          })
                        }),
                        canMarkAsUnread && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react422.Tooltip, {
                          label: t("MESSAGE_THREAD_MARK_AS_UNDREAD"),
                          openDelay: 500,
                          children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react422.IconButton, {
                            "aria-label": "message readed status",
                            icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react423.default, {
                              path: (thread == null ? void 0 : thread.hasBeenRead) ? import_js60.mdiEyeOutline : import_js60.mdiEyeOffOutline,
                              size: "24px"
                            }),
                            variant: "ghost",
                            onClick: toggleHasBeenRead
                          })
                        })
                      ]
                    }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, {})
                  })
                ]
              })
            ]
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalCloseButton, {
            color: "gray.700",
            size: "lg",
            fontSize: "13px"
          })
        ]
      }),
      isOpenRecipients && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react422.Box, {
        w: "full",
        pt: "4px",
        pb: 3,
        px: 6,
        textStyle: "bodyInput",
        className: "modal-message-thread__header__recipients",
        position: "absolute",
        top: "100%",
        left: "0",
        zIndex: 1401,
        bgColor: "#fff",
        borderBottom: "1px solid",
        borderColor: "gray.100",
        boxShadow: "0 1px 5px 0 rgba(22, 22, 22, 0.10), 0 1px 2px 0 rgba(22, 22, 22, 0.06);",
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(RecipientsSelector_default, {})
      })
    ]
  });
};
var ThreadHeader_default = ThreadHeader;

// src/components/ModalMessageThread/ThreadList/ThreadList.tsx
var import_react428 = require("@chakra-ui/react");
var import_react429 = require("react");

// src/components/ModalMessageThread/ThreadList/ThreadMessage/ThreadMessage.tsx
var import_react426 = require("@chakra-ui/react");
var import_react427 = require("react");

// src/components/ModalMessageThread/ThreadList/ViewedSummary/ViewedSummary.tsx
var import_react425 = require("@chakra-ui/react");
var import_jsx_runtime = require("react/jsx-runtime");
var ViewedSummary = ({
  message,
  isLastMessageInGroup
}) => {
  var _a2, _b, _c, _d;
  const { users, selfUserId, messages } = useModalThreadContext();
  const isRefersToLastMessageInThread = ((_a2 = messages == null ? void 0 : messages.at(-1)) == null ? void 0 : _a2.id) === (message == null ? void 0 : message.id);
  const isVisibleAdditionalPb = !isLastMessageInGroup || !isRefersToLastMessageInThread;
  const usersWhoViewedMessage = users == null ? void 0 : users.filter((userData) => {
    var _a3, _b2, _c2, _d2;
    const userTypeKey = getUserThreadNameKey(userData == null ? void 0 : userData.userType);
    const isUserAuthorLastMessage = ((_a3 = message == null ? void 0 : message.senderUser) == null ? void 0 : _a3.id) === ((_b2 = userData == null ? void 0 : userData[userTypeKey]) == null ? void 0 : _b2.id);
    return ((_c2 = userData == null ? void 0 : userData.lastReadMessage) == null ? void 0 : _c2.id) === (message == null ? void 0 : message.id) && ((_d2 = userData == null ? void 0 : userData[userTypeKey]) == null ? void 0 : _d2.id) !== selfUserId && !isUserAuthorLastMessage;
  });
  const totalCount = usersWhoViewedMessage == null ? void 0 : usersWhoViewedMessage.length;
  const preparedUsersDataForAvatars = (_b = usersWhoViewedMessage == null ? void 0 : usersWhoViewedMessage.map((userData) => {
    const userTypeKey = getUserThreadNameKey(userData == null ? void 0 : userData.userType);
    const user = userData == null ? void 0 : userData[userTypeKey];
    return {
      src: getImageUrl(user == null ? void 0 : user.avatar, "thmb"),
      name: user == null ? void 0 : user.fullName,
      bgColor: (user == null ? void 0 : user.defaultCallendarColor) ?? "gray.200"
    };
  })) == null ? void 0 : _b.slice(0, 9);
  const restOfViewedUsers = (_d = (_c = usersWhoViewedMessage == null ? void 0 : usersWhoViewedMessage.slice(10)) == null ? void 0 : _c.map((userData) => {
    var _a3;
    const userTypeKey = getUserThreadNameKey(userData == null ? void 0 : userData.userType);
    return (_a3 = userData == null ? void 0 : userData[userTypeKey]) == null ? void 0 : _a3.fullName;
  })) == null ? void 0 : _d.join(", ");
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react425.HStack, {
    spacing: "6px",
    w: "full",
    justifyContent: "flex-end",
    display: !!totalCount ? "flex" : "none",
    pb: isVisibleAdditionalPb ? "12px" : "0px",
    className: "modal-message-thread__body__list-messages__activity__viewed-summary-wrapper__users",
    children: [
      totalCount > 10 && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react425.Tooltip, {
        label: restOfViewedUsers,
        openDelay: 500,
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react425.Circle, {
          size: "24px",
          bgColor: "gray.200",
          color: "gray.700",
          id: "hidden-viewed-users-count",
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react425.Text, {
            fontSize: "9.5px",
            fontWeight: 500,
            lineHeight: "24px",
            letterSpacing: "0.4px",
            color: "gray.700",
            children: [
              "+",
              totalCount - 9
            ]
          })
        })
      }),
      preparedUsersDataForAvatars == null ? void 0 : preparedUsersDataForAvatars.map((params) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react425.Tooltip, {
        openDelay: 500,
        label: params == null ? void 0 : params.name,
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react425.Avatar, {
          ...params,
          size: "xs"
        })
      }))
    ]
  });
};
var ViewedSummary_default = ViewedSummary;

// src/components/ModalMessageThread/ThreadList/ThreadMessage/ThreadMessage.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var ThreadMessage = ({
  messages,
  sender,
  setLastReadMessageRef
}) => {
  const { selfUserId } = useModalThreadContext();
  const isSelfUserAuthor = selfUserId === (sender == null ? void 0 : sender.id);
  const messageMargin = (0, import_react426.useBreakpointValue)({
    base: "32px",
    md: "40px"
  });
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react426.VStack, {
    className: "modal-message-thread__body__list-messages__activity",
    w: "full",
    align: isSelfUserAuthor ? "flex-end" : "flex-start",
    pl: isSelfUserAuthor ? messageMargin : 0,
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(RenderThreadItemContent, {
      sender,
      messages,
      isSelfUserAuthor,
      setLastReadMessageRef
    })
  });
};
var RenderThreadItemContent = ({
  sender,
  messages,
  isSelfUserAuthor,
  setLastReadMessageRef
}) => {
  const [isAnchorReady, setIsAnchorReady] = (0, import_react427.useState)(false);
  const { t } = useAuraTranslation_default();
  const { lastReadMessageId } = useModalThreadContext();
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, {
    children: messages == null ? void 0 : messages.map((message, index) => {
      const props = getMessageProps(message, sender, t);
      if (index > 0) {
        delete props["users"];
        delete props["username"];
        delete props["createdDate"];
        props.showAvatar = false;
      }
      const isLastMessageInGroup = (messages == null ? void 0 : messages.length) === index + 1;
      const isSystemMessage = message == null ? void 0 : message.isSystemMessage;
      if (isSystemMessage) {
        return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(SystemMessage, {
          ...props,
          isLastMessageInGroup
        });
      }
      return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react427.Fragment, {
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react426.Box, {
            id: `thread-message-${message == null ? void 0 : message.id}`,
            ref: (el2) => {
              if ((message == null ? void 0 : message.id) === lastReadMessageId && !isAnchorReady) {
                setLastReadMessageRef(el2);
                setIsAnchorReady(true);
              }
            },
            w: props.width,
            pr: {
              base: isSelfUserAuthor ? "0" : "32px",
              lg: isSelfUserAuthor ? "0" : "40px"
            },
            pl: {
              base: 0,
              lg: isSelfUserAuthor ? "0" : (props == null ? void 0 : props.showAvatar) ? "8px" : "52px"
            },
            className: "modal-message-thread__body__list-messages__activity__message",
            children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(MessageItem_default, {
              ...props,
              ...isSelfUserAuthor ? {
                showAvatar: false,
                sx: {
                  ".message-item__content": {
                    bgColor: "gray.100"
                  }
                }
              } : {
                sx: {
                  ".message-item__content": {
                    bgColor: "#fff"
                  }
                }
              }
            })
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react426.Box, {
            w: "full",
            className: "modal-message-thread__body__list-messages__activity__viewed-summary-wrapper",
            children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ViewedSummary_default, {
              message,
              isLastMessageInGroup
            })
          })
        ]
      }, `thread-message-${message == null ? void 0 : message.id}`);
    })
  });
};
var getMessageProps = (message, sender, t) => {
  var _a2;
  return {
    variant: "messageThread",
    userDefaultCallendarColor: (sender == null ? void 0 : sender.defaultCallendarColor) ?? "gray.200",
    disableContentLimit: true,
    content: message == null ? void 0 : message.content,
    createdDate: new Date(message == null ? void 0 : message.dateSent),
    width: ((_a2 = message == null ? void 0 : message.files) == null ? void 0 : _a2.length) ? "full" : "fit-content",
    files: message == null ? void 0 : message.files,
    showAvatar: true,
    ...(message == null ? void 0 : message.isSystemMessage) ? {
      users: t("MESSAGE_THREAD_SYSTEM_MESSAGE")
    } : {
      avatarUrl: getImageUrl(sender == null ? void 0 : sender.avatar, "thmb"),
      users: message == null ? void 0 : message.senderName,
      username: message == null ? void 0 : message.senderName
    }
  };
};
var SystemMessage = ({ isLastMessageInGroup, ...props }) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(MessageItem_default, {
    ...props,
    className: "modal-message-thread__body__list-messages__activity__system",
    sx: {
      ".message-item__avatar-container": {
        display: "none"
      },
      ".message-item__text": {
        fontWeight: 600,
        fontSize: "13px"
      },
      ".message-item__content": {
        boxShadow: "none",
        ...isLastMessageInGroup ? {} : { pb: "0" }
      }
    }
  });
};
var ThreadMessage_default = ThreadMessage;

// src/components/ModalMessageThread/ThreadList/ThreadList.tsx
var import_groupBy = __toESM(require("lodash/groupBy"));
var import_date_fns16 = require("date-fns");
var import_react_intersection_observer = require("react-intersection-observer");
var import_react430 = require("react");
var import_jsx_runtime = require("react/jsx-runtime");
var ThreadList2 = ({ ...props }) => {
  const {
    messages,
    lastReadMessageId,
    shouldScrollToLastReadMessage,
    selfUserTypeName,
    isModalReady
  } = useModalThreadContext();
  const grouped = (0, import_react429.useMemo)(
    () => createGroupedByDayAndUser(messages, selfUserTypeName),
    [messages]
  );
  const endAnchor = (0, import_react429.useRef)(null);
  const lastReadMessageAnchor = (0, import_react429.useRef)(null);
  const containerRef = (0, import_react429.useRef)(null);
  const [rootEl, setRootEl] = (0, import_react430.useState)(null);
  const { ref: bottomRef, inView: isAtBottom } = (0, import_react_intersection_observer.useInView)({
    root: rootEl,
    threshold: 1,
    triggerOnce: true
  });
  const { ref: lastReadMessageRef, inView: isAtLastReadMessage } = (0, import_react_intersection_observer.useInView)({
    root: rootEl,
    threshold: 1,
    triggerOnce: true
  });
  const setLastReadMessageRef = (el2) => {
    if (!lastReadMessageAnchor.current) {
      lastReadMessageRef(el2);
      lastReadMessageAnchor.current = el2;
    }
  };
  (0, import_react429.useEffect)(() => {
    if (typeof shouldScrollToLastReadMessage !== "boolean" && !isModalReady) {
      return;
    }
    if (shouldScrollToLastReadMessage && lastReadMessageId && (lastReadMessageAnchor == null ? void 0 : lastReadMessageAnchor.current)) {
      lastReadMessageAnchor.current.scrollIntoView({ behavior: "auto" });
    } else if ((endAnchor == null ? void 0 : endAnchor.current) && (!shouldScrollToLastReadMessage || !idExists(lastReadMessageId))) {
      endAnchor.current.scrollIntoView({ behavior: "auto" });
    }
  }, [
    grouped,
    lastReadMessageId,
    shouldScrollToLastReadMessage,
    lastReadMessageAnchor,
    endAnchor,
    isModalReady
  ]);
  (0, import_react429.useEffect)(() => {
    if (containerRef == null ? void 0 : containerRef.current) {
      setRootEl(containerRef.current);
    }
  }, [containerRef]);
  (0, import_react429.useEffect)(() => {
    if (isAtBottom && containerRef.current && shouldScrollToLastReadMessage) {
      containerRef.current.style.opacity = "1";
    } else if (isAtLastReadMessage) {
      containerRef.current.style.opacity = "1";
    }
  }, [isAtBottom, isAtLastReadMessage, isModalReady, lastReadMessageId]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react428.VStack, {
    ...props,
    spacing: 4,
    ref: containerRef,
    justifyContent: "flex-end",
    opacity: 0,
    className: "modal-message-thread__body__list-messages",
    position: "relative",
    children: [
      grouped.map((day) => /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react429.Fragment, {
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react428.Text, {
            className: "date-separator",
            children: day.date
          }),
          day.groups.map((group) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ThreadMessage_default, {
            messages: group.messages,
            sender: group.sender,
            setLastReadMessageRef
          }, group.messages[0].id))
        ]
      }, day.date)),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react428.Box, {
        id: "end-anchor-list-messages",
        ref: (el2) => {
          bottomRef(el2);
          endAnchor.current = el2;
        },
        visibility: "hidden",
        h: "1px",
        position: "absolute",
        bottom: "0",
        left: "0"
      })
    ]
  });
};
var createGroupedByDayAndUser = (messages, selfUserTypeName) => {
  const groupedByDay = createGroupByDay(messages);
  return groupedByDay.map(({ date, messages: messages2 }) => ({
    date,
    groups: combineMessagesSameUser(messages2, selfUserTypeName)
  }));
};
var createGroupByDay = (data) => {
  const grouped = (0, import_groupBy.default)(
    data,
    (message) => (0, import_date_fns16.format)(new Date(message == null ? void 0 : message.dateSent), DATE_FORMAT_DOTS)
  );
  return Object.entries(grouped).map(([date, messages]) => {
    const parsed = (0, import_date_fns16.parse)(date, DATE_FORMAT_DOTS, new Date());
    return {
      date: (0, import_date_fns16.isThisYear)(parsed) ? (0, import_date_fns16.format)(parsed, DATE_DAY_MONTH_FORMAT) : (0, import_date_fns16.format)(parsed, DATE_FORMAT_DOTS),
      messages
    };
  });
};
var combineMessagesSameUser = (messages, selfUserTypeName, thresholdMinutes = 5) => {
  var _a2, _b;
  if (!(messages == null ? void 0 : messages.length))
    return [];
  const combined = [];
  for (let i = 0; i < messages.length; i++) {
    const current = messages[i];
    const previousGroup = combined[combined.length - 1];
    if (previousGroup) {
      const lastMessageInGroup = previousGroup.messages[previousGroup.messages.length - 1];
      const sameUser = ((_a2 = previousGroup == null ? void 0 : previousGroup.sender) == null ? void 0 : _a2.id) === ((_b = current == null ? void 0 : current[selfUserTypeName]) == null ? void 0 : _b.id);
      const minutesDiff = (0, import_date_fns16.differenceInMinutes)(
        new Date(current.dateSent),
        new Date(lastMessageInGroup.dateSent)
      );
      const withinThreshold = minutesDiff <= thresholdMinutes;
      if (sameUser && withinThreshold) {
        previousGroup.messages.push(current);
        continue;
      }
    }
    combined.push({
      sender: current == null ? void 0 : current[selfUserTypeName],
      messages: [current]
    });
  }
  return combined;
};
var ThreadList_default2 = ThreadList2;

// src/components/ModalMessageThread/ModalMessageThread.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var withCredentials14 = (Component) => {
  return ({ ...props }) => {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_lib29.CredentialContextProvider, {
      module: "message_threads",
      initialModuleParams: {},
      ...props.initialCredentials && {
        initialCredentials: props.initialCredentials
      },
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Component, {
        ...props
      })
    });
  };
};
var ModalMessageThread = ({
  id: threadId,
  newMessageThreadRelations,
  newMessageThreadRecipients,
  onMessageSent: manualCallbackOnMessageSent,
  isOpen,
  onClose,
  onOpen,
  refetch
}) => {
  const [id, setId] = (0, import_react432.useState)();
  const keepModalDataAfterClose = (0, import_react432.useRef)();
  const [modalLoadStatus, setModalLoadStatus] = (0, import_react432.useState)({});
  const { hasModuleCredential } = (0, import_lib29.useCredentials)();
  const { t } = useAuraTranslation_default();
  const isFooterVisible = hasModuleCredential("create");
  const { user } = (0, import_react432.useContext)(AuthContext);
  const selfUserId = user == null ? void 0 : user.id;
  const selfUserTypeName = getSenderUserTypeName(user);
  const [selfUserIdInMessageThread, setSelfUserIdInMessageThread] = (0, import_react432.useState)();
  const [dynamicFooterHeight, setDynamicFooterHeight] = (0, import_react432.useState)(
    !isFooterVisible ? 0 : 76
  );
  const [threadData, setThreadData] = (0, import_react432.useState)();
  const [messagesData, setMessagesData] = (0, import_react432.useState)();
  const [usersData, setUsersData] = (0, import_react432.useState)();
  const [lastReadMessageId, setLastReadMessageId] = (0, import_react432.useState)();
  const [shouldScrollToLastReadMessage, setShouldScrollToLastReadMessage] = (0, import_react432.useState)(void 0);
  const [tempUsersValue, setTempUsersValue] = (0, import_react432.useState)([]);
  const [tempContentValue, setTempContentValue] = (0, import_react432.useState)();
  const [tempFilesValue, setTempFilesValue] = (0, import_react432.useState)([]);
  useDefaultThreadRecipients_default({
    recipients: newMessageThreadRecipients,
    setRecipientsValue: setTempUsersValue,
    isOpen
  });
  const [isDirty, setIsDirty] = (0, import_react432.useState)(false);
  const isCreateNewThread = (0, import_react432.useMemo)(
    () => !idExists(threadId) && !idExists(id),
    [threadId, id]
  );
  (0, import_react432.useLayoutEffect)(() => {
    if (isCreateNewThread && isOpen)
      setModalLoadStatus({
        thread: true,
        threadUsers: true,
        messages: true
      });
  }, [isCreateNewThread, isOpen]);
  const { refetch: refetchThread } = (0, import_react_query57.useQuery)(
    ["messageThread", id],
    () => (0, import_api46.getMessageThread)(id, {
      settings: {
        withRelations: true
      },
      extraFields: ["hasBeenRead", "notificationsEnabled", "relations"]
    }),
    {
      enabled: idExists(id) && isOpen,
      refetchOnWindowFocus: true,
      cacheTime: 0,
      keepPreviousData: true,
      select: (res) => res == null ? void 0 : res.data,
      onSuccess: (data) => onSuccessLoadThread(data)
    }
  );
  const onSuccessLoadThread = (data) => {
    setThreadData(data);
    if (data == null ? void 0 : data.hasBeenRead) {
      setShouldScrollToLastReadMessage(false);
    } else {
      setShouldScrollToLastReadMessage(true);
      updateThread({
        hasBeenRead: true
      });
    }
    setModalLoadStatus((prev) => ({ ...prev, thread: true }));
  };
  const { mutate: updateThread, isLoading: isLoadingUpdateThread } = (0, import_react_query57.useMutation)(
    (data) => (0, import_api46.updateMessageThread)(id, {
      data,
      extraFields: ["hasBeenRead", "notificationsEnabled", "relations"],
      settings: {
        withRelations: true
      }
    }),
    {
      onSuccess: (data) => {
        setThreadData(data == null ? void 0 : data.data);
        refetch();
      }
    }
  );
  const { refetch: refetchThreadUsers } = (0, import_react_query57.useQuery)(
    ["messageThread", id, "users"],
    () => api_default.getEndpoint(`message_threads/${id}/message_thread_users`, {
      params: {
        fields: "id,userUser,accountUser,lastReadMessage.id,userType",
        extra_fields: "userUser.fullName,accountUser.fullName",
        "setting[with_deleted]": true,
        "setting[with_relations]": true,
        "page[limit]": -1
      }
    }),
    {
      enabled: idExists(id) && isOpen,
      refetchOnWindowFocus: true,
      cacheTime: 0,
      keepPreviousData: true,
      select: (res) => res == null ? void 0 : res.data,
      onSuccess: (data) => {
        setUsersData(data);
        setModalLoadStatus((prev) => ({ ...prev, threadUsers: true }));
      }
    }
  );
  const { mutate: updateThreadUsers } = (0, import_react_query57.useMutation)(
    (data) => {
      const selectedUserId = data == null ? void 0 : data.idMessageThreadUser;
      if (idExists(selectedUserId)) {
        return (0, import_api46.deleteMessageThreadUser)(selectedUserId);
      }
      return api_default.postEndpoint(
        `/message_threads/${id}/message_thread_users`,
        {
          data
        }
      );
    },
    {
      onSuccess: async (data, variables) => onSuccessUpdateThreadUsers(variables == null ? void 0 : variables.idMessageThreadUser)
    }
  );
  const onSuccessUpdateThreadUsers = async (deletedUseridInMessageThread) => {
    if (deletedUseridInMessageThread === selfUserIdInMessageThread) {
      handleOnClose({ forceClose: true });
      refetch();
    } else {
      await refetchThreadUsers();
      await refetchThread();
      await refetchMessages();
    }
  };
  const { refetch: refetchMessages } = (0, import_react_query57.useQuery)(
    ["messages", "forThreadId", id],
    () => api_default.getEndpoint(`message_threads/${id}/messages`, {
      params: {
        extra_fields: "files",
        "setting[with_relations]": true,
        "page[limit]": -1
      }
    }),
    {
      enabled: idExists(id) && isOpen,
      refetchOnWindowFocus: true,
      cacheTime: 0,
      keepPreviousData: true,
      select: (res) => res == null ? void 0 : res.data,
      onSuccess: (data) => {
        setMessagesData(data);
        setModalLoadStatus((prev) => ({ ...prev, messages: true }));
      }
    }
  );
  const {
    mutateAsync: sendMessage,
    isLoading: isLoadingSendMessage,
    isSuccess: isSuccessSendMessage
  } = (0, import_react_query57.useMutation)(
    async () => {
      const endpoint = isCreateNewThread ? "/messages" : `/message_threads/${id}/messages`;
      let preparedData = {
        [selfUserTypeName]: user.id,
        isSystemMessage: false,
        content: tempContentValue
      };
      if (isCreateNewThread && (tempUsersValue == null ? void 0 : tempUsersValue.length)) {
        preparedData.users = getUsersDataForAddToThread(tempUsersValue);
      }
      if (tempFilesValue == null ? void 0 : tempFilesValue.length) {
        preparedData.files = tempFilesValue == null ? void 0 : tempFilesValue.map((file) => file == null ? void 0 : file.id);
      }
      return api_default.postEndpoint(endpoint, {
        data: preparedData
      });
    },
    {
      onSuccess: async (response) => await onSuccessSendMessage(response == null ? void 0 : response.data)
    }
  );
  const onSuccessSendMessage = async (data) => {
    var _a2, _b;
    if (isCreateNewThread) {
      const newThreadId = (_b = (_a2 = data == null ? void 0 : data[0]) == null ? void 0 : _a2.thread) == null ? void 0 : _b.id;
      setId(newThreadId);
      if (newMessageThreadRelations) {
        await updateThread({
          relations: newMessageThreadRelations
        });
      }
      resetDirtyState();
    } else {
      resetDirtyState();
      await refetchMessages();
      refetch();
    }
    manualCallbackOnMessageSent == null ? void 0 : manualCallbackOnMessageSent();
  };
  const selfMessageThreadUserQuery = (0, import_react_query57.useQuery)(
    ["messageThreadUser", selfUserIdInMessageThread, "forMessageThread", id],
    () => (0, import_api46.getMessageThreadUser)(selfUserIdInMessageThread, {
      fields: ["lastReadMessage"],
      settings: {
        withRelations: true
      }
    }),
    {
      enabled: idExists(selfUserIdInMessageThread) && isOpen,
      refetchOnWindowFocus: true,
      cacheTime: 0,
      keepPreviousData: true,
      select: (res) => res == null ? void 0 : res.data,
      onSuccess: (data) => {
        var _a2;
        const value = (_a2 = data == null ? void 0 : data.lastReadMessage) == null ? void 0 : _a2.id;
        if (idExists(value)) {
          setLastReadMessageId(value);
        }
      }
    }
  );
  const handleToggleHasBeenRead = async () => {
    if (isLoadingUpdateThread)
      return;
    handleOnClose({ markAsUnread: true });
  };
  const handleToggleNotification = async () => {
    if (isLoadingUpdateThread)
      return;
    await updateThread({
      notificationsEnabled: !(threadData == null ? void 0 : threadData.notificationsEnabled)
    });
  };
  const handleOnChangeUsers = async (value, mode, actionForNewThread) => {
    var _a2;
    if (actionForNewThread) {
      setIsDirty(true);
      return setTempUsers(value, mode);
    }
    if (mode === "remove" && !actionForNewThread) {
      return updateThreadUsers({
        idMessageThreadUser: value == null ? void 0 : value.value
      });
    }
    const lastReadMessageIdForNewUser = (_a2 = messagesData == null ? void 0 : messagesData.at(-2)) == null ? void 0 : _a2.id;
    const preparedData = getUsersDataForAddToThread(
      value,
      lastReadMessageIdForNewUser
    );
    await updateThreadUsers(preparedData);
  };
  const setTempUsers = (value, mode) => {
    if (mode === "remove") {
      return setTempUsersValue(
        (prev) => prev.filter((user2) => user2.value !== value.value)
      );
    }
    return setTempUsersValue((prev) => [...prev, value]);
  };
  const handleOnClose = async ({
    forceClose,
    markAsUnread
  }) => {
    if (keepModalDataAfterClose.current) {
      return onClose();
    }
    if (isDirty && !forceClose) {
      onClose();
      const shouldClose = await confirmWrapper({
        confirmation: t("MESSAGE_THREAD_CLOSE_CONFIRMATION_ASK"),
        header: t("CLOSE"),
        okButton: t("CLOSE"),
        cancelButton: t("CANCEL")
      });
      if (!shouldClose) {
        return onOpen();
      }
    }
    if (markAsUnread) {
      await updateThread({
        hasBeenRead: false
      });
    }
    onClose();
    setMessagesData([]);
    setThreadData(void 0);
    setUsersData([]);
    setTempUsersValue([]);
    setId(void 0);
    setLastReadMessageId(void 0);
    setSelfUserIdInMessageThread(void 0);
    setShouldScrollToLastReadMessage(void 0);
    resetDirtyState();
    setModalLoadStatus(void 0);
  };
  const handleHideModal = () => {
    keepModalDataAfterClose.current = true;
    onClose();
  };
  const resetDirtyState = () => {
    setTempContentValue("");
    setTempFilesValue([]);
    setIsDirty(false);
  };
  const isModalReady = (0, import_react432.useMemo)(
    () => (modalLoadStatus == null ? void 0 : modalLoadStatus.thread) && (modalLoadStatus == null ? void 0 : modalLoadStatus.threadUsers) && (modalLoadStatus == null ? void 0 : modalLoadStatus.messages),
    [modalLoadStatus]
  );
  (0, import_react432.useEffect)(() => {
    if (idExists(threadId)) {
      setId(threadId);
    }
  }, [threadId]);
  (0, import_react432.useEffect)(() => {
    var _a2;
    if (idExists(selfUserId) && !!((_a2 = threadData == null ? void 0 : threadData.users) == null ? void 0 : _a2.length)) {
      const value = getSelfMessageThreadUserId(threadData == null ? void 0 : threadData.users, selfUserId);
      setSelfUserIdInMessageThread(value);
    }
  }, [threadData == null ? void 0 : threadData.users, selfUserId]);
  (0, import_react432.useEffect)(() => {
    if ((tempContentValue == null ? void 0 : tempContentValue.length) || (tempFilesValue == null ? void 0 : tempFilesValue.length)) {
      setIsDirty(true);
    }
  }, [tempContentValue, tempFilesValue]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ModalMessageThreadProvider, {
    value: {
      isNewThread: isCreateNewThread,
      thread: threadData,
      messages: messagesData,
      lastReadMessageId,
      users: isCreateNewThread ? tempUsersValue : usersData,
      toggleNotifications: handleToggleNotification,
      toggleHasBeenRead: handleToggleHasBeenRead,
      onChangeUsers: handleOnChangeUsers,
      onSendMessage: sendMessage,
      isSending: isLoadingSendMessage,
      isSuccessSend: isSuccessSendMessage,
      selfUserTypeName,
      selfUserId,
      setDynamicFooterHeight,
      tempContentValue,
      setTempContentValue,
      tempFilesValue,
      setTempFilesValue,
      shouldScrollToLastReadMessage,
      setShouldScrollToLastReadMessage,
      isModalReady
    },
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(AuraModal, {
      isOpen,
      onClose: () => {
        handleOnClose({});
        keepModalDataAfterClose.current = false;
      },
      autoFocus: false,
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalOverlay, {}),
        /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(AuraModalContent, {
          className: "modal-message-thread",
          maxWidth: "832px",
          w: "full",
          bgColor: "gray.50",
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ThreadHeader_default, {
              onOpen,
              handleHideModal
            }),
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalBody, {
              className: "modal-message-thread__body",
              id: "modal-message-thread-body",
              maxH: {
                base: `calc(100dvh - ${dynamicFooterHeight}px - 65px)`,
                md: "625px"
              },
              overflowY: "auto",
              borderBottomRadius: isFooterVisible && isModalReady ? 0 : "md",
              children: isModalReady ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ThreadList_default2, {
                minH: {
                  base: `calc(100dvh - ${dynamicFooterHeight}px - 65px - 32px)`,
                  md: `calc(625px - ${dynamicFooterHeight}px - 65px)`
                }
              }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react431.Center, {
                minH: {
                  base: `calc(100svh - ${dynamicFooterHeight}px - 65px - 32px)`,
                  md: `calc(625px - ${dynamicFooterHeight}px - 65px)`
                },
                children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSpinner_default, {})
              })
            }),
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ThreadFooter_default, {
              isVisible: isModalReady && isFooterVisible
            })
          ]
        })
      ]
    })
  });
};
var ModalMessageThread_default = withCredentials14(ModalMessageThread);

// src/components/ModalPriceIndividual/ModalPriceIndividual.tsx
var import_react433 = require("@chakra-ui/react");
var import_api47 = require("@questy/api");
var import_lib30 = require("@questy/lib");
var import_date_fns17 = require("date-fns");
var import_react434 = require("react");
var import_react_hook_form45 = require("react-hook-form");
var import_react_query58 = require("react-query");
var import_jsx_runtime = require("react/jsx-runtime");
var withCredentials15 = (Component) => {
  return ({ ...props }) => {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_lib30.CredentialContextProvider, {
      module: "price_individuals",
      initialModuleParams: {},
      ...props.initialCredentials && {
        initialCredentials: props.initialCredentials
      },
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Component, {
        ...props
      })
    });
  };
};
var ModalPriceIndividual = ({
  id,
  isOpen,
  onClose,
  afterSuccess,
  companyId,
  isReadOnly
}) => {
  const { data, isLoading, isFetching } = (0, import_react_query58.useQuery)(
    ["price_individual", id],
    () => (0, import_api47.getPriceIndividual)(id, {
      extraFields: ["company.displayName"],
      settings: {
        withRelations: true
      }
    }),
    {
      enabled: idExists(id) && isOpen,
      refetchOnWindowFocus: false,
      cacheTime: 0,
      select: (res) => res == null ? void 0 : res.data
    }
  );
  const { data: accountCompany, isLoading: isLoadingAccountCompany } = (0, import_react_query58.useQuery)(
    ["account_companies", companyId],
    () => (0, import_api47.getAccountCompany)(companyId, {
      fields: ["id"],
      extraFields: ["displayName"]
    }),
    {
      enabled: !idExists(id) && isOpen && idExists(companyId),
      refetchOnWindowFocus: false,
      select: (res) => res == null ? void 0 : res.data
    }
  );
  const defaultDataCreateForCompany = (0, import_react434.useMemo)(
    () => ({
      company: accountCompany
    }),
    [accountCompany]
  );
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(AuraModal, {
    size: "lg",
    isOpen,
    onClose,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalOverlay, {}),
      isLoading || isFetching || isLoadingAccountCompany ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSpinner_default, {}) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ModalPriceIndividualContent, {
        isOpen,
        defaultData: data ?? defaultDataCreateForCompany,
        onClose,
        afterSuccess,
        isReadOnly
      })
    ]
  });
};
var ModalPriceIndividualContent = ({
  isOpen,
  defaultData,
  onClose,
  afterSuccess,
  isReadOnly: isReadOnlyProp
}) => {
  var _a2, _b, _c, _d, _e, _f;
  const { t } = useAuraTranslation_default();
  const { resolveApiError } = useAuraErrorResolver_default();
  const { user } = (0, import_react434.useContext)(AuthContext);
  const toast = (0, import_react433.useToast)();
  const id = defaultData == null ? void 0 : defaultData.id;
  const isEditing = idExists(id);
  const isCurrencyCodeEditable = (_b = (_a2 = useSettings_default()) == null ? void 0 : _a2.settings) == null ? void 0 : _b.discountCurrency;
  const defaultUserCurrency = {
    value: user == null ? void 0 : user.currency,
    label: user == null ? void 0 : user.currency
  };
  (0, import_react434.useEffect)(() => {
    if (defaultUserCurrency && !isEditing) {
      setValue("currencyCode", defaultUserCurrency);
    }
  }, [defaultUserCurrency, isEditing]);
  const isReadOnly = isReadOnlyProp || (defaultData == null ? void 0 : defaultData.startDate) && ((0, import_date_fns17.isPast)(new Date(defaultData == null ? void 0 : defaultData.startDate)) || (0, import_date_fns17.isToday)(new Date(defaultData == null ? void 0 : defaultData.startDate)));
  const [isSubmitBtnDisabled, setIsSubmitBtnDisabled] = (0, import_react434.useState)(false);
  const { hasModuleCredential } = (0, import_lib30.useCredentials)();
  const {
    register,
    control,
    formState,
    handleSubmit,
    reset,
    resetField,
    setError,
    setValue,
    getValues,
    watch
  } = (0, import_react_hook_form45.useForm)({
    defaultValues: {
      ...defaultData ? {
        ...defaultData,
        ...(defaultData == null ? void 0 : defaultData.company) && {
          company: {
            value: (_c = defaultData == null ? void 0 : defaultData.company) == null ? void 0 : _c.id,
            label: (_d = defaultData == null ? void 0 : defaultData.company) == null ? void 0 : _d.displayName
          }
        },
        ...(defaultData == null ? void 0 : defaultData.currencyCode) && {
          currencyCode: {
            value: defaultData == null ? void 0 : defaultData.currencyCode,
            label: defaultData == null ? void 0 : defaultData.currencyCode
          }
        },
        ...(defaultData == null ? void 0 : defaultData.product) && {
          product: {
            value: (_e = defaultData == null ? void 0 : defaultData.product) == null ? void 0 : _e.id,
            label: (_f = defaultData == null ? void 0 : defaultData.product) == null ? void 0 : _f.name
          }
        }
      } : {}
    }
  });
  (0, import_react434.useEffect)(() => {
    reset();
  }, [isOpen, reset]);
  const screenPhone = (0, import_react433.useBreakpointValue)({
    base: true,
    md: false
  });
  const handleSubmitForm = async (formData) => {
    setIsSubmitBtnDisabled(true);
    if (isEditing) {
      editObj(formData);
    } else {
      createObj(formData);
    }
  };
  const createObj = async (data) => {
    var _a3, _b2, _c2, _d2, _e2, _f2, _g, _h;
    try {
      const response = await (0, import_api47.createPriceIndividual)({
        data: {
          name: data.name,
          company: data.company.value,
          product: data.product.value,
          priceNetto: auraParseFloat(data.priceNetto),
          ...isCurrencyCodeEditable && ((_a3 = data.currencyCode) == null ? void 0 : _a3.value) ? { currencyCode: (_b2 = data.currencyCode) == null ? void 0 : _b2.value } : {}
        }
      });
      if (response.errors === null) {
        toast({
          title: t("NOTICE_SAVE_SUCCESS"),
          status: "success"
        });
        afterSuccess == null ? void 0 : afterSuccess();
        onClose();
      }
    } catch (error) {
      resolveApiError(error);
      if ((_d2 = (_c2 = error == null ? void 0 : error.response) == null ? void 0 : _c2.data) == null ? void 0 : _d2.errors) {
        setError(
          (_f2 = (_e2 = error.response.data.errors) == null ? void 0 : _e2["item_0"]) == null ? void 0 : _f2[0].field,
          {
            type: "manual",
            message: `PRICE_INDIVIDUAL_${(_h = (_g = error.response.data.errors) == null ? void 0 : _g["item_0"]) == null ? void 0 : _h[0].type}`
          },
          {
            shouldFocus: true
          }
        );
        setIsSubmitBtnDisabled(false);
      }
    }
  };
  const editObj = async (data) => {
    var _a3, _b2;
    try {
      const response = await (0, import_api47.updatePriceIndividual)(defaultData.id, {
        data: {
          name: data.name,
          company: data.company.value,
          product: data.product.value,
          priceNetto: auraParseFloat(data.priceNetto),
          ...isCurrencyCodeEditable && ((_a3 = data == null ? void 0 : data.currencyCode) == null ? void 0 : _a3.value) ? { currencyCode: (_b2 = data.currencyCode) == null ? void 0 : _b2.value } : {}
        }
      });
      if (response.errors === null) {
        toast({
          title: t("NOTICE_SAVE_SUCCESS"),
          status: "success"
        });
        afterSuccess == null ? void 0 : afterSuccess();
        onClose();
      }
    } catch (error) {
      resolveApiError(error);
      setIsSubmitBtnDisabled(false);
    }
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(AuraModalContent, {
    as: "form",
    onSubmit: handleSubmit(handleSubmitForm),
    className: "price-individual__create-modal",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalHeader, {
        showBorders: false,
        className: "price-individual__create-modal__header",
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react433.Text, {
          isTruncated: true,
          as: screenPhone ? "h5" : "h4",
          textStyle: { base: "h5", md: "h4" },
          children: isEditing ? t("PRICE_INDIVIDUAL") : t("NEW_PRICE_INDIVIDUAL")
        })
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalBody, {
        overflowY: "visible",
        className: "price-individual__create-modal__body",
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(PriceIndividualForm, {
          control,
          register,
          resetField,
          formState,
          setValue,
          getValues,
          defaultData,
          watch,
          isReadOnly,
          isNameDisabled: isReadOnlyProp
        })
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalFooter, {
        className: "price-individual__create-modal__footer",
        showBorders: false,
        children: hasModuleCredential("create") && !isReadOnly && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react433.Button, {
          className: "price-individual__create-modal__footer__button-create",
          isLoading: formState.isSubmitting || isSubmitBtnDisabled,
          type: "submit",
          colorScheme: "blue",
          textTransform: "capitalize",
          children: t("SAVE")
        })
      })
    ]
  });
};
var PriceIndividualForm = ({
  control,
  isReadOnly,
  formState,
  isNameDisabled
}) => {
  var _a2, _b, _c, _d, _e, _f, _g, _h, _i, _j;
  const { hasCredential } = (0, import_lib30.useCredentials)();
  const { t } = useAuraTranslation_default();
  const { user } = (0, import_react434.useContext)(AuthContext);
  const availableCurrencies = (_a2 = user == null ? void 0 : user.availableCurrencies) == null ? void 0 : _a2.map(
    (code) => ({ value: code, label: code })
  );
  const isCurrencyCodeEditable = (_c = (_b = useSettings_default()) == null ? void 0 : _b.settings) == null ? void 0 : _c.discountCurrency;
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react433.Stack, {
    spacing: 4,
    "data-testid": "create-price-individual-form",
    className: "price-individual__create-modal__form",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react433.Flex, {
        justifyContent: "flex-end",
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react433.Text, {
            textStyle: "bodyInput",
            color: "red.500",
            mr: "16px",
            children: "*"
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react433.Text, {
            textStyle: "bodyInput",
            color: "blackAlpha.500",
            children: t("REQUIRED")
          })
        ]
      }),
      hasCredential("name", "field", "show") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react433.FormControl, {
        isInvalid: !!((_d = formState == null ? void 0 : formState.errors) == null ? void 0 : _d.name),
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react433.FormLabel, {
            htmlFor: "name",
            children: t("NAME")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form45.Controller, {
            control,
            name: "name",
            render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraInput_default, {
              isReadOnly: isNameDisabled,
              ...field
            })
          })
        ]
      }),
      hasCredential("product", "field", "show") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react433.FormControl, {
        isRequired: true,
        isInvalid: !!((_e = formState == null ? void 0 : formState.errors) == null ? void 0 : _e.product),
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react433.FormLabel, {
            htmlFor: "price-individual-product",
            children: t("PRODUCT")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form45.Controller, {
            control,
            name: "product",
            rules: {
              required: true
            },
            render: ({ field }) => {
              var _a3;
              return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSelect_default, {
                loadDataProps: {
                  endpoint: "products",
                  labelField: "name",
                  autoselect: false,
                  additionalNameAccessor: "code",
                  settings: {
                    "order[_q]": "DESC",
                    "order[name]": "ASC"
                  }
                },
                components: {
                  Option: CustomProductOption_default
                },
                ...field,
                isReadOnly,
                inputId: "price-individual-product",
                isError: (_a3 = formState == null ? void 0 : formState.errors) == null ? void 0 : _a3.product
              });
            }
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react433.FormErrorMessage, {
            children: t("ERROR_FIELD_IS_EMPTY")
          })
        ]
      }),
      hasCredential("company", "field", "show") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react433.FormControl, {
        isRequired: true,
        isInvalid: !!((_f = formState == null ? void 0 : formState.errors) == null ? void 0 : _f.company),
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react433.FormLabel, {
            htmlFor: "price-individual-company",
            children: t("CONTRACTOR")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form45.Controller, {
            control,
            name: "company",
            rules: {
              required: true
            },
            render: ({ field }) => {
              var _a3;
              return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSelect_default, {
                optionAllEnabled: true,
                loadDataProps: {
                  endpoint: "account_companies",
                  labelField: "displayName",
                  settings: {
                    "order[_q]": "DESC",
                    "order[name]": "ASC",
                    extra_fields: "displayName"
                  }
                },
                ...field,
                isReadOnly,
                inputId: "price-individual-company",
                isError: (_a3 = formState == null ? void 0 : formState.errors) == null ? void 0 : _a3.company
              });
            }
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react433.FormErrorMessage, {
            children: t("ERROR_FIELD_IS_EMPTY")
          })
        ]
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react433.HStack, {
        alignItems: "flex-start",
        children: [
          hasCredential("priceNetto", "field", "show") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react433.FormControl, {
            isRequired: true,
            isInvalid: !!((_g = formState == null ? void 0 : formState.errors) == null ? void 0 : _g.priceNetto),
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react433.FormLabel, {
                htmlFor: "priceNetto",
                children: t("PRICE_INDIVIDUAL_VALUE_NETTO")
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form45.Controller, {
                control,
                name: "priceNetto",
                rules: {
                  required: t("ERROR_FIELD_IS_EMPTY"),
                  validate: (value) => {
                    if (value === "0,00") {
                      return t("PRICE_INDIVIDUAL_PRICE_NETTO_GT_ZERO");
                    }
                  }
                },
                render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraInput_default, {
                  className: "price-individual__create-modal__priceNetto",
                  flex: 1,
                  ...field,
                  onChange: (e) => {
                    e.target.value = e.target.value.replace(/[^\d.\,]/g, "");
                    field.onChange(e);
                  },
                  isRequired: false,
                  onBlur: (e) => {
                    var _a3;
                    const parsedToFloat = auraParseFloat((_a3 = e == null ? void 0 : e.target) == null ? void 0 : _a3.value);
                    const newValue = priceFormatter(
                      parsedToFloat,
                      "none",
                      {},
                      2
                    );
                    field.onChange(newValue);
                  },
                  isReadOnly
                })
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react433.FormErrorMessage, {
                children: (_i = (_h = formState == null ? void 0 : formState.errors) == null ? void 0 : _h.priceNetto) == null ? void 0 : _i.message
              })
            ]
          }),
          hasCredential("currencyCode", "field", "show") && isCurrencyCodeEditable && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react433.FormControl, {
            isInvalid: !!((_j = formState == null ? void 0 : formState.errors) == null ? void 0 : _j.currencyCode),
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react433.FormLabel, {
                htmlFor: "currencyCode",
                children: t("Currency")
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form45.Controller, {
                control,
                name: "currencyCode",
                render: ({ field }) => {
                  var _a3;
                  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSelect_default, {
                    ...field,
                    isReadOnly: !isCurrencyCodeEditable,
                    inputId: "price-individual-currency-code",
                    isError: (_a3 = formState == null ? void 0 : formState.errors) == null ? void 0 : _a3.currencyCode,
                    options: availableCurrencies
                  });
                }
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react433.FormErrorMessage, {
                children: t("ERROR_FIELD_IS_EMPTY")
              })
            ]
          })
        ]
      })
    ]
  });
};
var ModalPriceIndividual_default = withCredentials15(ModalPriceIndividual);

// src/components/TaxDuplicatesModal/DuplicateNameLink.tsx
var import_react435 = require("@chakra-ui/react");
var import_jsx_runtime = require("react/jsx-runtime");
var getCompanyHref = (id) => `/accountCompany/show/company_id/${id}`;
var DuplicateNameLink = ({ id, name }) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react435.Link, {
    href: getCompanyHref(id),
    target: "_blank",
    rel: "noopener noreferrer",
    color: "blue.500",
    children: name
  });
};
var DuplicateNameLink_default = DuplicateNameLink;

// src/components/TaxDuplicatesModal/TaxDuplicatesModal.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var TaxDuplicatesModal = ({
  isOpen,
  onClose,
  duplicates
}) => {
  const { t } = useAuraTranslation_default();
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(AuraModal, {
    isOpen,
    onClose,
    size: "xl",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalOverlay, {}),
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(AuraModalContent, {
        className: "tax-duplicates-modal",
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalHeader, {
            children: t("COMPANY_TAX_DUPLICATES_TITLE")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalBody, {
            pb: "24px",
            children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TableContainer, {
              children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Table, {
                variant: "simple",
                children: [
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Thead, {
                    children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Tr, {
                      children: [
                        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Th, {
                          children: t("NAME")
                        }),
                        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Th, {
                          children: t("NIP")
                        }),
                        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Th, {
                          children: t("ADDRESS")
                        })
                      ]
                    })
                  }),
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Tbody, {
                    children: duplicates == null ? void 0 : duplicates.map((duplicate) => /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Tr, {
                      children: [
                        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Td, {
                          children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(DuplicateNameLink_default, {
                            id: duplicate.id,
                            name: duplicate.name
                          })
                        }),
                        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Td, {
                          children: duplicate.nip
                        }),
                        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Td, {
                          children: duplicate.defaultPlace ?? "-"
                        })
                      ]
                    }, duplicate.id))
                  })
                ]
              })
            })
          })
        ]
      })
    ]
  });
};
var TaxDuplicatesModal_default = TaxDuplicatesModal;

// src/components/ModalSelectTemplate/ModalSelectTemplate.tsx
var import_react436 = require("@chakra-ui/react");
var import_react437 = require("react");
var import_jsx_runtime = require("react/jsx-runtime");
var ModalSelectTemplate = ({
  parentClassName = "",
  templates,
  useDisclosureTemplateModal,
  onSubmit,
  modalTitle,
  labelTitle,
  buttonTitle
}) => {
  const { t } = useAuraTranslation_default();
  const preparedClassNamePrefix = parentClassName && `${parentClassName}__`;
  const [template, setTemplate] = (0, import_react437.useState)();
  const { onClose, isOpen } = useDisclosureTemplateModal;
  const options = (0, import_react437.useMemo)(
    () => buildOptions(templates ?? [], "name"),
    [templates]
  );
  (0, import_react437.useEffect)(() => {
    (options == null ? void 0 : options.length) && setTemplate(options[0]);
  }, [options]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, {
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(AuraModal, {
      isOpen,
      onClose,
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalOverlay, {}),
        /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(AuraModalContent, {
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalHeader, {
              children: t(modalTitle ? modalTitle : "SELECT")
            }),
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalBody, {
              children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react436.FormControl, {
                className: `${preparedClassNamePrefix}modal-select-template`,
                children: [
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react436.FormLabel, {
                    htmlFor: `${preparedClassNamePrefix}modal-select-template`,
                    children: t(labelTitle ? labelTitle : "TEMPLATE")
                  }),
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSelect_default, {
                    inputId: `${preparedClassNamePrefix}modal-select-template__selected`,
                    value: template,
                    onChange: (newValue) => setTemplate(newValue),
                    options,
                    isClearable: false
                  })
                ]
              })
            }),
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalFooter, {
              showBorders: false,
              children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react436.Button, {
                className: `${preparedClassNamePrefix}modal-select-template__submit`,
                colorScheme: "blue",
                onClick: () => onSubmit(template == null ? void 0 : template.value),
                isDisabled: !template,
                children: t(buttonTitle ? buttonTitle : "SELECT")
              })
            })
          ]
        })
      ]
    })
  });
};
var ModalSelectTemplate_default = ModalSelectTemplate;

// src/components/ModalServicedProduct/ModalServicedProduct.tsx
var import_react438 = require("@chakra-ui/react");
var import_react439 = require("react");
var import_react_hook_form46 = require("react-hook-form");
var import_api48 = require("@questy/api");
var import_lib31 = require("@questy/lib");
var import_react_query59 = require("react-query");
var import_jsx_runtime = require("react/jsx-runtime");
var withCredentials16 = (Component) => {
  return ({ ...props }) => {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_lib31.CredentialContextProvider, {
      module: "serviced_products",
      initialModuleParams: {},
      ...props.initialCredentials && {
        initialCredentials: props.initialCredentials
      },
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Component, {
        ...props
      })
    });
  };
};
var ModalServicedProduct = ({
  isOpen,
  onClose,
  onSubmit,
  afterSuccess,
  company,
  isCompanyFieldReadOnly = false,
  address,
  product,
  serialCode,
  parentId,
  headerLabel
}) => {
  const { t } = useAuraTranslation_default();
  const { resolveApiError } = useAuraErrorResolver_default();
  const {
    hasModuleCredential,
    isLoading: isLoadingCredentials,
    hasCredential
  } = (0, import_lib31.useCredentials)();
  const {
    register,
    control,
    formState,
    handleSubmit,
    reset,
    resetField,
    setError,
    setValue
  } = (0, import_react_hook_form46.useForm)();
  (0, import_react439.useEffect)(() => {
    if (isOpen) {
      reset({
        serialCode,
        date: new Date(),
        active: false,
        ...idExists(company == null ? void 0 : company.id) && {
          company: {
            value: company.id,
            label: company == null ? void 0 : company.name
          }
        },
        ...idExists(address == null ? void 0 : address.id) && {
          address: {
            value: address.id,
            label: (address == null ? void 0 : address.fullName) ?? (address == null ? void 0 : address.name)
          }
        },
        ...idExists(product == null ? void 0 : product.id) && {
          product: {
            value: product.id,
            label: product == null ? void 0 : product.name
          }
        }
      });
    }
  }, [isOpen, company, address, serialCode]);
  const handleCreateProduct = async (productName) => {
    try {
      const productResponse = await (0, import_api48.createProduct)({
        data: {
          name: productName
        }
      });
      if (productResponse.errors === null && Array.isArray(productResponse.data)) {
        return productResponse.data[0].id;
      }
    } catch (error) {
      resolveApiError(error);
      if (error == null ? void 0 : error.response) {
        setError(
          "product",
          {
            type: "manual",
            message: "ERROR_PRODUCT_ADD_FAILED"
          },
          {
            shouldFocus: true
          }
        );
      }
    }
  };
  const handleCreateServicedProduct = async (data) => {
    var _a2, _b, _c, _d;
    const isNewProduct = (_a2 = data == null ? void 0 : data.product) == null ? void 0 : _a2.__isNew__;
    const productId = isNewProduct ? await handleCreateProduct(data.product.value) : data.product.value;
    try {
      const servicedProductResponse = await (0, import_api48.createServicedProduct)({
        data: {
          serialCode: data.serialCode,
          ...hasCredential("date", "field", "edit") && {
            date: formatDateForApi(data == null ? void 0 : data.date)
          },
          isActive: data.active,
          product: productId,
          ...data.sold && { hasBeenSold: data.sold },
          company: ((_b = data.company) == null ? void 0 : _b.value) ?? null,
          ...hasCredential("place", "field", "edit") && {
            place: ((_c = data.address) == null ? void 0 : _c.value) ?? null
          },
          ...parentId && { parent: parentId }
        },
        extra_fields: [
          "fullName",
          "product.fullName",
          "company.displayName",
          "place.fullName"
        ]
      });
      if (servicedProductResponse.errors === null && Array.isArray(servicedProductResponse.data)) {
        afterSuccess((_d = servicedProductResponse == null ? void 0 : servicedProductResponse.data) == null ? void 0 : _d[0]);
        onClose();
      }
    } catch (error) {
      resolveApiError(error);
      if (error == null ? void 0 : error.response) {
        setError(
          "serialCode",
          {
            type: "manual",
            message: "ERROR_SERVICED_PRODUCT_SERIAL_NOT_UNIQUE"
          },
          {
            shouldFocus: true
          }
        );
      }
    }
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(AuraModal, {
    size: "lg",
    isOpen,
    onClose,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalOverlay, {}),
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(AuraModalContent, {
        as: "form",
        onSubmit: handleSubmit(handleCreateServicedProduct),
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalHeader, {
            children: headerLabel ? t(headerLabel) : t("NEW_SERVICED_PRODUCT")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalBody, {
            overflowY: "visible",
            className: "serviced-product__create-modal__body",
            children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ServicedProductCreateForm, {
              control,
              register,
              resetField,
              formState,
              setValue,
              isCompanyFieldReadOnly
            })
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalFooter, {
            className: "serviced-product__create-modal__footer",
            showBorders: false,
            children: hasModuleCredential("create") && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react438.Button, {
              className: "serviced-product__create-modal__footer-button",
              textTransform: "capitalize",
              isLoading: formState.isSubmitting,
              type: "submit",
              colorScheme: "blue",
              children: t("SAVE")
            })
          })
        ]
      })
    ]
  });
};
var ServicedProductCreateForm = ({
  register,
  control,
  resetField,
  isCompanyFieldReadOnly,
  setValue
}) => {
  var _a2, _b;
  const { language } = (0, import_react439.useContext)(LanguageContext);
  const { hasCredential } = (0, import_lib31.useCredentials)();
  const { t } = useAuraTranslation_default();
  const { errors } = (0, import_react_hook_form46.useFormState)({ control });
  const currentCompany = (0, import_react_hook_form46.useWatch)({ control, name: "company" });
  const { data: moduleProductsCredential } = (0, import_react_query59.useQuery)(
    ["products", "meta", "moduleCredential"],
    () => api_default.getMeta("products"),
    {
      select: (data) => {
        var _a3;
        return (_a3 = data == null ? void 0 : data.data) == null ? void 0 : _a3.module.credential;
      }
    }
  );
  const handleProductName = (inputValue, action) => {
    if (moduleProductsCredential > 2) {
      if (action.action === "input-change") {
        setValue("product", {
          label: inputValue,
          value: inputValue,
          __isNew__: true
        });
      }
    }
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react438.Stack, {
    spacing: 4,
    "data-testid": "create-serviced-product-form",
    className: "serviced-product__create-modal__form",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react438.Flex, {
        justifyContent: "flex-end",
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react438.Text, {
            textStyle: "bodyInput",
            color: "red.500",
            mr: "16px",
            children: "*"
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react438.Text, {
            textStyle: "bodyInput",
            color: "blackAlpha.500",
            children: t("REQUIRED")
          })
        ]
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react438.FormControl, {
        isInvalid: !!(errors == null ? void 0 : errors.serialCode),
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react438.FormLabel, {
            htmlFor: "serviced-product-serial-code",
            children: t("SERVICED_PRODUCT_SERIAL_CODE")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react438.Input, {
            id: "serviced-product-serial-code",
            className: "serviced-product__create-modal__serial-code",
            ...register(
              "serialCode"
            )
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react438.FormErrorMessage, {
            children: t(((_a2 = errors == null ? void 0 : errors.serialCode) == null ? void 0 : _a2.message) ?? "ERROR")
          })
        ]
      }),
      hasCredential("product", "field", "edit") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react438.FormControl, {
        isRequired: true,
        isInvalid: !!(errors == null ? void 0 : errors.product),
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react438.FormLabel, {
            htmlFor: "serviced-product-product",
            requiredIndicator: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraRequiredIndicator_default, {}),
            children: t("SERVICED_PRODUCT_PRODUCT")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form46.Controller, {
            control,
            name: "product",
            rules: {
              required: {
                value: true,
                message: "ERROR_SERVICED_PRODUCT_PRODUCT_REQUIRED"
              }
            },
            render: ({ field }) => {
              const fieldValue = field == null ? void 0 : field.value;
              const labelValue = fieldValue && `${fieldValue == null ? void 0 : fieldValue.label} ${(fieldValue == null ? void 0 : fieldValue.additionalName) ? `(${fieldValue.additionalName})` : ""} `;
              return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(DataSelector_default, {
                placeholder: t("SELECT"),
                noOptionsMessage: (elem) => (elem == null ? void 0 : elem.inputValue) === "" ? t("BEGIN_WRITING_TO_SEARCH") : t("NOTHING_FOUND"),
                loadingMessage: () => t("LOADING"),
                inputId: "serviced-product-product",
                className: "serviced-product__create-modal__product",
                endpoint: "products",
                labelField: "name",
                getFilter: (inputValue) => ({
                  "filter[_q][hasText]": inputValue
                }),
                params: {
                  "order[_q]": "DESC",
                  "order[name]": "ASC"
                },
                fields: ["code"],
                valueField: "id",
                additionalOptionField: [
                  { field: "additionalName", source: "code" }
                ],
                onInputChange: (value, action) => handleProductName(value, action),
                components: {
                  Option: CustomProductOption_default,
                  ValueContainer: CreatableValueContainer_default
                },
                ...field,
                value: {
                  ...fieldValue,
                  label: labelValue
                }
              });
            }
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react438.FormErrorMessage, {
            children: t(((_b = errors == null ? void 0 : errors.product) == null ? void 0 : _b.message) ?? "ERROR")
          })
        ]
      }),
      hasCredential("company", "field", "edit") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react438.FormControl, {
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react438.FormLabel, {
            htmlFor: "serviced-product-company",
            children: t("SERVICED_PRODUCT_COMPANY")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form46.Controller, {
            control,
            name: "company",
            render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(DataSelector_default, {
              placeholder: "",
              noOptionsMessage: (elem) => (elem == null ? void 0 : elem.inputValue) === "" ? t("BEGIN_WRITING_TO_SEARCH") : t("NOTHING_FOUND"),
              loadingMessage: () => t("LOADING"),
              isDisabled: isCompanyFieldReadOnly,
              inputId: "serviced-product-company",
              className: "serviced-product__create-modal__company",
              endpoint: "account_companies",
              labelField: "displayName",
              getFilter: (inputValue) => ({
                "filter[_q][hasText]": inputValue
              }),
              extraFields: ["displayName"],
              valueField: "id",
              ...field,
              onChange: (value, changedOption) => {
                field.onChange(value, changedOption);
                resetField("address");
              }
            })
          })
        ]
      }),
      hasCredential("place", "field", "edit") && currentCompany && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react438.FormControl, {
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react438.FormLabel, {
            htmlFor: "serviced-product-address",
            children: t("SERVICED_PRODUCT_ADDRESS")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form46.Controller, {
            control,
            name: "address",
            render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(DataSelector_default, {
              placeholder: t("SELECT"),
              noOptionsMessage: (elem) => (elem == null ? void 0 : elem.inputValue) === "" ? t("BEGIN_WRITING_TO_SEARCH") : t("NOTHING_FOUND"),
              loadingMessage: () => t("LOADING"),
              inputId: "serviced-product-address",
              className: "serviced-product__create-modal__address",
              endpoint: "places",
              labelField: "fullName",
              valueField: "id",
              fields: ["company.id", "company.name"],
              extraFields: ["fullName"],
              getFilter: (value) => ({
                "filter[fullName][hasText]": value,
                "filter[company.id][eq]": currentCompany == null ? void 0 : currentCompany.value,
                "setting[with_relations]:": true
              }),
              ...field
            })
          })
        ]
      }),
      hasCredential("date", "field", "edit") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react438.FormControl, {
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react438.FormLabel, {
            htmlFor: "serviced-product-date",
            children: t("SERVICED_PRODUCT_DATE")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hook_form46.Controller, {
            control,
            name: "date",
            render: ({ field: { ref, ...field } }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(DateInput_default, {
              id: "serviced-product-date",
              className: "serviced-product__create-modal__date",
              lang: language,
              isClearable: false,
              ...field
            })
          })
        ]
      }),
      hasCredential("isActive", "field", "edit") && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react438.FormControl, {
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react438.Stack, {
          className: "serviced-product__create-modal__active",
          direction: "row",
          alignItems: "center",
          spacing: 2,
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react438.Checkbox, {
              id: "serviced-product-active",
              size: "lg",
              ...register("active")
            }),
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react438.FormLabel, {
              htmlFor: "serviced-product-active",
              children: t("SERVICED_PRODUCT_ACTIVE")
            })
          ]
        })
      })
    ]
  });
};
var ModalServicedProduct_default = withCredentials16(ModalServicedProduct);

// src/components/CustomScripts/CustomScripts.tsx
var import_react441 = require("@chakra-ui/react");
var import_react442 = require("react");
var import_react_dom = __toESM(require("react-dom"));
var import_react_query61 = require("react-query");

// src/components/CustomScripts/utils.tsx
var import_js61 = require("@mdi/js");
var import_api50 = require("@questy/api");
var import_react440 = require("react");
var import_react_query60 = require("react-query");
var import_jsx_runtime = require("react/jsx-runtime");
var CustommSelect = (props) => {
  const [inputValue, setInputValue] = (0, import_react440.useState)("");
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSelect_default, {
    value: inputValue,
    onChange: (value) => setInputValue(value),
    isReadOnly: false,
    icon: import_js61.mdiAccountGroupOutline,
    loadDataProps: {
      titleLabel: (props == null ? void 0 : props.titleLabel) ?? "Poka\u017C jeszcze wi\u0119cej wynik\xF3w",
      labelField: (props == null ? void 0 : props.labelField) ?? "name",
      endpoint: props == null ? void 0 : props.endpoint,
      settings: props == null ? void 0 : props.settings
    },
    ...props
  });
};
var CustommSelectDate = (props) => {
  const [inputValue, setInputValue] = (0, import_react440.useState)();
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AttributeDate_default, {
    value: inputValue,
    onChange: (value) => setInputValue(value),
    ...props
  });
};
var CustomColorPicker = (props) => {
  const [inputValue, setInputValue] = (0, import_react440.useState)();
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ColorPicker_default, {
    value: inputValue,
    onChange: (value) => setInputValue(value),
    ...props
  });
};
var CustomConnectedProcess = (props) => {
  var _a2, _b, _c, _d, _e, _f;
  const { id } = props;
  const { data, isLoading } = (0, import_react_query60.useQuery)(
    ["customComponentConnectedProcess", {}],
    () => (0, import_api50.getCommission)(id, {
      extraFields: ["attributes", "user.fullName", "fullName"],
      fields: ["phaseName"],
      settings: {
        withRelations: true
      }
    }),
    {
      enabled: true
    }
  );
  const commissionObject = {
    id: data == null ? void 0 : data.data.id,
    commissionName: data == null ? void 0 : data.data.fullName,
    relationName: "",
    relatedPhase: data == null ? void 0 : data.data.commissionPhase,
    relatedSystemAttributes: data == null ? void 0 : data.data.attributes,
    user: {
      fullName: `${(_b = (_a2 = data == null ? void 0 : data.data) == null ? void 0 : _a2.user) == null ? void 0 : _b.fullName}`,
      avatar: (_d = (_c = data == null ? void 0 : data.data) == null ? void 0 : _c.user) == null ? void 0 : _d.avatar
    },
    startDate: (_e = data == null ? void 0 : data.data) == null ? void 0 : _e.startDate,
    endDate: (_f = data == null ? void 0 : data.data) == null ? void 0 : _f.endDate
  };
  if (isLoading)
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, {});
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ConnectedProcess_default, {
    commission: commissionObject,
    maxStages: (props == null ? void 0 : props.maxStages) ?? 1,
    index: id,
    onRemove: () => {
    },
    commissionUserAvatars: [commissionObject]
  });
};
var getCustomComponent = (componentName, props) => {
  switch (componentName) {
    case "AuraSelect":
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CustommSelect, {
        ...props
      });
    case "AttributeDate":
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CustommSelectDate, {
        ...props
      });
    case "BlockedDisabledInfo":
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(BlockedDisabledInfo_default, {
        ...props
      });
    case "Address":
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Address_default, {
        icon: import_js61.mdiMapMarkerOutline,
        ...props
      });
    case "ColorPicker":
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CustomColorPicker, {
        ...props
      });
    case "DocumentSummary":
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(DocumentSummary_default, {
        ...props
      });
    case "ConnectedProcess":
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CustomConnectedProcess, {
        ...props
      });
    default:
      break;
  }
};

// src/components/CustomScripts/CustomScripts.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var Wraper = ({
  queryClient,
  children
}) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_query61.QueryClientProvider, {
  client: queryClient,
  children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react441.ChakraProvider, {
    theme: customTheme,
    children
  })
});
var CustomFormScripts = ({ moduleName }) => {
  const iframeId = "customFormBridgeNext";
  const modalClass = "modal-dialog";
  const handleShowModal = (...props) => {
    if (!(props == null ? void 0 : props.length) || document.getElementById(iframeId)) {
      return;
    }
    window.customFormProps = { data: props };
    const iframe = document.createElement("iframe");
    iframe.setAttribute(
      "sandbox",
      "allow-same-origin allow-scripts allow-popups allow-forms allow-modals"
    );
    iframe.id = iframeId;
    iframe.src = "/";
    iframe.width = `${window.innerWidth}px`;
    iframe.height = `${window.innerHeight}px`;
    iframe.style.position = "fixed";
    iframe.style.top = "0";
    iframe.style.left = "0";
    iframe.style.zIndex = "1000";
    iframe.style.opacity = "0";
    document.body.insertBefore(iframe, window.document.body.firstChild);
    iframe.onload = () => {
      var _a2;
      const iframeDoc = iframe.contentDocument || ((_a2 = iframe.contentWindow) == null ? void 0 : _a2.document);
      if (iframeDoc) {
        const style = iframeDoc.createElement("style");
        style.textContent = `
          .wrapper, #footer-main {
              opacity: 0; 
            }
        `;
        iframeDoc.head.appendChild(style);
      }
      iframe.style.opacity = "1";
    };
  };
  const removeIframe = () => {
    const iframeElement = document.getElementById(iframeId);
    if (iframeElement) {
      iframeElement.remove();
    }
  };
  (0, import_react442.useEffect)(() => {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.removedNodes.forEach((node) => {
          var _a2;
          if (node == null ? void 0 : node.children) {
            (_a2 = node == null ? void 0 : node.children) == null ? void 0 : _a2.forEach((child) => {
              if ((child == null ? void 0 : child.className) === modalClass) {
                window.parent.postMessage({ closeIframe: true }, "*");
              }
            });
          }
        });
      });
    });
    const targetNode = document.body;
    const config = { childList: true, subtree: true };
    observer.observe(targetNode, config);
    return () => {
      observer.disconnect();
      removeIframe();
    };
  }, []);
  (0, import_react442.useLayoutEffect)(() => {
    if (moduleName === "aura-frontend") {
      if (!document.getElementById(iframeId)) {
        window.newFormWindow = handleShowModal;
      }
    }
  }, []);
  (0, import_react442.useEffect)(() => {
    var _a2, _b;
    window.addEventListener("message", (event) => {
      var _a3;
      if ((_a3 = event == null ? void 0 : event.data) == null ? void 0 : _a3.closeIframe) {
        try {
          removeIframe();
        } catch (error) {
          console.error("Error while calling iFrame window", error);
        }
      }
    });
    const formProps = (_b = (_a2 = window == null ? void 0 : window.parent) == null ? void 0 : _a2.customFormProps) == null ? void 0 : _b.data;
    if (formProps) {
      window == null ? void 0 : window.newFormWindow(...formProps);
    }
    return () => {
      const existingIframe = document.getElementById(iframeId);
      if (existingIframe) {
        document.body.removeChild(existingIframe);
      }
    };
  }, [moduleName]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, {});
};
var CustomScripts = ({ queryClient, moduleName = "aura-spa" }) => {
  (0, import_react442.useEffect)(() => {
    window.customComponent = (props) => {
      props == null ? void 0 : props.forEach((component) => {
        const { waitElement: waitElement2 } = window == null ? void 0 : window.auraCustom;
        (component == null ? void 0 : component.displayLogs) && console.log("CustomComponent - props", props);
        const nameClass = `customComponent-${component == null ? void 0 : component.name}`;
        if (document.querySelector(`.${nameClass}`))
          return;
        if (component == null ? void 0 : component.destinationClass) {
          waitElement2(`.${component == null ? void 0 : component.destinationClass}`).then(
            (element) => {
              (component == null ? void 0 : component.displayLogs) && console.log(
                "CustomComponent - wybrane miejsce wy\u015Bwietlenia komponentu:",
                element
              );
              const container = document.createElement("div");
              container.classList.add(nameClass);
              element.after(container);
              const render = getCustomComponent(
                component.componentName,
                component.props
              );
              import_react_dom.default.render(
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Wraper, {
                  queryClient,
                  children: render
                }),
                container
              );
            }
          );
        }
      });
    };
  }, []);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, {
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CustomFormScripts, {
      moduleName
    })
  });
};
var CustomScripts_default = CustomScripts;

// src/components/PersonInfo/PersonInfo.tsx
var import_react443 = require("@chakra-ui/react");
var import_jsx_runtime = require("react/jsx-runtime");
var PersonInfo = ({
  fullName,
  position,
  accountUserId,
  userUserId,
  isMainUser
}) => {
  const baseStyle = {
    textStyle: "bodyInput"
  };
  const link = accountUserId || userUserId ? userUserId ? `/userUser/show/userid/${userUserId}` : `/accountUser/show/user_id/${accountUserId}` : "#";
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react443.VStack, {
    spacing: "8px",
    alignItems: "flex-start",
    className: "person-info",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react443.Link, {
        ...baseStyle,
        color: "crmBlue",
        href: link,
        className: "person-info__link",
        ...isMainUser && { fontWeight: 600 },
        children: fullName
      }),
      position && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react443.Text, {
        ...baseStyle,
        color: "gray.500",
        className: "person-info__position",
        children: position
      })
    ]
  });
};
var PersonInfo_default = PersonInfo;

// src/components/PersonItem/PersonItem.tsx
var import_react444 = require("@chakra-ui/react");
var import_js62 = require("@mdi/js");
var import_react445 = __toESM(require("@mdi/react"));
var import_jsx_runtime = require("react/jsx-runtime");
var DisplayPhoneNumbers = ({ phoneNumbers }) => {
  const { call, enableCall } = useDatera();
  const displayNumbers = phoneNumbers.map(
    (number, index) => number && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Information_default, {
      icon: import_js62.mdiPhone,
      label: number,
      onClick: enableCall ? () => call(number) : void 0
    }, index)
  );
  return displayNumbers;
};
var PersonItem = ({
  fullName,
  position,
  accountUserId,
  userUserId,
  emailAddress,
  link,
  onClick,
  phoneNumbers,
  onDisconnect,
  isMainUser,
  ...props
}) => {
  const baseStyle = {
    width: {
      base: "100%",
      md: "50%"
    }
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react444.Stack, {
    align: "left",
    direction: { base: "column", md: "row" },
    alignItems: "center",
    spacing: "16px",
    className: "person-item",
    ...props,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react444.Stack, {
        ...baseStyle,
        className: "person-item__info",
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(PersonInfo_default, {
          fullName,
          position,
          accountUserId,
          userUserId,
          isMainUser
        })
      }),
      (emailAddress || phoneNumbers) && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react444.Stack, {
        spacing: "8px",
        ...baseStyle,
        className: "person-item__contact",
        children: [
          emailAddress && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Information_default, {
            link,
            onClick,
            label: emailAddress,
            icon: import_js62.mdiAt
          }),
          phoneNumbers && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(DisplayPhoneNumbers, {
            phoneNumbers
          })
        ]
      }),
      onDisconnect ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react444.IconButton, {
        size: "md",
        icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react445.default, {
          path: import_js62.mdiLinkVariantOff,
          size: "20px"
        }),
        "aria-label": `disconnect ${fullName}`,
        onClick: onDisconnect
      }) : null
    ]
  });
};
var PersonItem_default = PersonItem;

// src/components/PersonList/PersonList.tsx
var import_react446 = require("react");
var import_react447 = require("@chakra-ui/react");
var import_jsx_runtime = require("react/jsx-runtime");
var DisplayList = ({
  actualPage,
  resultsPerPage,
  items,
  withPagination = true
}) => {
  const startIndex = actualPage * resultsPerPage - resultsPerPage;
  const readyList = withPagination ? items.slice(startIndex, startIndex + resultsPerPage) : items;
  const showList = readyList.map((person, index) => {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react447.Box, {
      borderTop: index > 0 ? "1px solid" : null,
      p: "16px",
      borderColor: "gray.200",
      className: "person-list__items",
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(PersonItem_default, {
        ...person
      })
    }, index);
  });
  return showList;
};
var PersonList = ({
  items,
  paginationValues,
  withPagination = true
}) => {
  const [resultsPerPage, setSelectedPeoplePerPage] = (0, import_react446.useState)(5);
  const [numberOfPage, setNumberOfPage] = (0, import_react446.useState)(1);
  const totalNumberOfPages = Math.ceil(items.length / resultsPerPage);
  const handleSetSelectedPeoplePerPage = (e) => {
    const value = parseInt(e.target.value);
    setSelectedPeoplePerPage(value);
    const totalNumberOfPages2 = Math.ceil(items.length / value);
    if (numberOfPage > totalNumberOfPages2)
      setNumberOfPage(totalNumberOfPages2);
  };
  const handleNextPage = () => {
    numberOfPage < totalNumberOfPages && setNumberOfPage((prevValue) => prevValue + 1);
  };
  const handlePreviousPage = () => {
    numberOfPage > 1 && setNumberOfPage((prevValue) => prevValue - 1);
  };
  const { t } = useAuraTranslation_default();
  const perPageSelectVisible = (0, import_react447.useBreakpointValue)({ base: false, md: true });
  let actualPage = 1;
  if (numberOfPage > totalNumberOfPages)
    actualPage = totalNumberOfPages;
  else if (numberOfPage <= 0)
    actualPage = 1;
  else
    actualPage = numberOfPage;
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react447.Stack, {
    spacing: "0px",
    className: "person-list",
    w: "100%",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(DisplayList, {
        actualPage,
        resultsPerPage,
        items,
        withPagination
      }),
      items.length > 5 && withPagination ? /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react447.Flex, {
        justifyContent: { base: "center", md: "space-between" },
        alignItems: "center",
        px: "16px",
        py: "12px",
        textStyle: "bodyInput",
        className: "person-list__pagination-box",
        children: [
          perPageSelectVisible && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ObjectsPerPageSelect, {
                resultsPerPage,
                setTotalResult: handleSetSelectedPeoplePerPage,
                paginationValues
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react447.Text, {
                children: [
                  items.length,
                  " ",
                  t("LIST_TOTAL_RESULTS")
                ]
              })
            ]
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Pagination_default, {
            page: numberOfPage,
            totalPages: totalNumberOfPages,
            nextPage: handleNextPage,
            previousPage: handlePreviousPage,
            setPage: setNumberOfPage
          })
        ]
      }) : null
    ]
  });
};
var PersonList_default = PersonList;

// src/components/ProductListItem/ProductListItem.tsx
var import_react448 = require("@chakra-ui/react");
var import_framer_motion2 = require("framer-motion");
var import_react449 = __toESM(require("react"));
var import_jsx_runtime = require("react/jsx-runtime");
var ProductListItem = import_react449.default.memo(
  ({
    product,
    isLast,
    isSelected,
    onToggleCheckbox,
    variant,
    displayImage = true,
    errorMessages,
    hideQuantitySelector,
    favoriteProps,
    showDiscountInfo,
    withRedirectToBasket = false,
    disableQuantitySelector = false,
    customPriceTag
  }) => {
    var _a2, _b, _c, _d;
    const theme = (0, import_react448.useTheme)();
    const settings = useSettings_default();
    const { t } = useAuraTranslation_default();
    const cardVariants = {
      hover: {
        boxShadow: theme.shadows.md
      }
    };
    const activeMarkers = getActiveMarkers(product.externalMarkers);
    const seoUrl = settings["enable_seo_urls"] ? prepareSeoUrlForProduct(t, (_b = (_a2 = product.categories) == null ? void 0 : _a2[0]) == null ? void 0 : _b.name, product.name) : "";
    const productUrl = `/product/show/productid/${product.id}${seoUrl}`;
    const measureUnitName = (_c = product == null ? void 0 : product.measureUnit) == null ? void 0 : _c.name;
    const customPriceLevel = variant === "forCompanyPriceList" ? "individual" : void 0;
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react448.LinkBox, {
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(AnimatedBox2, {
        variants: cardVariants,
        whileHover: "hover",
        initial: "initial",
        animate: "initial",
        className: "product",
        id: `product-${product.id}`,
        rounded: 4,
        p: "24px",
        pt: "4px",
        ...isLast ? null : {
          borderBottom: 1,
          borderStyle: "solid",
          borderBottomColor: "gray.100"
        },
        cursor: "pointer",
        bg: "white",
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ExternalMarkerContainer_default, {
            externalMarkers: activeMarkers
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react448.HStack, {
            w: "full",
            children: [
              typeof onToggleCheckbox === "function" && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react448.Checkbox, {
                isChecked: isSelected,
                size: "lg",
                zIndex: 2,
                onChange: onToggleCheckbox,
                me: displayImage && variant === "basket" ? "0" : "24px"
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react448.Stack, {
                isInline: true,
                spacing: 4,
                w: "full",
                children: [
                  displayImage && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react448.Flex, {
                    alignItems: "center",
                    position: "relative",
                    children: [
                      (favoriteProps == null ? void 0 : favoriteProps.isVisible) && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react448.Center, {
                        position: "absolute",
                        top: "0",
                        right: "0",
                        zIndex: 2,
                        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ButtonFavorite_default, {
                          onClick: favoriteProps == null ? void 0 : favoriteProps.onClickFavorite,
                          isChecked: product == null ? void 0 : product.favorite
                        })
                      }),
                      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ProductImage_default, {
                        w: "160px",
                        h: "160px",
                        defaultImage: product.defaultImage,
                        name: product.name
                      })
                    ]
                  }),
                  /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react448.HStack, {
                    justifyContent: "space-between",
                    w: "full",
                    alignItems: "flex-start",
                    children: [
                      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react448.Stack, {
                        overflow: "hidden",
                        children: [
                          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react448.LinkOverlay, {
                            href: productUrl,
                            children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(NameDisplay_default, {
                              id: product.id,
                              name: product == null ? void 0 : product.name,
                              code: product == null ? void 0 : product.code
                            })
                          }),
                          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ProductEAN_default, {
                            ean: product.ean
                          }),
                          variant === "basket" && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react448.Text, {
                            color: "gray.400",
                            fontSize: "sm",
                            children: measureUnitName
                          })
                        ]
                      }),
                      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react448.Box, {
                        className: "product__price",
                        textAlign: "right",
                        h: "100%",
                        children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react448.Stack, {
                          h: "full",
                          justifyContent: "space-between",
                          children: [
                            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(PriceDisplay_default, {
                              customPriceTag,
                              showAllPriceData: variant === "basket",
                              prices: product.prices,
                              customPriceLevel,
                              showDiscountInfo
                            }),
                            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ProductAvailability_default, {
                              availability: product.availability,
                              estimatedAvailability: product.estimatedAvailability,
                              justifyContent: "flex-end",
                              isService: product == null ? void 0 : product.isService
                            }),
                            !hideQuantitySelector && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react448.Flex, {
                              justifyContent: "flex-end",
                              children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ProductQuantitySelector_default, {
                                productId: product == null ? void 0 : product.id,
                                positionId: product == null ? void 0 : product.positionId,
                                isDisabled: disableQuantitySelector,
                                zIndex: 2,
                                withAddButton: variant !== "basket",
                                errorMessages,
                                withRedirectToBasket,
                                availableQuantity: (product == null ? void 0 : product.isService) ? DEFAULT_LIMIT_AVAILABLE_PRODUCTS : (_d = product == null ? void 0 : product.availability) == null ? void 0 : _d.available
                              })
                            })
                          ]
                        })
                      })
                    ]
                  })
                ]
              })
            ]
          })
        ]
      })
    });
  }
);
ProductListItem.displayName = "FullListItem";
var AnimatedBox2 = (0, import_framer_motion2.motion)(import_react448.Box);
var ProductListItem_default = ProductListItem;

// src/components/ProductSlider/ProductSlider.tsx
var import_react450 = require("@chakra-ui/react");
var import_react451 = require("@emotion/react");
var import_react452 = require("react");
var import_swiper = __toESM(require("swiper"));
var import_react453 = require("swiper/react");
var import_react454 = __toESM(require("@mdi/react"));
var import_js63 = require("@mdi/js");
var import_jsx_runtime = require("react/jsx-runtime");
import_swiper.default.use([import_swiper.Navigation, import_swiper.Pagination, import_swiper.A11y]);
var ProductSlider = ({
  products,
  pagination,
  resolutionBreakpoints,
  swiperProps,
  galleryItemProps,
  showOnlyPrice,
  hideQuantitySelector,
  showDiscountInfo,
  withRedirectToBasket
}) => {
  if (!products || !products.length) {
    return null;
  }
  const swiperRef = (0, import_react452.useRef)(null);
  const isSm = (0, import_react450.useBreakpointValue)({
    base: true,
    md: false
  });
  const [isPrevButtonVisible, setIsPrevButtonVisible] = (0, import_react452.useState)(true);
  const [isNextButtonVisible, setIsNextButtonVisible] = (0, import_react452.useState)(true);
  const handlePrev = () => {
    if (swiperRef.current && swiperRef.current.swiper) {
      swiperRef.current.swiper.slidePrev();
    }
  };
  const handleNext = () => {
    if (swiperRef.current && swiperRef.current.swiper) {
      swiperRef.current.swiper.slideNext();
    }
  };
  (0, import_react452.useEffect)(() => {
    if ((products == null ? void 0 : products.length) > (swiperProps == null ? void 0 : swiperProps.slidesPerView)) {
      setIsNextButtonVisible(true);
    }
  }, [swiperProps == null ? void 0 : swiperProps.slidesPerView, products]);
  (0, import_react452.useEffect)(() => {
    const updateNavigationVisibility = () => {
      if (swiperRef.current && swiperRef.current.swiper) {
        setIsPrevButtonVisible(swiperRef.current.swiper.activeIndex !== 0);
        setIsNextButtonVisible(!swiperRef.current.swiper.isEnd);
      }
    };
    if (swiperRef.current && swiperRef.current.swiper) {
      swiperRef.current.swiper.on("slideChange", updateNavigationVisibility);
      swiperRef.current.swiper.on("reachEnd", updateNavigationVisibility);
    }
    updateNavigationVisibility();
    return () => {
      if (swiperRef.current && swiperRef.current.swiper) {
        swiperRef.current.swiper.off("slideChange", updateNavigationVisibility);
        swiperRef.current.swiper.off("reachEnd", updateNavigationVisibility);
      }
    };
  }, []);
  const baseStyleNavigation = {
    size: "lg",
    rounded: "full",
    color: "gray.700",
    bg: "white",
    boxShadow: "md",
    zIndex: 2,
    top: "50%",
    transform: "translateY(-50%)"
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react450.Box, {
    className: "product-slider",
    "data-testid": "product-slider",
    css: import_react451.css`
        .swiper-pagination {
          bottom: 0 !important;
        }
        .swiper-button-disabled {
          display: none !important;
        }
        .swiper-slide {
          height: auto;
        }
      `,
    position: "relative",
    children: [
      isPrevButtonVisible && !isSm ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react450.IconButton, {
        className: "product-slider-scroll-buttons__left",
        "aria-label": "",
        icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react454.default, {
          size: "28.8px",
          path: import_js63.mdiChevronLeft
        }),
        onClick: handlePrev,
        position: "absolute",
        left: "20px",
        ...baseStyleNavigation
      }) : null,
      isNextButtonVisible && !isSm ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react450.IconButton, {
        className: "product-slider-scroll-buttons__right",
        "aria-label": "",
        icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react454.default, {
          size: "28.8px",
          path: import_js63.mdiChevronRight
        }),
        onClick: handleNext,
        position: "absolute",
        right: "20px",
        ...baseStyleNavigation
      }) : null,
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react453.Swiper, {
        ref: swiperRef,
        navigation: { nextEl: null, prevEl: null },
        spaceBetween: 8,
        pagination: pagination ?? { clickable: false },
        autoHeight: false,
        watchOverflow: true,
        ...swiperProps,
        children: products.map((product) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react453.SwiperSlide, {
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(GalleryItem_default, {
            product,
            margin: 1,
            height: "full",
            hidePromotedMarkers: true,
            omitImageSizeSetting: true,
            showOnlyPrice,
            hideQuantitySelector,
            showDiscountInfo,
            withRedirectToBasket,
            ...galleryItemProps
          })
        }, product.id))
      })
    ]
  });
};
var ProductSlider_default = ProductSlider;

// src/components/ReportTable/ReportTable.tsx
var import_react455 = require("@chakra-ui/react");
var import_jsx_runtime = require("react/jsx-runtime");
var getParsedCellValue = (cellValue, columnType) => {
  switch (columnType) {
    case "float8":
      return new Intl.NumberFormat("pl-PL", { style: "decimal" }).format(
        cellValue
      );
    case "text":
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react455.Box, {
        dangerouslySetInnerHTML: { __html: cellValue }
      });
    default:
      return cellValue;
  }
};
var getAlignment = (type) => {
  switch (type) {
    case "float8":
      return "right";
    default:
      return "left";
  }
};
var ReportTable = ({ columns, result, ...props }) => {
  const { t } = useAuraTranslation_default();
  if (!(columns == null ? void 0 : columns.length) || !(result == null ? void 0 : result.length)) {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TableContainer, {
      className: "report-container",
      ...props,
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Table, {
        variant: "simple",
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Thead, {
            children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Tr, {
              children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Th, {})
            })
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Tbody, {
            children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(EmptyState_default, {
              my: "16px"
            })
          })
        ]
      })
    });
  }
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TableContainer, {
    className: "report-container",
    ...props,
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Table, {
      variant: "simple",
      className: "report-container__table",
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Thead, {
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Tr, {
            sx: {
              th: {
                fontSize: "13px"
              }
            },
            children: columns.map((col) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Th, {
              textAlign: getAlignment(col.type),
              children: t(col == null ? void 0 : col.name)
            }, col.index))
          })
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Tbody, {
          children: result == null ? void 0 : result.map((row, rowIndex) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Tr, {
            children: row.map((cell, cellIndex) => {
              const columnType = columns[cellIndex].type;
              return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Td, {
                textAlign: getAlignment(columnType),
                children: getParsedCellValue(cell, columnType)
              }, cellIndex);
            })
          }, rowIndex))
        })
      ]
    })
  });
};
var ReportTable_default = ReportTable;

// src/components/RepositoryFile/RepositoryFile.tsx
var import_react456 = require("@chakra-ui/react");
var import_js64 = require("@mdi/js");
var import_react457 = __toESM(require("@mdi/react"));
var import_date_fns18 = require("date-fns");
var import_filesize5 = __toESM(require("filesize"));
var import_react458 = require("react");
var import_react_truncate_string2 = __toESM(require("react-truncate-string"));
var import_jsx_runtime = require("react/jsx-runtime");
var isFile = (file) => {
  return file.type !== void 0;
};
var RepositoryFile = ({
  file,
  onClickFile,
  onClickDirectory,
  onCredentialsChange,
  onDelete,
  onDownload,
  onMove,
  onRename,
  selectedFiles,
  onSelectFile,
  selectedDirectories,
  onSelectDirectory,
  hasEditCredential = true,
  ...props
}) => {
  const { t, tCustom } = useAuraTranslation_default();
  const [, isMd] = useResponsive_default();
  const fileIsFile = isFile(file);
  const menuItems = (0, import_react458.useMemo)(
    () => [
      ...fileIsFile ? [
        {
          icon: import_js64.mdiTrayArrowDown,
          label: t("FILE_REPO_DOWNLOAD"),
          onClick: () => onDownload(file)
        }
      ] : [],
      ...hasEditCredential ? [
        {
          icon: import_js64.mdiFolderArrowRightOutline,
          label: t("FILE_REPO_MOVE"),
          onClick: () => onMove(file)
        }
      ] : [],
      ...fileIsFile ? [] : hasEditCredential ? [
        {
          icon: import_js64.mdiAccountCheckOutline,
          label: t("FILE_REPO_CREDENTIALS"),
          onClick: () => onCredentialsChange(file)
        }
      ] : [],
      ...hasEditCredential ? [
        {
          icon: import_js64.mdiPencilOutline,
          label: t("FILE_REPO_RENAME"),
          onClick: () => onRename(file)
        },
        {
          icon: import_js64.mdiTrashCanOutline,
          label: t("FILE_REPO_DELETE"),
          onClick: () => onDelete(file)
        }
      ] : []
    ],
    [
      t,
      onDownload,
      onMove,
      onCredentialsChange,
      onRename,
      onDelete,
      file,
      hasEditCredential
    ]
  );
  const hasImageThumbnail = (0, import_react458.useMemo)(
    () => fileIsFile ? isImage(file.mimeType) : false,
    [fileIsFile, file]
  );
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react456.Stack, {
    isInline: true,
    height: "72px",
    align: "center",
    spacing: 3,
    minW: 0,
    borderBottom: "1px solid",
    borderColor: "gray.200",
    className: `file-repository__item${fileIsFile ? " file-repository__item-file" : " file-repository__item-directory"}`,
    ...props,
    children: [
      fileIsFile ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react456.Checkbox, {
        disabled: !hasEditCredential,
        size: "lg",
        isChecked: selectedFiles == null ? void 0 : selectedFiles.includes(file.id),
        onChange: () => onSelectFile(file.id)
      }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react456.Checkbox, {
        disabled: !hasEditCredential,
        size: "lg",
        isChecked: selectedDirectories == null ? void 0 : selectedDirectories.includes(file.id),
        onChange: () => onSelectDirectory(file.id)
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react456.Flex, {
        boxSize: "40px",
        align: "center",
        justify: "center",
        color: "gray.300",
        children: fileIsFile ? hasImageThumbnail ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react456.Img, {
          boxSize: "40px",
          objectFit: "contain",
          src: getImageUrl(file.dbName, "thmb")
        }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react457.default, {
          path: import_js64.mdiFile,
          size: "40px"
        }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react457.default, {
          path: import_js64.mdiFolder,
          size: "40px"
        })
      }),
      fileIsFile ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react456.Link, {
        flex: 1,
        fontSize: "md",
        minW: 0,
        title: tCustom(file.fileName),
        onClick: (e) => onClickFile(file),
        "data-file-id": file.id,
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_truncate_string2.default, {
          text: tCustom(file.fileName) ?? ""
        })
      }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react456.Link, {
        flex: 1,
        fontSize: "md",
        href: "#",
        minW: 0,
        title: tCustom(file.name),
        onClick: () => onClickDirectory(file),
        isTruncated: true,
        "data-dir-id": file.id,
        children: tCustom(file.name ?? "")
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react456.Stack, {
        spacing: 4,
        isInline: true,
        align: "center",
        children: [
          isMd && fileIsFile ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react456.Text, {
            as: "span",
            className: "file-size",
            textStyle: "bodyInput",
            children: (0, import_filesize5.default)((file == null ? void 0 : file.fileSize) ?? 0)
          }) : null,
          isMd && fileIsFile && (file == null ? void 0 : file.dateCreate) ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react456.Text, {
            as: "span",
            className: "file-date-created",
            textStyle: "bodyInput",
            children: (0, import_date_fns18.format)(new Date(file.dateCreate), DATE_FORMAT_DOTS)
          }) : null,
          menuItems.length > 0 && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraDropdownMenu_default, {
            menuItems,
            children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react456.MenuButton, {
              as: MoreIconButton_default,
              "data-testid": `more-btn-${fileIsFile ? "file" : "directory"}`
            })
          })
        ]
      })
    ]
  });
};
var RepositoryFile_default = RepositoryFile;

// src/components/RepositoryFileList/RepositoryFileList.tsx
var import_react459 = require("@chakra-ui/react");
var import_jsx_runtime = require("react/jsx-runtime");
var RepositoryFileList = ({
  files,
  onClickFile,
  onClickDirectory,
  onCredentialsChange,
  onDelete,
  onDownload,
  onMove,
  onRename,
  selectedFiles,
  onSelectFile,
  selectedDirectories,
  onSelectDirectory,
  hasEditCredential = true,
  ...props
}) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react459.Stack, {
    className: "file-repository__list",
    ...props,
    children: files.map((file) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(RepositoryFile_default, {
      selectedFiles,
      onSelectFile,
      selectedDirectories,
      onSelectDirectory,
      file,
      onCredentialsChange,
      onDelete,
      onDownload,
      onMove,
      onRename,
      onClickFile,
      onClickDirectory,
      hasEditCredential
    }, isFile(file) ? `file-${file.id}` : `directory-${file.id}`))
  });
};
var RepositoryFileList_default = RepositoryFileList;

// src/components/ResultsPagination/ResultsPagination.tsx
var import_react460 = require("@chakra-ui/react");
var import_react461 = __toESM(require("@mdi/react"));
var import_js65 = require("@mdi/js");
var import_jsx_runtime = require("react/jsx-runtime");
var Pagination3 = ({
  page,
  totalPages,
  nextPage,
  previousPage,
  setPage,
  ...props
}) => {
  const { t } = useAuraTranslation_default();
  const canNextPage = page < totalPages;
  const canPreviousPage = page > 1;
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react460.Stack, {
    as: "nav",
    role: "navigation",
    className: "pagination",
    isInline: true,
    justifyContent: "flex-end",
    align: "center",
    my: 0,
    spacing: 3,
    ...props,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react460.IconButton, {
        "aria-label": t("PAGINATION_GO_TO_PREV_PAGE"),
        size: "md",
        opacity: canPreviousPage ? 1 : 0.5,
        color: "gray.700",
        variant: "ghost",
        icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react461.default, {
          path: import_js65.mdiChevronLeft,
          size: "16px"
        }),
        onClick: previousPage
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react460.NumberInput, {
        backgroundColor: "white",
        size: "md",
        value: page,
        maxW: "40px",
        minW: "46px",
        min: 1,
        max: totalPages + 1,
        onChange: (value) => setPage(Number(value)),
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react460.NumberInputField, {
          textAlign: "center",
          paddingInline: 0
        })
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react460.Text, {
        as: "span",
        color: "gray.500",
        children: [
          t("OF"),
          " ",
          totalPages
        ]
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react460.IconButton, {
        "aria-label": t("PAGINATION_GO_TO_NEXT_PAGE"),
        size: "md",
        opacity: canNextPage ? 1 : 0.5,
        color: "gray.700",
        variant: "ghost",
        icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react461.default, {
          path: import_js65.mdiChevronRight,
          size: "16px"
        }),
        onClick: nextPage
      })
    ]
  });
};
var ResultsPagination_default = Pagination3;

// src/components/ResultsPerPage/ResultsPerPage.tsx
var import_react462 = require("@chakra-ui/react");
var import_jsx_runtime = require("react/jsx-runtime");
var ResultsPerPage = ({
  value,
  onChange,
  perPageOptions = [20, 40, 100],
  ...props
}) => {
  const { t } = useAuraTranslation_default();
  const handleChange = (e) => {
    onChange(e.target.value);
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react462.Stack, {
    className: "per-page",
    direction: "row",
    alignItems: "center",
    maxW: "100%",
    minW: "0%",
    flex: 1,
    fontSize: "md",
    ...props,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react462.Select, {
        borderRadius: 6,
        backgroundColor: "white",
        width: "80px",
        value,
        onChange: handleChange,
        children: perPageOptions.map((opt) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)("option", {
          value: opt,
          children: opt
        }, opt))
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react462.Text, {
        isTruncated: true,
        maxW: "100%",
        as: "span",
        color: "gray.700",
        children: t("PAGINATION_RESULTS_PER_PAGE")
      })
    ]
  });
};
var ResultsPerPage_default = ResultsPerPage;

// src/components/RoundIcon/RoundIcon.tsx
var import_react463 = require("@chakra-ui/react");
var import_react464 = __toESM(require("react"));
var import_jsx_runtime = require("react/jsx-runtime");
var RoundIcon = import_react464.default.forwardRef(
  ({ icon, ...props }, ref) => {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react463.Flex, {
      ref,
      position: "relative",
      as: "span",
      minW: "33px",
      minH: "33px",
      maxW: "33px",
      maxH: "33px",
      justify: "center",
      align: "center",
      fontSize: 20,
      borderRadius: "9999px",
      rounded: "full",
      bg: "cyan.400",
      color: "white",
      ...props,
      children: (0, import_react464.createElement)(icon)
    });
  }
);
var RoundIcon_default = RoundIcon;

// src/components/SubordinatesCheckbox/SubordinatesCheckbox.tsx
var import_react465 = require("@chakra-ui/react");
var import_jsx_runtime = require("react/jsx-runtime");
var SubordinatesCheckbox = ({
  isChecked = false,
  onChange = () => {
  },
  ...props
}) => {
  const { t } = useAuraTranslation_default();
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react465.FormControl, {
    display: "flex",
    gap: "12px",
    ...props,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react465.Switch, {
        id: "with-subordinates",
        isChecked,
        onChange: () => onChange(!isChecked)
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react465.FormLabel, {
        htmlFor: "with-subordinates",
        fontWeight: "400",
        mb: "0",
        children: t("WITH_SUBORDINATES_SWITCH")
      })
    ]
  });
};
var SubordinatesCheckbox_default = SubordinatesCheckbox;

// src/components/TaskItem/TaskItem.tsx
var import_react466 = require("@chakra-ui/react");
var import_react467 = require("@emotion/react");
var import_lib32 = require("@questy/lib");
var import_fa8 = require("react-icons/fa");
var import_react_query62 = require("react-query");
var import_jsx_runtime = require("react/jsx-runtime");
var STANDARD_ICONS = {
  default: import_fa8.FaQuestion,
  "glyphicon-phone-alt": import_fa8.FaPhone,
  "glyphicon-star": import_fa8.FaStar,
  "glyphicon-briefcase": import_fa8.FaBriefcase,
  "glyphicon-flag": import_fa8.FaFlag,
  "glyphicon-fire": import_fa8.FaFire
};
var getTaskTypeIcon = (icon, iconColor, typeName) => {
  const standardIconKey = !icon ? "default" : Object.keys(STANDARD_ICONS).find((key) => icon.match(key));
  if (standardIconKey) {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(RoundIcon_default, {
      className: "task__icon",
      maxW: 6,
      maxH: 6,
      minW: 6,
      minH: 6,
      fontSize: 12,
      icon: STANDARD_ICONS[standardIconKey],
      color: iconColor,
      bg: "none",
      border: 1,
      borderStyle: "solid",
      borderColor: "gray.200",
      title: typeName,
      display: "inline-flex"
    });
  } else {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react466.Box, {
      display: "inline-block",
      className: "task__icon",
      dangerouslySetInnerHTML: {
        __html: `<span style="fill: ${iconColor}" title="${typeName}">${icon}</span>`
      }
    });
  }
};
var TaskItem = ({
  task,
  index,
  isLoading = false,
  handleEditTaskAura,
  handleCompleteTaskAura,
  showCompany = true,
  showUserAvatar = true
}) => {
  var _a2, _b;
  const { t } = useAuraTranslation_default();
  const { id, user, taskName, taskDescription, beginDate, type } = task;
  const typeName = type.typeName;
  const icon = type.icon;
  const iconColor = type.iconColor;
  const isEvent = type.isEvent;
  const isRecurring = task.recurrenceUuid !== null;
  const isVirtualTask = task.id === null && task.recurrenceUuid && task.recurrenceParentBeginDate;
  const isExecutable = (task.id || isVirtualTask) && !isEvent && !task.isCompleted;
  const { data: moduleCredential } = (0, import_react_query62.useQuery)(
    ["tasks", "meta", "moduleCredential", { forType: task.type.id }],
    () => api_default.getMeta("tasks", {
      params: {
        "for[type]": task.type.id
      }
    }),
    {
      staleTime: Infinity,
      select: (data) => {
        var _a3;
        return (_a3 = data.data) == null ? void 0 : _a3.module.credential;
      },
      enabled: typeof ((_a2 = task == null ? void 0 : task.type) == null ? void 0 : _a2.id) !== "undefined" && isExecutable === true
    }
  );
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react466.Flex, {
    role: "group",
    direction: "row",
    align: "center",
    w: "100%",
    className: "task",
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react466.Flex, {
      borderTop: index === 0 ? 0 : 1,
      borderStyle: "solid",
      borderColor: "gray.200",
      p: 4,
      width: "100%",
      justify: "flex-start",
      align: "center",
      flexWrap: "nowrap",
      children: [
        showUserAvatar && ((user == null ? void 0 : user.fullName) ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react466.Avatar, {
          css: import_react467.css`
                & > img {
                  background: white;
                }
              `,
          size: "sm",
          showBorder: true,
          name: user.fullName,
          title: user.fullName,
          src: getImageUrl(user == null ? void 0 : user.avatar, "thmb") ?? void 0,
          ...(user == null ? void 0 : user.defaultCallendarColor) && {
            bg: user.defaultCallendarColor
          }
        }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react466.Avatar, {
          size: "sm",
          showBorder: true
        })),
        /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react466.Stack, {
          m: 1,
          mx: 4,
          spacing: 1,
          direction: "column",
          flex: "1 1 auto",
          overflow: "hidden",
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react466.Stack, {
              className: "task__main-info",
              isInline: true,
              align: "center",
              w: "full",
              children: [
                getTaskTypeIcon(icon, iconColor, typeName),
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react466.Box, {
                  className: "task__time",
                  children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(DateTag_default, {
                    value: beginDate,
                    withColors: !isEvent
                  })
                }),
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react466.Link, {
                  className: "task__link",
                  wordBreak: "break-word",
                  onClick: () => handleEditTaskAura(task),
                  children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react466.Text, {
                    as: "span",
                    color: "gray.800",
                    fontWeight: "bold",
                    children: !taskName || taskName.trim().length === 0 ? t("NO_NAME") : taskName
                  })
                }),
                isRecurring && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react466.Tooltip, {
                  placement: "top",
                  "aria-label": "Recurring task",
                  label: t("TASK_RECURRING"),
                  children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react466.Box, {
                    className: "task__recurring",
                    "data-testid": "recurring task icon",
                    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react466.Box, {
                      as: import_fa8.FaRedoAlt,
                      color: "gray.400"
                    })
                  })
                })
              ]
            }),
            taskDescription && taskDescription.trim().length > 0 && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react466.Text, {
              w: "full",
              isTruncated: true,
              className: "task__description",
              mt: 1,
              color: "gray.600",
              whiteSpace: "nowrap",
              children: stripHtmlTags(taskDescription)
            }),
            showCompany && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react466.Text, {
              fontSize: "sm",
              children: (_b = task.relations) == null ? void 0 : _b.accountCompanies.map(
                (company, index2, acArray) => /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
                  children: [
                    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react466.Link, {
                      href: `/accountCompany/show/company_id/${company.id}`,
                      children: company.value
                    }, company.id),
                    index2 === acArray.length - 1 ? "" : ", "
                  ]
                })
              )
            })
          ]
        }),
        isExecutable && moduleCredential > import_lib32.ModuleCredential.Show ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react466.IconButton, {
          isLoading,
          isDisabled: isLoading,
          "aria-label": "Execute task",
          ml: 2,
          title: t("EXECUTE"),
          variant: "solid",
          colorScheme: "green",
          size: "xs",
          icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_fa8.FaCalendarCheck, {}),
          onClick: () => handleCompleteTaskAura(task)
        }) : null
      ]
    })
  });
};
TaskItem.displayName = "TaskItem";
var TaskItem_default = TaskItem;

// src/components/TaskList/TaskList.tsx
var import_react468 = require("@chakra-ui/react");
var import_slice = __toESM(require("lodash/slice"));
var import_jsx_runtime = require("react/jsx-runtime");
var TaskList = ({
  data: tasks,
  loadingTasks = [],
  handleCompleteTask,
  handleEditTask,
  isEvent = false,
  limit = 500,
  showCompany,
  showUserAvatar,
  ...props
}) => {
  const theme = (0, import_react468.useTheme)();
  if (!tasks) {
    return null;
  }
  const sortedTasks = sortTasks(tasks, isEvent);
  const limitedTasks = (0, import_slice.default)(sortedTasks, 0, limit);
  if (limitedTasks.length === 0) {
    return null;
  }
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react468.Box, {
    className: "task-list",
    border: 1,
    borderStyle: "solid",
    borderColor: "gray.200",
    borderRadius: 4,
    my: 2,
    css: import_react468.css`
        & > .task ~ .task {
          border-top: 1px solid
            ${theme.colors.gray[200]};
        }
      `,
    ...props,
    children: limitedTasks.map((task, index) => {
      const isLoading = loadingTasks.find(
        (loadingTask) => loadingTask.recurrenceUuid === task.recurrenceUuid && loadingTask.recurrenceParentBeginDate === task.recurrenceParentBeginDate
      );
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TaskItem_default, {
        task,
        index,
        isLoading: !!isLoading,
        handleEditTaskAura: handleEditTask,
        handleCompleteTaskAura: handleCompleteTask,
        showCompany,
        showUserAvatar,
        isEvent
      }, `${task.id}${task.recurrenceUuid}${task.beginDate}`);
    })
  });
};
var TaskList_default = TaskList;

// src/components/TextScroll/TextScroll.tsx
var import_react469 = require("react");
var import_react470 = require("@chakra-ui/react");
var import_jsx_runtime = require("react/jsx-runtime");
var TextScroll = ({ children, ...props }) => {
  const scrollContentRef = (0, import_react469.useRef)(null);
  const [isScrollableToLeft, setIsScrollableToLeft] = (0, import_react469.useState)(false);
  const [isScrollableToRight, setIsScrollableToRight] = (0, import_react469.useState)(true);
  (0, import_react469.useEffect)(() => {
    const scrollContent = scrollContentRef.current;
    const handleScroll = () => {
      if (scrollContent) {
        setIsScrollableToLeft(scrollContent.scrollLeft > 0);
        setIsScrollableToRight(
          scrollContent.scrollLeft < scrollContent.scrollWidth - scrollContent.clientWidth
        );
      }
    };
    if (scrollContent) {
      scrollContent.addEventListener("scroll", handleScroll);
    }
    return () => {
      if (scrollContent) {
        scrollContent.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react470.Box, {
    h: "fit-content",
    position: "relative",
    ...props,
    children: [
      isScrollableToLeft && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ShadowBox, {
        type: "left"
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react470.HStack, {
        ref: scrollContentRef,
        className: "text-scroll",
        overflowX: "auto",
        width: "100%",
        whiteSpace: "nowrap",
        sx: {
          "&::-webkit-scrollbar": {
            display: "none"
          },
          "scrollbar-width": "none",
          "::-webkit-scrollbar": {
            display: "none"
          }
        },
        children
      }),
      (isScrollableToRight || !(scrollContentRef == null ? void 0 : scrollContentRef.current)) && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ShadowBox, {
        type: "right"
      })
    ]
  });
};
var TextScroll_default = TextScroll;
var ShadowBox = ({ type, ...props }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react470.Box, {
  h: "100%",
  w: "32px",
  position: "absolute",
  top: "0",
  ...type === "left" ? { left: "0" } : { right: "0" },
  ...props,
  sx: {
    "&": {
      "background-color": "rgba(255, 255, 255, 0)",
      "background-image": `linear-gradient(${type === "left" ? "270deg" : "90deg"}, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 100%)`
    }
  }
});

// src/components/TileList/TileItem/TileItem.tsx
var import_react471 = require("@chakra-ui/react");
var import_jsx_runtime = require("react/jsx-runtime");
var TileItem = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react471.Link, {
    color: "blue.500",
    fontSize: "sm",
    fontWeight: 400,
    lineHeight: "20px",
    isExternal: true,
    ...props
  });
};
var TileItem_default = TileItem;

// src/components/TileList/TileItemList/TileItemList.tsx
var import_react472 = require("@chakra-ui/react");
var import_jsx_runtime = require("react/jsx-runtime");
var TileItemList = ({ children }) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react472.Stack, {
    children
  });
};
var TileItemList_default = TileItemList;

// src/components/TileList/TileList.tsx
var import_react473 = require("@chakra-ui/react");
var import_jsx_runtime = require("react/jsx-runtime");
var TileList = ({ icon, children }) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react473.HStack, {
    className: "tile-list",
    alignItems: "flex-start",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react473.Box, {
        className: "tile-list__icon",
        color: "gray.300",
        children: icon
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react473.Flex, {
        className: "tile-list__items",
        children
      })
    ]
  });
};
var TileList_default = TileList;

// src/components/Timeline/Timeline.tsx
var import_react474 = require("@chakra-ui/react");
var import_react475 = __toESM(require("@mdi/react"));
var import_js66 = require("@mdi/js");
var import_date_fns19 = require("date-fns");
var import_react476 = require("react");
var import_has = __toESM(require("lodash/has"));
var import_jsx_runtime = require("react/jsx-runtime");
var Timeline = ({ children, ...props }) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react474.VStack, {
    className: "timeline",
    position: "relative",
    bg: "white",
    spacing: 0,
    ...props,
    children
  });
};
var TimelineCompact = ({
  urlFullHistory,
  onLoadMore,
  isLoadingMore,
  additionalData,
  totalNumberItems,
  children,
  ...props
}) => {
  const { t } = useAuraTranslation_default();
  const createdAtDate = getParsedDateValue(additionalData == null ? void 0 : additionalData.createdAt);
  const modifiedDate = getParsedDateValue(additionalData == null ? void 0 : additionalData.modified);
  const countVisibleTimelineItems = (children == null ? void 0 : children.length) ?? 0;
  const gridFieldsCount = (0, import_react476.useMemo)(() => {
    var _a2;
    return (_a2 = [
      (0, import_has.default)(additionalData, "createdAt"),
      (0, import_has.default)(additionalData, "modified"),
      (0, import_has.default)(additionalData, "registerMethod")
    ].filter((item) => !!item)) == null ? void 0 : _a2.length;
  }, [additionalData]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react474.Stack, {
    spacing: 4,
    className: "timeline-compact",
    ...props,
    children: [
      urlFullHistory && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react474.Link, {
        isExternal: true,
        color: "crmBlue",
        href: urlFullHistory,
        className: "timeline-compact__link-full-history",
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react474.Text, {
          textStyle: "buttonSmall",
          children: t("FULL_CHANGELOG")
        })
      }),
      gridFieldsCount > 0 && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react474.Grid, {
        templateColumns: {
          base: `repeat(1, ${gridFieldsCount}fr)`,
          lg: `repeat(${gridFieldsCount}, 1fr)`
        },
        gap: 4,
        children: [
          (0, import_has.default)(additionalData, "createdAt") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react474.FormControl, {
            className: "timeline-compact__registered-date",
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AttributeLabel_default, {
                text: "REGISTERED"
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react474.InputGroup, {
                mt: 2,
                children: [
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react474.InputLeftElement, {
                    pointerEvents: "none",
                    color: "gray.300",
                    pl: 4,
                    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react475.default, {
                      path: import_js66.mdiCalendarBlankOutline,
                      size: "24px"
                    })
                  }),
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react474.Input, {
                    pl: "44px",
                    value: createdAtDate,
                    bgColor: "gray.50",
                    isReadOnly: true,
                    letterSpacing: "mediumWide",
                    "data-testid": "registered-date"
                  })
                ]
              })
            ]
          }),
          (0, import_has.default)(additionalData, "modified") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react474.FormControl, {
            className: "timeline-compact__modified-date",
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AttributeLabel_default, {
                text: "MODIFIED"
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react474.InputGroup, {
                mt: 2,
                children: [
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react474.InputLeftElement, {
                    pointerEvents: "none",
                    color: "gray.300",
                    pl: 4,
                    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react475.default, {
                      path: import_js66.mdiCalendarBlankOutline,
                      size: "24px"
                    })
                  }),
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react474.Input, {
                    pl: "44px",
                    value: modifiedDate,
                    bgColor: "gray.50",
                    isReadOnly: true,
                    letterSpacing: "mediumWide",
                    "data-testid": "last-modified-date"
                  })
                ]
              })
            ]
          }),
          (0, import_has.default)(additionalData, "registerMethod") && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react474.FormControl, {
            className: "timeline-compact__register-method",
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AttributeLabel_default, {
                text: "REGISTRATION_METHOD"
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react474.InputGroup, {
                mt: 2,
                children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react474.Input, {
                  value: t(additionalData == null ? void 0 : additionalData.registerMethod),
                  textTransform: "uppercase",
                  bgColor: "gray.50",
                  isReadOnly: true,
                  letterSpacing: "mediumWide"
                })
              })
            ]
          })
        ]
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Timeline, {
        "data-testid": "timeline-compact-history-list",
        className: "timeline-compact__register-date",
        children
      }),
      countVisibleTimelineItems < totalNumberItems && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react474.Flex, {
        w: "full",
        justify: "left",
        mt: 4,
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react474.Button, {
          isLoading: isLoadingMore,
          onClick: onLoadMore,
          variant: "link",
          fontWeight: 500,
          fontSize: "sm",
          color: "crmBlue",
          "data-testid": "btn-load-full",
          className: "timeline-compact__btn-load-more",
          children: `${t("LOAD_FULL_HISTORY")} (${totalNumberItems - countVisibleTimelineItems} ${t("TOTAL_ENTIRES")})`
        })
      })
    ]
  });
};
var getParsedDateValue = (date) => {
  if (typeof date !== void 0) {
    if (date) {
      return (0, import_date_fns19.format)((0, import_date_fns19.parseISO)(date), DATETIME_FORMAT_DOTS);
    } else {
      return "";
    }
  }
  return void 0;
};
var Timeline_default = Timeline;

// src/components/Timeline/TimelineItem/TimelineItem.tsx
var import_react477 = require("@chakra-ui/react");
var import_js67 = require("@mdi/js");
var import_react478 = __toESM(require("@mdi/react"));
var import_jsx_runtime = require("react/jsx-runtime");
var TimelineItem = ({
  children,
  date,
  user,
  title,
  fieldType,
  ...props
}) => {
  const { isOpen, onToggle } = (0, import_react477.useDisclosure)();
  const { t, tCustom } = useAuraTranslation_default();
  const avatarBaseProps = {
    name: user == null ? void 0 : user.fullName,
    src: getImageUrl(user == null ? void 0 : user.avatar, "thmb")
  };
  const translateTitle = 2 /* attribute */ === fieldType ? tCustom : t;
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react477.VStack, {
    className: "timeline-item",
    _before: {
      width: "1px",
      content: "''",
      position: "absolute",
      left: "32px",
      top: 0,
      bottom: 0,
      background: "gray.200"
    },
    alignItems: "flex-start",
    w: "full",
    pl: "60px",
    ...props,
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react477.HStack, {
      spacing: 0,
      align: "flex-start",
      justify: "flex-start",
      w: "full",
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react477.Flex, {
          direction: "column",
          zIndex: 1,
          alignItems: "flex-start",
          py: 4,
          flex: 1,
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(DateTag_default, {
              value: date,
              className: "timeline-item__time-badge"
            }),
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react477.Stack, {
              isInline: true,
              align: "center",
              spacing: "12px",
              mb: "2px",
              mt: "8px",
              className: "timeline-item__author",
              children: user ? /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
                children: [
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react477.Avatar, {
                    showBorder: true,
                    borderColor: "gray.200",
                    borderWidth: "1px",
                    size: "sm",
                    ml: "-44px",
                    name: user.fullName,
                    ...(user == null ? void 0 : user.defaultCallendarColor) && {
                      bg: user.defaultCallendarColor
                    },
                    ...avatarBaseProps
                  }),
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react477.Text, {
                    fontSize: "sm",
                    color: "gray.500",
                    fontWeight: 400,
                    lineHeight: "20px",
                    letterSpacing: "0.25px",
                    children: user.fullName
                  })
                ]
              }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react477.Avatar, {
                showBorder: true,
                borderColor: "gray.200",
                borderWidth: "1px",
                size: "sm",
                ml: "-44px"
              })
            }),
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react477.Text, {
              className: "timeline-item__title",
              fontSize: "md",
              color: "gray.700",
              mb: 2,
              lineHeight: "24px",
              fontWeight: 500,
              letterSpacing: "0.15px",
              children: translateTitle(title)
            }),
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react477.Collapse, {
              className: "timeline-item__content",
              in: isOpen,
              animateOpacity: true,
              children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react477.Text, {
                fontSize: "md",
                color: "gray.600",
                lineHeight: "24px",
                letterSpacing: "0.5px",
                wordBreak: "break-word",
                children
              })
            })
          ]
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react477.Box, {
          pt: "42px",
          px: 3,
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react477.IconButton, {
            className: "timeline-item__toggle-content-button",
            "aria-label": "expand",
            icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react478.default, {
              path: isOpen ? import_js67.mdiChevronUp : import_js67.mdiChevronDown
            }),
            minW: "unset",
            variant: "ghost",
            boxSize: "20px",
            onClick: onToggle
          })
        })
      ]
    })
  });
};
var TimelineItem_default = TimelineItem;

// src/components/UsedMaterials/UsedMaterials.tsx
var import_react484 = require("@chakra-ui/react");
var import_react485 = require("react");
var import_react486 = require("@chakra-ui/react");
var import_react487 = require("@mdi/react");
var import_js69 = require("@mdi/js");

// src/components/UsedMaterials/TdExtended/TdExtended.tsx
var import_react479 = require("@chakra-ui/react");
var import_js68 = require("@mdi/js");
var import_react480 = __toESM(require("@mdi/react"));
var import_react481 = require("react");

// src/components/UsedMaterials/utils.ts
var isPositionFieldInvalid = (errors, positionId, fieldName) => {
  var _a2;
  const positionErrorFields = (_a2 = errors == null ? void 0 : errors.find(
    (item) => item.positionId === positionId
  )) == null ? void 0 : _a2.errorFields;
  return positionErrorFields == null ? void 0 : positionErrorFields.includes(fieldName);
};

// src/components/UsedMaterials/TdExtended/TdExtended.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var TdExtended = ({
  handleOnChange,
  handleDelete,
  handleAdd,
  product,
  isReadOnly,
  meta,
  errors
}) => {
  var _a2, _b, _c, _d;
  const [quantity, setQuantity] = (0, import_react481.useState)(product == null ? void 0 : product.quantity);
  const [plannedQuantity, setPlannedQuantity] = (0, import_react481.useState)(
    product == null ? void 0 : product.plannedQuantity
  );
  const [price, setPrice] = (0, import_react481.useState)(product == null ? void 0 : product.price);
  const [selectedValue, setSelectedValue] = (0, import_react481.useState)();
  const hasCredentialToShowPlannedQuantity = ((_b = (_a2 = meta == null ? void 0 : meta.fields) == null ? void 0 : _a2.plannedQuantity) == null ? void 0 : _b.credential) > 0;
  const hasCredentialToEditPlannedQuantity = ((_d = (_c = meta == null ? void 0 : meta.fields) == null ? void 0 : _c.plannedQuantity) == null ? void 0 : _d.credential) > 1;
  const handlePrice = (e) => {
    const newValue = e.target.value.replace(/[^\d.\,]/g, "");
    setPrice(newValue);
  };
  const onChange = async (key, value) => {
    const preparedPrice = preparePriceValueForField(price);
    setPrice(preparedPrice);
    const preparedData = {
      id: product == null ? void 0 : product.id,
      quantity,
      price: preparedPrice,
      ...key && { [key]: value },
      ...hasCredentialToEditPlannedQuantity && {
        plannedQuantity
      }
    };
    await handleOnChange(preparedData);
  };
  const onAdd = (value) => {
    value && setSelectedValue(value);
    handleAdd(value ?? selectedValue);
  };
  const labelValue = `${product == null ? void 0 : product.productName} ${(product == null ? void 0 : product.productCode) ? `(${product.productCode})` : ""}`;
  (0, import_react481.useEffect)(() => {
    setQuantity(product == null ? void 0 : product.quantity);
    setPlannedQuantity(product == null ? void 0 : product.plannedQuantity);
    if (isReadOnly) {
      setPrice(product == null ? void 0 : product.price);
    } else {
      const preparedPrice = preparePriceValueForField(product == null ? void 0 : product.price);
      if (preparedPrice) {
        setPrice(preparedPrice);
      }
    }
  }, [product]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, {
    children: !isReadOnly ? /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react479.Td, {
          w: "50%",
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react479.HStack, {
            spacing: "8px",
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react479.FormControl, {
                children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSelect_default, {
                  className: "used-materials__table__row__product-input",
                  value: {
                    label: labelValue,
                    value: product == null ? void 0 : product.id
                  },
                  controlShouldRenderValue: product ? true : false,
                  blurInputOnSelect: true,
                  onChange: (data) => {
                    typeof handleAdd === "function" ? onAdd(data == null ? void 0 : data.value) : onChange("changedProductId", data == null ? void 0 : data.value);
                  },
                  isClearable: false,
                  hideSelectedOptions: false,
                  components: {
                    Option: CustomProductOption_default
                  },
                  loadDataProps: {
                    endpoint: "products",
                    labelField: "name",
                    autoselect: true,
                    additionalNameAccessor: "code",
                    settings: {
                      "order[_q]": "DESC",
                      "order[name]": "ASC"
                    }
                  }
                })
              }),
              product && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
                children: [
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react479.Link, {
                    href: product == null ? void 0 : product.link,
                    isExternal: true,
                    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react479.IconButton, {
                      className: "used-materials__table__row__product-link",
                      w: "40px",
                      h: "40px",
                      "aria-label": "Open",
                      icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react480.default, {
                        path: import_js68.mdiOpenInNew,
                        size: "20px"
                      })
                    })
                  }),
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react479.IconButton, {
                    className: "used-materials__table__row__delete",
                    w: "40px",
                    h: "40px",
                    "aria-label": "Delete",
                    onClick: () => handleDelete(product == null ? void 0 : product.id),
                    icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react480.default, {
                      path: import_js68.mdiTrashCanOutline,
                      size: "20px"
                    })
                  })
                ]
              })
            ]
          })
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react479.Td, {
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraInput_default, {
            className: "used-materials__table__row__quantity",
            isDisabled: !product,
            type: "number",
            value: quantity,
            onChange: (e) => setQuantity(parseQuantity(e)),
            onBlur: () => onChange("quantity", quantity),
            borderColor: "gray.200",
            isInvalid: isPositionFieldInvalid(
              errors,
              product == null ? void 0 : product.id,
              "quantity"
            )
          })
        }),
        hasCredentialToShowPlannedQuantity && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react479.Td, {
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraInput_default, {
            className: "used-materials__table__row__planned-quantity",
            isDisabled: !product,
            type: "number",
            value: plannedQuantity,
            onChange: (e) => setPlannedQuantity(parseQuantity(e)),
            onBlur: () => onChange("plannedQuantity", plannedQuantity),
            borderColor: "gray.200",
            isReadOnly: !hasCredentialToEditPlannedQuantity
          })
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react479.Td, {
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraInput_default, {
            className: "used-materials__table__row__price",
            isDisabled: !product,
            value: price,
            onBlur: () => onChange(),
            onChange: handlePrice,
            borderColor: "gray.200"
          })
        })
      ]
    }) : /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react479.Td, {
          w: "50%",
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react479.Link, {
            className: "used-materials__table__row__product-link-readonly",
            href: product == null ? void 0 : product.link,
            color: "crmBlue",
            isTruncated: true,
            children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react479.Text, {
              isTruncated: true,
              children: `${product == null ? void 0 : product.productName} (${product == null ? void 0 : product.productCode})`
            })
          })
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react479.Td, {
          className: "used-materials__table__row__quantity-readonly",
          children: product == null ? void 0 : product.quantity
        }),
        hasCredentialToShowPlannedQuantity && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react479.Td, {
          className: "used-materials__table__row__quantity-readonly",
          children: product == null ? void 0 : product.plannedQuantity
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react479.Td, {
          className: "used-materials__table__row__price-readonly",
          textAlign: "right",
          children: priceFormatter(price, "none", { formatToParts: true }, 2)
        })
      ]
    })
  });
};
var preparePriceValueForField = (value) => {
  if (!value)
    return;
  return auraParseDisplayValue(auraParseFloat(value).toFixed(2));
};
var parseQuantity = (e) => {
  var _a2;
  return parseFloat(((_a2 = e == null ? void 0 : e.target) == null ? void 0 : _a2.value) ?? "0");
};
var TdExtended_default = TdExtended;

// src/components/UsedMaterials/Modal/ModalUsedMaterials.tsx
var import_react482 = require("@chakra-ui/react");
var import_react483 = require("react");
var import_isEmpty16 = __toESM(require("lodash/isEmpty"));
var import_jsx_runtime = require("react/jsx-runtime");
var getProduct = async ({
  id,
  companyId
}) => {
  var _a2;
  const product = await api_default.getAutoselect("products", {
    params: {
      fields: "id,name,code",
      extra_fields: "prices",
      "setting[with_relations]": true,
      ...companyId && { "for[company.id]": companyId },
      ...id && { "filter[id][eq]": id }
    }
  });
  return (_a2 = product == null ? void 0 : product.data) == null ? void 0 : _a2[0];
};
var ModalUsedMaterials = ({
  isOpen,
  onClose,
  editedProduct: product,
  companyId,
  handleAdd,
  handleOnChange,
  handleDelete,
  meta,
  errors
}) => {
  var _a2, _b, _c, _d, _e, _f;
  const [isDeleting, setIsDeleting] = (0, import_react483.useState)(false);
  const [isSaving, setIsSaving] = (0, import_react483.useState)(false);
  const { t } = useAuraTranslation_default();
  const [quantity, setQuantity] = (0, import_react483.useState)();
  const [plannedQuantity, setPlannedQuantity] = (0, import_react483.useState)();
  const hasCredentialToShowPlannedQuantity = ((_b = (_a2 = meta == null ? void 0 : meta.fields) == null ? void 0 : _a2.plannedQuantity) == null ? void 0 : _b.credential) > 0;
  const hasCredentialToEditPlannedQuantity = ((_d = (_c = meta == null ? void 0 : meta.fields) == null ? void 0 : _c.plannedQuantity) == null ? void 0 : _d.credential) > 1;
  const isEnabledValidateQuantityPosition = (_f = (_e = useSettings_default()) == null ? void 0 : _e.settings) == null ? void 0 : _f.validateStorehouseContentForCommissionPosition;
  const handleQuantity = (e) => {
    const newValue = parseFloat(e.target.value) ?? null;
    setQuantity(newValue);
  };
  const handlePlannedQuantity = (e) => {
    const newValue = parseFloat(e.target.value) ?? null;
    setPlannedQuantity(newValue);
  };
  const [price, setPrice] = (0, import_react483.useState)();
  const handlePrice = (e) => {
    const newValue = e.target.value.replace(/[^\d.\,]/g, "");
    setPrice(newValue);
  };
  const [selectedProduct, setSelectedProduct] = (0, import_react483.useState)();
  const isSm = (0, import_react482.useBreakpointValue)({
    base: true,
    md: false
  });
  const mobileStyle = {
    height: "100%",
    mt: 0,
    borderRadius: 0
  };
  const handleProductChange = async (productId) => {
    var _a3;
    const fetchedProduct = await getProduct({ id: productId, companyId });
    setSelectedProduct(fetchedProduct);
    if (isEnabledValidateQuantityPosition) {
      setQuantity(0);
      setPlannedQuantity(1);
    } else {
      setQuantity(1);
      setPlannedQuantity(1);
    }
    const companyPrice = getUserPrice(fetchedProduct == null ? void 0 : fetchedProduct.prices);
    const preparedPrice = auraParseDisplayValue(
      (_a3 = companyPrice == null ? void 0 : companyPrice.priceNetto) == null ? void 0 : _a3.toFixed(2)
    );
    setPrice(preparedPrice);
  };
  const onSave = async () => {
    var _a3;
    if (!(selectedProduct == null ? void 0 : selectedProduct.id))
      return;
    const res = await handleOnChange({
      id: product == null ? void 0 : product.id,
      quantity,
      price,
      ...hasCredentialToEditPlannedQuantity ? { plannedQuantity } : {},
      ...(selectedProduct == null ? void 0 : selectedProduct.id) ? { changedProductId: selectedProduct.id } : null
    });
    if ((res == null ? void 0 : res.data) && (0, import_isEmpty16.default)((_a3 = res == null ? void 0 : res.data) == null ? void 0 : _a3.errors)) {
      onClose();
    }
  };
  const onAdd = async () => {
    var _a3;
    if (!(selectedProduct == null ? void 0 : selectedProduct.id))
      return;
    setIsSaving(true);
    const res = await handleAdd(
      selectedProduct.id,
      price,
      quantity,
      plannedQuantity
    );
    if ((res == null ? void 0 : res.data) && (0, import_isEmpty16.default)((_a3 = res == null ? void 0 : res.data) == null ? void 0 : _a3.errors)) {
      onClose();
      setIsSaving(false);
    }
  };
  const onDelete = async () => {
    setIsDeleting(true);
    await handleDelete(product == null ? void 0 : product.id);
    setIsDeleting(false);
  };
  (0, import_react483.useEffect)(() => {
    const preparedPrice = (product == null ? void 0 : product.price) ? auraParseDisplayValue(Number(product == null ? void 0 : product.price).toFixed(2)) : "";
    setPrice(preparedPrice);
    setQuantity((product == null ? void 0 : product.quantity) ?? "");
    setPlannedQuantity((product == null ? void 0 : product.plannedQuantity) ?? "");
    setSelectedProduct(product ?? {});
  }, [product == null ? void 0 : product.quantity, product == null ? void 0 : product.plannedQuantity, isOpen]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(AuraModal, {
    isOpen,
    onClose,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalOverlay, {}),
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(AuraModalContent, {
        ...isSm && mobileStyle,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalHeader, {
            children: t(`${!product ? "Add product" : "USED_MATERIALS_EDIT_PRODUCT"}`)
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalBody, {
            children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react482.VStack, {
              spacing: "16px",
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react482.FormControl, {
                  children: [
                    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react482.FormLabel, {
                      htmlFor: "product-name",
                      children: t("Product name")
                    }),
                    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraSelect_default, {
                      value: {
                        label: getLabelValue(selectedProduct),
                        value: selectedProduct == null ? void 0 : selectedProduct.id
                      },
                      onChange: ({ value }) => handleProductChange(value),
                      isClearable: false,
                      loadDataProps: {
                        endpoint: "products",
                        labelField: "name",
                        autoselect: false,
                        additionalNameAccessor: "code",
                        settings: {
                          "order[_q]": "DESC",
                          "order[name]": "ASC"
                        }
                      },
                      components: {
                        Option: CustomProductOption_default
                      },
                      closeMenuOnSelect: true
                    })
                  ]
                }),
                /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react482.FormControl, {
                  children: [
                    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react482.FormLabel, {
                      htmlFor: "product-used-quantity",
                      children: t("USED_MATERIALS_USED_QUANTITY")
                    }),
                    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraInput_default, {
                      type: "number",
                      value: quantity,
                      onChange: (e) => handleQuantity(e),
                      id: "product-used-quantity",
                      isInvalid: isPositionFieldInvalid(
                        errors,
                        product == null ? void 0 : product.id,
                        "quantity"
                      )
                    })
                  ]
                }),
                hasCredentialToShowPlannedQuantity && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react482.FormControl, {
                  children: [
                    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react482.FormLabel, {
                      htmlFor: "product-planned-quantity",
                      children: t("USED_MATERIALS_PLANNED_QUANTITY")
                    }),
                    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraInput_default, {
                      type: "number",
                      value: plannedQuantity,
                      onChange: (e) => handlePlannedQuantity(e),
                      id: "product-planned-quantity",
                      isReadOnly: !hasCredentialToEditPlannedQuantity
                    })
                  ]
                }),
                /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react482.FormControl, {
                  children: [
                    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react482.FormLabel, {
                      htmlFor: "product-price",
                      children: t("Price netto")
                    }),
                    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraInput_default, {
                      value: price,
                      onChange: (e) => handlePrice(e),
                      onBlur: () => {
                        const preparedPrice = auraParseDisplayValue(
                          auraParseFloat(price).toFixed(2)
                        );
                        setPrice(preparedPrice);
                      },
                      id: "product-price"
                    })
                  ]
                })
              ]
            })
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(AuraModalFooter, {
            showBorders: false,
            children: [
              product && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react482.Button, {
                variant: "ghost",
                onClick: onDelete,
                isLoading: isDeleting,
                isDisabled: isSaving,
                children: t("Delete")
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react482.Button, {
                backgroundColor: "crmBlue",
                color: "#fff",
                ml: 3,
                onClick: () => product ? onSave() : onAdd(),
                isDisabled: isDeleting,
                isLoading: isSaving,
                children: product ? t("TASK_CONFIRM_EDIT") : t("GANTT_CONFIG_ADD")
              })
            ]
          })
        ]
      })
    ]
  });
};
var ModalUsedMaterials_default = ModalUsedMaterials;
var getLabelValue = (selectedProduct) => {
  return `${(selectedProduct == null ? void 0 : selectedProduct.name) ?? (selectedProduct == null ? void 0 : selectedProduct.productName) ?? ""} ${(selectedProduct == null ? void 0 : selectedProduct.code) || (selectedProduct == null ? void 0 : selectedProduct.productCode) ? `(${selectedProduct.code ?? selectedProduct.productCode})` : ""}`;
};

// src/components/UsedMaterials/UsedMaterials.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var UsedMaterials = ({
  usedMaterials,
  companyId,
  handleDelete,
  handleOnChange,
  handleAdd,
  isReadOnly,
  modalDisclousure,
  meta,
  errors
}) => {
  var _a2, _b;
  const { t } = useAuraTranslation_default();
  const isLg = (0, import_react484.useBreakpointValue)({
    base: false,
    lg: true
  });
  const [editedProduct, setEditedProduct] = (0, import_react485.useState)();
  const hasCredentialToShowPlannedQuantity = ((_b = (_a2 = meta == null ? void 0 : meta.fields) == null ? void 0 : _a2.plannedQuantity) == null ? void 0 : _b.credential) > 0;
  const closeModalForm = () => {
    setEditedProduct(null);
    modalDisclousure == null ? void 0 : modalDisclousure.onClose();
  };
  const onDelete = async (id) => {
    await handleDelete(id);
    modalDisclousure.onClose();
  };
  const mobileRow = usedMaterials == null ? void 0 : usedMaterials.map((product, index) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Tr, {
    id: `user-materials-row-${index}`,
    className: "used-materials__table__row-base",
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Td, {
      p: 0,
      maxW: "0px",
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(BoxCollapse, {
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(BoxCollapseItem, {
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(BoxCollapseButton, {
              minH: "56px",
              py: "16px",
              pl: "24px",
              pr: "8px",
              justifyContent: "space-between",
              _expanded: { bg: "gray.50" },
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react486.Link, {
                  color: "crmBlue",
                  target: "_blank",
                  isTruncated: true,
                  mr: "24px",
                  href: product == null ? void 0 : product.link,
                  isExternal: true,
                  children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react486.Text, {
                    letterSpacing: "0.5px",
                    isTruncated: true,
                    children: `${product == null ? void 0 : product.productName} (${product == null ? void 0 : product.productCode})`
                  })
                }),
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react484.AccordionIcon, {})
              ]
            }),
            /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(BoxCollapseContent, {
              px: "24px",
              py: "0",
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react484.Flex, {
                  justifyContent: "space-between",
                  py: "16px",
                  children: [
                    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react486.Text, {
                      fontStyle: "bodyInput",
                      fontWeight: "500",
                      letterSpacing: "0.5px",
                      children: t("USED_MATERIALS_USED_QUANTITY")
                    }),
                    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react486.Text, {
                      fontStyle: "bodyInput",
                      letterSpacing: "0.5px",
                      children: product == null ? void 0 : product.quantity
                    })
                  ]
                }),
                hasCredentialToShowPlannedQuantity && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react484.Flex, {
                  justifyContent: "space-between",
                  py: "16px",
                  children: [
                    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react486.Text, {
                      fontStyle: "bodyInput",
                      fontWeight: "500",
                      letterSpacing: "0.5px",
                      children: t("USED_MATERIALS_PLANNED_QUANTITY")
                    }),
                    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react486.Text, {
                      fontStyle: "bodyInput",
                      letterSpacing: "0.5px",
                      children: product == null ? void 0 : product.plannedQuantity
                    })
                  ]
                }),
                /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react484.Flex, {
                  justifyContent: "space-between",
                  py: "16px",
                  children: [
                    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react486.Text, {
                      fontStyle: "bodyInput",
                      fontWeight: "500",
                      letterSpacing: "0.5px",
                      children: t("Price netto")
                    }),
                    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react486.Text, {
                      fontStyle: "bodyInput",
                      letterSpacing: "0.5px",
                      children: priceFormatter(
                        product == null ? void 0 : product.price,
                        "none",
                        { formatToParts: true },
                        2
                      )
                    })
                  ]
                }),
                /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react484.Flex, {
                  gap: "8px",
                  py: "8px",
                  justifyContent: "flex-end",
                  children: [
                    !isReadOnly && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react484.IconButton, {
                      w: "40px",
                      h: "40px",
                      "aria-label": "Edit",
                      icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react487.Icon, {
                        path: import_js69.mdiPencilOutline,
                        size: "20px"
                      }),
                      onClick: () => {
                        setEditedProduct(product);
                        modalDisclousure == null ? void 0 : modalDisclousure.onOpen();
                      },
                      "data-testid": "btn-edit"
                    }),
                    !isReadOnly && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react484.IconButton, {
                      w: "40px",
                      h: "40px",
                      "aria-label": "Delete",
                      icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react487.Icon, {
                        path: import_js69.mdiTrashCanOutline,
                        size: "20px"
                      }),
                      onClick: () => handleDelete(product == null ? void 0 : product.id),
                      "data-testid": "btn-delete"
                    })
                  ]
                })
              ]
            })
          ]
        })
      })
    })
  }, index));
  const baseRow = usedMaterials == null ? void 0 : usedMaterials.map((product, index) => {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Tr, {
      id: `user-materials-row-${index}`,
      className: "used-materials__table__row-extended",
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TdExtended_default, {
        handleOnChange,
        handleDelete,
        product,
        isReadOnly,
        meta,
        errors
      })
    }, index);
  });
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, {
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react484.Box, {
      className: "used-materials",
      children: [
        (usedMaterials == null ? void 0 : usedMaterials.length) || isLg && (isReadOnly && (usedMaterials == null ? void 0 : usedMaterials.length) || !isReadOnly) ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react486.TableContainer, {
          border: "1px solid",
          borderColor: "gray.200",
          borderRadius: "6px",
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react486.Table, {
            className: "used-materials__table",
            children: [
              (usedMaterials == null ? void 0 : usedMaterials.length) ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react486.Thead, {
                backgroundColor: "gray.100",
                children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Tr, {
                  children: [
                    !isLg ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Th, {
                      children: t("Product name")
                    }) : null,
                    isLg && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
                      children: [
                        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Th, {
                          children: t("Product name")
                        }),
                        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Th, {
                          children: t("USED_MATERIALS_USED_QUANTITY")
                        }),
                        hasCredentialToShowPlannedQuantity && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Th, {
                          children: t("USED_MATERIALS_PLANNED_QUANTITY")
                        }),
                        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Th, {
                          textAlign: isReadOnly ? "right" : "left",
                          children: t("Price netto")
                        })
                      ]
                    })
                  ]
                })
              }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, {}),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react486.Tbody, {
                children: isLg ? /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
                  children: [
                    baseRow,
                    !isReadOnly && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Tr, {
                      id: `user-materials-row-new`,
                      className: "used-materials__table__add-new",
                      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TdExtended_default, {
                        product: null,
                        handleOnChange,
                        handleAdd,
                        meta
                      })
                    })
                  ]
                }) : mobileRow
              })
            ]
          })
        }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, {}),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ModalUsedMaterials_default, {
          isOpen: modalDisclousure == null ? void 0 : modalDisclousure.isOpen,
          onClose: closeModalForm,
          editedProduct,
          companyId,
          handleAdd,
          handleOnChange,
          handleDelete: onDelete,
          meta,
          errors
        })
      ]
    })
  });
};
var UsedMaterials_default = UsedMaterials;

// src/components/UserAvatarManage/UserAvatarManage.tsx
var import_react491 = require("@chakra-ui/react");
var import_js71 = require("@mdi/js");
var import_react492 = __toESM(require("@mdi/react"));

// src/components/UserAvatarManage/ModalAvatar/ModalAvatar.tsx
var import_react488 = require("@chakra-ui/react");
var import_js70 = require("@mdi/js");
var import_react489 = __toESM(require("@mdi/react"));
var import_react490 = require("react");
var import_react_easy_crop = __toESM(require("react-easy-crop"));

// src/hooks/useFileAvatarUpload.ts
var import_react_query63 = require("react-query");
var fileUpload2 = async (formData) => {
  return api_default.uploadFile(formData, {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });
};
var handleFileUploadSequential2 = async ({
  data,
  filename
}) => {
  if (!data) {
    return;
  }
  const file = DataURIToBlob(data);
  const formData = new FormData();
  formData.append(`data_files[0]`, file, filename);
  return fileUpload2(formData);
};
function DataURIToBlob(dataURI) {
  const splitDataURI = dataURI.split(",");
  const byteString = splitDataURI[0].indexOf("base64") >= 0 ? atob(splitDataURI[1]) : decodeURI(splitDataURI[1]);
  const mimeString = splitDataURI[0].split(":")[1].split(";")[0];
  const ia = new Uint8Array(byteString.length);
  for (let i = 0; i < byteString.length; i++)
    ia[i] = byteString.charCodeAt(i);
  return new Blob([ia], { type: mimeString });
}
var useFileAvatarUpload = ({ onUpdate }) => {
  return (0, import_react_query63.useMutation)(handleFileUploadSequential2, {
    onSuccess: async (response) => {
      var _a2;
      onUpdate((_a2 = response == null ? void 0 : response.data) == null ? void 0 : _a2[0].dbName, "avatar");
    }
  });
};

// src/components/UserAvatarManage/ModalAvatar/ModalAvatar.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var createImage = (url) => new Promise((resolve, reject) => {
  const image = new Image();
  image.addEventListener("load", () => resolve(image));
  image.addEventListener("error", (error) => reject(error));
  image.src = url;
});
async function getCroppedImg(imageSrc, pixelCrop) {
  const image = await createImage(imageSrc);
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");
  if (!ctx) {
    return null;
  }
  canvas.width = image.width;
  canvas.height = image.height;
  ctx.drawImage(image, 0, 0);
  const croppedCanvas = document.createElement("canvas");
  const croppedCtx = croppedCanvas.getContext("2d");
  if (!croppedCtx) {
    return null;
  }
  croppedCanvas.width = pixelCrop.width;
  croppedCanvas.height = pixelCrop.height;
  croppedCtx.drawImage(
    canvas,
    pixelCrop.x,
    pixelCrop.y,
    pixelCrop.width,
    pixelCrop.height,
    0,
    0,
    pixelCrop.width,
    pixelCrop.height
  );
  return croppedCanvas.toDataURL("image/png");
}
var readFile = (file) => {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.addEventListener("load", () => resolve(reader.result), false);
    reader.readAsDataURL(file);
  });
};
var ModalAvatar = ({
  isOpen,
  onClose,
  userAvatar,
  userId,
  fullName,
  defaultCallendarColor,
  onUpdate,
  classNamePrefix
}) => {
  const { t } = useAuraTranslation_default();
  const [imageUrl, setImageUrl] = (0, import_react490.useState)(
    getImageUrl(userAvatar, "big") ?? ""
  );
  const [crop, setCrop] = (0, import_react490.useState)({ x: 0, y: 0 });
  const [zoom, setZoom] = (0, import_react490.useState)(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = (0, import_react490.useState)(null);
  (0, import_react490.useEffect)(() => {
    isOpen && setImageUrl(getImageUrl(userAvatar, "big") ?? "");
  }, [isOpen]);
  const onCropComplete = (croppedArea, croppedAreaPixels2) => {
    setCroppedAreaPixels(croppedAreaPixels2);
  };
  const setNewAvatar = async () => {
    try {
      const croppedImage = await getCroppedImg(
        imageUrl,
        croppedAreaPixels
      );
      mutate({ data: croppedImage, filename: `avatar-user-${userId}` });
    } catch (e) {
      console.error(e);
    }
    onClose();
  };
  const onFileChange = async (e) => {
    var _a2, _b;
    if (((_b = (_a2 = e.target) == null ? void 0 : _a2.files) == null ? void 0 : _b.length) > 0) {
      const file = e.target.files[0];
      let imageDataUrl = await readFile(file);
      setImageUrl(imageDataUrl);
    }
  };
  const { mutate, isLoading } = useFileAvatarUpload({ onUpdate });
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(AuraModal, {
    isOpen,
    onClose,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalOverlay, {}),
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(AuraModalContent, {
        className: `${classNamePrefix}__modal-avatar`,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalHeader, {
            border: "none",
            children: t("EDIT_AVATAR")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalBody, {
            children: imageUrl ? /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react488.Center, {
                  position: "relative",
                  h: "400px",
                  children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_easy_crop.default, {
                    cropShape: "round",
                    showGrid: false,
                    image: imageUrl,
                    crop,
                    zoom,
                    aspect: 1,
                    onCropChange: setCrop,
                    onCropComplete,
                    onZoomChange: setZoom
                  })
                }),
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react488.Center, {
                  children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react488.Slider, {
                    mt: "52px",
                    w: "272px",
                    "aria-label": "zoom",
                    defaultValue: 1,
                    min: 1,
                    max: 3,
                    step: 0.1,
                    value: zoom,
                    onChange: (val) => setZoom(val),
                    children: [
                      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react488.SliderTrack, {
                        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react488.SliderFilledTrack, {})
                      }),
                      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react488.SliderThumb, {
                        boxSize: "24px"
                      })
                    ]
                  })
                })
              ]
            }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react488.Center, {
              h: "272px",
              children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react488.Avatar, {
                size: "2xl",
                src: getImageUrl(userAvatar, "big") ?? "",
                name: fullName,
                ...defaultCallendarColor && {
                  bg: defaultCallendarColor
                }
              })
            })
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(AuraModalFooter, {
            border: "none",
            justifyContent: "space-between",
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react488.IconButton, {
                "aria-label": "add file",
                colorScheme: "gray",
                icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react489.default, {
                  path: import_js70.mdiFileImagePlusOutline,
                  size: "24px"
                }),
                as: import_react488.FormLabel,
                htmlFor: "avatar-file-input"
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react488.Input, {
                id: "avatar-file-input",
                type: "file",
                accept: "image/*",
                hidden: true,
                onChange: onFileChange
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react488.ButtonGroup, {
                children: [
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react488.Button, {
                    size: "md",
                    onClick: () => window.confirm(t("MODAL_CLOSE_QUESTION")) && onClose(),
                    children: t("CANCEL")
                  }),
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react488.Button, {
                    colorScheme: "blue",
                    color: "#fff",
                    onClick: setNewAvatar,
                    isLoading,
                    textTransform: "capitalize",
                    children: t("SAVE")
                  })
                ]
              })
            ]
          })
        ]
      })
    ]
  });
};
var ModalAvatar_default = ModalAvatar;

// src/components/UserAvatarManage/UserAvatarManage.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var UserAvatarManage = ({
  userId,
  userAvatar,
  fullName,
  defaultCallendarColor,
  onUpdate,
  className,
  isReadOnly
}) => {
  const { t } = useAuraTranslation_default();
  const { onOpen, onClose, isOpen } = (0, import_react491.useDisclosure)();
  const handleDeleteAvatar = () => {
    onUpdate(null, "avatar");
  };
  const options = [
    {
      icon: import_js71.mdiPencilOutline,
      label: t("Edit"),
      onClick: onOpen
    },
    {
      icon: import_js71.mdiTrashCanOutline,
      label: t("Delete"),
      onClick: handleDeleteAvatar
    }
  ];
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react491.Center, {
        className,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react491.Avatar, {
            size: "xl",
            sx: { ".chakra-avatar__badge": { border: "none" } },
            src: getImageUrl(userAvatar, "big") ?? "",
            name: fullName,
            ...defaultCallendarColor && {
              bg: defaultCallendarColor
            }
          }),
          !isReadOnly && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react491.Box, {
            m: "0",
            ml: "-28px",
            mb: "-62px",
            children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraDropdownMenu_default, {
              menuItems: options,
              children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react491.MenuButton, {
                as: import_react491.IconButton,
                m: "8px",
                "aria-label": "Edit avatar",
                size: "sm",
                colorScheme: "blue",
                variant: "ghost",
                icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react492.default, {
                  path: import_js71.mdiPencilCircle,
                  size: "32px"
                }),
                _hover: { bg: "blue.50" },
                sx: { borderRadius: "32px" }
              })
            })
          })
        ]
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ModalAvatar_default, {
        isOpen,
        onClose,
        userId,
        userAvatar,
        fullName,
        defaultCallendarColor,
        onUpdate,
        classNamePrefix: className
      })
    ]
  });
};
var UserAvatarManage_default = UserAvatarManage;

// src/components/Widget/Widget.tsx
var import_react493 = require("@chakra-ui/react");
var import_react494 = require("@emotion/react");
var import_jsx_runtime = require("react/jsx-runtime");
var Widget = ({ widgetUUID, children }) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react493.Box, {
    className: "widget__container",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react494.Global, {
        styles: import_react494.css`
          /* Ukrycie starych panelu kontrolek */
          .widgetElementOptions[uid="${widgetUUID}"] {
            display: none !important;
          }
        `
      }),
      children
    ]
  });
};
var Widget_default = Widget;

// src/components/Widget/WidgetBody/WidgetBody.tsx
var import_react495 = require("@chakra-ui/react");
var import_jsx_runtime = require("react/jsx-runtime");
var WidgetBody = ({
  isOpen = true,
  children,
  ...props
}) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react495.Box, {
    className: "widget__body",
    mt: 4,
    ...props,
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react495.Collapse, {
      in: isOpen,
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react495.Box, {
        children
      })
    })
  });
};
var WidgetBody_default = WidgetBody;

// src/components/Widget/WidgetControls/WidgetControls.tsx
var import_react496 = require("@chakra-ui/react");
var import_js72 = require("@mdi/js");
var import_react497 = __toESM(require("@mdi/react"));
var import_react_query64 = require("react-query");
var import_jsx_runtime = require("react/jsx-runtime");
var WidgetControls = ({
  isLoading,
  isOpen,
  onOpenSettings,
  onRefresh,
  onToggleOpen
}) => {
  const { data: isWidgetEditableCredential, isFetched } = (0, import_react_query64.useQuery)(
    ["meta", "user_settings"],
    () => api_default.getMeta("user_settings"),
    {
      refetchOnWindowFocus: false,
      enabled: true,
      select: (data) => {
        var _a2, _b;
        return !!((_b = (_a2 = data == null ? void 0 : data.data) == null ? void 0 : _a2.actions) == null ? void 0 : _b.config_desktop_widget);
      }
    }
  );
  if (!isFetched) {
    return null;
  }
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react496.ButtonGroup, {
    className: "widget__controls",
    spacing: 2,
    variant: "ghost",
    children: [
      onRefresh ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react496.IconButton, {
        className: "widget__controls__refresh",
        isLoading,
        "aria-label": "refresh",
        icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react497.default, {
          path: import_js72.mdiRefresh,
          size: "24px"
        }),
        onClick: onRefresh
      }) : null,
      isWidgetEditableCredential && onOpenSettings ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react496.IconButton, {
        className: "widget__controls__settings",
        "aria-label": "settings",
        icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react497.default, {
          path: import_js72.mdiCogOutline,
          size: "24px"
        }),
        onClick: onOpenSettings
      }) : null,
      onToggleOpen ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react496.IconButton, {
        className: "widget__controls__minimize",
        "aria-label": "minimize",
        icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react497.default, {
          path: isOpen ? import_js72.mdiChevronUp : import_js72.mdiChevronDown,
          size: "24px"
        }),
        onClick: onToggleOpen
      }) : null
    ]
  });
};
var WidgetControls_default = WidgetControls;

// src/components/Widget/WidgetHeader/WidgetHeader.tsx
var import_react498 = require("@chakra-ui/react");
var import_jsx_runtime = require("react/jsx-runtime");
var WidgetHeader = ({ children, ...props }) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react498.Flex, {
    className: "widget__header",
    justifyContent: "space-between",
    alignItems: "center",
    ...props,
    children
  });
};
var WidgetHeader_default = WidgetHeader;

// src/components/Widget/WidgetName/WidgetName.tsx
var import_react499 = require("@chakra-ui/react");
var import_jsx_runtime = require("react/jsx-runtime");
var WidgetName = ({ children, ...props }) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react499.Heading, {
    className: "widget__name",
    as: "h5",
    fontSize: "lg",
    fontWeight: 500,
    ...props,
    children
  });
};
var WidgetName_default = WidgetName;

// src/components/Widget/WidgetSettingsModal/WidgetSettingsModal.tsx
var import_react500 = require("@chakra-ui/react");
var import_jsx_runtime = require("react/jsx-runtime");
var WidgetSettingsModal = ({
  onClose,
  onRemove,
  initialFocusRef,
  children,
  ...props
}) => {
  const { t } = useAuraTranslation_default();
  const handleSave = () => {
    onClose();
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(AuraModal, {
    initialFocusRef,
    closeOnOverlayClick: false,
    onClose,
    scrollBehavior: "inside",
    ...props,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalOverlay, {}),
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(AuraModalContent, {
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalHeader, {
            className: "widget__settings-modal__header",
            children: t("WIDGET_SETTINGS")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuraModalBody, {
            className: "widget__settings-modal__body",
            children
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(AuraModalFooter, {
            className: "widget__settings-modal__footer",
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react500.Button, {
                variant: "ghost",
                onClick: onRemove,
                children: t("WIDGET_SETTINGS_DELETE")
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react500.Button, {
                type: "submit",
                colorScheme: "blue",
                form: "widget-config",
                onClick: handleSave,
                children: t("WIDGET_SETTINGS_SAVE")
              })
            ]
          })
        ]
      })
    ]
  });
};
var WidgetSettingsModal_default = WidgetSettingsModal;

// src/components/ChangeHistoryTable/ChangeHistoryTable.tsx
var import_react501 = require("@chakra-ui/react");
var import_jsx_runtime = require("react/jsx-runtime");
var FIELD_TYPE_BADGE = {
  [1 /* standard */]: {
    labelKey: "FIELD",
    bg: "blue.100",
    color: "blue.700"
  },
  [2 /* attribute */]: {
    labelKey: "ATTRIBUTE",
    bg: "purple.100",
    color: "purple.700"
  },
  [3 /* positionField */]: {
    labelKey: "POSITION_FIELD",
    bg: "teal.100",
    color: "teal.700"
  },
  [4 /* positionAttribute */]: {
    labelKey: "POSITION_ATTRIBUTE",
    bg: "orange.100",
    color: "orange.700"
  }
};
var ChangeHistoryTable = ({
  items,
  title,
  subtitle,
  parentId,
  module: module2,
  relationResolvers,
  ...boxProps
}) => {
  const { t, tCustom } = useAuraTranslation_default();
  const preparedTitle = (title == null ? void 0 : title.length) ? title : t("CHANGELOG");
  const thProps = {
    textStyle: "buttonSmall",
    fontSize: "sm",
    px: "24px",
    py: "12px"
  };
  const tdProps = { px: "24px", py: "16px", lineHeight: "20px" };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(ContentBox_default, {
    className: "change-history-table",
    ...boxProps,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CardHeader, {
        title: preparedTitle,
        subtitle,
        parentId,
        module: module2
      }),
      !(items == null ? void 0 : items.length) ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(EmptyState_default, {
        py: 20
      }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TableContainer, {
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Table, {
          colorScheme: "gray",
          w: "100%",
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Thead, {
              children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Tr, {
                children: [
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Th, {
                    ...thProps,
                    minW: "140px",
                    children: t("CHANGE_HISTORY_FIELD_NAME")
                  }),
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Th, {
                    ...thProps,
                    minW: "120px",
                    children: t("CHANGE_HISTORY_FIELD_TYPE")
                  }),
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Th, {
                    ...thProps,
                    minW: "200px",
                    children: t("CHANGE_HISTORY_PREVIOUS_VALUE")
                  }),
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Th, {
                    ...thProps,
                    minW: "200px",
                    children: t("CHANGE_HISTORY_NEW_VALUE")
                  }),
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Th, {
                    ...thProps,
                    minW: "130px",
                    whiteSpace: "nowrap",
                    children: t("CHANGE_HISTORY_DATE")
                  }),
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Th, {
                    ...thProps,
                    minW: "130px",
                    whiteSpace: "nowrap",
                    children: t("CHANGE_HISTORY_MODIFIED_BY")
                  })
                ]
              })
            }),
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Tbody, {
              children: items == null ? void 0 : items.map((item) => /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Tr, {
                className: "change-history-table__row",
                children: [
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Td, {
                    ...tdProps,
                    className: "change-history-table__row__cell-field-name",
                    whiteSpace: "normal",
                    wordBreak: "break-word",
                    children: item.attribute ? tCustom(item.fieldName) : t(item.fieldName)
                  }),
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Td, {
                    ...tdProps,
                    className: "change-history-table__row__cell-field-type",
                    children: (() => {
                      const badge = FIELD_TYPE_BADGE[item.fieldType] ?? FIELD_TYPE_BADGE[1 /* standard */];
                      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react501.Box, {
                        as: "span",
                        display: "inline-block",
                        px: 2,
                        py: 0.5,
                        borderRadius: "md",
                        fontSize: "xs",
                        fontWeight: "500",
                        bg: badge.bg,
                        color: badge.color,
                        children: t(badge.labelKey)
                      });
                    })()
                  }),
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Td, {
                    ...tdProps,
                    className: "change-history-table__row__cell-old-value",
                    color: item.oldValue ? "gray.700" : "gray.400",
                    whiteSpace: "normal",
                    wordBreak: "break-word",
                    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ValueCell, {
                      value: item.oldValue,
                      attribute: item.attribute,
                      resolver: item.fieldRelation ? relationResolvers == null ? void 0 : relationResolvers[item.fieldRelation] : void 0,
                      t,
                      tCustom
                    })
                  }),
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Td, {
                    ...tdProps,
                    className: "change-history-table__row__cell-new-value",
                    whiteSpace: "normal",
                    wordBreak: "break-word",
                    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ValueCell, {
                      value: item.newValue,
                      attribute: item.attribute,
                      resolver: item.fieldRelation ? relationResolvers == null ? void 0 : relationResolvers[item.fieldRelation] : void 0,
                      t,
                      tCustom
                    })
                  }),
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Td, {
                    ...tdProps,
                    className: "change-history-table__row__cell-date",
                    whiteSpace: "nowrap",
                    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(DateTag_default, {
                      fontSize: 15,
                      value: item.modificationDate
                    })
                  }),
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Td, {
                    ...tdProps,
                    className: "change-history-table__row__cell-modified-by",
                    whiteSpace: "normal",
                    wordBreak: "break-word",
                    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ModifiedByCell, {
                      userUser: item.userUser,
                      accountUser: item.accountUser
                    })
                  })
                ]
              }, item.id))
            })
          ]
        })
      })
    ]
  });
};
var ValueCell = ({
  value,
  attribute,
  resolver,
  t,
  tCustom
}) => {
  if (["bool", "boolean"].includes(attribute == null ? void 0 : attribute.type)) {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react501.Checkbox, {
      isChecked: value === "1",
      isReadOnly: true,
      pointerEvents: "none",
      colorScheme: "blue",
      size: "md"
    });
  }
  if (["date", "datetime"].includes(attribute == null ? void 0 : attribute.type)) {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(DateTag_default, {
      value: value ?? "",
      withTime: (attribute == null ? void 0 : attribute.type) === "datetime"
    });
  }
  if (["list", "listMulti", "file"].includes(attribute == null ? void 0 : attribute.type)) {
    const tags = value ? value.split(", ").filter(Boolean) : [];
    tags.forEach((tag, index) => tags[index] = tCustom(tag));
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TagList, {
      items: tags
    });
  }
  if (resolver !== null && resolver !== void 0) {
    const resolved = resolveValue(value, resolver);
    const label = attribute ? tCustom(resolved) : t(resolved);
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TagList, {
      items: label != null ? [label] : []
    });
  }
  const returnResolvedValue = attribute ? tCustom(resolveValue(value, resolver)) : t(resolveValue(value, resolver));
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, {
    children: (returnResolvedValue == null ? void 0 : returnResolvedValue.length) ? returnResolvedValue : "\u2014"
  });
};
var ModifiedByCell = ({ userUser, accountUser }) => {
  if (userUser) {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(UserLink, {
      user: userUser,
      href: `/userUser/show/userid/${userUser.id}`
    });
  }
  if (accountUser) {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(UserLink, {
      user: accountUser,
      href: `/accountUser/show/user_id/${accountUser.id}`
    });
  }
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react501.Box, {
    as: "span",
    color: "gray.400",
    children: "\u2014"
  });
};
var TagList = ({ items }) => {
  if (items.length === 0) {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react501.Box, {
      as: "span",
      color: "gray.400",
      children: "\u2014"
    });
  }
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react501.Box, {
    display: "flex",
    flexWrap: "wrap",
    gap: 1,
    children: items.map((label, i) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(SmallTag_default, {
      children: label
    }, i))
  });
};
var CardHeader = ({
  title,
  subtitle,
  parentId,
  module: module2
}) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react501.Box, {
  className: "change-history-table__header",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  mb: 4,
  children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react501.Box, {
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react501.Box, {
        as: "h2",
        className: "change-history-table__header-title",
        fontWeight: "600",
        fontSize: "xl",
        lineHeight: "1.2",
        m: 0,
        children: title
      }),
      subtitle && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react501.Box, {
        className: "change-history-table__header-subtitle",
        color: "gray.600",
        fontSize: "sm",
        mt: 1,
        children: module2 && parentId ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react501.Box, {
          as: "a",
          href: getModuleHref(module2, parentId),
          target: "_blank",
          color: "crmBlue",
          _hover: { textDecoration: "underline" },
          children: subtitle
        }) : subtitle
      })
    ]
  })
});
var UserLink = ({
  user,
  href
}) => /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react501.Box, {
  as: "a",
  href,
  display: "inline-flex",
  alignItems: "center",
  gap: 2,
  color: "blue.500",
  _hover: { textDecoration: "underline" },
  children: [
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react501.Avatar, {
      className: "change-history-table__row__cell-avatar",
      size: "xs",
      name: user.fullName,
      src: (user == null ? void 0 : user.avatar) ? getImageUrl(user == null ? void 0 : user.avatar, "thmb") : void 0,
      ...(user == null ? void 0 : user.defaultCallendarColor) && { bg: user == null ? void 0 : user.defaultCallendarColor },
      "aria-hidden": true
    }),
    user.fullName
  ]
});
var resolveValue = (value, resolver) => {
  var _a2, _b;
  if (value === null || value === void 0 || resolver === null || resolver === void 0)
    return value;
  if (typeof resolver === "function") {
    return ((_a2 = resolver(value)) == null ? void 0 : _a2.label) ?? value;
  }
  return ((_b = resolver[value]) == null ? void 0 : _b.label) ?? value;
};
var ChangeHistoryTable_default = ChangeHistoryTable;
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  ABSENCE_APPLICATION_TYPES,
  ABSENCE_STATUSES,
  ACCOUNT_COMPANY_CREATION_TYPE,
  ACCOUNT_COMPANY_VAT_HANDLING,
  AccountUserFilter,
  ActionBadge,
  ActiveFilterDisplay,
  ActiveFilters,
  Address,
  AttributeBoolean,
  AttributeChat,
  AttributeChecklist,
  AttributeChecklistField,
  AttributeDate,
  AttributeDateField,
  AttributeFile,
  AttributeFileItem,
  AttributeHtml,
  AttributeLabel,
  AttributeList,
  AttributeListMulti,
  AttributeNumber,
  AttributeText,
  Attributes,
  AuraCustomTranslation,
  AuraDatePicker,
  AuraDrawer,
  AuraDrawerBody,
  AuraDrawerCloseButton,
  AuraDrawerContent,
  AuraDrawerFooter,
  AuraDrawerHeader,
  AuraDrawerOverlay,
  AuraDropdownMenu,
  AuraErrorResolverException,
  AuraFormLabel,
  AuraInput,
  AuraInputCompact,
  AuraMenuItem,
  AuraModal,
  AuraModalBody,
  AuraModalCloseButton,
  AuraModalContent,
  AuraModalFooter,
  AuraModalHeader,
  AuraModalOverlay,
  AuraSelect,
  AuraSpinner,
  AuraTabs,
  AuraTextarea,
  AuraTranslation,
  AuthContext,
  AuthContextProvider,
  AvailabilityFilter,
  BackwardNavigation,
  BasketContext,
  BasketContextProvider,
  BlockedDisabledInfo,
  BooleanCell,
  BooleanFilter,
  BoxCollapse,
  BoxCollapseButton,
  BoxCollapseContent,
  BoxCollapseItem,
  BoxCollapseItemCompact,
  BoxIcon,
  Breadcrumbs,
  ButtonAction,
  ButtonFavorite,
  ButtonManage2FA,
  CAMPAIGN_OPPORTUNITY_STATUSES,
  CAMPAIGN_STATUSES,
  CHANGELOG_FIELD_TYPES,
  COMMISSION_SCOPE_TYPES,
  COMMISSION_SCOPE_TYPE_LABELS,
  COPY_PRODUCTS_STORAGE_KEY,
  CSSReset,
  CURRENCY_CHANGE_CONFIRM_DIALOG_TYPES,
  CellWrapper,
  ChangeHistoryTable,
  ColorPicker,
  CommunicatorThreads,
  ConnectedCampaignOpportunity,
  ConnectedDocument,
  ConnectedProcess,
  ConnectedProcessPopover,
  ConnectedProcessesPopover,
  ConnectedServicedProduct,
  ConnectedTaskAndEvent,
  ContentBox,
  CookieNotice,
  CountBadge,
  CountryFilter,
  CreatorUserCell,
  CredentialsCompact,
  CustomCSSReset,
  CustomMultiValueContainer,
  CustomMultiValueRemove,
  CustomProductOption,
  CustomScripts,
  CustomSelectOption,
  CustomizeColumns,
  CustomizeColumnsModal,
  CustomizerContext,
  CustomizerContextProvider,
  CustomizerInit,
  DATETIME_FORMAT_DOTS,
  DATE_DAY_MONTH_FORMAT,
  DATE_FORMAT_DOTS,
  DEFAULT_LIMIT_AVAILABLE_PRODUCTS,
  DISCOUNT_APPLY_ON,
  DISCOUNT_CODES_SCOPES,
  DISCOUNT_CODES_TYPES,
  DISCOUNT_SCOPES,
  DOCUMENT_INVOICE_TYPES,
  DOCUMENT_POSITION_TYPES,
  DOCUMENT_TYPES,
  DURATION_ERROR_VISIBLE,
  DataSelector,
  DataSelectorFilter,
  DateInput,
  DateTag,
  DateraContext,
  DateraProvider,
  DatetimeFilter,
  DefaultEventDates,
  DiscountApplyOnTypes,
  DiscountCodeScopeTypes,
  DiscountScopeTypes,
  DocumentPositionTile,
  DocumentSummary,
  DocumentSummaryVerticalTable,
  EmptyFilters,
  EmptyList,
  EmptyState,
  ExternalMarkerContainer,
  ExternalMarkerFilter,
  ExternalMarkerLabel,
  ExternalMarkersContext,
  ExternalMarkersProvider,
  FileDetails,
  FilePreview,
  FilterFormLabel,
  FilterInputSeparator,
  FilterName,
  FilterTextInput,
  FiltersDisplayItem,
  GalleryItem,
  HOUR_MINUTE_FORMAT,
  Header,
  InBasketInfo,
  InBasketText,
  Information,
  KSEF_STATUSES,
  LANGUAGES,
  LOCAL_STORAGE_MESSAGES_LAST_FETCH,
  LanguageContext,
  LanguageProvider,
  LinkContext,
  LinkContextProvider,
  Linkify,
  List,
  ListFilter,
  ListFilters,
  ListFiltersContext,
  ListFiltersContextProvider,
  LoadingModal,
  LoadingOverlay,
  MESSAGE_FETCH_INTERVAL,
  MODULE_MAP,
  MainHeader,
  MessageBreadcrumbs,
  MessageItem,
  MessagesContext,
  MessagesContextProvider,
  Modal,
  ModalAbsence,
  ModalAbsenceLimit,
  ModalAccountUser,
  ModalAdditionalI18n,
  ModalAddress,
  ModalCampaignOpportunity,
  ModalCommission,
  ModalCompany,
  ModalDiscount,
  ModalDiscountCode,
  ModalHoliday,
  ModalMassDiscount,
  ModalMessageThread,
  ModalPriceIndividual,
  ModalSelectTemplate,
  ModalServicedProduct,
  ModalVisibilityProvider,
  ModuleLink,
  MoreIconButton,
  MultiFilter,
  NIP_BLOCKING_MODE,
  NameDisplay,
  NotificationBar,
  NumberBox,
  NumericFilter,
  ObjectsPerPageSelect,
  Pagination,
  PanelHeading,
  PerPage,
  PersonInfo,
  PersonItem,
  PersonList,
  PriceDisplay,
  PriceWithCurrency,
  ProductAvailability,
  ProductEAN,
  ProductImage,
  ProductListItem,
  ProductQuantitySelector,
  ProductSlider,
  ProfileSaveConfigModal,
  QAvatar,
  QuantitySelector,
  RECEIVER_GROUP_USERS_TYPES,
  ReportTable,
  RepositoryFile,
  RepositoryFileList,
  ResultsPagination,
  ResultsPerPage,
  RoundIcon,
  STable,
  STableContainer,
  STbody,
  STd,
  STfoot,
  STh,
  SThead,
  STr,
  SecondaryHeader,
  SettingsContext,
  SettingsProvider,
  SmallTag,
  SortingIndicator,
  SubordinatesCheckbox,
  TAGS_TYPES,
  TAX_NON_UE_COUNTRIES,
  TAX_TYPES,
  TAX_UE_COUNTRIES,
  Table,
  TagButton,
  TagDisplay,
  TagFilter,
  TaskItem,
  TaskList,
  TaxCheckAlert,
  TaxDuplicatesModal,
  Tbody,
  Td,
  TextFilter,
  TextScroll,
  Th,
  Thead,
  TileItem,
  TileItemList,
  TileList,
  Timeline,
  TimelineCompact,
  TimelineItem,
  TooltipWrapper,
  Tr,
  UNRESET_SCSS,
  USED_SETTINGS,
  UsedMaterials,
  UserAvatarManage,
  UserTypes,
  WRAP_LINES_IN_LISTS,
  Widget,
  WidgetBody,
  WidgetControls,
  WidgetHeader,
  WidgetName,
  WidgetSettingsModal,
  auraAddNewEvent,
  auraAddNewTask,
  auraCompleteTask,
  auraCreateCampaignOpportunity,
  auraCreateProccesFromShortcut,
  auraEditTask,
  auraParseDisplayValue,
  auraParseFloat,
  auraSelectFilterConfig,
  baseApi,
  baseInputStyle,
  buildOptions,
  checkIsEdgeElement,
  checkIsVirtualTask,
  confirm,
  confirmWrapper,
  disableSortingColumns,
  documentInvoiceStatus,
  documentStatusPositions,
  downloadXlsxDocument,
  escapeFilterValueForQuery,
  expandRecurringTasks,
  fetchData,
  filterGlobalExcludedFields,
  formatAttributeCell,
  formatAttributeHeader,
  formatDateForApi,
  formatFieldCell,
  formatHeader,
  formatPhoneNumber,
  formatRelationFieldCell,
  formatRelationHeader,
  formatValue,
  getActiveMarkers,
  getAttributeClass,
  getAttributeContainerId,
  getAttributeId,
  getAttributeIdFromHTMLId,
  getAttributeTagTypeForModule,
  getAvailabilityProductLabel,
  getBasePriceFilter,
  getCommonI18nConfig,
  getCountryNameByCode,
  getDocumentRelationName,
  getFormattedPlaceLabel,
  getGoogleMapsQueryUrl,
  getImageUrl,
  getListFiltersConfig,
  getModuleHref,
  getParsedCellValue,
  getPriceFilterLevelForUserType,
  getUserPrice,
  getVisibleColumnsParams,
  idExists,
  imageSizeValue,
  initModal,
  isAppliedVatForCompany,
  isCommaSeparatorVisible,
  isFieldDirty,
  isFile,
  isImage,
  log,
  mapRelationTasksToTaskFields,
  normalizeSettings,
  openGoogleMaps,
  parseAttributeNameFormPrefix,
  parseFiltersForApi,
  parseMetaToColumns,
  parseTaxId,
  parseUrlParams,
  prepareAllTasks,
  prepareAttributeFormValues,
  prepareAttributesDefaultValues,
  prepareAttributesForApi,
  prepareDocumentPositionTile,
  prepareObjectRelationEvents,
  prepareObjectRelationTasks,
  preparePositionAttributesDefaultValues,
  preparePositionAttributesForApi,
  preparePositionAttributesWithValues,
  prepareSeoUrlForProduct,
  prepareToastDescription,
  priceFormatter,
  redirectToUrl,
  replaceForSeo,
  sanitizeDecimalInput,
  scrollToField,
  setValueWithPriceFormat,
  shouldShowDiscountInfo,
  simplePriceFormatter,
  sortTasks,
  splitPriceParts,
  statusCampaignOpportunity,
  stripHtmlTags,
  theme,
  transformApiResponse,
  translateOptions,
  useAuraErrorResolver,
  useAuraTranslation,
  useBasketContent,
  useCheckCompanyTax,
  useClearElasticFilter,
  useCloneFiles,
  useCustomScript,
  useDatera,
  useExternalMarkers,
  useFilesUpdateValidate,
  useLanguage,
  useLink,
  useListColumnsOrdering,
  useListColumnsVisibility,
  useListFilters,
  useListFiltersVisibility,
  useListPagination,
  useListSorting,
  useMessages,
  useMinimalAutoselect,
  useModalVisibilityContext,
  useOnClick,
  usePersistedState,
  useProductPrice,
  useQueryParams,
  useResponsive,
  useSetting,
  useSettings,
  useTemplates,
  useUserProfiles,
  useUserSettingsWithFallback,
  validateAttribute
});
